// Généré automatiquement à partir de communes-france-2025.csv
// 34932 communes françaises avec codes postaux
export const villesFrance = [
  {
    "code": "01400",
    "ville": "L'Abergement-Clémenciat",
    "dep": "Ain"
  },
  {
    "code": "01640",
    "ville": "L'Abergement-de-Varey",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Ambérieu-en-Bugey",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Ambérieux-en-Dombes",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Ambléon",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Ambronay",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Ambutrix",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Andert-et-Condon",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Anglefort",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Apremont",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Aranc",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Arandas",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Arbent",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Arboys en Bugey",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Arbigny",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Argis",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Armix",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Ars-sur-Formans",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Artemare",
    "dep": "Ain"
  },
  {
    "code": "01570",
    "ville": "Asnières-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Attignat",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Bâgé-Dommartin",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Bâgé-le-Châtel",
    "dep": "Ain"
  },
  {
    "code": "01360",
    "ville": "Balan",
    "dep": "Ain"
  },
  {
    "code": "01990",
    "ville": "Baneins",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Beaupont",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Beauregard",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Bellignat",
    "dep": "Ain"
  },
  {
    "code": "01360",
    "ville": "Béligneux",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Valserhône",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Belley",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Belleydoux",
    "dep": "Ain"
  },
  {
    "code": "01260",
    "ville": "Valromey-sur-Séran",
    "dep": "Ain"
  },
  {
    "code": "01470",
    "ville": "Bénonces",
    "dep": "Ain"
  },
  {
    "code": "01370",
    "ville": "Bény",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Béréziat",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Bettant",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Bey",
    "dep": "Ain"
  },
  {
    "code": "01700",
    "ville": "Beynost",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Billiat",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Birieux",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Biziat",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Blyes",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "La Boisse",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Boissey",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Bolozon",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Bouligneux",
    "dep": "Ain"
  },
  {
    "code": "01000",
    "ville": "Bourg-en-Bresse",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Bourg-Saint-Christophe",
    "dep": "Ain"
  },
  {
    "code": "01640",
    "ville": "Boyeux-Saint-Jérôme",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Boz",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Brégnier-Cordon",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Brénod",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Brens",
    "dep": "Ain"
  },
  {
    "code": "01360",
    "ville": "Bressolles",
    "dep": "Ain"
  },
  {
    "code": "01460",
    "ville": "Brion",
    "dep": "Ain"
  },
  {
    "code": "01470",
    "ville": "Briord",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Buellas",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "La Burbanche",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Ceignes",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Cerdon",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Certines",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Cessy",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Ceyzériat",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Ceyzérieu",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Chalamont",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Chaleins",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Chaley",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Challes-la-Montagne",
    "dep": "Ain"
  },
  {
    "code": "01630",
    "ville": "Challex",
    "dep": "Ain"
  },
  {
    "code": "01260",
    "ville": "Champagne-en-Valromey",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Champdor-Corcelles",
    "dep": "Ain"
  },
  {
    "code": "01410",
    "ville": "Champfromier",
    "dep": "Ain"
  },
  {
    "code": "01420",
    "ville": "Chanay",
    "dep": "Ain"
  },
  {
    "code": "01990",
    "ville": "Chaneins",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Chanoz-Châtenay",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "La Chapelle-du-Châtelard",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Charix",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Charnoz-sur-Ain",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Château-Gaillard",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Châtenay",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Châtillon-la-Palud",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Châtillon-sur-Chalaronne",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Chavannes-sur-Reyssouze",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Nivigne et Suran",
    "dep": "Ain"
  },
  {
    "code": "01660",
    "ville": "Chaveyriat",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Chazey-Bons",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Chazey-sur-Ain",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Cheignieu-la-Balme",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Chevillard",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Chevroux",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Chevry",
    "dep": "Ain"
  },
  {
    "code": "01410",
    "ville": "Chézery-Forens",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Civrieux",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Cize",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Cleyzieu",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Coligny",
    "dep": "Ain"
  },
  {
    "code": "01550",
    "ville": "Collonges",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Colomieu",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Conand",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Condamine",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Condeissiat",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Confort",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Confrançon",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Contrevoz",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Conzieu",
    "dep": "Ain"
  },
  {
    "code": "01420",
    "ville": "Corbonod",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Corlier",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Cormoranche-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Cormoz",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Corveissiat",
    "dep": "Ain"
  },
  {
    "code": "01370",
    "ville": "Courmangoux",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Courtes",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Crans",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Bresse Vallons",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Cressin-Rochefort",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Crottet",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Crozet",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Cruzilles-lès-Mépillat",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Culoz-Béon",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Curciat-Dongalon",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Curtafond",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Cuzieu",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Dagneux",
    "dep": "Ain"
  },
  {
    "code": "01220",
    "ville": "Divonne-les-Bains",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Dompierre-sur-Veyle",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Dompierre-sur-Chalaronne",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Domsure",
    "dep": "Ain"
  },
  {
    "code": "01590",
    "ville": "Dortan",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Douvres",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Drom",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Druillat",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Échallon",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Échenevex",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Évosges",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Faramans",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Fareins",
    "dep": "Ain"
  },
  {
    "code": "01550",
    "ville": "Farges",
    "dep": "Ain"
  },
  {
    "code": "01570",
    "ville": "Feillens",
    "dep": "Ain"
  },
  {
    "code": "01210",
    "ville": "Ferney-Voltaire",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Flaxieu",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Foissiat",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Francheleins",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Frans",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Garnerans",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Genouilleux",
    "dep": "Ain"
  },
  {
    "code": "01460",
    "ville": "Béard-Géovreissiat",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Géovreisset",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Gex",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Giron",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Gorrevod",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Grand-Corent",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Grièges",
    "dep": "Ain"
  },
  {
    "code": "01220",
    "ville": "Grilly",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Groissiat",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Guéreins",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Hautecourt-Romanèche",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Plateau d'Hauteville",
    "dep": "Ain"
  },
  {
    "code": "01260",
    "ville": "Haut Valromey",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Illiat",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Injoux-Génissiat",
    "dep": "Ain"
  },
  {
    "code": "01680",
    "ville": "Innimond",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Izenave",
    "dep": "Ain"
  },
  {
    "code": "01580",
    "ville": "Izernore",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Izieu",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Jassans-Riottier",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Jasseron",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Jayat",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Journans",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Joyeux",
    "dep": "Ain"
  },
  {
    "code": "01640",
    "ville": "Jujurieux",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Labalme",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Lagnieu",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Laiz",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Le Poizat-Lalleyriat",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Lantenay",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Lapeyrouse",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Lavours",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Léaz",
    "dep": "Ain"
  },
  {
    "code": "01410",
    "ville": "Lélex",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Lent",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Lescheroux",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Leyment",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Leyssard",
    "dep": "Ain"
  },
  {
    "code": "01420",
    "ville": "Surjoux-Lhopital",
    "dep": "Ain"
  },
  {
    "code": "01680",
    "ville": "Lhuis",
    "dep": "Ain"
  },
  {
    "code": "01680",
    "ville": "Lompnas",
    "dep": "Ain"
  },
  {
    "code": "01360",
    "ville": "Loyettes",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Lurcy",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Magnieu",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Maillat",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Malafretaz",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Mantenay-Montlin",
    "dep": "Ain"
  },
  {
    "code": "01570",
    "ville": "Manziat",
    "dep": "Ain"
  },
  {
    "code": "01851",
    "ville": "Marboz",
    "dep": "Ain"
  },
  {
    "code": "01680",
    "ville": "Marchamp",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Marignieu",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Marlieux",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Marsonnas",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Martignat",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Massieux",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Massignieu-de-Rives",
    "dep": "Ain"
  },
  {
    "code": "01580",
    "ville": "Matafelon-Granges",
    "dep": "Ain"
  },
  {
    "code": "01370",
    "ville": "Meillonnas",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Mérignat",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Messimy-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Meximieux",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Bohas-Meyriat-Rignat",
    "dep": "Ain"
  },
  {
    "code": "01660",
    "ville": "Mézériat",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Mijoux",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Mionnay",
    "dep": "Ain"
  },
  {
    "code": "01700",
    "ville": "Miribel",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Misérieux",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Mogneneins",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Montagnat",
    "dep": "Ain"
  },
  {
    "code": "01470",
    "ville": "Montagnieu",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Montanges",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Montceaux",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Montcet",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Le Montellier",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Monthieux",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Montluel",
    "dep": "Ain"
  },
  {
    "code": "01090",
    "ville": "Montmerle-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Montracol",
    "dep": "Ain"
  },
  {
    "code": "01460",
    "ville": "Montréal-la-Cluse",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Montrevel-en-Bresse",
    "dep": "Ain"
  },
  {
    "code": "01460",
    "ville": "Nurieux-Volognat",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Murs-et-Gélignieux",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Nantua",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Neuville-les-Dames",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Neuville-sur-Ain",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Les Neyrolles",
    "dep": "Ain"
  },
  {
    "code": "01700",
    "ville": "Neyron",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Niévroz",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Nivollet-Montgriffon",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Oncieu",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Ordonnaz",
    "dep": "Ain"
  },
  {
    "code": "01210",
    "ville": "Ornex",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Outriaz",
    "dep": "Ain"
  },
  {
    "code": "01100",
    "ville": "Oyonnax",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Ozan",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Parcieux",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Parves et Nattages",
    "dep": "Ain"
  },
  {
    "code": "01630",
    "ville": "Péron",
    "dep": "Ain"
  },
  {
    "code": "01960",
    "ville": "Péronnas",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Pérouges",
    "dep": "Ain"
  },
  {
    "code": "01540",
    "ville": "Perrex",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Peyriat",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Peyrieu",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Peyzieux-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Pirajoux",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Pizay",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Plagne",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Le Plantay",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Polliat",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Pollieu",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Poncin",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Pont-d'Ain",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Pont-de-Vaux",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Pont-de-Veyle",
    "dep": "Ain"
  },
  {
    "code": "01460",
    "ville": "Port",
    "dep": "Ain"
  },
  {
    "code": "01550",
    "ville": "Pougny",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Pouillat",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Prémeyzel",
    "dep": "Ain"
  },
  {
    "code": "01110",
    "ville": "Prémillieu",
    "dep": "Ain"
  },
  {
    "code": "01280",
    "ville": "Prévessin-Moëns",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Priay",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Ramasse",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Rancé",
    "dep": "Ain"
  },
  {
    "code": "01990",
    "ville": "Relevant",
    "dep": "Ain"
  },
  {
    "code": "01750",
    "ville": "Replonges",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Revonnas",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Reyrieux",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Reyssouze",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Rignieux-le-Franc",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Romans",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Rossillon",
    "dep": "Ain"
  },
  {
    "code": "01260",
    "ville": "Ruffieu",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Saint-Alban",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Saint-André-de-Bâgé",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Saint-André-de-Corcy",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Saint-André-d'Huiriat",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Saint-André-le-Bouchoux",
    "dep": "Ain"
  },
  {
    "code": "01960",
    "ville": "Saint-André-sur-Vieux-Jonc",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Saint-Bénigne",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Groslée-Saint-Benoit",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Saint-Bernard",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Sainte-Croix",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Saint-Cyr-sur-Menthon",
    "dep": "Ain"
  },
  {
    "code": "01000",
    "ville": "Saint-Denis-lès-Bourg",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Saint-Denis-en-Bugey",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Saint-Didier-d'Aussiat",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Saint-Didier-de-Formans",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Saint-Didier-sur-Chalaronne",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Saint-Éloi",
    "dep": "Ain"
  },
  {
    "code": "01370",
    "ville": "Saint-Étienne-du-Bois",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Saint-Étienne-sur-Chalaronne",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Saint-Étienne-sur-Reyssouze",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Sainte-Euphémie",
    "dep": "Ain"
  },
  {
    "code": "01630",
    "ville": "Saint-Genis-Pouilly",
    "dep": "Ain"
  },
  {
    "code": "01380",
    "ville": "Saint-Genis-sur-Menthon",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Saint-Georges-sur-Renon",
    "dep": "Ain"
  },
  {
    "code": "01130",
    "ville": "Saint-Germain-de-Joux",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Saint-Germain-les-Paroisses",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Saint-Germain-sur-Renon",
    "dep": "Ain"
  },
  {
    "code": "01630",
    "ville": "Saint-Jean-de-Gonville",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Saint-Jean-de-Niost",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Saint-Jean-de-Thurigneux",
    "dep": "Ain"
  },
  {
    "code": "01640",
    "ville": "Saint-Jean-le-Vieux",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Saint-Jean-sur-Reyssouze",
    "dep": "Ain"
  },
  {
    "code": "01290",
    "ville": "Saint-Jean-sur-Veyle",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Sainte-Julie",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Saint-Julien-sur-Reyssouze",
    "dep": "Ain"
  },
  {
    "code": "01540",
    "ville": "Saint-Julien-sur-Veyle",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Saint-Just",
    "dep": "Ain"
  },
  {
    "code": "01750",
    "ville": "Saint-Laurent-sur-Saône",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Saint-Marcel",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Saint-Martin-de-Bavel",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Saint-Martin-du-Frêne",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Saint-Martin-du-Mont",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Saint-Martin-le-Châtel",
    "dep": "Ain"
  },
  {
    "code": "01700",
    "ville": "Saint-Maurice-de-Beynost",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Saint-Maurice-de-Gourdans",
    "dep": "Ain"
  },
  {
    "code": "01500",
    "ville": "Saint-Maurice-de-Rémens",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Saint-Nizier-le-Bouchoux",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Saint-Nizier-le-Désert",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Sainte-Olive",
    "dep": "Ain"
  },
  {
    "code": "01240",
    "ville": "Saint-Paul-de-Varax",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Saint-Rambert-en-Bugey",
    "dep": "Ain"
  },
  {
    "code": "01310",
    "ville": "Saint-Rémy",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Saint-Sorlin-en-Bugey",
    "dep": "Ain"
  },
  {
    "code": "01340",
    "ville": "Saint-Sulpice",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Saint-Trivier-de-Courtes",
    "dep": "Ain"
  },
  {
    "code": "01990",
    "ville": "Saint-Trivier-sur-Moignans",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Saint-Vulbas",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Salavre",
    "dep": "Ain"
  },
  {
    "code": "01580",
    "ville": "Samognat",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Sandrans",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Sault-Brénaz",
    "dep": "Ain"
  },
  {
    "code": "01220",
    "ville": "Sauverny",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Savigneux",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Ségny",
    "dep": "Ain"
  },
  {
    "code": "01470",
    "ville": "Seillonnaz",
    "dep": "Ain"
  },
  {
    "code": "01630",
    "ville": "Sergy",
    "dep": "Ain"
  },
  {
    "code": "01190",
    "ville": "Sermoyer",
    "dep": "Ain"
  },
  {
    "code": "01470",
    "ville": "Serrières-de-Briord",
    "dep": "Ain"
  },
  {
    "code": "01450",
    "ville": "Serrières-sur-Ain",
    "dep": "Ain"
  },
  {
    "code": "01960",
    "ville": "Servas",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Servignat",
    "dep": "Ain"
  },
  {
    "code": "01420",
    "ville": "Seyssel",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Simandre-sur-Suran",
    "dep": "Ain"
  },
  {
    "code": "01580",
    "ville": "Sonthonnax-la-Montagne",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Souclin",
    "dep": "Ain"
  },
  {
    "code": "01400",
    "ville": "Sulignat",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Talissieu",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Tenay",
    "dep": "Ain"
  },
  {
    "code": "01120",
    "ville": "Thil",
    "dep": "Ain"
  },
  {
    "code": "01710",
    "ville": "Thoiry",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Thoissey",
    "dep": "Ain"
  },
  {
    "code": "01230",
    "ville": "Torcieu",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Tossiat",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Toussieux",
    "dep": "Ain"
  },
  {
    "code": "01390",
    "ville": "Tramoyes",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "La Tranclière",
    "dep": "Ain"
  },
  {
    "code": "01370",
    "ville": "Val-Revermont",
    "dep": "Ain"
  },
  {
    "code": "01600",
    "ville": "Trévoux",
    "dep": "Ain"
  },
  {
    "code": "01140",
    "ville": "Valeins",
    "dep": "Ain"
  },
  {
    "code": "01660",
    "ville": "Vandeins",
    "dep": "Ain"
  },
  {
    "code": "01160",
    "ville": "Varambon",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Vaux-en-Bugey",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Verjon",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Vernoux",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Versailleux",
    "dep": "Ain"
  },
  {
    "code": "01210",
    "ville": "Versonnex",
    "dep": "Ain"
  },
  {
    "code": "01170",
    "ville": "Vesancy",
    "dep": "Ain"
  },
  {
    "code": "01560",
    "ville": "Vescours",
    "dep": "Ain"
  },
  {
    "code": "01570",
    "ville": "Vésines",
    "dep": "Ain"
  },
  {
    "code": "01430",
    "ville": "Vieu-d'Izenave",
    "dep": "Ain"
  },
  {
    "code": "01330",
    "ville": "Villars-les-Dombes",
    "dep": "Ain"
  },
  {
    "code": "01150",
    "ville": "Villebois",
    "dep": "Ain"
  },
  {
    "code": "01270",
    "ville": "Villemotier",
    "dep": "Ain"
  },
  {
    "code": "01480",
    "ville": "Villeneuve",
    "dep": "Ain"
  },
  {
    "code": "01250",
    "ville": "Villereversure",
    "dep": "Ain"
  },
  {
    "code": "01200",
    "ville": "Villes",
    "dep": "Ain"
  },
  {
    "code": "01320",
    "ville": "Villette-sur-Ain",
    "dep": "Ain"
  },
  {
    "code": "01800",
    "ville": "Villieu-Loyes-Mollon",
    "dep": "Ain"
  },
  {
    "code": "01440",
    "ville": "Viriat",
    "dep": "Ain"
  },
  {
    "code": "01510",
    "ville": "Virieu-le-Grand",
    "dep": "Ain"
  },
  {
    "code": "01260",
    "ville": "Arvière-en-Valromey",
    "dep": "Ain"
  },
  {
    "code": "01300",
    "ville": "Virignin",
    "dep": "Ain"
  },
  {
    "code": "01350",
    "ville": "Vongnes",
    "dep": "Ain"
  },
  {
    "code": "01540",
    "ville": "Vonnas",
    "dep": "Ain"
  },
  {
    "code": "02300",
    "ville": "Abbécourt",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Achery",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Acy",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Agnicourt-et-Séchelles",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Aguilcourt",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Aisonville-et-Bernoville",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Aizelles",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Aizy-Jouy",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Alaincourt",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Allemant",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Ambleny",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Ambrief",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Amifontaine",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Amigny-Rouy",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Ancienville",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Andelain",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Anguilcourt-le-Sart",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Anizy-le-Grand",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Annois",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Any-Martin-Rieux",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Archon",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Arcy-Sainte-Restitue",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Armentières-sur-Ourcq",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Arrancy",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Artemps",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Assis-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Athies-sous-Laon",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Attilly",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Aubencheul-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Aubenton",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Aubigny-aux-Kaisnes",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Aubigny-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Audignicourt",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Audigny",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Augy",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Aulnois-sous-Laon",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Les Autels",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Autremencourt",
    "dep": "Aisne"
  },
  {
    "code": "02580",
    "ville": "Autreppes",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Autreville",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Azy-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Bagneux",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Bancigny",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Barenton-Bugny",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Barenton-Cel",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Barenton-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Barisis-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02170",
    "ville": "Barzy-en-Thiérache",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Barzy-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Bassoles-Aulers",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Vallées en Champagne",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Bazoches-et-Saint-Thibaut",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Beaumé",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Beaumont-en-Beine",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Beaurevoir",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Beaurieux",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Beautor",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Beauvois-en-Vermandois",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Becquigny",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Belleau",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Bellenglise",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Belleu",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Bellicourt",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Benay",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Bergues-sur-Sambre",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Berlancourt",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Berlise",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Bernot",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Berny-Rivière",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Berrieux",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Berry-au-Bac",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Bertaucourt-Epourdon",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Berthenicourt",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Bertricourt",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Besmé",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Besmont",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Besny-et-Loizy",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Béthancourt-en-Vaux",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Beugneux",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Beuvardes",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Bézu-le-Guéry",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Bézu-Saint-Germain",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Bichancourt",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Bieuxy",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Bièvres",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Billy-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Billy-sur-Ourcq",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Blanzy-lès-Fismes",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Blérancourt",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Blesmes",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Bohain-en-Vermandois",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Bois-lès-Pargny",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Boncourt",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Bonneil",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Bonnesvalyn",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Bony",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Bosmont-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Bouconville-Vauclair",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Boué",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Bouffignereux",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Bouresches",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Bourg-et-Comin",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Bourguignon-sous-Coucy",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Bourguignon-sous-Montbavin",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "La Bouteille",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Braine",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Brancourt-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Brancourt-le-Grand",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Brasles",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Braye-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Braye-en-Thiérache",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Bray-Saint-Christophe",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Braye",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Brécy",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Brenelle",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Breny",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Brie",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Brissay-Choigny",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Brissy-Hamégicourt",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Brumetz",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Brunehamel",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Bruyères-sur-Fère",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Bruyères-et-Montbérault",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Bruys",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Bucilly",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Bucy-le-Long",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Bucy-lès-Cerny",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Bucy-lès-Pierrepont",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Buire",
    "dep": "Aisne"
  },
  {
    "code": "02620",
    "ville": "Buironfosse",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Burelles",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Bussiares",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Buzancy",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Caillouël-Crépigny",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Camelin",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "La Capelle",
    "dep": "Aisne"
  },
  {
    "code": "02680",
    "ville": "Castres",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Le Catelet",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Caulaincourt",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Caumont",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Celles-lès-Condé",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Celles-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Cerizy",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Cerny-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Cerny-lès-Bucy",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Cerseuil",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Cessières-Suzy",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Chacrise",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chaillevois",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Chalandry",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chambry",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Chamouille",
    "dep": "Aisne"
  },
  {
    "code": "02670",
    "ville": "Champs",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Chaourse",
    "dep": "Aisne"
  },
  {
    "code": "02570",
    "ville": "La Chapelle-sur-Chézy",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Charly-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Le Charmel",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Charmes",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Chartèves",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Chassemy",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Château-Thierry",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Châtillon-lès-Sons",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Châtillon-sur-Oise",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Chaudardes",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Chaudun",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Chauny",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chavignon",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Chavigny",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Chavonne",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Chérêt",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Chermizy-Ailles",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Chéry-Chartreuve",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chéry-lès-Pouilly",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Chéry-lès-Rozoy",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Chevennes",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chevregny",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Chevresis-Monceau",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Chézy-en-Orxois",
    "dep": "Aisne"
  },
  {
    "code": "02570",
    "ville": "Chézy-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Chierry",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Chigny",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Chivres-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Chivres-Val",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Chivy-lès-Étouvelles",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Chouy",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Cierges",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Cilly",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Ciry-Salsogne",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Clacy-et-Thierret",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Clairfontaine",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Clamecy",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Clastres",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Clermont-les-Fermes",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Cœuvres-et-Valsery",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Coincy",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Coingt",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Colligis-Crandelain",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Colonfay",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Commenchon",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Concevreux",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Condé-en-Brie",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Condé-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Condé-sur-Suippe",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Condren",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Connigis",
    "dep": "Aisne"
  },
  {
    "code": "02680",
    "ville": "Contescourt",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Corbeny",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Corcy",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Coucy-le-Château-Auffrique",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Coucy-lès-Eppes",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Coucy-la-Ville",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Coulonges-Cohan",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Coupru",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Courbes",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Courboin",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Courcelles-sur-Vesle",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Courchamps",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Courmelles",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Courmont",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Courtemont-Varennes",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Courtrizy-et-Fussigny",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Couvrelles",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Couvron-et-Aumencourt",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Coyolles",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Cramaille",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Craonne",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Craonnelle",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Crécy-au-Mont",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Crécy-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Crépy",
    "dep": "Aisne"
  },
  {
    "code": "02650",
    "ville": "Crézancy",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Croix-Fonsomme",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "La Croix-sur-Ourcq",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Crouttes-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Crouy",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Crupilly",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Cuffies",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Cugny",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Cuirieux",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Cuiry-Housse",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Cuiry-lès-Chaudardes",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Cuiry-lès-Iviers",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Cuissy-et-Geny",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Cuisy-en-Almont",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Cutry",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Cys-la-Commune",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Dagny-Lambercy",
    "dep": "Aisne"
  },
  {
    "code": "02680",
    "ville": "Dallon",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Dammard",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Dampleux",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Danizy",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Dercy",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Deuillet",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Dhuizel",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Dizy-le-Gros",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Dohis",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Dolignon",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Dommiers",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Domptin",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Dorengt",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Douchy",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Dravegny",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Droizy",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Dury",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Ébouleau",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Effry",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Englancourt",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Épagny",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Éparcy",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Épaux-Bézu",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Épieds",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "L'Épine-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Eppes",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Erlon",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Erloy",
    "dep": "Aisne"
  },
  {
    "code": "02170",
    "ville": "Esquéhéries",
    "dep": "Aisne"
  },
  {
    "code": "02690",
    "ville": "Essigny-le-Grand",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Essigny-le-Petit",
    "dep": "Aisne"
  },
  {
    "code": "02570",
    "ville": "Essises",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Essômes-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Estrées",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Étampes-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Étaves-et-Bocquiaux",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Étouvelles",
    "dep": "Aisne"
  },
  {
    "code": "02580",
    "ville": "Étréaupont",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Étreillers",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Étrépilly",
    "dep": "Aisne"
  },
  {
    "code": "02510",
    "ville": "Étreux",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Évergnicourt",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Faverolles",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Fayet",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "La Fère",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Fère-en-Tardenois",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "La Ferté-Chevresis",
    "dep": "Aisne"
  },
  {
    "code": "02460",
    "ville": "La Ferté-Milon",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Fesmy-le-Sart",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Festieux",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Fieulaine",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Filain",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "La Flamengrie",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Flavigny-le-Grand-et-Beaurain",
    "dep": "Aisne"
  },
  {
    "code": "02520",
    "ville": "Flavy-le-Martel",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Fleury",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Fluquières",
    "dep": "Aisne"
  },
  {
    "code": "02670",
    "ville": "Folembray",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Fonsomme",
    "dep": "Aisne"
  },
  {
    "code": "02680",
    "ville": "Fontaine-lès-Clercs",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Fontaine-lès-Vervins",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Fontaine-Notre-Dame",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Fontaine-Uterte",
    "dep": "Aisne"
  },
  {
    "code": "02170",
    "ville": "Fontenelle",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Fontenoy",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Foreste",
    "dep": "Aisne"
  },
  {
    "code": "02650",
    "ville": "Fossoy",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Fourdrain",
    "dep": "Aisne"
  },
  {
    "code": "02760",
    "ville": "Francilly-Selency",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Franqueville",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Fresnes-en-Tardenois",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Fresnes-sous-Coucy",
    "dep": "Aisne"
  },
  {
    "code": "02230",
    "ville": "Fresnoy-le-Grand",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Fressancourt",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Frières-Faillouël",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Froidestrées",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Froidmont-Cohartille",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Gandelu",
    "dep": "Aisne"
  },
  {
    "code": "02430",
    "ville": "Gauchy",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Gercy",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Gergny",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Germaine",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Gibercourt",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Gizy",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Gland",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Goudelancourt-lès-Berrieux",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Goudelancourt-lès-Pierrepont",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Goussancourt",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Gouy",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Grandlup-et-Fay",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Grandrieux",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Gricourt",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Grisolles",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Gronard",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Grougis",
    "dep": "Aisne"
  },
  {
    "code": "02680",
    "ville": "Grugies",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Villeneuve-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Guise",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Guivry",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Guny",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Guyencourt",
    "dep": "Aisne"
  },
  {
    "code": "02510",
    "ville": "Hannapes",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Happencourt",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Haramont",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Harcigny",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Hargicourt",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Harly",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Hartennes-et-Taux",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Hary",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Lehaucourt",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Hautevesnes",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Hauteville",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Haution",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "La Hérie",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Le Hérie-la-Viéville",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Hinacourt",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Hirson",
    "dep": "Aisne"
  },
  {
    "code": "02760",
    "ville": "Holnon",
    "dep": "Aisne"
  },
  {
    "code": "02720",
    "ville": "Homblières",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Houry",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Housset",
    "dep": "Aisne"
  },
  {
    "code": "02510",
    "ville": "Iron",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Itancourt",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Iviers",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Jaulgonne",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Jeancourt",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Jeantes",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Joncourt",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Jouaignes",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Jumencourt",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Jumigny",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Jussy",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Juvigny",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Juvincourt-et-Damary",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Laffaux",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Laigny",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Lanchy",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Landifay-et-Bertaignemont",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Landouzy-la-Cour",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Landouzy-la-Ville",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Landricourt",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Laniscourt",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Laon",
    "dep": "Aisne"
  },
  {
    "code": "02150",
    "ville": "Lappion",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Largny-sur-Automne",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Latilly",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Launoy",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Laval-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Lavaqueresse",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Laversine",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Lemé",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Lempire",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Lerzy",
    "dep": "Aisne"
  },
  {
    "code": "02170",
    "ville": "Leschelle",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Lesdins",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Lesges",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Lesquielles-Saint-Germain",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Leuilly-sous-Coucy",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Leury",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Leuze",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Levergies",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Lhuys",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Licy-Clignon",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Lierval",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Liesse-Notre-Dame",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Liez",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Limé",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Lislet",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Logny-lès-Aubenton",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Longpont",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Les Septvallons",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Lor",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Louâtre",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Loupeigne",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Lucy-le-Bocage",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Lugny",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Luzoir",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Ly-Fontaine",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Maast-et-Violaine",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Mâchecourt",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Macogny",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Macquigny",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Magny-la-Fosse",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Maissemy",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Maizy",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "La Malmaison",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Malzy",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Manicamp",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Marchais",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Dhuys et Morin-en-Brie",
    "dep": "Aisne"
  },
  {
    "code": "02720",
    "ville": "Marcy",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Marcy-sous-Marle",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Marest-Dampcourt",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Mareuil-en-Dôle",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Marfontaine",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Margival",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Marigny-en-Orxois",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Marizy-Sainte-Geneviève",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Marizy-Saint-Mard",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Marle",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Marly-Gomont",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Martigny",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Martigny-Courpierre",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Mauregny-en-Haye",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Mayot",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Mennessis",
    "dep": "Aisne"
  },
  {
    "code": "02630",
    "ville": "Mennevret",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Mercin-et-Vaux",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Merlieux-et-Fouquerolles",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Mesbrecourt-Richecourt",
    "dep": "Aisne"
  },
  {
    "code": "02720",
    "ville": "Mesnil-Saint-Laurent",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Meurival",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Mézières-sur-Oise",
    "dep": "Aisne"
  },
  {
    "code": "02650",
    "ville": "Mézy-Moulins",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Missy-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Missy-lès-Pierrepont",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Missy-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Molain",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Molinchart",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Monampteuil",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Monceau-le-Neuf-et-Faucouzy",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Monceau-lès-Leups",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Monceau-le-Waast",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Monceau-sur-Oise",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Mondrepuis",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Monnes",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Mons-en-Laonnois",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Montaigu",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Montbavin",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Montbrehain",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Montchâlons",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Montcornet",
    "dep": "Aisne"
  },
  {
    "code": "02390",
    "ville": "Mont-d'Origny",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Montescourt-Lizerolles",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Montfaucon",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Montgobert",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Montgru-Saint-Hilaire",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Monthenault",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Monthiers",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Monthurel",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Montigny-en-Arrouaise",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Montigny-l'Allier",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Montigny-le-Franc",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Montigny-Lengrain",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Montigny-lès-Condé",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Montigny-sous-Marle",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Montigny-sur-Crécy",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Montlevon",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Montloué",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Mont-Notre-Dame",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Montreuil-aux-Lions",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Mont-Saint-Jean",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Mont-Saint-Martin",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Mont-Saint-Père",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Morcourt",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Morgny-en-Thiérache",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Morsain",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Mortefontaine",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Mortiers",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Moulins",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Moussy-Verneuil",
    "dep": "Aisne"
  },
  {
    "code": "02610",
    "ville": "Moÿ-de-l'Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Muret-et-Crouttes",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Muscourt",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Nampcelles-la-Cour",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Nampteuil-sous-Muret",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Nanteuil-la-Fosse",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Nanteuil-Notre-Dame",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Nauroy",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Nesles-la-Montagne",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Neufchâtel-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Neuflieux",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Neuilly-Saint-Front",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Neuve-Maison",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "La Neuville-Bosmont",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "La Neuville-en-Beine",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "La Neuville-Housset",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "La Neuville-lès-Dorengt",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Neuville-Saint-Amand",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Neuville-sur-Ailette",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Neuville-sur-Margival",
    "dep": "Aisne"
  },
  {
    "code": "02390",
    "ville": "Neuvillette",
    "dep": "Aisne"
  },
  {
    "code": "02150",
    "ville": "Nizy-le-Comte",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Nogentel",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Nogent-l'Artaud",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Noircourt",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Noroy-sur-Ourcq",
    "dep": "Aisne"
  },
  {
    "code": "02170",
    "ville": "Le Nouvion-en-Thiérache",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Nouvion-et-Catillon",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Nouvion-le-Comte",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Nouvion-le-Vineux",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Nouvron-Vingré",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Noyales",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Bernoy-le-Château",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Œuilly",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Ognes",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Ohis",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Oigny-en-Valois",
    "dep": "Aisne"
  },
  {
    "code": "02450",
    "ville": "Oisy",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Ollezy",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Omissy",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Orainville",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Orgeval",
    "dep": "Aisne"
  },
  {
    "code": "02550",
    "ville": "Origny-en-Thiérache",
    "dep": "Aisne"
  },
  {
    "code": "02390",
    "ville": "Origny-Sainte-Benoite",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Osly-Courtil",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Ostel",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Oulches-la-Vallée-Foulon",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Oulchy-la-Ville",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Oulchy-le-Château",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Paars",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Paissy",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Pancy-Courtecon",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Papleux",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Parcy-et-Tigny",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Parfondeval",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Parfondru",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Pargnan",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Pargny-Filain",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Pargny-la-Dhuys",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Pargny-les-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Parpeville",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Pasly",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Passy-en-Valois",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Passy-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Pavant",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Pernant",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Pierremande",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Pierrepont",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Pignicourt",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Pinon",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Pithon",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Pleine-Selve",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Le Plessier-Huleu",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Ploisy",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Plomion",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Ployart-et-Vaurseine",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Pommiers",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Pont-Arcy",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Pontavert",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Pontru",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Pontruet",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Pont-Saint-Mard",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Pouilly-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Prémont",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Prémontré",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Presles-et-Boves",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Presles-et-Thierny",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Priez",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Prisces",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Proisy",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Proix",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Prouvais",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Proviseux-et-Plesnoy",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Puiseux-en-Retz",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Puisieux-et-Clanlieu",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Quierzy",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Quincy-Basse",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Quincy-sous-le-Mont",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Raillimont",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Ramicourt",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Regny",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Remaucourt",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Remies",
    "dep": "Aisne"
  },
  {
    "code": "02440",
    "ville": "Remigny",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Renansart",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Renneval",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Résigny",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Ressons-le-Long",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Retheuil",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Reuilly-Sauvigny",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Ribeauville",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Ribemont",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Rocourt-Saint-Martin",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Rocquigny",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Rogécourt",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Rogny",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Romeny-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Romery",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Ronchères",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Roucy",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Rougeries",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Roupy",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Rouvroy",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Rouvroy-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Royaucourt-et-Chailvet",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Rozet-Saint-Albin",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Rozières-sur-Crise",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Rozoy-Bellevalle",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Grand-Rozoy",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Rozoy-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Saconin-et-Breuil",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Sains-Richaumont",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Saint-Algis",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Saint-Aubin",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Saint-Bandry",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Saint-Christophe-à-Berry",
    "dep": "Aisne"
  },
  {
    "code": "02360",
    "ville": "Saint-Clément",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Sainte-Croix",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Saint-Erme-Outre-et-Ramecourt",
    "dep": "Aisne"
  },
  {
    "code": "02330",
    "ville": "Saint-Eugène",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Sainte-Geneviève",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Saint-Gengoulph",
    "dep": "Aisne"
  },
  {
    "code": "02410",
    "ville": "Saint-Gobain",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Saint-Gobert",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Saint-Mard",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Saint-Martin-Rivière",
    "dep": "Aisne"
  },
  {
    "code": "02830",
    "ville": "Saint-Michel",
    "dep": "Aisne"
  },
  {
    "code": "02410",
    "ville": "Saint-Nicolas-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Saint-Paul-aux-Bois",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Saint-Pierre-Aigle",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Saint-Pierre-lès-Franqueville",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Saint-Pierremont",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Sainte-Preuve",
    "dep": "Aisne"
  },
  {
    "code": "02100",
    "ville": "Saint-Quentin",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Saint-Rémy-Blanzy",
    "dep": "Aisne"
  },
  {
    "code": "02640",
    "ville": "Saint-Simon",
    "dep": "Aisne"
  },
  {
    "code": "02820",
    "ville": "Saint-Thomas",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Samoussy",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Sancy-les-Cheminots",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Saponay",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Saulchery",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Savy",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Seboncourt",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Selens",
    "dep": "Aisne"
  },
  {
    "code": "02150",
    "ville": "La Selve",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Septmonts",
    "dep": "Aisne"
  },
  {
    "code": "02410",
    "ville": "Septvaux",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Sequehart",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Serain",
    "dep": "Aisne"
  },
  {
    "code": "02790",
    "ville": "Seraucourt-le-Grand",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Serches",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Sergy",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Seringes-et-Nesles",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Sermoise",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Serval",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Servais",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Séry-lès-Mézières",
    "dep": "Aisne"
  },
  {
    "code": "02460",
    "ville": "Silly-la-Poterie",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Sinceny",
    "dep": "Aisne"
  },
  {
    "code": "02150",
    "ville": "Sissonne",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Sissy",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Soissons",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Soize",
    "dep": "Aisne"
  },
  {
    "code": "02470",
    "ville": "Sommelans",
    "dep": "Aisne"
  },
  {
    "code": "02260",
    "ville": "Sommeron",
    "dep": "Aisne"
  },
  {
    "code": "02480",
    "ville": "Sommette-Eaucourt",
    "dep": "Aisne"
  },
  {
    "code": "02270",
    "ville": "Sons-et-Ronchères",
    "dep": "Aisne"
  },
  {
    "code": "02580",
    "ville": "Sorbais",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Soucy",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Soupir",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Le Sourd",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Surfontaine",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Taillefontaine",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Tannières",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Tartiers",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Tavaux-et-Pontséricourt",
    "dep": "Aisne"
  },
  {
    "code": "02700",
    "ville": "Tergnier",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Terny-Sorny",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Thenailles",
    "dep": "Aisne"
  },
  {
    "code": "02390",
    "ville": "Thenelles",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Thiernu",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Le Thuel",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Torcy-en-Valois",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Toulis-et-Attencourt",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Travecy",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Trefcon",
    "dep": "Aisne"
  },
  {
    "code": "02850",
    "ville": "Trélou-sur-Marne",
    "dep": "Aisne"
  },
  {
    "code": "02460",
    "ville": "Troësnes",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Trosly-Loire",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Trucy",
    "dep": "Aisne"
  },
  {
    "code": "02640",
    "ville": "Tugny-et-Pont",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Tupigny",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Ugny-le-Gay",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Urcel",
    "dep": "Aisne"
  },
  {
    "code": "02690",
    "ville": "Urvillers",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Vadencourt",
    "dep": "Aisne"
  },
  {
    "code": "02370",
    "ville": "Vailly-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "La Vallée-au-Blé",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "La Vallée-Mulâtre",
    "dep": "Aisne"
  },
  {
    "code": "02190",
    "ville": "Variscourt",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Vassens",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Vasseny",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Vassogne",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Vaucelles-et-Beffecourt",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Vaudesson",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Vauxrezis",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Vauxaillon",
    "dep": "Aisne"
  },
  {
    "code": "02110",
    "ville": "Vaux-Andigny",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Vauxbuin",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Vaux-en-Vermandois",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Vauxtin",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Vendelles",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Vendeuil",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Vendhuile",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Vendières",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Vendresse-Beaulne",
    "dep": "Aisne"
  },
  {
    "code": "02510",
    "ville": "Vénérolles",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Venizel",
    "dep": "Aisne"
  },
  {
    "code": "02400",
    "ville": "Verdilly",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Le Verguier",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Grand-Verly",
    "dep": "Aisne"
  },
  {
    "code": "02630",
    "ville": "Petit-Verly",
    "dep": "Aisne"
  },
  {
    "code": "02490",
    "ville": "Vermand",
    "dep": "Aisne"
  },
  {
    "code": "02380",
    "ville": "Verneuil-sous-Coucy",
    "dep": "Aisne"
  },
  {
    "code": "02000",
    "ville": "Verneuil-sur-Serre",
    "dep": "Aisne"
  },
  {
    "code": "02800",
    "ville": "Versigny",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Vervins",
    "dep": "Aisne"
  },
  {
    "code": "02350",
    "ville": "Vesles-et-Caumont",
    "dep": "Aisne"
  },
  {
    "code": "02840",
    "ville": "Veslud",
    "dep": "Aisne"
  },
  {
    "code": "02810",
    "ville": "Veuilly-la-Poterie",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Vézaponin",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Vézilly",
    "dep": "Aisne"
  },
  {
    "code": "02290",
    "ville": "Vic-sur-Aisne",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Vichel-Nanteuil",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "Viel-Arcy",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Viels-Maisons",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Vierzy",
    "dep": "Aisne"
  },
  {
    "code": "02540",
    "ville": "Viffort",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Vigneux-Hocquet",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "La Ville-aux-Bois-lès-Dizy",
    "dep": "Aisne"
  },
  {
    "code": "02160",
    "ville": "La Ville-aux-Bois-lès-Pontavert",
    "dep": "Aisne"
  },
  {
    "code": "02210",
    "ville": "Villemontoire",
    "dep": "Aisne"
  },
  {
    "code": "02200",
    "ville": "Villeneuve-Saint-Germain",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Villeneuve-sur-Fère",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Villequier-Aumont",
    "dep": "Aisne"
  },
  {
    "code": "02420",
    "ville": "Villeret",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Villers-Agron-Aiguizy",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Villers-Cotterêts",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Villers-Hélon",
    "dep": "Aisne"
  },
  {
    "code": "02240",
    "ville": "Villers-le-Sec",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Villers-lès-Guise",
    "dep": "Aisne"
  },
  {
    "code": "02590",
    "ville": "Villers-Saint-Christophe",
    "dep": "Aisne"
  },
  {
    "code": "02130",
    "ville": "Villers-sur-Fère",
    "dep": "Aisne"
  },
  {
    "code": "02220",
    "ville": "Ville-Savoye",
    "dep": "Aisne"
  },
  {
    "code": "02310",
    "ville": "Villiers-Saint-Denis",
    "dep": "Aisne"
  },
  {
    "code": "02340",
    "ville": "Vincy-Reuil-et-Magny",
    "dep": "Aisne"
  },
  {
    "code": "02300",
    "ville": "Viry-Noureuil",
    "dep": "Aisne"
  },
  {
    "code": "02870",
    "ville": "Vivaise",
    "dep": "Aisne"
  },
  {
    "code": "02600",
    "ville": "Vivières",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Voharies",
    "dep": "Aisne"
  },
  {
    "code": "02860",
    "ville": "Vorges",
    "dep": "Aisne"
  },
  {
    "code": "02140",
    "ville": "Voulpaix",
    "dep": "Aisne"
  },
  {
    "code": "02250",
    "ville": "Voyenne",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Vregny",
    "dep": "Aisne"
  },
  {
    "code": "02880",
    "ville": "Vuillery",
    "dep": "Aisne"
  },
  {
    "code": "02630",
    "ville": "Wassigny",
    "dep": "Aisne"
  },
  {
    "code": "02830",
    "ville": "Watigny",
    "dep": "Aisne"
  },
  {
    "code": "02120",
    "ville": "Wiège-Faty",
    "dep": "Aisne"
  },
  {
    "code": "02500",
    "ville": "Wimy",
    "dep": "Aisne"
  },
  {
    "code": "02320",
    "ville": "Wissignicourt",
    "dep": "Aisne"
  },
  {
    "code": "03200",
    "ville": "Abrest",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Agonges",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Ainay-le-Château",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Andelaroche",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Archignat",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Arfeuilles",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Arpheuilles-Saint-Priest",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Arronnes",
    "dep": "Allier"
  },
  {
    "code": "03460",
    "ville": "Aubigny",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Audes",
    "dep": "Allier"
  },
  {
    "code": "03460",
    "ville": "Aurouër",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Autry-Issards",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Avermes",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Avrilly",
    "dep": "Allier"
  },
  {
    "code": "03460",
    "ville": "Bagneux",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Barberier",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Barrais-Bussolles",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Bayet",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Beaulon",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Beaune-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Bègues",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Bellenaves",
    "dep": "Allier"
  },
  {
    "code": "03700",
    "ville": "Bellerive-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Bert",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Bessay-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Besson",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Bézenet",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Billezois",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Billy",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Biozat",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Bizeneuille",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Blomard",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Bost",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Boucé",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Le Bouchaud",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Bourbon-l'Archambault",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Braize",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Bransat",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Bresnay",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Bressolles",
    "dep": "Allier"
  },
  {
    "code": "03350",
    "ville": "Le Brethon",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Le Breuil",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Broût-Vernet",
    "dep": "Allier"
  },
  {
    "code": "03700",
    "ville": "Brugheas",
    "dep": "Allier"
  },
  {
    "code": "03270",
    "ville": "Busset",
    "dep": "Allier"
  },
  {
    "code": "03440",
    "ville": "Buxières-les-Mines",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "La Celle",
    "dep": "Allier"
  },
  {
    "code": "03350",
    "ville": "Cérilly",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Cesset",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "La Chabanne",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Chambérat",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Chamblet",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Chantelle",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Chapeau",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "La Chapelaude",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "La Chapelle",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "La Chapelle-aux-Chasses",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Chappes",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Chareil-Cintrat",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Charmeil",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Charmes",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Charroux",
    "dep": "Allier"
  },
  {
    "code": "03510",
    "ville": "Chassenard",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Château-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Châtel-de-Neuvre",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Châtel-Montagne",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Châtelperron",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Châtelus",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Châtillon",
    "dep": "Allier"
  },
  {
    "code": "03440",
    "ville": "Chavenon",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Chavroches",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Chazemais",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Chemilly",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Chevagnes",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Chezelle",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Chézy",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Chirat-l'Église",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Chouvigny",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Cindré",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Cognat-Lyonne",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "Colombier",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "Commentry",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Contigny",
    "dep": "Allier"
  },
  {
    "code": "03430",
    "ville": "Cosne-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Coulandon",
    "dep": "Allier"
  },
  {
    "code": "03470",
    "ville": "Coulanges",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Couleuvre",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Courçais",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Coutansouze",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Couzon",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Créchy",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Cressanges",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Creuzier-le-Neuf",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Creuzier-le-Vieux",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Cusset",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Deneuille-lès-Chantelle",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Deneuille-les-Mines",
    "dep": "Allier"
  },
  {
    "code": "03630",
    "ville": "Désertines",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Deux-Chaises",
    "dep": "Allier"
  },
  {
    "code": "03290",
    "ville": "Diou",
    "dep": "Allier"
  },
  {
    "code": "03410",
    "ville": "Domérat",
    "dep": "Allier"
  },
  {
    "code": "03290",
    "ville": "Dompierre-sur-Besbre",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Le Donjon",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Doyet",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Droiturier",
    "dep": "Allier"
  },
  {
    "code": "03310",
    "ville": "Durdat-Larequille",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Ébreuil",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Échassières",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Escurolles",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Espinasse-Vozelle",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Estivareilles",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Étroussat",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Ferrières-sur-Sichon",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "La Ferté-Hauterive",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Fleuriel",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Fourilles",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Franchesse",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Gannat",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Gannay-sur-Loire",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Garnat-sur-Engièvre",
    "dep": "Allier"
  },
  {
    "code": "03400",
    "ville": "Gennetines",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Gipcy",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Gouise",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "La Guillermie",
    "dep": "Allier"
  },
  {
    "code": "03270",
    "ville": "Hauterive",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Hérisson",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Huriel",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "Hyds",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Isle-et-Bardais",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Isserpent",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Jaligny-sur-Besbre",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Jenzat",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Laféline",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Lalizolle",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Lamaids",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Langy",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Lapalisse",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Laprugne",
    "dep": "Allier"
  },
  {
    "code": "03100",
    "ville": "Lavault-Sainte-Anne",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Lavoine",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Lenax",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Lételon",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Liernolles",
    "dep": "Allier"
  },
  {
    "code": "03410",
    "ville": "Lignerolles",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Limoise",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Loddes",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Loriges",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Louchy-Montfand",
    "dep": "Allier"
  },
  {
    "code": "03350",
    "ville": "Louroux-Bourbonnais",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "Louroux-de-Beaune",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Louroux-de-Bouble",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Luneau",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Lurcy-Lévis",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Lusigny",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Magnet",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Haut-Bocage",
    "dep": "Allier"
  },
  {
    "code": "03600",
    "ville": "Malicorne",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Marcenat",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Marcillat-en-Combraille",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Marigny",
    "dep": "Allier"
  },
  {
    "code": "03270",
    "ville": "Mariol",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Le Mayet-d'École",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Le Mayet-de-Montagne",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Mazerier",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Mazirat",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Meaulne-Vitray",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Meillard",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Meillers",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Mercy",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Mesples",
    "dep": "Allier"
  },
  {
    "code": "03510",
    "ville": "Molinet",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Molles",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Monestier",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Monétay-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03470",
    "ville": "Monétay-sur-Loire",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Montaiguët-en-Forez",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Montaigu-le-Blin",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Montbeugny",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Montcombroux-les-Mines",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Monteignet-sur-l'Andelot",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Le Montet",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Montilly",
    "dep": "Allier"
  },
  {
    "code": "03100",
    "ville": "Montluçon",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Montmarault",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Montoldre",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Montord",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Montvicq",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Moulins",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Murat",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Nades",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Nassigny",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Naves",
    "dep": "Allier"
  },
  {
    "code": "03310",
    "ville": "Néris-les-Bains",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Neuilly-en-Donjon",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Neuilly-le-Réal",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Neure",
    "dep": "Allier"
  },
  {
    "code": "03000",
    "ville": "Neuvy",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Nizerolles",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Noyant-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Paray-le-Frésil",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Paray-sous-Briailles",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Périgny",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "La Petite-Marche",
    "dep": "Allier"
  },
  {
    "code": "03470",
    "ville": "Pierrefitte-sur-Loire",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Le Pin",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Poëzat",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Pouzy-Mésangy",
    "dep": "Allier"
  },
  {
    "code": "03410",
    "ville": "Prémilhat",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Quinssaines",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Reugny",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Rocles",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Rongères",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Ronnet",
    "dep": "Allier"
  },
  {
    "code": "03170",
    "ville": "Saint-Angel",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Saint-Aubin-le-Monial",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Saint-Bonnet-de-Four",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Saint-Bonnet-de-Rochefort",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Saint-Bonnet-Tronçais",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Saint-Caprais",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Saint-Christophe-en-Bourbonnais",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Saint-Clément",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Saint-Désiré",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Saint-Didier-en-Donjon",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Saint-Didier-la-Forêt",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Saint-Éloy-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03400",
    "ville": "Saint-Ennemond",
    "dep": "Allier"
  },
  {
    "code": "03300",
    "ville": "Saint-Étienne-de-Vicq",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Saint-Fargeol",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Saint-Félix",
    "dep": "Allier"
  },
  {
    "code": "03310",
    "ville": "Saint-Genest",
    "dep": "Allier"
  },
  {
    "code": "03340",
    "ville": "Saint-Gérand-de-Vaux",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Saint-Gérand-le-Puy",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Saint-Germain-des-Fossés",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Saint-Germain-de-Salles",
    "dep": "Allier"
  },
  {
    "code": "03440",
    "ville": "Saint-Hilaire",
    "dep": "Allier"
  },
  {
    "code": "03130",
    "ville": "Saint-Léger-sur-Vouzance",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Saint-Léon",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Saint-Léopardin-d'Augy",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Saint-Loup",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Saint-Marcel-en-Murat",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Saint-Marcel-en-Marcillat",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Saint-Martin-des-Lais",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Saint-Martinien",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Saint-Menoux",
    "dep": "Allier"
  },
  {
    "code": "03250",
    "ville": "Saint-Nicolas-des-Biefs",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Saint-Palais",
    "dep": "Allier"
  },
  {
    "code": "42620",
    "ville": "Saint-Pierre-Laval",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Saint-Plaisir",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Saint-Pont",
    "dep": "Allier"
  },
  {
    "code": "03290",
    "ville": "Saint-Pourçain-sur-Besbre",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Saint-Pourçain-sur-Sioule",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Saint-Priest-d'Andelot",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Saint-Priest-en-Murat",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Saint-Prix",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Saint-Rémy-en-Rollat",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Saint-Sauvier",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Saint-Sornin",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Sainte-Thérence",
    "dep": "Allier"
  },
  {
    "code": "03410",
    "ville": "Saint-Victor",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Saint-Voir",
    "dep": "Allier"
  },
  {
    "code": "03270",
    "ville": "Saint-Yorre",
    "dep": "Allier"
  },
  {
    "code": "03470",
    "ville": "Saligny-sur-Roudon",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Sanssat",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Saulcet",
    "dep": "Allier"
  },
  {
    "code": "03800",
    "ville": "Saulzet",
    "dep": "Allier"
  },
  {
    "code": "03430",
    "ville": "Sauvagny",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Sazeret",
    "dep": "Allier"
  },
  {
    "code": "03700",
    "ville": "Serbannes",
    "dep": "Allier"
  },
  {
    "code": "03120",
    "ville": "Servilly",
    "dep": "Allier"
  },
  {
    "code": "03260",
    "ville": "Seuillet",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Sorbier",
    "dep": "Allier"
  },
  {
    "code": "03210",
    "ville": "Souvigny",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Sussat",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Target",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Taxat-Senat",
    "dep": "Allier"
  },
  {
    "code": "03410",
    "ville": "Teillet-Argenty",
    "dep": "Allier"
  },
  {
    "code": "03420",
    "ville": "Terjat",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Le Theil",
    "dep": "Allier"
  },
  {
    "code": "03350",
    "ville": "Theneuille",
    "dep": "Allier"
  },
  {
    "code": "03230",
    "ville": "Thiel-sur-Acolin",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Thionne",
    "dep": "Allier"
  },
  {
    "code": "03430",
    "ville": "Tortezais",
    "dep": "Allier"
  },
  {
    "code": "03400",
    "ville": "Toulon-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Treban",
    "dep": "Allier"
  },
  {
    "code": "03380",
    "ville": "Treignat",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Treteau",
    "dep": "Allier"
  },
  {
    "code": "03460",
    "ville": "Trévol",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Trézelles",
    "dep": "Allier"
  },
  {
    "code": "03240",
    "ville": "Tronget",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Urçay",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Ussel-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03330",
    "ville": "Valignat",
    "dep": "Allier"
  },
  {
    "code": "03360",
    "ville": "Valigny",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Vallon-en-Sully",
    "dep": "Allier"
  },
  {
    "code": "03150",
    "ville": "Varennes-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Varennes-sur-Tèche",
    "dep": "Allier"
  },
  {
    "code": "03220",
    "ville": "Vaumas",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Vaux",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Veauce",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Venas",
    "dep": "Allier"
  },
  {
    "code": "03110",
    "ville": "Vendat",
    "dep": "Allier"
  },
  {
    "code": "03190",
    "ville": "Verneix",
    "dep": "Allier"
  },
  {
    "code": "03200",
    "ville": "Le Vernet",
    "dep": "Allier"
  },
  {
    "code": "03500",
    "ville": "Verneuil-en-Bourbonnais",
    "dep": "Allier"
  },
  {
    "code": "03390",
    "ville": "Vernusse",
    "dep": "Allier"
  },
  {
    "code": "03320",
    "ville": "Le Veurdre",
    "dep": "Allier"
  },
  {
    "code": "03200",
    "ville": "Vichy",
    "dep": "Allier"
  },
  {
    "code": "03450",
    "ville": "Vicq",
    "dep": "Allier"
  },
  {
    "code": "03430",
    "ville": "Vieure",
    "dep": "Allier"
  },
  {
    "code": "03350",
    "ville": "Le Vilhain",
    "dep": "Allier"
  },
  {
    "code": "03310",
    "ville": "Villebret",
    "dep": "Allier"
  },
  {
    "code": "03430",
    "ville": "Villefranche-d'Allier",
    "dep": "Allier"
  },
  {
    "code": "03460",
    "ville": "Villeneuve-sur-Allier",
    "dep": "Allier"
  },
  {
    "code": "03370",
    "ville": "Viplaix",
    "dep": "Allier"
  },
  {
    "code": "03140",
    "ville": "Voussac",
    "dep": "Allier"
  },
  {
    "code": "03160",
    "ville": "Ygrande",
    "dep": "Allier"
  },
  {
    "code": "03400",
    "ville": "Yzeure",
    "dep": "Allier"
  },
  {
    "code": "04510",
    "ville": "Aiglun",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Allemagne-en-Provence",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Allons",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04260",
    "ville": "Allos",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Angles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Annot",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Archail",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Aubenas-les-Alpes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Aubignosc",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Authon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Auzet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Banon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Barcelonnette",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Barles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04380",
    "ville": "Barras",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Barrême",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Bayons",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Beaujeu",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04370",
    "ville": "Beauvezer",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Bellaffaire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Bevons",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Beynes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Blieux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Bras-d'Asse",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Braux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04340",
    "ville": "Ubaye-Serre-Ponçon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "La Brillanne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04210",
    "ville": "Brunet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Le Brusquet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Le Caire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "Castellane",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04380",
    "ville": "Le Castellard-Mélan",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "Le Castellet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04320",
    "ville": "Castellet-lès-Sausses",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04320",
    "ville": "Val-de-Chalvagne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04280",
    "ville": "Céreste-en-Luberon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04510",
    "ville": "Le Chaffaut-Saint-Jurson",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04660",
    "ville": "Champtercier",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04160",
    "ville": "Château-Arnoux-Saint-Auban",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Châteaufort",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Châteauneuf-Miravail",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Châteauneuf-Val-Saint-Donat",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Châteauredon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Chaudon-Norante",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Clamensane",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05110",
    "ville": "Claret",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Clumanc",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04370",
    "ville": "Colmars",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04530",
    "ville": "La Condamine-Châtelard",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04220",
    "ville": "Corbières-en-Provence",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Cruis",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05110",
    "ville": "Curbans",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Curel",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Dauphin",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "Demandolx",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04000",
    "ville": "Digne-les-Bains",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Draix",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Enchastrayes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Entrages",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Entrepierres",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04320",
    "ville": "Entrevaux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "Entrevennes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04160",
    "ville": "L'Escale",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04800",
    "ville": "Esparron-de-Verdon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Estoublon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Faucon-du-Caire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Faucon-de-Barcelonnette",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Fontienne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Forcalquier",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Le Fugeret",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04310",
    "ville": "Ganagobie",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "La Garde",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Gigors",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04800",
    "ville": "Gréoux-les-Bains",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "L'Hospitalet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04850",
    "ville": "Jausiers",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04000",
    "ville": "La Javie",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Lambruisse",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Lardiers",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04340",
    "ville": "Le Lauzet-Ubaye",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Limans",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "Lurs",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Majastres",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04350",
    "ville": "Malijai",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Mallefougasse-Augès",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04510",
    "ville": "Mallemoisson",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Mane",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04100",
    "ville": "Manosque",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Marcoux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Méailles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04190",
    "ville": "Les Mées",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Melve",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04530",
    "ville": "Val d'Oronaye",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Mézel",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04510",
    "ville": "Mirabeau",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Mison",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Montagnac-Montpezat",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Montclar",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04600",
    "ville": "Montfort",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Montfuron",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Montjustin",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Montlaux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Montsalier",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Moriez",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "La Motte-du-Caire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04360",
    "ville": "Moustiers-Sainte-Marie",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "La Mure-Argens",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Nibles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Niozelles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Noyers-sur-Jabron",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Les Omergues",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Ongles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Oppedette",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "Oraison",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "La Palud-sur-Verdon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Peipin",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "Peyroules",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04310",
    "ville": "Peyruis",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05130",
    "ville": "Piégut",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Pierrerue",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04860",
    "ville": "Pierrevert",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05160",
    "ville": "Pontis",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04420",
    "ville": "Prads-Haute-Bléone",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04700",
    "ville": "Puimichel",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04410",
    "ville": "Puimoisson",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Quinson",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Redortiers",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Reillanne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04340",
    "ville": "Méolans-Revel",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Revest-des-Brousses",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Revest-du-Bion",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Revest-Saint-Martin",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Riez",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04000",
    "ville": "La Robine-sur-Galabre",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "La Rochegiron",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "06260",
    "ville": "La Rochette",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "Rougon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Roumoules",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Saint-André-les-Alpes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Saint-Benoît",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Sainte-Croix-à-Lauze",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Sainte-Croix-du-Verdon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04380",
    "ville": "Hautes-Duyes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04230",
    "ville": "Saint-Étienne-les-Orgues",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Saint-Geniez",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Saint-Jacques",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Saint-Jeannet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04270",
    "ville": "Saint-Julien-d'Asse",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Saint-Julien-du-Verdon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04410",
    "ville": "Saint-Jurs",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04500",
    "ville": "Saint-Laurent-du-Verdon",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Saint-Lions",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Saint-Maime",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04800",
    "ville": "Saint-Martin-de-Brômes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Saint-Martin-les-Eaux",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Saint-Martin-lès-Seyne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04870",
    "ville": "Saint-Michel-l'Observatoire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04530",
    "ville": "Saint-Paul-sur-Ubaye",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "06260",
    "ville": "Saint-Pierre",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Saint-Pons",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04220",
    "ville": "Sainte-Tulle",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Saint-Vincent-sur-Jabron",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04290",
    "ville": "Salignac",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Saumane",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04320",
    "ville": "Sausses",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Selonnet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Senez",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Seyne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04300",
    "ville": "Sigonce",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Sigoyer",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04150",
    "ville": "Simiane-la-Rotonde",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Sisteron",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04120",
    "ville": "Soleilhas",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04290",
    "ville": "Sourribes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04330",
    "ville": "Tartonne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Thèze",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04380",
    "ville": "Thoard",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Thorame-Basse",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Thorame-Haute",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Les Thuiles",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Turriers",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04240",
    "ville": "Ubraye",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04400",
    "ville": "Uvernet-Fours",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Vachères",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04250",
    "ville": "Valavoire",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Valbelle",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04210",
    "ville": "Valensole",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Valernes",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04200",
    "ville": "Vaumeilh",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05130",
    "ville": "Venterol",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Verdaches",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04170",
    "ville": "Vergons",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04140",
    "ville": "Le Vernet",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04370",
    "ville": "Villars-Colmars",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04110",
    "ville": "Villemus",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04180",
    "ville": "Villeneuve",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04290",
    "ville": "Volonne",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "04130",
    "ville": "Volx",
    "dep": "Alpes-de-Haute-Provence"
  },
  {
    "code": "05460",
    "ville": "Abriès-Ristolas",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05470",
    "ville": "Aiguilles",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Ancelle",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05120",
    "ville": "L'Argentière-la-Bessée",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05350",
    "ville": "Arvieux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "Aspremont",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Aspres-lès-Corps",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "Aspres-sur-Buëch",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05230",
    "ville": "Avançon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Baratier",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "Barcillonnette",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Barret-sur-Méouge",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "La Bâtie-Montsaléon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05230",
    "ville": "La Bâtie-Neuve",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "La Bâtie-Vieille",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "La Beaume",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Le Bersac",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Bréziers",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Briançon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Valdoule",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Buissard",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Ceillac",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Cervières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Chabestan",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Chabottes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05310",
    "ville": "Champcella",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Champoléon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Chanousse",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Châteauneuf-d'Oze",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05380",
    "ville": "Châteauroux-les-Alpes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "Châteauvieux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05350",
    "ville": "Château-Ville-Vieille",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Aubessagne",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05230",
    "ville": "Chorges",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Crévoux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Crots",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Embrun",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Éourres",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "L'Épine",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "Esparron",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Espinasses",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Étoile-Saint-Cyrice",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Eygliers",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Garde-Colombe",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "La Fare-en-Champsaur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "La Faurie",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Forest-Saint-Julien",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Fouillouse",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05310",
    "ville": "Freissinières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "La Freissinouse",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Furmeyer",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "Gap",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Le Glaizil",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05320",
    "ville": "La Grave",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "La Chapelle-en-Valgaudémar",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Guillestre",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "La Haute-Beaume",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Jarjayes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Laragne-Montéglin",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "Lardier-et-Valença",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Laye",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Lazer",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Lettret",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Manteyer",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Méreuil",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05350",
    "ville": "Molines-en-Queyras",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "Monêtier-Allemont",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05220",
    "ville": "Le Monêtier-les-Bains",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "Montbrand",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Montclus",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Mont-Dauphin",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05230",
    "ville": "Montgardin",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Montgenèvre",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Montjay",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Montmaur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Montrond",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "La Motte-en-Champsaur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Moydans",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "Neffes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Névache",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Nossage-et-Bénévent",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Le Noyer",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05170",
    "ville": "Orcières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Orpierre",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Les Orres",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Oze",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "Pelleautier",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05340",
    "ville": "Vallouise-Pelvoux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "La Piarre",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Le Poët",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Poligny",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05230",
    "ville": "Prunières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Puy-Saint-André",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Puy-Saint-Eusèbe",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Puy-Saint-Pierre",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05290",
    "ville": "Puy-Saint-Vincent",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Puy-Sanières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Rabou",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "Rambaud",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05160",
    "ville": "Réallon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Remollon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Réotier",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Ribeyret",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Val Buëch-Méouge",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Risoul",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Rochebrune",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05310",
    "ville": "La Roche-de-Rame",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "La Roche-des-Arnauds",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05000",
    "ville": "La Rochette",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Rosans",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Rousset",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Saint-André-d'Embrun",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Saint-André-de-Rosans",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05160",
    "ville": "Saint-Apollinaire",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Saint-Auban-d'Oze",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Saint-Bonnet-en-Champsaur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05330",
    "ville": "Saint-Chaffrey",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Saint-Clément-sur-Durance",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Sainte-Colombe",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05600",
    "ville": "Saint-Crépin",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05250",
    "ville": "Dévoluy",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Saint-Étienne-le-Laus",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Saint-Firmin",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Saint-Jacques-en-Valgodemard",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Saint-Jean-Saint-Nicolas",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "Saint-Julien-en-Beauchêne",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Saint-Julien-en-Champsaur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05500",
    "ville": "Saint-Laurent-du-Cros",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Saint-Léger-les-Mélèzes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05120",
    "ville": "Saint-Martin-de-Queyrières",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Saint-Maurice-en-Valgodemard",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05260",
    "ville": "Saint-Michel-de-Chaillol",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05140",
    "ville": "Saint-Pierre-d'Argençon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Saint-Pierre-Avez",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05200",
    "ville": "Saint-Sauveur",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05350",
    "ville": "Saint-Véran",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Le Saix",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Saléon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Salérans",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05240",
    "ville": "La Salle-les-Alpes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "La Saulce",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05160",
    "ville": "Le Sauze-du-Lac",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05160",
    "ville": "Savines-le-Lac",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Savournon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Serres",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Sigottier",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Sigoyer",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05150",
    "ville": "Sorbiers",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Tallard",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05190",
    "ville": "Théus",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05700",
    "ville": "Trescléoux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Upaix",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Val-des-Prés",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05130",
    "ville": "Valserres",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05560",
    "ville": "Vars",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05300",
    "ville": "Ventavon",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05400",
    "ville": "Veynes",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05120",
    "ville": "Les Vigneaux",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05480",
    "ville": "Villar-d'Arêne",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05800",
    "ville": "Villar-Loubière",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05100",
    "ville": "Villar-Saint-Pancrace",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "05110",
    "ville": "Vitrolles",
    "dep": "Hautes-Alpes"
  },
  {
    "code": "06910",
    "ville": "Aiglun",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Amirat",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06750",
    "ville": "Andon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06160",
    "ville": "Antibes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Ascros",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06790",
    "ville": "Aspremont",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06810",
    "ville": "Auribeau-sur-Siagne",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Auvare",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Bairols",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06620",
    "ville": "Le Bar-sur-Loup",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06310",
    "ville": "Beaulieu-sur-Mer",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06240",
    "ville": "Beausoleil",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Belvédère",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06390",
    "ville": "Bendejun",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06390",
    "ville": "Berre-les-Alpes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Beuil",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Bézaudun-les-Alpes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06410",
    "ville": "Biot",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "Blausasc",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "La Bollène-Vésubie",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06830",
    "ville": "Bonson",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Bouyon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06540",
    "ville": "Breil-sur-Roya",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06850",
    "ville": "Briançonnet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Le Broc",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06530",
    "ville": "Cabris",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06800",
    "ville": "Cagnes-sur-Mer",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06750",
    "ville": "Caille",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06150",
    "ville": "Cannes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06110",
    "ville": "Le Cannet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06340",
    "ville": "Cantaron",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06320",
    "ville": "Cap-d'Ail",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Carros",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Castagniers",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06500",
    "ville": "Castellar",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06500",
    "ville": "Castillon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06460",
    "ville": "Caussols",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06740",
    "ville": "Châteauneuf-Grasse",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06390",
    "ville": "Châteauneuf-Villevieille",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Châteauneuf-d'Entraunes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06620",
    "ville": "Cipières",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Clans",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06390",
    "ville": "Coaraze",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06480",
    "ville": "La Colle-sur-Loup",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Collongues",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Colomars",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Conségudes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06390",
    "ville": "Contes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06620",
    "ville": "Courmes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06140",
    "ville": "Coursegoules",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "La Croix-sur-Roudoule",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Cuébris",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Daluis",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06340",
    "ville": "Drap",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Duranus",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Entraunes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "L'Escarène",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06460",
    "ville": "Escragnolles",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06360",
    "ville": "Èze",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06950",
    "ville": "Falicon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Les Ferres",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06540",
    "ville": "Fontan",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06850",
    "ville": "Gars",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06510",
    "ville": "Gattières",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06610",
    "ville": "La Gaude",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06830",
    "ville": "Gilette",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06500",
    "ville": "Gorbio",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06620",
    "ville": "Gourdon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06130",
    "ville": "Grasse",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06620",
    "ville": "Gréolières",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Guillaumes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Ilonse",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Isola",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Lantosque",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Levens",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Lieuche",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "Lucéram",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06710",
    "ville": "Malaussène",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06210",
    "ville": "Mandelieu-la-Napoule",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Marie",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Le Mas",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06710",
    "ville": "Massoins",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06500",
    "ville": "Menton",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06370",
    "ville": "Mouans-Sartoux",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06250",
    "ville": "Mougins",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06380",
    "ville": "Moulinet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Les Mujouls",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06000",
    "ville": "Nice",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06650",
    "ville": "Opio",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06580",
    "ville": "Pégomas",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "Peille",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "Peillon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "La Penne",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Péone",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06530",
    "ville": "Peymeinade",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Pierlas",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Pierrefeu",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Puget-Rostang",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Puget-Théniers",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06830",
    "ville": "Revest-les-Roches",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Rigaud",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Rimplas",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Roquebillière",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06190",
    "ville": "Roquebrune-Cap-Martin",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06330",
    "ville": "Roquefort-les-Pins",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Roquestéron",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "La Roque-en-Provence",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06550",
    "ville": "La Roquette-sur-Siagne",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "La Roquette-sur-Var",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Roubion",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Roure",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06650",
    "ville": "Le Rouret",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06500",
    "ville": "Sainte-Agnès",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06730",
    "ville": "Saint-André-de-la-Roche",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Saint-Antonin",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06850",
    "ville": "Saint-Auban",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Saint-Blaise",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06530",
    "ville": "Saint-Cézaire-sur-Siagne",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06660",
    "ville": "Saint-Dalmas-le-Selvage",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06660",
    "ville": "Saint-Étienne-de-Tinée",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06230",
    "ville": "Saint-Jean-Cap-Ferrat",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06640",
    "ville": "Saint-Jeannet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06700",
    "ville": "Saint-Laurent-du-Var",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06260",
    "ville": "Saint-Léger",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Saint-Martin-d'Entraunes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06670",
    "ville": "Saint-Martin-du-Var",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Saint-Martin-Vésubie",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06570",
    "ville": "Saint-Paul-de-Vence",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Saint-Sauveur-sur-Tinée",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06460",
    "ville": "Saint-Vallier-de-Thiey",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Sallagriffon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06540",
    "ville": "Saorge",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Sauze",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06750",
    "ville": "Séranon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06910",
    "ville": "Sigale",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06380",
    "ville": "Sospel",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06530",
    "ville": "Spéracèdes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06590",
    "ville": "Théoule-sur-Mer",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06710",
    "ville": "Thiéry",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06530",
    "ville": "Le Tignet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06830",
    "ville": "Toudon",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06440",
    "ville": "Touët-de-l'Escarène",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06710",
    "ville": "Touët-sur-Var",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "La Tour",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06830",
    "ville": "Tourette-du-Château",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Tournefort",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06690",
    "ville": "Tourrette-Levens",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06140",
    "ville": "Tourrettes-sur-Loup",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06340",
    "ville": "La Trinité",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06320",
    "ville": "La Turbie",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Utelle",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06560",
    "ville": "Valbonne",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06420",
    "ville": "Valdeblore",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06750",
    "ville": "Valderoure",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06220",
    "ville": "Vallauris",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06450",
    "ville": "Venanson",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06140",
    "ville": "Vence",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06710",
    "ville": "Villars-sur-Var",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06230",
    "ville": "Villefranche-sur-Mer",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06470",
    "ville": "Villeneuve-d'Entraunes",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06270",
    "ville": "Villeneuve-Loubet",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06430",
    "ville": "La Brigue",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "06430",
    "ville": "Tende",
    "dep": "Alpes-Maritimes"
  },
  {
    "code": "07160",
    "ville": "Accons",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Ailhon",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Aizac",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Ajoux",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Alba-la-Romaine",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Albon-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07440",
    "ville": "Alboussière",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Alissas",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Andance",
    "dep": "Ardèche"
  },
  {
    "code": "07100",
    "ville": "Annonay",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Vallées-d'Antraigues-Asperjoc",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Arcens",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Ardoix",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Arlebosc",
    "dep": "Ardèche"
  },
  {
    "code": "07370",
    "ville": "Arras-sur-Rhône",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Les Assions",
    "dep": "Ardèche"
  },
  {
    "code": "07330",
    "ville": "Astet",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Aubenas",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Aubignas",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Baix",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Balazuc",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Banne",
    "dep": "Ardèche"
  },
  {
    "code": "07330",
    "ville": "Barnas",
    "dep": "Ardèche"
  },
  {
    "code": "07630",
    "ville": "Le Béage",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Beauchastel",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Beaulieu",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Beaumont",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Beauvène",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Berrias-et-Casteljau",
    "dep": "Ardèche"
  },
  {
    "code": "07580",
    "ville": "Berzème",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Bessas",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Bidon",
    "dep": "Ardèche"
  },
  {
    "code": "07440",
    "ville": "Boffres",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Bogy",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Borée",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Borne",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Bozas",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Boucieu-le-Roi",
    "dep": "Ardèche"
  },
  {
    "code": "07100",
    "ville": "Boulieu-lès-Annonay",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Bourg-Saint-Andéol",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Brossainc",
    "dep": "Ardèche"
  },
  {
    "code": "07450",
    "ville": "Burzet",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Cellier-du-Luc",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Chalencon",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Le Chambon",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Chambonas",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Champagne",
    "dep": "Ardèche"
  },
  {
    "code": "07440",
    "ville": "Champis",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Chandolas",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Chanéac",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Charmes-sur-Rhône",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Charnas",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Chassiers",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Châteaubourg",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Châteauneuf-de-Vernoux",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Chauzon",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Chazeaux",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Cheminas",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Le Cheylard",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Chirols",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Chomérac",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Colombier-le-Cardinal",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Colombier-le-Jeune",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Colombier-le-Vieux",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Cornas",
    "dep": "Ardèche"
  },
  {
    "code": "07470",
    "ville": "Coucouron",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Coux",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Le Crestet",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Creysseilles",
    "dep": "Ardèche"
  },
  {
    "code": "07510",
    "ville": "Cros-de-Géorand",
    "dep": "Ardèche"
  },
  {
    "code": "07350",
    "ville": "Cruas",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Darbres",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Davézieux",
    "dep": "Ardèche"
  },
  {
    "code": "07570",
    "ville": "Désaignes",
    "dep": "Ardèche"
  },
  {
    "code": "07320",
    "ville": "Devesset",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Dompnac",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Dornas",
    "dep": "Ardèche"
  },
  {
    "code": "07360",
    "ville": "Dunière-sur-Eyrieux",
    "dep": "Ardèche"
  },
  {
    "code": "07370",
    "ville": "Eclassan",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Empurany",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Étables",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Fabras",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Faugères",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Félines",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Flaviac",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Fons",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Freyssenet",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Genestelle",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Gilhac-et-Bruzac",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Gilhoc-sur-Ormèze",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Gluiras",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Glun",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Gourdon",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Gras",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Gravières",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Grospierres",
    "dep": "Ardèche"
  },
  {
    "code": "07500",
    "ville": "Guilherand-Granges",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Saint-Julien-d'Intres",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Issamoulenc",
    "dep": "Ardèche"
  },
  {
    "code": "07660",
    "ville": "Issanlas",
    "dep": "Ardèche"
  },
  {
    "code": "07470",
    "ville": "Issarlès",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Jaujac",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Jaunac",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Joannas",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Joyeuse",
    "dep": "Ardèche"
  },
  {
    "code": "07600",
    "ville": "Juvinas",
    "dep": "Ardèche"
  },
  {
    "code": "07600",
    "ville": "Labastide-sur-Bésorgues",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Labastide-de-Virac",
    "dep": "Ardèche"
  },
  {
    "code": "07570",
    "ville": "Labatie-d'Andaure",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Labeaume",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Labégude",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Lablachère",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Laboule",
    "dep": "Ardèche"
  },
  {
    "code": "07470",
    "ville": "Le Lac-d'Issarlès",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Lachamp-Raphaël",
    "dep": "Ardèche"
  },
  {
    "code": "07470",
    "ville": "Lachapelle-Graillouse",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Lachapelle-sous-Aubenas",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Lachapelle-sous-Chanéac",
    "dep": "Ardèche"
  },
  {
    "code": "07520",
    "ville": "Lafarre",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Lagorce",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Lalevade-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07520",
    "ville": "Lalouvesc",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Lamastre",
    "dep": "Ardèche"
  },
  {
    "code": "07660",
    "ville": "Lanarce",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Lanas",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Largentière",
    "dep": "Ardèche"
  },
  {
    "code": "07220",
    "ville": "Larnas",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Laurac-en-Vivarais",
    "dep": "Ardèche"
  },
  {
    "code": "48250",
    "ville": "Laveyrune",
    "dep": "Ardèche"
  },
  {
    "code": "07660",
    "ville": "Lavillatte",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Lavilledieu",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Laviolle",
    "dep": "Ardèche"
  },
  {
    "code": "07610",
    "ville": "Lemps",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Lentillères",
    "dep": "Ardèche"
  },
  {
    "code": "07660",
    "ville": "Lespéron",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Limony",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Loubaresse",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Lussas",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Lyas",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Malarce-sur-la-Thines",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Malbosc",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Marcols-les-Eaux",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Mariac",
    "dep": "Ardèche"
  },
  {
    "code": "07320",
    "ville": "Mars",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Mauves",
    "dep": "Ardèche"
  },
  {
    "code": "07330",
    "ville": "Mayres",
    "dep": "Ardèche"
  },
  {
    "code": "07510",
    "ville": "Mazan-l'Abbaye",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Mercuer",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Meyras",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Meysse",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Mézilhac",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Mirabel",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Monestier",
    "dep": "Ardèche"
  },
  {
    "code": "07560",
    "ville": "Montpezat-sous-Bauzon",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Montréal",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Montselgues",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Belsentes",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Nozières",
    "dep": "Ardèche"
  },
  {
    "code": "07360",
    "ville": "Les Ollières-sur-Eyrieux",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Orgnac-l'Aven",
    "dep": "Ardèche"
  },
  {
    "code": "07370",
    "ville": "Ozon",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Pailharès",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Payzac",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Peaugres",
    "dep": "Ardèche"
  },
  {
    "code": "07450",
    "ville": "Péreyres",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Peyraud",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Le Plagnal",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Planzolles",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Plats",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Pont-de-Labeaume",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Pourchères",
    "dep": "Ardèche"
  },
  {
    "code": "07250",
    "ville": "Le Pouzin",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Prades",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Pradons",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Pranles",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Préaux",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Privas",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Prunet",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Quintenas",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Ribes",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Rochecolombe",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Rochemaure",
    "dep": "Ardèche"
  },
  {
    "code": "07320",
    "ville": "Rochepaule",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Rocher",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Rochessauve",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "La Rochette",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Rocles",
    "dep": "Ardèche"
  },
  {
    "code": "07100",
    "ville": "Roiffieux",
    "dep": "Ardèche"
  },
  {
    "code": "07250",
    "ville": "Rompon",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Rosières",
    "dep": "Ardèche"
  },
  {
    "code": "07560",
    "ville": "Le Roux",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Ruoms",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Sablières",
    "dep": "Ardèche"
  },
  {
    "code": "07450",
    "ville": "Sagnes-et-Goudoulet",
    "dep": "Ardèche"
  },
  {
    "code": "07320",
    "ville": "Saint-Agrève",
    "dep": "Ardèche"
  },
  {
    "code": "07790",
    "ville": "Saint-Alban-d'Ay",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Saint-Alban-en-Montagne",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Saint-Alban-Auriolles",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Saint-Andéol-de-Berg",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Andéol-de-Fourchades",
    "dep": "Ardèche"
  },
  {
    "code": "07600",
    "ville": "Saint-Andéol-de-Vals",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Saint-André-de-Cruzières",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Saint-André-en-Vivarais",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Saint-André-Lachamp",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Saint-Apollinaire-de-Rias",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Barthélemy-le-Meil",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Saint-Barthélemy-Grozon",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Saint-Barthélemy-le-Plain",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Saint-Basile",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Saint-Bauzile",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Christol",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Saint-Cierge-la-Serre",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Cierge-sous-le-Cheylard",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "Saint-Cirgues-de-Prades",
    "dep": "Ardèche"
  },
  {
    "code": "07510",
    "ville": "Saint-Cirgues-en-Montagne",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Saint-Clair",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Saint-Clément",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Saint-Cyr",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Saint-Désirat",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Didier-sous-Aubenas",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Étienne-de-Boulogne",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Étienne-de-Fontbellon",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Saint-Étienne-de-Lugdarès",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Saint-Étienne-de-Serre",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Saint-Étienne-de-Valoux",
    "dep": "Ardèche"
  },
  {
    "code": "07510",
    "ville": "Sainte-Eulalie",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Saint-Félicien",
    "dep": "Ardèche"
  },
  {
    "code": "07360",
    "ville": "Saint-Fortunat-sur-Eyrieux",
    "dep": "Ardèche"
  },
  {
    "code": "07230",
    "ville": "Saint-Genest-de-Beauzon",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Genest-Lachamp",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Saint-Georges-les-Bains",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Saint-Germain",
    "dep": "Ardèche"
  },
  {
    "code": "07580",
    "ville": "Saint-Gineys-en-Coiron",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Saint-Jacques-d'Atticieux",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Saint-Jean-Chambre",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Saint-Jean-de-Muzols",
    "dep": "Ardèche"
  },
  {
    "code": "07580",
    "ville": "Saint-Jean-le-Centenier",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Jean-Roure",
    "dep": "Ardèche"
  },
  {
    "code": "07320",
    "ville": "Saint-Jeure-d'Andaure",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Saint-Jeure-d'Ay",
    "dep": "Ardèche"
  },
  {
    "code": "07530",
    "ville": "Saint-Joseph-des-Bancs",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Saint-Julien-du-Gua",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Julien-du-Serre",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Saint-Julien-en-Saint-Alban",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Saint-Julien-le-Roux",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Saint-Julien-Vocance",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Saint-Just-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Saint-Lager-Bressac",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "Saint-Laurent-du-Pape",
    "dep": "Ardèche"
  },
  {
    "code": "07590",
    "ville": "Saint-Laurent-les-Bains-Laval-d'Aurelle",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Saint-Laurent-sous-Coiron",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Saint-Marcel-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07100",
    "ville": "Saint-Marcel-lès-Annonay",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Sainte-Marguerite-Lafigère",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Saint-Martial",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Saint-Martin-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07310",
    "ville": "Saint-Martin-de-Valamas",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Saint-Martin-sur-Lavezon",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Maurice-d'Ardèche",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Saint-Maurice-d'Ibie",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Saint-Maurice-en-Chalencon",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Saint-Mélany",
    "dep": "Ardèche"
  },
  {
    "code": "07160",
    "ville": "Saint-Michel-d'Aurance",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Michel-de-Boulogne",
    "dep": "Ardèche"
  },
  {
    "code": "07360",
    "ville": "Saint-Michel-de-Chabrillanoux",
    "dep": "Ardèche"
  },
  {
    "code": "07220",
    "ville": "Saint-Montan",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Saint-Paul-le-Jeune",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Saint-Péray",
    "dep": "Ardèche"
  },
  {
    "code": "07450",
    "ville": "Saint-Pierre-de-Colombier",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Saint-Pierre-la-Roche",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Saint-Pierre-Saint-Jean",
    "dep": "Ardèche"
  },
  {
    "code": "07520",
    "ville": "Saint-Pierre-sur-Doux",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Saint-Pierreville",
    "dep": "Ardèche"
  },
  {
    "code": "07580",
    "ville": "Saint-Pons",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Saint-Priest",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Privat",
    "dep": "Ardèche"
  },
  {
    "code": "07270",
    "ville": "Saint-Prix",
    "dep": "Ardèche"
  },
  {
    "code": "07700",
    "ville": "Saint-Remèze",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Saint-Romain-d'Ay",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Saint-Romain-de-Lerps",
    "dep": "Ardèche"
  },
  {
    "code": "07460",
    "ville": "Saint-Sauveur-de-Cruzières",
    "dep": "Ardèche"
  },
  {
    "code": "07190",
    "ville": "Saint-Sauveur-de-Montagut",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Saint-Sernin",
    "dep": "Ardèche"
  },
  {
    "code": "07440",
    "ville": "Saint-Sylvestre",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Saint-Symphorien-sous-Chomérac",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Saint-Symphorien-de-Mahun",
    "dep": "Ardèche"
  },
  {
    "code": "07220",
    "ville": "Saint-Thomé",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Saint-Victor",
    "dep": "Ardèche"
  },
  {
    "code": "07210",
    "ville": "Saint-Vincent-de-Barrès",
    "dep": "Ardèche"
  },
  {
    "code": "07360",
    "ville": "Saint-Vincent-de-Durfort",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Salavas",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Les Salelles",
    "dep": "Ardèche"
  },
  {
    "code": "07120",
    "ville": "Sampzon",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Sanilhac",
    "dep": "Ardèche"
  },
  {
    "code": "07370",
    "ville": "Sarras",
    "dep": "Ardèche"
  },
  {
    "code": "07290",
    "ville": "Satillieu",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Savas",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Sceautres",
    "dep": "Ardèche"
  },
  {
    "code": "07610",
    "ville": "Sécheras",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Serrières",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Silhac",
    "dep": "Ardèche"
  },
  {
    "code": "07380",
    "ville": "La Souche",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Soyons",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Talencieux",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Tauriers",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Le Teil",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Thorrenc",
    "dep": "Ardèche"
  },
  {
    "code": "07330",
    "ville": "Thueyts",
    "dep": "Ardèche"
  },
  {
    "code": "07130",
    "ville": "Toulaud",
    "dep": "Ardèche"
  },
  {
    "code": "07300",
    "ville": "Tournon-sur-Rhône",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Ucel",
    "dep": "Ardèche"
  },
  {
    "code": "07510",
    "ville": "Usclades-et-Rieutord",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Uzer",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Vagnas",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Valgorge",
    "dep": "Ardèche"
  },
  {
    "code": "07150",
    "ville": "Vallon-Pont-d'Arc",
    "dep": "Ardèche"
  },
  {
    "code": "07600",
    "ville": "Vals-les-Bains",
    "dep": "Ardèche"
  },
  {
    "code": "07400",
    "ville": "Valvignères",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Vanosc",
    "dep": "Ardèche"
  },
  {
    "code": "07140",
    "ville": "Les Vans",
    "dep": "Ardèche"
  },
  {
    "code": "07410",
    "ville": "Vaudevant",
    "dep": "Ardèche"
  },
  {
    "code": "07260",
    "ville": "Vernon",
    "dep": "Ardèche"
  },
  {
    "code": "07430",
    "ville": "Vernosc-lès-Annonay",
    "dep": "Ardèche"
  },
  {
    "code": "07240",
    "ville": "Vernoux-en-Vivarais",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Vesseaux",
    "dep": "Ardèche"
  },
  {
    "code": "07000",
    "ville": "Veyras",
    "dep": "Ardèche"
  },
  {
    "code": "07170",
    "ville": "Villeneuve-de-Berg",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Villevocance",
    "dep": "Ardèche"
  },
  {
    "code": "07110",
    "ville": "Vinezac",
    "dep": "Ardèche"
  },
  {
    "code": "07340",
    "ville": "Vinzieux",
    "dep": "Ardèche"
  },
  {
    "code": "07610",
    "ville": "Vion",
    "dep": "Ardèche"
  },
  {
    "code": "07220",
    "ville": "Viviers",
    "dep": "Ardèche"
  },
  {
    "code": "07690",
    "ville": "Vocance",
    "dep": "Ardèche"
  },
  {
    "code": "07200",
    "ville": "Vogüé",
    "dep": "Ardèche"
  },
  {
    "code": "07800",
    "ville": "La Voulte-sur-Rhône",
    "dep": "Ardèche"
  },
  {
    "code": "08300",
    "ville": "Acy-Romance",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Aiglemont",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Aire",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Alincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Alland'Huy-et-Sausseuil",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Amagne",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Ambly-Fleury",
    "dep": "Ardennes"
  },
  {
    "code": "08500",
    "ville": "Anchamps",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Angecourt",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Annelles",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Antheny",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Aouste",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Apremont",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Ardeuil-et-Montfauxelles",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Les Grandes-Armoises",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Les Petites-Armoises",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Arnicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Arreux",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Artaise-le-Vivier",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Asfeld",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Attigny",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Aubigny-les-Pothées",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Auboncourt-Vauzelles",
    "dep": "Ardennes"
  },
  {
    "code": "08320",
    "ville": "Aubrives",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Auflance",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Auge",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Aure",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Aussonce",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Authe",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Autrecourt-et-Pourron",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Autruche",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Autry",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Auvillers-les-Forges",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Avançon",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Avaux",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "Les Ayvelles",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Baâlons",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Balan",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Balham",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Ballay",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Banogne-Recouvrance",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Barbaise",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Barby",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Bar-lès-Buzancy",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Bayonville",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Bazeilles",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Beaumont-en-Argonne",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Beffu-et-le-Morthomme",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Belleville-et-Châtillon-sur-Bar",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Belval",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Belval-Bois-des-Dames",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Bergnicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "La Berlière",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Bertoncourt",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "La Besace",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Biermes",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Bièvres",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Bignicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Blagny",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Blanchefosse-et-Bay",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Blanzy-la-Salonnaise",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Blombay",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Bossus-lès-Rumigny",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Bouconville",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Boult-aux-Bois",
    "dep": "Ardennes"
  },
  {
    "code": "08410",
    "ville": "Boulzicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Bourcq",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Bourg-Fidèle",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Bouvellemont",
    "dep": "Ardennes"
  },
  {
    "code": "08120",
    "ville": "Bogny-sur-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Brécy-Brières",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Brévilly",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Brienne-sur-Aisne",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Brieulles-sur-Bar",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Briquenay",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Brognon",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Bulson",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Buzancy",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Carignan",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Cauroy",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Cernion",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Chagny",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Chalandry-Elaire",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Challerange",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Champigneulle",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Champigneul-sur-Vence",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Champlin",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "La Chapelle",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Chappes",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Charbogne",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Chardeny",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "Charleville-Mézières",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Charnois",
    "dep": "Ardennes"
  },
  {
    "code": "08360",
    "ville": "Château-Porcien",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Chatel-Chéhéry",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Le Châtelet-sur-Sormonne",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Le Châtelet-sur-Retourne",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Chaumont-Porcien",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Chémery-Chéhéry",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Bairon et ses environs",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Chesnois-Auboncourt",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Cheveuges",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Chevières",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Chilly",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Chooz",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Chuffilly-Roche",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Clavy-Warby",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Cliron",
    "dep": "Ardennes"
  },
  {
    "code": "08360",
    "ville": "Condé-lès-Herpy",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Condé-lès-Autry",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Contreuve",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Cornay",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Corny-Machéroménil",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Coucy",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Coulommes-et-Marqueny",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "La Croix-aux-Bois",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Daigny",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Damouzy",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Les Deux-Villes",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Deville",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Dom-le-Mesnil",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Dommery",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Donchery",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Doumely-Bégny",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Doux",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Douzy",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Draize",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Dricourt",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "L'Écaille",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "L'Échelle",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Écly",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Écordal",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Escombres-et-le-Chesnois",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Estrebay",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Étalle",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Éteignières",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Étrépigny",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Euilly-et-Lombut",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Évigny",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Exermont",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Fagnon",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Faissault",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Falaise",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Faux",
    "dep": "Ardennes"
  },
  {
    "code": "08170",
    "ville": "Fépin",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "La Férée",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "La Ferté-sur-Chiers",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Flaignes-Havys",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Fleigneux",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Fléville",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Fligny",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Flize",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Floing",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Foisches",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Fossé",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Fraillicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Francheval",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "La Francheville",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Le Fréty",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Fromelennes",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Fromy",
    "dep": "Ardennes"
  },
  {
    "code": "08170",
    "ville": "Fumay",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Germont",
    "dep": "Ardennes"
  },
  {
    "code": "08440",
    "ville": "Gernelle",
    "dep": "Ardennes"
  },
  {
    "code": "08700",
    "ville": "Gespunsart",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Girondelle",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Givet",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Givonne",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Givron",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Givry",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Glaire",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Gomont",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Grandchamp",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Grandham",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Grandpré",
    "dep": "Ardennes"
  },
  {
    "code": "08700",
    "ville": "La Grandville",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Grivy-Loisy",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Gruyères",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Gué-d'Hossus",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Guignicourt-sur-Vence",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Guincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Hagnicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Ham-les-Moines",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Ham-sur-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Hannappes",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Hannogne-Saint-Martin",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Hannogne-Saint-Rémy",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Haraucourt",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Harcy",
    "dep": "Ardennes"
  },
  {
    "code": "08170",
    "ville": "Hargnies",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Harricourt",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Haudrecy",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Haulmé",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Les Hautes-Rivières",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Hauteville",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Hauviné",
    "dep": "Ardennes"
  },
  {
    "code": "08170",
    "ville": "Haybes",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Herbeuval",
    "dep": "Ardennes"
  },
  {
    "code": "08360",
    "ville": "Herpy-l'Arlésienne",
    "dep": "Ardennes"
  },
  {
    "code": "08320",
    "ville": "Hierges",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "La Horgne",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Houdilcourt",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Houldizy",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Illy",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Imécourt",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Inaumont",
    "dep": "Ardennes"
  },
  {
    "code": "08440",
    "ville": "Issancourt-et-Rumel",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Jandun",
    "dep": "Ardennes"
  },
  {
    "code": "08700",
    "ville": "Joigny-sur-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Jonval",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Juniville",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Justine-Herbigny",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Laifour",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Lalobbe",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Lametz",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Lançon",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Landres-et-Saint-Georges",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Landrichamps",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Launois-sur-Vence",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Laval-Morency",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Leffincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Lépron-les-Vallées",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Létanne",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Liart",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Linay",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Liry",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Logny-Bogny",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Longwé",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Lonny",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Lucquy",
    "dep": "Ardennes"
  },
  {
    "code": "08440",
    "ville": "Lumes",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Machault",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Maisoncelle-et-Villers",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Malandry",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Manre",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Maranwez",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Marby",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Marcq",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Margny",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Margut",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Marlemont",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Marquigny",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Mars-sous-Bourcq",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Marvaux-Vieux",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Matton-et-Clémency",
    "dep": "Ardennes"
  },
  {
    "code": "08260",
    "ville": "Maubert-Fontaine",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Mazerny",
    "dep": "Ardennes"
  },
  {
    "code": "08500",
    "ville": "Les Mazures",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Ménil-Annelles",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Ménil-Lépinois",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Mesmont",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Messincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Mogues",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Moiry",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Mondigny",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Montcheutin",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Montcornet",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Montcy-Notre-Dame",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Le Mont-Dieu",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Montgon",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Monthermé",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Monthois",
    "dep": "Ardennes"
  },
  {
    "code": "08170",
    "ville": "Montigny-sur-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Montigny-sur-Vence",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Mont-Laurent",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Montmeillant",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Mont-Saint-Martin",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Mont-Saint-Remy",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Mouron",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Mouzon",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Murtin-et-Bogny",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Nanteuil-sur-Aisne",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Neuflize",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Neufmaison",
    "dep": "Ardennes"
  },
  {
    "code": "08700",
    "ville": "Neufmanil",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "La Neuville-à-Maire",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "La Neuville-aux-Joûtes",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Neuville-lez-Beaulieu",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "La Neuville-en-Tourne-à-Fuy",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Neuville-Day",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Neuville-lès-This",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "La Neuville-lès-Wasigny",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Neuvizy",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Noirval",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Nouart",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Nouvion-sur-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08700",
    "ville": "Nouzonville",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Novion-Porcien",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Novy-Chevrières",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Noyers-Pont-Maugis",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Oches",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Olizy-Primat",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Omicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Omont",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Osnes",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Pauvres",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Perthes",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Poilcourt-Sydney",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Poix-Terron",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Pouru-aux-Bois",
    "dep": "Ardennes"
  },
  {
    "code": "08140",
    "ville": "Pouru-Saint-Remy",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Prez",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "Prix-lès-Mézières",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Puilly-et-Charbeaux",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Puiseux",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Pure",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Quatre-Champs",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Quilly",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Raillicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08600",
    "ville": "Rancennes",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Raucourt-et-Flaba",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Regniowez",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Remaucourt",
    "dep": "Ardennes"
  },
  {
    "code": "08450",
    "ville": "Remilly-Aillicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Remilly-les-Pothées",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Renneville",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Renwez",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Rethel",
    "dep": "Ardennes"
  },
  {
    "code": "08500",
    "ville": "Revin",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Rilly-sur-Aisne",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Rimogne",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Rocquigny",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Rocroi",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Roizy",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "La Romagne",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Rouvroy-sur-Audry",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Rubigny",
    "dep": "Ardennes"
  },
  {
    "code": "08290",
    "ville": "Rumigny",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "La Sabotterie",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Sachy",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Sailly",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Saint-Aignan",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Saint-Clément-à-Arnes",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Saint-Étienne-à-Arnes",
    "dep": "Ardennes"
  },
  {
    "code": "08360",
    "ville": "Saint-Fergeux",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Saint-Germainmont",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Saint-Jean-aux-Bois",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Saint-Juvin",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Saint-Lambert-et-Mont-de-Jeux",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Saint-Laurent",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Saint-Loup-en-Champagne",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Saint-Loup-Terrier",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Saint-Marceau",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Saint-Marcel",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Sainte-Marie",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Saint-Menges",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Saint-Morel",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Saint-Pierre-à-Arnes",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Saint-Pierremont",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Saint-Pierre-sur-Vence",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Saint-Quentin-le-Petit",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Saint-Remy-le-Petit",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Sainte-Vaubourg",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Sapogne-sur-Marche",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Sapogne-et-Feuchères",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Saulces-Champenoises",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Saulces-Monclin",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Sault-lès-Rethel",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Sault-Saint-Remy",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Sauville",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Savigny-sur-Aisne",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Séchault",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Sécheval",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Sedan",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Semide",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Semuy",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Senuc",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Seraincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Sery",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Seuil",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Sévigny-la-Forêt",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Sévigny-Waleppe",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Signy-l'Abbaye",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Signy-le-Petit",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Signy-Montlibert",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Singly",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Sommauthe",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Sommerance",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Son",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Sorbon",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Sorcy-Bauthémont",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Sormonne",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Stonne",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Sugny",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Sury",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Suzanne",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Sy",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Tagnon",
    "dep": "Ardennes"
  },
  {
    "code": "08230",
    "ville": "Taillette",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Tailly",
    "dep": "Ardennes"
  },
  {
    "code": "08360",
    "ville": "Taizy",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Tannay",
    "dep": "Ardennes"
  },
  {
    "code": "08380",
    "ville": "Tarzy",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Tétaigne",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Thelonne",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Thénorgues",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Thilay",
    "dep": "Ardennes"
  },
  {
    "code": "08460",
    "ville": "Thin-le-Moutier",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "This",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Le Thour",
    "dep": "Ardennes"
  },
  {
    "code": "08300",
    "ville": "Thugny-Trugny",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Toges",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Touligny",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Tourcelles-Chaumont",
    "dep": "Ardennes"
  },
  {
    "code": "08800",
    "ville": "Tournavaux",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Tournes",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Tourteron",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Tremblois-lès-Carignan",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Tremblois-lès-Rocroi",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Vandy",
    "dep": "Ardennes"
  },
  {
    "code": "08130",
    "ville": "Vaux-Champagne",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Vaux-en-Dieulet",
    "dep": "Ardennes"
  },
  {
    "code": "08250",
    "ville": "Vaux-lès-Mouron",
    "dep": "Ardennes"
  },
  {
    "code": "08220",
    "ville": "Vaux-lès-Rubigny",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Vaux-lès-Mouzon",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Vaux-Montreuil",
    "dep": "Ardennes"
  },
  {
    "code": "08150",
    "ville": "Vaux-Villaine",
    "dep": "Ardennes"
  },
  {
    "code": "08160",
    "ville": "Vendresse",
    "dep": "Ardennes"
  },
  {
    "code": "08240",
    "ville": "Verpel",
    "dep": "Ardennes"
  },
  {
    "code": "08390",
    "ville": "Verrières",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Viel-Saint-Remy",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Vieux-lès-Asfeld",
    "dep": "Ardennes"
  },
  {
    "code": "08190",
    "ville": "Villers-devant-le-Thour",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Villers-devant-Mouzon",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Villers-le-Tilleul",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Villers-le-Tourneur",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "Villers-Semeuse",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Villers-sur-Bar",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Villers-sur-le-Mont",
    "dep": "Ardennes"
  },
  {
    "code": "08440",
    "ville": "Ville-sur-Lumes",
    "dep": "Ardennes"
  },
  {
    "code": "08310",
    "ville": "Ville-sur-Retourne",
    "dep": "Ardennes"
  },
  {
    "code": "08370",
    "ville": "Villy",
    "dep": "Ardennes"
  },
  {
    "code": "08320",
    "ville": "Vireux-Molhain",
    "dep": "Ardennes"
  },
  {
    "code": "08320",
    "ville": "Vireux-Wallerand",
    "dep": "Ardennes"
  },
  {
    "code": "08440",
    "ville": "Vivier-au-Court",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Voncq",
    "dep": "Ardennes"
  },
  {
    "code": "08400",
    "ville": "Vouziers",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Vrigne aux Bois",
    "dep": "Ardennes"
  },
  {
    "code": "08350",
    "ville": "Vrigne-Meuse",
    "dep": "Ardennes"
  },
  {
    "code": "08200",
    "ville": "Wadelincourt",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Wagnon",
    "dep": "Ardennes"
  },
  {
    "code": "08000",
    "ville": "Warcq",
    "dep": "Ardennes"
  },
  {
    "code": "08090",
    "ville": "Warnécourt",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Wasigny",
    "dep": "Ardennes"
  },
  {
    "code": "08270",
    "ville": "Wignicourt",
    "dep": "Ardennes"
  },
  {
    "code": "08110",
    "ville": "Williers",
    "dep": "Ardennes"
  },
  {
    "code": "08210",
    "ville": "Yoncq",
    "dep": "Ardennes"
  },
  {
    "code": "08430",
    "ville": "Yvernaumont",
    "dep": "Ardennes"
  },
  {
    "code": "09240",
    "ville": "Aigues-Juntes",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Aigues-Vives",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "L'Aiguillon",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Albiès",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Aleu",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Alliat",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Allières",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Alos",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Alzen",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Antras",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Appy",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Arabaux",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Argein",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Arignac",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Arnave",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Arrien-en-Bethmale",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Arrout",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Artigat",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Artigues",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Artix",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Arvigna",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Ascou",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Aston",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Aucazein",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Audressein",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Augirein",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Aulus-les-Bains",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Auzat",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Axiat",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Ax-les-Thermes",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Bagert",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Balacet",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Balaguères",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Barjac",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "La Bastide-de-Besplas",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "La Bastide-de-Bousignac",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "La Bastide-de-Lordat",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "La Bastide-du-Salat",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "La Bastide-de-Sérou",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "La Bastide-sur-l'Hers",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Baulou",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Bédeilhac-et-Aynat",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Bédeille",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Bélesta",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Belloc",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Bénac",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Benagues",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Bénaix",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Besset",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Bestiac",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Betchat",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Bethmale",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Bézac",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Biert",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Bompas",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Bonac-Irazein",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Bonnac",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Les Bordes-sur-Arize",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Bordes-Uchentein",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Le Bosc",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Bouan",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Boussenac",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Brassac",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Brie",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Burret",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Buzan",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Les Cabannes",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Cadarcet",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Calzan",
    "dep": "Ariège"
  },
  {
    "code": "09290",
    "ville": "Camarade",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Camon",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Campagne-sur-Arize",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Canté",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Capoulet-et-Junac",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Carcanières",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Carla-Bayle",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Carla-de-Roquefort",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Le Carlaret",
    "dep": "Ariège"
  },
  {
    "code": "09420",
    "ville": "Castelnau-Durban",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Castéras",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Castex",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Castillon-en-Couserans",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Caumont",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Caussou",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Caychax",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Cazals-des-Baylès",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Cazaux",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Cazavet",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Cazenave-Serres-et-Allens",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Celles",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Cérizols",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Cescau",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Château-Verdun",
    "dep": "Ariège"
  },
  {
    "code": "09420",
    "ville": "Clermont",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Contrazy",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Cos",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Couflens",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Coussa",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Coutens",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Crampagna",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Dalou",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Daumazan-sur-Arize",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Dreuilhe",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Dun",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Durban-sur-Arize",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Durfort",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Encourtiech",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Engomer",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Ercé",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Erp",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Esclagne",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Escosse",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Esplas",
    "dep": "Ariège"
  },
  {
    "code": "09420",
    "ville": "Esplas-de-Sérou",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Eycheil",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Fabas",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Ferrières-sur-Ariège",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Foix",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Fornex",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Le Fossat",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Fougax-et-Barrineuf",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Freychenet",
    "dep": "Ariège"
  },
  {
    "code": "09290",
    "ville": "Gabre",
    "dep": "Ariège"
  },
  {
    "code": "09190",
    "ville": "Gajan",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Galey",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Ganac",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Garanou",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Gaudiès",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Génat",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Gestiès",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Gourbit",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Gudas",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "L'Herm",
    "dep": "Ariège"
  },
  {
    "code": "09390",
    "ville": "L'Hospitalet-près-l'Andorre",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Ignaux",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Illartein",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Ilhat",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Illier-et-Laramade",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Les Issards",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Justiniac",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Labatut",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Lacave",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Lacourt",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Lagarde",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Lanoux",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Lapège",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Lapenne",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Larbont",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Larcat",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Larnat",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Laroque-d'Olmes",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Lasserre",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Lassur",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Lavelanet",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Léran",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Lercoul",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Lescousse",
    "dep": "Ariège"
  },
  {
    "code": "09420",
    "ville": "Lescure",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Lesparrou",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Leychert",
    "dep": "Ariège"
  },
  {
    "code": "09210",
    "ville": "Lézat-sur-Lèze",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Lieurac",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Limbrassac",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Lissac",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Lordat",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Loubaut",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Loubens",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Loubières",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Ludiès",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Luzenac",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Madière",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Malegoude",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Malléon",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Manses",
    "dep": "Ariège"
  },
  {
    "code": "09290",
    "ville": "Le Mas-d'Azil",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Massat",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Mauvezin-de-Prat",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Mauvezin-de-Sainte-Croix",
    "dep": "Ariège"
  },
  {
    "code": "09270",
    "ville": "Mazères",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Méras",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Mercenac",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Mercus-Garrabet",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Mérens-les-Vals",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Mérigon",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Miglos",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Mijanès",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Mirepoix",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Monesple",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Montagagne",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Montaillou",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Montardit",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Montaut",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Montbel",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Montégut-en-Couserans",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Montégut-Plantaurel",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Montels",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Montesquieu-Avantès",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Montfa",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Montferrier",
    "dep": "Ariège"
  },
  {
    "code": "09330",
    "ville": "Montgailhard",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Montgauch",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Montjoie-en-Couserans",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Montoulieu",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Montségur",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Montseron",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Moulin-Neuf",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Moulis",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Nalzen",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Nescus",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Niaux",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Orgeix",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Orgibet",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Orlu",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Ornolac-Ussat-les-Bains",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Orus",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Oust",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Pailhès",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Pamiers",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Pech",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Péreille",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Perles-et-Castelet",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Le Peyrat",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Le Pla",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Le Port",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Prades",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Pradettes",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Pradières",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Prat-Bonrepaux",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Prayols",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Le Puch",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Les Pujols",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Quérigut",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Quié",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Rabat-les-Trois-Seigneurs",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Raissac",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Régat",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Rieucros",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Rieux-de-Pelleport",
    "dep": "Ariège"
  },
  {
    "code": "09420",
    "ville": "Rimont",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Rivèrenert",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Roquefixade",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Roquefort-les-Cascades",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Roumengoux",
    "dep": "Ariège"
  },
  {
    "code": "09460",
    "ville": "Rouze",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Sabarat",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Saint-Amadou",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Saint-Bauzeil",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Sainte-Croix-Volvestre",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Saint-Félix-de-Rieutord",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Saint-Félix-de-Tournegat",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Sainte-Foi",
    "dep": "Ariège"
  },
  {
    "code": "09200",
    "ville": "Saint-Girons",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Saint-Jean-d'Aigues-Vives",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Saint-Jean-du-Castillonnais",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Saint-Jean-de-Verges",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Saint-Jean-du-Falga",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Saint-Julien-de-Gras-Capou",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Saint-Lary",
    "dep": "Ariège"
  },
  {
    "code": "09190",
    "ville": "Saint-Lizier",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Saint-Martin-de-Caralp",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Saint-Martin-d'Oydes",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Saint-Michel",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Saint-Paul-de-Jarrat",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Saint-Pierre-de-Rivière",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Saint-Quentin-la-Tour",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Saint-Quirc",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Saint-Victor-Rouzaud",
    "dep": "Ariège"
  },
  {
    "code": "09210",
    "ville": "Saint-Ybars",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Salsein",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Saurat",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Sautel",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Saverdun",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Savignac-les-Ormeaux",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Ségura",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Seix",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Senconac",
    "dep": "Ariège"
  },
  {
    "code": "09190",
    "ville": "Lorp-Sentaraille",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Sentein",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Sentenac-d'Oust",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Sentenac-de-Sérou",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Serres-sur-Arget",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Sieuras",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Siguer",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Aulos-Sinsat",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Sor",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Sorgeat",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Soueix-Rogalle",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Soula",
    "dep": "Ariège"
  },
  {
    "code": "09320",
    "ville": "Soulan",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Surba",
    "dep": "Ariège"
  },
  {
    "code": "09240",
    "ville": "Suzan",
    "dep": "Ariège"
  },
  {
    "code": "09600",
    "ville": "Tabre",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Tarascon-sur-Ariège",
    "dep": "Ariège"
  },
  {
    "code": "09160",
    "ville": "Taurignan-Castet",
    "dep": "Ariège"
  },
  {
    "code": "09190",
    "ville": "Taurignan-Vieux",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Teilhet",
    "dep": "Ariège"
  },
  {
    "code": "09350",
    "ville": "Thouars-sur-Arize",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Tignac",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "La Tour-du-Crieu",
    "dep": "Ariège"
  },
  {
    "code": "09230",
    "ville": "Tourtouse",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Tourtrol",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Trémoulet",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Troye-d'Ariège",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Unac",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Unzent",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Urs",
    "dep": "Ariège"
  },
  {
    "code": "09400",
    "ville": "Ussat",
    "dep": "Ariège"
  },
  {
    "code": "09140",
    "ville": "Ustou",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Vals",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Varilhes",
    "dep": "Ariège"
  },
  {
    "code": "09110",
    "ville": "Vaychis",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Vèbre",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Ventenac",
    "dep": "Ariège"
  },
  {
    "code": "09310",
    "ville": "Verdun",
    "dep": "Ariège"
  },
  {
    "code": "09000",
    "ville": "Vernajoul",
    "dep": "Ariège"
  },
  {
    "code": "09250",
    "ville": "Vernaux",
    "dep": "Ariège"
  },
  {
    "code": "09700",
    "ville": "Le Vernet",
    "dep": "Ariège"
  },
  {
    "code": "09340",
    "ville": "Verniolle",
    "dep": "Ariège"
  },
  {
    "code": "09220",
    "ville": "Val-de-Sos",
    "dep": "Ariège"
  },
  {
    "code": "09800",
    "ville": "Villeneuve",
    "dep": "Ariège"
  },
  {
    "code": "09300",
    "ville": "Villeneuve-d'Olmes",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Villeneuve-du-Latou",
    "dep": "Ariège"
  },
  {
    "code": "09100",
    "ville": "Villeneuve-du-Paréage",
    "dep": "Ariège"
  },
  {
    "code": "09120",
    "ville": "Vira",
    "dep": "Ariège"
  },
  {
    "code": "09500",
    "ville": "Viviès",
    "dep": "Ariège"
  },
  {
    "code": "09130",
    "ville": "Sainte-Suzanne",
    "dep": "Ariège"
  },
  {
    "code": "10200",
    "ville": "Ailleville",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Aix-Villemaur-Pâlis",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Allibaudières",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Amance",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Arcis-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Arconville",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Argançon",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Arrelles",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Arrembécourt",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Arrentières",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Arsonval",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Assenay",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Assencières",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Aubeterre",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Aulnay",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Auxon",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Val-d'Auzon",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Avant-lès-Marcilly",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Avant-lès-Ramerupt",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Avirey-Lingey",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Avon-la-Pèze",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Avreuil",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Bagneux-la-Fosse",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Bailly-le-Franc",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Balignicourt",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Balnot-la-Grange",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Balnot-sur-Laignes",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "Barberey-Saint-Sulpice",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Barbuise",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Baroville",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Bar-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Bar-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10310",
    "ville": "Bayel",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Bercenay-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Bercenay-le-Hayer",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Bergères",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Bernon",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Bertignolles",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Bérulle",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Bessy",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Bétignicourt",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Beurey",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Blaincourt-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Blignicourt",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Bligny",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Les Bordes-Aumont",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Bossancourt",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Bouilly",
    "dep": "Aube"
  },
  {
    "code": "10380",
    "ville": "Boulages",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Bouranton",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Bourdenay",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Bourguignons",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Bouy-Luxembourg",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Bouy-sur-Orvin",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Bragelogne-Beauvoir",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Braux",
    "dep": "Aube"
  },
  {
    "code": "10450",
    "ville": "Bréviandes",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Brévonnes",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Briel-sur-Barse",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Brienne-la-Vieille",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Brienne-le-Château",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Brillecourt",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Bucey-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Buchères",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Buxeuil",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Buxières-sur-Arce",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Celles-sur-Ource",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Chacenay",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "La Chaise",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Chalette-sur-Voire",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Chamoy",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Champfleury",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Champignol-lez-Mondeville",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Champigny-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Champ-sur-Barse",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Channes",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Chaource",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "La Chapelle-Saint-Luc",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Chapelle-Vallon",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Chappes",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Charmont-sous-Barbuise",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Charmoy",
    "dep": "Aube"
  },
  {
    "code": "10380",
    "ville": "Charny-le-Bachot",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Chaserey",
    "dep": "Aube"
  },
  {
    "code": "10510",
    "ville": "Châtres",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Chauchigny",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Chaudrey",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Chauffour-lès-Bailly",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Chaumesnil",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Chavanges",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Le Chêne",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Chennegy",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Chervey",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Chesley",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Chessy-les-Prés",
    "dep": "Aube"
  },
  {
    "code": "10390",
    "ville": "Clérey",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Coclois",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Colombé-la-Fosse",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Colombé-le-Sec",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Cormost",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Courcelles-sur-Voire",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Courceroy",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Coursan-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Courtaoult",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Courtenot",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Courteranges",
    "dep": "Aube"
  },
  {
    "code": "10250",
    "ville": "Courteron",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Coussegrey",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Couvignon",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Crancey",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Creney-près-Troyes",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Crésantignes",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Crespy-le-Neuf",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Les Croûtes",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Cunfin",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Cussangy",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Dampierre",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Davrey",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Dienville",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Dierrey-Saint-Julien",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Dierrey-Saint-Pierre",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Dolancourt",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Dommartin-le-Coq",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Donnement",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Dosches",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Dosnon",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Droupt-Saint-Basle",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Droupt-Sainte-Marie",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Eaux-Puiseaux",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Échemines",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Éclance",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Éguilly-sous-Bois",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Engente",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Épagne",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Épothémont",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Ervy-le-Châtel",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Essoyes",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Estissac",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Étourvy",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Étrelles-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Faux-Villecerf",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Fay-lès-Marcilly",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Fays-la-Chapelle",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Ferreux-Quincey",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Feuges",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Fontaine",
    "dep": "Aube"
  },
  {
    "code": "10280",
    "ville": "Fontaine-les-Grès",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Fontaine-Mâcon",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Fontenay-de-Bossery",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Fontette",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Fontvannes",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "La Fosse-Corduan",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Fouchères",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Fralignes",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Fravaux",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Fresnay",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Fresnoy-le-Château",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Fuligny",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Gélannes",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Géraudot",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Les Grandes-Chapelles",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Grandville",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Les Granges",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Gumery",
    "dep": "Aube"
  },
  {
    "code": "10250",
    "ville": "Gyé-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Hampigny",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Herbisse",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Isle-Aumont",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Isle-Aubigny",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Jasseines",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Jaucourt",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Javernant",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Jessains",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Jeugny",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Joncreuil",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Jully-sur-Sarce",
    "dep": "Aube"
  },
  {
    "code": "10310",
    "ville": "Juvancourt",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Juvanzé",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Juzanvigny",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Lagesse",
    "dep": "Aube"
  },
  {
    "code": "10120",
    "ville": "Laines-aux-Bois",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Landreville",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Lantages",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Lassicourt",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Laubressel",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Lavau",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Lentilles",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Lesmont",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Lévigny",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Lhuître",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Lignières",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Lignol-le-Château",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Lirey",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Loches-sur-Ource",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "La Loge-aux-Chèvres",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "La Loge-Pomblin",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Les Loges-Margueron",
    "dep": "Aube"
  },
  {
    "code": "10310",
    "ville": "Longchamp-sur-Aujon",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Longeville-sur-Mogne",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Longpré-le-Sec",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Longsols",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Longueville-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "La Louptière-Thénard",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Lusigny-sur-Barse",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Luyères",
    "dep": "Aube"
  },
  {
    "code": "10300",
    "ville": "Macey",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Machy",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Magnant",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Magnicourt",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Magny-Fouchard",
    "dep": "Aube"
  },
  {
    "code": "10230",
    "ville": "Mailly-le-Camp",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Maison-des-Champs",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Maisons-lès-Chaource",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Maisons-lès-Soulaines",
    "dep": "Aube"
  },
  {
    "code": "10510",
    "ville": "Maizières-la-Grande-Paroisse",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Maizières-lès-Brienne",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Maraye-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Marcilly-le-Hayer",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Marigny-le-Châtel",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Marnay-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Marolles-lès-Bailly",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Marolles-sous-Lignières",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Mathaux",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Maupas",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "Mergey",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Le Mériot",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Merrey-sur-Arce",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Méry-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Mesgrigny",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Mesnil-la-Comtesse",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Mesnil-Lettre",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Mesnil-Saint-Loup",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Mesnil-Saint-Père",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Mesnil-Sellières",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Messon",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Metz-Robert",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Meurville",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Molins-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Montaulin",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Montceaux-lès-Vaudes",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Montfey",
    "dep": "Aube"
  },
  {
    "code": "10300",
    "ville": "Montgueux",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Montiéramey",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Montier-en-l'Isle",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Montigny-les-Monts",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Montmartin-le-Haut",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Montmorency-Beaufort",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Montpothier",
    "dep": "Aube"
  },
  {
    "code": "10270",
    "ville": "Montreuil-sur-Barse",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Montsuzain",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Morembert",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Morvilliers",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "La Motte-Tilly",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Moussey",
    "dep": "Aube"
  },
  {
    "code": "10250",
    "ville": "Mussy-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10250",
    "ville": "Neuville-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Neuville-sur-Vanne",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Noé-les-Mallets",
    "dep": "Aube"
  },
  {
    "code": "10420",
    "ville": "Les Noës-près-Troyes",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Nogent-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Nogent-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Nogent-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Nozay",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Onjon",
    "dep": "Aube"
  },
  {
    "code": "10510",
    "ville": "Origny-le-Sec",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Ormes",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Ortillon",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Orvilliers-Saint-Julien",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Ossey-les-Trois-Maisons",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Paisy-Cosdon",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Pargues",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Pars-lès-Chavanges",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Pars-lès-Romilly",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Le Pavillon-Sainte-Julie",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "Payns",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Pel-et-Der",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Périgny-la-Rose",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Perthes-lès-Brienne",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Petit-Mesnil",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Piney",
    "dep": "Aube"
  },
  {
    "code": "10250",
    "ville": "Plaines-Saint-Lange",
    "dep": "Aube"
  },
  {
    "code": "10380",
    "ville": "Plancy-l'Abbaye",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Planty",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Plessis-Barbuise",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Poivres",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Poligny",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Polisot",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Polisy",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Pont-Sainte-Marie",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Pont-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Pouan-les-Vallées",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Pougy",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Pouy-sur-Vannes",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Praslin",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Précy-Notre-Dame",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Précy-Saint-Martin",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Prémierfait",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Proverville",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Prugny",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Prunay-Belleville",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Prusy",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Puits-et-Nuisement",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Racines",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Radonvilliers",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Ramerupt",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Rances",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Rhèges",
    "dep": "Aube"
  },
  {
    "code": "10340",
    "ville": "Les Riceys",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Rigny-la-Nonneuse",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Rigny-le-Ferron",
    "dep": "Aube"
  },
  {
    "code": "10280",
    "ville": "Rilly-Sainte-Syre",
    "dep": "Aube"
  },
  {
    "code": "10440",
    "ville": "La Rivière-de-Corps",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Romilly-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Roncenay",
    "dep": "Aube"
  },
  {
    "code": "10430",
    "ville": "Rosières-près-Troyes",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Rosnay-l'Hôpital",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "La Rothière",
    "dep": "Aube"
  },
  {
    "code": "10220",
    "ville": "Rouilly-Sacey",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Rouilly-Saint-Loup",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Rouvres-les-Vignes",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Rumilly-lès-Vaudes",
    "dep": "Aube"
  },
  {
    "code": "10410",
    "ville": "Ruvigny",
    "dep": "Aube"
  },
  {
    "code": "10120",
    "ville": "Saint-André-les-Vergers",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Saint-Aubin",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Saint-Benoist-sur-Vanne",
    "dep": "Aube"
  },
  {
    "code": "10180",
    "ville": "Saint-Benoît-sur-Seine",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Saint-Christophe-Dodinicourt",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Saint-Étienne-sous-Barbuise",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Saint-Flavy",
    "dep": "Aube"
  },
  {
    "code": "10120",
    "ville": "Saint-Germain",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Saint-Hilaire-sous-Romilly",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Saint-Jean-de-Bonneval",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Saint-Julien-les-Villas",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Saint-Léger-près-Troyes",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Saint-Léger-sous-Brienne",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Saint-Léger-sous-Margerie",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Saint-Loup-de-Buffigny",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Saint-Lupien",
    "dep": "Aube"
  },
  {
    "code": "10180",
    "ville": "Saint-Lyé",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Saint-Mards-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10100",
    "ville": "Saint-Martin-de-Bossenay",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Sainte-Maure",
    "dep": "Aube"
  },
  {
    "code": "10280",
    "ville": "Saint-Mesmin",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Saint-Nabord-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Saint-Nicolas-la-Chapelle",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Saint-Oulph",
    "dep": "Aube"
  },
  {
    "code": "10410",
    "ville": "Saint-Parres-aux-Tertres",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Saint-Parres-lès-Vaudes",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Saint-Phal",
    "dep": "Aube"
  },
  {
    "code": "10120",
    "ville": "Saint-Pouange",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Saint-Remy-sous-Barbuise",
    "dep": "Aube"
  },
  {
    "code": "10300",
    "ville": "Sainte-Savine",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Saint-Thibault",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Saint-Usage",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Salon",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Saulcy",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "La Saulsotte",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "Savières",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Semoine",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Soligny-les-Étangs",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Sommeval",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Soulaines-Dhuys",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Souligny",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Spoy",
    "dep": "Aube"
  },
  {
    "code": "10410",
    "ville": "Thennelières",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Thieffrain",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Thil",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Thors",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Torcy-le-Grand",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Torcy-le-Petit",
    "dep": "Aube"
  },
  {
    "code": "10440",
    "ville": "Torvilliers",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "Traînel",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Trancault",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Trannes",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Trouans",
    "dep": "Aube"
  },
  {
    "code": "10000",
    "ville": "Troyes",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Turgy",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Unienville",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Urville",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Vailly",
    "dep": "Aube"
  },
  {
    "code": "10170",
    "ville": "Vallant-Saint-Georges",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Vallentigny",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Vallières",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Vanlay",
    "dep": "Aube"
  },
  {
    "code": "10190",
    "ville": "Vauchassis",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Vauchonvilliers",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Vaucogne",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Vaudes",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Vaupoisson",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Vendeuvre-sur-Barse",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "La Vendue-Mignot",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Vernonvilliers",
    "dep": "Aube"
  },
  {
    "code": "10360",
    "ville": "Verpillières-sur-Ource",
    "dep": "Aube"
  },
  {
    "code": "10240",
    "ville": "Verricourt",
    "dep": "Aube"
  },
  {
    "code": "10390",
    "ville": "Verrières",
    "dep": "Aube"
  },
  {
    "code": "10380",
    "ville": "Viâpres-le-Petit",
    "dep": "Aube"
  },
  {
    "code": "10600",
    "ville": "Villacerf",
    "dep": "Aube"
  },
  {
    "code": "10290",
    "ville": "Villadin",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "La Ville-aux-Bois",
    "dep": "Aube"
  },
  {
    "code": "10410",
    "ville": "Villechétif",
    "dep": "Aube"
  },
  {
    "code": "10350",
    "ville": "Villeloup",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Villemereuil",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Villemoiron-en-Othe",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Villemorien",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Villemoyenne",
    "dep": "Aube"
  },
  {
    "code": "10370",
    "ville": "Villenauxe-la-Grande",
    "dep": "Aube"
  },
  {
    "code": "10400",
    "ville": "La Villeneuve-au-Châtelot",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Villeneuve-au-Chemin",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "La Villeneuve-au-Chêne",
    "dep": "Aube"
  },
  {
    "code": "10330",
    "ville": "Villeret",
    "dep": "Aube"
  },
  {
    "code": "10320",
    "ville": "Villery",
    "dep": "Aube"
  },
  {
    "code": "10310",
    "ville": "Ville-sous-la-Ferté",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Ville-sur-Arce",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Ville-sur-Terre",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Villette-sur-Aube",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Villiers-Herbisse",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Villiers-le-Bois",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Villiers-sous-Praslin",
    "dep": "Aube"
  },
  {
    "code": "10140",
    "ville": "Villy-en-Trodes",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Villy-le-Bois",
    "dep": "Aube"
  },
  {
    "code": "10800",
    "ville": "Villy-le-Maréchal",
    "dep": "Aube"
  },
  {
    "code": "10700",
    "ville": "Vinets",
    "dep": "Aube"
  },
  {
    "code": "10260",
    "ville": "Virey-sous-Bar",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Vitry-le-Croisé",
    "dep": "Aube"
  },
  {
    "code": "10110",
    "ville": "Viviers-sur-Artaut",
    "dep": "Aube"
  },
  {
    "code": "10200",
    "ville": "Voigny",
    "dep": "Aube"
  },
  {
    "code": "10130",
    "ville": "Vosnon",
    "dep": "Aube"
  },
  {
    "code": "10150",
    "ville": "Voué",
    "dep": "Aube"
  },
  {
    "code": "10210",
    "ville": "Vougrey",
    "dep": "Aube"
  },
  {
    "code": "10160",
    "ville": "Vulaines",
    "dep": "Aube"
  },
  {
    "code": "10500",
    "ville": "Yèvres-le-Petit",
    "dep": "Aube"
  },
  {
    "code": "11800",
    "ville": "Aigues-Vives",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Airoux",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Ajac",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Alaigne",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Alairac",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Albas",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Albières",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Alet-les-Bains",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Alzonne",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Antugnac",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Aragon",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Argeliers",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Argens-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11110",
    "ville": "Armissan",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Arques",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Arquettes-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Artigues",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Arzens",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Aunat",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Auriac",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Axat",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Azille",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Badens",
    "dep": "Aude"
  },
  {
    "code": "11100",
    "ville": "Bages",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Bagnoles",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Baraigne",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Barbaira",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Belcaire",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Belcastel-et-Buc",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Belflou",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Belfort-sur-Rebenty",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Bellegarde-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Belpech",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Belvèze-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Belvianes-et-Cavirac",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Belvis",
    "dep": "Aude"
  },
  {
    "code": "11000",
    "ville": "Berriac",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Bessède-de-Sault",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "La Bezole",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Bizanet",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Bize-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Blomac",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Bouilhonnac",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Bouisse",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Bouriège",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Bourigeole",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Le Bousquet",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Boutenac",
    "dep": "Aude"
  },
  {
    "code": "11150",
    "ville": "Bram",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Brézilhac",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Brousses-et-Villaret",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Brugairolles",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Les Brunels",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Bugarach",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Cabrespine",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Cahuzac",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Cailhau",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Cailhavel",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Cailla",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Cambieure",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Campagna-de-Sault",
    "dep": "Aude"
  },
  {
    "code": "11260",
    "ville": "Campagne-sur-Aude",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Camplong-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Camps-sur-l'Agly",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Camurac",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Canet",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Capendu",
    "dep": "Aude"
  },
  {
    "code": "11000",
    "ville": "Carcassonne",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Carlipa",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Cascastel-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "La Cassaigne",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Cassaignes",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Les Cassés",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Castans",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Castelnaudary",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Castelnau-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Castelreng",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Caudebronde",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Val de Lambronne",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Caunes-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Caunette-sur-Lauquet",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Caunettes-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Caux-et-Sauzens",
    "dep": "Aude"
  },
  {
    "code": "11570",
    "ville": "Cavanac",
    "dep": "Aude"
  },
  {
    "code": "11510",
    "ville": "Caves",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Cazalrenoux",
    "dep": "Aude"
  },
  {
    "code": "11570",
    "ville": "Cazilhac",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Cenne-Monestiés",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Cépie",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Chalabre",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Citou",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Le Clat",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Clermont-sur-Lauquet",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Comigne",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Comus",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Conilhac-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Conques-sur-Orbiel",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Corbières",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Coudons",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Couffoulens",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Couiza",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Counozouls",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Cournanel",
    "dep": "Aude"
  },
  {
    "code": "11110",
    "ville": "Coursan",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Courtauly",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "La Courtète",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Coustaussa",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Coustouge",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Cruscades",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Cubières-sur-Cinoble",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Cucugnan",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Cumiès",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Cuxac-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11590",
    "ville": "Cuxac-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Davejean",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Dernacueillette",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "La Digne-d'Amont",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "La Digne-d'Aval",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Donazac",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Douzens",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Duilhac-sous-Peyrepertuse",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Durban-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Embres-et-Castelmaure",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Escales",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Escouloubre",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Escueillens-et-Saint-Just-de-Bélengard",
    "dep": "Aude"
  },
  {
    "code": "11260",
    "ville": "Espéraza",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Espezel",
    "dep": "Aude"
  },
  {
    "code": "11260",
    "ville": "Val-du-Faby",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Fabrezan",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Fajac-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Fajac-la-Relenque",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "La Fajolle",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Fanjeaux",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Félines-Termenès",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Fendeille",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Fenouillet-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Ferrals-les-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Ferran",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Festes-et-Saint-André",
    "dep": "Aude"
  },
  {
    "code": "11510",
    "ville": "Feuilla",
    "dep": "Aude"
  },
  {
    "code": "11510",
    "ville": "Fitou",
    "dep": "Aude"
  },
  {
    "code": "11560",
    "ville": "Fleury",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Floure",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Fontanès-de-Sault",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Fontcouverte",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Fonters-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Fontiers-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Fontiès-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Fontjoncouse",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "La Force",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Fournes-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Fourtou",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Fraisse-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Fraissé-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Gaja-et-Villedieu",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Gaja-la-Selve",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Galinagues",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Gardie",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Generville",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Gincla",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Ginestas",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Ginoles",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Gourvieille",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Gramazie",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Granès",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Greffeil",
    "dep": "Aude"
  },
  {
    "code": "11430",
    "ville": "Gruissan",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Homps",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Hounoux",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Les Ilhes",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Issel",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Jonquières",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Joucou",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Labastide-d'Anjou",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Labastide-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Labastide-Esparbairenque",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Labécède-Lauragais",
    "dep": "Aude"
  },
  {
    "code": "11310",
    "ville": "Lacombe",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Ladern-sur-Lauquet",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Lafage",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Lagrasse",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Lairière",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Lanet",
    "dep": "Aude"
  },
  {
    "code": "11480",
    "ville": "La Palme",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Laprade",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "La Redorte",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Laroque-de-Fa",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Lasbordes",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Lasserre-de-Prouille",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Lastours",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Laurabuc",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Laurac",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Lauraguel",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Laure-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Lavalette",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Lespinassière",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Leuc",
    "dep": "Aude"
  },
  {
    "code": "11370",
    "ville": "Leucate",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Lézignan-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Lignairolles",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Limousis",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Limoux",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Loupia",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "La Louvière-Lauragais",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Luc-sur-Aude",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Luc-sur-Orbieu",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Magrie",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Mailhac",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Maisons",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Malras",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Malves-en-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Malviès",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Marcorignan",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Marquein",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Marsa",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Marseillette",
    "dep": "Aude"
  },
  {
    "code": "11390",
    "ville": "Les Martys",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Mas-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11570",
    "ville": "Mas-des-Cours",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Massac",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Mas-Saintes-Puelles",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Mayreville",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Mayronnes",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Mazerolles-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Mazuby",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Mérial",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Mézerville",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Miraval-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Mirepeisset",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Mireval-Lauragais",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Missègre",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Molandier",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Molleville",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Montauriol",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Montazels",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Montbrun-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Montclar",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Montferrand",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Montfort-sur-Boulzane",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Montgaillard",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Montgradail",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Monthaut",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Montirat",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Montjardin",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Montjoi",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Val-de-Dagne",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Montmaur",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Montolieu",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Montréal",
    "dep": "Aude"
  },
  {
    "code": "11100",
    "ville": "Montredon-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Montséret",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Monze",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Moussan",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Moussoulens",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Mouthoumet",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Moux",
    "dep": "Aude"
  },
  {
    "code": "11100",
    "ville": "Narbonne",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Nébias",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Névian",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Niort-de-Sault",
    "dep": "Aude"
  },
  {
    "code": "11210",
    "ville": "Port-la-Nouvelle",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Ornaisons",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Orsans",
    "dep": "Aude"
  },
  {
    "code": "11590",
    "ville": "Ouveillan",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Padern",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Palairac",
    "dep": "Aude"
  },
  {
    "code": "11570",
    "ville": "Palaja",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Paraza",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Pauligne",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Payra-sur-l'Hers",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Paziols",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Pécharic-et-le-Py",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Pech-Luna",
    "dep": "Aude"
  },
  {
    "code": "11610",
    "ville": "Pennautier",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Pépieux",
    "dep": "Aude"
  },
  {
    "code": "11150",
    "ville": "Pexiora",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Peyrefitte-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Peyrefitte-sur-l'Hers",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Peyrens",
    "dep": "Aude"
  },
  {
    "code": "11440",
    "ville": "Peyriac-de-Mer",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Peyriac-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Peyrolles",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Pezens",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Pieusse",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Plaigne",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Plavilla",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "La Pomarède",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Pomas",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Pomy",
    "dep": "Aude"
  },
  {
    "code": "11490",
    "ville": "Portel-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Pouzols-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Pradelles-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Preixan",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Puginier",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Puichéric",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Puilaurens",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Puivert",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Quillan",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Quintillan",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Quirbajou",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Raissac-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Raissac-sur-Lampy",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Rennes-le-Château",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Rennes-les-Bains",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Ribaute",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Ribouisse",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Ricaud",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Rieux-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Rieux-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Rivel",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Rodome",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Roquecourbe-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "Roquefère",
    "dep": "Aude"
  },
  {
    "code": "11340",
    "ville": "Roquefeuil",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Roquefort-de-Sault",
    "dep": "Aude"
  },
  {
    "code": "11540",
    "ville": "Roquefort-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Roquetaillade-et-Conilhac",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Roubia",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Rouffiac-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Rouffiac-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Roullens",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Routier",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Rustiques",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Saint-Amans",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Saint-André-de-Roquelongue",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Saint-Benoît",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Sainte-Camelle",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Sainte-Colombe-sur-Guette",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Sainte-Colombe-sur-l'Hers",
    "dep": "Aude"
  },
  {
    "code": "11700",
    "ville": "Saint-Couat-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Saint-Couat-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11310",
    "ville": "Saint-Denis",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Sainte-Eulalie",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Saint-Ferriol",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Saint-Frichoux",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Saint-Gaudéric",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Saint-Hilaire",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Saint-Jean-de-Barrou",
    "dep": "Aude"
  },
  {
    "code": "11260",
    "ville": "Saint-Jean-de-Paracol",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Saint-Julia-de-Bec",
    "dep": "Aude"
  },
  {
    "code": "11270",
    "ville": "Saint-Julien-de-Briola",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Saint-Just-et-le-Bézu",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Saint-Laurent-de-la-Cabrerisse",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Saint-Louis-et-Parahou",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Saint-Marcel-sur-Aude",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Saint-Martin-des-Puits",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Saint-Martin-de-Villereglan",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Saint-Martin-Lalande",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Saint-Martin-le-Vieil",
    "dep": "Aude"
  },
  {
    "code": "11500",
    "ville": "Saint-Martin-Lys",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Saint-Michel-de-Lanès",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Saint-Nazaire-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Saint-Papoul",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Saint-Paulet",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Saint-Pierre-des-Champs",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Saint-Polycarpe",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Saint-Sernin",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Sainte-Valière",
    "dep": "Aude"
  },
  {
    "code": "11310",
    "ville": "Saissac",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Sallèles-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11590",
    "ville": "Sallèles-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11110",
    "ville": "Salles-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11410",
    "ville": "Salles-sur-l'Hers",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Salsigne",
    "dep": "Aude"
  },
  {
    "code": "11140",
    "ville": "Salvezines",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Salza",
    "dep": "Aude"
  },
  {
    "code": "11240",
    "ville": "Seignalens",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "La Serpent",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Serres",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Serviès-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11130",
    "ville": "Sigean",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Sonnac-sur-l'Hers",
    "dep": "Aude"
  },
  {
    "code": "11190",
    "ville": "Sougraigne",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Souilhanels",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Souilhe",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Soulatgé",
    "dep": "Aude"
  },
  {
    "code": "11320",
    "ville": "Soupex",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Talairan",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Taurize",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Termes",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Terroles",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Thézan-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11380",
    "ville": "La Tourette-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Tournissan",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Tourouzelle",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Tourreilles",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Trassanel",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Trausse",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Trèbes",
    "dep": "Aude"
  },
  {
    "code": "11510",
    "ville": "Treilles",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Tréville",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Tréziers",
    "dep": "Aude"
  },
  {
    "code": "11350",
    "ville": "Tuchan",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Valmigère",
    "dep": "Aude"
  },
  {
    "code": "11610",
    "ville": "Ventenac-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11120",
    "ville": "Ventenac-en-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Véraza",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Verdun-en-Lauragais",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Verzeille",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Vignevieille",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villalier",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villanière",
    "dep": "Aude"
  },
  {
    "code": "11580",
    "ville": "Villardebelle",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villardonnel",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Villar-en-Val",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Villar-Saint-Anselme",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villarzel-Cabardès",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Villarzel-du-Razès",
    "dep": "Aude"
  },
  {
    "code": "11150",
    "ville": "Villasavary",
    "dep": "Aude"
  },
  {
    "code": "11420",
    "ville": "Villautou",
    "dep": "Aude"
  },
  {
    "code": "11250",
    "ville": "Villebazy",
    "dep": "Aude"
  },
  {
    "code": "11200",
    "ville": "Villedaigne",
    "dep": "Aude"
  },
  {
    "code": "11800",
    "ville": "Villedubert",
    "dep": "Aude"
  },
  {
    "code": "11570",
    "ville": "Villefloure",
    "dep": "Aude"
  },
  {
    "code": "11230",
    "ville": "Villefort",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villegailhenc",
    "dep": "Aude"
  },
  {
    "code": "11600",
    "ville": "Villegly",
    "dep": "Aude"
  },
  {
    "code": "11300",
    "ville": "Villelongue-d'Aude",
    "dep": "Aude"
  },
  {
    "code": "11310",
    "ville": "Villemagne",
    "dep": "Aude"
  },
  {
    "code": "11620",
    "ville": "Villemoustaussou",
    "dep": "Aude"
  },
  {
    "code": "11400",
    "ville": "Villeneuve-la-Comptal",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Villeneuve-les-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11290",
    "ville": "Villeneuve-lès-Montréal",
    "dep": "Aude"
  },
  {
    "code": "11160",
    "ville": "Villeneuve-Minervois",
    "dep": "Aude"
  },
  {
    "code": "11150",
    "ville": "Villepinte",
    "dep": "Aude"
  },
  {
    "code": "11330",
    "ville": "Villerouge-Termenès",
    "dep": "Aude"
  },
  {
    "code": "11360",
    "ville": "Villesèque-des-Corbières",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Villesèquelande",
    "dep": "Aude"
  },
  {
    "code": "11150",
    "ville": "Villesiscle",
    "dep": "Aude"
  },
  {
    "code": "11170",
    "ville": "Villespy",
    "dep": "Aude"
  },
  {
    "code": "11220",
    "ville": "Villetritouls",
    "dep": "Aude"
  },
  {
    "code": "11110",
    "ville": "Vinassan",
    "dep": "Aude"
  },
  {
    "code": "12630",
    "ville": "Agen-d'Aveyron",
    "dep": "Aveyron"
  },
  {
    "code": "12520",
    "ville": "Aguessac",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Les Albres",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Almont-les-Junies",
    "dep": "Aveyron"
  },
  {
    "code": "12430",
    "ville": "Alrance",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Ambeyrac",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Anglars-Saint-Félix",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Arnac-sur-Dourdou",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Arques",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Arvieu",
    "dep": "Aveyron"
  },
  {
    "code": "12700",
    "ville": "Asprières",
    "dep": "Aveyron"
  },
  {
    "code": "12110",
    "ville": "Aubin",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Auriac-Lagast",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Auzits",
    "dep": "Aveyron"
  },
  {
    "code": "12430",
    "ville": "Ayssènes",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Balaguier-d'Olt",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "Balaguier-sur-Rance",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Le Bas Ségala",
    "dep": "Aveyron"
  },
  {
    "code": "12490",
    "ville": "La Bastide-Pradines",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "La Bastide-Solages",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Belcastel",
    "dep": "Aveyron"
  },
  {
    "code": "12370",
    "ville": "Belmont-sur-Rance",
    "dep": "Aveyron"
  },
  {
    "code": "12310",
    "ville": "Bertholène",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Bessuéjouls",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Boisse-Penchot",
    "dep": "Aveyron"
  },
  {
    "code": "12270",
    "ville": "Bor-et-Bar",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Bouillac",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Bournazel",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Boussac",
    "dep": "Aveyron"
  },
  {
    "code": "12340",
    "ville": "Bozouls",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Brandonnet",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Brasc",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Brommat",
    "dep": "Aveyron"
  },
  {
    "code": "12480",
    "ville": "Broquiès",
    "dep": "Aveyron"
  },
  {
    "code": "12480",
    "ville": "Brousse-le-Château",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Brusque",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Cabanès",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Calmels-et-le-Viala",
    "dep": "Aveyron"
  },
  {
    "code": "12450",
    "ville": "Calmont",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Camarès",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Camboulazet",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Camjac",
    "dep": "Aveyron"
  },
  {
    "code": "12560",
    "ville": "Campagnac",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Campouriez",
    "dep": "Aveyron"
  },
  {
    "code": "12580",
    "ville": "Campuac",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Canet-de-Salars",
    "dep": "Aveyron"
  },
  {
    "code": "12420",
    "ville": "Cantoin",
    "dep": "Aveyron"
  },
  {
    "code": "12700",
    "ville": "Capdenac-Gare",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "La Capelle-Balaguier",
    "dep": "Aveyron"
  },
  {
    "code": "12240",
    "ville": "La Capelle-Bleys",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "La Capelle-Bonance",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Baraqueville",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Cassagnes-Bégonhès",
    "dep": "Aveyron"
  },
  {
    "code": "12210",
    "ville": "Cassuéjouls",
    "dep": "Aveyron"
  },
  {
    "code": "12240",
    "ville": "Castanet",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Castelmary",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Castelnau-de-Mandailles",
    "dep": "Aveyron"
  },
  {
    "code": "12620",
    "ville": "Castelnau-Pégayrols",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "La Cavalerie",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Le Cayrol",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Centrès",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Clairvaux-d'Aveyron",
    "dep": "Aveyron"
  },
  {
    "code": "12540",
    "ville": "Le Clapier",
    "dep": "Aveyron"
  },
  {
    "code": "12240",
    "ville": "Colombiès",
    "dep": "Aveyron"
  },
  {
    "code": "12370",
    "ville": "Combret",
    "dep": "Aveyron"
  },
  {
    "code": "12520",
    "ville": "Compeyre",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Compolibat",
    "dep": "Aveyron"
  },
  {
    "code": "12100",
    "ville": "Comprégnac",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Comps-la-Grand-Ville",
    "dep": "Aveyron"
  },
  {
    "code": "12470",
    "ville": "Condom-d'Aubrac",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "Connac",
    "dep": "Aveyron"
  },
  {
    "code": "12320",
    "ville": "Conques-en-Rouergue",
    "dep": "Aveyron"
  },
  {
    "code": "12540",
    "ville": "Cornus",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Les Costes-Gozon",
    "dep": "Aveyron"
  },
  {
    "code": "12190",
    "ville": "Coubisou",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Coupiac",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "La Couvertoirade",
    "dep": "Aveyron"
  },
  {
    "code": "12110",
    "ville": "Cransac",
    "dep": "Aveyron"
  },
  {
    "code": "12100",
    "ville": "Creissels",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Crespin",
    "dep": "Aveyron"
  },
  {
    "code": "12640",
    "ville": "La Cresse",
    "dep": "Aveyron"
  },
  {
    "code": "12210",
    "ville": "Curières",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Decazeville",
    "dep": "Aveyron"
  },
  {
    "code": "12000",
    "ville": "Druelle Balsac",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Drulhe",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "Durenque",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Le Fel",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Entraygues-sur-Truyère",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Escandolières",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Espalion",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Espeyrac",
    "dep": "Aveyron"
  },
  {
    "code": "12190",
    "ville": "Estaing",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Fayet",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Firmi",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Flagnac",
    "dep": "Aveyron"
  },
  {
    "code": "12450",
    "ville": "Flavin",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Florentin-la-Capelle",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Foissac",
    "dep": "Aveyron"
  },
  {
    "code": "12270",
    "ville": "La Fouillade",
    "dep": "Aveyron"
  },
  {
    "code": "12340",
    "ville": "Gabriac",
    "dep": "Aveyron"
  },
  {
    "code": "12310",
    "ville": "Gaillac-d'Aveyron",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Galgan",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Gissac",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Golinhac",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Goutrens",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Gramond",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "L'Hospitalet-du-Larzac",
    "dep": "Aveyron"
  },
  {
    "code": "12460",
    "ville": "Huparlac",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Lacroix-Barrez",
    "dep": "Aveyron"
  },
  {
    "code": "12210",
    "ville": "Laguiole",
    "dep": "Aveyron"
  },
  {
    "code": "12310",
    "ville": "Laissac-Sévérac l'Église",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Lanuéjouls",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "Lapanouse-de-Cernon",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Lassouts",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "Laval-Roquecezière",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "Lédergues",
    "dep": "Aveyron"
  },
  {
    "code": "12440",
    "ville": "Lescure-Jaoul",
    "dep": "Aveyron"
  },
  {
    "code": "12430",
    "ville": "Lestrade-et-Thouels",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Livinhac-le-Haut",
    "dep": "Aveyron"
  },
  {
    "code": "12740",
    "ville": "La Loubière",
    "dep": "Aveyron"
  },
  {
    "code": "12450",
    "ville": "Luc-la-Primaube",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Lugan",
    "dep": "Aveyron"
  },
  {
    "code": "12270",
    "ville": "Lunac",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Maleville",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Manhac",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Marcillac-Vallon",
    "dep": "Aveyron"
  },
  {
    "code": "12540",
    "ville": "Marnhagues-et-Latour",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Martiel",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Martrin",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Mayran",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Mélagues",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Meljac",
    "dep": "Aveyron"
  },
  {
    "code": "12100",
    "ville": "Millau",
    "dep": "Aveyron"
  },
  {
    "code": "12000",
    "ville": "Le Monastère",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Montagnol",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Montbazens",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Montclar",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Monteils",
    "dep": "Aveyron"
  },
  {
    "code": "12460",
    "ville": "Montézic",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "Montfranc",
    "dep": "Aveyron"
  },
  {
    "code": "12490",
    "ville": "Montjaux",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Montlaur",
    "dep": "Aveyron"
  },
  {
    "code": "12540",
    "ville": "Fondamente",
    "dep": "Aveyron"
  },
  {
    "code": "12210",
    "ville": "Montpeyroux",
    "dep": "Aveyron"
  },
  {
    "code": "12630",
    "ville": "Montrozier",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Montsalès",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Morlhon-le-Haut",
    "dep": "Aveyron"
  },
  {
    "code": "12720",
    "ville": "Mostuéjouls",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Mouret",
    "dep": "Aveyron"
  },
  {
    "code": "12160",
    "ville": "Moyrazès",
    "dep": "Aveyron"
  },
  {
    "code": "12370",
    "ville": "Murasson",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Mur-de-Barrez",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Muret-le-Château",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Murols",
    "dep": "Aveyron"
  },
  {
    "code": "12270",
    "ville": "Najac",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "Nant",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Naucelle",
    "dep": "Aveyron"
  },
  {
    "code": "12700",
    "ville": "Naussac",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Nauviale",
    "dep": "Aveyron"
  },
  {
    "code": "12190",
    "ville": "Le Nayrac",
    "dep": "Aveyron"
  },
  {
    "code": "12510",
    "ville": "Olemps",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Ols-et-Rinhodes",
    "dep": "Aveyron"
  },
  {
    "code": "12000",
    "ville": "Onet-le-Château",
    "dep": "Aveyron"
  },
  {
    "code": "12310",
    "ville": "Palmas d'Aveyron",
    "dep": "Aveyron"
  },
  {
    "code": "12520",
    "ville": "Paulhe",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Peux-et-Couffouleux",
    "dep": "Aveyron"
  },
  {
    "code": "12720",
    "ville": "Peyreleau",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Peyrusse-le-Roc",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "Pierrefiche",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Plaisance",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "Pomayrols",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Pont-de-Salars",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "Pousthomy",
    "dep": "Aveyron"
  },
  {
    "code": "12470",
    "ville": "Prades-d'Aubrac",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Prades-Salars",
    "dep": "Aveyron"
  },
  {
    "code": "12240",
    "ville": "Pradinas",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Prévinquières",
    "dep": "Aveyron"
  },
  {
    "code": "12350",
    "ville": "Privezac",
    "dep": "Aveyron"
  },
  {
    "code": "12370",
    "ville": "Mounes-Prohencoux",
    "dep": "Aveyron"
  },
  {
    "code": "12320",
    "ville": "Pruines",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Quins",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Rebourguil",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "Réquista",
    "dep": "Aveyron"
  },
  {
    "code": "12240",
    "ville": "Rieupeyroux",
    "dep": "Aveyron"
  },
  {
    "code": "12390",
    "ville": "Rignac",
    "dep": "Aveyron"
  },
  {
    "code": "12640",
    "ville": "Rivière-sur-Tarn",
    "dep": "Aveyron"
  },
  {
    "code": "12340",
    "ville": "Rodelle",
    "dep": "Aveyron"
  },
  {
    "code": "12000",
    "ville": "Rodez",
    "dep": "Aveyron"
  },
  {
    "code": "12250",
    "ville": "Roquefort-sur-Soulzon",
    "dep": "Aveyron"
  },
  {
    "code": "12100",
    "ville": "La Roque-Sainte-Marguerite",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "La Rouquette",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Roussennac",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Rullac-Saint-Cirq",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Saint-Affrique",
    "dep": "Aveyron"
  },
  {
    "code": "12460",
    "ville": "Saint-Amans-des-Cots",
    "dep": "Aveyron"
  },
  {
    "code": "12270",
    "ville": "Saint-André-de-Najac",
    "dep": "Aveyron"
  },
  {
    "code": "12720",
    "ville": "Saint-André-de-Vézines",
    "dep": "Aveyron"
  },
  {
    "code": "12540",
    "ville": "Saint-Beaulize",
    "dep": "Aveyron"
  },
  {
    "code": "12620",
    "ville": "Saint-Beauzély",
    "dep": "Aveyron"
  },
  {
    "code": "12470",
    "ville": "Saint-Chély-d'Aubrac",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Saint-Christophe-Vallon",
    "dep": "Aveyron"
  },
  {
    "code": "12500",
    "ville": "Saint-Côme-d'Olt",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Sainte-Croix",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "Sainte-Eulalie-d'Olt",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "Sainte-Eulalie-de-Cernon",
    "dep": "Aveyron"
  },
  {
    "code": "12320",
    "ville": "Saint-Félix-de-Lunel",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Saint-Félix-de-Sorgues",
    "dep": "Aveyron"
  },
  {
    "code": "12420",
    "ville": "Argences en Aubrac",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "Saint Geniez d'Olt et d'Aubrac",
    "dep": "Aveyron"
  },
  {
    "code": "12100",
    "ville": "Saint-Georges-de-Luzençon",
    "dep": "Aveyron"
  },
  {
    "code": "12140",
    "ville": "Saint-Hippolyte",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Saint-Igest",
    "dep": "Aveyron"
  },
  {
    "code": "12480",
    "ville": "Saint-Izaire",
    "dep": "Aveyron"
  },
  {
    "code": "12250",
    "ville": "Saint-Jean-d'Alcapiès",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "Saint-Jean-Delnous",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "Saint-Jean-du-Bruel",
    "dep": "Aveyron"
  },
  {
    "code": "12250",
    "ville": "Saint-Jean-et-Saint-Paul",
    "dep": "Aveyron"
  },
  {
    "code": "12550",
    "ville": "Saint-Juéry",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Sainte-Juliette-sur-Viaur",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Saint-Just-sur-Viaur",
    "dep": "Aveyron"
  },
  {
    "code": "12620",
    "ville": "Saint-Laurent-de-Lévézou",
    "dep": "Aveyron"
  },
  {
    "code": "12560",
    "ville": "Saint-Laurent-d'Olt",
    "dep": "Aveyron"
  },
  {
    "code": "12780",
    "ville": "Saint-Léons",
    "dep": "Aveyron"
  },
  {
    "code": "12130",
    "ville": "Saint-Martin-de-Lenne",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Saint-Parthem",
    "dep": "Aveyron"
  },
  {
    "code": "12850",
    "ville": "Sainte-Radegonde",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Saint-Rémy",
    "dep": "Aveyron"
  },
  {
    "code": "12490",
    "ville": "Saint-Rome-de-Cernon",
    "dep": "Aveyron"
  },
  {
    "code": "12490",
    "ville": "Saint-Rome-de-Tarn",
    "dep": "Aveyron"
  },
  {
    "code": "12300",
    "ville": "Saint-Santin",
    "dep": "Aveyron"
  },
  {
    "code": "12560",
    "ville": "Saint-Saturnin-de-Lenne",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "Saint-Sernin-sur-Rance",
    "dep": "Aveyron"
  },
  {
    "code": "12370",
    "ville": "Saint-Sever-du-Moustier",
    "dep": "Aveyron"
  },
  {
    "code": "12460",
    "ville": "Saint-Symphorien-de-Thénières",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Saint-Victor-et-Melvieu",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Salles-Courbatiès",
    "dep": "Aveyron"
  },
  {
    "code": "12410",
    "ville": "Salles-Curan",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Salles-la-Source",
    "dep": "Aveyron"
  },
  {
    "code": "12120",
    "ville": "Salmiech",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Salvagnac-Cajarc",
    "dep": "Aveyron"
  },
  {
    "code": "12700",
    "ville": "Causse-et-Diège",
    "dep": "Aveyron"
  },
  {
    "code": "12440",
    "ville": "La Salvetat-Peyralès",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Sanvensa",
    "dep": "Aveyron"
  },
  {
    "code": "12230",
    "ville": "Sauclières",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Saujac",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Sauveterre-de-Rouergue",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Savignac",
    "dep": "Aveyron"
  },
  {
    "code": "12740",
    "ville": "Sébazac-Concourès",
    "dep": "Aveyron"
  },
  {
    "code": "12190",
    "ville": "Sébrazac",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Ségur",
    "dep": "Aveyron"
  },
  {
    "code": "12170",
    "ville": "La Selve",
    "dep": "Aveyron"
  },
  {
    "code": "12320",
    "ville": "Sénergues",
    "dep": "Aveyron"
  },
  {
    "code": "12380",
    "ville": "La Serre",
    "dep": "Aveyron"
  },
  {
    "code": "12150",
    "ville": "Sévérac d'Aveyron",
    "dep": "Aveyron"
  },
  {
    "code": "12700",
    "ville": "Sonnac",
    "dep": "Aveyron"
  },
  {
    "code": "12210",
    "ville": "Soulages-Bonneval",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Sylvanès",
    "dep": "Aveyron"
  },
  {
    "code": "12360",
    "ville": "Tauriac-de-Camarès",
    "dep": "Aveyron"
  },
  {
    "code": "12800",
    "ville": "Tauriac-de-Naucelle",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Taussac",
    "dep": "Aveyron"
  },
  {
    "code": "12440",
    "ville": "Tayrac",
    "dep": "Aveyron"
  },
  {
    "code": "12600",
    "ville": "Thérondels",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Toulonjac",
    "dep": "Aveyron"
  },
  {
    "code": "12250",
    "ville": "Tournemire",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Trémouilles",
    "dep": "Aveyron"
  },
  {
    "code": "12430",
    "ville": "Le Truel",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Vabres-l'Abbaye",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Vailhourles",
    "dep": "Aveyron"
  },
  {
    "code": "12330",
    "ville": "Valady",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Valzergues",
    "dep": "Aveyron"
  },
  {
    "code": "12220",
    "ville": "Vaureilles",
    "dep": "Aveyron"
  },
  {
    "code": "12520",
    "ville": "Verrières",
    "dep": "Aveyron"
  },
  {
    "code": "12400",
    "ville": "Versols-et-Lapeyre",
    "dep": "Aveyron"
  },
  {
    "code": "12720",
    "ville": "Veyreau",
    "dep": "Aveyron"
  },
  {
    "code": "12780",
    "ville": "Vézins-de-Lévézou",
    "dep": "Aveyron"
  },
  {
    "code": "12250",
    "ville": "Viala-du-Pas-de-Jaux",
    "dep": "Aveyron"
  },
  {
    "code": "12490",
    "ville": "Viala-du-Tarn",
    "dep": "Aveyron"
  },
  {
    "code": "12290",
    "ville": "Le Vibal",
    "dep": "Aveyron"
  },
  {
    "code": "12580",
    "ville": "Villecomtal",
    "dep": "Aveyron"
  },
  {
    "code": "12430",
    "ville": "Villefranche-de-Panat",
    "dep": "Aveyron"
  },
  {
    "code": "12200",
    "ville": "Villefranche-de-Rouergue",
    "dep": "Aveyron"
  },
  {
    "code": "12260",
    "ville": "Villeneuve",
    "dep": "Aveyron"
  },
  {
    "code": "12310",
    "ville": "Vimenet",
    "dep": "Aveyron"
  },
  {
    "code": "12110",
    "ville": "Viviez",
    "dep": "Aveyron"
  },
  {
    "code": "12410",
    "ville": "Curan",
    "dep": "Aveyron"
  },
  {
    "code": "13100",
    "ville": "Aix-en-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13190",
    "ville": "Allauch",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13980",
    "ville": "Alleins",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13280",
    "ville": "Arles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13400",
    "ville": "Aubagne",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13930",
    "ville": "Aureille",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13390",
    "ville": "Auriol",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13121",
    "ville": "Aurons",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13330",
    "ville": "La Barben",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13570",
    "ville": "Barbentane",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13520",
    "ville": "Les Baux-de-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13100",
    "ville": "Beaurecueil",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13720",
    "ville": "Belcodène",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13130",
    "ville": "Berre-l'Étang",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13320",
    "ville": "Bouc-Bel-Air",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13720",
    "ville": "La Bouilladisse",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13150",
    "ville": "Boulbon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13440",
    "ville": "Cabannes",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13480",
    "ville": "Cabriès",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13950",
    "ville": "Cadolive",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13620",
    "ville": "Carry-le-Rouet",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13260",
    "ville": "Cassis",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13600",
    "ville": "Ceyreste",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13350",
    "ville": "Charleval",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13790",
    "ville": "Châteauneuf-le-Rouge",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13220",
    "ville": "Châteauneuf-les-Martigues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13160",
    "ville": "Châteaurenard",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13600",
    "ville": "La Ciotat",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13250",
    "ville": "Cornillon-Confoux",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13780",
    "ville": "Cuges-les-Pins",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13112",
    "ville": "La Destrousse",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13510",
    "ville": "Éguilles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13820",
    "ville": "Ensuès-la-Redonne",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13810",
    "ville": "Eygalières",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13430",
    "ville": "Eyguières",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13630",
    "ville": "Eyragues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13580",
    "ville": "La Fare-les-Oliviers",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13990",
    "ville": "Fontvieille",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13270",
    "ville": "Fos-sur-Mer",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13710",
    "ville": "Fuveau",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13120",
    "ville": "Gardanne",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13420",
    "ville": "Gémenos",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13180",
    "ville": "Gignac-la-Nerthe",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13450",
    "ville": "Grans",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13690",
    "ville": "Graveson",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13850",
    "ville": "Gréasque",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13118",
    "ville": "Istres",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13490",
    "ville": "Jouques",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13113",
    "ville": "Lamanon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13410",
    "ville": "Lambesc",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13680",
    "ville": "Lançon-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13910",
    "ville": "Maillane",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13370",
    "ville": "Mallemort",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13700",
    "ville": "Marignane",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13000",
    "ville": "Marseille",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13500",
    "ville": "Martigues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13103",
    "ville": "Mas-Blanc-des-Alpilles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13520",
    "ville": "Maussane-les-Alpilles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13650",
    "ville": "Meyrargues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13590",
    "ville": "Meyreuil",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13150",
    "ville": "Saint-Pierre-de-Mézoargues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13105",
    "ville": "Mimet",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13140",
    "ville": "Miramas",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13940",
    "ville": "Mollégès",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13890",
    "ville": "Mouriès",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13550",
    "ville": "Noves",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13660",
    "ville": "Orgon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13520",
    "ville": "Paradou",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13330",
    "ville": "Pélissanne",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13821",
    "ville": "La Penne-sur-Huveaune",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13170",
    "ville": "Les Pennes-Mirabeau",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13790",
    "ville": "Peynier",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13124",
    "ville": "Peypin",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13860",
    "ville": "Peyrolles-en-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13380",
    "ville": "Plan-de-Cuques",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13750",
    "ville": "Plan-d'Orgon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13110",
    "ville": "Port-de-Bouc",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13230",
    "ville": "Port-Saint-Louis-du-Rhône",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13114",
    "ville": "Puyloubier",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13610",
    "ville": "Le Puy-Sainte-Réparade",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13340",
    "ville": "Rognac",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13840",
    "ville": "Rognes",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13870",
    "ville": "Rognonas",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13640",
    "ville": "La Roque-d'Anthéron",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13830",
    "ville": "Roquefort-la-Bédoule",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13360",
    "ville": "Roquevaire",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13790",
    "ville": "Rousset",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13740",
    "ville": "Le Rove",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13670",
    "ville": "Saint-Andiol",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13100",
    "ville": "Saint-Antonin-sur-Bayon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13760",
    "ville": "Saint-Cannat",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13250",
    "ville": "Saint-Chamas",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13610",
    "ville": "Saint-Estève-Janson",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13103",
    "ville": "Saint-Étienne-du-Grès",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13100",
    "ville": "Saint-Marc-Jaumegarde",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13460",
    "ville": "Saintes-Maries-de-la-Mer",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13310",
    "ville": "Saint-Martin-de-Crau",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13920",
    "ville": "Saint-Mitre-les-Remparts",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13115",
    "ville": "Saint-Paul-lès-Durance",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13210",
    "ville": "Saint-Rémy-de-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13119",
    "ville": "Saint-Savournin",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13730",
    "ville": "Saint-Victoret",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13300",
    "ville": "Salon-de-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13960",
    "ville": "Sausset-les-Pins",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13560",
    "ville": "Sénas",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13240",
    "ville": "Septèmes-les-Vallons",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13109",
    "ville": "Simiane-Collongue",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13150",
    "ville": "Tarascon",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13100",
    "ville": "Le Tholonet",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13530",
    "ville": "Trets",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13126",
    "ville": "Vauvenargues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13880",
    "ville": "Velaux",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13770",
    "ville": "Venelles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13122",
    "ville": "Ventabren",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13116",
    "ville": "Vernègues",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13670",
    "ville": "Verquières",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13127",
    "ville": "Vitrolles",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13111",
    "ville": "Coudoux",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "13470",
    "ville": "Carnoux-en-Provence",
    "dep": "Bouches-du-Rhône"
  },
  {
    "code": "14600",
    "ville": "Ablon",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Agy",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Valambray",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Amayé-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Amayé-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14860",
    "ville": "Amfreville",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Aurseulles",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Angerville",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Colomby-Anguerny",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Anisy",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Annebault",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Arganchy",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Argences",
    "dep": "Calvados"
  },
  {
    "code": "14117",
    "ville": "Arromanches-les-Bains",
    "dep": "Calvados"
  },
  {
    "code": "14960",
    "ville": "Asnelles",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Asnières-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14640",
    "ville": "Auberville",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Aubigny",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Audrieu",
    "dep": "Calvados"
  },
  {
    "code": "14770",
    "ville": "Les Monts d'Aunay",
    "dep": "Calvados"
  },
  {
    "code": "14280",
    "ville": "Authie",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Les Authieux-sur-Calonne",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Auvillars",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Avenay",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Balleroy-sur-Drôme",
    "dep": "Calvados"
  },
  {
    "code": "14940",
    "ville": "Banneville-la-Campagne",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Malherbe-sur-Ajon",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Banville",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Barbery",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Barbeville",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Barneville-la-Bertran",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Baron-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Barou-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Basly",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Basseneville",
    "dep": "Calvados"
  },
  {
    "code": "14860",
    "ville": "Bavent",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Bayeux",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Bazenville",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "La Bazoque",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Beaumais",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Beaumesnil",
    "dep": "Calvados"
  },
  {
    "code": "14950",
    "ville": "Beaumont-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Bellengreville",
    "dep": "Calvados"
  },
  {
    "code": "14910",
    "ville": "Benerville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14970",
    "ville": "Bénouville",
    "dep": "Calvados"
  },
  {
    "code": "14350",
    "ville": "Souleuvre en Bocage",
    "dep": "Calvados"
  },
  {
    "code": "14440",
    "ville": "Bény-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Bernesq",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Bernières-d'Ailly",
    "dep": "Calvados"
  },
  {
    "code": "14990",
    "ville": "Bernières-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14112",
    "ville": "Biéville-Beuville",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Beuvillers",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Beuvron-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14550",
    "ville": "Blainville-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Blangy-le-Château",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Blay",
    "dep": "Calvados"
  },
  {
    "code": "14910",
    "ville": "Blonville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Le Bô",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "La Boissière",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Bonnebosq",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Bonnemaison",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Bonneville-la-Louvet",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Bonneville-sur-Touques",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Bonnœil",
    "dep": "Calvados"
  },
  {
    "code": "14420",
    "ville": "Bons-Tassilly",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Bougy",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Boulon",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Bourgeauville",
    "dep": "Calvados"
  },
  {
    "code": "14540",
    "ville": "Bourguébus",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Branville",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Brémoy",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Bretteville-le-Rabet",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Thue et Mue",
    "dep": "Calvados"
  },
  {
    "code": "14680",
    "ville": "Bretteville-sur-Laize",
    "dep": "Calvados"
  },
  {
    "code": "14760",
    "ville": "Bretteville-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Breuil-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Le Breuil-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Brévedent",
    "dep": "Calvados"
  },
  {
    "code": "14860",
    "ville": "Bréville-les-Monts",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Bricqueville",
    "dep": "Calvados"
  },
  {
    "code": "14160",
    "ville": "Brucourt",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Bucéels",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Le Bû-sur-Rouvres",
    "dep": "Calvados"
  },
  {
    "code": "14390",
    "ville": "Cabourg",
    "dep": "Calvados"
  },
  {
    "code": "14000",
    "ville": "Caen",
    "dep": "Calvados"
  },
  {
    "code": "14630",
    "ville": "Cagny",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Cahagnes",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Cahagnolles",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "La Caine",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Cairon",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "La Cambe",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Cambes-en-Plaine",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Cambremer",
    "dep": "Calvados"
  },
  {
    "code": "14500",
    "ville": "Campagnolles",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Campigny",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Canapville",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Canchy",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Canteloup",
    "dep": "Calvados"
  },
  {
    "code": "14740",
    "ville": "Carcagny",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Cardonville",
    "dep": "Calvados"
  },
  {
    "code": "14650",
    "ville": "Carpiquet",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Cartigny-l'Épinay",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Castillon",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Castillon-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Caumont-sur-Aure",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Cauvicourt",
    "dep": "Calvados"
  },
  {
    "code": "14770",
    "ville": "Cauville",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "Cernay",
    "dep": "Calvados"
  },
  {
    "code": "14270",
    "ville": "Cesny-aux-Vignes",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Cesny-les-Sources",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Chouain",
    "dep": "Calvados"
  },
  {
    "code": "14680",
    "ville": "Cintheaux",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Clarbec",
    "dep": "Calvados"
  },
  {
    "code": "14570",
    "ville": "Clécy",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Cléville",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Colleville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14880",
    "ville": "Colleville-Montgomery",
    "dep": "Calvados"
  },
  {
    "code": "14460",
    "ville": "Colombelles",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Colombières",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Colombiers-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Combray",
    "dep": "Calvados"
  },
  {
    "code": "14520",
    "ville": "Commes",
    "dep": "Calvados"
  },
  {
    "code": "14270",
    "ville": "Condé-sur-Ifs",
    "dep": "Calvados"
  },
  {
    "code": "14110",
    "ville": "Condé-en-Normandie",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Condé-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Coquainvilliers",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Cordebugle",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Cordey",
    "dep": "Calvados"
  },
  {
    "code": "14123",
    "ville": "Cormelles-le-Royal",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Cormolain",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Cossesseville",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Cottun",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Courcy",
    "dep": "Calvados"
  },
  {
    "code": "14470",
    "ville": "Courseulles-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Courtonne-la-Meurdrac",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "Courtonne-les-Deux-Églises",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Courvaudon",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Crépon",
    "dep": "Calvados"
  },
  {
    "code": "14440",
    "ville": "Cresserons",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Cresseveuille",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Creully sur Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14113",
    "ville": "Cricquebœuf",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Cricqueville-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14450",
    "ville": "Cricqueville-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Cristot",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Crocy",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Croisilles",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Crouay",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Culey-le-Patry",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Cussy",
    "dep": "Calvados"
  },
  {
    "code": "14840",
    "ville": "Cuverville",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Damblainville",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Danestal",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Deauville",
    "dep": "Calvados"
  },
  {
    "code": "14840",
    "ville": "Démouville",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Le Détroit",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Deux-Jumeaux",
    "dep": "Calvados"
  },
  {
    "code": "14160",
    "ville": "Dives-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Donnay",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Douville-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14440",
    "ville": "Douvres-la-Délivrande",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Dozulé",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Drubec",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Beaufour-Druval",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Ducy-Sainte-Marguerite",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Ellon",
    "dep": "Calvados"
  },
  {
    "code": "14630",
    "ville": "Émiéville",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Englesqueville-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Englesqueville-la-Percée",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Épaney",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Épinay-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Épron",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Équemauville",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Eraines",
    "dep": "Calvados"
  },
  {
    "code": "14270",
    "ville": "Ernes",
    "dep": "Calvados"
  },
  {
    "code": "14850",
    "ville": "Escoville",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Espins",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Esquay-Notre-Dame",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Esquay-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Esson",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Estrées-la-Campagne",
    "dep": "Calvados"
  },
  {
    "code": "14930",
    "ville": "Éterville",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Étréham",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Évrecy",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Falaise",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Fauguernon",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Faulq",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "Feuguerolles-Bully",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Fierville-les-Parcs",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Firfol",
    "dep": "Calvados"
  },
  {
    "code": "14123",
    "ville": "Fleury-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "La Folie",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "La Folletière-Abenon",
    "dep": "Calvados"
  },
  {
    "code": "14790",
    "ville": "Fontaine-Étoupefour",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Fontaine-Henry",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Fontaine-le-Pin",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "Fontenay-le-Marmion",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Fontenay-le-Pesnel",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Formentin",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Formigny La Bataille",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Foulognes",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Fourches",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Fourneaux-le-Val",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Le Fournet",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Fourneville",
    "dep": "Calvados"
  },
  {
    "code": "14630",
    "ville": "Frénouville",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Le Fresne-Camilly",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Fresné-la-Mère",
    "dep": "Calvados"
  },
  {
    "code": "14680",
    "ville": "Fresney-le-Puceux",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Fresney-le-Vieux",
    "dep": "Calvados"
  },
  {
    "code": "14590",
    "ville": "Fumichon",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Gavrus",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Géfosse-Fontenay",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Genneville",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Gerrots",
    "dep": "Calvados"
  },
  {
    "code": "14730",
    "ville": "Giberville",
    "dep": "Calvados"
  },
  {
    "code": "14950",
    "ville": "Glanville",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Glos",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Gonneville-sur-Honfleur",
    "dep": "Calvados"
  },
  {
    "code": "14510",
    "ville": "Gonneville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14810",
    "ville": "Gonneville-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Goustranville",
    "dep": "Calvados"
  },
  {
    "code": "14680",
    "ville": "Gouvix",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Grainville-Langannerie",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Grainville-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14450",
    "ville": "Grandcamp-Maisy",
    "dep": "Calvados"
  },
  {
    "code": "14160",
    "ville": "Grangues",
    "dep": "Calvados"
  },
  {
    "code": "14470",
    "ville": "Graye-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14540",
    "ville": "Grentheville",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Grimbosq",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Guéron",
    "dep": "Calvados"
  },
  {
    "code": "14880",
    "ville": "Hermanville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Hermival-les-Vaux",
    "dep": "Calvados"
  },
  {
    "code": "14200",
    "ville": "Hérouville-Saint-Clair",
    "dep": "Calvados"
  },
  {
    "code": "14850",
    "ville": "Hérouvillette",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Heuland",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "La Hoguette",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Honfleur",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "L'Hôtellerie",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Hotot-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Hottot-les-Bagues",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "La Houblonnière",
    "dep": "Calvados"
  },
  {
    "code": "14510",
    "ville": "Houlgate",
    "dep": "Calvados"
  },
  {
    "code": "14123",
    "ville": "Ifs",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Isigny-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Les Isles-Bardel",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Janville",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Jort",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Juaye-Mondaye",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Dialan sur Chaîne",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Juvigny-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "Laize-Clinchamps",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Landelles-et-Coupigny",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Landes-sur-Ajon",
    "dep": "Calvados"
  },
  {
    "code": "14830",
    "ville": "Langrune-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Ponts sur Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14770",
    "ville": "Terres de Druance",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Léaupartie",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Leffard",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Lessard-et-le-Chêne",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Lingèvres",
    "dep": "Calvados"
  },
  {
    "code": "14780",
    "ville": "Lion-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Lisieux",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Lison",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Lisores",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Litteau",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Le Molay-Littry",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Livarot-Pays-d'Auge",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Les Loges",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Les Loges-Saulces",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Longues-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Longueville",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Longvillers",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Loucelles",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Louvagny",
    "dep": "Calvados"
  },
  {
    "code": "14111",
    "ville": "Louvigny",
    "dep": "Calvados"
  },
  {
    "code": "14530",
    "ville": "Luc-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Magny-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Maisoncelles-Pelvey",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Maisoncelles-sur-Ajon",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Maisons",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Maizet",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Maizières",
    "dep": "Calvados"
  },
  {
    "code": "14930",
    "ville": "Maltot",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Mandeville-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Manerbe",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Manneville-la-Pipard",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Le Manoir",
    "dep": "Calvados"
  },
  {
    "code": "14117",
    "ville": "Manvieux",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Le Marais-la-Chapelle",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Marolles",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Martainville",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Martigny-sur-l'Ante",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Moulins-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14920",
    "ville": "Mathieu",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "May-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14810",
    "ville": "Merville-Franceville-Plage",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Méry-Bissières-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Meslay",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Le Mesnil-au-Grain",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Le Mesnil-Eudes",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Le Mesnil-Guillaume",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Le Mesnil-Robert",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Le Mesnil-Simon",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Mesnil-sur-Blangy",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Le Mesnil-Villement",
    "dep": "Calvados"
  },
  {
    "code": "14960",
    "ville": "Meuvaines",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Mézidon Vallée d'Auge",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Les Monceaux",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Monceaux-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14120",
    "ville": "Mondeville",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Mondrainville",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Monfréville",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Montfiquet",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Montigny",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Montreuil-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Monts-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Morteaux-Coulibœuf",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Mosles",
    "dep": "Calvados"
  },
  {
    "code": "14790",
    "ville": "Mouen",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Moulines",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Moult-Chicheboville",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Les Moutiers-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Les Moutiers-en-Cinglais",
    "dep": "Calvados"
  },
  {
    "code": "14590",
    "ville": "Moyaux",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Mutrécy",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Nonant",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Norolles",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Noron-l'Abbaye",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Noron-la-Poterie",
    "dep": "Calvados"
  },
  {
    "code": "14620",
    "ville": "Norrey-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Notre-Dame-de-Livaye",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Notre-Dame-d'Estrées-Corbon",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Val d'Arry",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Olendon",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "Orbec",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Osmanville",
    "dep": "Calvados"
  },
  {
    "code": "14270",
    "ville": "Ouézy",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Ouffières",
    "dep": "Calvados"
  },
  {
    "code": "14590",
    "ville": "Ouilly-du-Houley",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Ouilly-le-Tesson",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Ouilly-le-Vicomte",
    "dep": "Calvados"
  },
  {
    "code": "14150",
    "ville": "Ouistreham",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Parfouru-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "Pennedepie",
    "dep": "Calvados"
  },
  {
    "code": "14160",
    "ville": "Périers-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14112",
    "ville": "Périers-sur-le-Dan",
    "dep": "Calvados"
  },
  {
    "code": "14770",
    "ville": "Périgny",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Perrières",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Pertheville-Ners",
    "dep": "Calvados"
  },
  {
    "code": "14390",
    "ville": "Petiville",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Pierrefitte-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Pierrefitte-en-Cinglais",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Pierrepont",
    "dep": "Calvados"
  },
  {
    "code": "14590",
    "ville": "Le Pin",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Planquery",
    "dep": "Calvados"
  },
  {
    "code": "14440",
    "ville": "Plumetot",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "La Pommeraye",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Pont-Bellanger",
    "dep": "Calvados"
  },
  {
    "code": "14110",
    "ville": "Pontécoulant",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Pont-l'Évêque",
    "dep": "Calvados"
  },
  {
    "code": "14520",
    "ville": "Port-en-Bessin-Huppain",
    "dep": "Calvados"
  },
  {
    "code": "14420",
    "ville": "Potigny",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Préaux-Bocage",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Le Pré-d'Auge",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Prêtreville",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Putot-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14270",
    "ville": "Belle Vie en Auge",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Quetteville",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Ranchy",
    "dep": "Calvados"
  },
  {
    "code": "14860",
    "ville": "Ranville",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Rapilly",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Repentigny",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Reux",
    "dep": "Calvados"
  },
  {
    "code": "14470",
    "ville": "Reviers",
    "dep": "Calvados"
  },
  {
    "code": "14600",
    "ville": "La Rivière-Saint-Sauveur",
    "dep": "Calvados"
  },
  {
    "code": "14540",
    "ville": "Castine-en-Plaine",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Rocques",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "La Roque-Baignard",
    "dep": "Calvados"
  },
  {
    "code": "14740",
    "ville": "Rosel",
    "dep": "Calvados"
  },
  {
    "code": "14980",
    "ville": "Rots",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Rouvres",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Rubercy",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Rumesnil",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Ryes",
    "dep": "Calvados"
  },
  {
    "code": "14540",
    "ville": "Le Castelet",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-André-d'Hébertot",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "Saint-André-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Saint-Arnoult",
    "dep": "Calvados"
  },
  {
    "code": "14970",
    "ville": "Saint-Aubin-d'Arquenay",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Saint-Aubin-des-Bois",
    "dep": "Calvados"
  },
  {
    "code": "14750",
    "ville": "Saint-Aubin-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Benoît-d'Hébertot",
    "dep": "Calvados"
  },
  {
    "code": "14960",
    "ville": "Saint-Côme-de-Fresné",
    "dep": "Calvados"
  },
  {
    "code": "14280",
    "ville": "Saint-Contest",
    "dep": "Calvados"
  },
  {
    "code": "14480",
    "ville": "Sainte-Croix-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "Valorbiquet",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Denis-de-Mailloc",
    "dep": "Calvados"
  },
  {
    "code": "14110",
    "ville": "Saint-Denis-de-Méré",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Désir",
    "dep": "Calvados"
  },
  {
    "code": "14950",
    "ville": "Saint-Étienne-la-Thillaye",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Val-de-Vie",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Gatien-des-Bois",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Seulline",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Germain-de-Livet",
    "dep": "Calvados"
  },
  {
    "code": "14230",
    "ville": "Saint-Germain-du-Pert",
    "dep": "Calvados"
  },
  {
    "code": "14280",
    "ville": "Saint-Germain-la-Blanche-Herbe",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Saint-Germain-Langot",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Saint-Germain-le-Vasson",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Sainte-Honorine-de-Ducy",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Aure sur Mer",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Sainte-Honorine-du-Fay",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Hymer",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Jean-de-Livet",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Saint-Jouin",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Julien-sur-Calonne",
    "dep": "Calvados"
  },
  {
    "code": "14570",
    "ville": "Saint-Lambert",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Saint-Laurent-de-Condel",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Saint-Laurent-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Saint-Léger-Dubosq",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Saint-Louet-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Saint-Loup-Hors",
    "dep": "Calvados"
  },
  {
    "code": "14740",
    "ville": "Saint-Manvieu-Norrey",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Saint-Marcouf",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Sainte-Marguerite-d'Elle",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Sainte-Marie-Outre-l'Eau",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Martin-aux-Chartrains",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "Saint-Martin-de-Bienfaite-la-Cressonnière",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Saint-Martin-de-Blagny",
    "dep": "Calvados"
  },
  {
    "code": "14320",
    "ville": "Saint-Martin-de-Fontenay",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Martin-de-la-Lieue",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Martin-de-Mailloc",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Saint-Martin-de-Mieux",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Saint-Martin-des-Entrées",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Saint-Omer",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Saint-Ouen-du-Mesnil-Oger",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Saint-Ouen-le-Pin",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Saint-Pair",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Saint-Paul-du-Vernay",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Saint-Philbert-des-Champs",
    "dep": "Calvados"
  },
  {
    "code": "14950",
    "ville": "Saint-Pierre-Azif",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Saint-Pierre-Canivet",
    "dep": "Calvados"
  },
  {
    "code": "14100",
    "ville": "Saint-Pierre-des-Ifs",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Saint-Pierre-du-Bû",
    "dep": "Calvados"
  },
  {
    "code": "14260",
    "ville": "Saint-Pierre-du-Fresne",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Saint-Pierre-du-Jonquet",
    "dep": "Calvados"
  },
  {
    "code": "14450",
    "ville": "Saint-Pierre-du-Mont",
    "dep": "Calvados"
  },
  {
    "code": "14140",
    "ville": "Saint-Pierre-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14570",
    "ville": "Saint-Rémy",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Saint-Samson",
    "dep": "Calvados"
  },
  {
    "code": "14380",
    "ville": "Noues de Sienne",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Saint-Sylvain",
    "dep": "Calvados"
  },
  {
    "code": "14640",
    "ville": "Saint-Vaast-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Saint-Vaast-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Saint-Vigor-le-Grand",
    "dep": "Calvados"
  },
  {
    "code": "14240",
    "ville": "Sallen",
    "dep": "Calvados"
  },
  {
    "code": "14121",
    "ville": "Sallenelles",
    "dep": "Calvados"
  },
  {
    "code": "14940",
    "ville": "Sannerville",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Saon",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Saonnet",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Sassy",
    "dep": "Calvados"
  },
  {
    "code": "14350",
    "ville": "Val de Drôme",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Soignolles",
    "dep": "Calvados"
  },
  {
    "code": "14540",
    "ville": "Soliers",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Sommervieu",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Soulangy",
    "dep": "Calvados"
  },
  {
    "code": "14420",
    "ville": "Soumont-Saint-Quentin",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Subles",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Sully",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Surrain",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Surville",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Tessel",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Thaon",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Theil-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14220",
    "ville": "Thury-Harcourt-le-Hom",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Tilly-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Le Torquesne",
    "dep": "Calvados"
  },
  {
    "code": "14940",
    "ville": "Touffréville",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Touques",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Tour-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Tourgéville",
    "dep": "Calvados"
  },
  {
    "code": "14330",
    "ville": "Tournières",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Tourville-en-Auge",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Tourville-sur-Odon",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Tracy-Bocage",
    "dep": "Calvados"
  },
  {
    "code": "14117",
    "ville": "Tracy-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Tréprel",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Trévières",
    "dep": "Calvados"
  },
  {
    "code": "14670",
    "ville": "Troarn",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Montillières-sur-Orne",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Le Tronquay",
    "dep": "Calvados"
  },
  {
    "code": "14360",
    "ville": "Trouville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14490",
    "ville": "Trungy",
    "dep": "Calvados"
  },
  {
    "code": "14190",
    "ville": "Urville",
    "dep": "Calvados"
  },
  {
    "code": "14420",
    "ville": "Ussy",
    "dep": "Calvados"
  },
  {
    "code": "14210",
    "ville": "Vacognes-Neuilly",
    "dep": "Calvados"
  },
  {
    "code": "14340",
    "ville": "Valsemé",
    "dep": "Calvados"
  },
  {
    "code": "14390",
    "ville": "Varaville",
    "dep": "Calvados"
  },
  {
    "code": "14410",
    "ville": "Valdallière",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Vaucelles",
    "dep": "Calvados"
  },
  {
    "code": "14800",
    "ville": "Vauville",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Vaux-sur-Aure",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Vaux-sur-Seulles",
    "dep": "Calvados"
  },
  {
    "code": "14250",
    "ville": "Vendes",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Vendeuvre",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Versainville",
    "dep": "Calvados"
  },
  {
    "code": "14790",
    "ville": "Verson",
    "dep": "Calvados"
  },
  {
    "code": "14114",
    "ville": "Ver-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14290",
    "ville": "La Vespière-Friardel",
    "dep": "Calvados"
  },
  {
    "code": "14570",
    "ville": "Le Vey",
    "dep": "Calvados"
  },
  {
    "code": "14170",
    "ville": "Vicques",
    "dep": "Calvados"
  },
  {
    "code": "14430",
    "ville": "Victot-Pontfol",
    "dep": "Calvados"
  },
  {
    "code": "14400",
    "ville": "Vienne-en-Bessin",
    "dep": "Calvados"
  },
  {
    "code": "14710",
    "ville": "Vierville-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14930",
    "ville": "Vieux",
    "dep": "Calvados"
  },
  {
    "code": "14130",
    "ville": "Vieux-Bourg",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Vignats",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Villers-Bocage",
    "dep": "Calvados"
  },
  {
    "code": "14420",
    "ville": "Villers-Canivet",
    "dep": "Calvados"
  },
  {
    "code": "14640",
    "ville": "Villers-sur-Mer",
    "dep": "Calvados"
  },
  {
    "code": "14113",
    "ville": "Villerville",
    "dep": "Calvados"
  },
  {
    "code": "14570",
    "ville": "La Villette",
    "dep": "Calvados"
  },
  {
    "code": "14610",
    "ville": "Villons-les-Buissons",
    "dep": "Calvados"
  },
  {
    "code": "14700",
    "ville": "Villy-lez-Falaise",
    "dep": "Calvados"
  },
  {
    "code": "14310",
    "ville": "Villy-Bocage",
    "dep": "Calvados"
  },
  {
    "code": "14370",
    "ville": "Vimont",
    "dep": "Calvados"
  },
  {
    "code": "14500",
    "ville": "Vire Normandie",
    "dep": "Calvados"
  },
  {
    "code": "14690",
    "ville": "Pont-d'Ouilly",
    "dep": "Calvados"
  },
  {
    "code": "15160",
    "ville": "Allanche",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Alleuze",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Ally",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Andelat",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Anglards-de-Saint-Flour",
    "dep": "Cantal"
  },
  {
    "code": "15380",
    "ville": "Anglards-de-Salers",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Anterrieux",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Antignac",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Apchon",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Arches",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Arnac",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Arpajon-sur-Cère",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Auriac-l'Église",
    "dep": "Cantal"
  },
  {
    "code": "15000",
    "ville": "Aurillac",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Auzers",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Ayrens",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Badailhac",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Barriac-les-Bosquets",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Bassignac",
    "dep": "Cantal"
  },
  {
    "code": "15270",
    "ville": "Beaulieu",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Boisset",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Bonnac",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Brageac",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Albepierre-Bredons",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Brezons",
    "dep": "Cantal"
  },
  {
    "code": "15340",
    "ville": "Puycapel",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Carlat",
    "dep": "Cantal"
  },
  {
    "code": "15340",
    "ville": "Cassaniouze",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Cayrols",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Celoux",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Cézens",
    "dep": "Cantal"
  },
  {
    "code": "15320",
    "ville": "Chaliers",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Chalvignac",
    "dep": "Cantal"
  },
  {
    "code": "15350",
    "ville": "Champagnac",
    "dep": "Cantal"
  },
  {
    "code": "15270",
    "ville": "Champs-sur-Tarentaine-Marchal",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Chanterelle",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "La Chapelle-d'Alagnon",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "La Chapelle-Laurent",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Charmensac",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Chaudes-Aigues",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Chaussenac",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Chazelles",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Cheylade",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Le Claux",
    "dep": "Cantal"
  },
  {
    "code": "15320",
    "ville": "Clavières",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Collandres",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Coltines",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Condat",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Coren",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Crandelles",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Cros-de-Montvert",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Cros-de-Ronesque",
    "dep": "Cantal"
  },
  {
    "code": "15430",
    "ville": "Cussac",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Deux-Verges",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Dienne",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Drugeac",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Escorailles",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Espinasse",
    "dep": "Cantal"
  },
  {
    "code": "15380",
    "ville": "Le Falgoux",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Le Fau",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Ferrières-Saint-Mary",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Fontanges",
    "dep": "Cantal"
  },
  {
    "code": "15310",
    "ville": "Freix-Anglards",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Fridefont",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Giou-de-Mamou",
    "dep": "Cantal"
  },
  {
    "code": "15310",
    "ville": "Girgols",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Glénat",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Gourdièges",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Jabrun",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Jaleyrac",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Joursac",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Jou-sous-Monjou",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Junhac",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Jussac",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Labesserette",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Labrousse",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Lacapelle-Barrès",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Lacapelle-del-Fraisse",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Lacapelle-Viescamp",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Ladinhac",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Lafeuillade-en-Vézie",
    "dep": "Cantal"
  },
  {
    "code": "15160",
    "ville": "Landeyrat",
    "dep": "Cantal"
  },
  {
    "code": "15270",
    "ville": "Lanobre",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Lapeyrugue",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Laroquebrou",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Laroquevieille",
    "dep": "Cantal"
  },
  {
    "code": "15590",
    "ville": "Lascelle",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Lastic",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Laurie",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Laveissenet",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Laveissière",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Lavigerie",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Leucamp",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Leynhac",
    "dep": "Cantal"
  },
  {
    "code": "43450",
    "ville": "Leyvaux",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Lieutadès",
    "dep": "Cantal"
  },
  {
    "code": "15320",
    "ville": "Lorcières",
    "dep": "Cantal"
  },
  {
    "code": "15320",
    "ville": "Val d'Arcomie",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Lugarde",
    "dep": "Cantal"
  },
  {
    "code": "15210",
    "ville": "Madic",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Malbo",
    "dep": "Cantal"
  },
  {
    "code": "15590",
    "ville": "Mandailles-Saint-Julien",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Marcenat",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Marchastel",
    "dep": "Cantal"
  },
  {
    "code": "15220",
    "ville": "Marcolès",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Marmanhac",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Massiac",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Mauriac",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Maurines",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Maurs",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Méallet",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Menet",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Mentières",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Molèdes",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Molompize",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "La Monselie",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Montboudif",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Montchamp",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Le Monteil",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Montgreleix",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Montmurat",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Montsalvy",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Montvert",
    "dep": "Cantal"
  },
  {
    "code": "15380",
    "ville": "Moussages",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Murat",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Narnhac",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Naucelles",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Neussargues en Pinatelle",
    "dep": "Cantal"
  },
  {
    "code": "15260",
    "ville": "Neuvéglise-sur-Truyère",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Nieudan",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Omps",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Pailherols",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Parlan",
    "dep": "Cantal"
  },
  {
    "code": "15430",
    "ville": "Paulhac",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Paulhenc",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Peyrusse",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Pierrefort",
    "dep": "Cantal"
  },
  {
    "code": "15700",
    "ville": "Pleaux",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Polminhac",
    "dep": "Cantal"
  },
  {
    "code": "15160",
    "ville": "Pradiers",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Prunet",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Quézac",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Rageade",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Raulhac",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Reilhac",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Rézentières",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Riom-ès-Montagnes",
    "dep": "Cantal"
  },
  {
    "code": "15220",
    "ville": "Roannes-Saint-Mary",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Roffiac",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Rouffiac",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Roumégoux",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Rouziers",
    "dep": "Cantal"
  },
  {
    "code": "15320",
    "ville": "Ruynes-en-Margeride",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Saignes",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Saint-Amandin",
    "dep": "Cantal"
  },
  {
    "code": "15220",
    "ville": "Saint-Antoine",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Saint-Bonnet-de-Condat",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Bonnet-de-Salers",
    "dep": "Cantal"
  },
  {
    "code": "15310",
    "ville": "Saint-Cernin",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Chamant",
    "dep": "Cantal"
  },
  {
    "code": "15590",
    "ville": "Saint-Cirgues-de-Jordanne",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Cirgues-de-Malbert",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Saint-Clément",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Saint-Constant-Fournoulès",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Saint-Étienne-Cantalès",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Saint-Étienne-de-Carlat",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Saint-Étienne-de-Maurs",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Saint-Étienne-de-Chomeil",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Sainte-Eulalie",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Saint-Flour",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Saint-Georges",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Saint-Gérons",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Saint-Hippolyte",
    "dep": "Cantal"
  },
  {
    "code": "15310",
    "ville": "Saint-Illide",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Saint-Jacques-des-Blats",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Saint-Julien-de-Toursac",
    "dep": "Cantal"
  },
  {
    "code": "15220",
    "ville": "Saint-Mamet-la-Salvetat",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Sainte-Marie",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Saint-Martial",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Martin-Cantalès",
    "dep": "Cantal"
  },
  {
    "code": "15230",
    "ville": "Saint-Martin-sous-Vigouroux",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Martin-Valmeroux",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Saint-Mary-le-Plain",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Saint-Paul-des-Landes",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Paul-de-Salers",
    "dep": "Cantal"
  },
  {
    "code": "15350",
    "ville": "Saint-Pierre",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Saint-Poncy",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Saint-Projet-de-Salers",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Saint-Rémy-de-Chaudes-Aigues",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Saint-Santin-Cantalès",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Saint-Santin-de-Maurs",
    "dep": "Cantal"
  },
  {
    "code": "15190",
    "ville": "Saint-Saturnin",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Saint-Saury",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Saint-Simon",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "Saint-Urcize",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Saint-Victor",
    "dep": "Cantal"
  },
  {
    "code": "15380",
    "ville": "Saint-Vincent-de-Salers",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Salers",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Salins",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Sansac-de-Marmiesse",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Sansac-Veinazès",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Sauvat",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "La Ségalassière",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Ségur-les-Villas",
    "dep": "Cantal"
  },
  {
    "code": "15340",
    "ville": "Sénezergues",
    "dep": "Cantal"
  },
  {
    "code": "15150",
    "ville": "Siran",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Soulages",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Sourniac",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Talizat",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Tanavelle",
    "dep": "Cantal"
  },
  {
    "code": "15250",
    "ville": "Teissières-de-Cornet",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Teissières-lès-Bouliès",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Les Ternes",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Thiézac",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Tiviers",
    "dep": "Cantal"
  },
  {
    "code": "15310",
    "ville": "Tournemire",
    "dep": "Cantal"
  },
  {
    "code": "15270",
    "ville": "Trémouille",
    "dep": "Cantal"
  },
  {
    "code": "15110",
    "ville": "La Trinitat",
    "dep": "Cantal"
  },
  {
    "code": "15600",
    "ville": "Le Trioulou",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Trizac",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Ussel",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Vabres",
    "dep": "Cantal"
  },
  {
    "code": "15400",
    "ville": "Valette",
    "dep": "Cantal"
  },
  {
    "code": "15170",
    "ville": "Valjouze",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Valuéjols",
    "dep": "Cantal"
  },
  {
    "code": "15380",
    "ville": "Le Vaulmier",
    "dep": "Cantal"
  },
  {
    "code": "15240",
    "ville": "Vebret",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Védrines-Saint-Loup",
    "dep": "Cantal"
  },
  {
    "code": "15590",
    "ville": "Velzic",
    "dep": "Cantal"
  },
  {
    "code": "15160",
    "ville": "Vernols",
    "dep": "Cantal"
  },
  {
    "code": "15350",
    "ville": "Veyrières",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Vézac",
    "dep": "Cantal"
  },
  {
    "code": "15160",
    "ville": "Vèze",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Vezels-Roussy",
    "dep": "Cantal"
  },
  {
    "code": "15800",
    "ville": "Vic-sur-Cère",
    "dep": "Cantal"
  },
  {
    "code": "15500",
    "ville": "Vieillespesse",
    "dep": "Cantal"
  },
  {
    "code": "15120",
    "ville": "Vieillevie",
    "dep": "Cantal"
  },
  {
    "code": "15200",
    "ville": "Le Vigean",
    "dep": "Cantal"
  },
  {
    "code": "15100",
    "ville": "Villedieu",
    "dep": "Cantal"
  },
  {
    "code": "15300",
    "ville": "Virargues",
    "dep": "Cantal"
  },
  {
    "code": "15220",
    "ville": "Vitrac",
    "dep": "Cantal"
  },
  {
    "code": "15210",
    "ville": "Ydes",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Yolet",
    "dep": "Cantal"
  },
  {
    "code": "15130",
    "ville": "Ytrac",
    "dep": "Cantal"
  },
  {
    "code": "15290",
    "ville": "Le Rouget-Pers",
    "dep": "Cantal"
  },
  {
    "code": "15140",
    "ville": "Besse",
    "dep": "Cantal"
  },
  {
    "code": "16500",
    "ville": "Abzac",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Les Adjots",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Agris",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Aigre",
    "dep": "Charente"
  },
  {
    "code": "16490",
    "ville": "Alloue",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Ambérac",
    "dep": "Charente"
  },
  {
    "code": "16490",
    "ville": "Ambernac",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Anais",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Angeac-Champagne",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Angeac-Charente",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Angeduc",
    "dep": "Charente"
  },
  {
    "code": "16000",
    "ville": "Angoulême",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Ansac-sur-Vienne",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Ars",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Asnières-sur-Nouère",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Aubeterre-sur-Dronne",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Aunac-sur-Charente",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Aussac-Vadalle",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Baignes-Sainte-Radegonde",
    "dep": "Charente"
  },
  {
    "code": "16430",
    "ville": "Balzac",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Barbezières",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Barbezieux-Saint-Hilaire",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Bardenac",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Barret",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Barro",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Bassac",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Bazac",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Beaulieu-sur-Sonnette",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Bécheresse",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Bellon",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Benest",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Bernac",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Berneuil",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Bessac",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Bessé",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Bioussac",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Birac",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Coteaux-du-Blanzacais",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Blanzaguet-Saint-Cybard",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Boisbreteau",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Bonnes",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Bonneuil",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Bors (Canton de Tude-et-Lavalette)",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Bors (Canton de Charente-Sud)",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Le Bouchage",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Bouëx",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Bourg-Charente",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Bouteville",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Boutiers-Saint-Trojan",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Brettes",
    "dep": "Charente"
  },
  {
    "code": "16370",
    "ville": "Bréville",
    "dep": "Charente"
  },
  {
    "code": "16590",
    "ville": "Brie",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Brie-sous-Barbezieux",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Brie-sous-Chalais",
    "dep": "Charente"
  },
  {
    "code": "16420",
    "ville": "Brigueuil",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Brillac",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Brossac",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Bunzac",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "Cellefrouin",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Cellettes",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Chabanais",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Chabrac",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Chadurie",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Chalais",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Challignac",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Champagne-Vigny",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Champagne-Mouton",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Champmillon",
    "dep": "Charente"
  },
  {
    "code": "16430",
    "ville": "Champniers",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Chantillac",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "La Chapelle",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Boisné-La Tude",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Charmé",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Charras",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "Chasseneuil-sur-Bonnieure",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Chassenon",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Chassiecq",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Chassors",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Châteaubernard",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Châteauneuf-sur-Charente",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Châtignac",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Chazelles",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Chenon",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Cherves-Châtelars",
    "dep": "Charente"
  },
  {
    "code": "16370",
    "ville": "Val-de-Cognac",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "La Chèvrerie",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Chillac",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Chirac",
    "dep": "Charente"
  },
  {
    "code": "16440",
    "ville": "Claix",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Cognac",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Combiers",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Condac",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Condéon",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Confolens",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Coulgens",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Coulonges",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Courbillac",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Courcôme",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Courgeac",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Courlac",
    "dep": "Charente"
  },
  {
    "code": "16400",
    "ville": "La Couronne",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Couture",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Criteuil-la-Magdeleine",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Curac",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Deviat",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Dignac",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Dirac",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Douzat",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Ébréon",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Échallat",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Écuras",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Édon",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Empuré",
    "dep": "Charente"
  },
  {
    "code": "16490",
    "ville": "Épenède",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Les Essards",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Esse",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Étagnac",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Étriac",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Exideuil-sur-Vienne",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Eymouthiers",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "La Faye",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Feuillade",
    "dep": "Charente"
  },
  {
    "code": "16730",
    "ville": "Fléac",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Fleurac",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Fontenille",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "La Forêt-de-Tessé",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Fouquebrune",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Fouqueure",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Foussignac",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Garat",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Gardes-le-Pontaroux",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Genac-Bignac",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Gensac-la-Pallue",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Genté",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Gimeux",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Mainxe-Gondeville",
    "dep": "Charente"
  },
  {
    "code": "16160",
    "ville": "Gond-Pontouvre",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Les Gours",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Le Grand-Madieu",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Grassac",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Guimps",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Guizengeard",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Gurat",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Hiersac",
    "dep": "Charente"
  },
  {
    "code": "16490",
    "ville": "Hiesse",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Houlette",
    "dep": "Charente"
  },
  {
    "code": "16340",
    "ville": "L'Isle-d'Espagnac",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Jarnac",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Jauldes",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Javrezac",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Juignac",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Juillac-le-Coq",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Juillé",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Julienne",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Val des Vignes",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Lachaise",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Ladiville",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Lagarde-sur-le-Né",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Laprade",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Lessac",
    "dep": "Charente"
  },
  {
    "code": "16420",
    "ville": "Lesterps",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Lésignac-Durand",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Lichères",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Ligné",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Lignières-Ambleville",
    "dep": "Charente"
  },
  {
    "code": "16730",
    "ville": "Linars",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Le Lindois",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Londigny",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Longré",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Lonnes",
    "dep": "Charente"
  },
  {
    "code": "16270",
    "ville": "Terres-de-Haute-Charente",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Louzac-Saint-André",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Lupsault",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Lussac",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Luxé",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "La Magdeleine",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Magnac-Lavalette-Villars",
    "dep": "Charente"
  },
  {
    "code": "16600",
    "ville": "Magnac-sur-Touvre",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Maine-de-Boixe",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Mainzac",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Bellevigne",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Manot",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Mansle-les-Fontaines",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Marcillac-Lanville",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Mareuil",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Marillac-le-Franc",
    "dep": "Charente"
  },
  {
    "code": "16570",
    "ville": "Marsac",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Marthon",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Massignac",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Mazerolles",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Médillac",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Mérignac",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Merpins",
    "dep": "Charente"
  },
  {
    "code": "16370",
    "ville": "Mesnac",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Les Métairies",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Mons",
    "dep": "Charente"
  },
  {
    "code": "16620",
    "ville": "Montboyer",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Montbron",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Montmérac",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Montembœuf",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Montignac-Charente",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Montignac-le-Coq",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Montjean",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Montmoreau",
    "dep": "Charente"
  },
  {
    "code": "16420",
    "ville": "Montrollet",
    "dep": "Charente"
  },
  {
    "code": "16600",
    "ville": "Mornac",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Mosnac-Saint-Simeux",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Moulidars",
    "dep": "Charente"
  },
  {
    "code": "16440",
    "ville": "Mouthiers-sur-Boëme",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Mouton",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Moutonneau",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Mouzon",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Nabinaud",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Nanclars",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Nanteuil-en-Vallée",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Nercillac",
    "dep": "Charente"
  },
  {
    "code": "16440",
    "ville": "Nersac",
    "dep": "Charente"
  },
  {
    "code": "16270",
    "ville": "Nieuil",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Nonac",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Oradour",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Oradour-Fanais",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Orgedeuil",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Oriolles",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Orival",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Paizay-Naudouin-Embourie",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Palluaud",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Parzac",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Passirac",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Pérignac",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Pillac",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "Les Pins",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Plassac-Rouffiac",
    "dep": "Charente"
  },
  {
    "code": "16490",
    "ville": "Pleuville",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Poullignac",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Poursac",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Pranzac",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Pressignac",
    "dep": "Charente"
  },
  {
    "code": "16400",
    "ville": "Puymoyen",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Puyréaux",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Raix",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Ranville-Breuillaud",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Reignac",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Réparsac",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Rioux-Martin",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Rivières",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "La Rochefoucauld-en-Angoumois",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "La Rochette",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Ronsenac",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Rouffiac",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Rougnac",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Rouillac",
    "dep": "Charente"
  },
  {
    "code": "16440",
    "ville": "Roullet-Saint-Estèphe",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Roussines",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Rouzède",
    "dep": "Charente"
  },
  {
    "code": "16600",
    "ville": "Ruelle-sur-Touvre",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Ruffec",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Saint-Adjutory",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Saint-Amant-de-Boixe",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Graves-Saint-Amant",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Saint-Amant-de-Nouère",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Val-de-Bonnieure",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Saint-Aulais-la-Chapelle",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Saint-Avit",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Saint-Bonnet",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Saint-Brice",
    "dep": "Charente"
  },
  {
    "code": "16420",
    "ville": "Saint-Christophe",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Saint-Ciers-sur-Bonnieure",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Saint-Claud",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Saint-Coutant",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Saint-Cybardeaux",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Saint-Félix",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Saint-Fort-sur-le-Né",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Saint-Fraigne",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Saint-Front",
    "dep": "Charente"
  },
  {
    "code": "16570",
    "ville": "Saint-Genis-d'Hiersac",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Saint-Georges",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Saint-Germain-de-Montbron",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Saint-Gourson",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Saint-Groux",
    "dep": "Charente"
  },
  {
    "code": "16450",
    "ville": "Saint-Laurent-de-Céris",
    "dep": "Charente"
  },
  {
    "code": "16100",
    "ville": "Saint-Laurent-de-Cognac",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Saint-Laurent-des-Combes",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Saint-Martial",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Saint-Martin-du-Clocher",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "Saint-Mary",
    "dep": "Charente"
  },
  {
    "code": "16500",
    "ville": "Saint-Maurice-des-Lions",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Saint-Médard",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Val-d'Auge",
    "dep": "Charente"
  },
  {
    "code": "16720",
    "ville": "Saint-Même-les-Carrières",
    "dep": "Charente"
  },
  {
    "code": "16470",
    "ville": "Saint-Michel",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Saint-Palais-du-Né",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Saint-Preuil",
    "dep": "Charente"
  },
  {
    "code": "16150",
    "ville": "Saint-Quentin-sur-Charente",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Saint-Quentin-de-Chalais",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Saint-Romain",
    "dep": "Charente"
  },
  {
    "code": "16290",
    "ville": "Saint-Saturnin",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Sainte-Sévère",
    "dep": "Charente"
  },
  {
    "code": "16390",
    "ville": "Saint-Séverin",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Saint-Simon",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Saint-Sornin",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Sainte-Souline",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Saint-Sulpice-de-Ruffec",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Saint-Vallier",
    "dep": "Charente"
  },
  {
    "code": "16710",
    "ville": "Saint-Yrieix-sur-Charente",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Salles-d'Angles",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Salles-de-Barbezieux",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Salles-de-Villefagnan",
    "dep": "Charente"
  },
  {
    "code": "16190",
    "ville": "Salles-Lavalette",
    "dep": "Charente"
  },
  {
    "code": "16420",
    "ville": "Saulgond",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Sauvagnac",
    "dep": "Charente"
  },
  {
    "code": "16480",
    "ville": "Sauvignac",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Segonzac",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Sers",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Sigogne",
    "dep": "Charente"
  },
  {
    "code": "16440",
    "ville": "Sireuil",
    "dep": "Charente"
  },
  {
    "code": "16380",
    "ville": "Souffrignac",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Souvigné",
    "dep": "Charente"
  },
  {
    "code": "16800",
    "ville": "Soyaux",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "Suaux",
    "dep": "Charente"
  },
  {
    "code": "16260",
    "ville": "La Tâche",
    "dep": "Charente"
  },
  {
    "code": "16700",
    "ville": "Taizé-Aizie",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Taponnat-Fleurignac",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Le Tâtre",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Theil-Rabier",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Torsac",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Tourriers",
    "dep": "Charente"
  },
  {
    "code": "16360",
    "ville": "Touvérac",
    "dep": "Charente"
  },
  {
    "code": "16600",
    "ville": "Touvre",
    "dep": "Charente"
  },
  {
    "code": "16200",
    "ville": "Triac-Lautrait",
    "dep": "Charente"
  },
  {
    "code": "16730",
    "ville": "Trois-Palis",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Turgon",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Tusson",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Valence",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Vars",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Vaux-Lavalette",
    "dep": "Charente"
  },
  {
    "code": "16170",
    "ville": "Vaux-Rouillac",
    "dep": "Charente"
  },
  {
    "code": "16460",
    "ville": "Ventouse",
    "dep": "Charente"
  },
  {
    "code": "16140",
    "ville": "Verdille",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Verneuil",
    "dep": "Charente"
  },
  {
    "code": "16130",
    "ville": "Verrières",
    "dep": "Charente"
  },
  {
    "code": "16510",
    "ville": "Verteuil-sur-Charente",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Vervant",
    "dep": "Charente"
  },
  {
    "code": "16120",
    "ville": "Vibrac",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Le Vieux-Cérier",
    "dep": "Charente"
  },
  {
    "code": "16350",
    "ville": "Vieux-Ruffec",
    "dep": "Charente"
  },
  {
    "code": "16300",
    "ville": "Vignolles",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Moulins-sur-Tardoire",
    "dep": "Charente"
  },
  {
    "code": "16320",
    "ville": "Villebois-Lavalette",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Villefagnan",
    "dep": "Charente"
  },
  {
    "code": "16560",
    "ville": "Villejoubert",
    "dep": "Charente"
  },
  {
    "code": "16240",
    "ville": "Villiers-le-Roux",
    "dep": "Charente"
  },
  {
    "code": "16230",
    "ville": "Villognon",
    "dep": "Charente"
  },
  {
    "code": "16430",
    "ville": "Vindelle",
    "dep": "Charente"
  },
  {
    "code": "16310",
    "ville": "Vitrac-Saint-Vincent",
    "dep": "Charente"
  },
  {
    "code": "16400",
    "ville": "Vœuil-et-Giget",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Vouharte",
    "dep": "Charente"
  },
  {
    "code": "16250",
    "ville": "Voulgézac",
    "dep": "Charente"
  },
  {
    "code": "16220",
    "ville": "Vouthon",
    "dep": "Charente"
  },
  {
    "code": "16410",
    "ville": "Vouzan",
    "dep": "Charente"
  },
  {
    "code": "16330",
    "ville": "Xambes",
    "dep": "Charente"
  },
  {
    "code": "16210",
    "ville": "Yviers",
    "dep": "Charente"
  },
  {
    "code": "16110",
    "ville": "Yvrac-et-Malleyrand",
    "dep": "Charente"
  },
  {
    "code": "17500",
    "ville": "Agudelle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Aigrefeuille-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17123",
    "ville": "Île-d'Aix",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Allas-Bocage",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Allas-Champagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Anais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Andilly",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Angliers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17690",
    "ville": "Angoulins",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Annepont",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Annezay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Antezant-la-Chapelle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Arces",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Archiac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Archingeay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Ardillières",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17590",
    "ville": "Ars-en-Ré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Arthenac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17530",
    "ville": "Arvert",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Asnières-la-Giraud",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Aujac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Aulnay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Aumagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Authon-Ébéon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Avy",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17440",
    "ville": "Aytré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Bagnizeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Balanzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Ballans",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Ballon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "La Barde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Barzan",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Bazauges",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "Beaugeay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Beauvais-sur-Matha",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Bedenac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Belluire",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Benon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Bercloux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Bernay-Saint-Martin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Berneuil",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Beurlay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Bignay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Biron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Blanzac-lès-Matha",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Blanzay-sur-Boutonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17580",
    "ville": "Le Bois-Plage-en-Ré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Boisredon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Bords",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Boresse-et-Martron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "Boscamnant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Bougneau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Bouhet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17560",
    "ville": "Bourcefranc-le-Chapus",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Bourgneuf",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Boutenac-Touvent",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Bran",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Bresdon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Breuil-la-Réorte",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17920",
    "ville": "Breuillet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17870",
    "ville": "Breuil-Magné",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Brie-sous-Archiac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Brie-sous-Matha",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Brie-sous-Mortagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Brives-sur-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Brizambourg",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "La Brousse",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Burie",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Bussac-sur-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Bussac-Forêt",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Cabariot",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Celles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Cercoux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Chadenac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17890",
    "ville": "Chaillevette",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Chambon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Chamouillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Champagnac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "Champagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Champagnolles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Champdolent",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17610",
    "ville": "Chaniers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Chantemerle-sur-la-Soie",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "La Chapelle-des-Pots",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Charron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Chartuzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17480",
    "ville": "Le Château-d'Oléron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17340",
    "ville": "Châtelaillon-Plage",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Chatenet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Chaunac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Le Chay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Chenac-Saint-Seurin-d'Uzet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Chepniers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17610",
    "ville": "Chérac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Cherbonnières",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Chermignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Chevanceaux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Chives",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Cierzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Ciré-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Clam",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Clavette",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Clérac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Clion",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "La Clisse",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "La Clotte",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Coivert",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Colombiers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Consac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Contré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Corignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Corme-Écluse",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Corme-Royal",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17670",
    "ville": "La Couarde-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Coulonges",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Courant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Courcelles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Courcerac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Courçon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Courcoury",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Courpignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Coux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Cozes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Cram-Chaban",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Cravans",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Crazannes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Cressé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Croix-Chapeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "La Croix-Comtesse",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Dampierre-sur-Boutonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Dœuil-sur-le-Mignon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17550",
    "ville": "Dolus-d'Oléron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17610",
    "ville": "Dompierre-sur-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17139",
    "ville": "Dompierre-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Le Douhet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Échebrune",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "Échillais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Écoyeux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17810",
    "ville": "Écurat",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Les Éduts",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Les Églises-d'Argenteuil",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "L'Éguille",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Épargnes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17137",
    "ville": "Esnandes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Les Essards",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17750",
    "ville": "Étaules",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Expiremont",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Fenioux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Ferrières",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Fléac-sur-Seugne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Floirac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17630",
    "ville": "La Flotte",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Fontaine-Chalendray",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Fontaines-d'Ozillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Fontcouverte",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Fontenet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Forges",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Le Fouilloux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17450",
    "ville": "Fouras",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Geay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Gémozac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "La Genétouze",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Genouillé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Germignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Gibourne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Le Gicq",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Givrezac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Les Gonds",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Gourvillette",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Grandjean",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "La Grève-sur-Mignon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Grézac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "La Gripperie-Saint-Symphorien",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Le Gua",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Le Gué-d'Alleré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Guitinières",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Haimps",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17137",
    "ville": "L'Houmeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "La Jard",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Jarnac-Champagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "La Jarne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "La Jarrie",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "La Jarrie-Audouin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Jazennes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Jonzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Juicq",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Jussas",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17140",
    "ville": "Lagord",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "La Laigne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Landes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Landrais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Léoville",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17870",
    "ville": "Loire-les-Marais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Loiré-sur-Nie",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17111",
    "ville": "Loix",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Longèves",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Lonzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Lorignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Loulay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Louzignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Lozay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Luchat",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Lussac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Lussant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Macqueville",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Marans",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17320",
    "ville": "Marennes-Hiers-Brouage",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Marignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Marsais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17137",
    "ville": "Marsilly",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Massac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Matha",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17570",
    "ville": "Les Mathes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Mazeray",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Mazerolles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Médis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Mérignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17132",
    "ville": "Meschers-sur-Gironde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Messac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Meursac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Meux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Migré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Migron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Mirambeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17780",
    "ville": "Moëze",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Mons",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Montendre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Montguyon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Montils",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Montlieu-la-Garde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Montpellier-de-Médillan",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Montroy",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Moragne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17113",
    "ville": "Mornac-sur-Seudre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Mortagne-sur-Gironde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Mortiers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Mosnac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Le Mung",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Muron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Nachamps",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Nancras",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Nantillé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Néré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Neuillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Neulles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Neuvicq",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Neuvicq-le-Château",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17810",
    "ville": "Nieul-lès-Saintes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Nieul-le-Virouil",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17137",
    "ville": "Nieul-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Nieulle-sur-Seudre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Les Nouillers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Nuaillé-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Nuaillé-sur-Boutonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Orignolles",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Ozillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Paillé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Pérignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17180",
    "ville": "Périgny",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17810",
    "ville": "Pessines",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Le Pin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Essouvert",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Pisany",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Plassac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Plassay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Polignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Pommiers-Moulons",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Pons",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Pont-l'Abbé-d'Arnoult",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Port-d'Envaux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17880",
    "ville": "Les Portes-en-Ré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Pouillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Poursay-Garnaud",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Préguillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Prignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17138",
    "ville": "Puilboreau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Puy-du-Lac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Puyravault",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Puyrolland",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Réaux sur Trèfle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Rétaud",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17940",
    "ville": "Rivedoux-Plage",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Rioux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17300",
    "ville": "Rochefort",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17000",
    "ville": "La Rochelle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Romazières",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Romegoux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "La Ronde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Rouffiac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Rouffignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17200",
    "ville": "Royan",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Sablonceaux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "Saint-Agnant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "Saint-Aigulin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Saint-André-de-Lidon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17570",
    "ville": "Saint-Augustin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Bonnet-sur-Gironde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Saint-Bris-des-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Saint-Césaire",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Saint-Christophe",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Saint-Ciers-Champagne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Ciers-du-Taillon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17590",
    "ville": "Saint-Clément-des-Baleines",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Sainte-Colombe",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Saint-Coutant-le-Grand",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Saint-Crépin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Saint-Cyr-du-Doret",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17650",
    "ville": "Saint-Denis-d'Oléron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Dizant-du-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Dizant-du-Gua",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Saint-Eugène",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Saint-Félix",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Fort-sur-Gironde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17780",
    "ville": "Saint-Froult",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Sainte-Gemme",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Genis-de-Saintonge",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Georges-Antignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17110",
    "ville": "Saint-Georges-de-Didonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Saint-Georges-de-Longuepierre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Georges-des-Agoûts",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17810",
    "ville": "Saint-Georges-des-Coteaux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17190",
    "ville": "Saint-Georges-d'Oléron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Saint-Georges-du-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Germain-de-Lusignan",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Saint-Pierre-La-Noue",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Germain-de-Vibrac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Germain-du-Seudre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Grégoire-d'Ardennes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Saint-Hilaire-de-Villefranche",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Hilaire-du-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Saint-Hippolyte",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Saint-Jean-d'Angély",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17620",
    "ville": "Saint-Jean-d'Angle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Saint-Jean-de-Liversay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Saint-Julien-de-l'Escap",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17320",
    "ville": "Saint-Just-Luzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17450",
    "ville": "Saint-Laurent-de-la-Prée",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Saint-Léger",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Sainte-Lheurine",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Saint-Loup",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Saint-Maigrin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Saint-Mandé-sur-Brédoire",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Saint-Mard",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17740",
    "ville": "Sainte-Marie-de-Ré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Saint-Martial",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Martial-de-Mirambeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Martial-de-Vitaterne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17520",
    "ville": "Saint-Martial-sur-Né",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Saint-Martin-d'Ary",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17360",
    "ville": "Saint-Martin-de-Coux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Saint-Martin-de-Juillers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17410",
    "ville": "Saint-Martin-de-Ré",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Médard",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Saint-Médard-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Sainte-Même",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17780",
    "ville": "Saint-Nazaire-sur-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Saint-Ouen-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Saint-Ouen-la-Thène",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17210",
    "ville": "Saint-Palais-de-Négrignac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Saint-Palais-de-Phiolin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17420",
    "ville": "Saint-Palais-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Saint-Pardoult",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Saint-Pierre-d'Amilly",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Saint-Pierre-de-Juillers",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Saint-Pierre-de-l'Isle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17310",
    "ville": "Saint-Pierre-d'Oléron",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17270",
    "ville": "Saint-Pierre-du-Palais",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Saint-Porchaire",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Saint-Quantin-de-Rançanne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Sainte-Radegonde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Sainte-Ramée",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Saint-Rogatien",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Saint-Romain-de-Benet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Saint-Saturnin-du-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17610",
    "ville": "Saint-Sauvant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Saint-Sauveur-d'Aunis",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Saint-Savinien",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Saint-Seurin-de-Palenne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Saint-Sever-de-Saintonge",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Saint-Séverin-sur-Boutonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17240",
    "ville": "Saint-Sigismond-de-Clermont",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Saint-Simon-de-Bordes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Saint-Simon-de-Pellouaille",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Sorlin-de-Conac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Saint-Sornin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Sainte-Soulle",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Saint-Sulpice-d'Arnoult",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17200",
    "ville": "Saint-Sulpice-de-Royan",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Saint-Thomas-de-Conac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17370",
    "ville": "Saint-Trojan-les-Bains",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Saint-Vaize",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Saint-Vivien",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17138",
    "ville": "Saint-Xandre",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Saintes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Saleignes",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Salignac-de-Mirambeau",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17800",
    "ville": "Salignac-sur-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17220",
    "ville": "Salles-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Saujon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Seigné",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Semillac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Semoussac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Semussac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Le Seure",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17490",
    "ville": "Siecq",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Sonnac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17780",
    "ville": "Soubise",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17150",
    "ville": "Soubran",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Soulignonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Souméras",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Sousmoulins",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Surgères",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Taillant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17350",
    "ville": "Taillebourg",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Talmont-sur-Gironde",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Tanzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17170",
    "ville": "Taugon",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Ternant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Tesson",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17120",
    "ville": "Thaims",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Thairé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Thénac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17600",
    "ville": "Thézac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Thors",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Le Thou",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Tonnay-Boutonne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17430",
    "ville": "Tonnay-Charente",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "Torxé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17160",
    "ville": "Les Touches-de-Périgny",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17390",
    "ville": "La Tremblade",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "Trizay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Tugéras-Saint-Maurice",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17250",
    "ville": "La Vallée",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17380",
    "ville": "La Devise",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Vanzac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Varaize",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17460",
    "ville": "Varzay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17640",
    "ville": "Vaux-sur-Mer",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17100",
    "ville": "Vénérand",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17300",
    "ville": "Vergeroux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Vergné",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "La Vergne",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17540",
    "ville": "Vérines",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Vervant",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17130",
    "ville": "Vibrac",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Villars-en-Pons",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17770",
    "ville": "Villars-les-Bois",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "La Villedieu",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17230",
    "ville": "Villedoux",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17470",
    "ville": "Villemorin",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17330",
    "ville": "Villeneuve-la-Comtesse",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17500",
    "ville": "Villexavier",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Villiers-Couture",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17510",
    "ville": "Vinax",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17260",
    "ville": "Virollet",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17290",
    "ville": "Virson",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17400",
    "ville": "Voissay",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17700",
    "ville": "Vouhé",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17340",
    "ville": "Yves",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17730",
    "ville": "Port-des-Barques",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17370",
    "ville": "Le Grand-Village-Plage",
    "dep": "Charente-Maritime"
  },
  {
    "code": "17840",
    "ville": "La Brée-les-Bains",
    "dep": "Charente-Maritime"
  },
  {
    "code": "18250",
    "ville": "Achères",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Ainay-le-Vieil",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Les Aix-d'Angillon",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Allogny",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Allouis",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Annoix",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "Apremont-sur-Allier",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Arçay",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Arcomps",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Ardenais",
    "dep": "Cher"
  },
  {
    "code": "18410",
    "ville": "Argent-sur-Sauldre",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Argenvières",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Arpheuilles",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Assigny",
    "dep": "Cher"
  },
  {
    "code": "18700",
    "ville": "Aubigny-sur-Nère",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Aubinges",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Augy-sur-Aubois",
    "dep": "Cher"
  },
  {
    "code": "18520",
    "ville": "Avord",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Azy",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Bannay",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Bannegon",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Barlieu",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Baugy",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Beddes",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Beffes",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Belleville-sur-Loire",
    "dep": "Cher"
  },
  {
    "code": "18520",
    "ville": "Bengy-sur-Craon",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Berry-Bouy",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Bessais-le-Fromental",
    "dep": "Cher"
  },
  {
    "code": "18410",
    "ville": "Blancafort",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Blet",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Boulleret",
    "dep": "Cher"
  },
  {
    "code": "18000",
    "ville": "Bourges",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Bouzais",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Brécy",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Brinay",
    "dep": "Cher"
  },
  {
    "code": "18410",
    "ville": "Brinon-sur-Sauldre",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Bruère-Allichamps",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Bué",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Bussy",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "La Celette",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "La Celle",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "La Celle-Condé",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Cerbois",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Chalivoy-Milon",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Chambon",
    "dep": "Cher"
  },
  {
    "code": "18380",
    "ville": "La Chapelle-d'Angillon",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "La Chapelle-Hugon",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "La Chapelle-Montlinard",
    "dep": "Cher"
  },
  {
    "code": "18570",
    "ville": "La Chapelle-Saint-Ursin",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "La Chapelotte",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Charenton-du-Cher",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Charentonnay",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Charly",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Chârost",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Chassy",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Châteaumeillant",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Châteauneuf-sur-Cher",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Le Châtelet",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Chaumont",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Chaumoux-Marcilly",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "Le Chautay",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Chavannes",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Chéry",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Chezal-Benoît",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Civray",
    "dep": "Cher"
  },
  {
    "code": "18410",
    "ville": "Clémont",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Cogny",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Colombiers",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Concressault",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Contres",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Cornusse",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Corquoy",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Couargues",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Cours-les-Barres",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Coust",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Couy",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Crézançay-sur-Cher",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Crézancy-en-Sancerre",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Croisy",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Crosses",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "Cuffy",
    "dep": "Cher"
  },
  {
    "code": "18270",
    "ville": "Culan",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Dampierre-en-Crot",
    "dep": "Cher"
  },
  {
    "code": "18310",
    "ville": "Dampierre-en-Graçay",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Drevant",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Dun-sur-Auron",
    "dep": "Cher"
  },
  {
    "code": "18380",
    "ville": "Ennordres",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "Épineuil-le-Fleuriel",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Étréchy",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Farges-Allichamps",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Farges-en-Septaine",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "Faverdines",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Feux",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Flavigny",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Foëcy",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Fussy",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Gardefort",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Garigny",
    "dep": "Cher"
  },
  {
    "code": "18310",
    "ville": "Genouilly",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "Germigny-l'Exempt",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Givardon",
    "dep": "Cher"
  },
  {
    "code": "18310",
    "ville": "Graçay",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Groises",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Gron",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Grossouvre",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "La Groutte",
    "dep": "Cher"
  },
  {
    "code": "18150",
    "ville": "La Guerche-sur-l'Aubois",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "Henrichemont",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Herry",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "Humbligny",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Ids-Saint-Roch",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Ignol",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Ineuil",
    "dep": "Cher"
  },
  {
    "code": "18380",
    "ville": "Ivoy-le-Pré",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Jalognes",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Jars",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Jouet-sur-l'Aubois",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Jussy-Champagne",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Jussy-le-Chaudrier",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Lantan",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Lapan",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Lazenay",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Léré",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Levet",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Lignières",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Limeux",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Lissay-Lochy",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Loye-sur-Arnon",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Lugny-Champagne",
    "dep": "Cher"
  },
  {
    "code": "18400",
    "ville": "Lunery",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Lury-sur-Arnon",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Maisonnais",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Marçais",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Mareuil-sur-Arnon",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Marmagne",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Marseilles-lès-Aubigny",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Massay",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Mehun-sur-Yèvre",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Meillant",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Menetou-Couture",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Menetou-Râtel",
    "dep": "Cher"
  },
  {
    "code": "18510",
    "ville": "Menetou-Salon",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Ménétréol-sous-Sancerre",
    "dep": "Cher"
  },
  {
    "code": "18700",
    "ville": "Ménétréol-sur-Sauldre",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Méreau",
    "dep": "Cher"
  },
  {
    "code": "18380",
    "ville": "Méry-ès-Bois",
    "dep": "Cher"
  },
  {
    "code": "18100",
    "ville": "Méry-sur-Cher",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "Montigny",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Montlouis",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Morlac",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Mornay-Berry",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Mornay-sur-Allier",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Morogues",
    "dep": "Cher"
  },
  {
    "code": "18570",
    "ville": "Morthomiers",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Moulins-sur-Yèvre",
    "dep": "Cher"
  },
  {
    "code": "18330",
    "ville": "Nançay",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Nérondes",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Neuilly-en-Dun",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "Neuilly-en-Sancerre",
    "dep": "Cher"
  },
  {
    "code": "18250",
    "ville": "Neuvy-Deux-Clochers",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Neuvy-le-Barrois",
    "dep": "Cher"
  },
  {
    "code": "18330",
    "ville": "Neuvy-sur-Barangeon",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Nohant-en-Goût",
    "dep": "Cher"
  },
  {
    "code": "18310",
    "ville": "Nohant-en-Graçay",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Le Noyer",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Nozières",
    "dep": "Cher"
  },
  {
    "code": "18700",
    "ville": "Oizon",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Orcenais",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Orval",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Osmery",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Osmoy",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Ourouer-les-Bourdelins",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Parassy",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Parnay",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "La Perche",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Pigny",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Plaimpied-Givaudins",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Plou",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Poisieux",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Le Pondy",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Précy",
    "dep": "Cher"
  },
  {
    "code": "18380",
    "ville": "Presly",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Preuilly",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Préveranges",
    "dep": "Cher"
  },
  {
    "code": "18400",
    "ville": "Primelles",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Quantilly",
    "dep": "Cher"
  },
  {
    "code": "18120",
    "ville": "Quincy",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Raymond",
    "dep": "Cher"
  },
  {
    "code": "18270",
    "ville": "Reigny",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Rezay",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Rians",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Sagonne",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Saint-Aignan-des-Noyers",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Saint-Amand-Montrond",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Saint-Ambroix",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Saint-Baudel",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Saint-Bouize",
    "dep": "Cher"
  },
  {
    "code": "18400",
    "ville": "Saint-Caprais",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Saint-Céols",
    "dep": "Cher"
  },
  {
    "code": "18270",
    "ville": "Saint-Christophe-le-Chaudry",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Saint-Denis-de-Palin",
    "dep": "Cher"
  },
  {
    "code": "18230",
    "ville": "Saint-Doulchard",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Saint-Éloy-de-Gy",
    "dep": "Cher"
  },
  {
    "code": "18400",
    "ville": "Saint-Florent-sur-Cher",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Sainte-Gemme-en-Sancerrois",
    "dep": "Cher"
  },
  {
    "code": "18200",
    "ville": "Saint-Georges-de-Poisieux",
    "dep": "Cher"
  },
  {
    "code": "18100",
    "ville": "Saint-Georges-sur-la-Prée",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Saint-Georges-sur-Moulon",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Saint-Germain-des-Bois",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Saint-Germain-du-Puy",
    "dep": "Cher"
  },
  {
    "code": "18100",
    "ville": "Saint-Hilaire-de-Court",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Saint-Hilaire-de-Gondilly",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Saint-Hilaire-en-Lignières",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Saint-Jeanvrin",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Saint-Just",
    "dep": "Cher"
  },
  {
    "code": "18330",
    "ville": "Saint-Laurent",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Saint-Léger-le-Petit",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Saint-Loup-des-Chaumes",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Saint-Martin-d'Auxigny",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Saint-Martin-des-Champs",
    "dep": "Cher"
  },
  {
    "code": "18270",
    "ville": "Saint-Maur",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Saint-Michel-de-Volangis",
    "dep": "Cher"
  },
  {
    "code": "18700",
    "ville": "Sainte-Montaine",
    "dep": "Cher"
  },
  {
    "code": "18310",
    "ville": "Saint-Outrille",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Saint-Palais",
    "dep": "Cher"
  },
  {
    "code": "18170",
    "ville": "Saint-Pierre-les-Bois",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Saint-Pierre-les-Étieux",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Saint-Priest-la-Marche",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Saint-Satur",
    "dep": "Cher"
  },
  {
    "code": "18370",
    "ville": "Saint-Saturnin",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Sainte-Solange",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Saint-Symphorien",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Sainte-Thorette",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "Saint-Vitte",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Sancergues",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Sancerre",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Sancoins",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Santranges",
    "dep": "Cher"
  },
  {
    "code": "18290",
    "ville": "Saugy",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "Saulzais-le-Potier",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Savigny-en-Sancerre",
    "dep": "Cher"
  },
  {
    "code": "18390",
    "ville": "Savigny-en-Septaine",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Senneçay",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Sens-Beaujeu",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Serruelles",
    "dep": "Cher"
  },
  {
    "code": "18140",
    "ville": "Sévry",
    "dep": "Cher"
  },
  {
    "code": "18270",
    "ville": "Sidiailles",
    "dep": "Cher"
  },
  {
    "code": "18220",
    "ville": "Soulangis",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Soye-en-Septaine",
    "dep": "Cher"
  },
  {
    "code": "18570",
    "ville": "Le Subdray",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Subligny",
    "dep": "Cher"
  },
  {
    "code": "18240",
    "ville": "Sury-près-Léré",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Sury-en-Vaux",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Sury-ès-Bois",
    "dep": "Cher"
  },
  {
    "code": "18350",
    "ville": "Tendron",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Thaumiers",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Thauvenay",
    "dep": "Cher"
  },
  {
    "code": "18100",
    "ville": "Thénioux",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Thou",
    "dep": "Cher"
  },
  {
    "code": "18320",
    "ville": "Torteron",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Touchay",
    "dep": "Cher"
  },
  {
    "code": "18570",
    "ville": "Trouy",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Uzay-le-Venon",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Vailly-sur-Sauldre",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Vallenay",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Vasselay",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Veaugues",
    "dep": "Cher"
  },
  {
    "code": "18190",
    "ville": "Venesmes",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Verdigny",
    "dep": "Cher"
  },
  {
    "code": "18600",
    "ville": "Vereaux",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Vernais",
    "dep": "Cher"
  },
  {
    "code": "18210",
    "ville": "Verneuil",
    "dep": "Cher"
  },
  {
    "code": "18360",
    "ville": "Vesdun",
    "dep": "Cher"
  },
  {
    "code": "18100",
    "ville": "Vierzon",
    "dep": "Cher"
  },
  {
    "code": "18110",
    "ville": "Vignoux-sous-les-Aix",
    "dep": "Cher"
  },
  {
    "code": "18500",
    "ville": "Vignoux-sur-Barangeon",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Villabon",
    "dep": "Cher"
  },
  {
    "code": "18160",
    "ville": "Villecelin",
    "dep": "Cher"
  },
  {
    "code": "18260",
    "ville": "Villegenon",
    "dep": "Cher"
  },
  {
    "code": "18400",
    "ville": "Villeneuve-sur-Cher",
    "dep": "Cher"
  },
  {
    "code": "18800",
    "ville": "Villequiers",
    "dep": "Cher"
  },
  {
    "code": "18300",
    "ville": "Vinon",
    "dep": "Cher"
  },
  {
    "code": "18340",
    "ville": "Vorly",
    "dep": "Cher"
  },
  {
    "code": "18130",
    "ville": "Vornay",
    "dep": "Cher"
  },
  {
    "code": "18330",
    "ville": "Vouzeron",
    "dep": "Cher"
  },
  {
    "code": "19260",
    "ville": "Affieux",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Aix",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Albignac",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Albussac",
    "dep": "Corrèze"
  },
  {
    "code": "19240",
    "ville": "Allassac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Alleyrat",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Altillac",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Ambrugeat",
    "dep": "Corrèze"
  },
  {
    "code": "19000",
    "ville": "Les Angles-sur-Corrèze",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Argentat-sur-Dordogne",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Arnac-Pompadour",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Astaillac",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Aubazines",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Auriac",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Ayen",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Bar",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Bassignac-le-Bas",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Bassignac-le-Haut",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Beaulieu-sur-Dordogne",
    "dep": "Corrèze"
  },
  {
    "code": "19390",
    "ville": "Beaumont",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Bellechassagne",
    "dep": "Corrèze"
  },
  {
    "code": "19510",
    "ville": "Benayes",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Beynat",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Beyssac",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Beyssenac",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Bilhac",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Bonnefond",
    "dep": "Corrèze"
  },
  {
    "code": "19110",
    "ville": "Bort-les-Orgues",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Branceilles",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Brignac-la-Plaine",
    "dep": "Corrèze"
  },
  {
    "code": "19100",
    "ville": "Brive-la-Gaillarde",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Bugeat",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Camps-Saint-Mathurin-Léobazel",
    "dep": "Corrèze"
  },
  {
    "code": "19350",
    "ville": "Chabrignac",
    "dep": "Corrèze"
  },
  {
    "code": "19370",
    "ville": "Chamberet",
    "dep": "Corrèze"
  },
  {
    "code": "19450",
    "ville": "Chamboulive",
    "dep": "Corrèze"
  },
  {
    "code": "19330",
    "ville": "Chameyrat",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Champagnac-la-Noaille",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Champagnac-la-Prune",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Chanac-les-Mines",
    "dep": "Corrèze"
  },
  {
    "code": "19330",
    "ville": "Chanteix",
    "dep": "Corrèze"
  },
  {
    "code": "19360",
    "ville": "La Chapelle-aux-Brocs",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "La Chapelle-aux-Saints",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "La Chapelle-Saint-Géraud",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Chapelle-Spinasse",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Chartrier-Ferrière",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Le Chastang",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Chasteaux",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Chauffour-sur-Vell",
    "dep": "Corrèze"
  },
  {
    "code": "19390",
    "ville": "Chaumeil",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Chavanac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Chaveroche",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Chenailler-Mascheix",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Chirac-Bellevue",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Clergoux",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Collonges-la-Rouge",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Combressol",
    "dep": "Corrèze"
  },
  {
    "code": "19350",
    "ville": "Concèze",
    "dep": "Corrèze"
  },
  {
    "code": "19140",
    "ville": "Condat-sur-Ganaveix",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Cornil",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Corrèze",
    "dep": "Corrèze"
  },
  {
    "code": "19360",
    "ville": "Cosnac",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Couffy-sur-Sarsonne",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Courteix",
    "dep": "Corrèze"
  },
  {
    "code": "19520",
    "ville": "Cublac",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Curemonte",
    "dep": "Corrèze"
  },
  {
    "code": "19360",
    "ville": "Dampniat",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Darazac",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Darnets",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Davignac",
    "dep": "Corrèze"
  },
  {
    "code": "19270",
    "ville": "Donzenac",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Égletons",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "L'Église-aux-Bois",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Espagnac",
    "dep": "Corrèze"
  },
  {
    "code": "19140",
    "ville": "Espartignac",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Estivals",
    "dep": "Corrèze"
  },
  {
    "code": "19410",
    "ville": "Estivaux",
    "dep": "Corrèze"
  },
  {
    "code": "19140",
    "ville": "Eyburie",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Eygurande",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Eyrein",
    "dep": "Corrèze"
  },
  {
    "code": "19330",
    "ville": "Favars",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Feyt",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Forgès",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Gimel-les-Cascades",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Goulles",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Gourdon-Murat",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Grandsaigne",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Gros-Chastang",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Gumond",
    "dep": "Corrèze"
  },
  {
    "code": "19400",
    "ville": "Hautefage",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Jugeals-Nazareth",
    "dep": "Corrèze"
  },
  {
    "code": "19350",
    "ville": "Juillac",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Lacelle",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Ladignac-sur-Rondelles",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Lafage-sur-Sombre",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Lagarde-Marc-la-Tour",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Lagleygeolle",
    "dep": "Corrèze"
  },
  {
    "code": "19700",
    "ville": "Lagraulière",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Laguenne-sur-Avalouze",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Lamazière-Basse",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Lamazière-Haute",
    "dep": "Corrèze"
  },
  {
    "code": "19510",
    "ville": "Lamongerie",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Lanteuil",
    "dep": "Corrèze"
  },
  {
    "code": "19550",
    "ville": "Lapleau",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Larche",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Laroche-près-Feyt",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Lascaux",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Latronche",
    "dep": "Corrèze"
  },
  {
    "code": "19550",
    "ville": "Laval-sur-Luzège",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Lestards",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Liginiac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Lignareix",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Ligneyrac",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Liourdres",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Lissac-sur-Couze",
    "dep": "Corrèze"
  },
  {
    "code": "19470",
    "ville": "Le Lonzac",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Lostanges",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Louignac",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Lubersac",
    "dep": "Corrèze"
  },
  {
    "code": "19470",
    "ville": "Madranges",
    "dep": "Corrèze"
  },
  {
    "code": "19360",
    "ville": "Malemort",
    "dep": "Corrèze"
  },
  {
    "code": "19520",
    "ville": "Mansac",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Marcillac-la-Croisille",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Marcillac-la-Croze",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Margerides",
    "dep": "Corrèze"
  },
  {
    "code": "19510",
    "ville": "Masseret",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Maussac",
    "dep": "Corrèze"
  },
  {
    "code": "19510",
    "ville": "Meilhards",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Ménoire",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Mercœur",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Merlines",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Mestes",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Meymac",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Meyrignac-l'Église",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Meyssac",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Millevaches",
    "dep": "Corrèze"
  },
  {
    "code": "19400",
    "ville": "Monceaux-sur-Dordogne",
    "dep": "Corrèze"
  },
  {
    "code": "19340",
    "ville": "Monestier-Merlines",
    "dep": "Corrèze"
  },
  {
    "code": "19110",
    "ville": "Monestier-Port-Dieu",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Montaignac-sur-Doustre",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Montgibaud",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Moustier-Ventadour",
    "dep": "Corrèze"
  },
  {
    "code": "19460",
    "ville": "Naves",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Nespouls",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Neuvic",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Neuville",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Noailhac",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Noailles",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Nonards",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Objat",
    "dep": "Corrèze"
  },
  {
    "code": "19410",
    "ville": "Orgnac-sur-Vézère",
    "dep": "Corrèze"
  },
  {
    "code": "19390",
    "ville": "Orliac-de-Bar",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Palazinges",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Palisse",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Pandrignes",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Péret-Bel-Air",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Pérols-sur-Vézère",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Perpezac-le-Blanc",
    "dep": "Corrèze"
  },
  {
    "code": "19410",
    "ville": "Perpezac-le-Noir",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Le Pescher",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Peyrelevade",
    "dep": "Corrèze"
  },
  {
    "code": "19260",
    "ville": "Peyrissac",
    "dep": "Corrèze"
  },
  {
    "code": "19450",
    "ville": "Pierrefitte",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Confolent-Port-Dieu",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Pradines",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Puy-d'Arnac",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Queyssac-les-Vignes",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Reygade",
    "dep": "Corrèze"
  },
  {
    "code": "19260",
    "ville": "Rilhac-Treignac",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Rilhac-Xaintrie",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "La Roche-Canillac",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Roche-le-Peyroux",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Rosiers-d'Égletons",
    "dep": "Corrèze"
  },
  {
    "code": "19350",
    "ville": "Rosiers-de-Juillac",
    "dep": "Corrèze"
  },
  {
    "code": "19270",
    "ville": "Sadroc",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Saillac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Angel",
    "dep": "Corrèze"
  },
  {
    "code": "19390",
    "ville": "Saint-Augustin",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Saint-Aulaire",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Saint-Bazile-de-Meyssac",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Saint-Bonnet-Elvert",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Saint-Bonnet-la-Rivière",
    "dep": "Corrèze"
  },
  {
    "code": "19410",
    "ville": "Saint-Bonnet-l'Enfantier",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Saint-Bonnet-les-Tours-de-Merle",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Bonnet-près-Bort",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Saint-Cernin-de-Larche",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Saint-Chamant",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Saint-Cirgues-la-Loutre",
    "dep": "Corrèze"
  },
  {
    "code": "19700",
    "ville": "Saint-Clément",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Saint-Cyprien",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Saint-Cyr-la-Roche",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Saint-Éloy-les-Tuileries",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Étienne-aux-Clos",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Saint-Étienne-la-Geneste",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Exupéry-les-Roches",
    "dep": "Corrèze"
  },
  {
    "code": "19270",
    "ville": "Sainte-Féréole",
    "dep": "Corrèze"
  },
  {
    "code": "19490",
    "ville": "Sainte-Fortunade",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Fréjoux",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Saint-Geniez-ô-Merle",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Saint-Germain-Lavolps",
    "dep": "Corrèze"
  },
  {
    "code": "19330",
    "ville": "Saint-Germain-les-Vergnes",
    "dep": "Corrèze"
  },
  {
    "code": "19550",
    "ville": "Saint-Hilaire-Foissac",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Saint-Hilaire-les-Courbes",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Saint-Hilaire-Luc",
    "dep": "Corrèze"
  },
  {
    "code": "19560",
    "ville": "Saint-Hilaire-Peyroux",
    "dep": "Corrèze"
  },
  {
    "code": "19400",
    "ville": "Saint-Hilaire-Taurieux",
    "dep": "Corrèze"
  },
  {
    "code": "19700",
    "ville": "Saint-Jal",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Saint-Julien-aux-Bois",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Saint-Julien-le-Pèlerin",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Saint-Julien-le-Vendômois",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Saint-Julien-Maumont",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Sainte-Marie-Lapanouze",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Saint-Martial-de-Gimel",
    "dep": "Corrèze"
  },
  {
    "code": "19400",
    "ville": "Saint-Martial-Entraygues",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Saint-Martin-la-Méanne",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Saint-Martin-Sepert",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Saint-Merd-de-Lapleau",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Saint-Merd-les-Oussines",
    "dep": "Corrèze"
  },
  {
    "code": "19330",
    "ville": "Saint-Mexant",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Saint-Pantaléon-de-Lapleau",
    "dep": "Corrèze"
  },
  {
    "code": "19600",
    "ville": "Saint-Pantaléon-de-Larche",
    "dep": "Corrèze"
  },
  {
    "code": "19210",
    "ville": "Saint-Pardoux-Corbier",
    "dep": "Corrèze"
  },
  {
    "code": "19320",
    "ville": "Saint-Pardoux-la-Croisille",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Pardoux-le-Neuf",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Pardoux-le-Vieux",
    "dep": "Corrèze"
  },
  {
    "code": "19270",
    "ville": "Saint-Pardoux-l'Ortigier",
    "dep": "Corrèze"
  },
  {
    "code": "19150",
    "ville": "Saint-Paul",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Saint-Priest-de-Gimel",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Saint-Privat",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Saint-Rémy",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Saint-Robert",
    "dep": "Corrèze"
  },
  {
    "code": "19700",
    "ville": "Saint-Salvadour",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Saint-Setiers",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Saint-Solve",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Saint-Sornin-Lavolps",
    "dep": "Corrèze"
  },
  {
    "code": "19250",
    "ville": "Saint-Sulpice-les-Bois",
    "dep": "Corrèze"
  },
  {
    "code": "19380",
    "ville": "Saint-Sylvain",
    "dep": "Corrèze"
  },
  {
    "code": "19240",
    "ville": "Saint-Viance",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Saint-Victour",
    "dep": "Corrèze"
  },
  {
    "code": "19140",
    "ville": "Saint-Ybard",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Saint-Yrieix-le-Déjalat",
    "dep": "Corrèze"
  },
  {
    "code": "19510",
    "ville": "Salon-la-Tour",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Sarran",
    "dep": "Corrèze"
  },
  {
    "code": "19110",
    "ville": "Sarroux - Saint Julien",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Segonzac",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Ségur-le-Château",
    "dep": "Corrèze"
  },
  {
    "code": "19700",
    "ville": "Seilhac",
    "dep": "Corrèze"
  },
  {
    "code": "19160",
    "ville": "Sérandon",
    "dep": "Corrèze"
  },
  {
    "code": "19190",
    "ville": "Sérilhac",
    "dep": "Corrèze"
  },
  {
    "code": "19220",
    "ville": "Servières-le-Château",
    "dep": "Corrèze"
  },
  {
    "code": "19430",
    "ville": "Sexcles",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Sioniac",
    "dep": "Corrèze"
  },
  {
    "code": "19290",
    "ville": "Sornac",
    "dep": "Corrèze"
  },
  {
    "code": "19370",
    "ville": "Soudaine-Lavinadière",
    "dep": "Corrèze"
  },
  {
    "code": "19300",
    "ville": "Soudeilles",
    "dep": "Corrèze"
  },
  {
    "code": "19550",
    "ville": "Soursac",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Tarnac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Thalamy",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Toy-Viam",
    "dep": "Corrèze"
  },
  {
    "code": "19260",
    "ville": "Treignac",
    "dep": "Corrèze"
  },
  {
    "code": "19230",
    "ville": "Troche",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Tudeils",
    "dep": "Corrèze"
  },
  {
    "code": "19000",
    "ville": "Tulle",
    "dep": "Corrèze"
  },
  {
    "code": "19500",
    "ville": "Turenne",
    "dep": "Corrèze"
  },
  {
    "code": "19270",
    "ville": "Ussac",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Ussel",
    "dep": "Corrèze"
  },
  {
    "code": "19140",
    "ville": "Uzerche",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Valiergues",
    "dep": "Corrèze"
  },
  {
    "code": "19240",
    "ville": "Varetz",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Vars-sur-Roseix",
    "dep": "Corrèze"
  },
  {
    "code": "19120",
    "ville": "Végennes",
    "dep": "Corrèze"
  },
  {
    "code": "19260",
    "ville": "Veix",
    "dep": "Corrèze"
  },
  {
    "code": "19200",
    "ville": "Veyrières",
    "dep": "Corrèze"
  },
  {
    "code": "19170",
    "ville": "Viam",
    "dep": "Corrèze"
  },
  {
    "code": "19410",
    "ville": "Vigeois",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Vignols",
    "dep": "Corrèze"
  },
  {
    "code": "19800",
    "ville": "Vitrac-sur-Montane",
    "dep": "Corrèze"
  },
  {
    "code": "19130",
    "ville": "Voutezac",
    "dep": "Corrèze"
  },
  {
    "code": "19310",
    "ville": "Yssandon",
    "dep": "Corrèze"
  },
  {
    "code": "21700",
    "ville": "Agencourt",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Agey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Ahuy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Aignay-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Aiserey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Aisey-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Aisy-sous-Thil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Alise-Sainte-Reine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Allerey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21420",
    "ville": "Aloxe-Corton",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Ampilly-les-Bordes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Ampilly-le-Sec",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Ancey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Antheuil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Antigny-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Arceau",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Arcenant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Arcey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Arconcey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21560",
    "ville": "Arc-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Argilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Arnay-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Arnay-sous-Vitteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Arrans",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Asnières-en-Montagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Asnières-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Athée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Athie",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Aubaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Aubigny-en-Plaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Aubigny-la-Ronce",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Aubigny-lès-Sombernon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Autricourt",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Auvillars-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Auxant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Auxey-Duresses",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Auxonne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Avelanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Avosnes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Avot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Bagnot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Baigneux-les-Juifs",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Balot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Barbirey-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Bard-le-Régulier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Bard-lès-Époisses",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Barges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Barjon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Baubigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Baulme-la-Roche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Beaulieu",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Beaumont-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Beaunotte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Beire-le-Châtel",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Beire-le-Fort",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Belan-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Bellefond",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Belleneuve",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Bellenod-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Bellenot-sous-Pouilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Beneuvre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Benoisey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Bessey-en-Chaume",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Bessey-la-Cour",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Bessey-lès-Cîteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Beurey-Bauguay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Beurizot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Bévy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Bèze",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Bézouotte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Billey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Billy-lès-Chanceaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Binges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Bissey-la-Côte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Bissey-la-Pierre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Blagny-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Blaisy-Bas",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Blaisy-Haut",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Blancey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Blanot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Source-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Bligny-le-Sec",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Bligny-lès-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Bligny-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Boncourt-le-Bois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Bonnencontre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Boudreville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Bouhey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21420",
    "ville": "Bouilland",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Bouix",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Bourberain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Bousselange",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Boussenois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Boussey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Boux-sous-Salmaise",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Bouze-lès-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Brain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Braux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Brazey-en-Morvan",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21470",
    "ville": "Brazey-en-Plaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Brémur-et-Vaurois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21560",
    "ville": "Bressey-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Bretenière",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Bretigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Brianny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Brion-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Brochon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Brognon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Broin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Broindon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Buffon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Buncey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Bure-les-Templiers",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Busseaut",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Busserotte-et-Montenaille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Bussières",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "La Bussière-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Bussy-la-Pesle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Bussy-le-Grand",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Buxerolles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Censerey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Cérilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Cessey-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Chaignay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Chailly-sur-Armançon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Chambain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Chambeire",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Chamblanc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Chambœuf",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Chambolle-Musigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Chamesson",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Champagne-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Champagny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Champ-d'Oiseau",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Champdôtre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Champeau-en-Morvan",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Champignolles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Champrenault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Chanceaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Channay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Charencey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Charigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Charmes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Charny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Charrey-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Charrey-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Chassagne-Montrachet",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Chassey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Châteauneuf",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Châtellenot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Châtillon-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Chaudenay-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Chaudenay-le-Château",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Chaugey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Chaume-et-Courchamp",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "La Chaume",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Chaume-lès-Baigneux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Chaumont-le-Bois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Chaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Chazeuil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Chazilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Chemin-d'Aisey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21300",
    "ville": "Chenôve",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Cheuge",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Chevannay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Chevannes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Chevigny-en-Valière",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21800",
    "ville": "Chevigny-Saint-Sauveur",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21820",
    "ville": "Chivres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Chorey-les-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Cirey-lès-Pontailler",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Civry-en-Montagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Clamerey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Valforêt",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Clénay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Cléry",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Clomot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Collonges-lès-Bévy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Collonges-et-Premières",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Colombier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Combertault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Comblanchien",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Commarin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Corberon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Corcelles-les-Arts",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Corcelles-lès-Cîteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21160",
    "ville": "Corcelles-les-Monts",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Corgengoux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Corgoloin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Cormot-Vauchignon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Corpeau",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Corpoyer-la-Chapelle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Corrombles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Corsaint",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21160",
    "ville": "Couchey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Coulmier-le-Sec",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Courban",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Courcelles-Frémoy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Courcelles-lès-Montbard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Courcelles-lès-Semur",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Courlon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Courtivron",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21560",
    "ville": "Couternon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Créancey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Crécey-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Crépand",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Crugey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Cuiserey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Culètre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Curley",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Curtil-Saint-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Curtil-Vergy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Cussey-les-Forges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Cussy-la-Colonne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Cussy-le-Châtel",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Daix",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Dampierre-en-Montagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Dampierre-et-Flée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Darcey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Darois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Détain-et-Bruant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Diancey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Diénay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21000",
    "ville": "Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Dompierre-en-Morvan",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Drambon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Drée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Duesme",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Ébaty",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Échalot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Échannay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Échenon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Échevannes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21420",
    "ville": "Échevronne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Échigey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Écutigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Éguilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Épagny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Épernay-sous-Gevrey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Époisses",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Éringes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Esbarres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Essarois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Essey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Étais",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Étalante",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "L'Étang-Vergy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Étaules",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Étevaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Étormay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Étrochey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Fain-lès-Montbard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Fain-lès-Moutiers",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Fauverney",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Faverolles-lès-Lucey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21600",
    "ville": "Fénay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Le Fête",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Fixin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Flacey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21640",
    "ville": "Flagey-Echézeaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Flagey-lès-Auxonne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Flammerans",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21160",
    "ville": "Flavignerot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Flavigny-sur-Ozerain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Le Val-Larrey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Fleurey-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Foissy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Foncegrive",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Fontaines-en-Duesmois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Fontaine-Française",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Fontaine-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Fontaines-les-Sèches",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Fontangy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Fontenelle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Forléans",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Fraignot-et-Vesvrotte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Francheville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Franxault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Frénois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Fresnes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Frôlois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Fussey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Gemeaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Genay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Genlis",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Gergueil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Gerland",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Gevrey-Chambertin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Gevrolles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21640",
    "ville": "Gilly-lès-Cîteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Gissey-le-Vieil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Gissey-sous-Flavigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Gissey-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Glanon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Gomméville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Les Goulles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Grancey-le-Château-Neuvelle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Grancey-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Grenant-lès-Sombernon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Grésigny-Sainte-Reine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Grignon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Griselles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Grosbois-en-Montagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Grosbois-lès-Tichey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Gurgy-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Gurgy-le-Château",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Hauteroche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Hauteville-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Heuilley-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Is-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Izeure",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Izier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Jailly-les-Moulins",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Jallanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Jancigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Jeux-lès-Bard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Jouey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Jours-lès-Baigneux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Val-Mont",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Juillenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Juilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Labergement-Foigney",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Labergement-lès-Auxonne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21820",
    "ville": "Labergement-lès-Seurre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Labruyère",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Lacanche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Lacour-d'Arcenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Laignes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21760",
    "ville": "Lamarche-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Lamargelle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21370",
    "ville": "Lantenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Lanthes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Lantilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Laperrière-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Larrey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Lechâtelet",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Léry",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Leuglay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Levernois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Licey-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Liernais",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Lignerolles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Longchamp",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Longeault-Pluvault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Longecourt-en-Plaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Longecourt-lès-Culêtre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21600",
    "ville": "Longvic",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Losne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Louesme",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Lucenay-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Lucey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Lusigny-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Lux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Maconge",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Magnien",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Magny-Lambert",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Magny-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Magny-lès-Aubigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Magny-Montarlot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Magny-lès-Villers",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Magny-Saint-Médard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Magny-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Les Maillys",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Maisey-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Mâlain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Maligny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Manlay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Marandeuil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Marcellois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Marcenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Marcheseuil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Marcigny-sous-Thil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Marcilly-et-Dracy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Marcilly-Ogny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Marcilly-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Marey-lès-Fussey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Marey-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Marigny-le-Cahouët",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Marigny-lès-Reullée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Marliens",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Marmagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21160",
    "ville": "Marsannay-la-Côte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Marsannay-le-Bois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Martrois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Massingy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Massingy-lès-Semur",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Massingy-lès-Vitteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Mauvilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Mavilly-Mandelot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Maxilly-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Meilly-sur-Rouvres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Le Meix",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Meloisey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Menesble",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Ménessaire",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Ménétreux-le-Pitois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Merceuil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Mesmont",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Messanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Messigny-et-Vantoux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Meuilley",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Meulson",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Meursanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Meursault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Millery",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Mimeure",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Minot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Mirebeau-sur-Bèze",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Missery",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Moitron",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Molesme",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Molinot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Moloy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Molphey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Montagny-lès-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Montagny-lès-Seurre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Montbard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Montberthault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Montceau-et-Écharnant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Monthelie",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Montigny-Montfort",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Montigny-Saint-Barthélemy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Montigny-sur-Armançon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Montigny-sur-Aube",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Montigny-Mornay-Villeneuve-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Montlay-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Montliot-et-Courcelles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Montmain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Montmançon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Montmoyen",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Montoillot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Montot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Mont-Saint-Jean",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Morey-Saint-Denis",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Mosson",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "La Motte-Ternant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Moutiers-Saint-Jean",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Musigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Mussy-la-Fosse",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Nan-sous-Thil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Nantoux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Nesle-et-Massoult",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21800",
    "ville": "Neuilly-Crimolois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Nicey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Nod-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Nogent-lès-Montbard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Noidan",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Noiron-sous-Gevrey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Noiron-sur-Bèze",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Noiron-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Nolay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Norges-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Normier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Nuits-Saint-Georges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Obtrée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Oigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Oisilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Orain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Orgeux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Origny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Orret",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Orville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21600",
    "ville": "Ouges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Pagny-la-Ville",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Pagny-le-Château",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Painblanc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Panges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21370",
    "ville": "Pasques",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Pellerey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21420",
    "ville": "Pernand-Vergelesses",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21160",
    "ville": "Perrigny-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Perrigny-sur-l'Ognon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Pichanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Planay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21370",
    "ville": "Plombières-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Pluvet",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Poinçon-lès-Larrey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Poiseul-la-Grange",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Poiseul-la-Ville-et-Laperrière",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Poiseul-lès-Saulx",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21630",
    "ville": "Pommard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Poncey-lès-Athée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Poncey-sur-l'Ignon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Pont",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Pontailler-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Pont-et-Massène",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Posanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Pothières",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Pouillenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Pouilly-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Pouilly-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Pouilly-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Prâlon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Précy-sous-Thil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Premeaux-Prissey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21370",
    "ville": "Prenois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Prusly-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Puits",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Puligny-Montrachet",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Quemigny-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21800",
    "ville": "Quetigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Quincerot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Quincey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Quincy-le-Vicomte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Recey-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Remilly-en-Montagne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21560",
    "ville": "Remilly-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Renève",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Reulle-Vergy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Riel-les-Eaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21530",
    "ville": "La Roche-en-Brenil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Rochefort-sur-Brévon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "La Rochepot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "La Roche-Vanneau",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Roilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Rougemont",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21530",
    "ville": "Rouvray",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Rouvres-en-Plaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Rouvres-sous-Meilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Ruffey-lès-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Ruffey-lès-Echirey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Sacquenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Saffres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21530",
    "ville": "Saint-Andeux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Saint-Anthot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21850",
    "ville": "Saint-Apollinaire",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Saint-Aubin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Saint-Bernard",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Saint-Broing-les-Moines",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Sainte-Colombe-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Sainte-Colombe-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Saint-Didier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Saint-Euphrône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21530",
    "ville": "Saint-Germain-de-Modéon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21510",
    "ville": "Saint-Germain-le-Rocheux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Saint-Germain-lès-Senailly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Saint-Hélier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Saint-Jean-de-Bœuf",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Saint-Jean-de-Losne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Saint-Julien",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Saint-Léger-Triey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Saint-Marc-sur-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Sainte-Marie-la-Blanche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Sainte-Marie-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Saint-Martin-de-la-Mer",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Saint-Martin-du-Mont",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Saint-Maurice-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Saint-Mesmin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Saint-Nicolas-lès-Cîteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Saint-Philibert",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Saint-Pierre-en-Vaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Saint-Prix-lès-Arnay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Saint-Rémy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Saint-Romain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Sainte-Sabine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Saint-Sauveur",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Saint-Seine-en-Bâche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Saint-Seine-l'Abbaye",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21610",
    "ville": "Saint-Seine-sur-Vingeanne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Saint-Symphorien-sur-Saône",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Saint-Thibault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Saint-Usage",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21410",
    "ville": "Saint-Victor-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21580",
    "ville": "Salives",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Salmaise",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Samerey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21590",
    "ville": "Santenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Santosse",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Saulieu",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Saulon-la-Chapelle",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Saulon-la-Rue",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Saulx-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Saussey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Saussy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21420",
    "ville": "Savigny-lès-Beaune",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21380",
    "ville": "Savigny-le-Sec",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Savigny-sous-Mâlain",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Savilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Savoisy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Savolles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21910",
    "ville": "Savouges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Segrois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Seigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Selongey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Semarey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Semezanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Semond",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Semur-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Senailly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21800",
    "ville": "Sennecey-lès-Dijon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21550",
    "ville": "Ladoix-Serrigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Seurre",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21530",
    "ville": "Sincey-lès-Rouvray",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Soirans",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Soissons-sur-Nacey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Sombernon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Souhey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Soussey-sur-Brionne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Spoy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Sussey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Tailly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21240",
    "ville": "Talant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Talmay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Tanay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Tarsul",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Tart-le-Bas",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Tart",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Tellecey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Ternant",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Terrefondrée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Thenissey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21570",
    "ville": "Thoires",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Thoisy-la-Berchère",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Thoisy-le-Désert",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Thomirey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Thorey-en-Plaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Thorey-sous-Charny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Thorey-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Thoste",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21340",
    "ville": "Thury",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Tichey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Til-Châtel",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Tillenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Torcy-et-Pouligny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Touillon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Toutry",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Tréclun",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Trochères",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21170",
    "ville": "Trouhans",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Trouhaut",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Trugny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Turcey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Uncey-le-Franc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21220",
    "ville": "Urcy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21121",
    "ville": "Val-Suzon",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21320",
    "ville": "Vandenesse-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Vannaire",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Vanvey",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21110",
    "ville": "Varanges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21490",
    "ville": "Varois-et-Chaignot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21440",
    "ville": "Vaux-Saules",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Veilly",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21370",
    "ville": "Velars-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Velogny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21150",
    "ville": "Venarey-les-Laumes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Verdonnet",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Vernois-lès-Vesvres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Vernot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21260",
    "ville": "Véronnes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Verrey-sous-Drée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Verrey-sous-Salmaise",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Vertault",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Vesvres",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Veuvey-sur-Ouche",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21520",
    "ville": "Veuxhaulles-sur-Aube",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Vianges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Vic-de-Chassenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21360",
    "ville": "Vic-des-Prés",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21390",
    "ville": "Vic-sous-Thil",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21540",
    "ville": "Vieilmoulin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Vielverge",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21460",
    "ville": "Vieux-Château",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21310",
    "ville": "Viévigne",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Viévy",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21200",
    "ville": "Vignoles",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "Villaines-en-Duesmois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Villaines-les-Prévôtes",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21210",
    "ville": "Villargoix",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Villars-Fontaine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Villars-et-Villenotte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Villeberny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Villebichot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Villecomte",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21330",
    "ville": "Villedieu",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Villeferry",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21450",
    "ville": "La Villeneuve-les-Convers",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21140",
    "ville": "Villeneuve-sous-Charigny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Villers-la-Faye",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Villers-les-Pots",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Villers-Patras",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21130",
    "ville": "Villers-Rotin",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21120",
    "ville": "Villey-sur-Tille",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21430",
    "ville": "Villiers-en-Morvan",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Villiers-le-Duc",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21690",
    "ville": "Villotte-Saint-Seine",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Villotte-sur-Ource",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Villy-en-Auxois",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21250",
    "ville": "Villy-le-Moutier",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21500",
    "ville": "Viserny",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21350",
    "ville": "Vitteaux",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21400",
    "ville": "Vix",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21190",
    "ville": "Volnay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21270",
    "ville": "Vonges",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21700",
    "ville": "Vosne-Romanée",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21230",
    "ville": "Voudenay",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21640",
    "ville": "Vougeot",
    "dep": "Côte-d'Or"
  },
  {
    "code": "21290",
    "ville": "Voulaines-les-Templiers",
    "dep": "Côte-d'Or"
  },
  {
    "code": "22460",
    "ville": "Allineuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Andel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Aucaleuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Bégard",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22810",
    "ville": "Belle-Isle-en-Terre",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Berhet",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Bobital",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Le Bodéo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Boqueho",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22240",
    "ville": "La Bouillie",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22390",
    "ville": "Bourbriac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Bourseul",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Bréhand",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22870",
    "ville": "Île-de-Bréhat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Brélidy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Bringolo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Broons",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Brusvily",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Bulat-Pestivien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Calanhel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Callac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Calorguen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "Le Cambout",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Camlez",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Canihuel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Caouënnec-Lanvézéac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Carnoët",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Caulnes",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22530",
    "ville": "Caurel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Cavan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Les Champs-Géraux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "La Chapelle-Blanche",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "La Chapelle-Neuve",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "La Chèze",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22970",
    "ville": "Coadout",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Coatascorn",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Coatréven",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "Coëtlogon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Coëtmieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Cohiniac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22330",
    "ville": "Le Mené",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Corlay",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Corseul",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Créhen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Dinan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Duault",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Éréac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22430",
    "ville": "Erquy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22520",
    "ville": "Binic-Étables-sur-Mer",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Évran",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Le Faouët",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Le Fœil",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Gausson",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Glomel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Gomené",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Gommenec'h",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22570",
    "ville": "Gouarec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Goudelin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Grâces",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Grâce-Uzel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Guenroc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Guingamp",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Guitté",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22390",
    "ville": "Gurunhuel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "La Harmoye",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Le Haut-Corlay",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Hémonstoir",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22550",
    "ville": "Hénanbihen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Hénansal",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Hénon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22120",
    "ville": "Hillion",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Le Hinglé",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Illifaut",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22270",
    "ville": "Jugon-les-Lacs",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22610",
    "ville": "Kerbors",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22500",
    "ville": "Kerfot",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Kergrist-Moëlou",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Kerien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Kermaria-Sulard",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Kermoroc'h",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Kerpert",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Lamballe-Armor",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22770",
    "ville": "Lancieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Landebaëron",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Landébia",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "La Landec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Landéhen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Lanfains",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Langoat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22490",
    "ville": "Langrolay-sur-Rance",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Languédias",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Languenan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22360",
    "ville": "Langueux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22570",
    "ville": "Bon Repos sur Blavet",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Lanleff",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22580",
    "ville": "Lanloup",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Lanmérin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22610",
    "ville": "Lanmodez",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Lannebert",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Lannion",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Lanrelas",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Lanrivain",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Lanrodec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22410",
    "ville": "Lantic",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Lanvallay",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22420",
    "ville": "Lanvellec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Lanvollon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Laurenan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22570",
    "ville": "Lescouët-Gouarec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Le Leslay",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22740",
    "ville": "Lézardrieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Locarn",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22810",
    "ville": "Loc-Envel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22780",
    "ville": "Loguivy-Plougras",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Lohuec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Loscouët-sur-Meu",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22700",
    "ville": "Louannec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22540",
    "ville": "Louargat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Loudéac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Maël-Carhaix",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Maël-Pestivien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Magoar",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22640",
    "ville": "La Malhoure",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Mantallot",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22550",
    "ville": "Matignon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22440",
    "ville": "La Méaugon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22270",
    "ville": "Mégrit",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Mellionnec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Merdrignac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Mérillac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Merléac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Le Merzer",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22220",
    "ville": "Minihy-Tréguier",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Moncontour",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "La Motte",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Moustéru",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Le Moustoir",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22530",
    "ville": "Guerlédan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Noyal",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Pabu",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22500",
    "ville": "Paimpol",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Paule",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22540",
    "ville": "Pédernec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Penguily",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22710",
    "ville": "Penvénan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22700",
    "ville": "Perros-Guirec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Peumerit-Quintin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Plaine-Haute",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22940",
    "ville": "Plaintel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Plancoët",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22550",
    "ville": "Pléboulle",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22270",
    "ville": "Plédéliac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22960",
    "ville": "Plédran",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Pléguien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Pléhédel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22240",
    "ville": "Fréhel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Plélan-le-Petit",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22570",
    "ville": "Plélauff",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Plélo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "Plémet",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Plémy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22640",
    "ville": "Plénée-Jugon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22370",
    "ville": "Pléneuf-Val-André",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22190",
    "ville": "Plérin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Plerneuf",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22720",
    "ville": "Plésidy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22490",
    "ville": "Pleslin-Trigavou",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22640",
    "ville": "Plestan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22310",
    "ville": "Plestin-les-Grèves",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22610",
    "ville": "Pleubian",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22740",
    "ville": "Pleudaniel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22690",
    "ville": "Pleudihen-sur-Rance",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22560",
    "ville": "Pleumeur-Bodou",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22740",
    "ville": "Pleumeur-Gautier",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Pléven",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22240",
    "ville": "Plévenon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Plévin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Plœuc-L'Hermitage",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Ploëzal",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Plorec-sur-Arguenon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Châtelaudren-Plouagat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22420",
    "ville": "Plouaret",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22830",
    "ville": "Plouasne",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22650",
    "ville": "Beaussais-sur-Mer",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22620",
    "ville": "Ploubazlanec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Ploubezre",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Plouëc-du-Trieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22490",
    "ville": "Plouër-sur-Rance",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22470",
    "ville": "Plouézec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22440",
    "ville": "Ploufragan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22810",
    "ville": "Plougonver",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22780",
    "ville": "Plougras",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22820",
    "ville": "Plougrescant",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Plouguenast-Langast",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Plouguernével",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22220",
    "ville": "Plouguiel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22580",
    "ville": "Plouha",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Plouisy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Ploulec'h",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22970",
    "ville": "Ploumagoar",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Ploumilliau",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22780",
    "ville": "Plounérin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22810",
    "ville": "Plounévez-Moëdec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Plounévez-Quintin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Plourac'h",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22410",
    "ville": "Plourhan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22860",
    "ville": "Plourivo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Plouvara",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22420",
    "ville": "Plouzélambre",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Pludual",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Pluduno",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22310",
    "ville": "Plufur",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Plumaudan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Plumaugat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "Plumieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22240",
    "ville": "Plurien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Plusquellec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Plussulien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Pluzunet",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22120",
    "ville": "Pommeret",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Pommerit-le-Vicomte",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22390",
    "ville": "Pont-Melvez",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Pontrieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22590",
    "ville": "Pordic",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Prat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "La Prénessaye",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Quemper-Guézennec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Quemperven",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22120",
    "ville": "Quessoy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Quévert",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Le Quillio",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Quintenic",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Quintin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Le Quiou",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "La Roche-Jaudy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Rospez",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Rostrenen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Rouillac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22550",
    "ville": "Ruca",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Runan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22390",
    "ville": "Saint-Adrien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Saint-Agathon",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Saint-Alban",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Saint-André-des-Eaux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Saint-Barnabé",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Saint-Bihy",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Saint-Brandan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22000",
    "ville": "Saint-Brieuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Saint-Caradec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Saint-Carné",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22150",
    "ville": "Saint-Carreuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22380",
    "ville": "Saint-Cast-le-Guildo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22260",
    "ville": "Saint-Clet",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Saint-Connan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22530",
    "ville": "Saint-Connec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22400",
    "ville": "Saint-Denoual",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Saint-Donan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22210",
    "ville": "Saint-Étienne-du-Gué-de-l'Isle",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22720",
    "ville": "Saint-Fiacre",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Saint-Gildas",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Saint-Gilles-les-Bois",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Saint-Gilles-Pligeaux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22530",
    "ville": "Saint-Gilles-Vieux-Marché",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Saint-Glen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Saint-Hélen",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Saint-Hervé",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22750",
    "ville": "Saint-Jacut-de-la-Mer",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22170",
    "ville": "Saint-Jean-Kerdaniel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Saint-Jouan-de-l'Isle",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Saint-Judoce",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22940",
    "ville": "Saint-Julien",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Saint-Juvat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Saint-Launeuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Saint-Laurent",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22130",
    "ville": "Saint-Lormel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Saint-Maden",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Saint-Martin-des-Prés",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Saint-Maudan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Saint-Maudez",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22320",
    "ville": "Saint-Mayeux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Saint-Méloir-des-Bois",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Saint-Michel-de-Plélan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Saint-Michel-en-Grève",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Saint-Nicodème",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Saint-Nicolas-du-Pélem",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22720",
    "ville": "Saint-Péver",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22550",
    "ville": "Saint-Pôtan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22700",
    "ville": "Saint-Quay-Perros",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22410",
    "ville": "Saint-Quay-Portrieux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22270",
    "ville": "Saint-Rieul",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Saint-Samson-sur-Rance",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22160",
    "ville": "Saint-Servais",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Saint-Thélo",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22480",
    "ville": "Sainte-Tréphine",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Saint-Trimoël",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Saint-Vran",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22570",
    "ville": "Saint-Igeaux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22720",
    "ville": "Senven-Léhart",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Sévignac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Squiffiec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Taden",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22140",
    "ville": "Tonquédec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22640",
    "ville": "Tramain",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Trébédan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22560",
    "ville": "Trébeurden",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Trébrivan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Trébry",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22510",
    "ville": "Trédaniel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22220",
    "ville": "Trédarzec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Trédias",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22300",
    "ville": "Trédrez-Locquémeau",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22310",
    "ville": "Tréduder",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Treffrin",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22630",
    "ville": "Tréfumel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22730",
    "ville": "Trégastel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22540",
    "ville": "Tréglamus",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22590",
    "ville": "Trégomeur",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22200",
    "ville": "Trégonneau",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22420",
    "ville": "Trégrom",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22950",
    "ville": "Trégueux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Tréguidel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22220",
    "ville": "Tréguier",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22660",
    "ville": "Trélévern",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Trélivan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22110",
    "ville": "Trémargat",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22310",
    "ville": "Trémel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22490",
    "ville": "Tréméreuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22250",
    "ville": "Trémeur",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Tréméven",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22230",
    "ville": "Trémorel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22440",
    "ville": "Trémuson",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22340",
    "ville": "Tréogan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Tressignaux",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22600",
    "ville": "Trévé",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22410",
    "ville": "Tréveneuc",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22290",
    "ville": "Trévérec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22660",
    "ville": "Trévou-Tréguignec",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22100",
    "ville": "Trévron",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Trézény",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22450",
    "ville": "Troguéry",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22460",
    "ville": "Uzel",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22690",
    "ville": "La Vicomté-sur-Rance",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22800",
    "ville": "Le Vieux-Bourg",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22420",
    "ville": "Le Vieux-Marché",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22980",
    "ville": "Vildé-Guingalan",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22120",
    "ville": "Yffiniac",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22930",
    "ville": "Yvias",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "22350",
    "ville": "Yvignac-la-Tour",
    "dep": "Côtes-d'Armor"
  },
  {
    "code": "23150",
    "ville": "Ahun",
    "dep": "Creuse"
  },
  {
    "code": "23380",
    "ville": "Ajain",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Alleyrat",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Anzême",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Arfeuille-Châtain",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Arrènes",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Ars",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Aubusson",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Auge",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Augères",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Aulon",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Auriat",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Auzances",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Azat-Châtenet",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "Azerables",
    "dep": "Creuse"
  },
  {
    "code": "23120",
    "ville": "Banize",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Basville",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "Bazelat",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Beissat",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Bellegarde-en-Marche",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Bénévent-l'Abbaye",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Bétête",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Blaudeix",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Blessac",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Bonnat",
    "dep": "Creuse"
  },
  {
    "code": "23230",
    "ville": "Bord-Saint-Georges",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Bosmoreau-les-Mines",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Bosroger",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Le Bourg-d'Hem",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Bourganeuf",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Boussac",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Boussac-Bourg",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "La Brionne",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Brousse",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Budelière",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Bussière-Dunoise",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Bussière-Nouvelle",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Bussière-Saint-Georges",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "La Celle-Dunoise",
    "dep": "Creuse"
  },
  {
    "code": "23230",
    "ville": "La Celle-sous-Gouzon",
    "dep": "Creuse"
  },
  {
    "code": "23350",
    "ville": "La Cellette",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Ceyroux",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Chamberaud",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Chambon-Sainte-Croix",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Chambon-sur-Voueize",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Chambonchard",
    "dep": "Creuse"
  },
  {
    "code": "23240",
    "ville": "Chamborand",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Champagnat",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Champsanglard",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "La Chapelle-Baloue",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "La Chapelle-Saint-Martial",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "La Chapelle-Taillefert",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Chard",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Charron",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Châtelard",
    "dep": "Creuse"
  },
  {
    "code": "23430",
    "ville": "Châtelus-le-Marcheix",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Châtelus-Malvaleix",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Le Chauchet",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "La Chaussade",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Chavanat",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Chénérailles",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Chéniers",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Clairavaux",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Clugnat",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Colondannes",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Le Compas",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "La Courtine",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Cressat",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Crocq",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "Crozant",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Croze",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Domeyrot",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Dontreix",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Le Donzeil",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Dun-le-Palestel",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Évaux-les-Bains",
    "dep": "Creuse"
  },
  {
    "code": "23340",
    "ville": "Faux-la-Montagne",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Faux-Mazuras",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Felletin",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "Féniers",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Flayat",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Fleurat",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Fontanières",
    "dep": "Creuse"
  },
  {
    "code": "23360",
    "ville": "La Forêt-du-Temple",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Fransèches",
    "dep": "Creuse"
  },
  {
    "code": "23450",
    "ville": "Fresselines",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Gartempe",
    "dep": "Creuse"
  },
  {
    "code": "23350",
    "ville": "Genouillac",
    "dep": "Creuse"
  },
  {
    "code": "23340",
    "ville": "Gentioux-Pigerolles",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Gioux",
    "dep": "Creuse"
  },
  {
    "code": "23380",
    "ville": "Glénic",
    "dep": "Creuse"
  },
  {
    "code": "23230",
    "ville": "Gouzon",
    "dep": "Creuse"
  },
  {
    "code": "23240",
    "ville": "Le Grand-Bourg",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Guéret",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Issoudun-Létrieix",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Jalesches",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Janaillat",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Jarnages",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Jouillat",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Ladapeyre",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Lafat",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Lavaufranche",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Lavaveix-les-Mines",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Lépaud",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Lépinas",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Leyrat",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Linard-Malval",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Lioux-les-Monges",
    "dep": "Creuse"
  },
  {
    "code": "23240",
    "ville": "Lizières",
    "dep": "Creuse"
  },
  {
    "code": "23360",
    "ville": "Lourdoueix-Saint-Pierre",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Lupersat",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Lussat",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Magnat-l'Étrange",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Mainsat",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Maison-Feyne",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Maisonnisses",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Malleret",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Malleret-Boussac",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Mansat-la-Courrière",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Les Mars",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Marsac",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "Le Mas-d'Artige",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Mautes",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Mazeirat",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "La Mazière-aux-Bons-Hommes",
    "dep": "Creuse"
  },
  {
    "code": "23360",
    "ville": "Méasnes",
    "dep": "Creuse"
  },
  {
    "code": "23420",
    "ville": "Mérinchal",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Montaigut-le-Blanc",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Montboucher",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Le Monteil-au-Vicomte",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Mortroux",
    "dep": "Creuse"
  },
  {
    "code": "23210",
    "ville": "Mourioux-Vieilleville",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Moutier-d'Ahun",
    "dep": "Creuse"
  },
  {
    "code": "23220",
    "ville": "Moutier-Malcard",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Moutier-Rozeille",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Naillat",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Néoux",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Noth",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "La Nouaille",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Nouhant",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Nouzerines",
    "dep": "Creuse"
  },
  {
    "code": "23360",
    "ville": "Nouzerolles",
    "dep": "Creuse"
  },
  {
    "code": "23350",
    "ville": "Nouziers",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Parsac-Rimondeix",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Peyrabout",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Peyrat-la-Nonière",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Pierrefitte",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Pionnat",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Pontarion",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Pontcharraud",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "La Pouge",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Poussanges",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Puy-Malsignat",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Reterre",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Roches",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Rougnat",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Royère-de-Vassivière",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Sagnat",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Sannat",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Sardent",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "La Saunière",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Savennes",
    "dep": "Creuse"
  },
  {
    "code": "23700",
    "ville": "Sermur",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "La Serre-Bussière-Vieille",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Soubrebost",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Soumans",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Sous-Parsat",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "La Souterraine",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Saint-Agnant-de-Versillat",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Saint-Agnant-près-Crocq",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Alpinien",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Amand",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Amand-Jartoudeix",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Avit-de-Tardes",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Saint-Avit-le-Pauvre",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Saint-Bard",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Saint-Chabrais",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Christophe",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Saint-Dizier-la-Tour",
    "dep": "Creuse"
  },
  {
    "code": "23270",
    "ville": "Saint-Dizier-les-Domaines",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Dizier-Masbaraud",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Saint-Domet",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Éloi",
    "dep": "Creuse"
  },
  {
    "code": "23290",
    "ville": "Fursac",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Sainte-Feyre",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Sainte-Feyre-la-Montagne",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Fiel",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Saint-Frion",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Saint-Georges-la-Pouge",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Saint-Georges-Nigremont",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "Saint-Germain-Beaupré",
    "dep": "Creuse"
  },
  {
    "code": "23430",
    "ville": "Saint-Goussaud",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Saint-Hilaire-la-Plaine",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Saint-Hilaire-le-Château",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Saint-Julien-la-Genête",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Saint-Julien-le-Châtel",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Junien-la-Bregère",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Laurent",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Saint-Léger-Bridereix",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Léger-le-Guérétois",
    "dep": "Creuse"
  },
  {
    "code": "23130",
    "ville": "Saint-Loup",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Maixant",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Marc-à-Frongier",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Saint-Marc-à-Loubaud",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Saint-Marien",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Saint-Martial-le-Mont",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "Saint-Martial-le-Vieux",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Saint-Martin-Château",
    "dep": "Creuse"
  },
  {
    "code": "23430",
    "ville": "Saint-Martin-Sainte-Catherine",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Saint-Maurice-près-Crocq",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Saint-Maurice-la-Souterraine",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Médard-la-Rochette",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "Saint-Merd-la-Breuille",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Saint-Michel-de-Veisse",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Moreil",
    "dep": "Creuse"
  },
  {
    "code": "23100",
    "ville": "Saint-Oradoux-de-Chirouze",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Saint-Oradoux-près-Crocq",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "Saint-Pardoux-d'Arnet",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Pardoux-Morterolles",
    "dep": "Creuse"
  },
  {
    "code": "23200",
    "ville": "Saint-Pardoux-le-Neuf",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Saint-Pardoux-les-Cards",
    "dep": "Creuse"
  },
  {
    "code": "23430",
    "ville": "Saint-Pierre-Chérignat",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Saint-Pierre-Bellevue",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Saint-Pierre-le-Bost",
    "dep": "Creuse"
  },
  {
    "code": "23110",
    "ville": "Saint-Priest",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Saint-Priest-la-Feuille",
    "dep": "Creuse"
  },
  {
    "code": "23240",
    "ville": "Saint-Priest-la-Plaine",
    "dep": "Creuse"
  },
  {
    "code": "23400",
    "ville": "Saint-Priest-Palus",
    "dep": "Creuse"
  },
  {
    "code": "23500",
    "ville": "Saint-Quentin-la-Chabanne",
    "dep": "Creuse"
  },
  {
    "code": "23160",
    "ville": "Saint-Sébastien",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Saint-Silvain-Bas-le-Roc",
    "dep": "Creuse"
  },
  {
    "code": "23190",
    "ville": "Saint-Silvain-Bellegarde",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Saint-Silvain-Montaigut",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Saint-Silvain-sous-Toulx",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Saint-Sulpice-le-Dunois",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Sulpice-le-Guérétois",
    "dep": "Creuse"
  },
  {
    "code": "23480",
    "ville": "Saint-Sulpice-les-Champs",
    "dep": "Creuse"
  },
  {
    "code": "23320",
    "ville": "Saint-Vaury",
    "dep": "Creuse"
  },
  {
    "code": "23000",
    "ville": "Saint-Victor-en-Marche",
    "dep": "Creuse"
  },
  {
    "code": "23460",
    "ville": "Saint-Yrieix-la-Montagne",
    "dep": "Creuse"
  },
  {
    "code": "23150",
    "ville": "Saint-Yrieix-les-Bois",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Tardes",
    "dep": "Creuse"
  },
  {
    "code": "23350",
    "ville": "Tercillat",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Thauron",
    "dep": "Creuse"
  },
  {
    "code": "23600",
    "ville": "Toulx-Sainte-Croix",
    "dep": "Creuse"
  },
  {
    "code": "23230",
    "ville": "Trois-Fonds",
    "dep": "Creuse"
  },
  {
    "code": "23120",
    "ville": "Vallière",
    "dep": "Creuse"
  },
  {
    "code": "23300",
    "ville": "Vareilles",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Verneiges",
    "dep": "Creuse"
  },
  {
    "code": "23250",
    "ville": "Vidaillat",
    "dep": "Creuse"
  },
  {
    "code": "23170",
    "ville": "Viersat",
    "dep": "Creuse"
  },
  {
    "code": "23140",
    "ville": "Vigeville",
    "dep": "Creuse"
  },
  {
    "code": "23800",
    "ville": "Villard",
    "dep": "Creuse"
  },
  {
    "code": "23340",
    "ville": "La Villedieu",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "La Villeneuve",
    "dep": "Creuse"
  },
  {
    "code": "23260",
    "ville": "La Villetelle",
    "dep": "Creuse"
  },
  {
    "code": "24300",
    "ville": "Abjat-sur-Bandiat",
    "dep": "Dordogne"
  },
  {
    "code": "24460",
    "ville": "Agonac",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Ajat",
    "dep": "Dordogne"
  },
  {
    "code": "24480",
    "ville": "Alles-sur-Dordogne",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Allas-les-Mines",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Allemans",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Angoisse",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Anlhiac",
    "dep": "Dordogne"
  },
  {
    "code": "24430",
    "ville": "Annesse-et-Beaulieu",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Antonne-et-Trigonant",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Archignac",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Aubas",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Audrix",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Augignac",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Auriac-du-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Azerat",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "La Bachellerie",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Badefols-d'Ans",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Badefols-sur-Dordogne",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Baneuil",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Bardou",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Bars",
    "dep": "Dordogne"
  },
  {
    "code": "24330",
    "ville": "Bassillac et Auberoche",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Bayac",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Beaumontois en Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Beaupouyet",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Beauregard-de-Terrasson",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Beauregard-et-Bassac",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Beauronne",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Beleymas",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Pays de Belvès",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Berbiguières",
    "dep": "Dordogne"
  },
  {
    "code": "24100",
    "ville": "Bergerac",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Bertric-Burée",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Besse",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Beynac-et-Cazenac",
    "dep": "Dordogne"
  },
  {
    "code": "24310",
    "ville": "Biras",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Biron",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Boisse",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Boisseuilh",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Bonneville-et-Saint-Avit-de-Fumadières",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Borrèze",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Bosset",
    "dep": "Dordogne"
  },
  {
    "code": "24480",
    "ville": "Bouillac",
    "dep": "Dordogne"
  },
  {
    "code": "24750",
    "ville": "Boulazac Isle Manoire",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Bouniagues",
    "dep": "Dordogne"
  },
  {
    "code": "24310",
    "ville": "Bourdeilles",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Le Bourdeix",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Bourg-des-Maisons",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Bourg-du-Bost",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Bourgnac",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Bourniquel",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Bourrou",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Bouteilles-Saint-Sébastien",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Bouzic",
    "dep": "Dordogne"
  },
  {
    "code": "24310",
    "ville": "Brantôme en Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Brouchaud",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Le Bugue",
    "dep": "Dordogne"
  },
  {
    "code": "24480",
    "ville": "Le Buisson-de-Cadouin",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Bussac",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Busserolles",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Bussière-Badil",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Calès",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Calviac-en-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Campagnac-lès-Quercy",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Campagne",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Campsegret",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Capdrot",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Carlux",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Carsac-Aillac",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Carsac-de-Gurson",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Carves",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "La Cassagne",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Castelnaud-la-Chapelle",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Castels et Bézenac",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Cause-de-Clérans",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Celles",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Cénac-et-Saint-Julien",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Chalagnac",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Chalais",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "Champagnac-de-Belair",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Champagne-et-Fontaine",
    "dep": "Dordogne"
  },
  {
    "code": "24750",
    "ville": "Champcevinel",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Champniers-et-Reilhac",
    "dep": "Dordogne"
  },
  {
    "code": "24470",
    "ville": "Champs-Romain",
    "dep": "Dordogne"
  },
  {
    "code": "24650",
    "ville": "Chancelade",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Chantérac",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Chapdeuil",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "La Chapelle-Aubareil",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "La Chapelle-Faucher",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "La Chapelle-Gonaguet",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "La Chapelle-Grésignac",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "La Chapelle-Montabourlet",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "La Chapelle-Montmoreau",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "La Chapelle-Saint-Jean",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Chassaignes",
    "dep": "Dordogne"
  },
  {
    "code": "24460",
    "ville": "Château-l'Évêque",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Châtres",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Les Coteaux Périgourdins",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Cherval",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Cherveix-Cubas",
    "dep": "Dordogne"
  },
  {
    "code": "24640",
    "ville": "Chourgnac",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Cladech",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Clermont-de-Beauregard",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Clermont-d'Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Colombier",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Comberanche-et-Épeluche",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "Condat-sur-Trincou",
    "dep": "Dordogne"
  },
  {
    "code": "24570",
    "ville": "Condat-sur-Vézère",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Connezac",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Conne-de-Labarde",
    "dep": "Dordogne"
  },
  {
    "code": "24450",
    "ville": "La Coquille",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Corgnac-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24750",
    "ville": "Cornille",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Coubjours",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Coulaures",
    "dep": "Dordogne"
  },
  {
    "code": "24660",
    "ville": "Coulounieix-Chamiers",
    "dep": "Dordogne"
  },
  {
    "code": "24430",
    "ville": "Coursac",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Cours-de-Pile",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Coutures",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Coux et Bigaroque-Mouzens",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Couze-et-Saint-Front",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Creyssac",
    "dep": "Dordogne"
  },
  {
    "code": "24100",
    "ville": "Creysse",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Creyssensac-et-Pissot",
    "dep": "Dordogne"
  },
  {
    "code": "24640",
    "ville": "Cubjac-Auvézère-Val d'Ans",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Cunèges",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Daglan",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Doissat",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Domme",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "La Dornac",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Douchapt",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Douville",
    "dep": "Dordogne"
  },
  {
    "code": "24330",
    "ville": "La Douze",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Douzillac",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Dussac",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Échourgnac",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Église-Neuve-de-Vergt",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Église-Neuve-d'Issac",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Escoire",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Étouars",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Eygurande-et-Gardedeuil",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Eymet",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Plaisance",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Eyzerac",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Les Eyzies",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Fanlac",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Les Farges",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Faurilles",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Faux",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "La Feuillade",
    "dep": "Dordogne"
  },
  {
    "code": "24450",
    "ville": "Firbeix",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Le Fleix",
    "dep": "Dordogne"
  },
  {
    "code": "24580",
    "ville": "Fleurac",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Florimont-Gaumier",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Fonroque",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Fossemagne",
    "dep": "Dordogne"
  },
  {
    "code": "33220",
    "ville": "Fougueyrolles",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Fouleix",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Fraisse",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Gabillou",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Gageac-et-Rouillac",
    "dep": "Dordogne"
  },
  {
    "code": "24680",
    "ville": "Gardonne",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Gaugeac",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Génis",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Ginestet",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Gout-Rossignol",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Grand-Brassac",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Granges-d'Ans",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Grignols",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Grives",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Groléjac",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Grun-Bordas",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Hautefaye",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Hautefort",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Issac",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Issigeac",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Jaure",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Javerlhac-et-la-Chapelle-Saint-Robert",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Jayac",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "La Jemaye-Ponteyraud",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Journiac",
    "dep": "Dordogne"
  },
  {
    "code": "24630",
    "ville": "Jumilhac-le-Grand",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Lacropte",
    "dep": "Dordogne"
  },
  {
    "code": "24340",
    "ville": "Rudeau-Ladosse",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "La Force",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Lalinde",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Lamonzie-Montastruc",
    "dep": "Dordogne"
  },
  {
    "code": "24680",
    "ville": "Lamonzie-Saint-Martin",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Lamothe-Montravel",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Lanouaille",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Lanquais",
    "dep": "Dordogne"
  },
  {
    "code": "24570",
    "ville": "Le Lardin-Saint-Lazare",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Larzac",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Lavalade",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Lavaur",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Les Lèches",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Léguillac-de-l'Auche",
    "dep": "Dordogne"
  },
  {
    "code": "24100",
    "ville": "Lembras",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Lempzours",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Limeuil",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Limeyrat",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Liorac-sur-Louyre",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Lisle",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Lolme",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Loubejac",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Lunas",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Lusignac",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Lussas-et-Nontronneau",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Manzac-sur-Vern",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Marcillac-Saint-Quentin",
    "dep": "Dordogne"
  },
  {
    "code": "24340",
    "ville": "Mareuil en Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Marnac",
    "dep": "Dordogne"
  },
  {
    "code": "24620",
    "ville": "Marquay",
    "dep": "Dordogne"
  },
  {
    "code": "24430",
    "ville": "Marsac-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Marsalès",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Eyraud-Crempse-Maurens",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Mauzac-et-Grand-Castang",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Mauzens-et-Miremont",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Mayac",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Mazeyrolles",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Ménesplet",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Mensignac",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Mescoules",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Meyrals",
    "dep": "Dordogne"
  },
  {
    "code": "24450",
    "ville": "Mialet",
    "dep": "Dordogne"
  },
  {
    "code": "24470",
    "ville": "Milhac-de-Nontron",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Minzac",
    "dep": "Dordogne"
  },
  {
    "code": "24480",
    "ville": "Molières",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Monbazillac",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Monestier",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Monfaucon",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Monmadalès",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Monmarvès",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Monpazier",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Monsac",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Monsaguel",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Montagnac-d'Auberoche",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Montagnac-la-Crempse",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Montagrier",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Montaut",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Montazeau",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Montcaret",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Montferrand-du-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Montignac-Lascaux",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Montpeyroux",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Monplaisant",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Montpon-Ménestérol",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Montrem",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Mouleydier",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Moulin-Neuf",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Mussidan",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Nabirat",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Nadaillac",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Nailhac",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Nanteuil-Auriac-de-Bourzac",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Nantheuil",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Nanthiat",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Nastringues",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Naussannes",
    "dep": "Dordogne"
  },
  {
    "code": "24460",
    "ville": "Négrondes",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Neuvic",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Nontron",
    "dep": "Dordogne"
  },
  {
    "code": "24660",
    "ville": "Sanilhac",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Orliac",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Parcoul-Chenaud",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Paulin",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Paunat",
    "dep": "Dordogne"
  },
  {
    "code": "24310",
    "ville": "Paussac-et-Saint-Vivien",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Payzac",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Pazayac",
    "dep": "Dordogne"
  },
  {
    "code": "24000",
    "ville": "Périgueux",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Petit-Bersac",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Peyrignac",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Pechs-de-l'Espérance",
    "dep": "Dordogne"
  },
  {
    "code": "24620",
    "ville": "Peyzac-le-Moustier",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Pezuls",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Piégut-Pluviers",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Le Pizou",
    "dep": "Dordogne"
  },
  {
    "code": "24580",
    "ville": "Plazac",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Pomport",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Pontours",
    "dep": "Dordogne"
  },
  {
    "code": "33220",
    "ville": "Port-Sainte-Foy-et-Ponchapt",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Prats-de-Carlux",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Prats-du-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Pressignac-Vicq",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Preyssac-d'Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Prigonrieux",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Proissans",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Queyssac",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "Quinsac",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Rampieux",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Razac-d'Eymet",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Razac-de-Saussignac",
    "dep": "Dordogne"
  },
  {
    "code": "24430",
    "ville": "Razac-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Ribagnac",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Ribérac",
    "dep": "Dordogne"
  },
  {
    "code": "24340",
    "ville": "La Rochebeaucourt-et-Argentine",
    "dep": "Dordogne"
  },
  {
    "code": "24490",
    "ville": "La Roche-Chalais",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "La Roque-Gageac",
    "dep": "Dordogne"
  },
  {
    "code": "24580",
    "ville": "Rouffignac-Saint-Cernin-de-Reilhac",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Rouffignac-de-Sigoulès",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Sadillac",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Sagelat",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Saint-Agne",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Val de Louyre et Caudeau",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Coly-Saint-Amand",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Saint-Amand-de-Vergt",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Saint-André-d'Allas",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Saint-André-de-Double",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Saint-Antoine-de-Breuilh",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Saint-Aquilin",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Saint-Astier",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Saint-Aubin-de-Cadelech",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Saint-Aubin-de-Lanquais",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Saint-Aubin-de-Nabirat",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Saint Aulaye-Puymangou",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Saint-Avit-de-Vialard",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Saint-Avit-Rivière",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Saint-Avit-Sénieur",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Saint-Barthélemy-de-Bellegarde",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Saint-Barthélemy-de-Bussière",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Saint-Capraise-de-Lalinde",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Saint-Capraise-d'Eymet",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Saint-Cassien",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Saint-Cernin-de-Labarde",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Saint-Cernin-de-l'Herm",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Saint-Chamassy",
    "dep": "Dordogne"
  },
  {
    "code": "24330",
    "ville": "Saint-Crépin-d'Auberoche",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Saint-Crépin-et-Carlucet",
    "dep": "Dordogne"
  },
  {
    "code": "24440",
    "ville": "Sainte-Croix",
    "dep": "Dordogne"
  },
  {
    "code": "24340",
    "ville": "Sainte-Croix-de-Mareuil",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Saint-Cybranet",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Saint-Cyprien",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Saint-Cyr-les-Champagnes",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Saint-Estèphe",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Étienne-de-Puycorbier",
    "dep": "Dordogne"
  },
  {
    "code": "24640",
    "ville": "Sainte-Eulalie-d'Ans",
    "dep": "Dordogne"
  },
  {
    "code": "24340",
    "ville": "Saint-Félix-de-Bourdeilles",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Saint-Félix-de-Reillac-et-Mortemart",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Saint-Félix-de-Villadeix",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Sainte-Foy-de-Belvès",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Sainte-Foy-de-Longas",
    "dep": "Dordogne"
  },
  {
    "code": "24460",
    "ville": "Saint-Front-d'Alemps",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Front-de-Pradoux",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Saint-Front-la-Rivière",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Saint-Front-sur-Nizonne",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Saint-Geniès",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Saint-Georges-Blancaneix",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Saint-Georges-de-Montclard",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Saint-Géraud-de-Corps",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Saint-Germain-de-Belvès",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Germain-des-Prés",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Saint-Germain-du-Salembre",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Saint-Germain-et-Mons",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Géry",
    "dep": "Dordogne"
  },
  {
    "code": "24330",
    "ville": "Saint-Geyrac",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Saint-Hilaire-d'Estissac",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Saint-Julien-Innocence-Eulalie",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Saint-Jean-d'Ataux",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Jean-de-Côle",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Saint-Jean-d'Estissac",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Jory-de-Chalais",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Jory-las-Bloux",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Saint-Julien-de-Lampon",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Saint-Just",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Laurent-des-Hommes",
    "dep": "Dordogne"
  },
  {
    "code": "24100",
    "ville": "Saint-Laurent-des-Vignes",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Saint-Laurent-la-Vallée",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Saint-Léon-d'Issigeac",
    "dep": "Dordogne"
  },
  {
    "code": "24110",
    "ville": "Saint-Léon-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Saint-Léon-sur-Vézère",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Louis-en-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Saint-Marcel-du-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Saint-Marcory",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Martial-d'Albarède",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Saint-Martial-d'Artenset",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Saint-Martial-de-Nabirat",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Saint-Martial-de-Valette",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Saint-Martial-Viveyrol",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Martin-de-Fressengeas",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Saint-Martin-de-Gurson",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Saint-Martin-de-Ribérac",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Saint-Martin-des-Combes",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Martin-l'Astier",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Saint-Martin-le-Pin",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Saint-Mayme-de-Péreyrol",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Saint-Méard-de-Drône",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Saint-Méard-de-Gurçon",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Médard-de-Mussidan",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Médard-d'Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Saint-Mesmin",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Saint-Michel-de-Double",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Saint-Michel-de-Montaigne",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Saint-Michel-de-Villadeix",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Sainte-Mondane",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Sainte-Nathalène",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Saint-Nexans",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Sainte-Orse",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "Saint-Pancrace",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Pantaly-d'Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Saint-Pardoux-de-Drône",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Saint-Pardoux-et-Vielvic",
    "dep": "Dordogne"
  },
  {
    "code": "24470",
    "ville": "Saint-Pardoux-la-Rivière",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Saint-Paul-de-Serre",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Paul-la-Roche",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Saint-Paul-Lizonne",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Saint-Perdoux",
    "dep": "Dordogne"
  },
  {
    "code": "24330",
    "ville": "Saint-Pierre-de-Chignac",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Pierre-de-Côle",
    "dep": "Dordogne"
  },
  {
    "code": "24450",
    "ville": "Saint-Pierre-de-Frugie",
    "dep": "Dordogne"
  },
  {
    "code": "24130",
    "ville": "Saint-Pierre-d'Eyraud",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Saint-Pompon",
    "dep": "Dordogne"
  },
  {
    "code": "24450",
    "ville": "Saint-Priest-les-Fougères",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Saint Privat en Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Saint-Rabier",
    "dep": "Dordogne"
  },
  {
    "code": "24560",
    "ville": "Sainte-Radegonde",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Saint-Raphaël",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Saint-Rémy",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Saint-Romain-de-Monpazier",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Romain-et-Saint-Clément",
    "dep": "Dordogne"
  },
  {
    "code": "24470",
    "ville": "Saint-Saud-Lacoussière",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Saint-Sauveur",
    "dep": "Dordogne"
  },
  {
    "code": "24700",
    "ville": "Saint-Sauveur-Lalande",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Saint-Seurin-de-Prats",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Saint-Séverin-d'Estissac",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Saint-Sulpice-de-Roumagnac",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Saint-Sulpice-d'Excideuil",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Sainte-Trie",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Saint-Victor",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Saint-Vincent-de-Connezac",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Saint-Vincent-de-Cosse",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Saint-Vincent-Jalmoutiers",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Saint-Vincent-le-Paluel",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Saint-Vincent-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Saint-Vivien",
    "dep": "Dordogne"
  },
  {
    "code": "24160",
    "ville": "Salagnac",
    "dep": "Dordogne"
  },
  {
    "code": "24590",
    "ville": "Salignac-Eyvigues",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Salles-de-Belvès",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Salon",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Sarlande",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Sarlat-la-Canéda",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Sarliac-sur-l'Isle",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Sarrazac",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Saussignac",
    "dep": "Dordogne"
  },
  {
    "code": "24260",
    "ville": "Savignac-de-Miremont",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Savignac-de-Nontron",
    "dep": "Dordogne"
  },
  {
    "code": "24270",
    "ville": "Savignac-Lédrier",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Savignac-les-Églises",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Sceau-Saint-Angel",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Segonzac",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Sergeac",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Serres-et-Montguyard",
    "dep": "Dordogne"
  },
  {
    "code": "24410",
    "ville": "Servanches",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Sigoulès-et-Flaugeac",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Simeyrols",
    "dep": "Dordogne"
  },
  {
    "code": "24500",
    "ville": "Singleyrac",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Siorac-de-Ribérac",
    "dep": "Dordogne"
  },
  {
    "code": "24170",
    "ville": "Siorac-en-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24420",
    "ville": "Sorges et Ligueux en Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Soudat",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Soulaures",
    "dep": "Dordogne"
  },
  {
    "code": "24400",
    "ville": "Sourzac",
    "dep": "Dordogne"
  },
  {
    "code": "24620",
    "ville": "Tamniès",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Teillots",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Temple-Laguyon",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Terrasson-Lavilledieu",
    "dep": "Dordogne"
  },
  {
    "code": "24300",
    "ville": "Teyjat",
    "dep": "Dordogne"
  },
  {
    "code": "24240",
    "ville": "Thénac",
    "dep": "Dordogne"
  },
  {
    "code": "24210",
    "ville": "Thenon",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Thiviers",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Thonac",
    "dep": "Dordogne"
  },
  {
    "code": "24350",
    "ville": "Tocane-Saint-Apre",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "La Tour-Blanche-Cercles",
    "dep": "Dordogne"
  },
  {
    "code": "24390",
    "ville": "Tourtoirac",
    "dep": "Dordogne"
  },
  {
    "code": "24750",
    "ville": "Trélissac",
    "dep": "Dordogne"
  },
  {
    "code": "24510",
    "ville": "Trémolat",
    "dep": "Dordogne"
  },
  {
    "code": "24620",
    "ville": "Tursac",
    "dep": "Dordogne"
  },
  {
    "code": "24480",
    "ville": "Urval",
    "dep": "Dordogne"
  },
  {
    "code": "24190",
    "ville": "Vallereuil",
    "dep": "Dordogne"
  },
  {
    "code": "24290",
    "ville": "Valojoulx",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Vanxains",
    "dep": "Dordogne"
  },
  {
    "code": "24360",
    "ville": "Varaignes",
    "dep": "Dordogne"
  },
  {
    "code": "24150",
    "ville": "Varennes",
    "dep": "Dordogne"
  },
  {
    "code": "24800",
    "ville": "Vaunac",
    "dep": "Dordogne"
  },
  {
    "code": "24230",
    "ville": "Vélines",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Vendoire",
    "dep": "Dordogne"
  },
  {
    "code": "24520",
    "ville": "Verdon",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Vergt",
    "dep": "Dordogne"
  },
  {
    "code": "24540",
    "ville": "Vergt-de-Biron",
    "dep": "Dordogne"
  },
  {
    "code": "24320",
    "ville": "Verteillac",
    "dep": "Dordogne"
  },
  {
    "code": "24370",
    "ville": "Veyrignac",
    "dep": "Dordogne"
  },
  {
    "code": "24250",
    "ville": "Veyrines-de-Domme",
    "dep": "Dordogne"
  },
  {
    "code": "24380",
    "ville": "Veyrines-de-Vergt",
    "dep": "Dordogne"
  },
  {
    "code": "24220",
    "ville": "Vézac",
    "dep": "Dordogne"
  },
  {
    "code": "24120",
    "ville": "Villac",
    "dep": "Dordogne"
  },
  {
    "code": "24140",
    "ville": "Villamblard",
    "dep": "Dordogne"
  },
  {
    "code": "24530",
    "ville": "Villars",
    "dep": "Dordogne"
  },
  {
    "code": "24610",
    "ville": "Villefranche-de-Lonchat",
    "dep": "Dordogne"
  },
  {
    "code": "24550",
    "ville": "Villefranche-du-Périgord",
    "dep": "Dordogne"
  },
  {
    "code": "24600",
    "ville": "Villetoureix",
    "dep": "Dordogne"
  },
  {
    "code": "24200",
    "ville": "Vitrac",
    "dep": "Dordogne"
  },
  {
    "code": "25320",
    "ville": "Abbans-Dessous",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Abbans-Dessus",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Abbenans",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Abbévillers",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Accolans",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Adam-lès-Passavant",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Adam-lès-Vercel",
    "dep": "Doubs"
  },
  {
    "code": "25750",
    "ville": "Aibre",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Aïssey",
    "dep": "Doubs"
  },
  {
    "code": "25490",
    "ville": "Allenjoie",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Les Alliés",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Allondans",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Amagney",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Amancey",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Amathay-Vésigneux",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Amondans",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Anteuil",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Appenans",
    "dep": "Doubs"
  },
  {
    "code": "25400",
    "ville": "Arbouans",
    "dep": "Doubs"
  },
  {
    "code": "25610",
    "ville": "Arc-et-Senans",
    "dep": "Doubs"
  },
  {
    "code": "25750",
    "ville": "Arcey",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Arçon",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Arc-sous-Cicon",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Arc-sous-Montenot",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Aubonne",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Audeux",
    "dep": "Doubs"
  },
  {
    "code": "25400",
    "ville": "Audincourt",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Autechaux",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Autechaux-Roide",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Les Auxons",
    "dep": "Doubs"
  },
  {
    "code": "25720",
    "ville": "Avanne-Aveney",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Avilley",
    "dep": "Doubs"
  },
  {
    "code": "25690",
    "ville": "Avoudrey",
    "dep": "Doubs"
  },
  {
    "code": "25490",
    "ville": "Badevel",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Bannans",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Le Barboux",
    "dep": "Doubs"
  },
  {
    "code": "25420",
    "ville": "Bart",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Bartherans",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Battenans-les-Mines",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Battenans-Varin",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Baume-les-Dames",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Bavans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Belfays",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Le Bélieu",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Belleherbe",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Belmont",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Belvoir",
    "dep": "Doubs"
  },
  {
    "code": "25420",
    "ville": "Berche",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Berthelange",
    "dep": "Doubs"
  },
  {
    "code": "25000",
    "ville": "Besançon",
    "dep": "Doubs"
  },
  {
    "code": "25200",
    "ville": "Bethoncourt",
    "dep": "Doubs"
  },
  {
    "code": "25720",
    "ville": "Beure",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Beutal",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Val-d'Usiers",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Bief",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Le Bizot",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Blamont",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Blarians",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Blussangeaux",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Blussans",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Bolandoz",
    "dep": "Doubs"
  },
  {
    "code": "25230",
    "ville": "Bondeval",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Bonnal",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Bonnay",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Bonnétage",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Bonnevaux",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "La Bosse",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Bouclans",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Boujailles",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Bourguignon",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Bournois",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Boussières",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Bouverans",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Braillans",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Branne",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Breconchaux",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Bremondans",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Brères",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Les Bréseux",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "La Bretenière",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Bretigney",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Bretigney-Notre-Dame",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Bretonvillers",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Brey-et-Maison-du-Bois",
    "dep": "Doubs"
  },
  {
    "code": "25600",
    "ville": "Brognard",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Buffard",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Bugny",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Bulle",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Burgille",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Burnevillers",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Busy",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "By",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Byans-sur-Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Cademène",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Cendrey",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Cernay-l'Église",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Cessey",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Chaffois",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Chalèze",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Chalezeule",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Chamesey",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Chamesol",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Champagney",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Champlive",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Champoux",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Champvans-les-Moulins",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Chantrans",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Chapelle-des-Bois",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Chapelle-d'Huin",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Charmauvillers",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Charmoille",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Charnay",
    "dep": "Doubs"
  },
  {
    "code": "25140",
    "ville": "Charquemont",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Chassagne-Saint-Denis",
    "dep": "Doubs"
  },
  {
    "code": "25840",
    "ville": "Châteauvieux-les-Fossés",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Châtelblanc",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Châtillon-Guyotte",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Châtillon-le-Duc",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Chaucenne",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Les Terres-de-Chaux",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "La Chaux",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Chaux-lès-Passavant",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Chaux-Neuve",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Chay",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Chazot",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Chemaudin et Vaux",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "La Chenalotte",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Chenecey-Buillon",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Chevigney-sur-l'Ognon",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Chevigney-lès-Vercel",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "La Chevillotte",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Chevroz",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Chouzelot",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Cléron",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Pays-de-Clerval",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "La Cluse-et-Mijoux",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Colombier-Fontaine",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Les Combes",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Consolation-Maisonnettes",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Corcelles-Ferrières",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Corcelle-Mieslot",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Corcondray",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Côtebrune",
    "dep": "Doubs"
  },
  {
    "code": "25420",
    "ville": "Courcelles-lès-Montbéliard",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Courcelles",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Courchapon",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Cour-Saint-Maurice",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Courtefontaine",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Courtetain-et-Salans",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Courvières",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Crosey-le-Grand",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Crosey-le-Petit",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Le Crouzet",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Crouzet-Migette",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Cubrial",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Cubry",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Cusance",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Cuse-et-Adrisans",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Cussey-sur-Lison",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Cussey-sur-l'Ognon",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Dambelin",
    "dep": "Doubs"
  },
  {
    "code": "25600",
    "ville": "Dambenois",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Dammartin-les-Templiers",
    "dep": "Doubs"
  },
  {
    "code": "25490",
    "ville": "Dampierre-les-Bois",
    "dep": "Doubs"
  },
  {
    "code": "25420",
    "ville": "Dampierre-sur-le-Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Dampjoux",
    "dep": "Doubs"
  },
  {
    "code": "25450",
    "ville": "Damprichard",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Dannemarie",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Dannemarie-sur-Crète",
    "dep": "Doubs"
  },
  {
    "code": "25230",
    "ville": "Dasle",
    "dep": "Doubs"
  },
  {
    "code": "25960",
    "ville": "Deluz",
    "dep": "Doubs"
  },
  {
    "code": "25750",
    "ville": "Désandans",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Déservillers",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Devecey",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Dommartin",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Dompierre-les-Tilleuls",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Domprel",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Dung",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Durnes",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Échay",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Échenans",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Échevannes",
    "dep": "Doubs"
  },
  {
    "code": "25480",
    "ville": "École-Valentin",
    "dep": "Doubs"
  },
  {
    "code": "25140",
    "ville": "Les Écorces",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Écot",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "L'Écouvotte",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Écurcey",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Émagny",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Épenouse",
    "dep": "Doubs"
  },
  {
    "code": "25800",
    "ville": "Épenoy",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Épeugney",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Esnans",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Étalans",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Éternoz",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Étouvans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Étrabonne",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Étrappe",
    "dep": "Doubs"
  },
  {
    "code": "25800",
    "ville": "Étray",
    "dep": "Doubs"
  },
  {
    "code": "25460",
    "ville": "Étupes",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Évillers",
    "dep": "Doubs"
  },
  {
    "code": "25400",
    "ville": "Exincourt",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Eysson",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Faimbe",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Fallerans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Ferrières-le-Lac",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Ferrières-les-Bois",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Fertans",
    "dep": "Doubs"
  },
  {
    "code": "25490",
    "ville": "Fesches-le-Châtel",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Fessevillers",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Feule",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Les Fins",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Flagey",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Flagey-Rigney",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Flangebouche",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Fleurey",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Fontain",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Fontaine-lès-Clerval",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Fontenelle-Montby",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Les Fontenelles",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Fontenotte",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Fourbanne",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Fourcatier-et-Maison-Neuve",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Fourg",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Les Fourgs",
    "dep": "Doubs"
  },
  {
    "code": "25140",
    "ville": "Fournet-Blancheroche",
    "dep": "Doubs"
  },
  {
    "code": "25140",
    "ville": "Frambouhans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Franey",
    "dep": "Doubs"
  },
  {
    "code": "25770",
    "ville": "Franois",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "Frasne",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Froidevaux",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Fuans",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Gellin",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Gémonval",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Geneuille",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Geney",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Gennes",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Germéfontaine",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Germondans",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Gevresin",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Gilley",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Glamondans",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Glay",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Glère",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Gondenans-Montby",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Gondenans-les-Moulins",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Gonsans",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Gouhelans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Goumois",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Goux-lès-Dambelin",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Goux-sous-Landet",
    "dep": "Doubs"
  },
  {
    "code": "25200",
    "ville": "Grand-Charmont",
    "dep": "Doubs"
  },
  {
    "code": "25570",
    "ville": "Grand'Combe-Châteleu",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Grand'Combe-des-Bois",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Grandfontaine",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Fournets-Luisans",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Grandfontaine-sur-Creuse",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "La Grange",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Granges-Narboz",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Les Grangettes",
    "dep": "Doubs"
  },
  {
    "code": "25790",
    "ville": "Les Gras",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Le Gratteris",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Grosbois",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Guillon-les-Bains",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Guyans-Durnes",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Guyans-Vennes",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Hauterive-la-Fresse",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Hérimoncourt",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "L'Hôpital-du-Grosbois",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "L'Hôpital-Saint-Lieffroy",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Les Hôpitaux-Neufs",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Les Hôpitaux-Vieux",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Houtaud",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Huanne-Montmartin",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Hyémondans",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Hyèvre-Magny",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Hyèvre-Paroisse",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Indevillers",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "L'Isle-sur-le-Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Issans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Jallerange",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Jougne",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Labergement-Sainte-Marie",
    "dep": "Doubs"
  },
  {
    "code": "25130",
    "ville": "Villers-le-Lac",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Laire",
    "dep": "Doubs"
  },
  {
    "code": "25820",
    "ville": "Laissey",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Lanans",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Landresse",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Lantenne-Vertière",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Lanthenans",
    "dep": "Doubs"
  },
  {
    "code": "25720",
    "ville": "Larnod",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Laval-le-Prieuré",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Lavans-Quingey",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Lavans-Vuillafans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Lavernay",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Laviron",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Levier",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Liebvillers",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Liesle",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Lizine",
    "dep": "Doubs"
  },
  {
    "code": "25930",
    "ville": "Lods",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Lombard",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Lomont-sur-Crête",
    "dep": "Doubs"
  },
  {
    "code": "25690",
    "ville": "Longechaux",
    "dep": "Doubs"
  },
  {
    "code": "25690",
    "ville": "Longemaison",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Longevelle-lès-Russey",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Longevelle-sur-Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Longeville",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "La Longeville",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Longevilles-Mont-d'Or",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Loray",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Lougres",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Le Luhier",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Luxiol",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Magny-Châtelard",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Maîche",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Maisons-du-Bois-Lièvremont",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Malans",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Malbrans",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Malbuisson",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Malpas",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Mamirolle",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Mancenans",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Mancenans-Lizerne",
    "dep": "Doubs"
  },
  {
    "code": "25350",
    "ville": "Mandeure",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Marchaux-Chaudefontaine",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Marvelise",
    "dep": "Doubs"
  },
  {
    "code": "25700",
    "ville": "Mathay",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Mazerolles-le-Salin",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Médière",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Le Mémont",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Mercey-le-Grand",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Les Monts-Ronds",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Mérey-Vieilley",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Mésandans",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Meslières",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Mesmay",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Métabief",
    "dep": "Doubs"
  },
  {
    "code": "25480",
    "ville": "Miserey-Salines",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Moncey",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Moncley",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Mondon",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Montagney-Servigney",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Montancy",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Montandon",
    "dep": "Doubs"
  },
  {
    "code": "25200",
    "ville": "Montbéliard",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Montbéliardot",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Montbenoît",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Mont-de-Laval",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Mont-de-Vougney",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Montécheroux",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Montenois",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Montfaucon",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Montferrand-le-Château",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Montflovin",
    "dep": "Doubs"
  },
  {
    "code": "25111",
    "ville": "Montgesoye",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Montivernage",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Montjoie-le-Château",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Montlebon",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Montmahoux",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Montperreux",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Montrond-le-Château",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Montussaint",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Morre",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Morteau",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Mouthe",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Le Moutherot",
    "dep": "Doubs"
  },
  {
    "code": "25920",
    "ville": "Mouthier-Haute-Pierre",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Myon",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Naisey-les-Granges",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Nancray",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Nans",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Nans-sous-Sainte-Anne",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Narbief",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Neuchâtel-Urtière",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Les Premiers Sapins",
    "dep": "Doubs"
  },
  {
    "code": "25500",
    "ville": "Noël-Cerneux",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Noirefontaine",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Noironte",
    "dep": "Doubs"
  },
  {
    "code": "25600",
    "ville": "Nommay",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Novillars",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Ollans",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Onans",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Orchamps-Vennes",
    "dep": "Doubs"
  },
  {
    "code": "25120",
    "ville": "Orgeans-Blanchefontaine",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Ornans",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Orsans",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Orve",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Osse",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Osselle-Routelle",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Ougney-Douvot",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Ouhans",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Ouvans",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Oye-et-Pallet",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Palantine",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Palise",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Paroy",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Passavant",
    "dep": "Doubs"
  },
  {
    "code": "25690",
    "ville": "Passonfontaine",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Pelousey",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Péseux",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Pessans",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Petite-Chaux",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Pierrefontaine-lès-Blamont",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Pierrefontaine-les-Varans",
    "dep": "Doubs"
  },
  {
    "code": "25480",
    "ville": "Pirey",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Placey",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Plaimbois-du-Miroir",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Plaimbois-Vennes",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Les Plains-et-Grands-Essarts",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "La Planée",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Le Val",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Pompierre-sur-Doubs",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Pontarlier",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Pont-de-Roide-Vermondans",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Les Pontets",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Pont-les-Moulins",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Pouilley-Français",
    "dep": "Doubs"
  },
  {
    "code": "25115",
    "ville": "Pouilley-les-Vignes",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Pouligney-Lusans",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Présentevillers",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "La Prétière",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Provenchère",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Puessans",
    "dep": "Doubs"
  },
  {
    "code": "25720",
    "ville": "Pugey",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Le Puy",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Quingey",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Rahon",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Rancenay",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Randevillers",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Rang",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Raynans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Recologne",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Reculfoz",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Rémondans-Vaivre",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Remoray-Boujeons",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Renédale",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Rennes-sur-Loue",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Reugney",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Rigney",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Rignosot",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Rillans",
    "dep": "Doubs"
  },
  {
    "code": "25560",
    "ville": "La Rivière-Drugeon",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Rochejean",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Roche-lez-Beaupré",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Roche-lès-Clerval",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Roches-lès-Blamont",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Rognon",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Romain",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Ronchaux",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Rondefontaine",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Roset-Fluans",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Rosières-sur-Barbèche",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Rosureux",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Rougemont",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Rougemontot",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Rouhe",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Roulans",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Ruffey-le-Château",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Rurey",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Le Russey",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Sainte-Anne",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Saint-Antoine",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Sainte-Colombe",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Saint-Georges-Armont",
    "dep": "Doubs"
  },
  {
    "code": "25520",
    "ville": "Saint-Gorgon-Main",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Saint-Hilaire",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Saint-Hippolyte",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Saint-Juan",
    "dep": "Doubs"
  },
  {
    "code": "25550",
    "ville": "Saint-Julien-lès-Montbéliard",
    "dep": "Doubs"
  },
  {
    "code": "25210",
    "ville": "Saint-Julien-lès-Russey",
    "dep": "Doubs"
  },
  {
    "code": "25113",
    "ville": "Sainte-Marie",
    "dep": "Doubs"
  },
  {
    "code": "25260",
    "ville": "Saint-Maurice-Colombier",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Saint-Point-Lac",
    "dep": "Doubs"
  },
  {
    "code": "25630",
    "ville": "Sainte-Suzanne",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Saint-Vit",
    "dep": "Doubs"
  },
  {
    "code": "25440",
    "ville": "Samson",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Sancey",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "Saône",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Saraz",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Sarrageois",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Saules",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Sauvagney",
    "dep": "Doubs"
  },
  {
    "code": "25290",
    "ville": "Scey-Maisières",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Séchin",
    "dep": "Doubs"
  },
  {
    "code": "25230",
    "ville": "Seloncourt",
    "dep": "Doubs"
  },
  {
    "code": "25750",
    "ville": "Semondans",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Septfontaines",
    "dep": "Doubs"
  },
  {
    "code": "25770",
    "ville": "Serre-les-Sapins",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Servin",
    "dep": "Doubs"
  },
  {
    "code": "25330",
    "ville": "Silley-Amancey",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Silley-Bléfond",
    "dep": "Doubs"
  },
  {
    "code": "25600",
    "ville": "Sochaux",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Solemont",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "La Sommette",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Soulce-Cernay",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Sourans",
    "dep": "Doubs"
  },
  {
    "code": "25250",
    "ville": "Soye",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Surmont",
    "dep": "Doubs"
  },
  {
    "code": "25400",
    "ville": "Taillecourt",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Tallans",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Tallenay",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Tarcenay-Foucherans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Thiébouhans",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Thise",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Thoraise",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Thulay",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Thurey-le-Mont",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Torpes",
    "dep": "Doubs"
  },
  {
    "code": "25370",
    "ville": "Touillon-et-Loutelet",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "La Tour-de-Sçay",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Tournans",
    "dep": "Doubs"
  },
  {
    "code": "25620",
    "ville": "Trépot",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Tressandans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Trévillers",
    "dep": "Doubs"
  },
  {
    "code": "25680",
    "ville": "Trouvans",
    "dep": "Doubs"
  },
  {
    "code": "25470",
    "ville": "Urtière",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Uzelle",
    "dep": "Doubs"
  },
  {
    "code": "25220",
    "ville": "Vaire",
    "dep": "Doubs"
  },
  {
    "code": "25800",
    "ville": "Valdahon",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Val-de-Roulans",
    "dep": "Doubs"
  },
  {
    "code": "25700",
    "ville": "Valentigney",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Valleroy",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Valonne",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Valoreille",
    "dep": "Doubs"
  },
  {
    "code": "25230",
    "ville": "Vandoncourt",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Vaucluse",
    "dep": "Doubs"
  },
  {
    "code": "25380",
    "ville": "Vauclusotte",
    "dep": "Doubs"
  },
  {
    "code": "25360",
    "ville": "Vaudrivillers",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Vaufrey",
    "dep": "Doubs"
  },
  {
    "code": "25160",
    "ville": "Vaux-et-Chantegrue",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Velesmes-Essarts",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Vellerot-lès-Belvoir",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Vellerot-lès-Vercel",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Vellevans",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Venise",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Vennans",
    "dep": "Doubs"
  },
  {
    "code": "25390",
    "ville": "Vennes",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Vercel-Villedieu-le-Camp",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Vergranne",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Verne",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Vernierfontaine",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Vernois-lès-Belvoir",
    "dep": "Doubs"
  },
  {
    "code": "25750",
    "ville": "Le Vernoy",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Verrières-de-Joux",
    "dep": "Doubs"
  },
  {
    "code": "25660",
    "ville": "La Vèze",
    "dep": "Doubs"
  },
  {
    "code": "25870",
    "ville": "Vieilley",
    "dep": "Doubs"
  },
  {
    "code": "25340",
    "ville": "Viéthorey",
    "dep": "Doubs"
  },
  {
    "code": "25600",
    "ville": "Vieux-Charmont",
    "dep": "Doubs"
  },
  {
    "code": "25310",
    "ville": "Villars-lès-Blamont",
    "dep": "Doubs"
  },
  {
    "code": "25410",
    "ville": "Villars-Saint-Georges",
    "dep": "Doubs"
  },
  {
    "code": "25190",
    "ville": "Villars-sous-Dampjoux",
    "dep": "Doubs"
  },
  {
    "code": "25150",
    "ville": "Villars-sous-Écot",
    "dep": "Doubs"
  },
  {
    "code": "25240",
    "ville": "Les Villedieu",
    "dep": "Doubs"
  },
  {
    "code": "25650",
    "ville": "Ville-du-Pont",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Villeneuve-d'Amont",
    "dep": "Doubs"
  },
  {
    "code": "25170",
    "ville": "Villers-Buzon",
    "dep": "Doubs"
  },
  {
    "code": "25530",
    "ville": "Villers-Chief",
    "dep": "Doubs"
  },
  {
    "code": "25640",
    "ville": "Villers-Grélot",
    "dep": "Doubs"
  },
  {
    "code": "25510",
    "ville": "Villers-la-Combe",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Villers-Saint-Martin",
    "dep": "Doubs"
  },
  {
    "code": "25270",
    "ville": "Villers-sous-Chalamont",
    "dep": "Doubs"
  },
  {
    "code": "25110",
    "ville": "Voillans",
    "dep": "Doubs"
  },
  {
    "code": "25580",
    "ville": "Voires",
    "dep": "Doubs"
  },
  {
    "code": "25320",
    "ville": "Vorges-les-Pins",
    "dep": "Doubs"
  },
  {
    "code": "25420",
    "ville": "Voujeaucourt",
    "dep": "Doubs"
  },
  {
    "code": "25840",
    "ville": "Vuillafans",
    "dep": "Doubs"
  },
  {
    "code": "25300",
    "ville": "Vuillecin",
    "dep": "Doubs"
  },
  {
    "code": "25430",
    "ville": "Vyt-lès-Belvoir",
    "dep": "Doubs"
  },
  {
    "code": "26150",
    "ville": "Solaure en Diois",
    "dep": "Drôme"
  },
  {
    "code": "26140",
    "ville": "Albon",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Aleyrac",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Alixan",
    "dep": "Drôme"
  },
  {
    "code": "26780",
    "ville": "Allan",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Allex",
    "dep": "Drôme"
  },
  {
    "code": "26800",
    "ville": "Ambonil",
    "dep": "Drôme"
  },
  {
    "code": "26200",
    "ville": "Ancône",
    "dep": "Drôme"
  },
  {
    "code": "26140",
    "ville": "Andancette",
    "dep": "Drôme"
  },
  {
    "code": "26140",
    "ville": "Anneyron",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Aouste-sur-Sye",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Arnayon",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Arpavon",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Arthémonay",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Aubenasson",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Aubres",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Aucelon",
    "dep": "Drôme"
  },
  {
    "code": "26570",
    "ville": "Aulan",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Aurel",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "La Répara-Auriples",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Autichamp",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Ballons",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Barbières",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Barcelonne",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Barnave",
    "dep": "Drôme"
  },
  {
    "code": "26570",
    "ville": "Barret-de-Lioure",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Barsac",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Bathernay",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "La Bâtie-des-Fonds",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "La Bâtie-Rolland",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "La Baume-Cornillane",
    "dep": "Drôme"
  },
  {
    "code": "26790",
    "ville": "La Baume-de-Transit",
    "dep": "Drôme"
  },
  {
    "code": "26730",
    "ville": "La Baume-d'Hostun",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Beaufort-sur-Gervanne",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Beaumont-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26760",
    "ville": "Beaumont-lès-Valence",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Beaumont-Monteux",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Beauregard-Baret",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Beaurières",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Beausemblant",
    "dep": "Drôme"
  },
  {
    "code": "26800",
    "ville": "Beauvallon",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Beauvoisin",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "La Bégude-de-Mazenc",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Bellecombe-Tarendol",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Bellegarde-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Bénivay-Ollon",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Bésayes",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Bésignan",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Bézaudun-sur-Bîne",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Bonlieu-sur-Roubion",
    "dep": "Drôme"
  },
  {
    "code": "26790",
    "ville": "Bouchet",
    "dep": "Drôme"
  },
  {
    "code": "26410",
    "ville": "Boulc",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Bourdeaux",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Bourg-de-Péage",
    "dep": "Drôme"
  },
  {
    "code": "26500",
    "ville": "Bourg-lès-Valence",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Bouvante",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Bouvières",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Bren",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Brette",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Buis-les-Baronnies",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Chabeuil",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Chabrillan",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Le Chaffal",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Chalancon",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Le Chalon",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Chamaloc",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Chamaret",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Chanos-Curson",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Chantemerle-les-Blés",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Chantemerle-lès-Grignan",
    "dep": "Drôme"
  },
  {
    "code": "26420",
    "ville": "La Chapelle-en-Vercors",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "La Charce",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Charens",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Charmes-sur-l'Herbasse",
    "dep": "Drôme"
  },
  {
    "code": "26450",
    "ville": "Charols",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Charpey",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Chastel-Arnaud",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Châteaudouble",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Châteauneuf-de-Bordette",
    "dep": "Drôme"
  },
  {
    "code": "26330",
    "ville": "Châteauneuf-de-Galaure",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Châteauneuf-sur-Isère",
    "dep": "Drôme"
  },
  {
    "code": "26780",
    "ville": "Châteauneuf-du-Rhône",
    "dep": "Drôme"
  },
  {
    "code": "26410",
    "ville": "Châtillon-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Châtillon-Saint-Jean",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Chatuzange-le-Goubet",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Chaudebonne",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "La Chaudière",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Chauvac-Laux-Montaux",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Chavannes",
    "dep": "Drôme"
  },
  {
    "code": "26130",
    "ville": "Clansayes",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Claveyson",
    "dep": "Drôme"
  },
  {
    "code": "26450",
    "ville": "Cléon-d'Andran",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Clérieux",
    "dep": "Drôme"
  },
  {
    "code": "26270",
    "ville": "Cliousclat",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Cobonne",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Colonzelle",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Combovin",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Comps",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Condillac",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Condorcet",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Cornillac",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Cornillon-sur-l'Oule",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "La Coucourde",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Crépol",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Crest",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Crozes-Hermitage",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Crupies",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Curnier",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Die",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Dieulefit",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Divajeu",
    "dep": "Drôme"
  },
  {
    "code": "26290",
    "ville": "Donzère",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Échevis",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Épinouze",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Érôme",
    "dep": "Drôme"
  },
  {
    "code": "26780",
    "ville": "Espeluche",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Espenel",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Establet",
    "dep": "Drôme"
  },
  {
    "code": "26800",
    "ville": "Étoile-sur-Rhône",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Eurre",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Eygalayes",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Eygaliers",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Eygluy-Escoulin",
    "dep": "Drôme"
  },
  {
    "code": "26730",
    "ville": "Eymeux",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Eyroles",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Eyzahut",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Fay-le-Clos",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Félines-sur-Rimandoule",
    "dep": "Drôme"
  },
  {
    "code": "26570",
    "ville": "Ferrassières",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Val-Maravel",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Francillon-sur-Roubion",
    "dep": "Drôme"
  },
  {
    "code": "26700",
    "ville": "La Garde-Adhémar",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Génissieux",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Geyssans",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Gigors-et-Lozeron",
    "dep": "Drôme"
  },
  {
    "code": "26410",
    "ville": "Glandage",
    "dep": "Drôme"
  },
  {
    "code": "26530",
    "ville": "Le Grand-Serre",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Grane",
    "dep": "Drôme"
  },
  {
    "code": "26290",
    "ville": "Les Granges-Gontardes",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Grignan",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Gumiane",
    "dep": "Drôme"
  },
  {
    "code": "26390",
    "ville": "Hauterives",
    "dep": "Drôme"
  },
  {
    "code": "26730",
    "ville": "Hostun",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Izon-la-Bruisse",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Jonchères",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Laborel",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Lachau",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Lapeyrouse-Mornay",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Larnage",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "La Laupie",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Laval-d'Aix",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Laveyron",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Lemps",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Lens-Lestang",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Léoncel",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Lesches-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26250",
    "ville": "Livron-sur-Drôme",
    "dep": "Drôme"
  },
  {
    "code": "26270",
    "ville": "Loriol-sur-Drôme",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Luc-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26620",
    "ville": "Lus-la-Croix-Haute",
    "dep": "Drôme"
  },
  {
    "code": "26780",
    "ville": "Malataverne",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Malissard",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Manas",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Manthes",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Marches",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Margès",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Marignac-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Marsanne",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Marsaz",
    "dep": "Drôme"
  },
  {
    "code": "26410",
    "ville": "Menglon",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Mercurol-Veaunes",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Mérindol-les-Oliviers",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Mévouillon",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Mirabel-aux-Baronnies",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Mirabel-et-Blacons",
    "dep": "Drôme"
  },
  {
    "code": "26270",
    "ville": "Mirmande",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Miscon",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Mollans-sur-Ouvèze",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Montauban-sur-l'Ouvèze",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Montaulieu",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Montboucher-sur-Jabron",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Montbrison-sur-Lez",
    "dep": "Drôme"
  },
  {
    "code": "26570",
    "ville": "Montbrun-les-Bains",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Montchenu",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Montclar-sur-Gervanne",
    "dep": "Drôme"
  },
  {
    "code": "26760",
    "ville": "Montéléger",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Montélier",
    "dep": "Drôme"
  },
  {
    "code": "26200",
    "ville": "Montélimar",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Montferrand-la-Fare",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Montfroc",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Montguers",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Montjoux",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Montjoyer",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Montlaur-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Montmaur-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Montmeyran",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Montmiral",
    "dep": "Drôme"
  },
  {
    "code": "26800",
    "ville": "Montoison",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Montréal-les-Sources",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Valherbasse",
    "dep": "Drôme"
  },
  {
    "code": "26130",
    "ville": "Montségur-sur-Lauzon",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Montvendre",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Moras-en-Valloire",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Mornans",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "La Motte-Chalancon",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Saint-Jean-de-Galaure",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "La Motte-Fanjas",
    "dep": "Drôme"
  },
  {
    "code": "26540",
    "ville": "Mours-Saint-Eusèbe",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Nyons",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Omblèze",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Orcinas",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Oriol-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Ourches",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Parnans",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Le Pègue",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Pelonne",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Pennes-le-Sec",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "La Penne-sur-l'Ouvèze",
    "dep": "Drôme"
  },
  {
    "code": "26380",
    "ville": "Peyrins",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Peyrus",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Piégon",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Piégros-la-Clastre",
    "dep": "Drôme"
  },
  {
    "code": "26700",
    "ville": "Pierrelatte",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Pierrelongue",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Les Pilles",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Plaisians",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Plan-de-Baix",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Le Poët-Célard",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Le Poët-en-Percip",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Le Poët-Laval",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Le Poët-Sigillat",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Pommerol",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Ponet-et-Saint-Auban",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Ponsas",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Pontaix",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Pont-de-Barret",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Pont-de-l'Isère",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Portes-en-Valdaine",
    "dep": "Drôme"
  },
  {
    "code": "26800",
    "ville": "Portes-lès-Valence",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Poyols",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Pradelle",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Les Prés",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Propiac",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Puygiron",
    "dep": "Drôme"
  },
  {
    "code": "26450",
    "ville": "Puy-Saint-Martin",
    "dep": "Drôme"
  },
  {
    "code": "26330",
    "ville": "Ratières",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Réauville",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Recoubeau-Jansac",
    "dep": "Drôme"
  },
  {
    "code": "26570",
    "ville": "Reilhanette",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Rémuzat",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Rimon-et-Savel",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Rioms",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Rochebaudin",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Rochebrune",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Rochechinard",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "La Roche-de-Glun",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Rochefort-en-Valdaine",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Rochefort-Samson",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Rochefourchat",
    "dep": "Drôme"
  },
  {
    "code": "26790",
    "ville": "Rochegude",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Roche-Saint-Secret-Béconne",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "La Roche-sur-Grane",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "La Roche-sur-le-Buis",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "La Rochette-du-Buis",
    "dep": "Drôme"
  },
  {
    "code": "26100",
    "ville": "Romans-sur-Isère",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Romeyer",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Rottier",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Roussas",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Rousset-les-Vignes",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Roussieux",
    "dep": "Drôme"
  },
  {
    "code": "26450",
    "ville": "Roynac",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Sahune",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Saillans",
    "dep": "Drôme"
  },
  {
    "code": "26420",
    "ville": "Saint-Agnan-en-Vercors",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Saint-Andéol",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Saint-Auban-sur-l'Ouvèze",
    "dep": "Drôme"
  },
  {
    "code": "26330",
    "ville": "Saint-Avit",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Saint-Bardoux",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Saint-Barthélemy-de-Vals",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Saint-Benoit-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Saint-Christophe-et-le-Laris",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Sainte-Croix",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Saint-Dizier-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26260",
    "ville": "Saint-Donat-sur-l'Herbasse",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Sainte-Eulalie-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Sainte-Euphémie-sur-Ouvèze",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Saint-Ferréol-Trente-Pas",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Saint-Gervais-sur-Roubion",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Sainte-Jalle",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Saint-Jean-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Saint-Julien-en-Quint",
    "dep": "Drôme"
  },
  {
    "code": "26420",
    "ville": "Saint-Julien-en-Vercors",
    "dep": "Drôme"
  },
  {
    "code": "26350",
    "ville": "Saint-Laurent-d'Onay",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Saint-Laurent-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Saint-Marcel-lès-Sauzet",
    "dep": "Drôme"
  },
  {
    "code": "26320",
    "ville": "Saint-Marcel-lès-Valence",
    "dep": "Drôme"
  },
  {
    "code": "26330",
    "ville": "Saint-Martin-d'Août",
    "dep": "Drôme"
  },
  {
    "code": "26420",
    "ville": "Saint-Martin-en-Vercors",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Saint-Martin-le-Colonel",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Saint-Maurice-sur-Eygues",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Saint-May",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Saint-Michel-sur-Savasse",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Saint-Nazaire-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Saint-Nazaire-le-Désert",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Saint-Pantaléon-les-Vignes",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Saint-Paul-lès-Romans",
    "dep": "Drôme"
  },
  {
    "code": "26130",
    "ville": "Saint-Paul-Trois-Châteaux",
    "dep": "Drôme"
  },
  {
    "code": "26140",
    "ville": "Saint-Rambert-d'Albon",
    "dep": "Drôme"
  },
  {
    "code": "26130",
    "ville": "Saint-Restitut",
    "dep": "Drôme"
  },
  {
    "code": "26410",
    "ville": "Saint-Roman",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Saint-Sauveur-en-Diois",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Saint-Sauveur-Gouvernet",
    "dep": "Drôme"
  },
  {
    "code": "26210",
    "ville": "Saint-Sorlin-en-Valloire",
    "dep": "Drôme"
  },
  {
    "code": "26190",
    "ville": "Saint-Thomas-en-Royans",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Saint-Uze",
    "dep": "Drôme"
  },
  {
    "code": "26240",
    "ville": "Saint-Vallier",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Salettes",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Salles-sous-Bois",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Saou",
    "dep": "Drôme"
  },
  {
    "code": "26270",
    "ville": "Saulce-sur-Rhône",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Sauzet",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Savasse",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Séderon",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Serves-sur-Rhône",
    "dep": "Drôme"
  },
  {
    "code": "26130",
    "ville": "Solérieux",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "Souspierre",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Soyans",
    "dep": "Drôme"
  },
  {
    "code": "26790",
    "ville": "Suze-la-Rousse",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Suze",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Tain-l'Hermitage",
    "dep": "Drôme"
  },
  {
    "code": "26770",
    "ville": "Taulignan",
    "dep": "Drôme"
  },
  {
    "code": "26390",
    "ville": "Tersanne",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Teyssières",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Les Tonils",
    "dep": "Drôme"
  },
  {
    "code": "26160",
    "ville": "La Touche",
    "dep": "Drôme"
  },
  {
    "code": "26740",
    "ville": "Les Tourrettes",
    "dep": "Drôme"
  },
  {
    "code": "26750",
    "ville": "Triors",
    "dep": "Drôme"
  },
  {
    "code": "26460",
    "ville": "Truinas",
    "dep": "Drôme"
  },
  {
    "code": "26790",
    "ville": "Tulette",
    "dep": "Drôme"
  },
  {
    "code": "26120",
    "ville": "Upie",
    "dep": "Drôme"
  },
  {
    "code": "26150",
    "ville": "Vachères-en-Quint",
    "dep": "Drôme"
  },
  {
    "code": "26230",
    "ville": "Valaurie",
    "dep": "Drôme"
  },
  {
    "code": "26310",
    "ville": "Valdrôme",
    "dep": "Drôme"
  },
  {
    "code": "26000",
    "ville": "Valence",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Valouse",
    "dep": "Drôme"
  },
  {
    "code": "26420",
    "ville": "Vassieux-en-Vercors",
    "dep": "Drôme"
  },
  {
    "code": "26400",
    "ville": "Vaunaveys-la-Rochette",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Venterol",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Vercheny",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Verclause",
    "dep": "Drôme"
  },
  {
    "code": "26170",
    "ville": "Vercoiran",
    "dep": "Drôme"
  },
  {
    "code": "26340",
    "ville": "Véronne",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Vers-sur-Méouge",
    "dep": "Drôme"
  },
  {
    "code": "26220",
    "ville": "Vesc",
    "dep": "Drôme"
  },
  {
    "code": "05700",
    "ville": "Villebois-les-Pins",
    "dep": "Drôme"
  },
  {
    "code": "26560",
    "ville": "Villefranche-le-Château",
    "dep": "Drôme"
  },
  {
    "code": "26510",
    "ville": "Villeperdrix",
    "dep": "Drôme"
  },
  {
    "code": "26110",
    "ville": "Vinsobres",
    "dep": "Drôme"
  },
  {
    "code": "26470",
    "ville": "Volvent",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Granges-les-Beaumont",
    "dep": "Drôme"
  },
  {
    "code": "26600",
    "ville": "Gervans",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Jaillans",
    "dep": "Drôme"
  },
  {
    "code": "26300",
    "ville": "Saint-Vincent-la-Commanderie",
    "dep": "Drôme"
  },
  {
    "code": "27800",
    "ville": "Aclou",
    "dep": "Eure"
  },
  {
    "code": "27570",
    "ville": "Acon",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Acquigny",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Aigleville",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Ailly",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Aizier",
    "dep": "Eure"
  },
  {
    "code": "27460",
    "ville": "Alizay",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Ambenay",
    "dep": "Eure"
  },
  {
    "code": "27140",
    "ville": "Amécourt",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Amfreville-Saint-Amand",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Amfreville-les-Champs",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Amfreville-sous-les-Monts",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Amfreville-sur-Iton",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Andé",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Les Andelys",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Angerville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Appeville-Annebault",
    "dep": "Eure"
  },
  {
    "code": "27820",
    "ville": "Armentières-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Arnières-sur-Iton",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Asnières",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Le Val d'Hazey",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Aulnay-sur-Iton",
    "dep": "Eure"
  },
  {
    "code": "27490",
    "ville": "Autheuil-Authouillet",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Authevernes",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Les Authieux",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Authou",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Aviron",
    "dep": "Eure"
  },
  {
    "code": "27240",
    "ville": "Chambois",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Bacquepuis",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Bacqueville",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Bailleul-la-Vallée",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Bâlines",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Barc",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Les Barils",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Barneville-sur-Seine",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Barquet",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Barville",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Les Baux-de-Breteuil",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Les Baux-Sainte-Croix",
    "dep": "Eure"
  },
  {
    "code": "27140",
    "ville": "Bazincourt-sur-Epte",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Bazoques",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Beaubray",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Beauficel-en-Lyons",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "Mesnil-en-Ouche",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Beaumontel",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Beaumont-le-Roger",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Le Bec-Hellouin",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Le Bec-Thomas",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Bémécourt",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Bérengeville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Bernay",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Bernienville",
    "dep": "Eure"
  },
  {
    "code": "27660",
    "ville": "Bernouville",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Berthouville",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Les Monts du Roumois",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Berville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Berville-sur-Mer",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Beuzeville",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Bézu-la-Forêt",
    "dep": "Eure"
  },
  {
    "code": "27660",
    "ville": "Bézu-Saint-Éloi",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "Bois-Anzeray",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Bois-Arnault",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Frenelles-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Le Bois-Hellain",
    "dep": "Eure"
  },
  {
    "code": "27620",
    "ville": "Bois-Jérôme-Saint-Ouen",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Bois-le-Roi",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Boisney",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "Bois-Normand-près-Lyre",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Boisset-les-Prévanches",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Boissey-le-Châtel",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "La Boissière",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Boissy-Lamberville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Boncourt",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "La Bonneville-sur-Iton",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Bonneville-Aptot",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Flancourt-Crescy-en-Roumois",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Thénouville",
    "dep": "Eure"
  },
  {
    "code": "27670",
    "ville": "Bosroumois",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Bosgouet",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Bosquentin",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Bosrobert",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Les Bottereaux",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Bouafles",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Bouchevilliers",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Le Boulay-Morin",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Boulleville",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Bouquelon",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Bouquetot",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Bourg-Achard",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Bourg-Beaudouin",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Grand Bourgtheroulde",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Bournainville-Faverolles",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Bourneville-Sainte-Croix",
    "dep": "Eure"
  },
  {
    "code": "27580",
    "ville": "Bourth",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Bray",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Brestot",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Bretagnolles",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Breteuil",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Brétigny",
    "dep": "Eure"
  },
  {
    "code": "27640",
    "ville": "Breuilpont",
    "dep": "Eure"
  },
  {
    "code": "27570",
    "ville": "Breux-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Brionne",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Broglie",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Brosville",
    "dep": "Eure"
  },
  {
    "code": "27730",
    "ville": "Bueil",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Burey",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Caillouet-Orgeville",
    "dep": "Eure"
  },
  {
    "code": "27490",
    "ville": "Cailly-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Calleville",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Campigny",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Canappeville",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Caorches-Saint-Nicolas",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Capelle-les-Grands",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Caugé",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Caumont",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Cauverville-en-Roumois",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Cesseville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Chaignes",
    "dep": "Eure"
  },
  {
    "code": "27580",
    "ville": "Chaise-Dieu-du-Theil",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Chamblac",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Chambord",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Chambray",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Champ-Dolent",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Champenard",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Champigny-la-Futelaye",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "La Chapelle-Bayvel",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "La Chapelle-du-Bois-des-Faulx",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "La Chapelle-Gauthier",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "La Chapelle-Hareng",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Charleval",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Château-sur-Epte",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Chauvincourt-Provemont",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Chavigny-Bailleul",
    "dep": "Eure"
  },
  {
    "code": "27820",
    "ville": "Chennebrun",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Chéronvilliers",
    "dep": "Eure"
  },
  {
    "code": "27240",
    "ville": "Marbois",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Cierrey",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Claville",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Collandres-Quincarnon",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Colletot",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Combon",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Conches-en-Ouche",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Condé-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Connelles",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Conteville",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Cormeilles",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Le Cormier",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Corneville-la-Fouquetière",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Corneville-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Coudray",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Coudres",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Courbépine",
    "dep": "Eure"
  },
  {
    "code": "27940",
    "ville": "Courcelles-sur-Seine",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Courdemanche",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Courteilles",
    "dep": "Eure"
  },
  {
    "code": "27750",
    "ville": "La Couture-Boussey",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Crasville",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Crestot",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Criquebeuf-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27340",
    "ville": "Criquebeuf-sur-Seine",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "La Croisille",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Croisy-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27490",
    "ville": "Clef Vallée d'Eure",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Crosville-la-Vieille",
    "dep": "Eure"
  },
  {
    "code": "27530",
    "ville": "Croth",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Cuverville",
    "dep": "Eure"
  },
  {
    "code": "27340",
    "ville": "Les Damps",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Mesnils-sur-Iton",
    "dep": "Eure"
  },
  {
    "code": "27720",
    "ville": "Dangu",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Dardez",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Daubeuf-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Daubeuf-près-Vatteville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Douains",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Doudeauville-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Douville-sur-Andelle",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Droisy",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Drucourt",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Duranville",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Écaquelon",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Écardenville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Écauville",
    "dep": "Eure"
  },
  {
    "code": "27510",
    "ville": "Vexin-sur-Epte",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Écouis",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Ecquetot",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Émalleville",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Émanville",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Épaignes",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Épégard",
    "dep": "Eure"
  },
  {
    "code": "27730",
    "ville": "Épieds",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Épreville-en-Lieuvin",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Épreville-près-le-Neubourg",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Étrépagny",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Étréville",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Éturqueraye",
    "dep": "Eure"
  },
  {
    "code": "27000",
    "ville": "Évreux",
    "dep": "Eure"
  },
  {
    "code": "27530",
    "ville": "Ézy-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Fains",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Farceaux",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Fatouville-Grestain",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Fauville",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Faverolles-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Le Favril",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Ferrières-Haut-Clocher",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Ferrières-Saint-Hilaire",
    "dep": "Eure"
  },
  {
    "code": "27760",
    "ville": "La Ferrière-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Feuguerolles",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Le Fidelaire",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Fiquefleur-Équainville",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Fleury-la-Forêt",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Fleury-sur-Andelle",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Flipou",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Folleville",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Fontaine-Bellenger",
    "dep": "Eure"
  },
  {
    "code": "27470",
    "ville": "Fontaine-l'Abbé",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Fontaine-la-Louvet",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Fontaine-sous-Jouy",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "La Forêt-du-Parc",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Fort-Moville",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Foucrainville",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Foulbec",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Fouqueville",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Le Perrey",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Franqueville",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Freneuse-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Fresne-Cauverville",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Fresney",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Gadencourt",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Gaillon",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Gamaches-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "La Baronnie",
    "dep": "Eure"
  },
  {
    "code": "27780",
    "ville": "Garennes-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27620",
    "ville": "Gasny",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Gauciel",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Gaudreville-la-Rivière",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Gauville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27140",
    "ville": "Gisors",
    "dep": "Eure"
  },
  {
    "code": "27620",
    "ville": "Giverny",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Giverville",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Glisolles",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Glos-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "La Goulafrière",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Goupil-Othon",
    "dep": "Eure"
  },
  {
    "code": "27580",
    "ville": "Gournay-le-Guérin",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Val d'Orger",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Grand-Camp",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Graveron-Sémerville",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Gravigny",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Grosley-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Grossœuvre",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Le Bosc du Theil",
    "dep": "Eure"
  },
  {
    "code": "27720",
    "ville": "Guerny",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Guichainville",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Guiseniers",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "L'Habit",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Hacqueville",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Harcourt",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Hardencourt-Cocherel",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "La Harengère",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Harquency",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Hauville",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "La Haye-Aubrée",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "La Haye-de-Calleville",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "La Haye-de-Routot",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "La Haye-du-Theil",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "La Haye-le-Comte",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "La Haye-Malherbe",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "La Haye-Saint-Sylvestre",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Hébécourt",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Hecmanville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Hécourt",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Hectomare",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Hennezis",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Herqueville",
    "dep": "Eure"
  },
  {
    "code": "27630",
    "ville": "Heubécourt-Haricourt",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Heudebouville",
    "dep": "Eure"
  },
  {
    "code": "27860",
    "ville": "Heudicourt",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Heudreville-en-Lieuvin",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Heudreville-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "La Heunière",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Heuqueville",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Les Hogues",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Hondouville",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Honguemare-Guenouville",
    "dep": "Eure"
  },
  {
    "code": "27570",
    "ville": "L'Hosmes",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Houetteville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Houlbec-Cocherel",
    "dep": "Eure"
  },
  {
    "code": "27410",
    "ville": "La Houssaye",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Houville-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Huest",
    "dep": "Eure"
  },
  {
    "code": "27460",
    "ville": "Igoville",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Illeville-sur-Montfort",
    "dep": "Eure"
  },
  {
    "code": "27770",
    "ville": "Illiers-l'Évêque",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Incarville",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Irreville",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Iville",
    "dep": "Eure"
  },
  {
    "code": "27540",
    "ville": "Ivry-la-Bataille",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Jouy-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Juignettes",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Jumelles",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "La Lande-Saint-Léger",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Le Landin",
    "dep": "Eure"
  },
  {
    "code": "27470",
    "ville": "Launay",
    "dep": "Eure"
  },
  {
    "code": "27690",
    "ville": "Léry",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Letteguives",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Lieurey",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Lignerolles",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Lilly",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Lisors",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Livet-sur-Authou",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Longchamps",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Lorleau",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Louversey",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Louviers",
    "dep": "Eure"
  },
  {
    "code": "27650",
    "ville": "Louye",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Lyons-la-Forêt",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "La Madeleine-de-Nonancourt",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Mainneville",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Malleville-sur-le-Bec",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Malouy",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Mandeville",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Mandres",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Manneville-la-Raoult",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Manneville-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27460",
    "ville": "Le Manoir",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Marais-Vernier",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Marbeuf",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Marcilly-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27810",
    "ville": "Marcilly-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Martagny",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Martainville",
    "dep": "Eure"
  },
  {
    "code": "27340",
    "ville": "Martot",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Mélicourt",
    "dep": "Eure"
  },
  {
    "code": "27850",
    "ville": "Ménesqueville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Ménilles",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Menneval",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "Mercey",
    "dep": "Eure"
  },
  {
    "code": "27640",
    "ville": "Merey",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Le Mesnil-Fuguet",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Le Mesnil-Jourdain",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Mesnil-Rousset",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Mesnil-sous-Vienne",
    "dep": "Eure"
  },
  {
    "code": "27650",
    "ville": "Mesnil-sur-l'Estrée",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Mesnil-Verclives",
    "dep": "Eure"
  },
  {
    "code": "27510",
    "ville": "Mézières-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Miserey",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Moisville",
    "dep": "Eure"
  },
  {
    "code": "27340",
    "ville": "Terres de Bord",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Montfort-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Montreuil-l'Argillé",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Morainville-Jouveaux",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Morgny",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Morsan",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Mouettes",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Mouflaines",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Mousseaux-Neuville",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Muids",
    "dep": "Eure"
  },
  {
    "code": "27650",
    "ville": "Muzy",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Nagel-Séez-Mesnil",
    "dep": "Eure"
  },
  {
    "code": "27550",
    "ville": "Nassandres sur Risle",
    "dep": "Eure"
  },
  {
    "code": "27830",
    "ville": "Neaufles-Saint-Martin",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Neaufles-Auvergny",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Le Neubourg",
    "dep": "Eure"
  },
  {
    "code": "27730",
    "ville": "Neuilly",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "La Neuve-Grange",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "La Neuve-Lyre",
    "dep": "Eure"
  },
  {
    "code": "27890",
    "ville": "La Neuville-du-Bosc",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Neuville-sur-Authou",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Noards",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "La Noë-Poulain",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Nogent-le-Sec",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Nojeon-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Nonancourt",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Normanville",
    "dep": "Eure"
  },
  {
    "code": "27940",
    "ville": "Notre-Dame-de-l'Isle",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Notre-Dame-d'Épine",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Notre-Dame-du-Hamel",
    "dep": "Eure"
  },
  {
    "code": "27410",
    "ville": "Le Noyer-en-Ouche",
    "dep": "Eure"
  },
  {
    "code": "27720",
    "ville": "Noyers",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Ormes",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Le Val-Doré",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Pacy-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Parville",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Perriers-sur-Andelle",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Perruel",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Piencourt",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Pinterville",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Piseux",
    "dep": "Eure"
  },
  {
    "code": "27590",
    "ville": "Pîtres",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Les Places",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Plainville",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Le Planquay",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Plasnes",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Le Plessis-Grohan",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Le Plessis-Hébert",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Le Plessis-Sainte-Opportune",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Pont-Audemer",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Pont-Authou",
    "dep": "Eure"
  },
  {
    "code": "27340",
    "ville": "Pont-de-l'Arche",
    "dep": "Eure"
  },
  {
    "code": "27360",
    "ville": "Pont-Saint-Pierre",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Porte-de-Seine",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Portes",
    "dep": "Eure"
  },
  {
    "code": "27940",
    "ville": "Port-Mort",
    "dep": "Eure"
  },
  {
    "code": "27740",
    "ville": "Poses",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "La Poterie-Mathieu",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Les Préaux",
    "dep": "Eure"
  },
  {
    "code": "27510",
    "ville": "Pressagny-l'Orgueilleux",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Prey",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Puchay",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Pullay",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "La Pyle",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Quatremare",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Quillebeuf-sur-Seine",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Quittebeuf",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Radepont",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Renneville",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Reuilly",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Richeville",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Romilly-la-Puthenaye",
    "dep": "Eure"
  },
  {
    "code": "27610",
    "ville": "Romilly-sur-Andelle",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "La Roquette",
    "dep": "Eure"
  },
  {
    "code": "27790",
    "ville": "Rosay-sur-Lieure",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Rougemontiers",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Rouge-Perriers",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Routot",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Rouvray",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Rugles",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Sacquenville",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Saint-Agnan-de-Cernières",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Saint-André-de-l'Eure",
    "dep": "Eure"
  },
  {
    "code": "27250",
    "ville": "Saint-Antonin-de-Sommaire",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Saint-Aubin-d'Écrosville",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Saint-Aubin-de-Scellon",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Saint-Aubin-du-Thenney",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Treis-Sants-en-Ouche",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Saint-Aubin-sur-Gaillon",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Saint-Aubin-sur-Quillebeuf",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Benoît-des-Ombres",
    "dep": "Eure"
  },
  {
    "code": "27820",
    "ville": "Saint-Christophe-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Christophe-sur-Condé",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Sainte-Colombe-la-Commanderie",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "Sainte-Colombe-près-Vernon",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Saint-Cyr-de-Salerne",
    "dep": "Eure"
  },
  {
    "code": "27100",
    "ville": "Le Vaudreuil",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Cyr-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Saint-Denis-d'Augerons",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Saint-Denis-des-Monts",
    "dep": "Eure"
  },
  {
    "code": "27140",
    "ville": "Saint-Denis-le-Ferment",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Didier-des-Bois",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Saint-Élier",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Saint-Éloi-de-Fourques",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Saint-Étienne-du-Vauvray",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Étienne-l'Allier",
    "dep": "Eure"
  },
  {
    "code": "27920",
    "ville": "Saint-Étienne-sous-Bailleul",
    "dep": "Eure"
  },
  {
    "code": "27620",
    "ville": "Sainte-Geneviève-lès-Gasny",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Le Mesnil-Saint-Jean",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Georges-du-Vièvre",
    "dep": "Eure"
  },
  {
    "code": "27710",
    "ville": "Saint-Georges-Motel",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Saint-Germain-de-Fresney",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Germain-de-Pasquier",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Saint-Germain-des-Angles",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Saint-Germain-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27320",
    "ville": "Saint-Germain-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Grégoire-du-Vièvre",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "Saint-Jean-du-Thenney",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Saint-Julien-de-la-Liègue",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "La Chapelle-Longueville",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Saint-Laurent-des-Bois",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Saint-Laurent-du-Tencement",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Saint-Léger-de-Rôtes",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Saint-Léger-du-Gennetey",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Saint-Luc",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Saint-Maclou",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "Saint-Marcel",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Saint-Mards-de-Blacarville",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Saint-Mards-de-Fresne",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Le Lesme",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Sainte-Marie-de-Vatimesnil",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Sainte-Marthe",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Saint-Martin-du-Tilleul",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Saint-Martin-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Martin-Saint-Firmin",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Meslin-du-Bosc",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Sainte-Opportune-du-Bosc",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Sainte-Opportune-la-Mare",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Sainte-Marie-d'Attez",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Ouen-de-Pontcheuil",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "Saint-Ouen-de-Thouberville",
    "dep": "Eure"
  },
  {
    "code": "27670",
    "ville": "Saint-Ouen-du-Tilleul",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Saint-Paul-de-Fourques",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Saint-Philbert-sur-Boissey",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Saint-Philbert-sur-Risle",
    "dep": "Eure"
  },
  {
    "code": "27920",
    "ville": "Saint-Pierre-de-Bailleul",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Saint-Pierre-de-Cernières",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Saint-Pierre-de-Cormeilles",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Saint-Pierre-de-Salerne",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Pierre-des-Fleurs",
    "dep": "Eure"
  },
  {
    "code": "27450",
    "ville": "Saint-Pierre-des-Ifs",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Saint-Pierre-du-Bosguérard",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Saint-Pierre-du-Val",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Saint-Pierre-du-Vauvray",
    "dep": "Eure"
  },
  {
    "code": "27600",
    "ville": "Saint-Pierre-la-Garenne",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Saint-Samson-de-la-Roque",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Saint-Sébastien-de-Morsent",
    "dep": "Eure"
  },
  {
    "code": "27560",
    "ville": "Saint-Siméon",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Saint-Sulpice-de-Grimbouville",
    "dep": "Eure"
  },
  {
    "code": "27260",
    "ville": "Saint-Sylvestre-de-Cormeilles",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Saint-Symphorien",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Saint-Victor-de-Chrétienville",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Saint-Victor-d'Épine",
    "dep": "Eure"
  },
  {
    "code": "27130",
    "ville": "Saint-Victor-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Saint-Vigor",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "Saint-Vincent-des-Bois",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Saint-Vincent-du-Boulay",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Sancourt",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Sassey",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "La Saussaye",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Saussay-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27190",
    "ville": "Sébécourt",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Selles",
    "dep": "Eure"
  },
  {
    "code": "27220",
    "ville": "Serez",
    "dep": "Eure"
  },
  {
    "code": "27470",
    "ville": "Serquigny",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Surtauville",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Surville",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Suzay",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Le Theil-Nolent",
    "dep": "Eure"
  },
  {
    "code": "27230",
    "ville": "Thiberville",
    "dep": "Eure"
  },
  {
    "code": "27800",
    "ville": "Thibouville",
    "dep": "Eure"
  },
  {
    "code": "27290",
    "ville": "Thierville",
    "dep": "Eure"
  },
  {
    "code": "27150",
    "ville": "Le Thil",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Les Thilliers-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Le Thuit",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Le Thuit de l'Oison",
    "dep": "Eure"
  },
  {
    "code": "27170",
    "ville": "Tilleul-Dame-Agnès",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Le Tilleul-Lambert",
    "dep": "Eure"
  },
  {
    "code": "27570",
    "ville": "Tillières-sur-Avre",
    "dep": "Eure"
  },
  {
    "code": "27510",
    "ville": "Tilly",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Tocqueville",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Le Torpt",
    "dep": "Eure"
  },
  {
    "code": "27440",
    "ville": "Touffreville",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Tournedos-Bois-Hubert",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Tourneville",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Tourville-la-Campagne",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Tourville-sur-Pont-Audemer",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Toutainville",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Le Tremblay-Omonville",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "La Trinité",
    "dep": "Eure"
  },
  {
    "code": "27270",
    "ville": "La Trinité-de-Réville",
    "dep": "Eure"
  },
  {
    "code": "27310",
    "ville": "La Trinité-de-Thouberville",
    "dep": "Eure"
  },
  {
    "code": "27500",
    "ville": "Triqueville",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Le Troncq",
    "dep": "Eure"
  },
  {
    "code": "27480",
    "ville": "Le Tronquay",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Trouville-la-Haule",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "La Vacherie",
    "dep": "Eure"
  },
  {
    "code": "27300",
    "ville": "Valailles",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Le Val-David",
    "dep": "Eure"
  },
  {
    "code": "27350",
    "ville": "Valletot",
    "dep": "Eure"
  },
  {
    "code": "27380",
    "ville": "Vandrimare",
    "dep": "Eure"
  },
  {
    "code": "27210",
    "ville": "Vannecrocq",
    "dep": "Eure"
  },
  {
    "code": "27910",
    "ville": "Vascœuil",
    "dep": "Eure"
  },
  {
    "code": "27430",
    "ville": "Vatteville",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Vaux-sur-Eure",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Les Trois Lacs",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Venon",
    "dep": "Eure"
  },
  {
    "code": "27180",
    "ville": "Les Ventes",
    "dep": "Eure"
  },
  {
    "code": "27160",
    "ville": "Verneuil d'Avre et d'Iton",
    "dep": "Eure"
  },
  {
    "code": "27390",
    "ville": "Verneusses",
    "dep": "Eure"
  },
  {
    "code": "27200",
    "ville": "Vernon",
    "dep": "Eure"
  },
  {
    "code": "27870",
    "ville": "Vesly",
    "dep": "Eure"
  },
  {
    "code": "27700",
    "ville": "Vézillon",
    "dep": "Eure"
  },
  {
    "code": "27930",
    "ville": "Le Vieil-Évreux",
    "dep": "Eure"
  },
  {
    "code": "27330",
    "ville": "La Vieille-Lyre",
    "dep": "Eure"
  },
  {
    "code": "27680",
    "ville": "Vieux-Port",
    "dep": "Eure"
  },
  {
    "code": "27120",
    "ville": "Villegats",
    "dep": "Eure"
  },
  {
    "code": "27420",
    "ville": "Villers-en-Vexin",
    "dep": "Eure"
  },
  {
    "code": "27940",
    "ville": "Villers-sur-le-Roule",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Villettes",
    "dep": "Eure"
  },
  {
    "code": "27240",
    "ville": "Sylvains-Lès-Moulins",
    "dep": "Eure"
  },
  {
    "code": "27950",
    "ville": "Villez-sous-Bailleul",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Villez-sur-le-Neubourg",
    "dep": "Eure"
  },
  {
    "code": "27640",
    "ville": "Villiers-en-Désœuvre",
    "dep": "Eure"
  },
  {
    "code": "27400",
    "ville": "Vironvay",
    "dep": "Eure"
  },
  {
    "code": "27110",
    "ville": "Vitot",
    "dep": "Eure"
  },
  {
    "code": "27520",
    "ville": "Voiscreville",
    "dep": "Eure"
  },
  {
    "code": "27370",
    "ville": "Vraiville",
    "dep": "Eure"
  },
  {
    "code": "27100",
    "ville": "Val-de-Reuil",
    "dep": "Eure"
  },
  {
    "code": "28410",
    "ville": "Abondant",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Allainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Allonnes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Alluyes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Amilly",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Anet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Ardelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Ardelu",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Argenvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28220",
    "ville": "Vald'Yerre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Aunay-sous-Auneau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Aunay-sous-Crécy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Auneau-Bleury-Saint-Symphorien",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Les Autels-Villevillon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Authon-du-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Baigneaux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Bailleau-le-Pin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Bailleau-l'Évêque",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28320",
    "ville": "Bailleau-Armenonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Barjouville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Barmainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Baudreville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "La Bazoche-Gouet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Bazoches-en-Dunois",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Bazoches-les-Hautes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Beauche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Beaumont-les-Autels",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Beauvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Belhomert-Guéhouville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Berchères-Saint-Germain",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Berchères-les-Pierres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Berchères-sur-Vesgre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Bérou-la-Mulotière",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Béthonvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Béville-le-Comte",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Billancelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Blandainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Boissy-en-Drouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "Boissy-lès-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Boisville-la-Saint-Père",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "La Bourdinière-Saint-Loup",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Boncé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Boncourt",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Bonneval",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Bouglainval",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Le Boullay-les-Deux-Églises",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Le Boullay-Mivoye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Le Boullay-Thierry",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Boutigny-Prouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Bouville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Bréchamps",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Brezolles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Briconville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Brou",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Broué",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Bû",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Bullainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Cernay",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Challet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Champhol",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Champrond-en-Gâtine",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Champrond-en-Perchet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Champseru",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "La Chapelle-d'Aunainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "La Chapelle-du-Noyer",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "La Chapelle-Forainvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "La Chapelle-Fortin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Chapelle-Guillaume",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28290",
    "ville": "Chapelle-Royale",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Charbonnières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Charonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Charpont",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Chartainvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28000",
    "ville": "Chartres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Chassant",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Châtaincourt",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Châteaudun",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Châteauneuf-en-Thymerais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Les Châtelets",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Les Châtelliers-Notre-Dame",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Châtenay",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Chaudon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Chauffours",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "La Chaussée-d'Ivry",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Cherisy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Chuisnes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Cintray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Clévilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28220",
    "ville": "Cloyes-les-Trois-Rivières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Coltainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Combres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Conie-Molitard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Corancez",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Cormainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Les Corvées-les-Yys",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Le Coudray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Coudray-au-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Coulombs",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Courbehaye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Courville-sur-Eure",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Crécy-Couvé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Croisilles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "La Croix-du-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Crucey-Villages",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Dambron",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Dammarie",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Dampierre-sous-Brou",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28350",
    "ville": "Dampierre-sur-Avre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Dancy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Dangeau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Dangers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Denonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "Digny",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Donnemain-Saint-Mamès",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28100",
    "ville": "Dreux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28230",
    "ville": "Droue-sur-Drouette",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Écluzelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28320",
    "ville": "Écrosnes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Épeautrolles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28230",
    "ville": "Épernon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Ermenonville-la-Grande",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Ermenonville-la-Petite",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Escorpain",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Les Étilleux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Faverolles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Favières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Le Favril",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "La Ferté-Vidame",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Fessanvilliers-Mattanvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Flacey",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Fontaine-la-Guyon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Fontaine-les-Ribouts",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Fontaine-Simon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Fontenay-sur-Conie",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Fontenay-sur-Eure",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "La Framboisière",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Francourville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Frazé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Fresnay-le-Comte",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Fresnay-le-Gilmert",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Fresnay-l'Évêque",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Friaize",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Fruncé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28320",
    "ville": "Gallardon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Garancières-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Garancières-en-Drouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Garnay",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28320",
    "ville": "Gas",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Gasville-Oisème",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "La Gaudaine",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Le Gault-Saint-Denis",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Gellainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Germainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Gilles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Gohory",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Gommerville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Gouillons",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Goussainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Guainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Le Gué-de-Longroi",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Guilleville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Guillonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Hanches",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Happonvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Havelu",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Houville-la-Branche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Houx",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Illiers-Combray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Intréville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Jallans",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Janville-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "Jaudrais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Jouy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "Lamblore",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Landelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Laons",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Léthuin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Levainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Lèves",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Levesville-la-Chenard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Logron",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Loigny-la-Bataille",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Lormaye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "La Loupe",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Louville-la-Chenard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Louvilliers-en-Drouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "Louvilliers-lès-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28110",
    "ville": "Lucé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Luigny",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28600",
    "ville": "Luisant",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Lumeau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Luplanté",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Luray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Magny",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Maillebois",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Maintenon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Mainvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Maisons",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "La Mancelière",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Manou",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Marboué",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Marchéville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Marchezais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Arcisses",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Marolles-les-Buis",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Marville-Moutiers-Brûlé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Meaucé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Méréglise",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Mérouville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Meslay-le-Grenet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Meslay-le-Vidame",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Le Mesnil-Simon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "Le Mesnil-Thomas",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Mévoisins",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Mézières-en-Drouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Miermaigne",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Mignières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Mittainvilliers-Vérigny",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Moinville-la-Jeulin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Moléans",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Mondonville-Saint-Jean",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Montboissier",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Montharville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Montigny-le-Chartif",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Montigny-sur-Avre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Montireau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Montlandon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Montreuil",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Morainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Morancez",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Moriers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "Morvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Mottereau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Moulhard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Moutiers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Néron",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Neuvy-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Neuvy-en-Dunois",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Nogent-le-Phaye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Nogent-le-Roi",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Nogent-le-Rotrou",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Nogent-sur-Eure",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Nonvilliers-Grandhoux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Nottonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Oinville-Saint-Liphard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Oinville-sous-Auneau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Ollé",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Orgères-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Ormoy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Orrouer",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Ouarville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Ouerre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Oulins",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Oysonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Péronville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Pierres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Les Pinthières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Poinville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Poisvilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Pontgouin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Poupry",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Prasville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Pré-Saint-Évroult",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Pré-Saint-Martin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Prudemanche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Prunay-le-Gillon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "La Puisaye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Puiseux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Réclainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "Les Ressuintes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Revercourt",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28340",
    "ville": "Rohaire",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Roinville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Rouvray-Saint-Denis",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Rouvres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Rueil-la-Gadelière",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Saint-Ange-et-Torçay",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Saint-Arnoult-des-Bois",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Saint-Aubin-des-Bois",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Saint-Avit-les-Guespières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28330",
    "ville": "Saint-Bomer",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Saint-Christophe",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Villemaury",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Saintigny",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Sainte-Gemme-Moronval",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Saint-Denis-des-Puits",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Saint-Denis-Lanneray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Saint-Éliph",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Saint-Éman",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Saint-Georges-sur-Eure",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Saint-Germain-le-Gaillard",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Saint-Jean-de-Rebervilliers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Saint-Jean-Pierre-Fixte",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Saint-Laurent-la-Gâtine",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Saint-Léger-des-Aubées",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28270",
    "ville": "Saint-Lubin-de-Cravant",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Saint-Lubin-de-la-Haye",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28350",
    "ville": "Saint-Lubin-des-Joncherets",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Saint-Lucien",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Saint-Luperce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Saint-Maixme-Hauterive",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Saint-Martin-de-Nigelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Saint-Maur-sur-le-Loir",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Saint-Maurice-Saint-Germain",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Saint-Ouen-Marchefroy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Saint-Piat",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28300",
    "ville": "Saint-Prest",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28380",
    "ville": "Saint-Rémy-sur-Avre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Saint-Sauveur-Marville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Saint-Victor-de-Buthon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Sainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Sancheville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Sandarville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Santeuil",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Santilly",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "La Saucelle",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Saulnières",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Saumeray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Saussay",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Senantes",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28250",
    "ville": "Senonches",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Serazereux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28410",
    "ville": "Serville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28260",
    "ville": "Sorel-Moussel",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Souancé-au-Perche",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Soulaires",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Sours",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Terminiers",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Theuville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Le Thieulin",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Thimert-Gâtelles",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Thiron-Gardais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Thivars",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Thiville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Tillay-le-Péneux",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Toury",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28310",
    "ville": "Trancrainville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28170",
    "ville": "Tremblay-les-Villages",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Tréon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28400",
    "ville": "Trizay-Coutretot-Saint-Serge",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Trizay-lès-Bonneval",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Umpeau",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Unverre",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28140",
    "ville": "Varize",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28240",
    "ville": "Vaupillon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28630",
    "ville": "Ver-lès-Chartres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Vernouillet",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28500",
    "ville": "Vert-en-Drouais",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Éole-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28480",
    "ville": "Vichères",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Vierville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28120",
    "ville": "Vieuvicq",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28200",
    "ville": "Villampuy",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Villars",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28190",
    "ville": "Villebon",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28210",
    "ville": "Villemeux-sur-Eure",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Villiers-le-Morhier",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28800",
    "ville": "Villiers-Saint-Orien",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28360",
    "ville": "Vitray-en-Beauce",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28700",
    "ville": "Voise",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Les Villages Vovéens",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28130",
    "ville": "Yermenonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28160",
    "ville": "Yèvres",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28320",
    "ville": "Ymeray",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "28150",
    "ville": "Ymonville",
    "dep": "Eure-et-Loir"
  },
  {
    "code": "29560",
    "ville": "Argol",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Arzano",
    "dep": "Finistère"
  },
  {
    "code": "29770",
    "ville": "Audierne",
    "dep": "Finistère"
  },
  {
    "code": "29380",
    "ville": "Bannalec",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Baye",
    "dep": "Finistère"
  },
  {
    "code": "29950",
    "ville": "Bénodet",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "Berrien",
    "dep": "Finistère"
  },
  {
    "code": "29790",
    "ville": "Beuzec-Cap-Sizun",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Bodilis",
    "dep": "Finistère"
  },
  {
    "code": "29820",
    "ville": "Bohars",
    "dep": "Finistère"
  },
  {
    "code": "29640",
    "ville": "Bolazec",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "Botmeur",
    "dep": "Finistère"
  },
  {
    "code": "29650",
    "ville": "Botsorhel",
    "dep": "Finistère"
  },
  {
    "code": "29860",
    "ville": "Bourg-Blanc",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Brasparts",
    "dep": "Finistère"
  },
  {
    "code": "29810",
    "ville": "Brélès",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "Brennilis",
    "dep": "Finistère"
  },
  {
    "code": "29200",
    "ville": "Brest",
    "dep": "Finistère"
  },
  {
    "code": "29510",
    "ville": "Briec",
    "dep": "Finistère"
  },
  {
    "code": "29890",
    "ville": "Plounéour-Brignogan-plages",
    "dep": "Finistère"
  },
  {
    "code": "29570",
    "ville": "Camaret-sur-Mer",
    "dep": "Finistère"
  },
  {
    "code": "29660",
    "ville": "Carantec",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Carhaix-Plouguer",
    "dep": "Finistère"
  },
  {
    "code": "29150",
    "ville": "Cast",
    "dep": "Finistère"
  },
  {
    "code": "29150",
    "ville": "Châteaulin",
    "dep": "Finistère"
  },
  {
    "code": "29520",
    "ville": "Châteauneuf-du-Faou",
    "dep": "Finistère"
  },
  {
    "code": "29770",
    "ville": "Cléden-Cap-Sizun",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Cléden-Poher",
    "dep": "Finistère"
  },
  {
    "code": "29233",
    "ville": "Cléder",
    "dep": "Finistère"
  },
  {
    "code": "29360",
    "ville": "Clohars-Carnoët",
    "dep": "Finistère"
  },
  {
    "code": "29950",
    "ville": "Clohars-Fouesnant",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Le Cloître-Pleyben",
    "dep": "Finistère"
  },
  {
    "code": "29410",
    "ville": "Le Cloître-Saint-Thégonnec",
    "dep": "Finistère"
  },
  {
    "code": "29870",
    "ville": "Coat-Méal",
    "dep": "Finistère"
  },
  {
    "code": "29530",
    "ville": "Collorec",
    "dep": "Finistère"
  },
  {
    "code": "29120",
    "ville": "Combrit",
    "dep": "Finistère"
  },
  {
    "code": "29450",
    "ville": "Commana",
    "dep": "Finistère"
  },
  {
    "code": "29900",
    "ville": "Concarneau",
    "dep": "Finistère"
  },
  {
    "code": "29217",
    "ville": "Le Conquet",
    "dep": "Finistère"
  },
  {
    "code": "29370",
    "ville": "Coray",
    "dep": "Finistère"
  },
  {
    "code": "29160",
    "ville": "Crozon",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Daoulas",
    "dep": "Finistère"
  },
  {
    "code": "29150",
    "ville": "Dinéault",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Dirinon",
    "dep": "Finistère"
  },
  {
    "code": "29100",
    "ville": "Douarnenez",
    "dep": "Finistère"
  },
  {
    "code": "29860",
    "ville": "Le Drennec",
    "dep": "Finistère"
  },
  {
    "code": "29510",
    "ville": "Edern",
    "dep": "Finistère"
  },
  {
    "code": "29370",
    "ville": "Elliant",
    "dep": "Finistère"
  },
  {
    "code": "29500",
    "ville": "Ergué-Gabéric",
    "dep": "Finistère"
  },
  {
    "code": "29590",
    "ville": "Le Faou",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "La Feuillée",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Le Folgoët",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "La Forest-Landerneau",
    "dep": "Finistère"
  },
  {
    "code": "29940",
    "ville": "La Forêt-Fouesnant",
    "dep": "Finistère"
  },
  {
    "code": "29170",
    "ville": "Fouesnant",
    "dep": "Finistère"
  },
  {
    "code": "29610",
    "ville": "Garlan",
    "dep": "Finistère"
  },
  {
    "code": "29950",
    "ville": "Gouesnach",
    "dep": "Finistère"
  },
  {
    "code": "29850",
    "ville": "Gouesnou",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Gouézec",
    "dep": "Finistère"
  },
  {
    "code": "29770",
    "ville": "Goulien",
    "dep": "Finistère"
  },
  {
    "code": "29890",
    "ville": "Goulven",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Gourlizon",
    "dep": "Finistère"
  },
  {
    "code": "29180",
    "ville": "Guengat",
    "dep": "Finistère"
  },
  {
    "code": "29650",
    "ville": "Guerlesquin",
    "dep": "Finistère"
  },
  {
    "code": "29410",
    "ville": "Guiclan",
    "dep": "Finistère"
  },
  {
    "code": "29820",
    "ville": "Guilers",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Guiler-sur-Goyen",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Guilligomarc'h",
    "dep": "Finistère"
  },
  {
    "code": "29730",
    "ville": "Guilvinec",
    "dep": "Finistère"
  },
  {
    "code": "29620",
    "ville": "Guimaëc",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Guimiliau",
    "dep": "Finistère"
  },
  {
    "code": "29490",
    "ville": "Guipavas",
    "dep": "Finistère"
  },
  {
    "code": "29290",
    "ville": "Milizac-Guipronvel",
    "dep": "Finistère"
  },
  {
    "code": "29880",
    "ville": "Guissény",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Hanvec",
    "dep": "Finistère"
  },
  {
    "code": "29670",
    "ville": "Henvic",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Hôpital-Camfrout",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "Huelgoat",
    "dep": "Finistère"
  },
  {
    "code": "29253",
    "ville": "Île-de-Batz",
    "dep": "Finistère"
  },
  {
    "code": "29990",
    "ville": "Île-de-Sein",
    "dep": "Finistère"
  },
  {
    "code": "29259",
    "ville": "Île-Molène",
    "dep": "Finistère"
  },
  {
    "code": "29980",
    "ville": "Île-Tudy",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Irvillac",
    "dep": "Finistère"
  },
  {
    "code": "29100",
    "ville": "Le Juch",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Kergloff",
    "dep": "Finistère"
  },
  {
    "code": "29100",
    "ville": "Kerlaz",
    "dep": "Finistère"
  },
  {
    "code": "29890",
    "ville": "Kerlouan",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Kernilis",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Kernouës",
    "dep": "Finistère"
  },
  {
    "code": "29860",
    "ville": "Kersaint-Plabennec",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Lampaul-Guimiliau",
    "dep": "Finistère"
  },
  {
    "code": "29810",
    "ville": "Lampaul-Plouarzel",
    "dep": "Finistère"
  },
  {
    "code": "29830",
    "ville": "Lampaul-Ploudalmézeau",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Lanarvily",
    "dep": "Finistère"
  },
  {
    "code": "29870",
    "ville": "Landéda",
    "dep": "Finistère"
  },
  {
    "code": "29530",
    "ville": "Landeleau",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Landerneau",
    "dep": "Finistère"
  },
  {
    "code": "29560",
    "ville": "Landévennec",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Landivisiau",
    "dep": "Finistère"
  },
  {
    "code": "29510",
    "ville": "Landrévarzec",
    "dep": "Finistère"
  },
  {
    "code": "29510",
    "ville": "Landudal",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Landudec",
    "dep": "Finistère"
  },
  {
    "code": "29840",
    "ville": "Landunvez",
    "dep": "Finistère"
  },
  {
    "code": "29510",
    "ville": "Langolen",
    "dep": "Finistère"
  },
  {
    "code": "29430",
    "ville": "Lanhouarneau",
    "dep": "Finistère"
  },
  {
    "code": "29840",
    "ville": "Lanildut",
    "dep": "Finistère"
  },
  {
    "code": "29620",
    "ville": "Lanmeur",
    "dep": "Finistère"
  },
  {
    "code": "29640",
    "ville": "Lannéanou",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Lannédern",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Lanneuffret",
    "dep": "Finistère"
  },
  {
    "code": "29870",
    "ville": "Lannilis",
    "dep": "Finistère"
  },
  {
    "code": "29290",
    "ville": "Lanrivoaré",
    "dep": "Finistère"
  },
  {
    "code": "29160",
    "ville": "Lanvéoc",
    "dep": "Finistère"
  },
  {
    "code": "29520",
    "ville": "Laz",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Lennon",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Lesneven",
    "dep": "Finistère"
  },
  {
    "code": "29390",
    "ville": "Leuhan",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Loc-Brévalaire",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Loc-Eguiner",
    "dep": "Finistère"
  },
  {
    "code": "29280",
    "ville": "Locmaria-Plouzané",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Locmélar",
    "dep": "Finistère"
  },
  {
    "code": "29670",
    "ville": "Locquénolé",
    "dep": "Finistère"
  },
  {
    "code": "29241",
    "ville": "Locquirec",
    "dep": "Finistère"
  },
  {
    "code": "29180",
    "ville": "Locronan",
    "dep": "Finistère"
  },
  {
    "code": "29750",
    "ville": "Loctudy",
    "dep": "Finistère"
  },
  {
    "code": "29310",
    "ville": "Locunolé",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Logonna-Daoulas",
    "dep": "Finistère"
  },
  {
    "code": "29590",
    "ville": "Lopérec",
    "dep": "Finistère"
  },
  {
    "code": "29470",
    "ville": "Loperhet",
    "dep": "Finistère"
  },
  {
    "code": "29530",
    "ville": "Loqueffret",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Lothey",
    "dep": "Finistère"
  },
  {
    "code": "29790",
    "ville": "Mahalon",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "La Martyre",
    "dep": "Finistère"
  },
  {
    "code": "29790",
    "ville": "Confort-Meilars",
    "dep": "Finistère"
  },
  {
    "code": "29140",
    "ville": "Melgven",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Mellac",
    "dep": "Finistère"
  },
  {
    "code": "29420",
    "ville": "Mespaul",
    "dep": "Finistère"
  },
  {
    "code": "29350",
    "ville": "Moëlan-sur-Mer",
    "dep": "Finistère"
  },
  {
    "code": "29600",
    "ville": "Morlaix",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Motreff",
    "dep": "Finistère"
  },
  {
    "code": "29920",
    "ville": "Névez",
    "dep": "Finistère"
  },
  {
    "code": "29242",
    "ville": "Ouessant",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Pencran",
    "dep": "Finistère"
  },
  {
    "code": "29760",
    "ville": "Penmarch",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Peumerit",
    "dep": "Finistère"
  },
  {
    "code": "29860",
    "ville": "Plabennec",
    "dep": "Finistère"
  },
  {
    "code": "29170",
    "ville": "Pleuven",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Pleyben",
    "dep": "Finistère"
  },
  {
    "code": "29410",
    "ville": "Pleyber-Christ",
    "dep": "Finistère"
  },
  {
    "code": "29740",
    "ville": "Plobannalec-Lesconil",
    "dep": "Finistère"
  },
  {
    "code": "29550",
    "ville": "Ploéven",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Plogastel-Saint-Germain",
    "dep": "Finistère"
  },
  {
    "code": "29770",
    "ville": "Plogoff",
    "dep": "Finistère"
  },
  {
    "code": "29180",
    "ville": "Plogonnec",
    "dep": "Finistère"
  },
  {
    "code": "29700",
    "ville": "Plomelin",
    "dep": "Finistère"
  },
  {
    "code": "29120",
    "ville": "Plomeur",
    "dep": "Finistère"
  },
  {
    "code": "29550",
    "ville": "Plomodiern",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Plonéis",
    "dep": "Finistère"
  },
  {
    "code": "29720",
    "ville": "Plonéour-Lanvern",
    "dep": "Finistère"
  },
  {
    "code": "29530",
    "ville": "Plonévez-du-Faou",
    "dep": "Finistère"
  },
  {
    "code": "29550",
    "ville": "Plonévez-Porzay",
    "dep": "Finistère"
  },
  {
    "code": "29810",
    "ville": "Plouarzel",
    "dep": "Finistère"
  },
  {
    "code": "29830",
    "ville": "Ploudalmézeau",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Ploudaniel",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Ploudiry",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Plouédern",
    "dep": "Finistère"
  },
  {
    "code": "29620",
    "ville": "Plouégat-Guérand",
    "dep": "Finistère"
  },
  {
    "code": "29650",
    "ville": "Plouégat-Moysan",
    "dep": "Finistère"
  },
  {
    "code": "29420",
    "ville": "Plouénan",
    "dep": "Finistère"
  },
  {
    "code": "29430",
    "ville": "Plouescat",
    "dep": "Finistère"
  },
  {
    "code": "29252",
    "ville": "Plouezoc'h",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Plougar",
    "dep": "Finistère"
  },
  {
    "code": "29630",
    "ville": "Plougasnou",
    "dep": "Finistère"
  },
  {
    "code": "29470",
    "ville": "Plougastel-Daoulas",
    "dep": "Finistère"
  },
  {
    "code": "29217",
    "ville": "Plougonvelin",
    "dep": "Finistère"
  },
  {
    "code": "29640",
    "ville": "Plougonven",
    "dep": "Finistère"
  },
  {
    "code": "29250",
    "ville": "Plougoulm",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Plougourvest",
    "dep": "Finistère"
  },
  {
    "code": "29880",
    "ville": "Plouguerneau",
    "dep": "Finistère"
  },
  {
    "code": "29830",
    "ville": "Plouguin",
    "dep": "Finistère"
  },
  {
    "code": "29780",
    "ville": "Plouhinec",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Plouider",
    "dep": "Finistère"
  },
  {
    "code": "29610",
    "ville": "Plouigneau",
    "dep": "Finistère"
  },
  {
    "code": "29810",
    "ville": "Ploumoguer",
    "dep": "Finistère"
  },
  {
    "code": "29410",
    "ville": "Plounéour-Ménez",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Plounéventer",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Plounévézel",
    "dep": "Finistère"
  },
  {
    "code": "29430",
    "ville": "Plounévez-Lochrist",
    "dep": "Finistère"
  },
  {
    "code": "29600",
    "ville": "Plourin-lès-Morlaix",
    "dep": "Finistère"
  },
  {
    "code": "29830",
    "ville": "Plourin",
    "dep": "Finistère"
  },
  {
    "code": "29860",
    "ville": "Plouvien",
    "dep": "Finistère"
  },
  {
    "code": "29420",
    "ville": "Plouvorn",
    "dep": "Finistère"
  },
  {
    "code": "29690",
    "ville": "Plouyé",
    "dep": "Finistère"
  },
  {
    "code": "29280",
    "ville": "Plouzané",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Plouzévédé",
    "dep": "Finistère"
  },
  {
    "code": "29720",
    "ville": "Plovan",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Plozévet",
    "dep": "Finistère"
  },
  {
    "code": "29700",
    "ville": "Pluguffan",
    "dep": "Finistère"
  },
  {
    "code": "29930",
    "ville": "Pont-Aven",
    "dep": "Finistère"
  },
  {
    "code": "29790",
    "ville": "Pont-Croix",
    "dep": "Finistère"
  },
  {
    "code": "29120",
    "ville": "Pont-l'Abbé",
    "dep": "Finistère"
  },
  {
    "code": "29840",
    "ville": "Porspoder",
    "dep": "Finistère"
  },
  {
    "code": "29150",
    "ville": "Port-Launay",
    "dep": "Finistère"
  },
  {
    "code": "29100",
    "ville": "Pouldergat",
    "dep": "Finistère"
  },
  {
    "code": "29710",
    "ville": "Pouldreuzic",
    "dep": "Finistère"
  },
  {
    "code": "29100",
    "ville": "Poullan-sur-Mer",
    "dep": "Finistère"
  },
  {
    "code": "29246",
    "ville": "Poullaouen",
    "dep": "Finistère"
  },
  {
    "code": "29770",
    "ville": "Primelin",
    "dep": "Finistère"
  },
  {
    "code": "29180",
    "ville": "Quéménéven",
    "dep": "Finistère"
  },
  {
    "code": "29310",
    "ville": "Querrien",
    "dep": "Finistère"
  },
  {
    "code": "29000",
    "ville": "Quimper",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Quimperlé",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Rédené",
    "dep": "Finistère"
  },
  {
    "code": "29480",
    "ville": "Le Relecq-Kerhuon",
    "dep": "Finistère"
  },
  {
    "code": "29340",
    "ville": "Riec-sur-Bélon",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "La Roche-Maurice",
    "dep": "Finistère"
  },
  {
    "code": "29570",
    "ville": "Roscanvel",
    "dep": "Finistère"
  },
  {
    "code": "29680",
    "ville": "Roscoff",
    "dep": "Finistère"
  },
  {
    "code": "29590",
    "ville": "Rosnoën",
    "dep": "Finistère"
  },
  {
    "code": "29140",
    "ville": "Rosporden",
    "dep": "Finistère"
  },
  {
    "code": "29150",
    "ville": "Saint-Coulitz",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Saint-Derrien",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Saint-Divy",
    "dep": "Finistère"
  },
  {
    "code": "29460",
    "ville": "Saint-Eloy",
    "dep": "Finistère"
  },
  {
    "code": "29170",
    "ville": "Saint-Évarzec",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Saint-Frégant",
    "dep": "Finistère"
  },
  {
    "code": "29520",
    "ville": "Saint-Goazec",
    "dep": "Finistère"
  },
  {
    "code": "29270",
    "ville": "Saint-Hernin",
    "dep": "Finistère"
  },
  {
    "code": "29630",
    "ville": "Saint-Jean-du-Doigt",
    "dep": "Finistère"
  },
  {
    "code": "29120",
    "ville": "Saint-Jean-Trolimon",
    "dep": "Finistère"
  },
  {
    "code": "29600",
    "ville": "Saint-Martin-des-Champs",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Saint-Méen",
    "dep": "Finistère"
  },
  {
    "code": "29550",
    "ville": "Saint-Nic",
    "dep": "Finistère"
  },
  {
    "code": "29830",
    "ville": "Saint-Pabu",
    "dep": "Finistère"
  },
  {
    "code": "29250",
    "ville": "Saint-Pol-de-Léon",
    "dep": "Finistère"
  },
  {
    "code": "29290",
    "ville": "Saint-Renan",
    "dep": "Finistère"
  },
  {
    "code": "29190",
    "ville": "Saint-Rivoal",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Saint-Sauveur",
    "dep": "Finistère"
  },
  {
    "code": "29590",
    "ville": "Saint-Ségal",
    "dep": "Finistère"
  },
  {
    "code": "29400",
    "ville": "Saint-Servais",
    "dep": "Finistère"
  },
  {
    "code": "29600",
    "ville": "Sainte-Sève",
    "dep": "Finistère"
  },
  {
    "code": "29410",
    "ville": "Saint-Thégonnec Loc-Eguiner",
    "dep": "Finistère"
  },
  {
    "code": "29520",
    "ville": "Saint-Thois",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Saint-Thonan",
    "dep": "Finistère"
  },
  {
    "code": "29380",
    "ville": "Saint-Thurien",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Saint-Urbain",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Saint-Vougay",
    "dep": "Finistère"
  },
  {
    "code": "29140",
    "ville": "Saint-Yvi",
    "dep": "Finistère"
  },
  {
    "code": "29250",
    "ville": "Santec",
    "dep": "Finistère"
  },
  {
    "code": "29390",
    "ville": "Scaër",
    "dep": "Finistère"
  },
  {
    "code": "29640",
    "ville": "Scrignac",
    "dep": "Finistère"
  },
  {
    "code": "29250",
    "ville": "Sibiril",
    "dep": "Finistère"
  },
  {
    "code": "29450",
    "ville": "Sizun",
    "dep": "Finistère"
  },
  {
    "code": "29540",
    "ville": "Spézet",
    "dep": "Finistère"
  },
  {
    "code": "29670",
    "ville": "Taulé",
    "dep": "Finistère"
  },
  {
    "code": "29560",
    "ville": "Telgruc-sur-Mer",
    "dep": "Finistère"
  },
  {
    "code": "29140",
    "ville": "Tourch",
    "dep": "Finistère"
  },
  {
    "code": "29217",
    "ville": "Trébabu",
    "dep": "Finistère"
  },
  {
    "code": "29730",
    "ville": "Treffiagat",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Tréflaouénan",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Tréflévénez",
    "dep": "Finistère"
  },
  {
    "code": "29430",
    "ville": "Tréflez",
    "dep": "Finistère"
  },
  {
    "code": "29260",
    "ville": "Trégarantec",
    "dep": "Finistère"
  },
  {
    "code": "29560",
    "ville": "Trégarvan",
    "dep": "Finistère"
  },
  {
    "code": "29870",
    "ville": "Tréglonou",
    "dep": "Finistère"
  },
  {
    "code": "29970",
    "ville": "Trégourez",
    "dep": "Finistère"
  },
  {
    "code": "29720",
    "ville": "Tréguennec",
    "dep": "Finistère"
  },
  {
    "code": "29910",
    "ville": "Trégunc",
    "dep": "Finistère"
  },
  {
    "code": "29450",
    "ville": "Le Tréhou",
    "dep": "Finistère"
  },
  {
    "code": "29800",
    "ville": "Trémaouézan",
    "dep": "Finistère"
  },
  {
    "code": "29120",
    "ville": "Tréméoc",
    "dep": "Finistère"
  },
  {
    "code": "29300",
    "ville": "Tréméven",
    "dep": "Finistère"
  },
  {
    "code": "29720",
    "ville": "Tréogat",
    "dep": "Finistère"
  },
  {
    "code": "29290",
    "ville": "Tréouergat",
    "dep": "Finistère"
  },
  {
    "code": "29380",
    "ville": "Le Trévoux",
    "dep": "Finistère"
  },
  {
    "code": "29440",
    "ville": "Trézilidé",
    "dep": "Finistère"
  },
  {
    "code": "29590",
    "ville": "Pont-de-Buis-lès-Quimerch",
    "dep": "Finistère"
  },
  {
    "code": "20167",
    "ville": "Afa",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20000",
    "ville": "Ajaccio",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Alata",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20128",
    "ville": "Albitreccia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20112",
    "ville": "Altagène",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20151",
    "ville": "Ambiegna",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Appietto",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20110",
    "ville": "Arbellara",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Arbori",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Argiusta-Moriccio",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20151",
    "ville": "Arro",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20116",
    "ville": "Aullène",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20190",
    "ville": "Azilone-Ampaza",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20121",
    "ville": "Azzana",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Balogna",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20119",
    "ville": "Bastelica",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20129",
    "ville": "Bastelicaccia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20110",
    "ville": "Belvédère-Campomoro",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Bilia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20136",
    "ville": "Bocognano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20169",
    "ville": "Bonifacio",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20111",
    "ville": "Calcatoggio",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20142",
    "ville": "Campo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20151",
    "ville": "Cannelle",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20170",
    "ville": "Carbini",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20133",
    "ville": "Carbuccia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20190",
    "ville": "Cardo-Torgia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20130",
    "ville": "Cargèse",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20164",
    "ville": "Cargiaca",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20111",
    "ville": "Casaglione",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Casalabriva",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20117",
    "ville": "Cauro",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20134",
    "ville": "Ciamannacce",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20118",
    "ville": "Coggia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20166",
    "ville": "Cognocoli-Monticchi",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20135",
    "ville": "Conca",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20168",
    "ville": "Corrano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20138",
    "ville": "Coti-Chiavari",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20148",
    "ville": "Cozzano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20126",
    "ville": "Cristinacce",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Cuttoli-Corticchiato",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20117",
    "ville": "Eccica-Suarella",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20126",
    "ville": "Évisa",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20114",
    "ville": "Figari",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Foce",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20190",
    "ville": "Forciolo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20143",
    "ville": "Fozzano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20157",
    "ville": "Frasseto",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Giuncheto",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Granace",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Grossa",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20128",
    "ville": "Grosseto-Prugna",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Guagno",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20128",
    "ville": "Guargualé",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20153",
    "ville": "Guitera-les-Bains",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20137",
    "ville": "Lecci",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Letia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20170",
    "ville": "Levie",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20139",
    "ville": "Lopigna",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20165",
    "ville": "Loreto-di-Tallano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20141",
    "ville": "Marignana",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20112",
    "ville": "Mela",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Moca-Croce",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20171",
    "ville": "Monacia-d'Aullène",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Murzo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20117",
    "ville": "Ocana",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Olivese",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20113",
    "ville": "Olmeto",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20112",
    "ville": "Olmiccia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20125",
    "ville": "Orto",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20147",
    "ville": "Osani",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20150",
    "ville": "Ota",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20134",
    "ville": "Palneca",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20147",
    "ville": "Partinello",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20121",
    "ville": "Pastricciola",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Peri",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Petreto-Bicchisano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20115",
    "ville": "Piana",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20131",
    "ville": "Pianottoli-Caldarello",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20166",
    "ville": "Pietrosella",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20123",
    "ville": "Pila-Canale",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Poggiolo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20137",
    "ville": "Porto-Vecchio",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20110",
    "ville": "Propriano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20142",
    "ville": "Quasquara",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20122",
    "ville": "Quenza",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Renno",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20121",
    "ville": "Rezza",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20121",
    "ville": "Rosazia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20121",
    "ville": "Salice",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20134",
    "ville": "Sampolo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20145",
    "ville": "Sari-Solenzara",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20151",
    "ville": "Sari-d'Orcino",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Sarrola-Carcopino",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20100",
    "ville": "Sartène",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Serra-di-Ferro",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20127",
    "ville": "Serra-di-Scopamène",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20147",
    "ville": "Serriera",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20125",
    "ville": "Soccia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20140",
    "ville": "Sollacaro",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20152",
    "ville": "Sorbollano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20146",
    "ville": "Sotta",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20151",
    "ville": "Sant'Andréa-d'Orcino",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20170",
    "ville": "San-Gavino-di-Carbini",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20112",
    "ville": "Sainte-Lucie-de-Tallano",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20143",
    "ville": "Santa-Maria-Figaniella",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20190",
    "ville": "Santa-Maria-Siché",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20134",
    "ville": "Tasso",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Tavaco",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20163",
    "ville": "Tavera",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20117",
    "ville": "Tolla",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20133",
    "ville": "Ucciani",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20128",
    "ville": "Urbalacone",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Valle-di-Mezzana",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20172",
    "ville": "Vero",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20160",
    "ville": "Vico",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20110",
    "ville": "Viggianello",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20167",
    "ville": "Villanova",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20116",
    "ville": "Zérubia",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20173",
    "ville": "Zévaco",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20132",
    "ville": "Zicavo",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20190",
    "ville": "Zigliara",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20144",
    "ville": "Zonza",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20112",
    "ville": "Zoza",
    "dep": "Corse-du-Sud"
  },
  {
    "code": "20270",
    "ville": "Aghione",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Aiti",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Alando",
    "dep": "Haute-Corse"
  },
  {
    "code": "20224",
    "ville": "Albertacce",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Aléria",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Algajola",
    "dep": "Haute-Corse"
  },
  {
    "code": "20251",
    "ville": "Altiani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Alzi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20272",
    "ville": "Ampriani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Antisanti",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Aregno",
    "dep": "Haute-Corse"
  },
  {
    "code": "20276",
    "ville": "Asco",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Avapessa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20253",
    "ville": "Barbaggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20228",
    "ville": "Barrettali",
    "dep": "Haute-Corse"
  },
  {
    "code": "20600",
    "ville": "Bastia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Belgodère",
    "dep": "Haute-Corse"
  },
  {
    "code": "20252",
    "ville": "Bigorno",
    "dep": "Haute-Corse"
  },
  {
    "code": "20620",
    "ville": "Biguglia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20235",
    "ville": "Bisinchi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Borgo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20222",
    "ville": "Brando",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Bustanico",
    "dep": "Haute-Corse"
  },
  {
    "code": "20228",
    "ville": "Cagnano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20224",
    "ville": "Calacuccia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20214",
    "ville": "Calenzana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20260",
    "ville": "Calvi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Cambia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Campana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Campi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Campile",
    "dep": "Haute-Corse"
  },
  {
    "code": "20252",
    "ville": "Campitello",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Canale-di-Verde",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Canari",
    "dep": "Haute-Corse"
  },
  {
    "code": "20235",
    "ville": "Canavaggia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Carcheto-Brustico",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Carpineto",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Carticasi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Casabianca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Casalta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20224",
    "ville": "Casamaccioli",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Casanova",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Casevecchie",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "Castellare-di-Casinca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Castellare-di-Mercurio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20235",
    "ville": "Castello-di-Rostino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Castifao",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Castiglione",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Castineta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20236",
    "ville": "Castirla",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Cateri",
    "dep": "Haute-Corse"
  },
  {
    "code": "20238",
    "ville": "Centuri",
    "dep": "Haute-Corse"
  },
  {
    "code": "20221",
    "ville": "Cervione",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Chiatra",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Corbara",
    "dep": "Haute-Corse"
  },
  {
    "code": "20224",
    "ville": "Corscia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Corte",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Costa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Croce",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Crocicchia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Erbajolo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Érone",
    "dep": "Haute-Corse"
  },
  {
    "code": "20275",
    "ville": "Ersa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20253",
    "ville": "Farinole",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Favalello",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Felce",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Feliceto",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Ficaja",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Focicchia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20600",
    "ville": "Furiani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20245",
    "ville": "Galéria",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Gavignano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Ghisonaccia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20227",
    "ville": "Ghisoni",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Giocatojo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20251",
    "ville": "Giuncaggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "L'Île-Rousse",
    "dep": "Haute-Corse"
  },
  {
    "code": "20243",
    "ville": "Isolaccio-di-Fiumorbo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Lama",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Lano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Lavatoggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20252",
    "ville": "Lento",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Linguizzetta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Loreto-di-Casinca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20224",
    "ville": "Lozzi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Lucciana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Lugo-di-Nazza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20260",
    "ville": "Lumio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20228",
    "ville": "Luri",
    "dep": "Haute-Corse"
  },
  {
    "code": "20245",
    "ville": "Manso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Matra",
    "dep": "Haute-Corse"
  },
  {
    "code": "20259",
    "ville": "Mausoléo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Mazzola",
    "dep": "Haute-Corse"
  },
  {
    "code": "20287",
    "ville": "Meria",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Moïta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Moltifao",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Monacia-d'Orezza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20214",
    "ville": "Moncale",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Monte",
    "dep": "Haute-Corse"
  },
  {
    "code": "20214",
    "ville": "Montegrosso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Monticello",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Morosaglia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20238",
    "ville": "Morsiglia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20219",
    "ville": "Muracciole",
    "dep": "Haute-Corse"
  },
  {
    "code": "20239",
    "ville": "Murato",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Muro",
    "dep": "Haute-Corse"
  },
  {
    "code": "20225",
    "ville": "Nessa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Nocario",
    "dep": "Haute-Corse"
  },
  {
    "code": "20242",
    "ville": "Noceta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Nonza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Novale",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Novella",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Occhiatana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Ogliastro",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Olcani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20232",
    "ville": "Oletta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Olmeta-di-Capocorso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20232",
    "ville": "Olmeta-di-Tuda",
    "dep": "Haute-Corse"
  },
  {
    "code": "20259",
    "ville": "Olmi-Cappella",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Olmo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20236",
    "ville": "Omessa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Ortale",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Ortiporio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Palasca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20251",
    "ville": "Pancheraccia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Parata",
    "dep": "Haute-Corse"
  },
  {
    "code": "20253",
    "ville": "Patrimonio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Penta-Acquatella",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "Penta-di-Casinca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Perelli",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Pero-Casevecchie",
    "dep": "Haute-Corse"
  },
  {
    "code": "20272",
    "ville": "Pianello",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Piano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Piazzali",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Piazzole",
    "dep": "Haute-Corse"
  },
  {
    "code": "20251",
    "ville": "Piedicorte-di-Gaggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Piedicroce",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Piedigriggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Piedipartino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Pie-d'Orezza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Pietralba",
    "dep": "Haute-Corse"
  },
  {
    "code": "20233",
    "ville": "Pietracorbara",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Pietra-di-Verde",
    "dep": "Haute-Corse"
  },
  {
    "code": "20251",
    "ville": "Pietraserena",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Pietricaggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20242",
    "ville": "Pietroso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20246",
    "ville": "Piève",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Pigna",
    "dep": "Haute-Corse"
  },
  {
    "code": "20228",
    "ville": "Pino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Piobetta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20259",
    "ville": "Pioggiola",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Poggio-di-Nazza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Poggio-di-Venaco",
    "dep": "Haute-Corse"
  },
  {
    "code": "20232",
    "ville": "Poggio-d'Oletta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Poggio-Marinaccio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Poggio-Mezzana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Polveroso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Popolasca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Porri",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "La Porta",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Prato-di-Giovellina",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Prunelli-di-Casacconi",
    "dep": "Haute-Corse"
  },
  {
    "code": "20243",
    "ville": "Prunelli-di-Fiumorbo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "Pruno",
    "dep": "Haute-Corse"
  },
  {
    "code": "20237",
    "ville": "Quercitello",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Rapaggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20246",
    "ville": "Rapale",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Riventosa",
    "dep": "Haute-Corse"
  },
  {
    "code": "20248",
    "ville": "Rogliano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20242",
    "ville": "Rospigliani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "Rusio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20239",
    "ville": "Rutali",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Saliceto",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "Scata",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Scolca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Sermano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20243",
    "ville": "Serra-di-Fiumorbo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Silvareccio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20233",
    "ville": "Sisco",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Solaro",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "Sorbo-Ocagnano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20246",
    "ville": "Sorio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Soveria",
    "dep": "Haute-Corse"
  },
  {
    "code": "20226",
    "ville": "Speloncato",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Stazzona",
    "dep": "Haute-Corse"
  },
  {
    "code": "20212",
    "ville": "Sant'Andréa-di-Bozio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20221",
    "ville": "Sant'Andréa-di-Cotone",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Sant'Antonino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "San-Damiano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Saint-Florent",
    "dep": "Haute-Corse"
  },
  {
    "code": "20213",
    "ville": "San-Gavino-d'Ampugnani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20246",
    "ville": "San-Gavino-di-Tenda",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "San-Giovanni-di-Moriani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "San-Giuliano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20244",
    "ville": "San-Lorenzo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20200",
    "ville": "San-Martino-di-Lota",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Santa-Lucia-di-Mercurio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Santa-Lucia-di-Moriani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20200",
    "ville": "Santa-Maria-di-Lota",
    "dep": "Haute-Corse"
  },
  {
    "code": "20221",
    "ville": "Santa-Maria-Poggio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "San-Nicolao",
    "dep": "Haute-Corse"
  },
  {
    "code": "20217",
    "ville": "Santo-Pietro-di-Tenda",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Santo-Pietro-di-Venaco",
    "dep": "Haute-Corse"
  },
  {
    "code": "20220",
    "ville": "Santa-Reparata-di-Balagna",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Santa-Reparata-di-Moriani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Taglio-Isolaccio",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Talasani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Tallone",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Tarrano",
    "dep": "Haute-Corse"
  },
  {
    "code": "20248",
    "ville": "Tomino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20270",
    "ville": "Tox",
    "dep": "Haute-Corse"
  },
  {
    "code": "20250",
    "ville": "Tralonca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20218",
    "ville": "Urtaca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20232",
    "ville": "Vallecalle",
    "dep": "Haute-Corse"
  },
  {
    "code": "20234",
    "ville": "Valle-d'Alesani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20221",
    "ville": "Valle-di-Campoloro",
    "dep": "Haute-Corse"
  },
  {
    "code": "20235",
    "ville": "Valle-di-Rostino",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Valle-d'Orezza",
    "dep": "Haute-Corse"
  },
  {
    "code": "20259",
    "ville": "Vallica",
    "dep": "Haute-Corse"
  },
  {
    "code": "20230",
    "ville": "Velone-Orneto",
    "dep": "Haute-Corse"
  },
  {
    "code": "20231",
    "ville": "Venaco",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Ventiseri",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Venzolasca",
    "dep": "Haute-Corse"
  },
  {
    "code": "20229",
    "ville": "Verdèse",
    "dep": "Haute-Corse"
  },
  {
    "code": "20215",
    "ville": "Vescovato",
    "dep": "Haute-Corse"
  },
  {
    "code": "20242",
    "ville": "Vezzani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Vignale",
    "dep": "Haute-Corse"
  },
  {
    "code": "20279",
    "ville": "Ville-di-Paraso",
    "dep": "Haute-Corse"
  },
  {
    "code": "20200",
    "ville": "Ville-di-Pietrabugno",
    "dep": "Haute-Corse"
  },
  {
    "code": "20219",
    "ville": "Vivario",
    "dep": "Haute-Corse"
  },
  {
    "code": "20290",
    "ville": "Volpajola",
    "dep": "Haute-Corse"
  },
  {
    "code": "20272",
    "ville": "Zalana",
    "dep": "Haute-Corse"
  },
  {
    "code": "20214",
    "ville": "Zilia",
    "dep": "Haute-Corse"
  },
  {
    "code": "20272",
    "ville": "Zuani",
    "dep": "Haute-Corse"
  },
  {
    "code": "20243",
    "ville": "San-Gavino-di-Fiumorbo",
    "dep": "Haute-Corse"
  },
  {
    "code": "20240",
    "ville": "Chisa",
    "dep": "Haute-Corse"
  },
  {
    "code": "30700",
    "ville": "Aigaliers",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Aigremont",
    "dep": "Gard"
  },
  {
    "code": "30220",
    "ville": "Aigues-Mortes",
    "dep": "Gard"
  },
  {
    "code": "30670",
    "ville": "Aigues-Vives",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Aiguèze",
    "dep": "Gard"
  },
  {
    "code": "30470",
    "ville": "Aimargues",
    "dep": "Gard"
  },
  {
    "code": "30100",
    "ville": "Alès",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Allègre-les-Fumades",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Alzon",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Anduze",
    "dep": "Gard"
  },
  {
    "code": "30133",
    "ville": "Les Angles",
    "dep": "Gard"
  },
  {
    "code": "30390",
    "ville": "Aramon",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Argilliers",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Arpaillargues-et-Aureillac",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Arphy",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Arre",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Arrigas",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Aspères",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Aubais",
    "dep": "Gard"
  },
  {
    "code": "30620",
    "ville": "Aubord",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Aubussargues",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Aujac",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Aujargues",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Aulas",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Aumessas",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Avèze",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Bagard",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Bagnols-sur-Cèze",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Barjac",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Baron",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "La Bastide-d'Engras",
    "dep": "Gard"
  },
  {
    "code": "30300",
    "ville": "Beaucaire",
    "dep": "Gard"
  },
  {
    "code": "30640",
    "ville": "Beauvoisin",
    "dep": "Gard"
  },
  {
    "code": "30127",
    "ville": "Bellegarde",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Belvézet",
    "dep": "Gard"
  },
  {
    "code": "30620",
    "ville": "Bernis",
    "dep": "Gard"
  },
  {
    "code": "30160",
    "ville": "Bessèges",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Bez-et-Esparon",
    "dep": "Gard"
  },
  {
    "code": "30320",
    "ville": "Bezouce",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Blandas",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Blauzac",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Boisset-et-Gaujac",
    "dep": "Gard"
  },
  {
    "code": "30114",
    "ville": "Boissières",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Bonnevaux",
    "dep": "Gard"
  },
  {
    "code": "30160",
    "ville": "Bordezac",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Boucoiran-et-Nozières",
    "dep": "Gard"
  },
  {
    "code": "30230",
    "ville": "Bouillargues",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Bouquet",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Bourdic",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Bragassargues",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Branoux-les-Taillades",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Bréau-Mars",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Brignon",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Brouzet-lès-Quissac",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Brouzet-lès-Alès",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "La Bruguière",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Cabrières",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "La Cadière-et-Cambo",
    "dep": "Gard"
  },
  {
    "code": "30740",
    "ville": "Le Cailar",
    "dep": "Gard"
  },
  {
    "code": "30132",
    "ville": "Caissargues",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "La Calmette",
    "dep": "Gard"
  },
  {
    "code": "30420",
    "ville": "Calvisson",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Campestre-et-Luc",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Canaules-et-Argentières",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Cannes-et-Clairan",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "La Capelle-et-Masmolène",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Cardet",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Carnas",
    "dep": "Gard"
  },
  {
    "code": "30130",
    "ville": "Carsan",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Cassagnoles",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Castelnau-Valence",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Castillon-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Causse-Bégon",
    "dep": "Gard"
  },
  {
    "code": "30820",
    "ville": "Caveirac",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Cavillargues",
    "dep": "Gard"
  },
  {
    "code": "30480",
    "ville": "Cendras",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Chambon",
    "dep": "Gard"
  },
  {
    "code": "30530",
    "ville": "Chamborigaud",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Chusclan",
    "dep": "Gard"
  },
  {
    "code": "30870",
    "ville": "Clarensac",
    "dep": "Gard"
  },
  {
    "code": "30920",
    "ville": "Codognan",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Codolet",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Collias",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Collorgues",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Colognac",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Combas",
    "dep": "Gard"
  },
  {
    "code": "30300",
    "ville": "Comps",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Concoules",
    "dep": "Gard"
  },
  {
    "code": "30111",
    "ville": "Congénies",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Connaux",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Conqueyrac",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Corbès",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Corconne",
    "dep": "Gard"
  },
  {
    "code": "30630",
    "ville": "Cornillon",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Courry",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Crespian",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Cros",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Cruviers-Lascours",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Deaux",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Dions",
    "dep": "Gard"
  },
  {
    "code": "30390",
    "ville": "Domazan",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Domessargues",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Dourbies",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Durfort-et-Saint-Martin-de-Sossenac",
    "dep": "Gard"
  },
  {
    "code": "30390",
    "ville": "Estézargues",
    "dep": "Gard"
  },
  {
    "code": "30124",
    "ville": "L'Estréchure",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Euzet",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Flaux",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Foissac",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Fons",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Fons-sur-Lussan",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Fontanès",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Fontarèches",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Fournès",
    "dep": "Gard"
  },
  {
    "code": "30300",
    "ville": "Fourques",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Fressac",
    "dep": "Gard"
  },
  {
    "code": "30160",
    "ville": "Gagnières",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Gailhan",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Gajan",
    "dep": "Gard"
  },
  {
    "code": "30660",
    "ville": "Gallargues-le-Montueux",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Le Garn",
    "dep": "Gard"
  },
  {
    "code": "30128",
    "ville": "Garons",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Garrigues-Sainte-Eulalie",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Gaujac",
    "dep": "Gard"
  },
  {
    "code": "30510",
    "ville": "Générac",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Générargues",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Génolhac",
    "dep": "Gard"
  },
  {
    "code": "30630",
    "ville": "Goudargues",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "La Grand-Combe",
    "dep": "Gard"
  },
  {
    "code": "30240",
    "ville": "Le Grau-du-Roi",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Issirac",
    "dep": "Gard"
  },
  {
    "code": "30300",
    "ville": "Jonquières-Saint-Vincent",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Junas",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Lamelouze",
    "dep": "Gard"
  },
  {
    "code": "30980",
    "ville": "Langlade",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Lanuéjols",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Lasalle",
    "dep": "Gard"
  },
  {
    "code": "30290",
    "ville": "Laudun-l'Ardoise",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Laval-Pradel",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Laval-Saint-Roman",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Lecques",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Lédenon",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Lédignan",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Lézan",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Liouc",
    "dep": "Gard"
  },
  {
    "code": "30126",
    "ville": "Lirac",
    "dep": "Gard"
  },
  {
    "code": "30610",
    "ville": "Logrian-Florian",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Lussan",
    "dep": "Gard"
  },
  {
    "code": "30960",
    "ville": "Les Mages",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Malons-et-Elze",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Mandagout",
    "dep": "Gard"
  },
  {
    "code": "30129",
    "ville": "Manduel",
    "dep": "Gard"
  },
  {
    "code": "30320",
    "ville": "Marguerittes",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Martignargues",
    "dep": "Gard"
  },
  {
    "code": "30960",
    "ville": "Le Martinet",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Maruéjols-lès-Gardon",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Massanes",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Massillargues-Attuech",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Mauressargues",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Méjannes-le-Clap",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Méjannes-lès-Alès",
    "dep": "Gard"
  },
  {
    "code": "30840",
    "ville": "Meynes",
    "dep": "Gard"
  },
  {
    "code": "30410",
    "ville": "Meyrannes",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Mialet",
    "dep": "Gard"
  },
  {
    "code": "30540",
    "ville": "Milhaud",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Molières-Cavaillac",
    "dep": "Gard"
  },
  {
    "code": "30410",
    "ville": "Molières-sur-Cèze",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Monoblet",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Mons",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Montaren-et-Saint-Médiers",
    "dep": "Gard"
  },
  {
    "code": "30630",
    "ville": "Montclus",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Montdardier",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Monteils",
    "dep": "Gard"
  },
  {
    "code": "30150",
    "ville": "Montfaucon",
    "dep": "Gard"
  },
  {
    "code": "30490",
    "ville": "Montfrin",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Montignargues",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Montmirat",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Montpezat",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Moulézan",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Moussac",
    "dep": "Gard"
  },
  {
    "code": "30121",
    "ville": "Mus",
    "dep": "Gard"
  },
  {
    "code": "30114",
    "ville": "Nages-et-Solorgues",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Navacelles",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Ners",
    "dep": "Gard"
  },
  {
    "code": "30900",
    "ville": "Nîmes",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Orsan",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Orthoux-Sérignac-Quilhan",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Parignargues",
    "dep": "Gard"
  },
  {
    "code": "30160",
    "ville": "Peyremale",
    "dep": "Gard"
  },
  {
    "code": "30124",
    "ville": "Peyrolles",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Le Pin",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Les Plans",
    "dep": "Gard"
  },
  {
    "code": "30122",
    "ville": "Les Plantiers",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Pommiers",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Pompignan",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Ponteils-et-Brésis",
    "dep": "Gard"
  },
  {
    "code": "30130",
    "ville": "Pont-Saint-Esprit",
    "dep": "Gard"
  },
  {
    "code": "30530",
    "ville": "Portes",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Potelières",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Pougnadoresse",
    "dep": "Gard"
  },
  {
    "code": "30320",
    "ville": "Poulx",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Pouzilhac",
    "dep": "Gard"
  },
  {
    "code": "30610",
    "ville": "Puechredon",
    "dep": "Gard"
  },
  {
    "code": "30131",
    "ville": "Pujaut",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Quissac",
    "dep": "Gard"
  },
  {
    "code": "30129",
    "ville": "Redessan",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Remoulins",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Revens",
    "dep": "Gard"
  },
  {
    "code": "30720",
    "ville": "Ribaute-les-Tavernes",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Rivières",
    "dep": "Gard"
  },
  {
    "code": "30160",
    "ville": "Robiac-Rochessadoule",
    "dep": "Gard"
  },
  {
    "code": "30650",
    "ville": "Rochefort-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Rochegude",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Rogues",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Roquedur",
    "dep": "Gard"
  },
  {
    "code": "30150",
    "ville": "Roquemaure",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "La Roque-sur-Cèze",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Rousson",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "La Rouvière",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Sabran",
    "dep": "Gard"
  },
  {
    "code": "30130",
    "ville": "Saint-Alexandre",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Saint-Ambroix",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Sainte-Anastasie",
    "dep": "Gard"
  },
  {
    "code": "30570",
    "ville": "Saint-André-de-Majencoules",
    "dep": "Gard"
  },
  {
    "code": "30630",
    "ville": "Saint-André-de-Roquepertuis",
    "dep": "Gard"
  },
  {
    "code": "30940",
    "ville": "Saint-André-de-Valborgne",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Saint-André-d'Olérargues",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Saint-Bauzély",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Saint-Bénézet",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Saint-Bonnet-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Saint-Bonnet-de-Salendrinque",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Saint-Brès",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Saint-Bresson",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Sainte-Cécile-d'Andorge",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Saint-Césaire-de-Gauzignan",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Saint-Chaptes",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Saint-Christol-de-Rodières",
    "dep": "Gard"
  },
  {
    "code": "30380",
    "ville": "Saint-Christol-lez-Alès",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Saint-Clément",
    "dep": "Gard"
  },
  {
    "code": "30870",
    "ville": "Saint-Côme-et-Maruéjols",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Sainte-Croix-de-Caderle",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Saint-Denis",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Saint-Dézéry",
    "dep": "Gard"
  },
  {
    "code": "30980",
    "ville": "Saint-Dionisy",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Saint-Étienne-de-l'Olm",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Saint-Étienne-des-Sorts",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Saint-Félix-de-Pallières",
    "dep": "Gard"
  },
  {
    "code": "30960",
    "ville": "Saint-Florent-sur-Auzonnet",
    "dep": "Gard"
  },
  {
    "code": "30150",
    "ville": "Saint-Geniès-de-Comolas",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Saint-Geniès-de-Malgoirès",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Saint-Gervais",
    "dep": "Gard"
  },
  {
    "code": "30320",
    "ville": "Saint-Gervasy",
    "dep": "Gard"
  },
  {
    "code": "30800",
    "ville": "Saint-Gilles",
    "dep": "Gard"
  },
  {
    "code": "30560",
    "ville": "Saint-Hilaire-de-Brethmas",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Saint-Hilaire-d'Ozilhan",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Saint-Hippolyte-de-Caton",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Saint-Hippolyte-de-Montaigu",
    "dep": "Gard"
  },
  {
    "code": "30170",
    "ville": "Saint-Hippolyte-du-Fort",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Saint-Jean-de-Ceyrargues",
    "dep": "Gard"
  },
  {
    "code": "30610",
    "ville": "Saint-Jean-de-Crieulon",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Saint-Jean-de-Maruéjols-et-Avéjan",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Saint-Jean-de-Serres",
    "dep": "Gard"
  },
  {
    "code": "30960",
    "ville": "Saint-Jean-de-Valériscle",
    "dep": "Gard"
  },
  {
    "code": "30270",
    "ville": "Saint-Jean-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Saint-Jean-du-Pin",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Saint-Julien-de-Cassagnas",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Saint-Julien-de-la-Nef",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Saint-Julien-de-Peyrolas",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Saint-Julien-les-Rosiers",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Saint-Just-et-Vacquières",
    "dep": "Gard"
  },
  {
    "code": "30220",
    "ville": "Saint-Laurent-d'Aigouze",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Saint-Laurent-de-Carnols",
    "dep": "Gard"
  },
  {
    "code": "30126",
    "ville": "Saint-Laurent-des-Arbres",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Saint-Laurent-la-Vernède",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Saint-Laurent-le-Minier",
    "dep": "Gard"
  },
  {
    "code": "30730",
    "ville": "Saint-Mamert-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Saint-Marcel-de-Careiret",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Saint-Martial",
    "dep": "Gard"
  },
  {
    "code": "30520",
    "ville": "Saint-Martin-de-Valgalgues",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Saint-Maurice-de-Cazevieille",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Saint-Maximin",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Saint-Michel-d'Euzet",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Saint-Nazaire",
    "dep": "Gard"
  },
  {
    "code": "30610",
    "ville": "Saint-Nazaire-des-Gardies",
    "dep": "Gard"
  },
  {
    "code": "30130",
    "ville": "Saint-Paulet-de-Caisson",
    "dep": "Gard"
  },
  {
    "code": "30480",
    "ville": "Saint-Paul-la-Coste",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Saint-Pons-la-Calm",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Saint-Privat-de-Champclos",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Saint-Privat-des-Vieux",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Saint-Quentin-la-Poterie",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Saint-Roman-de-Codières",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Saint-Sauveur-Camprieu",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Saint-Sébastien-d'Aigrefeuille",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Saint-Siffret",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Saint-Théodorit",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Saint-Victor-des-Oules",
    "dep": "Gard"
  },
  {
    "code": "30290",
    "ville": "Saint-Victor-la-Coste",
    "dep": "Gard"
  },
  {
    "code": "30500",
    "ville": "Saint-Victor-de-Malcap",
    "dep": "Gard"
  },
  {
    "code": "30760",
    "ville": "Salazac",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Salindres",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Salinelles",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Les Salles-du-Gardon",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Sanilhac-Sagriès",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Sardan",
    "dep": "Gard"
  },
  {
    "code": "30125",
    "ville": "Saumane",
    "dep": "Gard"
  },
  {
    "code": "30610",
    "ville": "Sauve",
    "dep": "Gard"
  },
  {
    "code": "30150",
    "ville": "Sauveterre",
    "dep": "Gard"
  },
  {
    "code": "30190",
    "ville": "Sauzet",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Savignargues",
    "dep": "Gard"
  },
  {
    "code": "30650",
    "ville": "Saze",
    "dep": "Gard"
  },
  {
    "code": "30450",
    "ville": "Sénéchas",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Sernhac",
    "dep": "Gard"
  },
  {
    "code": "30340",
    "ville": "Servas",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Serviers-et-Labaume",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Seynes",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Sommières",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Soudorgues",
    "dep": "Gard"
  },
  {
    "code": "30110",
    "ville": "Soustelle",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Souvignargues",
    "dep": "Gard"
  },
  {
    "code": "30440",
    "ville": "Sumène",
    "dep": "Gard"
  },
  {
    "code": "30126",
    "ville": "Tavel",
    "dep": "Gard"
  },
  {
    "code": "30430",
    "ville": "Tharaux",
    "dep": "Gard"
  },
  {
    "code": "30390",
    "ville": "Théziers",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Thoiras",
    "dep": "Gard"
  },
  {
    "code": "30140",
    "ville": "Tornac",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Tresques",
    "dep": "Gard"
  },
  {
    "code": "30750",
    "ville": "Trèves",
    "dep": "Gard"
  },
  {
    "code": "30620",
    "ville": "Uchaud",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Uzès",
    "dep": "Gard"
  },
  {
    "code": "30460",
    "ville": "Vabres",
    "dep": "Gard"
  },
  {
    "code": "30300",
    "ville": "Vallabrègues",
    "dep": "Gard"
  },
  {
    "code": "30700",
    "ville": "Vallabrix",
    "dep": "Gard"
  },
  {
    "code": "30580",
    "ville": "Vallérargues",
    "dep": "Gard"
  },
  {
    "code": "30570",
    "ville": "Val-d'Aigoual",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Valliguières",
    "dep": "Gard"
  },
  {
    "code": "30600",
    "ville": "Vauvert",
    "dep": "Gard"
  },
  {
    "code": "30200",
    "ville": "Vénéjan",
    "dep": "Gard"
  },
  {
    "code": "30630",
    "ville": "Verfeuil",
    "dep": "Gard"
  },
  {
    "code": "30310",
    "ville": "Vergèze",
    "dep": "Gard"
  },
  {
    "code": "30530",
    "ville": "La Vernarède",
    "dep": "Gard"
  },
  {
    "code": "30210",
    "ville": "Vers-Pont-du-Gard",
    "dep": "Gard"
  },
  {
    "code": "30600",
    "ville": "Vestric-et-Candiac",
    "dep": "Gard"
  },
  {
    "code": "30360",
    "ville": "Vézénobres",
    "dep": "Gard"
  },
  {
    "code": "30260",
    "ville": "Vic-le-Fesq",
    "dep": "Gard"
  },
  {
    "code": "30120",
    "ville": "Le Vigan",
    "dep": "Gard"
  },
  {
    "code": "30400",
    "ville": "Villeneuve-lès-Avignon",
    "dep": "Gard"
  },
  {
    "code": "30250",
    "ville": "Villevieille",
    "dep": "Gard"
  },
  {
    "code": "30770",
    "ville": "Vissec",
    "dep": "Gard"
  },
  {
    "code": "30350",
    "ville": "Montagnac",
    "dep": "Gard"
  },
  {
    "code": "30330",
    "ville": "Saint-Paul-les-Fonts",
    "dep": "Gard"
  },
  {
    "code": "30230",
    "ville": "Rodilhan",
    "dep": "Gard"
  },
  {
    "code": "31230",
    "ville": "Agassac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31550",
    "ville": "Aignes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31280",
    "ville": "Aigrefeuille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Ayguesvives",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Alan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Albiac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Ambax",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Anan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Antichan-de-Frontignes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Antignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Arbas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Arbon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Ardiège",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Arguenos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Argut-Dessous",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Arlos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Arnaud-Guilhem",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Artigue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Aspet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Aspret-Sarrat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Aucamville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Aulon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Auragne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Aureville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Auriac-sur-Vendinelle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Auribail",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Aurignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Aurin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Ausseing",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Ausson",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31840",
    "ville": "Aussonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Auterive",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Auzas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Auzeville-Tolosane",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31650",
    "ville": "Auzielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Avignonet-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Azas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Bachas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Bachos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Bagiry",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Bagnères-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Balesta",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31130",
    "ville": "Balma",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Barbazan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Baren",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Bax",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Baziège",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Bazus",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Beauchalot",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Beaufort",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31870",
    "ville": "Beaumont-sur-Lèze",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31850",
    "ville": "Beaupuy",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Beauteville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Beauville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31700",
    "ville": "Beauzelle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Belberaud",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Belbèze-de-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Belbèze-en-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Bélesta-en-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Bellegarde-Sainte-Marie",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Bellesserre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Benque",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Benque-Dessous-et-Dessus",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Bérat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31660",
    "ville": "Bessières",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Bezins-Garraux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Billière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31700",
    "ville": "Blagnac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Blajan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Bois-de-la-Pierre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Boissède",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Bondigoux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Bonrepos-Riquet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Bonrepos-sur-Aussonnelle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Bordes-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Le Born",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Boudrac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Bouloc",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Boulogne-sur-Gesse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Bourg-d'Oueil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Bourg-Saint-Bernard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Boussan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Boussens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Boutx",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Bouzin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Bragayrac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31490",
    "ville": "Brax",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Bretx",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Brignemont",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31150",
    "ville": "Bruguières",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Burgalays",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Le Burgaud",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31660",
    "ville": "Buzet-sur-Tarn",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Cabanac-Cazaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Cabanac-Séguenville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Le Cabanial",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Cadours",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Caignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Calmont",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Cambernard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Cambiac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Canens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Capens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Caragoudes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Caraman",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Carbonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Cardeilhac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Cassagnabère-Tournas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Cassagne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Castagnac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Castagnède",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Castanet-Tolosan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Castelbiague",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Castelgaillard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31780",
    "ville": "Castelginest",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31180",
    "ville": "Castelmaurou",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Castelnau-d'Estrétefonds",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Castelnau-Picampeau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Le Castéra",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Castéra-Vignoles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Casties-Labrande",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Castillon-de-Larboust",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Castillon-de-Saint-Martory",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Cathervielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Caubiac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Caubous",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Caujac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Cazarilh-Laspènes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Cazaril-Tambourès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Cazaunous",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Cazaux-Layrisse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Cazeaux-de-Larboust",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Cazeneuve-Montaut",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Cazères",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Cépet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Cessales",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Charlas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Chaum",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Chein-Dessus",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Ciadoux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Cier-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Cier-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Cierp-Gaud",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31550",
    "ville": "Cintegabelle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Cirès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Clarac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31810",
    "ville": "Clermont-le-Fort",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31770",
    "ville": "Colomiers",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31700",
    "ville": "Cornebarrieu",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Corronsac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Coueilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Couladère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Couret",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Cox",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31270",
    "ville": "Cugnaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Cuguron",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Le Cuing",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31700",
    "ville": "Daux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Deyme",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Donneville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31280",
    "ville": "Drémil-Lafage",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Drudas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Eaunes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Empeaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Encausse-les-Thermes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Eoux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31750",
    "ville": "Escalquens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Escanecrabe",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Espanès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Esparron",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Esperce",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Estadens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Estancarbon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Esténos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Eup",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Fabas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Le Faget",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Falga",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Le Fauga",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31150",
    "ville": "Fenouillet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Figarol",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31130",
    "ville": "Flourens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Folcarde",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Fonbeauzard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Fonsorbes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Fontenilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Forgues",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Fos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Fougaron",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Fourquevaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Le Fousseret",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Francarville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Francazal",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Francon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Franquevielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Le Fréchet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Fronsac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Frontignan-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Frontignan-Savès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Fronton",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31270",
    "ville": "Frouzins",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Fustignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31150",
    "ville": "Gagnac-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31550",
    "ville": "Gaillac-Toulza",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Galié",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Ganties",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Garac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Gardouch",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Gargas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Garidech",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Garin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Gauré",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Gémil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Génos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Gensac-de-Boulogne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Gensac-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Gibel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Gouaux-de-Larboust",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Gouaux-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Goudex",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Gourdan-Polignan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Goutevernisse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Gouzens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Goyrans",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Gragnague",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Gratens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31150",
    "ville": "Gratentour",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Grazac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Grenade",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Grépiac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Le Grès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Guran",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Herran",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "His",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Huos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "L'Isle-en-Dodon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Issus",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Izaut-de-l'Hôtel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Jurvielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Juzes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Juzet-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Juzet-d'Izaut",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Labarthe-Inard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Labarthe-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31860",
    "ville": "Labarthe-sur-Lèze",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Labastide-Beauvoir",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Labastide-Clermont",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Labastide-Paumès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Labastide-Saint-Sernin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Labastidette",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31670",
    "ville": "Labège",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Labroquère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Labruyère-Dorsa",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Lacaugne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Lacroix-Falgarde",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Laffite-Toupière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Lafitte-Vigordane",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Lagarde",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31870",
    "ville": "Lagardelle-sur-Lèze",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Lagrâce-Dieu",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Lagraulet-Saint-Nicolas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Lahage",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Lahitère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Lalouret-Laffiteau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Lamasquère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Landorthe",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Lanta",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Lapeyrère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31180",
    "ville": "Lapeyrouse-Fossat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Larcan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Laréole",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Larroque",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Lasserre-Pradère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Latoue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Latour",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Latrape",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Launac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Launaguet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Lautignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31650",
    "ville": "Lauzerville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Lavalette",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Lavelanet-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Lavernose-Lacasse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Layrac-sur-Tarn",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Lécussan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Lège",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31490",
    "ville": "Léguevin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Lescuns",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31150",
    "ville": "Lespinasse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Lespiteau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Lespugue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Lestelle-de-Saint-Martory",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Lévignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Lherm",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Lieoux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Lilhac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Lodes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Longages",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Loubens-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Loudet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Lourde",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Luscan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Lussan-Adeilhac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Lux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "La Magdelaine-sur-Tarn",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Mailholas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Malvezie",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Mancioux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Mane",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Marignac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Marignac-Lasclares",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Marignac-Laspeyres",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31550",
    "ville": "Marliac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Marquefave",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Marsoulas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Martisserre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Martres-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Martres-Tolosane",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Mascarville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Massabrac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Mauran",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Mauremont",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Maurens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Mauressac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Maureville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Mauvaisin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Mauvezin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Mauzac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Mayrègne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Mazères-sur-Salat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Melles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Menville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Mérenvielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Mervilla",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Merville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Milhas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Mirambeau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Miramont-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Miremont",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Mirepoix-sur-Tarn",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Molas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Moncaup",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Mondavezan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Mondilhan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31700",
    "ville": "Mondonville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31850",
    "ville": "Mondouzil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Monès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Monestrol",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31280",
    "ville": "Mons",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Montaigut-sur-Save",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Montastruc-de-Salies",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Montastruc-la-Conseillère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Montastruc-Savès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Montauban-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Montaut",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Montberaud",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Montbernard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Montberon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Montbrun-Bocage",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Montbrun-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Montclar-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Montclar-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Mont-de-Galié",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Montégut-Bourjac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Montégut-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Montespan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Montesquieu-Guittaut",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Montesquieu-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Montesquieu-Volvestre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Montgaillard-de-Salies",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Montgaillard-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Montgaillard-sur-Save",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Montgazin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Montgeard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Montgiscard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Montgras",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Montjoire",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Montlaur",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Montmaurin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Montoulieu-Saint-Bernard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Montoussin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Montpitol",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31850",
    "ville": "Montrabé",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Montréjeau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Montsaunès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Mourvilles-Basses",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Mourvilles-Hautes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Moustajon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Muret",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Nailloux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Nénigan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Nizan-Gesse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Noé",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Nogaret",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Noueilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Odars",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Ondes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Oô",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Ore",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Palaminy",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Paulhac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Payssous",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Péchabou",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Pechbonnieu",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Pechbusque",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Péguilhan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Pelleport",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Peyrissas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Peyrouzet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Peyssies",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31820",
    "ville": "Pibrac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31130",
    "ville": "Pin-Balma",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Le Pin-Murelet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Pinsaguel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31860",
    "ville": "Pins-Justaret",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Plagne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Plagnole",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31830",
    "ville": "Plaisance-du-Touch",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Le Plan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Pointis-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Pointis-Inard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Polastron",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Pompertuzat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Ponlat-Taillebourg",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Portet-d'Aspet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Portet-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Portet-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Poubeau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Poucharramet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Pouy-de-Touges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Pouze",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Préserville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Proupiary",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Prunet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31190",
    "ville": "Puydaniel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Puymaurin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Puysségur",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31130",
    "ville": "Quint-Fonsegrives",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31520",
    "ville": "Ramonville-Saint-Agne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Razecueillé",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Rebigue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Régades",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Renneville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31250",
    "ville": "Revel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Rieucazé",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Rieumajou",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Rieumes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Rieux-Volvestre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Riolas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Roquefort-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Roques",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Roquesérière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31120",
    "ville": "Roquettes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Rouède",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31180",
    "ville": "Rouffiac-Tolosan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Roumens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Sabonnères",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Saccourvielle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Saiguède",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Saint-Alban",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Saint-André",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Saint-Araille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Saint-Aventin",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Saint-Béat-Lez",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Saint-Bertrand-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Saint-Cézert",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31310",
    "ville": "Saint-Christaud",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Saint-Clar-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Saint-Élix-le-Château",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Saint-Élix-Séglan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Saint-Félix-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Saint-Ferréol-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Sainte-Foy-d'Aigrefeuille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Sainte-Foy-de-Peyrolières",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Saint-Frajou",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Saint-Gaudens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31180",
    "ville": "Saint-Geniès-Bellevue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Saint-Germier",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Saint-Hilaire",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Saint-Ignan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31240",
    "ville": "Saint-Jean",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Saint-Jean-Lherm",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31790",
    "ville": "Saint-Jory",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Saint-Julia",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Saint-Julien-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Saint-Lary-Boujean",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Saint-Laurent",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Saint-Léon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Sainte-Livrade",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31140",
    "ville": "Saint-Loup-Cammas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Saint-Loup-en-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Saint-Lys",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Saint-Mamet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Saint-Marcel-Paulel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Saint-Marcet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Saint-Martory",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Saint-Médard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Saint-Michel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31650",
    "ville": "Saint-Orens-de-Gameville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Saint-Paul-sur-Save",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Saint-Paul-d'Oueil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Saint-Pé-d'Ardet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Saint-Pé-Delbosc",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Saint-Pierre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Saint-Pierre-de-Lages",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Saint-Plancard",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Saint-Rome",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Saint-Rustice",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31790",
    "ville": "Saint-Sauveur",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31410",
    "ville": "Saint-Sulpice-sur-Lèze",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31470",
    "ville": "Saint-Thomas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Saint-Vincent",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Sajas",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Saleich",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Salerm",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Salies-du-Salat",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Salles-et-Pratviel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31390",
    "ville": "Salles-sur-Garonne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31880",
    "ville": "La Salvetat-Saint-Gilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "La Salvetat-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Saman",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Samouillan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31220",
    "ville": "Sana",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Sarrecave",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31350",
    "ville": "Sarremezan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Saubens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Saussens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Sauveterre-de-Comminges",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Saux-et-Pomarède",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Savarthès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31370",
    "ville": "Savères",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Sédeilhac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Ségreville",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31840",
    "ville": "Seilh",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Seilhan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31430",
    "ville": "Sénarens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Sengouagnet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31360",
    "ville": "Sepx",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31560",
    "ville": "Seyre",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31600",
    "ville": "Seysses",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Signac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Sode",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31160",
    "ville": "Soueich",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Tarabel",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31420",
    "ville": "Terrebasse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31530",
    "ville": "Thil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Touille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31100",
    "ville": "Toulouse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31210",
    "ville": "Les Tourreilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31170",
    "ville": "Tournefeuille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Toutens",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31110",
    "ville": "Trébons-de-Luchon",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Trébons-sur-la-Grasse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31240",
    "ville": "L'Union",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Urau",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Vacquiers",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31510",
    "ville": "Valcabrère",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Valentine",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Vallègue",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31570",
    "ville": "Vallesvilles",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31450",
    "ville": "Varennes",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31250",
    "ville": "Vaudreuille",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31540",
    "ville": "Vaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31460",
    "ville": "Vendine",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31810",
    "ville": "Venerque",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31590",
    "ville": "Verfeil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31810",
    "ville": "Vernet",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Vieille-Toulouse",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Vieillevigne",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31480",
    "ville": "Vignaux",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31320",
    "ville": "Vigoulet-Auzil",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31380",
    "ville": "Villariès",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31860",
    "ville": "Villate",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Villaudric",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Villefranche-de-Lauragais",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Villematier",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31340",
    "ville": "Villemur-sur-Tarn",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31800",
    "ville": "Villeneuve-de-Rivière",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31580",
    "ville": "Villeneuve-Lécussan",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31620",
    "ville": "Villeneuve-lès-Bouloc",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31270",
    "ville": "Villeneuve-Tolosane",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31290",
    "ville": "Villenouvelle",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31440",
    "ville": "Binos",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31260",
    "ville": "Escoulis",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31330",
    "ville": "Larra",
    "dep": "Haute-Garonne"
  },
  {
    "code": "31230",
    "ville": "Cazac",
    "dep": "Haute-Garonne"
  },
  {
    "code": "32290",
    "ville": "Aignan",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Ansan",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Antras",
    "dep": "Gers"
  },
  {
    "code": "32720",
    "ville": "Arblade-le-Bas",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Arblade-le-Haut",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Ardizas",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Armentieux",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Armous-et-Cau",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Arrouède",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Aubiet",
    "dep": "Gers"
  },
  {
    "code": "32000",
    "ville": "Auch",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Augnax",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Aujan-Mournède",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Auradé",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Aurensan",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Aurimont",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Auterive",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Aux-Aussat",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Avensac",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Avéron-Bergelle",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Avezan",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Ayguetinte",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Ayzieu",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Bajonnette",
    "dep": "Gers"
  },
  {
    "code": "32720",
    "ville": "Barcelonne-du-Gers",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Barcugnan",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Barran",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Bars",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Bascous",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Bassoues",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Bazian",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Bazugues",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Beaucaire",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Beaumarchés",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Beaumont",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Beaupuy",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Beccas",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Bédéchan",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Bellegarde",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Belloc-Saint-Clamens",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Belmont",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Béraut",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Berdoues",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Bernède",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Berrac",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Betcave-Aguin",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Bétous",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Betplan",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Bézéril",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Bezolles",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Bézues-Bajon",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Biran",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Bivès",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Blanquefort",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Blaziert",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Blousson-Sérian",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Bonas",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Boucagnères",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Boulaur",
    "dep": "Gers"
  },
  {
    "code": "32370",
    "ville": "Bourrouillan",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Bouzon-Gellenave",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Bretagne-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Le Brouilh-Monbert",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Brugnens",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Cabas-Loumassès",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Cadeilhan",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Cadeillan",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Cahuzac-sur-Adour",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Caillavet",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Callian",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Campagne-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Cassaigne",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Castelnau-Barbarens",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Castelnau-d'Anglès",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Castelnau-d'Arbieu",
    "dep": "Gers"
  },
  {
    "code": "32440",
    "ville": "Castelnau d'Auzan Labarrère",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Castelnau-sur-l'Auvignon",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Castelnavet",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Castéra-Lectourois",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Castéra-Verduzan",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Castéron",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Castet-Arrouy",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Castex",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Castex-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Castillon-Debats",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Castillon-Massas",
    "dep": "Gers"
  },
  {
    "code": "32490",
    "ville": "Castillon-Savès",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Castin",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Catonvielle",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Caumont",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Caupenne-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Caussens",
    "dep": "Gers"
  },
  {
    "code": "32150",
    "ville": "Cazaubon",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Cazaux-d'Anglès",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Cazaux-Savès",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Cazaux-Villecomtal",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Cazeneuve",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Céran",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Cézan",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Chélan",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Clermont-Pouyguillès",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Clermont-Savès",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Cologne",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Condom",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Corneillan",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Couloumé-Mondebat",
    "dep": "Gers"
  },
  {
    "code": "32330",
    "ville": "Courrensan",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Courties",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Crastes",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Cravencères",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Cuélas",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Dému",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Duffort",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Duran",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Durban",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Eauze",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Encausse",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Endoufielle",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Esclassan-Labastide",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Escornebœuf",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Espaon",
    "dep": "Gers"
  },
  {
    "code": "32370",
    "ville": "Espas",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Estampes",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Estang",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Estipouy",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Estramiac",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Faget-Abbatial",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Flamarens",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Fleurance",
    "dep": "Gers"
  },
  {
    "code": "32250",
    "ville": "Fourcès",
    "dep": "Gers"
  },
  {
    "code": "32490",
    "ville": "Frégouville",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Fustérouau",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Galiax",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Garravet",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Gaudonville",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Gaujac",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Gaujan",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Gavarret-sur-Aulouste",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Gazaupouy",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Gazax-et-Baccarisse",
    "dep": "Gers"
  },
  {
    "code": "32720",
    "ville": "Gée-Rivière",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Gimbrède",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Gimont",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Giscaro",
    "dep": "Gers"
  },
  {
    "code": "32330",
    "ville": "Gondrin",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Goutz",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Goux",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Haget",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Haulies",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Homps",
    "dep": "Gers"
  },
  {
    "code": "32460",
    "ville": "Le Houga",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Idrac-Respaillès",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "L'Isle-Arné",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "L'Isle-Bouzon",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "L'Isle-de-Noé",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "L'Isle-Jourdain",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Izotges",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Jegun",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Jû-Belloc",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Juillac",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Juilles",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Justian",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Laas",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Labarthe",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Labarthète",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Labastide-Savès",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Labéjan",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Labrihe",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Ladevèze-Rivière",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Ladevèze-Ville",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Lagarde",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Lagarde-Hachan",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Lagardère",
    "dep": "Gers"
  },
  {
    "code": "32330",
    "ville": "Lagraulet-du-Gers",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Laguian-Mazous",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Lahas",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Lahitte",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Lalanne",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Lalanne-Arqué",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Lamaguère",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Lamazère",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Lamothe-Goas",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Lannemaignan",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Lannepax",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Lanne-Soubiran",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Lannux",
    "dep": "Gers"
  },
  {
    "code": "32150",
    "ville": "Larée",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Larressingle",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Larroque-Engalin",
    "dep": "Gers"
  },
  {
    "code": "32410",
    "ville": "Larroque-Saint-Sernin",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Larroque-sur-l'Osse",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Lartigue",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Lasserrade",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Lasséran",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Lasseube-Propre",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Laujuzan",
    "dep": "Gers"
  },
  {
    "code": "32330",
    "ville": "Lauraët",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Lavardens",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Laveraët",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Laymont",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Leboulin",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Lectoure",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Lelin-Lapujolle",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Lias",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Lias-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Ligardes",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Lombez",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Loubédat",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Loubersan",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Lourties-Monbrun",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Louslitges",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Loussous-Débat",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Lupiac",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Luppé-Violles",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Lussan",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Magnan",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Magnas",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Maignaut-Tauzia",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Malabat",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Manas-Bastanous",
    "dep": "Gers"
  },
  {
    "code": "32370",
    "ville": "Manciet",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Manent-Montané",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Mansempuy",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Mansencôme",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Marambat",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Maravat",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Marciac",
    "dep": "Gers"
  },
  {
    "code": "32490",
    "ville": "Marestaing",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Margouët-Meymes",
    "dep": "Gers"
  },
  {
    "code": "32150",
    "ville": "Marguestau",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Marsan",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Marseillan",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Marsolan",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Mascaras",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Mas-d'Auvignon",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Masseube",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Mauléon-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Maulichères",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Maumusson-Laguian",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Maupas",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Maurens",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Mauroux",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Mauvezin",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Meilhan",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Mérens",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Miélan",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Miradoux",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Miramont-d'Astarac",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Miramont-Latour",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Mirande",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Mirannes",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Mirepoix",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Monbardon",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Monblanc",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Monbrun",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Moncassin",
    "dep": "Gers"
  },
  {
    "code": "32150",
    "ville": "Monclar",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Monclar-sur-Losse",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Moncorneil-Grazan",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Monferran-Plavès",
    "dep": "Gers"
  },
  {
    "code": "32490",
    "ville": "Monferran-Savès",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Monfort",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Mongausy",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Monguilhem",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Monlaur-Bernet",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Monlezun",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Monlezun-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Monpardiac",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Montadet",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Montamat",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Montaut",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Montaut-les-Créneaux",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Mont-d'Astarac",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Mont-de-Marrast",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Montégut",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Montégut-Arros",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Montégut-Savès",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Montesquiou",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Montestruc-sur-Gers",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Monties",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Montiron",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Montpezat",
    "dep": "Gers"
  },
  {
    "code": "32250",
    "ville": "Montréal",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Mormès",
    "dep": "Gers"
  },
  {
    "code": "32330",
    "ville": "Mouchan",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Mouchès",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Mourède",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Nizas",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Nogaro",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Noilhan",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Nougaroulet",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Noulens",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Orbessan",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Ordan-Larroque",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Ornézan",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Pallanne",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Panassac",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Panjas",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Pauilhac",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Pavie",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Pébées",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Pellefigue",
    "dep": "Gers"
  },
  {
    "code": "32460",
    "ville": "Perchède",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Pergain-Taillac",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Pessan",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Pessoulens",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Peyrecave",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Peyrusse-Grande",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Peyrusse-Massas",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Peyrusse-Vieille",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Pis",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Plaisance",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Plieux",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Polastron",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Pompiac",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Ponsampère",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Ponsan-Soubiran",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Pouydraguin",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Pouylebon",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Pouy-Loubrin",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Pouy-Roquelaure",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Préchac",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Préchac-sur-Adour",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Preignan",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Préneron",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Projan",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Pujaudran",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Puycasquier",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Puylausic",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Puységur",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Ramouzens",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Razengues",
    "dep": "Gers"
  },
  {
    "code": "32800",
    "ville": "Réans",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Réjaumont",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Ricourt",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Riguepeu",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Riscle",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "La Romieu",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Roquebrune",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Roquefort",
    "dep": "Gers"
  },
  {
    "code": "32810",
    "ville": "Roquelaure",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Roquelaure-Saint-Aubin",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Roquepine",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Roques",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Rozès",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Sabaillan",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Sabazan",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Sadeillan",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Saint-André",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Sainte-Anne",
    "dep": "Gers"
  },
  {
    "code": "32340",
    "ville": "Saint-Antoine",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Saint-Antonin",
    "dep": "Gers"
  },
  {
    "code": "32350",
    "ville": "Saint-Arailles",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Arroman",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Saint-Aunix-Lengros",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Sainte-Aurence-Cazaux",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Saint-Avit-Frandat",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Saint-Blancard",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Saint-Brès",
    "dep": "Gers"
  },
  {
    "code": "32320",
    "ville": "Saint-Christaud",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Sainte-Christie",
    "dep": "Gers"
  },
  {
    "code": "32370",
    "ville": "Sainte-Christie-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Saint-Clar",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Saint-Créac",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Saint-Cricq",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Sainte-Dode",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Saint-Élix-d'Astarac",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Élix-Theux",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Sainte-Gemme",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Saint-Georges",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Saint-Germé",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Saint-Germier",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Saint-Griède",
    "dep": "Gers"
  },
  {
    "code": "32550",
    "ville": "Saint-Jean-le-Comtal",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Saint-Jean-Poutge",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Saint-Justin",
    "dep": "Gers"
  },
  {
    "code": "32360",
    "ville": "Saint-Lary",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Saint-Léonard",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Saint-Lizier-du-Planté",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Saint-Loube",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Sainte-Marie",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Martin",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Saint-Martin-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32480",
    "ville": "Saint-Martin-de-Goyne",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Saint-Martin-Gimois",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Maur",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Médard",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Sainte-Mère",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Saint-Mézard",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Michel",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Saint-Mont",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Saint-Orens",
    "dep": "Gers"
  },
  {
    "code": "32100",
    "ville": "Saint-Orens-Pouy-Petit",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Saint-Ost",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Saint-Paul-de-Baïse",
    "dep": "Gers"
  },
  {
    "code": "32290",
    "ville": "Saint-Pierre-d'Aubézies",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Saint-Puy",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Sainte-Radegonde",
    "dep": "Gers"
  },
  {
    "code": "32270",
    "ville": "Saint-Sauvy",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Saint-Soulan",
    "dep": "Gers"
  },
  {
    "code": "32370",
    "ville": "Salles-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Samaran",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Samatan",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Sansan",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Saramon",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Sarcos",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Sarragachies",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Sarraguzan",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Sarrant",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "La Sauvetat",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Sauveterre",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Sauviac",
    "dep": "Gers"
  },
  {
    "code": "32220",
    "ville": "Sauvimont",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Savignac-Mona",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Scieurac-et-Flourès",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Séailles",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Ségos",
    "dep": "Gers"
  },
  {
    "code": "32600",
    "ville": "Ségoufielle",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Seissan",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Sembouès",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Sémézies-Cachan",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Sempesserre",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Sère",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Sérempuy",
    "dep": "Gers"
  },
  {
    "code": "32130",
    "ville": "Seysses-Savès",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Simorre",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Sion",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Sirac",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Solomiac",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Sorbets",
    "dep": "Gers"
  },
  {
    "code": "32260",
    "ville": "Tachoires",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Tarsac",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Tasque",
    "dep": "Gers"
  },
  {
    "code": "32120",
    "ville": "Taybosc",
    "dep": "Gers"
  },
  {
    "code": "32700",
    "ville": "Terraube",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Termes-d'Armagnac",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Thoux",
    "dep": "Gers"
  },
  {
    "code": "32160",
    "ville": "Tieste-Uragnoux",
    "dep": "Gers"
  },
  {
    "code": "32170",
    "ville": "Tillac",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Tirent-Pontéjac",
    "dep": "Gers"
  },
  {
    "code": "32430",
    "ville": "Touget",
    "dep": "Gers"
  },
  {
    "code": "32240",
    "ville": "Toujouse",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Tourdun",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Tournan",
    "dep": "Gers"
  },
  {
    "code": "32380",
    "ville": "Tournecoupe",
    "dep": "Gers"
  },
  {
    "code": "32390",
    "ville": "Tourrenquets",
    "dep": "Gers"
  },
  {
    "code": "32450",
    "ville": "Traversères",
    "dep": "Gers"
  },
  {
    "code": "32230",
    "ville": "Troncens",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Tudelle",
    "dep": "Gers"
  },
  {
    "code": "32500",
    "ville": "Urdens",
    "dep": "Gers"
  },
  {
    "code": "32110",
    "ville": "Urgosse",
    "dep": "Gers"
  },
  {
    "code": "32310",
    "ville": "Valence-sur-Baïse",
    "dep": "Gers"
  },
  {
    "code": "32720",
    "ville": "Vergoignan",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Verlus",
    "dep": "Gers"
  },
  {
    "code": "32190",
    "ville": "Vic-Fezensac",
    "dep": "Gers"
  },
  {
    "code": "32400",
    "ville": "Viella",
    "dep": "Gers"
  },
  {
    "code": "32730",
    "ville": "Villecomtal-sur-Arros",
    "dep": "Gers"
  },
  {
    "code": "32420",
    "ville": "Villefranche-d'Astarac",
    "dep": "Gers"
  },
  {
    "code": "32300",
    "ville": "Viozan",
    "dep": "Gers"
  },
  {
    "code": "32200",
    "ville": "Saint-Caprais",
    "dep": "Gers"
  },
  {
    "code": "32140",
    "ville": "Aussos",
    "dep": "Gers"
  },
  {
    "code": "33230",
    "ville": "Abzac",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Aillas",
    "dep": "Gironde"
  },
  {
    "code": "33440",
    "ville": "Ambarès-et-Lagrave",
    "dep": "Gironde"
  },
  {
    "code": "33810",
    "ville": "Ambès",
    "dep": "Gironde"
  },
  {
    "code": "33510",
    "ville": "Andernos-les-Bains",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Anglade",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Arbanats",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Porte-de-Benauge",
    "dep": "Gironde"
  },
  {
    "code": "33120",
    "ville": "Arcachon",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Arcins",
    "dep": "Gironde"
  },
  {
    "code": "33740",
    "ville": "Arès",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Arsac",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Artigues-près-Bordeaux",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Les Artigues-de-Lussac",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Arveyres",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Asques",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Aubiac",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Val de Virvée",
    "dep": "Gironde"
  },
  {
    "code": "33980",
    "ville": "Audenge",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Auriolles",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Auros",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Avensan",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Ayguemorte-les-Graves",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Bagas",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Baigneaux",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Balizac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Barie",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Baron",
    "dep": "Gironde"
  },
  {
    "code": "33114",
    "ville": "Le Barp",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Barsac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Bassanne",
    "dep": "Gironde"
  },
  {
    "code": "33530",
    "ville": "Bassens",
    "dep": "Gironde"
  },
  {
    "code": "33880",
    "ville": "Baurech",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Bayas",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Bayon-sur-Gironde",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Bazas",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Beautiran",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Bégadan",
    "dep": "Gironde"
  },
  {
    "code": "33130",
    "ville": "Bègles",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Béguey",
    "dep": "Gironde"
  },
  {
    "code": "33830",
    "ville": "Belin-Béliet",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Bellebat",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Bellefond",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Belvès-de-Castillon",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Bernos-Beaulac",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Berson",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Berthez",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Beychac-et-Caillau",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Bieujac",
    "dep": "Gironde"
  },
  {
    "code": "33380",
    "ville": "Biganos",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Les Billaux",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Birac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Blaignac",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Blaignan-Prignac",
    "dep": "Gironde"
  },
  {
    "code": "33290",
    "ville": "Blanquefort",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Blasimon",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Blésignac",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Bommes",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Bonnetan",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Bonzac",
    "dep": "Gironde"
  },
  {
    "code": "33300",
    "ville": "Bordeaux",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Bossugan",
    "dep": "Gironde"
  },
  {
    "code": "33270",
    "ville": "Bouliac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Bourdelles",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Bourg",
    "dep": "Gironde"
  },
  {
    "code": "33113",
    "ville": "Bourideys",
    "dep": "Gironde"
  },
  {
    "code": "33110",
    "ville": "Le Bouscat",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Brach",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Branne",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Brannens",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Braud-et-Saint-Louis",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Brouqueyran",
    "dep": "Gironde"
  },
  {
    "code": "33520",
    "ville": "Bruges",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Budos",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Cabanac-et-Villagrains",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Cabara",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Cadarsac",
    "dep": "Gironde"
  },
  {
    "code": "33140",
    "ville": "Cadaujac",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Cadillac-sur-Garonne",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Cadillac-en-Fronsadais",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Camarsac",
    "dep": "Gironde"
  },
  {
    "code": "33880",
    "ville": "Cambes",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Camblanes-et-Meynac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Camiac-et-Saint-Denis",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Camiran",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Camps-sur-l'Isle",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Campugnan",
    "dep": "Gironde"
  },
  {
    "code": "33610",
    "ville": "Canéjan",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Capian",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Caplong",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Captieux",
    "dep": "Gironde"
  },
  {
    "code": "33560",
    "ville": "Carbon-Blanc",
    "dep": "Gironde"
  },
  {
    "code": "33121",
    "ville": "Carcans",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Cardan",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Carignan-de-Bordeaux",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Cars",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Cartelègue",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Casseuil",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Castelmoron-d'Albret",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Castelnau-de-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Castelviel",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Castets et Castillon",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Castillon-la-Bataille",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Castres-Gironde",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Caudrot",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Caumont",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Cauvignac",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Cavignac",
    "dep": "Gironde"
  },
  {
    "code": "33113",
    "ville": "Cazalis",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Cazats",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Cazaugitat",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Cénac",
    "dep": "Gironde"
  },
  {
    "code": "33150",
    "ville": "Cenon",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Cérons",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Cessac",
    "dep": "Gironde"
  },
  {
    "code": "33610",
    "ville": "Cestas",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Cézac",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Chamadelle",
    "dep": "Gironde"
  },
  {
    "code": "33250",
    "ville": "Cissac-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Civrac-de-Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Civrac-sur-Dordogne",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Civrac-en-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Cleyrac",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Coimères",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Coirac",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Comps",
    "dep": "Gironde"
  },
  {
    "code": "33890",
    "ville": "Coubeyrac",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Couquèques",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Courpiac",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Cours-de-Monségur",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Cours-les-Bains",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Coutras",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Coutures",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Créon",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Croignon",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Cubnezais",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Cubzac-les-Ponts",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Cudos",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Cursan",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Cussac-Fort-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Daignac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Dardenac",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Daubèze",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Dieulivol",
    "dep": "Gironde"
  },
  {
    "code": "33860",
    "ville": "Donnezac",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Donzac",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Doulezon",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Les Églisottes-et-Chalaures",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Escaudes",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Escoussans",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Espiet",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Les Esseintes",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Étauliers",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Eynesse",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Eyrans",
    "dep": "Gironde"
  },
  {
    "code": "33320",
    "ville": "Eysines",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Faleyras",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Fargues",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Fargues-Saint-Hilaire",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Le Fieu",
    "dep": "Gironde"
  },
  {
    "code": "33270",
    "ville": "Floirac",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Flaujagues",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Floudès",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Fontet",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Fossès-et-Baleyssac",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Fours",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Francs",
    "dep": "Gironde"
  },
  {
    "code": "33126",
    "ville": "Fronsac",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Frontenac",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Gabarnac",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Gaillan-en-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Gajac",
    "dep": "Gironde"
  },
  {
    "code": "33133",
    "ville": "Galgon",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Gans",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Gardegan-et-Tourtirac",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Gauriac",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Gauriaguet",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Générac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Génissac",
    "dep": "Gironde"
  },
  {
    "code": "33890",
    "ville": "Gensac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Gironde-sur-Dropt",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Giscos",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Gornac",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Goualade",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Gours",
    "dep": "Gironde"
  },
  {
    "code": "33170",
    "ville": "Gradignan",
    "dep": "Gironde"
  },
  {
    "code": "33590",
    "ville": "Grayan-et-l'Hôpital",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Grézillac",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Grignols",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Guillac",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Guillos",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Guîtres",
    "dep": "Gironde"
  },
  {
    "code": "33470",
    "ville": "Gujan-Mestras",
    "dep": "Gironde"
  },
  {
    "code": "33185",
    "ville": "Le Haillan",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Haux",
    "dep": "Gironde"
  },
  {
    "code": "33125",
    "ville": "Hostens",
    "dep": "Gironde"
  },
  {
    "code": "33990",
    "ville": "Hourtin",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Hure",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Illats",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Isle-Saint-Georges",
    "dep": "Gironde"
  },
  {
    "code": "33450",
    "ville": "Izon",
    "dep": "Gironde"
  },
  {
    "code": "33590",
    "ville": "Jau-Dignac-et-Loirac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Jugazan",
    "dep": "Gironde"
  },
  {
    "code": "33890",
    "ville": "Juillac",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Labarde",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Labescau",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "La Brède",
    "dep": "Gironde"
  },
  {
    "code": "33680",
    "ville": "Lacanau",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Ladaux",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Lados",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Lagorce",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "La Lande-de-Fronsac",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Lamarque",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Lamothe-Landerron",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Lalande-de-Pomerol",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Landerrouat",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Landerrouet-sur-Ségur",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Landiras",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Langoiran",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Langon",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Lansac",
    "dep": "Gironde"
  },
  {
    "code": "33138",
    "ville": "Lanton",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Lapouyade",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Laroque",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Lartigue",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Laruscade",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Latresne",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Lavazan",
    "dep": "Gironde"
  },
  {
    "code": "33950",
    "ville": "Lège-Cap-Ferret",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Léogeats",
    "dep": "Gironde"
  },
  {
    "code": "33850",
    "ville": "Léognan",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Lerm-et-Musset",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Lesparre-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Lestiac-sur-Garonne",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Les Lèves-et-Thoumeyragues",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Libourne",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Lignan-de-Bazas",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Lignan-de-Bordeaux",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Ligueux",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Listrac-de-Durèze",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Listrac-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33310",
    "ville": "Lormont",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Loubens",
    "dep": "Gironde"
  },
  {
    "code": "33125",
    "ville": "Louchats",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Loupes",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Loupiac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Loupiac-de-la-Réole",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Lucmau",
    "dep": "Gironde"
  },
  {
    "code": "33290",
    "ville": "Ludon-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Lugaignac",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Lugasson",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Lugon-et-l'Île-du-Carnay",
    "dep": "Gironde"
  },
  {
    "code": "33830",
    "ville": "Lugos",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Lussac",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Macau",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Madirac",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Maransin",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Marcenais",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Margaux-Cantenac",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Margueron",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Marimbault",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Marions",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Marsas",
    "dep": "Gironde"
  },
  {
    "code": "33127",
    "ville": "Martignas-sur-Jalle",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Martillac",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Martres",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Masseilles",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Massugas",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Mauriac",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Mazères",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Mazion",
    "dep": "Gironde"
  },
  {
    "code": "33700",
    "ville": "Mérignac",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Mérignas",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Mesterrieux",
    "dep": "Gironde"
  },
  {
    "code": "33380",
    "ville": "Mios",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Mombrier",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Mongauzy",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Monprimblanc",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Monségur",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Montagne",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Montagoudin",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Montignac",
    "dep": "Gironde"
  },
  {
    "code": "33450",
    "ville": "Montussan",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Morizès",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Mouillac",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Mouliets-et-Villemartin",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Moulis-en-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Moulon",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Mourens",
    "dep": "Gironde"
  },
  {
    "code": "33990",
    "ville": "Naujac-sur-Mer",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Naujan-et-Postiac",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Néac",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Nérigean",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Neuffons",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Le Nizan",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Noaillac",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Noaillan",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Omet",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Ordonnac",
    "dep": "Gironde"
  },
  {
    "code": "33113",
    "ville": "Origne",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Paillet",
    "dep": "Gironde"
  },
  {
    "code": "33290",
    "ville": "Parempuyre",
    "dep": "Gironde"
  },
  {
    "code": "33250",
    "ville": "Pauillac",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Les Peintures",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Pellegrue",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Périssac",
    "dep": "Gironde"
  },
  {
    "code": "33600",
    "ville": "Pessac",
    "dep": "Gironde"
  },
  {
    "code": "33890",
    "ville": "Pessac-sur-Dordogne",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Petit-Palais-et-Cornemps",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Peujard",
    "dep": "Gironde"
  },
  {
    "code": "33290",
    "ville": "Le Pian-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Le Pian-sur-Garonne",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Pineuilh",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Plassac",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Pleine-Selve",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Podensac",
    "dep": "Gironde"
  },
  {
    "code": "33500",
    "ville": "Pomerol",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Pompéjac",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Pompignac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Pondaurat",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Porchères",
    "dep": "Gironde"
  },
  {
    "code": "33680",
    "ville": "Le Porge",
    "dep": "Gironde"
  },
  {
    "code": "33640",
    "ville": "Portets",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Le Pout",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Préchac",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Preignac",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Prignac-et-Marcamps",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Pugnac",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Puisseguin",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Pujols-sur-Ciron",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Pujols",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Le Puy",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Puybarban",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Puynormand",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Queyrac",
    "dep": "Gironde"
  },
  {
    "code": "33360",
    "ville": "Quinsac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Rauzan",
    "dep": "Gironde"
  },
  {
    "code": "33860",
    "ville": "Reignac",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "La Réole",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Rimons",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Riocaud",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Rions",
    "dep": "Gironde"
  },
  {
    "code": "33126",
    "ville": "La Rivière",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Roaillan",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Romagne",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Roquebrune",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "La Roquille",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Ruch",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Sablons",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Sadirac",
    "dep": "Gironde"
  },
  {
    "code": "33141",
    "ville": "Saillans",
    "dep": "Gironde"
  },
  {
    "code": "33126",
    "ville": "Saint-Aignan",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-André-de-Cubzac",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-André-du-Bois",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Saint-André-et-Appelles",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Saint-Androny",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Saint-Antoine-du-Queyret",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Saint-Antoine-sur-l'Isle",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Saint-Aubin-de-Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Saint-Aubin-de-Branne",
    "dep": "Gironde"
  },
  {
    "code": "33160",
    "ville": "Saint-Aubin-de-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Saint-Avit-de-Soulège",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Saint-Avit-Saint-Nazaire",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Brice",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Val-de-Livenne",
    "dep": "Gironde"
  },
  {
    "code": "33880",
    "ville": "Saint-Caprais-de-Bordeaux",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saint-Christoly-de-Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Saint-Christoly-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Christophe-des-Bardes",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Saint-Christophe-de-Double",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Saint-Cibard",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Saint-Ciers-d'Abzac",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Saint-Ciers-de-Canesse",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Saint-Ciers-sur-Gironde",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Sainte-Colombe",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Saint-Côme",
    "dep": "Gironde"
  },
  {
    "code": "33410",
    "ville": "Sainte-Croix-du-Mont",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Saint-Denis-de-Pile",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Émilion",
    "dep": "Gironde"
  },
  {
    "code": "33180",
    "ville": "Saint-Estèphe",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Étienne-de-Lisse",
    "dep": "Gironde"
  },
  {
    "code": "33560",
    "ville": "Sainte-Eulalie",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Saint-Exupéry",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Félix-de-Foncaude",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Saint-Ferme",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Sainte-Florence",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Sainte-Foy-la-Grande",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Sainte-Foy-la-Longue",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Sainte-Gemme",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Saint-Genès-de-Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Saint-Genès-de-Castillon",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-Genès-de-Fronsac",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Saint-Genès-de-Lombaud",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Saint-Genis-du-Bois",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Germain-de-Grave",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Saint-Germain-d'Esteuil",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Saint-Germain-du-Puch",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-Germain-de-la-Rivière",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-Gervais",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saint-Girons-d'Aiguevives",
    "dep": "Gironde"
  },
  {
    "code": "33480",
    "ville": "Sainte-Hélène",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Saint-Hilaire-de-la-Noaille",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Hilaire-du-Bois",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Hippolyte",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Saint-Jean-de-Blaignac",
    "dep": "Gironde"
  },
  {
    "code": "33127",
    "ville": "Saint-Jean-d'Illac",
    "dep": "Gironde"
  },
  {
    "code": "33250",
    "ville": "Saint-Julien-Beychevelle",
    "dep": "Gironde"
  },
  {
    "code": "33112",
    "ville": "Saint-Laurent-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-Laurent-d'Arce",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Laurent-des-Combes",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Laurent-du-Bois",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Saint-Laurent-du-Plan",
    "dep": "Gironde"
  },
  {
    "code": "33113",
    "ville": "Saint-Léger-de-Balson",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "Saint-Léon",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Saint-Loubert",
    "dep": "Gironde"
  },
  {
    "code": "33450",
    "ville": "Saint-Loubès",
    "dep": "Gironde"
  },
  {
    "code": "33440",
    "ville": "Saint-Louis-de-Montferrand",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Macaire",
    "dep": "Gironde"
  },
  {
    "code": "33125",
    "ville": "Saint-Magne",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Saint-Magne-de-Castillon",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Maixant",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Saint-Mariens",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Martial",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Saint-Martin-Lacaussade",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Saint-Martin-de-Laye",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Martin-de-Lerm",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Martin-de-Sescas",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Saint-Martin-du-Bois",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Martin-du-Puy",
    "dep": "Gironde"
  },
  {
    "code": "33230",
    "ville": "Saint-Médard-de-Guizières",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Saint-Médard-d'Eyrans",
    "dep": "Gironde"
  },
  {
    "code": "33160",
    "ville": "Saint-Médard-en-Jalles",
    "dep": "Gironde"
  },
  {
    "code": "33840",
    "ville": "Saint-Michel-de-Castelnau",
    "dep": "Gironde"
  },
  {
    "code": "33126",
    "ville": "Saint-Michel-de-Fronsac",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Saint-Michel-de-Rieufret",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Saint-Michel-de-Lapujade",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Saint-Morillon",
    "dep": "Gironde"
  },
  {
    "code": "33820",
    "ville": "Saint-Palais",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Saint-Pardon-de-Conques",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Saint-Paul",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Pey-d'Armens",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Saint-Pey-de-Castets",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Saint-Philippe-d'Aiguille",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Saint-Philippe-du-Seignal",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Saint-Pierre-d'Aurillac",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Saint-Pierre-de-Bat",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Saint-Pierre-de-Mons",
    "dep": "Gironde"
  },
  {
    "code": "33750",
    "ville": "Saint-Quentin-de-Baron",
    "dep": "Gironde"
  },
  {
    "code": "33220",
    "ville": "Saint-Quentin-de-Caplong",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Sainte-Radegonde",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Saint-Romain-la-Virvée",
    "dep": "Gironde"
  },
  {
    "code": "33250",
    "ville": "Saint-Sauveur",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Saint-Sauveur-de-Puynormand",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saint-Savin",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Saint-Selve",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Saint-Seurin-de-Bourg",
    "dep": "Gironde"
  },
  {
    "code": "33180",
    "ville": "Saint-Seurin-de-Cadourne",
    "dep": "Gironde"
  },
  {
    "code": "33390",
    "ville": "Saint-Seurin-de-Cursac",
    "dep": "Gironde"
  },
  {
    "code": "33660",
    "ville": "Saint-Seurin-sur-l'Isle",
    "dep": "Gironde"
  },
  {
    "code": "33190",
    "ville": "Saint-Sève",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Saint-Sulpice-de-Faleyrens",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Saint-Sulpice-de-Guilleragues",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Saint-Sulpice-de-Pommiers",
    "dep": "Gironde"
  },
  {
    "code": "33450",
    "ville": "Saint-Sulpice-et-Cameyrac",
    "dep": "Gironde"
  },
  {
    "code": "33113",
    "ville": "Saint-Symphorien",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Sainte-Terre",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Saint-Trojan",
    "dep": "Gironde"
  },
  {
    "code": "33440",
    "ville": "Saint-Vincent-de-Paul",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Saint-Vincent-de-Pertignas",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saint-Vivien-de-Blaye",
    "dep": "Gironde"
  },
  {
    "code": "33590",
    "ville": "Saint-Vivien-de-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Saint-Vivien-de-Monségur",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saint-Yzan-de-Soudiac",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Saint-Yzans-de-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33160",
    "ville": "Salaunes",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Sallebœuf",
    "dep": "Gironde"
  },
  {
    "code": "33770",
    "ville": "Salles",
    "dep": "Gironde"
  },
  {
    "code": "33350",
    "ville": "Les Salles-de-Castillon",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Samonac",
    "dep": "Gironde"
  },
  {
    "code": "33650",
    "ville": "Saucats",
    "dep": "Gironde"
  },
  {
    "code": "33920",
    "ville": "Saugon",
    "dep": "Gironde"
  },
  {
    "code": "33680",
    "ville": "Saumos",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Sauternes",
    "dep": "Gironde"
  },
  {
    "code": "33670",
    "ville": "La Sauve",
    "dep": "Gironde"
  },
  {
    "code": "33540",
    "ville": "Sauveterre-de-Guyenne",
    "dep": "Gironde"
  },
  {
    "code": "33430",
    "ville": "Sauviac",
    "dep": "Gironde"
  },
  {
    "code": "33124",
    "ville": "Savignac",
    "dep": "Gironde"
  },
  {
    "code": "33910",
    "ville": "Savignac-de-l'Isle",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Semens",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Sendets",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Sigalens",
    "dep": "Gironde"
  },
  {
    "code": "33690",
    "ville": "Sillas",
    "dep": "Gironde"
  },
  {
    "code": "33780",
    "ville": "Soulac-sur-Mer",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Soulignac",
    "dep": "Gironde"
  },
  {
    "code": "33790",
    "ville": "Soussac",
    "dep": "Gironde"
  },
  {
    "code": "33460",
    "ville": "Soussans",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Tabanac",
    "dep": "Gironde"
  },
  {
    "code": "33320",
    "ville": "Le Taillan-Médoc",
    "dep": "Gironde"
  },
  {
    "code": "33580",
    "ville": "Taillecavat",
    "dep": "Gironde"
  },
  {
    "code": "33590",
    "ville": "Talais",
    "dep": "Gironde"
  },
  {
    "code": "33400",
    "ville": "Talence",
    "dep": "Gironde"
  },
  {
    "code": "33760",
    "ville": "Targon",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Tarnès",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Tauriac",
    "dep": "Gironde"
  },
  {
    "code": "33570",
    "ville": "Tayac",
    "dep": "Gironde"
  },
  {
    "code": "33470",
    "ville": "Le Teich",
    "dep": "Gironde"
  },
  {
    "code": "33680",
    "ville": "Le Temple",
    "dep": "Gironde"
  },
  {
    "code": "33115",
    "ville": "La Teste-de-Buch",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Teuillac",
    "dep": "Gironde"
  },
  {
    "code": "33420",
    "ville": "Tizac-de-Curton",
    "dep": "Gironde"
  },
  {
    "code": "33620",
    "ville": "Tizac-de-Lapouyade",
    "dep": "Gironde"
  },
  {
    "code": "33210",
    "ville": "Toulenne",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Le Tourne",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Tresses",
    "dep": "Gironde"
  },
  {
    "code": "33125",
    "ville": "Le Tuzan",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Uzeste",
    "dep": "Gironde"
  },
  {
    "code": "33340",
    "ville": "Valeyrac",
    "dep": "Gironde"
  },
  {
    "code": "33870",
    "ville": "Vayres",
    "dep": "Gironde"
  },
  {
    "code": "33930",
    "ville": "Vendays-Montalivet",
    "dep": "Gironde"
  },
  {
    "code": "33590",
    "ville": "Vensac",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Vérac",
    "dep": "Gironde"
  },
  {
    "code": "33490",
    "ville": "Verdelais",
    "dep": "Gironde"
  },
  {
    "code": "33123",
    "ville": "Le Verdon-sur-Mer",
    "dep": "Gironde"
  },
  {
    "code": "33180",
    "ville": "Vertheuil",
    "dep": "Gironde"
  },
  {
    "code": "33330",
    "ville": "Vignonet",
    "dep": "Gironde"
  },
  {
    "code": "33730",
    "ville": "Villandraut",
    "dep": "Gironde"
  },
  {
    "code": "33141",
    "ville": "Villegouge",
    "dep": "Gironde"
  },
  {
    "code": "33550",
    "ville": "Villenave-de-Rions",
    "dep": "Gironde"
  },
  {
    "code": "33140",
    "ville": "Villenave-d'Ornon",
    "dep": "Gironde"
  },
  {
    "code": "33710",
    "ville": "Villeneuve",
    "dep": "Gironde"
  },
  {
    "code": "33720",
    "ville": "Virelade",
    "dep": "Gironde"
  },
  {
    "code": "33240",
    "ville": "Virsac",
    "dep": "Gironde"
  },
  {
    "code": "33370",
    "ville": "Yvrac",
    "dep": "Gironde"
  },
  {
    "code": "33380",
    "ville": "Marcheprime",
    "dep": "Gironde"
  },
  {
    "code": "34290",
    "ville": "Abeilhan",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Adissan",
    "dep": "Hérault"
  },
  {
    "code": "34300",
    "ville": "Agde",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Agel",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Agonès",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Aigne",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Aigues-Vives",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Les Aires",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Alignan-du-Vent",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Aniane",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Arboras",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Argelliers",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Aspiran",
    "dep": "Hérault"
  },
  {
    "code": "34820",
    "ville": "Assas",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Assignan",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Aumelas",
    "dep": "Hérault"
  },
  {
    "code": "34530",
    "ville": "Aumes",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Autignac",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Avène",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Azillanet",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Babeau-Bouldoux",
    "dep": "Hérault"
  },
  {
    "code": "34670",
    "ville": "Baillargues",
    "dep": "Hérault"
  },
  {
    "code": "34540",
    "ville": "Balaruc-les-Bains",
    "dep": "Hérault"
  },
  {
    "code": "34540",
    "ville": "Balaruc-le-Vieux",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Bassan",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Beaufort",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Beaulieu",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Bédarieux",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Bélarga",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Berlou",
    "dep": "Hérault"
  },
  {
    "code": "34550",
    "ville": "Bessan",
    "dep": "Hérault"
  },
  {
    "code": "34500",
    "ville": "Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Boisseron",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Boisset",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "La Boissière",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Le Bosc",
    "dep": "Hérault"
  },
  {
    "code": "34760",
    "ville": "Boujan-sur-Libron",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Le Bousquet-d'Orb",
    "dep": "Hérault"
  },
  {
    "code": "34140",
    "ville": "Bouzigues",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Brenas",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Brignac",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Brissac",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Buzignargues",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Cabrerolles",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Cabrières",
    "dep": "Hérault"
  },
  {
    "code": "34330",
    "ville": "Cambon-et-Salvergues",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Campagnan",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Campagne",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Camplong",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Candillargues",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Canet",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Capestang",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Carlencas-et-Levas",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Cassagnoles",
    "dep": "Hérault"
  },
  {
    "code": "34610",
    "ville": "Castanet-le-Haut",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Castelnau-de-Guers",
    "dep": "Hérault"
  },
  {
    "code": "34170",
    "ville": "Castelnau-le-Lez",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Castries",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "La Caunette",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Causse-de-la-Selle",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Causses-et-Veyran",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Caussiniojouls",
    "dep": "Hérault"
  },
  {
    "code": "34720",
    "ville": "Caux",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Le Caylar",
    "dep": "Hérault"
  },
  {
    "code": "34460",
    "ville": "Cazedarnes",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Cazevieille",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Cazilhac",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Cazouls-d'Hérault",
    "dep": "Hérault"
  },
  {
    "code": "34370",
    "ville": "Cazouls-lès-Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Cébazan",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Ceilhes-et-Rocozels",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Celles",
    "dep": "Hérault"
  },
  {
    "code": "34420",
    "ville": "Cers",
    "dep": "Hérault"
  },
  {
    "code": "34460",
    "ville": "Cessenon-sur-Orb",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Cesseras",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Ceyras",
    "dep": "Hérault"
  },
  {
    "code": "34830",
    "ville": "Clapiers",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Claret",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Clermont-l'Hérault",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Colombières-sur-Orb",
    "dep": "Hérault"
  },
  {
    "code": "34440",
    "ville": "Colombiers",
    "dep": "Hérault"
  },
  {
    "code": "34980",
    "ville": "Combaillaux",
    "dep": "Hérault"
  },
  {
    "code": "34240",
    "ville": "Combes",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Corneilhan",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Coulobres",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Courniou",
    "dep": "Hérault"
  },
  {
    "code": "34660",
    "ville": "Cournonsec",
    "dep": "Hérault"
  },
  {
    "code": "34660",
    "ville": "Cournonterral",
    "dep": "Hérault"
  },
  {
    "code": "34370",
    "ville": "Creissan",
    "dep": "Hérault"
  },
  {
    "code": "34920",
    "ville": "Le Crès",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Le Cros",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Cruzy",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Dio-et-Valquières",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Espondeilhan",
    "dep": "Hérault"
  },
  {
    "code": "34690",
    "ville": "Fabrègues",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Faugères",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Félines-Minervois",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Ferrals-les-Montagnes",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Ferrières-les-Verreries",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Ferrières-Poussarou",
    "dep": "Hérault"
  },
  {
    "code": "34510",
    "ville": "Florensac",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Fontanès",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Fontès",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Fos",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Fouzilhon",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Fozières",
    "dep": "Hérault"
  },
  {
    "code": "34330",
    "ville": "Fraisse-sur-Agout",
    "dep": "Hérault"
  },
  {
    "code": "34110",
    "ville": "Frontignan",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Gabian",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Galargues",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Ganges",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Garrigues",
    "dep": "Hérault"
  },
  {
    "code": "34770",
    "ville": "Gigean",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Gignac",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Gorniès",
    "dep": "Hérault"
  },
  {
    "code": "34790",
    "ville": "Grabels",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Graissessac",
    "dep": "Hérault"
  },
  {
    "code": "34820",
    "ville": "Guzargues",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Hérépian",
    "dep": "Hérault"
  },
  {
    "code": "34830",
    "ville": "Jacou",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Joncels",
    "dep": "Hérault"
  },
  {
    "code": "34725",
    "ville": "Jonquières",
    "dep": "Hérault"
  },
  {
    "code": "34990",
    "ville": "Juvignac",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Lacoste",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Lagamas",
    "dep": "Hérault"
  },
  {
    "code": "34240",
    "ville": "Lamalou-les-Bains",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Lansargues",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Laroque",
    "dep": "Hérault"
  },
  {
    "code": "34970",
    "ville": "Lattes",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Laurens",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Lauret",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Lauroux",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Lavalette",
    "dep": "Hérault"
  },
  {
    "code": "34880",
    "ville": "Lavérune",
    "dep": "Hérault"
  },
  {
    "code": "34710",
    "ville": "Lespignan",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Lézignan-la-Cèbe",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Liausson",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Lieuran-Cabrières",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Lieuran-lès-Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Lignan-sur-Orb",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "La Livinière",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Lodève",
    "dep": "Hérault"
  },
  {
    "code": "34140",
    "ville": "Loupian",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Lunas",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Lunel",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Lunel-Viel",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Magalas",
    "dep": "Hérault"
  },
  {
    "code": "34370",
    "ville": "Maraussan",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Margon",
    "dep": "Hérault"
  },
  {
    "code": "34340",
    "ville": "Marseillan",
    "dep": "Hérault"
  },
  {
    "code": "34590",
    "ville": "Marsillargues",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Mas-de-Londres",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Les Matelles",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Mauguio",
    "dep": "Hérault"
  },
  {
    "code": "34370",
    "ville": "Maureilhan",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Mérifons",
    "dep": "Hérault"
  },
  {
    "code": "34140",
    "ville": "Mèze",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Minerve",
    "dep": "Hérault"
  },
  {
    "code": "34110",
    "ville": "Mireval",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Mons",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Montady",
    "dep": "Hérault"
  },
  {
    "code": "34530",
    "ville": "Montagnac",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Montarnaud",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Montaud",
    "dep": "Hérault"
  },
  {
    "code": "34560",
    "ville": "Montbazin",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Montblanc",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Montels",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Montesquieu",
    "dep": "Hérault"
  },
  {
    "code": "34980",
    "ville": "Montferrier-sur-Lez",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Montouliers",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Montoulieu",
    "dep": "Hérault"
  },
  {
    "code": "34080",
    "ville": "Montpellier",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Montpeyroux",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Moulès-et-Baucels",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Mourèze",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Mudaison",
    "dep": "Hérault"
  },
  {
    "code": "34980",
    "ville": "Murles",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Murviel-lès-Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Murviel-lès-Montpellier",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Nébian",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Neffiès",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Nézignan-l'Évêque",
    "dep": "Hérault"
  },
  {
    "code": "34440",
    "ville": "Nissan-lez-Enserune",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Nizas",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Notre-Dame-de-Londres",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Octon",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Olargues",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Olmet-et-Villecun",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Olonzac",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Oupia",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Pailhès",
    "dep": "Hérault"
  },
  {
    "code": "34250",
    "ville": "Palavas-les-Flots",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Pardailhan",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Paulhan",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Pégairolles-de-Buèges",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Pégairolles-de-l'Escalette",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Péret",
    "dep": "Hérault"
  },
  {
    "code": "34470",
    "ville": "Pérols",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Pézenas",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Pézènes-les-Mines",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Pierrerue",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Pignan",
    "dep": "Hérault"
  },
  {
    "code": "34850",
    "ville": "Pinet",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Plaissan",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Les Plans",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Poilhes",
    "dep": "Hérault"
  },
  {
    "code": "34810",
    "ville": "Pomérols",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Popian",
    "dep": "Hérault"
  },
  {
    "code": "34420",
    "ville": "Portiragnes",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Le Pouget",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Le Poujol-sur-Orb",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Poujols",
    "dep": "Hérault"
  },
  {
    "code": "34560",
    "ville": "Poussan",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Pouzolles",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Pouzols",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Le Pradal",
    "dep": "Hérault"
  },
  {
    "code": "34730",
    "ville": "Prades-le-Lez",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Prades-sur-Vernazobre",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Prémian",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Le Puech",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Puéchabon",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Puilacher",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Puimisson",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Puissalicon",
    "dep": "Hérault"
  },
  {
    "code": "34620",
    "ville": "Puisserguier",
    "dep": "Hérault"
  },
  {
    "code": "34310",
    "ville": "Quarante",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Restinclières",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Rieussec",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Riols",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Les Rives",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Romiguières",
    "dep": "Hérault"
  },
  {
    "code": "34460",
    "ville": "Roquebrun",
    "dep": "Hérault"
  },
  {
    "code": "34650",
    "ville": "Roqueredonde",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Roquessels",
    "dep": "Hérault"
  },
  {
    "code": "34610",
    "ville": "Rosis",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Rouet",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Roujan",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Saint-André-de-Buèges",
    "dep": "Hérault"
  },
  {
    "code": "34725",
    "ville": "Saint-André-de-Sangonis",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Saint-Aunès",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Saint-Bauzille-de-la-Sylve",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saint-Bauzille-de-Montmel",
    "dep": "Hérault"
  },
  {
    "code": "34190",
    "ville": "Saint-Bauzille-de-Putois",
    "dep": "Hérault"
  },
  {
    "code": "34670",
    "ville": "Saint-Brès",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Saint-Chinian",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Entre-Vignes",
    "dep": "Hérault"
  },
  {
    "code": "34980",
    "ville": "Saint-Clément-de-Rivière",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Sainte-Croix-de-Quintillargues",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saint-Drézéry",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Saint-Étienne-d'Albagnan",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Saint-Étienne-de-Gourgas",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "Saint-Étienne-Estréchoux",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Saint-Félix-de-l'Héras",
    "dep": "Hérault"
  },
  {
    "code": "34725",
    "ville": "Saint-Félix-de-Lodez",
    "dep": "Hérault"
  },
  {
    "code": "34980",
    "ville": "Saint-Gély-du-Fesc",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saint-Geniès-des-Mourgues",
    "dep": "Hérault"
  },
  {
    "code": "34610",
    "ville": "Saint-Geniès-de-Varensal",
    "dep": "Hérault"
  },
  {
    "code": "34480",
    "ville": "Saint-Geniès-de-Fontedit",
    "dep": "Hérault"
  },
  {
    "code": "34680",
    "ville": "Saint-Georges-d'Orques",
    "dep": "Hérault"
  },
  {
    "code": "34610",
    "ville": "Saint-Gervais-sur-Mare",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Saint-Guilhem-le-Désert",
    "dep": "Hérault"
  },
  {
    "code": "34725",
    "ville": "Saint-Guiraud",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saint-Hilaire-de-Beauvoir",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Saint-Jean-de-Buèges",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saint-Jean-de-Cornies",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Saint-Jean-de-Cuculles",
    "dep": "Hérault"
  },
  {
    "code": "34150",
    "ville": "Saint-Jean-de-Fos",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Saint-Jean-de-la-Blaquière",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Saint-Jean-de-Minervois",
    "dep": "Hérault"
  },
  {
    "code": "34430",
    "ville": "Saint-Jean-de-Védas",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Saint-Julien",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Saint-Just",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Saint-Martin-de-l'Arçon",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Saint-Martin-de-Londres",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Saint-Mathieu-de-Tréviers",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Saint-Maurice-Navacelles",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Saint-Michel",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Saint-Nazaire-de-Ladarez",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Saint-Nazaire-de-Pézan",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Saint-Pargoire",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Saint-Paul-et-Valmalle",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Saint-Pierre-de-la-Fage",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Saint-Pons-de-Thomières",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Saint-Pons-de-Mauchiens",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Saint-Privat",
    "dep": "Hérault"
  },
  {
    "code": "34725",
    "ville": "Saint-Saturnin-de-Lucian",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Saint-Sériès",
    "dep": "Hérault"
  },
  {
    "code": "34630",
    "ville": "Saint-Thibéry",
    "dep": "Hérault"
  },
  {
    "code": "34730",
    "ville": "Saint-Vincent-de-Barbeyrargues",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Saint-Vincent-d'Olargues",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Salasc",
    "dep": "Hérault"
  },
  {
    "code": "34330",
    "ville": "La Salvetat-sur-Agout",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Saturargues",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Saussan",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Saussines",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Sauteyrargues",
    "dep": "Hérault"
  },
  {
    "code": "34410",
    "ville": "Sauvian",
    "dep": "Hérault"
  },
  {
    "code": "34410",
    "ville": "Sérignan",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Servian",
    "dep": "Hérault"
  },
  {
    "code": "34200",
    "ville": "Sète",
    "dep": "Hérault"
  },
  {
    "code": "34210",
    "ville": "Siran",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "Sorbs",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Soubès",
    "dep": "Hérault"
  },
  {
    "code": "34330",
    "ville": "Le Soulié",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Soumont",
    "dep": "Hérault"
  },
  {
    "code": "34160",
    "ville": "Sussargues",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Taussac-la-Billière",
    "dep": "Hérault"
  },
  {
    "code": "34820",
    "ville": "Teyran",
    "dep": "Hérault"
  },
  {
    "code": "34490",
    "ville": "Thézan-lès-Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34120",
    "ville": "Tourbes",
    "dep": "Hérault"
  },
  {
    "code": "34260",
    "ville": "La Tour-sur-Orb",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Tressan",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Le Triadou",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Usclas-d'Hérault",
    "dep": "Hérault"
  },
  {
    "code": "34700",
    "ville": "Usclas-du-Bosc",
    "dep": "Hérault"
  },
  {
    "code": "34520",
    "ville": "La Vacquerie-et-Saint-Martin-de-Castries",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Vacquières",
    "dep": "Hérault"
  },
  {
    "code": "34320",
    "ville": "Vailhan",
    "dep": "Hérault"
  },
  {
    "code": "34570",
    "ville": "Vailhauquès",
    "dep": "Hérault"
  },
  {
    "code": "34130",
    "ville": "Valergues",
    "dep": "Hérault"
  },
  {
    "code": "34270",
    "ville": "Valflaunès",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Valmascle",
    "dep": "Hérault"
  },
  {
    "code": "34350",
    "ville": "Valras-Plage",
    "dep": "Hérault"
  },
  {
    "code": "34290",
    "ville": "Valros",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Vélieux",
    "dep": "Hérault"
  },
  {
    "code": "34740",
    "ville": "Vendargues",
    "dep": "Hérault"
  },
  {
    "code": "34230",
    "ville": "Vendémian",
    "dep": "Hérault"
  },
  {
    "code": "34350",
    "ville": "Vendres",
    "dep": "Hérault"
  },
  {
    "code": "34220",
    "ville": "Verreries-de-Moussans",
    "dep": "Hérault"
  },
  {
    "code": "34450",
    "ville": "Vias",
    "dep": "Hérault"
  },
  {
    "code": "34110",
    "ville": "Vic-la-Gardiole",
    "dep": "Hérault"
  },
  {
    "code": "34390",
    "ville": "Vieussan",
    "dep": "Hérault"
  },
  {
    "code": "34600",
    "ville": "Villemagne-l'Argentière",
    "dep": "Hérault"
  },
  {
    "code": "34500",
    "ville": "Villeneuve-lès-Béziers",
    "dep": "Hérault"
  },
  {
    "code": "34750",
    "ville": "Villeneuve-lès-Maguelone",
    "dep": "Hérault"
  },
  {
    "code": "34800",
    "ville": "Villeneuvette",
    "dep": "Hérault"
  },
  {
    "code": "34360",
    "ville": "Villespassans",
    "dep": "Hérault"
  },
  {
    "code": "34400",
    "ville": "Villetelle",
    "dep": "Hérault"
  },
  {
    "code": "34560",
    "ville": "Villeveyrac",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Viols-en-Laval",
    "dep": "Hérault"
  },
  {
    "code": "34380",
    "ville": "Viols-le-Fort",
    "dep": "Hérault"
  },
  {
    "code": "34280",
    "ville": "La Grande-Motte",
    "dep": "Hérault"
  },
  {
    "code": "35690",
    "ville": "Acigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Amanlis",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Andouillé-Neuville",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35460",
    "ville": "Val-Couesnon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Arbrissel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Argentré-du-Plessis",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Aubigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Availles-sur-Seiche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Baguer-Morvan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Baguer-Pican",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35470",
    "ville": "Bain-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35600",
    "ville": "Bains-sur-Oust",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35680",
    "ville": "Bais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Balazé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Baulon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "La Baussaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "La Bazouge-du-Désert",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35560",
    "ville": "Bazouges-la-Pérouse",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Beaucé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Bécherel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35137",
    "ville": "Bédée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35830",
    "ville": "Betton",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Billé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35750",
    "ville": "Bléruais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "Boisgervilly",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Boistrudan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Bonnemain",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "La Bosse-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35340",
    "ville": "La Bouëxière",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35230",
    "ville": "Bourgbarré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35890",
    "ville": "Bourg-des-Comptes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "La Boussac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Bovel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35310",
    "ville": "Bréal-sous-Montfort",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Bréal-sous-Vitré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35530",
    "ville": "Brécé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35160",
    "ville": "Breteil",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Brie",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Brielles",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Broualan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Bruc-sur-Aff",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Les Brulais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35170",
    "ville": "Bruz",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35260",
    "ville": "Cancale",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Cardroc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35510",
    "ville": "Cesson-Sévigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Champeaux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Chanteloup",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35135",
    "ville": "Chantepie",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "La Chapelle-aux-Filtzméens",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "La Chapelle-Bouëxic",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "La Chapelle-Chaussée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35520",
    "ville": "La Chapelle-des-Fougeretz",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "La Chapelle du Lou du Lac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "La Chapelle-Erbrée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "La Chapelle-Fleurigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "La Chapelle-Saint-Aubert",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35660",
    "ville": "La Chapelle-de-Brain",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35590",
    "ville": "La Chapelle-Thouarault",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35131",
    "ville": "Chartres-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Chasné-sur-Illet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35220",
    "ville": "Châteaubourg",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35410",
    "ville": "Châteaugiron",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "Châteauneuf-d'Ille-et-Vilaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Le Châtellier",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Châtillon-en-Vendelais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35490",
    "ville": "Chauvigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35310",
    "ville": "Chavagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35640",
    "ville": "Chelun",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Cherrueix",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Chevaigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35310",
    "ville": "Cintré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35590",
    "ville": "Clayes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35134",
    "ville": "Coësmes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Comblessac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Combourg",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Combourtillé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Cornillé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Corps-Nuds",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "La Couyère",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Crevin",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Le Crouais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Cuguen",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35800",
    "ville": "Dinard",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35440",
    "ville": "Dingé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Dol-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35113",
    "ville": "Domagné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35680",
    "ville": "Domalain",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35390",
    "ville": "La Dominelais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35410",
    "ville": "Domloup",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35450",
    "ville": "Dourdain",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Drouges",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35640",
    "ville": "Eancé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Epiniac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Erbrée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35620",
    "ville": "Ercé-en-Lamée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35340",
    "ville": "Ercé-près-Liffré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Essé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Étrelles",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35440",
    "ville": "Feins",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Le Ferré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35640",
    "ville": "Forges-la-Forêt",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35300",
    "ville": "Fougères",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35111",
    "ville": "La Fresnais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Gaël",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35490",
    "ville": "Gahard",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Gennes-sur-Seiche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35850",
    "ville": "Gévezé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Gosné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35350",
    "ville": "La Gouesnière",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Goven",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35390",
    "ville": "Grand-Fougeray",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "La Guerche-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Guichen",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Guignen",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35440",
    "ville": "Guipel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Hédé-Bazouges",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35590",
    "ville": "L'Hermitage",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Hirel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35750",
    "ville": "Iffendic",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Les Iffs",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35850",
    "ville": "Irodouër",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Janzé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Javené",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Laignelet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35890",
    "ville": "Laillé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Lalleu",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35450",
    "ville": "Landavran",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Landéan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "Landujan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35850",
    "ville": "Langan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35660",
    "ville": "Langon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Langouet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Lanrigan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Lassy",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Lécousse",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Lieuron",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35340",
    "ville": "Liffré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35111",
    "ville": "Lillemer",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35450",
    "ville": "Livré-sur-Changeon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Lohéac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Longaulnay",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Le Loroux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Lourmais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Loutehel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35680",
    "ville": "Louvigné-de-Bais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Louvigné-du-Désert",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Luitré-Dompierre",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35560",
    "ville": "Marcillé-Raoul",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35240",
    "ville": "Marcillé-Robert",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35220",
    "ville": "Marpiré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35640",
    "ville": "Martigné-Ferchaud",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Val d'Anast",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35380",
    "ville": "Maxent",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35450",
    "ville": "Mecé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "Médréac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Meillac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35520",
    "ville": "Melesse",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Mellé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Mernel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35480",
    "ville": "Guipry-Messac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35520",
    "ville": "La Mézière",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Mézières-sur-Couesnon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35540",
    "ville": "Miniac-Morvan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Miniac-sous-Bécherel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35870",
    "ville": "Le Minihic-sur-Rance",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Mondevert",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "Montauban-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Montautour",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Mont-Dol",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35160",
    "ville": "Monterfil",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35160",
    "ville": "Montfort-sur-Meu",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35760",
    "ville": "Montgermont",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Monthault",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35460",
    "ville": "Les Portes du Coglais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Montreuil-des-Landes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35520",
    "ville": "Montreuil-le-Gast",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Montreuil-sous-Pérouse",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35440",
    "ville": "Montreuil-sur-Ille",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35310",
    "ville": "Mordelles",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Mouazé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35680",
    "ville": "Moulins",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Moussé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Moutiers",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Muel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35470",
    "ville": "La Noë-Blanche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35137",
    "ville": "La Nouaye",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35410",
    "ville": "Nouvoitou",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35560",
    "ville": "Noyal-sous-Bazouges",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35230",
    "ville": "Noyal-Châtillon-sur-Seiche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35530",
    "ville": "Noyal-sur-Vilaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35230",
    "ville": "Orgères",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35740",
    "ville": "Pacé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35380",
    "ville": "Paimpont",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Pancé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Parcé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Parigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35850",
    "ville": "Parthenay-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Le Pertre",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Le Petit-Fougeray",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Pipriac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35150",
    "ville": "Piré-Chancé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35470",
    "ville": "Pléchâtel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Pleine-Fougères",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35380",
    "ville": "Plélan-le-Grand",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35540",
    "ville": "Plerguer",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35720",
    "ville": "Plesder",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35720",
    "ville": "Pleugueneuc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35137",
    "ville": "Pleumeleuc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35730",
    "ville": "Pleurtuit",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Pocé-les-Bois",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Poilley",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Poligné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Princé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Québriac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Quédillac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Rannée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35600",
    "ville": "Redon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35660",
    "ville": "Renac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35700",
    "ville": "Rennes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35240",
    "ville": "Retiers",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35650",
    "ville": "Le Rheu",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35780",
    "ville": "La Richardais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35560",
    "ville": "Rimou",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Romagné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35490",
    "ville": "Romazy",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35850",
    "ville": "Romillé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Roz-Landrieux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Roz-sur-Couesnon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Sains",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35390",
    "ville": "Sainte-Anne-sur-Vilaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35230",
    "ville": "Saint-Armel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Saint-Aubin-d'Aubigné",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Saint-Aubin-des-Landes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Saint-Aubin-du-Cormier",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35114",
    "ville": "Saint-Benoît-des-Ondes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35800",
    "ville": "Saint-Briac-sur-Mer",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35460",
    "ville": "Maen Roch",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Saint-Brieuc-des-Iffs",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Saint-Broladre",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35210",
    "ville": "Saint-Christophe-des-Bois",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Saint-Christophe-de-Valains",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35134",
    "ville": "Sainte-Colombe",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35350",
    "ville": "Saint-Coulomb",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35220",
    "ville": "Saint-Didier",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Saint-Domineuc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35230",
    "ville": "Saint-Erblon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Saint-Ganton",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Saint-Georges-de-Gréhaigne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Saint-Georges-de-Reintembault",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Saint-Germain-du-Pinel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Saint-Germain-en-Coglès",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Saint-Germain-sur-Ille",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35590",
    "ville": "Saint-Gilles",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Saint-Gondran",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35750",
    "ville": "Saint-Gonlay",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35760",
    "ville": "Saint-Grégoire",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "Saint-Guinoux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Saint-Hilaire-des-Landes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35136",
    "ville": "Saint-Jacques-de-la-Lande",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Rives-du-Couesnon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35220",
    "ville": "Saint-Jean-sur-Vilaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "Saint-Jouan-des-Guérets",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Saint-Just",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Saint-Léger-des-Prés",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35800",
    "ville": "Saint-Lunaire",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35400",
    "ville": "Saint-Malo",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35480",
    "ville": "Saint-Malo-de-Phily",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35750",
    "ville": "Saint-Malon-sur-Mel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35120",
    "ville": "Saint-Marcan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35460",
    "ville": "Saint-Marc-le-Blanc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35600",
    "ville": "Sainte-Marie",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35750",
    "ville": "Saint-Maugan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Saint-Médard-sur-Ille",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Saint-Méen-le-Grand",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35350",
    "ville": "Saint-Méloir-des-Ondes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Saint-M'Hervé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35290",
    "ville": "Saint-Onen-la-Chapelle",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35140",
    "ville": "Saint-Ouen-des-Alleux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35380",
    "ville": "Saint-Péran",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "Saint-Père-Marc-en-Poulet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Saint-Pern",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35720",
    "ville": "Mesnil-Roc'h",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35560",
    "ville": "Saint-Rémy-du-Plain",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "Saint-Sauveur-des-Landes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35330",
    "ville": "Saint-Séglin",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35580",
    "ville": "Saint-Senoux",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "Saint-Suliac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35250",
    "ville": "Saint-Sulpice-la-Forêt",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35390",
    "ville": "Saint-Sulpice-des-Landes",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Saint-Symphorien",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Saint-Thual",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35310",
    "ville": "Saint-Thurial",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35360",
    "ville": "Saint-Uniac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Saulnières",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Le Sel-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35133",
    "ville": "La Selle-en-Luitré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "La Selle-Guerchaise",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35490",
    "ville": "Sens-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35530",
    "ville": "Servon-sur-Vilaine",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35550",
    "ville": "Sixt-sur-Aff",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Sougeal",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Taillis",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35160",
    "ville": "Talensac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35620",
    "ville": "Teillay",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35240",
    "ville": "Le Theil-de-Bretagne",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35235",
    "ville": "Thorigné-Fouillard",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35134",
    "ville": "Thourie",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35460",
    "ville": "Le Tiercent",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Tinténiac",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35370",
    "ville": "Torcé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Trans-la-Forêt",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35380",
    "ville": "Treffendel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35270",
    "ville": "Trémeheuc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35320",
    "ville": "Tresbœuf",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Trévérien",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35190",
    "ville": "Trimer",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35450",
    "ville": "Val-d'Izé",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35680",
    "ville": "Vergéal",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35160",
    "ville": "Le Verger",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35770",
    "ville": "Vern-sur-Seiche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35132",
    "ville": "Vezin-le-Coquet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35610",
    "ville": "Vieux-Viel",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35490",
    "ville": "Vieux-Vy-sur-Couesnon",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35630",
    "ville": "Vignoc",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35420",
    "ville": "Villamée",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35430",
    "ville": "La Ville-ès-Nonais",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35130",
    "ville": "Visseiche",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35500",
    "ville": "Vitré",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35960",
    "ville": "Le Vivier-sur-Mer",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35540",
    "ville": "Le Tronchet",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "35131",
    "ville": "Pont-Péan",
    "dep": "Ille-et-Vilaine"
  },
  {
    "code": "36140",
    "ville": "Aigurande",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Aize",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Ambrault",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Anjouin",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Ardentes",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Argenton-sur-Creuse",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Argy",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Arpheuilles",
    "dep": "Indre"
  },
  {
    "code": "36330",
    "ville": "Arthon",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Azay-le-Ferron",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Bagneux",
    "dep": "Indre"
  },
  {
    "code": "36270",
    "ville": "Baraize",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Baudres",
    "dep": "Indre"
  },
  {
    "code": "36270",
    "ville": "Bazaiges",
    "dep": "Indre"
  },
  {
    "code": "36310",
    "ville": "Beaulieu",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Bélâbre",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "La Berthenoux",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Le Blanc",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Bommiers",
    "dep": "Indre"
  },
  {
    "code": "36310",
    "ville": "Bonneuil",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Les Bordes",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Bouesse",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Bouges-le-Château",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Bretagne",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Briantes",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Brion",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Brives",
    "dep": "Indre"
  },
  {
    "code": "36140",
    "ville": "La Buxerette",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Buxeuil",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Buxières-d'Aillac",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Buzançais",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Ceaulmont",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Celon",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Chabris",
    "dep": "Indre"
  },
  {
    "code": "36310",
    "ville": "Chaillac",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Chalais",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "La Champenoise",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Champillet",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "La Chapelle-Orthemale",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "La Chapelle-Saint-Laurian",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Chasseneuil",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Chassignolles",
    "dep": "Indre"
  },
  {
    "code": "36000",
    "ville": "Châteauroux",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Châtillon-sur-Indre",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "La Châtre",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "La Châtre-Langlin",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Chavin",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Chazelet",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Chezelles",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Chitray",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Chouday",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Ciron",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Cléré-du-Bois",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Clion",
    "dep": "Indre"
  },
  {
    "code": "36340",
    "ville": "Cluis",
    "dep": "Indre"
  },
  {
    "code": "36130",
    "ville": "Coings",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Concremiers",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Condé",
    "dep": "Indre"
  },
  {
    "code": "36140",
    "ville": "Crevant",
    "dep": "Indre"
  },
  {
    "code": "36140",
    "ville": "Crozon-sur-Vauvre",
    "dep": "Indre"
  },
  {
    "code": "36190",
    "ville": "Cuzion",
    "dep": "Indre"
  },
  {
    "code": "36130",
    "ville": "Déols",
    "dep": "Indre"
  },
  {
    "code": "36130",
    "ville": "Diors",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Diou",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Douadic",
    "dep": "Indre"
  },
  {
    "code": "36310",
    "ville": "Dunet",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Dun-le-Poëlier",
    "dep": "Indre"
  },
  {
    "code": "36240",
    "ville": "Écueillé",
    "dep": "Indre"
  },
  {
    "code": "36270",
    "ville": "Éguzon-Chantôme",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Étrechet",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Feusines",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Fléré-la-Rivière",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Fontenay",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Fontgombault",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Fontguenand",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Fougerolles",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Francillon",
    "dep": "Indre"
  },
  {
    "code": "36180",
    "ville": "Frédille",
    "dep": "Indre"
  },
  {
    "code": "36190",
    "ville": "Gargilesse-Dampierre",
    "dep": "Indre"
  },
  {
    "code": "36240",
    "ville": "Gehée",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Giroux",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Gournay",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Guilly",
    "dep": "Indre"
  },
  {
    "code": "36180",
    "ville": "Heugnes",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Ingrandes",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Issoudun",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Jeu-les-Bois",
    "dep": "Indre"
  },
  {
    "code": "36240",
    "ville": "Jeu-Maloches",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Lacs",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Langé",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Levroux",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Lignac",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Lignerolles",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Lingé",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Liniez",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Lizeray",
    "dep": "Indre"
  },
  {
    "code": "36140",
    "ville": "Lourdoueix-Saint-Michel",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Lourouer-Saint-Laurent",
    "dep": "Indre"
  },
  {
    "code": "36350",
    "ville": "Luant",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Luçay-le-Libre",
    "dep": "Indre"
  },
  {
    "code": "36360",
    "ville": "Luçay-le-Mâle",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Lurais",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Lureuil",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Luzeret",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Lye",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Lys-Saint-Georges",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Le Magny",
    "dep": "Indre"
  },
  {
    "code": "36340",
    "ville": "Maillet",
    "dep": "Indre"
  },
  {
    "code": "36340",
    "ville": "Malicornay",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Mâron",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Martizay",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Mauvières",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Menetou-sur-Nahon",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Ménétréols-sous-Vatan",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Le Menoux",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Méobecq",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Mérigny",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Mers-sur-Indre",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Meunet-Planches",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Meunet-sur-Vatan",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Mézières-en-Brenne",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Migné",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Migny",
    "dep": "Indre"
  },
  {
    "code": "36140",
    "ville": "Montchevrier",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Montgivray",
    "dep": "Indre"
  },
  {
    "code": "36130",
    "ville": "Montierchaume",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Montipouret",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Montlevicq",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Mosnay",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "La Motte-Feuilly",
    "dep": "Indre"
  },
  {
    "code": "36340",
    "ville": "Mouhers",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Mouhet",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Moulins-sur-Céphons",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Murs",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Néons-sur-Creuse",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Néret",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Neuillay-les-Bois",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Neuvy-Pailloux",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Neuvy-Saint-Sépulchre",
    "dep": "Indre"
  },
  {
    "code": "36250",
    "ville": "Niherne",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Nohant-Vic",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Nuret-le-Ferron",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Obterre",
    "dep": "Indre"
  },
  {
    "code": "36190",
    "ville": "Orsennes",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Orville",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Oulches",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Palluau-sur-Indre",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Parnac",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Paudy",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Paulnay",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Le Pêchereau",
    "dep": "Indre"
  },
  {
    "code": "36180",
    "ville": "Pellevoisin",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Pérassay",
    "dep": "Indre"
  },
  {
    "code": "36350",
    "ville": "La Pérouille",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Badecon-le-Pin",
    "dep": "Indre"
  },
  {
    "code": "36330",
    "ville": "Le Poinçonnet",
    "dep": "Indre"
  },
  {
    "code": "36190",
    "ville": "Pommiers",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Le Pont-Chrétien-Chabenet",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Poulaines",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Pouligny-Notre-Dame",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Pouligny-Saint-Martin",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Pouligny-Saint-Pierre",
    "dep": "Indre"
  },
  {
    "code": "36240",
    "ville": "Préaux",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Preuilly-la-Ville",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Prissac",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Pruniers",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Reboursin",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Reuilly",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Rivarennes",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Rosnay",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Roussines",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Rouvres-les-Bois",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Ruffec",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Sacierges-Saint-Martin",
    "dep": "Indre"
  },
  {
    "code": "36300",
    "ville": "Saint-Aigny",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Saint-Aoustrille",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Saint-Août",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Saint-Aubin",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Saint-Benoît-du-Sault",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Saint-Chartier",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Saint-Christophe-en-Bazelle",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Saint-Christophe-en-Boucherie",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Saint-Civran",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Saint-Cyran-du-Jambot",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Saint-Denis-de-Jouhet",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Sainte-Fauste",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Saint-Florentin",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Saint-Gaultier",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Sainte-Gemme",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Saint-Genou",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Saint-Georges-sur-Arnon",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Saint-Gilles",
    "dep": "Indre"
  },
  {
    "code": "36370",
    "ville": "Saint-Hilaire-sur-Benaize",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Saint-Lactencin",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Sainte-Lizaigne",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Saint-Marcel",
    "dep": "Indre"
  },
  {
    "code": "36250",
    "ville": "Saint-Maur",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Saint-Médard",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Saint-Michel-en-Brenne",
    "dep": "Indre"
  },
  {
    "code": "36260",
    "ville": "Saint-Pierre-de-Jards",
    "dep": "Indre"
  },
  {
    "code": "36190",
    "ville": "Saint-Plantaire",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Sainte-Sévère-sur-Indre",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Saint-Valentin",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Sarzay",
    "dep": "Indre"
  },
  {
    "code": "36120",
    "ville": "Sassierges-Saint-Germain",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Saulnay",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Sauzelles",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Sazeray",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Ségry",
    "dep": "Indre"
  },
  {
    "code": "36180",
    "ville": "Selles-sur-Nahon",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Sembleçay",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Sougé",
    "dep": "Indre"
  },
  {
    "code": "36200",
    "ville": "Tendu",
    "dep": "Indre"
  },
  {
    "code": "36800",
    "ville": "Thenay",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Thevet-Saint-Julien",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Thizay",
    "dep": "Indre"
  },
  {
    "code": "36310",
    "ville": "Tilly",
    "dep": "Indre"
  },
  {
    "code": "36220",
    "ville": "Tournon-Saint-Martin",
    "dep": "Indre"
  },
  {
    "code": "36700",
    "ville": "Le Tranger",
    "dep": "Indre"
  },
  {
    "code": "36230",
    "ville": "Tranzault",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Urciers",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Valençay",
    "dep": "Indre"
  },
  {
    "code": "36210",
    "ville": "Val-Fouzon",
    "dep": "Indre"
  },
  {
    "code": "36150",
    "ville": "Vatan",
    "dep": "Indre"
  },
  {
    "code": "36330",
    "ville": "Velles",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Vendœuvres",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "La Vernelle",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Verneuil-sur-Igneraie",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Veuil",
    "dep": "Indre"
  },
  {
    "code": "36400",
    "ville": "Vicq-Exemplet",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Vicq-sur-Nahon",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Vigoulant",
    "dep": "Indre"
  },
  {
    "code": "36170",
    "ville": "Vigoux",
    "dep": "Indre"
  },
  {
    "code": "36160",
    "ville": "Vijon",
    "dep": "Indre"
  },
  {
    "code": "36320",
    "ville": "Villedieu-sur-Indre",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Villegongis",
    "dep": "Indre"
  },
  {
    "code": "36500",
    "ville": "Villegouin",
    "dep": "Indre"
  },
  {
    "code": "36600",
    "ville": "Villentrois-Faverolles-en-Berry",
    "dep": "Indre"
  },
  {
    "code": "36290",
    "ville": "Villiers",
    "dep": "Indre"
  },
  {
    "code": "36110",
    "ville": "Vineuil",
    "dep": "Indre"
  },
  {
    "code": "36100",
    "ville": "Vouillon",
    "dep": "Indre"
  },
  {
    "code": "37160",
    "ville": "Abilly",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Ambillou",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37400",
    "ville": "Amboise",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Anché",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Antogny-le-Tillac",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37260",
    "ville": "Artannes-sur-Indre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Assay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Athée-sur-Cher",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Autrèche",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Auzouer-en-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37420",
    "ville": "Avoine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Avon-les-Roches",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Avrillé-les-Ponceaux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Azay-le-Rideau",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Azay-sur-Cher",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Azay-sur-Indre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37510",
    "ville": "Ballan-Miré",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Barrou",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Beaulieu-lès-Loches",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Beaumont-Louestault",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37420",
    "ville": "Beaumont-en-Véron",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Beaumont-Village",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "Benais",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37510",
    "ville": "Berthenay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Betz-le-Château",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Bléré",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Bossay-sur-Claise",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Bossée",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Le Boulay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "Bourgueil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Bournan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Boussay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Braslou",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Braye-sous-Faye",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Braye-sur-Maulne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Brèches",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Bréhémont",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Bridoré",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Brizay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Bueil-en-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Candes-Saint-Martin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Cangey",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "La Celle-Guenand",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37160",
    "ville": "La Celle-Saint-Avant",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Céré-la-Ronde",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Cerelles",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Chambon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Chambourg-sur-Indre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37170",
    "ville": "Chambray-lès-Tours",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Champigny-sur-Veude",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Chançay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Chanceaux-près-Loches",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Chanceaux-sur-Choisille",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Channay-sur-Lathan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "La Chapelle-aux-Naux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "La Chapelle-Blanche-Saint-Martin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "La Chapelle-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Charentilly",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Chargé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Charnizay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Château-la-Vallière",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Château-Renault",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Chaumussay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Chaveignes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Chédigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Cheillé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Chemillé-sur-Dême",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Chemillé-sur-Indrois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Chenonceaux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Chezelles",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Chinon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Chisseaux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "Chouzé-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Cigogné",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Cinais",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Cinq-Mars-la-Pile",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Ciran",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Civray-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37160",
    "ville": "Civray-sur-Esves",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Cléré-les-Pins",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Continvoir",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37320",
    "ville": "Cormery",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Couesmes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Courçay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Courcelles-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Courcoué",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Couziers",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Cravant-les-Côteaux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Crissay-sur-Manse",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "La Croix-en-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Crotelles",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Crouzilles",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Cussay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Dame-Marie-les-Bois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Dierre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Dolus-le-Sec",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Draché",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Druye",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Épeigné-les-Bois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Épeigné-sur-Dême",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Esves-le-Moutier",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37320",
    "ville": "Esvres",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Faye-la-Vineuse",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "La Ferrière",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Ferrière-Larçon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Ferrière-sur-Beaulieu",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37230",
    "ville": "Fondettes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Francueil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Genillé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Gizeux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Le Grand-Pressigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "La Guerche",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37160",
    "ville": "Descartes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Les Hermites",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Hommes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37420",
    "ville": "Huismes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "L'Île-Bouchard",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Jaulnay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37300",
    "ville": "Joué-lès-Tours",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Langeais",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Larçay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Lémeré",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Lerné",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Le Liège",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Lignières-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Ligré",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Ligueil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Limeray",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Loches",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Loché-sur-Indrois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37320",
    "ville": "Louans",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Le Louroux",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Lublé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37400",
    "ville": "Lussault-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37230",
    "ville": "Luynes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Luzé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37150",
    "ville": "Luzillé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Maillé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Manthelan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Marçay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37160",
    "ville": "Marcé-sur-Esves",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Marcilly-sur-Maulne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Marcilly-sur-Vienne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Marigny-Marmande",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Marray",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Mazières-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "La Membrolle-sur-Choisille",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Mettray",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Monnaie",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37250",
    "ville": "Montbazon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Monthodon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Montlouis-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Montrésor",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Montreuil-en-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37260",
    "ville": "Monts",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Morand",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Mosnes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Mouzay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Nazelles-Négron",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Neuil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Neuillé-le-Lierre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37360",
    "ville": "Neuillé-Pont-Pierre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37160",
    "ville": "Neuilly-le-Brignon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Neuville-sur-Brenne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Neuvy-le-Roi",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Noizay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Notre-Dame-d'Oé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Nouans-les-Fontaines",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Nouâtre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Nouzilly",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Noyant-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Orbigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Panzoult",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Parçay-Meslay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Parçay-sur-Vienne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Paulmy",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37230",
    "ville": "Pernay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Perrusson",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37350",
    "ville": "Le Petit-Pressigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Pocé-sur-Cisse",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37260",
    "ville": "Pont-de-Ruan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Ports-sur-Vienne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Pouzay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Preuilly-sur-Claise",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Pussigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Razines",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Reignac-sur-Indre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "Restigné",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Reugny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37520",
    "ville": "La Riche",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Richelieu",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37420",
    "ville": "Rigny-Ussé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Rillé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Rilly-sur-Vienne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Rivarennes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Rivière",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "La Roche-Clermault",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Rochecorbon",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37360",
    "ville": "Rouziers-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Saché",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37360",
    "ville": "Saint-Antoine-du-Rocher",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Saint-Aubin-le-Dépeint",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37550",
    "ville": "Saint-Avertin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Saint-Benoît-la-Forêt",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37320",
    "ville": "Saint-Branchs",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Sainte-Catherine-de-Fierbois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Saint-Christophe-sur-le-Nais",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37540",
    "ville": "Saint-Cyr-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Saint-Épain",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37230",
    "ville": "Saint-Étienne-de-Chigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Saint-Flovier",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37510",
    "ville": "Saint-Genouph",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Saint-Germain-sur-Vienne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Saint-Hippolyte",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Saint-Jean-Saint-Germain",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Saint-Laurent-de-Lin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37380",
    "ville": "Saint-Laurent-en-Gâtines",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Saint-Martin-le-Beau",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Sainte-Maure-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37140",
    "ville": "Saint-Nicolas-de-Bourgueil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Saint-Nicolas-des-Motets",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Saint-Ouen-les-Vignes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Saint-Paterne-Racan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37130",
    "ville": "Coteaux-sur-Loire",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37700",
    "ville": "Saint-Pierre-des-Corps",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Saint-Quentin-sur-Indrois",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Saint-Règle",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37390",
    "ville": "Saint-Roch",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Saint-Senoch",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Saunay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37340",
    "ville": "Savigné-sur-Lathan",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37420",
    "ville": "Savigny-en-Véron",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37510",
    "ville": "Savonnières",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Sazilly",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37360",
    "ville": "Semblançay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Sennevières",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37800",
    "ville": "Sepmes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Seuilly",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37360",
    "ville": "Sonzay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37250",
    "ville": "Sorigny",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Souvigné",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37530",
    "ville": "Souvigny-de-Touraine",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Sublaines",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37310",
    "ville": "Tauxigny-Saint-Bauld",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Tavant",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Theneuil",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37260",
    "ville": "Thilouze",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37500",
    "ville": "Thizay",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Tournon-Saint-Pierre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "La Tour-Saint-Gelin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37100",
    "ville": "Tours",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37220",
    "ville": "Trogues",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37320",
    "ville": "Truyes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Vallères",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Varennes",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37250",
    "ville": "Veigné",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37270",
    "ville": "Véretz",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37120",
    "ville": "Verneuil-le-Château",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37600",
    "ville": "Verneuil-sur-Indre",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Vernou-sur-Brenne",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37190",
    "ville": "Villaines-les-Rochers",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37510",
    "ville": "Villandry",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37700",
    "ville": "La Ville-aux-Dames",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37370",
    "ville": "Villebourg",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Villedômain",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37110",
    "ville": "Villedômer",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37460",
    "ville": "Villeloin-Coulangé",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37260",
    "ville": "Villeperdue",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37330",
    "ville": "Villiers-au-Bouin",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37240",
    "ville": "Vou",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37210",
    "ville": "Vouvray",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "37290",
    "ville": "Yzeures-sur-Creuse",
    "dep": "Indre-et-Loire"
  },
  {
    "code": "38490",
    "ville": "Les Abrets en Dauphiné",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Les Adrets",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Agnin",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "L'Albenc",
    "dep": "Isère"
  },
  {
    "code": "38114",
    "ville": "Allemond",
    "dep": "Isère"
  },
  {
    "code": "38580",
    "ville": "Allevard",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Ambel",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Anjou",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Annoisin-Chatelans",
    "dep": "Isère"
  },
  {
    "code": "38280",
    "ville": "Anthon",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Aoste",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Apprieu",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Artas",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Assieu",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Auberives-en-Royans",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Auberives-sur-Varèze",
    "dep": "Isère"
  },
  {
    "code": "38142",
    "ville": "Auris",
    "dep": "Isère"
  },
  {
    "code": "38630",
    "ville": "Les Avenières Veyrins-Thuellin",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Avignonet",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "La Balme-les-Grottes",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "Barraux",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "La Bâtie-Montgascon",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Beaucroissant",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Beaufin",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Beaufort",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Beaulieu",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Beaurepaire",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Beauvoir-de-Marc",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Beauvoir-en-Royans",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Bellegarde-Poussieu",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Belmont",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Bernin",
    "dep": "Isère"
  },
  {
    "code": "38142",
    "ville": "Besse",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Bessins",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Bévenais",
    "dep": "Isère"
  },
  {
    "code": "38850",
    "ville": "Bilieu",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Biol",
    "dep": "Isère"
  },
  {
    "code": "38330",
    "ville": "Biviers",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Bizonnes",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Blandin",
    "dep": "Isère"
  },
  {
    "code": "38090",
    "ville": "Bonnefamille",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Bossieu",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Le Bouchage",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Bougé-Chambalud",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Le Bourg-d'Oisans",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Bourgoin-Jallieu",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Bouvesse-Quirieu",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Brangues",
    "dep": "Isère"
  },
  {
    "code": "38870",
    "ville": "Bressieux",
    "dep": "Isère"
  },
  {
    "code": "38320",
    "ville": "Bresson",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Brézins",
    "dep": "Isère"
  },
  {
    "code": "38320",
    "ville": "Brié-et-Angonnes",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Brion",
    "dep": "Isère"
  },
  {
    "code": "38500",
    "ville": "La Buisse",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "La Buissière",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Burcin",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Cessieu",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Châbons",
    "dep": "Isère"
  },
  {
    "code": "38122",
    "ville": "Chalon",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Chamagnieu",
    "dep": "Isère"
  },
  {
    "code": "38800",
    "ville": "Champagnier",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Champier",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Le Champ-près-Froges",
    "dep": "Isère"
  },
  {
    "code": "38560",
    "ville": "Champ-sur-Drac",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Chanas",
    "dep": "Isère"
  },
  {
    "code": "38740",
    "ville": "Chantepérier",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Chantesse",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "Chapareillan",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "La Chapelle-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "La Chapelle-de-Surieu",
    "dep": "Isère"
  },
  {
    "code": "38580",
    "ville": "La Chapelle-du-Bard",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Charancieu",
    "dep": "Isère"
  },
  {
    "code": "38790",
    "ville": "Charantonnay",
    "dep": "Isère"
  },
  {
    "code": "38850",
    "ville": "Charavines",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Charette",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Charnècles",
    "dep": "Isère"
  },
  {
    "code": "38230",
    "ville": "Charvieu-Chavagneux",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Chasselay",
    "dep": "Isère"
  },
  {
    "code": "38670",
    "ville": "Chasse-sur-Rhône",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Chassignieu",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Château-Bernard",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Châteauvilain",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Châtelus",
    "dep": "Isère"
  },
  {
    "code": "38980",
    "ville": "Châtenay",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Châtonnay",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Chatte",
    "dep": "Isère"
  },
  {
    "code": "38230",
    "ville": "Chavanoz",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Chélieu",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Chevrières",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "Le Cheylas",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Cheyssieu",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Chèzeneuve",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Chichilianne",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Chimilin",
    "dep": "Isère"
  },
  {
    "code": "38850",
    "ville": "Chirens",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Cholonge",
    "dep": "Isère"
  },
  {
    "code": "38121",
    "ville": "Chonas-l'Amballan",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Choranche",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Chozeau",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Chuzelles",
    "dep": "Isère"
  },
  {
    "code": "38640",
    "ville": "Claix",
    "dep": "Isère"
  },
  {
    "code": "38142",
    "ville": "Clavans-en-Haut-Oisans",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Clelles",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Clonas-sur-Varèze",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Saint-Martin-de-la-Cluze",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Cognet",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Cognin-les-Gorges",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Colombe",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "La Combe-de-Lancey",
    "dep": "Isère"
  },
  {
    "code": "38630",
    "ville": "Corbelin",
    "dep": "Isère"
  },
  {
    "code": "38700",
    "ville": "Corenc",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Cornillon-en-Trièves",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Corps",
    "dep": "Isère"
  },
  {
    "code": "38250",
    "ville": "Corrençon-en-Vercors",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "La Côte-Saint-André",
    "dep": "Isère"
  },
  {
    "code": "38138",
    "ville": "Les Côtes-d'Arey",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Les Côtes-de-Corps",
    "dep": "Isère"
  },
  {
    "code": "38500",
    "ville": "Coublevie",
    "dep": "Isère"
  },
  {
    "code": "38122",
    "ville": "Cour-et-Buis",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Courtenay",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Crachier",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Cras",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Crémieu",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Creys-Mépieu",
    "dep": "Isère"
  },
  {
    "code": "38920",
    "ville": "Crolles",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Culin",
    "dep": "Isère"
  },
  {
    "code": "38790",
    "ville": "Diémoz",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Dizimieu",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Doissin",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Dolomieu",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Domarin",
    "dep": "Isère"
  },
  {
    "code": "38420",
    "ville": "Domène",
    "dep": "Isère"
  },
  {
    "code": "38130",
    "ville": "Échirolles",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Eclose-Badinières",
    "dep": "Isère"
  },
  {
    "code": "38360",
    "ville": "Engins",
    "dep": "Isère"
  },
  {
    "code": "38740",
    "ville": "Entraigues",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Entre-deux-Guiers",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Les Éparres",
    "dep": "Isère"
  },
  {
    "code": "38780",
    "ville": "Estrablin",
    "dep": "Isère"
  },
  {
    "code": "38320",
    "ville": "Eybens",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Eydoche",
    "dep": "Isère"
  },
  {
    "code": "38780",
    "ville": "Eyzin-Pinet",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Faramans",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Faverges-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38580",
    "ville": "Le Haut-Bréda",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "La Flachère",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Flachères",
    "dep": "Isère"
  },
  {
    "code": "38600",
    "ville": "Fontaine",
    "dep": "Isère"
  },
  {
    "code": "38120",
    "ville": "Fontanil-Cornillon",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "La Forteresse",
    "dep": "Isère"
  },
  {
    "code": "38080",
    "ville": "Four",
    "dep": "Isère"
  },
  {
    "code": "38142",
    "ville": "Le Freney-d'Oisans",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "La Frette",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Froges",
    "dep": "Isère"
  },
  {
    "code": "38290",
    "ville": "Frontonas",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "La Garde",
    "dep": "Isère"
  },
  {
    "code": "38610",
    "ville": "Gières",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Gillonnay",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "Goncelin",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Le Grand-Lemps",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Granieu",
    "dep": "Isère"
  },
  {
    "code": "38540",
    "ville": "Grenay",
    "dep": "Isère"
  },
  {
    "code": "38000",
    "ville": "Grenoble",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Gresse-en-Vercors",
    "dep": "Isère"
  },
  {
    "code": "38450",
    "ville": "Le Gua",
    "dep": "Isère"
  },
  {
    "code": "38320",
    "ville": "Herbeys",
    "dep": "Isère"
  },
  {
    "code": "38540",
    "ville": "Heyrieux",
    "dep": "Isère"
  },
  {
    "code": "38118",
    "ville": "Hières-sur-Amby",
    "dep": "Isère"
  },
  {
    "code": "38750",
    "ville": "Huez",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "Hurtières",
    "dep": "Isère"
  },
  {
    "code": "38080",
    "ville": "L'Isle-d'Abeau",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Izeaux",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Izeron",
    "dep": "Isère"
  },
  {
    "code": "38280",
    "ville": "Janneyrias",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Jarcieu",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Jardin",
    "dep": "Isère"
  },
  {
    "code": "38560",
    "ville": "Jarrie",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Laffrey",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Lalley",
    "dep": "Isère"
  },
  {
    "code": "38250",
    "ville": "Lans-en-Vercors",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Laval-en-Belledonne",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Lavaldens",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Lavars",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Lentiol",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Leyrieu",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Lieudieu",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Livet-et-Gavet",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Longechenal",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Lumbin",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Luzinay",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Malleval-en-Vercors",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Marcieu",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Marcilloles",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Marcollin",
    "dep": "Isère"
  },
  {
    "code": "38980",
    "ville": "Marnans",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Massieu",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Maubec",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Mayres-Savel",
    "dep": "Isère"
  },
  {
    "code": "38112",
    "ville": "Autrans-Méaudre en Vercors",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Mens",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Merlas",
    "dep": "Isère"
  },
  {
    "code": "38240",
    "ville": "Meylan",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Meyrié",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Meyrieu-les-Étangs",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Meyssiez",
    "dep": "Isère"
  },
  {
    "code": "38450",
    "ville": "Miribel-Lanchâtre",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Miribel-les-Échelles",
    "dep": "Isère"
  },
  {
    "code": "38142",
    "ville": "Mizoën",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Moidieu-Détourbe",
    "dep": "Isère"
  },
  {
    "code": "38430",
    "ville": "Moirans",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Moissieu-sur-Dolon",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Monestier-d'Ambel",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Monestier-de-Clermont",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Monestier-du-Percy",
    "dep": "Isère"
  },
  {
    "code": "38122",
    "ville": "Monsteroux-Milieu",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Montagne",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Montagnieu",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Montalieu-Vercieu",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Montaud",
    "dep": "Isère"
  },
  {
    "code": "38330",
    "ville": "Montbonnot-Saint-Martin",
    "dep": "Isère"
  },
  {
    "code": "38890",
    "ville": "Montcarra",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Montchaboud",
    "dep": "Isère"
  },
  {
    "code": "38860",
    "ville": "Les Deux Alpes",
    "dep": "Isère"
  },
  {
    "code": "38770",
    "ville": "Monteynard",
    "dep": "Isère"
  },
  {
    "code": "38940",
    "ville": "Montfalcon",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Montferrat",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Montrevel",
    "dep": "Isère"
  },
  {
    "code": "38120",
    "ville": "Mont-Saint-Martin",
    "dep": "Isère"
  },
  {
    "code": "38122",
    "ville": "Montseveroux",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Moras",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Morestel",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Morette",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "La Morte",
    "dep": "Isère"
  },
  {
    "code": "38770",
    "ville": "La Motte-d'Aveillans",
    "dep": "Isère"
  },
  {
    "code": "38770",
    "ville": "La Motte-Saint-Martin",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Mottier",
    "dep": "Isère"
  },
  {
    "code": "38580",
    "ville": "Le Moutaret",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "La Mure",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "La Murette",
    "dep": "Isère"
  },
  {
    "code": "38420",
    "ville": "Murianette",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Murinais",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Nantes-en-Ratier",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Serre-Nerpol",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Nivolas-Vermelle",
    "dep": "Isère"
  },
  {
    "code": "38450",
    "ville": "Notre-Dame-de-Commiers",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Notre-Dame-de-l'Osier",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Notre-Dame-de-Mésage",
    "dep": "Isère"
  },
  {
    "code": "38144",
    "ville": "Notre-Dame-de-Vaulx",
    "dep": "Isère"
  },
  {
    "code": "38360",
    "ville": "Noyarey",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Optevoz",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Oris-en-Rattier",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Ornacieux-Balbins",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Ornon",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Oulles",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Oyeu",
    "dep": "Isère"
  },
  {
    "code": "38780",
    "ville": "Oytier-Saint-Oblas",
    "dep": "Isère"
  },
  {
    "code": "38114",
    "ville": "Oz",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Pact",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Pajay",
    "dep": "Isère"
  },
  {
    "code": "38850",
    "ville": "Villages du Lac de Paladru",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Panossas",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Parmilieu",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Le Passage",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Arandon-Passins",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Le Péage-de-Roussillon",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Pellafol",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Penol",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Le Percy",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "La Pierre",
    "dep": "Isère"
  },
  {
    "code": "38119",
    "ville": "Pierre-Châtel",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Pisieu",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Plan",
    "dep": "Isère"
  },
  {
    "code": "38320",
    "ville": "Poisat",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Poliénas",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Pommier-de-Beaurepaire",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Ponsonnas",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "Pontcharra",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Le Pont-de-Beauvoisin",
    "dep": "Isère"
  },
  {
    "code": "38230",
    "ville": "Pont-de-Chéruy",
    "dep": "Isère"
  },
  {
    "code": "38800",
    "ville": "Le Pont-de-Claix",
    "dep": "Isère"
  },
  {
    "code": "38780",
    "ville": "Pont-Évêque",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Pont-en-Royans",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Porcieu-Amblagnieu",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Prébois",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Presles",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Pressins",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Primarette",
    "dep": "Isère"
  },
  {
    "code": "38120",
    "ville": "Proveysieux",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Prunières",
    "dep": "Isère"
  },
  {
    "code": "38950",
    "ville": "Quaix-en-Chartreuse",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Quet-en-Beaumont",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Quincieu",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Réaumont",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Renage",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Rencurel",
    "dep": "Isère"
  },
  {
    "code": "38420",
    "ville": "Revel",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Revel-Tourdan",
    "dep": "Isère"
  },
  {
    "code": "38121",
    "ville": "Reventin-Vaugris",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Rives",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "La Rivière",
    "dep": "Isère"
  },
  {
    "code": "38090",
    "ville": "Roche",
    "dep": "Isère"
  },
  {
    "code": "38370",
    "ville": "Les Roches-de-Condrieu",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Rochetoirin",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Roissard",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Romagnieu",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Roussillon",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Rovon",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Royas",
    "dep": "Isère"
  },
  {
    "code": "38940",
    "ville": "Roybon",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Ruy-Montceau",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Sablons",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Sainte-Agnès",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Saint-Agnin-sur-Bion",
    "dep": "Isère"
  },
  {
    "code": "38080",
    "ville": "Saint-Alban-de-Roche",
    "dep": "Isère"
  },
  {
    "code": "38370",
    "ville": "Saint-Alban-du-Rhône",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Saint-Albin-de-Vaulserre",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Saint-Andéol",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Saint-André-en-Royans",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Saint-André-le-Gaz",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Sainte-Anne-sur-Gervonde",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint Antoine l'Abbaye",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Appolinard",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Saint-Arey",
    "dep": "Isère"
  },
  {
    "code": "38960",
    "ville": "Saint-Aupre",
    "dep": "Isère"
  },
  {
    "code": "38270",
    "ville": "Saint-Barthélemy",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Saint-Barthélemy-de-Séchilienne",
    "dep": "Isère"
  },
  {
    "code": "38118",
    "ville": "Saint-Baudille-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Saint-Baudille-et-Pipet",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Saint-Blaise-du-Buis",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Sainte-Blandine",
    "dep": "Isère"
  },
  {
    "code": "38840",
    "ville": "Saint-Bonnet-de-Chavagne",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Saint-Bueil",
    "dep": "Isère"
  },
  {
    "code": "38500",
    "ville": "Saint-Cassien",
    "dep": "Isère"
  },
  {
    "code": "38890",
    "ville": "Saint-Chef",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Saint-Christophe-en-Oisans",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Saint-Christophe-sur-Guiers",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Saint-Clair-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38370",
    "ville": "Saint-Clair-du-Rhône",
    "dep": "Isère"
  },
  {
    "code": "38940",
    "ville": "Saint-Clair-sur-Galaure",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Saint-Didier-de-Bizonnes",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Saint-Didier-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38120",
    "ville": "Saint-Égrève",
    "dep": "Isère"
  },
  {
    "code": "38960",
    "ville": "Saint-Étienne-de-Crossey",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Saint-Étienne-de-Saint-Geoirs",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Saint-Geoire-en-Valdaine",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Saint-Geoirs",
    "dep": "Isère"
  },
  {
    "code": "38450",
    "ville": "Saint-Georges-de-Commiers",
    "dep": "Isère"
  },
  {
    "code": "38790",
    "ville": "Saint-Georges-d'Espéranche",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Saint-Gervais",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Saint-Guillaume",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Saint-Hilaire-de-Brens",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Saint-Hilaire-de-la-Côte",
    "dep": "Isère"
  },
  {
    "code": "38840",
    "ville": "Saint-Hilaire-du-Rosier",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Plateau-des-Petites-Roches",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Saint-Honoré",
    "dep": "Isère"
  },
  {
    "code": "38330",
    "ville": "Saint-Ismier",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Saint-Jean-d'Avelanne",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Saint-Jean-de-Bournay",
    "dep": "Isère"
  },
  {
    "code": "38430",
    "ville": "Saint-Jean-de-Moirans",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Saint-Jean-de-Soudain",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Saint-Jean-de-Vaulx",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Saint-Jean-d'Hérans",
    "dep": "Isère"
  },
  {
    "code": "38420",
    "ville": "Saint-Jean-le-Vieux",
    "dep": "Isère"
  },
  {
    "code": "38134",
    "ville": "Saint-Joseph-de-Rivière",
    "dep": "Isère"
  },
  {
    "code": "38122",
    "ville": "Saint-Julien-de-l'Herms",
    "dep": "Isère"
  },
  {
    "code": "38134",
    "ville": "La Sure en Chartreuse",
    "dep": "Isère"
  },
  {
    "code": "38540",
    "ville": "Saint-Just-Chaleyssin",
    "dep": "Isère"
  },
  {
    "code": "38680",
    "ville": "Saint-Just-de-Claix",
    "dep": "Isère"
  },
  {
    "code": "38840",
    "ville": "Saint-Lattier",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Saint-Laurent-du-Pont",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Saint-Laurent-en-Beaumont",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "Sainte-Luce",
    "dep": "Isère"
  },
  {
    "code": "38080",
    "ville": "Saint-Marcel-Bel-Accueil",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Marcellin",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Sainte-Marie-d'Alloix",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Sainte-Marie-du-Mont",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Saint-Martin-de-Clelles",
    "dep": "Isère"
  },
  {
    "code": "38480",
    "ville": "Saint-Martin-de-Vaulserre",
    "dep": "Isère"
  },
  {
    "code": "38400",
    "ville": "Saint-Martin-d'Hères",
    "dep": "Isère"
  },
  {
    "code": "38410",
    "ville": "Saint-Martin-d'Uriage",
    "dep": "Isère"
  },
  {
    "code": "38950",
    "ville": "Saint-Martin-le-Vinoux",
    "dep": "Isère"
  },
  {
    "code": "38930",
    "ville": "Saint-Maurice-en-Trièves",
    "dep": "Isère"
  },
  {
    "code": "38550",
    "ville": "Saint-Maurice-l'Exil",
    "dep": "Isère"
  },
  {
    "code": "38530",
    "ville": "Saint-Maximin",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Saint-Michel-de-Saint-Geoirs",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Saint-Michel-en-Beaumont",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Saint-Michel-les-Portes",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Saint-Mury-Monteymond",
    "dep": "Isère"
  },
  {
    "code": "38330",
    "ville": "Saint-Nazaire-les-Eymes",
    "dep": "Isère"
  },
  {
    "code": "38500",
    "ville": "Saint-Nicolas-de-Macherin",
    "dep": "Isère"
  },
  {
    "code": "38250",
    "ville": "Saint-Nizier-du-Moucherotte",
    "dep": "Isère"
  },
  {
    "code": "38490",
    "ville": "Saint-Ondras",
    "dep": "Isère"
  },
  {
    "code": "38760",
    "ville": "Saint-Paul-de-Varces",
    "dep": "Isère"
  },
  {
    "code": "38140",
    "ville": "Saint-Paul-d'Izeaux",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Saint-Paul-lès-Monestier",
    "dep": "Isère"
  },
  {
    "code": "38830",
    "ville": "Crêts en Belledonne",
    "dep": "Isère"
  },
  {
    "code": "38870",
    "ville": "Saint-Pierre-de-Bressieux",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Saint-Pierre-de-Chartreuse",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Pierre-de-Chérennes",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Saint-Pierre-de-Méaroz",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Saint-Pierre-de-Mésage",
    "dep": "Isère"
  },
  {
    "code": "38380",
    "ville": "Saint-Pierre-d'Entremont",
    "dep": "Isère"
  },
  {
    "code": "38370",
    "ville": "Saint-Prim",
    "dep": "Isère"
  },
  {
    "code": "38070",
    "ville": "Saint-Quentin-Fallavier",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Saint-Quentin-sur-Isère",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Saint-Romain-de-Jalionas",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Saint-Romain-de-Surieu",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Romans",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Sauveur",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Saint-Savin",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Châtel-en-Trièves",
    "dep": "Isère"
  },
  {
    "code": "38870",
    "ville": "Saint-Siméon-de-Bressieux",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Saint-Sorlin-de-Morestel",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Saint-Sorlin-de-Vienne",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Saint-Sulpice-des-Rivoires",
    "dep": "Isère"
  },
  {
    "code": "38119",
    "ville": "Saint-Théoffrey",
    "dep": "Isère"
  },
  {
    "code": "38160",
    "ville": "Saint-Vérand",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "Saint-Victor-de-Cessieu",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Saint-Victor-de-Morestel",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Saint-Vincent-de-Mercuze",
    "dep": "Isère"
  },
  {
    "code": "38890",
    "ville": "Salagnon",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Salaise-sur-Sanne",
    "dep": "Isère"
  },
  {
    "code": "38970",
    "ville": "La Salette-Fallavaux",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "La Salle-en-Beaumont",
    "dep": "Isère"
  },
  {
    "code": "38700",
    "ville": "Le Sappey-en-Chartreuse",
    "dep": "Isère"
  },
  {
    "code": "38700",
    "ville": "Sarcenas",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Sardieu",
    "dep": "Isère"
  },
  {
    "code": "38360",
    "ville": "Sassenage",
    "dep": "Isère"
  },
  {
    "code": "38290",
    "ville": "Satolas-et-Bonce",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Savas-Mépin",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Séchilienne",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Porte-des-Bonnevaux",
    "dep": "Isère"
  },
  {
    "code": "38780",
    "ville": "Septème",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Sérézin-de-la-Tour",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Sermérieu",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Serpaize",
    "dep": "Isère"
  },
  {
    "code": "38170",
    "ville": "Seyssinet-Pariset",
    "dep": "Isère"
  },
  {
    "code": "38180",
    "ville": "Seyssins",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Seyssuel",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Siccieu-Saint-Julien-et-Carisieu",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Siévoz",
    "dep": "Isère"
  },
  {
    "code": "38590",
    "ville": "Sillans",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Sinard",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Soleymieu",
    "dep": "Isère"
  },
  {
    "code": "38840",
    "ville": "La Sône",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Sonnay",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Sousville",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Succieu",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "Susville",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Têche",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "Tencin",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "La Terrasse",
    "dep": "Isère"
  },
  {
    "code": "38570",
    "ville": "Theys",
    "dep": "Isère"
  },
  {
    "code": "38260",
    "ville": "Thodure",
    "dep": "Isère"
  },
  {
    "code": "38230",
    "ville": "Tignieu-Jameyzieu",
    "dep": "Isère"
  },
  {
    "code": "38690",
    "ville": "Torchefelon",
    "dep": "Isère"
  },
  {
    "code": "38110",
    "ville": "La Tour-du-Pin",
    "dep": "Isère"
  },
  {
    "code": "38660",
    "ville": "Le Touvet",
    "dep": "Isère"
  },
  {
    "code": "38300",
    "ville": "Tramolé",
    "dep": "Isère"
  },
  {
    "code": "38650",
    "ville": "Treffort",
    "dep": "Isère"
  },
  {
    "code": "38710",
    "ville": "Tréminis",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Trept",
    "dep": "Isère"
  },
  {
    "code": "38700",
    "ville": "La Tronche",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Tullins",
    "dep": "Isère"
  },
  {
    "code": "38740",
    "ville": "Valbonnais",
    "dep": "Isère"
  },
  {
    "code": "38540",
    "ville": "Valencin",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Valencogne",
    "dep": "Isère"
  },
  {
    "code": "38350",
    "ville": "La Valette",
    "dep": "Isère"
  },
  {
    "code": "38740",
    "ville": "Valjouffrey",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Varacieux",
    "dep": "Isère"
  },
  {
    "code": "38760",
    "ville": "Varces-Allières-et-Risset",
    "dep": "Isère"
  },
  {
    "code": "38890",
    "ville": "Vasselin",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Vatilieu",
    "dep": "Isère"
  },
  {
    "code": "38114",
    "ville": "Vaujany",
    "dep": "Isère"
  },
  {
    "code": "38410",
    "ville": "Vaulnaveys-le-Bas",
    "dep": "Isère"
  },
  {
    "code": "38410",
    "ville": "Vaulnaveys-le-Haut",
    "dep": "Isère"
  },
  {
    "code": "38090",
    "ville": "Vaulx-Milieu",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Velanne",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Vénérieu",
    "dep": "Isère"
  },
  {
    "code": "38610",
    "ville": "Venon",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Vernas",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Vernioz",
    "dep": "Isère"
  },
  {
    "code": "38290",
    "ville": "La Verpillière",
    "dep": "Isère"
  },
  {
    "code": "38420",
    "ville": "Le Versoud",
    "dep": "Isère"
  },
  {
    "code": "38390",
    "ville": "Vertrieu",
    "dep": "Isère"
  },
  {
    "code": "38113",
    "ville": "Veurey-Voroize",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Veyssilieu",
    "dep": "Isère"
  },
  {
    "code": "38510",
    "ville": "Vézeronce-Curtin",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Vienne",
    "dep": "Isère"
  },
  {
    "code": "38450",
    "ville": "Vif",
    "dep": "Isère"
  },
  {
    "code": "38890",
    "ville": "Vignieu",
    "dep": "Isère"
  },
  {
    "code": "38190",
    "ville": "Villard-Bonnot",
    "dep": "Isère"
  },
  {
    "code": "38250",
    "ville": "Villard-de-Lans",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Villard-Notre-Dame",
    "dep": "Isère"
  },
  {
    "code": "38114",
    "ville": "Villard-Reculas",
    "dep": "Isère"
  },
  {
    "code": "38520",
    "ville": "Villard-Reymond",
    "dep": "Isère"
  },
  {
    "code": "38119",
    "ville": "Villard-Saint-Christophe",
    "dep": "Isère"
  },
  {
    "code": "38090",
    "ville": "Villefontaine",
    "dep": "Isère"
  },
  {
    "code": "38460",
    "ville": "Villemoirieu",
    "dep": "Isère"
  },
  {
    "code": "38440",
    "ville": "Villeneuve-de-Marc",
    "dep": "Isère"
  },
  {
    "code": "38150",
    "ville": "Ville-sous-Anjou",
    "dep": "Isère"
  },
  {
    "code": "38280",
    "ville": "Villette-d'Anthon",
    "dep": "Isère"
  },
  {
    "code": "38200",
    "ville": "Villette-de-Vienne",
    "dep": "Isère"
  },
  {
    "code": "38470",
    "ville": "Vinay",
    "dep": "Isère"
  },
  {
    "code": "38730",
    "ville": "Val-de-Virieu",
    "dep": "Isère"
  },
  {
    "code": "38980",
    "ville": "Viriville",
    "dep": "Isère"
  },
  {
    "code": "38220",
    "ville": "Vizille",
    "dep": "Isère"
  },
  {
    "code": "38500",
    "ville": "Voiron",
    "dep": "Isère"
  },
  {
    "code": "38620",
    "ville": "Voissant",
    "dep": "Isère"
  },
  {
    "code": "38340",
    "ville": "Voreppe",
    "dep": "Isère"
  },
  {
    "code": "38210",
    "ville": "Vourey",
    "dep": "Isère"
  },
  {
    "code": "38410",
    "ville": "Chamrousse",
    "dep": "Isère"
  },
  {
    "code": "39500",
    "ville": "Abergement-la-Ronce",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Abergement-le-Grand",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Abergement-le-Petit",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Abergement-lès-Thésy",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Aiglepierre",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Alièze",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Amange",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Andelot-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Andelot-Morval",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Annoire",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Arbois",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Archelange",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Ardon",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Arinthod",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Arlay",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Aromas",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Les Arsures",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Arsure-Arsurette",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "La Chailleuse",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Asnans-Beauvoisin",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Audelange",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Augea",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Augerans",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Augisey",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Aumont",
    "dep": "Jura"
  },
  {
    "code": "39410",
    "ville": "Aumur",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Authume",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Auxange",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "Avignon-lès-Saint-Claude",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Balaiseaux",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Balanod",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Bans",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Barésia-sur-l'Ain",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "La Barre",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Barretaine",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Baume-les-Messieurs",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Baverans",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Beaufort-Orbagna",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Beffia",
    "dep": "Jura"
  },
  {
    "code": "39310",
    "ville": "Bellecombe",
    "dep": "Jura"
  },
  {
    "code": "39400",
    "ville": "Bellefontaine",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Belmont",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Bersaillin",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Besain",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Biarne",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Bief-des-Maisons",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Bief-du-Fourg",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Biefmorin",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Billecul",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Bletterans",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Blois-sur-Seille",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Blye",
    "dep": "Jura"
  },
  {
    "code": "39220",
    "ville": "Bois-d'Amont",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Bois-de-Gand",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Boissia",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "La Boissière",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Bonlieu",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Bonnefontaine",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Bornay",
    "dep": "Jura"
  },
  {
    "code": "39370",
    "ville": "Les Bouchoux",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Bourg-de-Sirod",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Bracon",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Brainans",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Brans",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "La Bretenière",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Bretenières",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Brevans",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Briod",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Broissia",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Buvilly",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Censeau",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Cernans",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Cerniébaud",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Cernon",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Cesancey",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Chaînée-des-Coupis",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Les Chalesmes",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Chambéria",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Chamblay",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Chamole",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Champagne-sur-Loue",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Champagney",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Champagnole",
    "dep": "Jura"
  },
  {
    "code": "39500",
    "ville": "Champdivers",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Champrougier",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Champvans",
    "dep": "Jura"
  },
  {
    "code": "01590",
    "ville": "Chancia",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "La Chapelle-sur-Furieuse",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Chapelle-Voland",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Chapois",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Charchilla",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Charcier",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Charency",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Charézier",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "La Charme",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Charnod",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "La Chassagne",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Château-Chalon",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "La Châtelaine",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Chatelay",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Châtel-de-Joux",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Le Chateley",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Châtelneuf",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Châtenois",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Châtillon",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Chaumergy",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "La Chaumusse",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Chaussenans",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Chaussin",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Chaux-des-Crotenay",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Nanchez",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "La Chaux-du-Dombief",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "La Chaux-en-Bresse",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Chaux-Champagny",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Chavéria",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Chemenot",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Saint-Hymetière-sur-Valouse",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Chemin",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Chêne-Bernard",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Chêne-Sec",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Chevigny",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Chevreaux",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Chevrotaine",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Chille",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Chilly-le-Vignoble",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Chilly-sur-Salins",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Chissey-sur-Loue",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Choisey",
    "dep": "Jura"
  },
  {
    "code": "39370",
    "ville": "Choux",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Cize",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Clairvaux-les-Lacs",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Clucy",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Cogna",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "Coiserette",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Colonne",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Commenailles",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Condamine",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Condes",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Conliège",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Conte",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Cornod",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Cosges",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Courbette",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Courbouzon",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Courlans",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Courlaoux",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Courtefontaine",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Cousance",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "Coyrière",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Coyron",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Cramans",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Hauteroche",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Crans",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Crenans",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Cressia",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Crissey",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Crotenay",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Les Crozets",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Cuisia",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Cuvier",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Dammartin-Marpain",
    "dep": "Jura"
  },
  {
    "code": "39500",
    "ville": "Damparis",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Dampierre",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Darbonnay",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Denezières",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Le Deschaux",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Desnes",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Les Deux-Fays",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Digna",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Dole",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Domblans",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Dompierre-sur-Mont",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Doucier",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Dournon",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Doye",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Dramelay",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Éclans-Nenon",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Écleux",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Écrille",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Entre-deux-Monts",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Val-d'Épy",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Équevillon",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Les Essards-Taignevaux",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Esserval-Tartre",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Étival",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "L'Étoile",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Étrepigney",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Évans",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Falletans",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "La Favière",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Fay-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "La Ferté",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Le Fied",
    "dep": "Jura"
  },
  {
    "code": "39520",
    "ville": "Foncine-le-Bas",
    "dep": "Jura"
  },
  {
    "code": "39460",
    "ville": "Foncine-le-Haut",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Fontainebrux",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Fontenu",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Fort-du-Plasne",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Foucherans",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Foulenay",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Fraisans",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Francheville",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Fraroz",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Frasne-les-Meulières",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "La Frasnée",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Le Frasnois",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Frébuans",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Frontenay",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Gatey",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Gendrey",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Genod",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Geraise",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Germigney",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Geruge",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Gevingey",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Gevry",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Gigny",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Gillois",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Gizia",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Grande-Rivière Château",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Grange-de-Vaivre",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Graye-et-Charnay",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Gredisans",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Grozon",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Hautecour",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Les Hays",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Ivory",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Ivrey",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Jeurre",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Jouhe",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Lac-des-Rouges-Truites",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Ladoye-sur-Seille",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Montlainsia",
    "dep": "Jura"
  },
  {
    "code": "39310",
    "ville": "Lajoux",
    "dep": "Jura"
  },
  {
    "code": "39310",
    "ville": "Lamoura",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Le Larderet",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Largillay-Marsonnay",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Larnaud",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Larrivoire",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Le Latet",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "La Latette",
    "dep": "Jura"
  },
  {
    "code": "01590",
    "ville": "Lavancia-Epercy",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Lavangeot",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Lavans-lès-Dole",
    "dep": "Jura"
  },
  {
    "code": "39170",
    "ville": "Lavans-lès-Saint-Claude",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Lavigny",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Lect",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Valzin en Petite Montagne",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Lemuy",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Lent",
    "dep": "Jura"
  },
  {
    "code": "39170",
    "ville": "Leschères",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Loisia",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Lombard",
    "dep": "Jura"
  },
  {
    "code": "39400",
    "ville": "Longchaumois",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Longcochon",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Longwy-sur-le-Doubs",
    "dep": "Jura"
  },
  {
    "code": "39000",
    "ville": "Lons-le-Saunier",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Loulle",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Louvatange",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Le Louverot",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "La Loye",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Macornay",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Maisod",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Malange",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Mantry",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Marigna-sur-Valouse",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Marigny",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Marnézia",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Marnoz",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "La Marre",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Martigna",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Mathenay",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Maynal",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Menétru-le-Vignoble",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Menétrux-en-Joux",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Menotey",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Mérona",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Mesnay",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Mesnois",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Messia-sur-Sorne",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Meussia",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Mièges",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Miéry",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Mignovillard",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Moirans-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Moiron",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Moissey",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Molain",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Molamboz",
    "dep": "Jura"
  },
  {
    "code": "39500",
    "ville": "Molay",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Chassal-Molinges",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Monay",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Monnetay",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Monnet-la-Ville",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Monnières",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Montagna-le-Reconduit",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Montaigu",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Montain",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Montbarrey",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Montcusel",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Monteplain",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Montfleur",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Montholier",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Montigny-lès-Arsures",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Montigny-sur-l'Ain",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Montmarlon",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Montmirey-la-Ville",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Montmirey-le-Château",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Montmorot",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Montrevel",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Montrond",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Mont-sous-Vaudrey",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Mont-sur-Monnet",
    "dep": "Jura"
  },
  {
    "code": "39400",
    "ville": "Morbier",
    "dep": "Jura"
  },
  {
    "code": "39400",
    "ville": "Hauts de Bienne",
    "dep": "Jura"
  },
  {
    "code": "39330",
    "ville": "Mouchard",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Mournans-Charbonny",
    "dep": "Jura"
  },
  {
    "code": "39310",
    "ville": "Les Moussières",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Moutonne",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Moutoux",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Mutigney",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Les Trois-Châteaux",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Nance",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Nancuise",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Les Nans",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Neublans-Abergement",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Neuvilley",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Nevy-lès-Dole",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Nevy-sur-Seille",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Ney",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Nogna",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Nozeroy",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Offlanges",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Onglières",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Onoz",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Orchamps",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Orgelet",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Ougney",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Ounans",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Our",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Oussières",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Pagney",
    "dep": "Jura"
  },
  {
    "code": "39330",
    "ville": "Pagnoz",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Pannessières",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Parcey",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Le Pasquier",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Passenans",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Patornay",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Peintre",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Perrigny",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Peseux",
    "dep": "Jura"
  },
  {
    "code": "39370",
    "ville": "La Pesse",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Petit-Noir",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Picarreau",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Pillemoine",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Pimorin",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Le Pin",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Plainoiseau",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Plaisia",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Les Planches-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Les Planches-près-Arbois",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Plasne",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Plénise",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Plénisette",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Pleure",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Plumont",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Poids-de-Fiole",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Pointre",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Poligny",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Pont-de-Poitte",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Pont-d'Héry",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Pont-du-Navoy",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Port-Lesney",
    "dep": "Jura"
  },
  {
    "code": "39220",
    "ville": "Prémanon",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Présilly",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Pretin",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Publy",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Pupillin",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Quintigny",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Rahon",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Rainans",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Ranchot",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Rans",
    "dep": "Jura"
  },
  {
    "code": "39170",
    "ville": "Ravilloles",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Recanoz",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Reithouse",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Relans",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Les Repôts",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Revigny",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "La Rixouse",
    "dep": "Jura"
  },
  {
    "code": "39250",
    "ville": "Rix",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Rochefort-sur-Nenon",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Rogna",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Romain",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Romange",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Rosay",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Rotalier",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Rothonay",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Rouffange",
    "dep": "Jura"
  },
  {
    "code": "39220",
    "ville": "Les Rousses",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Ruffey-sur-Seille",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Rye",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Saffloz",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Sainte-Agnès",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Saint-Amour",
    "dep": "Jura"
  },
  {
    "code": "39410",
    "ville": "Saint-Aubin",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Saint-Baraing",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "Saint-Claude",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Saint-Cyr-Montmalin",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Saint-Didier",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Saint-Germain-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39320",
    "ville": "Val Suran",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Saint-Lamain",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Saint-Laurent-en-Grandvaux",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Saint-Lothain",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Saint-Loup",
    "dep": "Jura"
  },
  {
    "code": "39170",
    "ville": "Coteaux du Lizon",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Saint-Maur",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Saint-Maurice-Crillat",
    "dep": "Jura"
  },
  {
    "code": "39150",
    "ville": "Saint-Pierre",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Saint-Thiébaud",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Saizenay",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Salans",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Saligney",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Salins-les-Bains",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Sampans",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Santans",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Sapois",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "Sarrogna",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Saugeot",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Séligney",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Sellières",
    "dep": "Jura"
  },
  {
    "code": "39310",
    "ville": "Septmoncel les Molunes",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Sergenaux",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Sergenon",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Sermange",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Serre-les-Moulières",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Sirod",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Songeson",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Soucia",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Souvans",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Supt",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Syam",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Tassenières",
    "dep": "Jura"
  },
  {
    "code": "39500",
    "ville": "Tavaux",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Taxenne",
    "dep": "Jura"
  },
  {
    "code": "39290",
    "ville": "Thervay",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Thésy",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Thoirette-Coisia",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Thoiria",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Thoissia",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Toulouse-le-Château",
    "dep": "Jura"
  },
  {
    "code": "39270",
    "ville": "La Tour-du-Meix",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Tourmont",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Trenal",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Uxelles",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Vadans",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Valempoulières",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Vannoz",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Le Vaudioux",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "Vaudrey",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Vaux-lès-Saint-Claude",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Vaux-sur-Poligny",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Verges",
    "dep": "Jura"
  },
  {
    "code": "39160",
    "ville": "Véria",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Vernantois",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Le Vernois",
    "dep": "Jura"
  },
  {
    "code": "39300",
    "ville": "Vers-en-Montagne",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Vers-sous-Sellières",
    "dep": "Jura"
  },
  {
    "code": "39130",
    "ville": "Vertamboz",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Vescles",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Vevy",
    "dep": "Jura"
  },
  {
    "code": "39380",
    "ville": "La Vieille-Loye",
    "dep": "Jura"
  },
  {
    "code": "39200",
    "ville": "Villard-Saint-Sauveur",
    "dep": "Jura"
  },
  {
    "code": "39260",
    "ville": "Villards-d'Héria",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Villeneuve-d'Aval",
    "dep": "Jura"
  },
  {
    "code": "39570",
    "ville": "Villeneuve-sous-Pymont",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Villerserine",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Villers-Farlay",
    "dep": "Jura"
  },
  {
    "code": "39800",
    "ville": "Villers-les-Bois",
    "dep": "Jura"
  },
  {
    "code": "39120",
    "ville": "Villers-Robert",
    "dep": "Jura"
  },
  {
    "code": "39600",
    "ville": "Villette-lès-Arbois",
    "dep": "Jura"
  },
  {
    "code": "39100",
    "ville": "Villette-lès-Dole",
    "dep": "Jura"
  },
  {
    "code": "39140",
    "ville": "Villevieux",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Le Villey",
    "dep": "Jura"
  },
  {
    "code": "39190",
    "ville": "Val-Sonnette",
    "dep": "Jura"
  },
  {
    "code": "39230",
    "ville": "Vincent-Froideville",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Viry",
    "dep": "Jura"
  },
  {
    "code": "39350",
    "ville": "Vitreux",
    "dep": "Jura"
  },
  {
    "code": "39210",
    "ville": "Voiteur",
    "dep": "Jura"
  },
  {
    "code": "39240",
    "ville": "Vosbles-Valfin",
    "dep": "Jura"
  },
  {
    "code": "39700",
    "ville": "Vriange",
    "dep": "Jura"
  },
  {
    "code": "39360",
    "ville": "Vulvoz",
    "dep": "Jura"
  },
  {
    "code": "39110",
    "ville": "Aresches",
    "dep": "Jura"
  },
  {
    "code": "40800",
    "ville": "Aire-sur-l'Adour",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Amou",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Angoumé",
    "dep": "Landes"
  },
  {
    "code": "40150",
    "ville": "Angresse",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Arboucave",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Arengosse",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Argelos",
    "dep": "Landes"
  },
  {
    "code": "40430",
    "ville": "Argelouse",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Arsague",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Artassenx",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Arthez-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Arue",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Arx",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Aubagnan",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Audignon",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Audon",
    "dep": "Landes"
  },
  {
    "code": "40200",
    "ville": "Aureilhan",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Aurice",
    "dep": "Landes"
  },
  {
    "code": "40140",
    "ville": "Azur",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Bahus-Soubiran",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Baigts",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Banos",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Bascons",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Bas-Mauco",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Bassercles",
    "dep": "Landes"
  },
  {
    "code": "40360",
    "ville": "Bastennes",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Bats",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Baudignan",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Bégaar",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Belhade",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Bélis",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Bélus",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Bénesse-lès-Dax",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Bénesse-Maremne",
    "dep": "Landes"
  },
  {
    "code": "40280",
    "ville": "Benquet",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Bergouey",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Betbezer-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40370",
    "ville": "Beylongue",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Beyries",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Biarrotte",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Bias",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Biaudos",
    "dep": "Landes"
  },
  {
    "code": "40600",
    "ville": "Biscarrosse",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Bonnegarde",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Bordères-et-Lamensans",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Bostens",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Bougue",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Bourdalat",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Bourriot-Bergonce",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Brassempouy",
    "dep": "Landes"
  },
  {
    "code": "40280",
    "ville": "Bretagne-de-Marsan",
    "dep": "Landes"
  },
  {
    "code": "40420",
    "ville": "Brocas",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Buanes",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Cachen",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Cagnotte",
    "dep": "Landes"
  },
  {
    "code": "40430",
    "ville": "Callen",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Campagne",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Campet-et-Lamolère",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Candresse",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Canenx-et-Réaut",
    "dep": "Landes"
  },
  {
    "code": "40130",
    "ville": "Capbreton",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Carcarès-Sainte-Croix",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Carcen-Ponson",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Cassen",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Castaignos-Souslens",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Castandet",
    "dep": "Landes"
  },
  {
    "code": "40360",
    "ville": "Castelnau-Chalosse",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Castelnau-Tursan",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Castelner",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Castel-Sarrazin",
    "dep": "Landes"
  },
  {
    "code": "40260",
    "ville": "Castets",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Cauna",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Cauneille",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Caupenne",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Cazalis",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Cazères-sur-l'Adour",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Cère",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Classun",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Clèdes",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Clermont",
    "dep": "Landes"
  },
  {
    "code": "40210",
    "ville": "Commensacq",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Coudures",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Créon-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40100",
    "ville": "Dax",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Doazit",
    "dep": "Landes"
  },
  {
    "code": "40360",
    "ville": "Donzacq",
    "dep": "Landes"
  },
  {
    "code": "40800",
    "ville": "Duhort-Bachen",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Dumes",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Escalans",
    "dep": "Landes"
  },
  {
    "code": "40210",
    "ville": "Escource",
    "dep": "Landes"
  },
  {
    "code": "40290",
    "ville": "Estibeaux",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Estigarde",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Eugénie-les-Bains",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Eyres-Moncube",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Fargues",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Le Frêche",
    "dep": "Landes"
  },
  {
    "code": "40350",
    "ville": "Gaas",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Gabarret",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Gaillères",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Gamarde-les-Bains",
    "dep": "Landes"
  },
  {
    "code": "40420",
    "ville": "Garein",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Garrey",
    "dep": "Landes"
  },
  {
    "code": "40160",
    "ville": "Gastes",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Gaujacq",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Geaune",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Geloux",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Gibret",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Goos",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Gourbera",
    "dep": "Landes"
  },
  {
    "code": "40465",
    "ville": "Gousse",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Gouts",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Grenade-sur-l'Adour",
    "dep": "Landes"
  },
  {
    "code": "40290",
    "ville": "Habas",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Hagetmau",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Hastingues",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Hauriet",
    "dep": "Landes"
  },
  {
    "code": "40280",
    "ville": "Haut-Mauco",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Herm",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Herré",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Heugas",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Hinx",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Hontanx",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Horsarrieu",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Josse",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Labastide-Chalosse",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Labastide-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Labatut",
    "dep": "Landes"
  },
  {
    "code": "40530",
    "ville": "Labenne",
    "dep": "Landes"
  },
  {
    "code": "40210",
    "ville": "Labouheyre",
    "dep": "Landes"
  },
  {
    "code": "40420",
    "ville": "Labrit",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Lacajunte",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Lacquy",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Lacrabe",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Laglorieuse",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Lagrange",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Lahosse",
    "dep": "Landes"
  },
  {
    "code": "40465",
    "ville": "Laluque",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Lamothe",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Larbey",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Larrivière-Saint-Savin",
    "dep": "Landes"
  },
  {
    "code": "40800",
    "ville": "Latrille",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Laurède",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Lauret",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Lencouacq",
    "dep": "Landes"
  },
  {
    "code": "40550",
    "ville": "Léon",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Lesgor",
    "dep": "Landes"
  },
  {
    "code": "40260",
    "ville": "Lesperon",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Le Leuy",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Lévignacq",
    "dep": "Landes"
  },
  {
    "code": "40260",
    "ville": "Linxe",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Liposthey",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Lit-et-Mixe",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Losse",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Louer",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Lourquen",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Lubbon",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Lucbardez-et-Bargues",
    "dep": "Landes"
  },
  {
    "code": "40210",
    "ville": "Lüe",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Retjons",
    "dep": "Landes"
  },
  {
    "code": "40630",
    "ville": "Luglon",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Lussagnet",
    "dep": "Landes"
  },
  {
    "code": "40430",
    "ville": "Luxey",
    "dep": "Landes"
  },
  {
    "code": "40140",
    "ville": "Magescq",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Maillas",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Maillères",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Mano",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Mant",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Marpaps",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Mauries",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Maurrin",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Mauvezin-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Maylis",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Mazerolles",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Mées",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Meilhan",
    "dep": "Landes"
  },
  {
    "code": "40660",
    "ville": "Messanges",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Mézos",
    "dep": "Landes"
  },
  {
    "code": "40350",
    "ville": "Mimbaste",
    "dep": "Landes"
  },
  {
    "code": "40200",
    "ville": "Mimizan",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Miramont-Sensacq",
    "dep": "Landes"
  },
  {
    "code": "40290",
    "ville": "Misson",
    "dep": "Landes"
  },
  {
    "code": "40660",
    "ville": "Moliets-et-Maa",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Momuy",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Monget",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Monségur",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Montaut",
    "dep": "Landes"
  },
  {
    "code": "40000",
    "ville": "Mont-de-Marsan",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Montégut",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Montfort-en-Chalosse",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Montgaillard",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Montsoué",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Morcenx-la-Nouvelle",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Morganx",
    "dep": "Landes"
  },
  {
    "code": "40290",
    "ville": "Mouscardès",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Moustey",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Mugron",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Narrosse",
    "dep": "Landes"
  },
  {
    "code": "40330",
    "ville": "Nassiet",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Nerbis",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Nousse",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Oeyregave",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Oeyreluy",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Onard",
    "dep": "Landes"
  },
  {
    "code": "40440",
    "ville": "Ondres",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Onesse-Laharie",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Orist",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Orthevielle",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Orx",
    "dep": "Landes"
  },
  {
    "code": "40290",
    "ville": "Ossages",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Ousse-Suzan",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Ozourt",
    "dep": "Landes"
  },
  {
    "code": "40160",
    "ville": "Parentis-en-Born",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Parleboscq",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Payros-Cazautets",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Pécorade",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Perquie",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Pey",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Peyre",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Peyrehorade",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Philondenx",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Pimbo",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Pissos",
    "dep": "Landes"
  },
  {
    "code": "40360",
    "ville": "Pomarez",
    "dep": "Landes"
  },
  {
    "code": "40200",
    "ville": "Pontenx-les-Forges",
    "dep": "Landes"
  },
  {
    "code": "40465",
    "ville": "Pontonx-sur-l'Adour",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Port-de-Lanne",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Poudenx",
    "dep": "Landes"
  },
  {
    "code": "40350",
    "ville": "Pouillon",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Pouydesseaux",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Poyanne",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Poyartin",
    "dep": "Landes"
  },
  {
    "code": "40465",
    "ville": "Préchacq-les-Bains",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Pujo-le-Plan",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Puyol-Cazalet",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Renung",
    "dep": "Landes"
  },
  {
    "code": "40310",
    "ville": "Rimbez-et-Baudiets",
    "dep": "Landes"
  },
  {
    "code": "40370",
    "ville": "Rion-des-Landes",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Rivière-Saas-et-Gourby",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Roquefort",
    "dep": "Landes"
  },
  {
    "code": "40630",
    "ville": "Sabres",
    "dep": "Landes"
  },
  {
    "code": "40800",
    "ville": "Saint-Agnet",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Saint-André-de-Seignanx",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Saint-Aubin",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Saint-Avit",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Saint-Barthélemy",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Sainte-Colombe",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Saint-Cricq-Chalosse",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Saint-Cricq-du-Gave",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Saint-Cricq-Villeneuve",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Saint-Étienne-d'Orthe",
    "dep": "Landes"
  },
  {
    "code": "40200",
    "ville": "Sainte-Eulalie-en-Born",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Sainte-Foy",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Saint-Gein",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Saint-Geours-d'Auribat",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Saint-Geours-de-Maremne",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Saint-Gor",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Saint-Jean-de-Lier",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Saint-Jean-de-Marsacq",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Saint-Julien-d'Armagnac",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Saint-Julien-en-Born",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Saint-Justin",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Saint-Laurent-de-Gosse",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Saint-Lon-les-Mines",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Saint-Loubouer",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Sainte-Marie-de-Gosse",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Saint-Martin-de-Hinx",
    "dep": "Landes"
  },
  {
    "code": "40390",
    "ville": "Saint-Martin-de-Seignanx",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Saint-Martin-d'Oney",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Saint-Maurice-sur-Adour",
    "dep": "Landes"
  },
  {
    "code": "40550",
    "ville": "Saint-Michel-Escalus",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Saint-Pandelon",
    "dep": "Landes"
  },
  {
    "code": "40200",
    "ville": "Saint-Paul-en-Born",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Saint-Paul-lès-Dax",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Saint-Perdon",
    "dep": "Landes"
  },
  {
    "code": "40280",
    "ville": "Saint-Pierre-du-Mont",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Saint-Sever",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Saint-Vincent-de-Paul",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Saint-Vincent-de-Tyrosse",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Saint-Yaguen",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Samadet",
    "dep": "Landes"
  },
  {
    "code": "40460",
    "ville": "Sanguinet",
    "dep": "Landes"
  },
  {
    "code": "40120",
    "ville": "Sarbazan",
    "dep": "Landes"
  },
  {
    "code": "40500",
    "ville": "Sarraziet",
    "dep": "Landes"
  },
  {
    "code": "40800",
    "ville": "Sarron",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Saubion",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Saubrigues",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Saubusse",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Saugnac-et-Cambran",
    "dep": "Landes"
  },
  {
    "code": "40410",
    "ville": "Saugnac-et-Muret",
    "dep": "Landes"
  },
  {
    "code": "40510",
    "ville": "Seignosse",
    "dep": "Landes"
  },
  {
    "code": "40420",
    "ville": "Le Sen",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Serres-Gaston",
    "dep": "Landes"
  },
  {
    "code": "40700",
    "ville": "Serreslous-et-Arribans",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Seyresse",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Siest",
    "dep": "Landes"
  },
  {
    "code": "40210",
    "ville": "Solférino",
    "dep": "Landes"
  },
  {
    "code": "40150",
    "ville": "Soorts-Hossegor",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Sorbets",
    "dep": "Landes"
  },
  {
    "code": "40300",
    "ville": "Sorde-l'Abbaye",
    "dep": "Landes"
  },
  {
    "code": "40430",
    "ville": "Sore",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Sort-en-Chalosse",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Souprosse",
    "dep": "Landes"
  },
  {
    "code": "40140",
    "ville": "Soustons",
    "dep": "Landes"
  },
  {
    "code": "40260",
    "ville": "Taller",
    "dep": "Landes"
  },
  {
    "code": "40220",
    "ville": "Tarnos",
    "dep": "Landes"
  },
  {
    "code": "40400",
    "ville": "Tartas",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Tercis-les-Bains",
    "dep": "Landes"
  },
  {
    "code": "40990",
    "ville": "Téthieu",
    "dep": "Landes"
  },
  {
    "code": "40360",
    "ville": "Tilh",
    "dep": "Landes"
  },
  {
    "code": "40230",
    "ville": "Tosse",
    "dep": "Landes"
  },
  {
    "code": "40250",
    "ville": "Toulouzette",
    "dep": "Landes"
  },
  {
    "code": "40630",
    "ville": "Trensacq",
    "dep": "Landes"
  },
  {
    "code": "40090",
    "ville": "Uchacq-et-Parentis",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Urgons",
    "dep": "Landes"
  },
  {
    "code": "40170",
    "ville": "Uza",
    "dep": "Landes"
  },
  {
    "code": "40420",
    "ville": "Vert",
    "dep": "Landes"
  },
  {
    "code": "40380",
    "ville": "Vicq-d'Auribat",
    "dep": "Landes"
  },
  {
    "code": "40320",
    "ville": "Vielle-Tursan",
    "dep": "Landes"
  },
  {
    "code": "40560",
    "ville": "Vielle-Saint-Girons",
    "dep": "Landes"
  },
  {
    "code": "40240",
    "ville": "Vielle-Soubiran",
    "dep": "Landes"
  },
  {
    "code": "40480",
    "ville": "Vieux-Boucau-les-Bains",
    "dep": "Landes"
  },
  {
    "code": "40270",
    "ville": "Le Vignau",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Villenave",
    "dep": "Landes"
  },
  {
    "code": "40190",
    "ville": "Villeneuve-de-Marsan",
    "dep": "Landes"
  },
  {
    "code": "40160",
    "ville": "Ychoux",
    "dep": "Landes"
  },
  {
    "code": "40110",
    "ville": "Ygos-Saint-Saturnin",
    "dep": "Landes"
  },
  {
    "code": "40180",
    "ville": "Yzosse",
    "dep": "Landes"
  },
  {
    "code": "41310",
    "ville": "Ambloy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Angé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Areines",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Artins",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41240",
    "ville": "Autainville",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Authon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Avaray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Averdon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Azé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Baillou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Bauzy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Beauchêne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41130",
    "ville": "Billy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41240",
    "ville": "Binas",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41000",
    "ville": "Blois",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Boisseau",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Bonneveau",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Bouffry",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Boursay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Bracieux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Brévainville",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Briou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Busloup",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Candé-sur-Beuvron",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41360",
    "ville": "Cellé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Cellettes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Chailles",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Chambord",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Champigny-en-Beauce",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Chaon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "La Chapelle-Enchérie",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "La Chapelle-Montmartin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "La Chapelle-Saint-Martin-en-Plaine",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "La Chapelle-Vendômoise",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "La Chapelle-Vicomtesse",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Châteauvieux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41130",
    "ville": "Châtillon-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Châtres-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Chaumont-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Chaumont-sur-Tharonne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41260",
    "ville": "La Chaussée-Saint-Victor",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Chauvigny-du-Perche",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Chémery",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Cheverny",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Chissay-en-Touraine",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Chitenay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Choue",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Choussy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Valloire-sur-Cisse",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Conan",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Concriers",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Le Controis-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Cormenon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Cormeray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Couddes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Couffy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Coulommiers-la-Tour",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Courbouzon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Cour-Cheverny",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Courmemin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Cour-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Vallée-de-Ronsard",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "Crouy-sur-Cosson",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Crucheray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Danzé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "Dhuizon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Droué",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Épiais",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41360",
    "ville": "Épuisay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Les Essarts",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Faverolles-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Faye",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "La Ferté-Beauharnais",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "La Ferté-Imbault",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "La Ferté-Saint-Cyr",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Fontaines-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Fontaine-les-Coteaux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Fontaine-Raoul",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "La Fontenelle",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41360",
    "ville": "Fortan",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Fossé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Françay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Fresnes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Fréteval",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Le Gault-du-Perche",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41130",
    "ville": "Gièvres",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Gombergean",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Gy-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Les Hayes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Herbault",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Houssay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Huisseau-en-Beauce",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41350",
    "ville": "Huisseau-sur-Cosson",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Josnes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Lamotte-Beuvron",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Lancé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Lancôme",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Landes-le-Gaulois",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Langon-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Lassay-sur-Croisne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Lavardin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Lestiou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Lignières",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Lisle",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Loreux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Lorges",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41360",
    "ville": "Lunay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "La Madeleine-Villefrouin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Maray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Marchenoir",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Marcilly-en-Beauce",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "Marcilly-en-Gault",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Mareuil-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "La Marolle-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Marolles",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Maslives",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Maves",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Mazangé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41140",
    "ville": "Méhers",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Menars",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Mennetou-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Mer",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Mesland",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Meslay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41130",
    "ville": "Meusnes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Millançay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Moisy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Valencisse",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Mondoubleau",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Monteaux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Monthou-sur-Bièvre",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Monthou-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Les Montils",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41350",
    "ville": "Montlivault",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Montoire-sur-le-Loir",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Mont-près-Chambord",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Montrichard Val de Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "Montrieux-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Montrouveau",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Morée",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Muides-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Mulsans",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Mur-de-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Naveil",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "Neung-sur-Beuvron",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Neuvy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Nouan-le-Fuzelier",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Nourray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41140",
    "ville": "Noyers-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Oisly",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Veuzain-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Orçay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Oucques La Nouvelle",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Ouzouer-le-Doyen",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41240",
    "ville": "Beauce la Romaine",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Périgny",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Pezou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Pierrefitte-sur-Sauldre",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Le Plessis-Dorin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Le Plessis-l'Échelle",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Le Poislay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Pontlevoy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Pouillé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Pray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Prunay-Cassereau",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Pruniers-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Rahart",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Renay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Rhodon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41150",
    "ville": "Rilly-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Rocé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Roches",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Les Roches-l'Évêque",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Romilly",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Romorantin-Lanthenay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Rougeou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Ruan-sur-Egvonne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Saint-Aignan",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Saint-Amand-Longpré",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Sainte-Anne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Saint-Arnoult",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Saint-Bohaire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41350",
    "ville": "Saint-Claude-de-Diray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Saint-Cyr-du-Gault",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41000",
    "ville": "Saint-Denis-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Saint-Dyé-sur-Loire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Saint-Étienne-des-Guérets",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Saint-Firmin-des-Prés",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Saint-Georges-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41350",
    "ville": "Saint-Gervais-la-Forêt",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Saint-Gourgon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Saint-Hilaire-la-Gravelle",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Saint-Jacques-des-Guérets",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "Saint-Jean-Froidmentel",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Saint-Julien-de-Chédon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Saint-Julien-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41240",
    "ville": "Saint-Laurent-des-Bois",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "Saint-Laurent-Nouan",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Saint-Léonard-en-Beauce",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41320",
    "ville": "Saint-Loup",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Saint-Lubin-en-Vergonnois",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Saint-Marc-du-Cor",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Saint-Martin-des-Bois",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Saint-Ouen",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Saint-Rimay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41140",
    "ville": "Saint-Romain-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41000",
    "ville": "Saint-Sulpice-de-Pommeray",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41210",
    "ville": "Saint-Viâtre",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Salbris",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Sambin",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Santenay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Sargé-sur-Braye",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Sasnières",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41700",
    "ville": "Sassay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41360",
    "ville": "Savigny-sur-Braye",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41110",
    "ville": "Seigy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Selles-Saint-Denis",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41130",
    "ville": "Selles-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Selommes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Séris",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Seur",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Soings-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Couëtron-au-Perche",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Souesmes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Sougé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Souvigny-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Suèvres",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41370",
    "ville": "Talcy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41170",
    "ville": "Le Temple",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Ternay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41300",
    "ville": "Theillay",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41140",
    "ville": "Thésée",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Thoré-la-Rochette",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "Thoury",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41190",
    "ville": "Tourailles",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41250",
    "ville": "Tour-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Troo",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41120",
    "ville": "Valaire",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41400",
    "ville": "Vallières-les-Grandes",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Veilleins",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Vendôme",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41230",
    "ville": "Vernou-en-Sologne",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Vievy-le-Rayé",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Villavard",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41160",
    "ville": "La Ville-aux-Clercs",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41000",
    "ville": "Villebarou",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41270",
    "ville": "Villebout",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Villechauve",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41800",
    "ville": "Villedieu-le-Château",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Villefranche-sur-Cher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41330",
    "ville": "Villefrancœur",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41200",
    "ville": "Villeherviers",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villemardy",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41290",
    "ville": "Villeneuve-Frouville",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41220",
    "ville": "Villeny",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41310",
    "ville": "Villeporcher",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villerable",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41000",
    "ville": "Villerbon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41240",
    "ville": "Villermain",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villeromain",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villetrun",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41500",
    "ville": "Villexanton",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villiersfaux",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41100",
    "ville": "Villiers-sur-Loir",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41350",
    "ville": "Vineuil",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Vouzon",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "41600",
    "ville": "Yvoy-le-Marron",
    "dep": "Loir-et-Cher"
  },
  {
    "code": "42380",
    "ville": "Aboën",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Ailleux",
    "dep": "Loire"
  },
  {
    "code": "42820",
    "ville": "Ambierle",
    "dep": "Loire"
  },
  {
    "code": "42160",
    "ville": "Andrézieux-Bouthéon",
    "dep": "Loire"
  },
  {
    "code": "42550",
    "ville": "Apinac",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Arcinges",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Arcon",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Arthun",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Aveizieux",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Balbigny",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Bard",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Bellegarde-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42670",
    "ville": "Belleroche",
    "dep": "Loire"
  },
  {
    "code": "42670",
    "ville": "Belmont-de-la-Loire",
    "dep": "Loire"
  },
  {
    "code": "42720",
    "ville": "La Bénisson-Dieu",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Le Bessat",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Bessey",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Boën-sur-Lignon",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Boisset-lès-Montrond",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Boisset-Saint-Priest",
    "dep": "Loire"
  },
  {
    "code": "42160",
    "ville": "Bonson",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Bourg-Argental",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Boyer",
    "dep": "Loire"
  },
  {
    "code": "42720",
    "ville": "Briennon",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Bully",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Burdignes",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Bussières",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Bussy-Albieux",
    "dep": "Loire"
  },
  {
    "code": "42240",
    "ville": "Caloire",
    "dep": "Loire"
  },
  {
    "code": "42320",
    "ville": "Cellieu",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Le Cergne",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "Cervières",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Cezay",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Chagnon",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Chalain-d'Uzore",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Chalain-le-Comtal",
    "dep": "Loire"
  },
  {
    "code": "42920",
    "ville": "Chalmazel-Jeansagnière",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "La Chamba",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Chambéon",
    "dep": "Loire"
  },
  {
    "code": "42170",
    "ville": "Chambles",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Chambœuf",
    "dep": "Loire"
  },
  {
    "code": "42500",
    "ville": "Le Chambon-Feugerolles",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "La Chambonie",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Champdieu",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Champoly",
    "dep": "Loire"
  },
  {
    "code": "42190",
    "ville": "Chandon",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Changy",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "La Chapelle-en-Lafaye",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "La Chapelle-Villars",
    "dep": "Loire"
  },
  {
    "code": "42190",
    "ville": "Charlieu",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Châteauneuf",
    "dep": "Loire"
  },
  {
    "code": "42940",
    "ville": "Châtelneuf",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Châtelus",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Chavanay",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Chazelles-sur-Lavieu",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Chazelles-sur-Lyon",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Chenereilles",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Cherier",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Chevrières",
    "dep": "Loire"
  },
  {
    "code": "42114",
    "ville": "Chirassimont",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Chuyer",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Civens",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Cleppé",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Colombier",
    "dep": "Loire"
  },
  {
    "code": "42840",
    "ville": "Combre",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Commelle-Vernay",
    "dep": "Loire"
  },
  {
    "code": "42123",
    "ville": "Cordelle",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Le Coteau",
    "dep": "Loire"
  },
  {
    "code": "42111",
    "ville": "La Côte-en-Couzan",
    "dep": "Loire"
  },
  {
    "code": "42360",
    "ville": "Cottance",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Coutouvre",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Craintilleux",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Cremeaux",
    "dep": "Loire"
  },
  {
    "code": "42540",
    "ville": "Croizet-sur-Gand",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Le Crozet",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Cuinzier",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Cuzieu",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Dargoire",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Débats-Rivière-d'Orpra",
    "dep": "Loire"
  },
  {
    "code": "42740",
    "ville": "Doizieux",
    "dep": "Loire"
  },
  {
    "code": "42670",
    "ville": "Écoche",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Écotay-l'Olme",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Épercieux-Saint-Paul",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Essertines-en-Châtelneuf",
    "dep": "Loire"
  },
  {
    "code": "42360",
    "ville": "Essertines-en-Donzy",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Estivareilles",
    "dep": "Loire"
  },
  {
    "code": "42580",
    "ville": "L'Étrat",
    "dep": "Loire"
  },
  {
    "code": "42320",
    "ville": "Farnay",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Feurs",
    "dep": "Loire"
  },
  {
    "code": "42700",
    "ville": "Firminy",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Fontanès",
    "dep": "Loire"
  },
  {
    "code": "42480",
    "ville": "La Fouillouse",
    "dep": "Loire"
  },
  {
    "code": "42470",
    "ville": "Fourneaux",
    "dep": "Loire"
  },
  {
    "code": "42490",
    "ville": "Fraisses",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "La Gimond",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Graix",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Grammond",
    "dep": "Loire"
  },
  {
    "code": "42320",
    "ville": "La Grand-Croix",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "La Gresle",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Grézieux-le-Fromental",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Grézolles",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Gumières",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "L'Hôpital-le-Grand",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "L'Hôpital-sous-Rochefort",
    "dep": "Loire"
  },
  {
    "code": "42152",
    "ville": "L'Horme",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Jarnosse",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Jas",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Jonzieux",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Juré",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Lavieu",
    "dep": "Loire"
  },
  {
    "code": "42470",
    "ville": "Lay",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Leigneux",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Lentigny",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Lérigneux",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Lézigneux",
    "dep": "Loire"
  },
  {
    "code": "42420",
    "ville": "Lorette",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Lupé",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Luré",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Luriecq",
    "dep": "Loire"
  },
  {
    "code": "42300",
    "ville": "Mably",
    "dep": "Loire"
  },
  {
    "code": "42114",
    "ville": "Machézal",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Maclas",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Magneux-Haute-Rive",
    "dep": "Loire"
  },
  {
    "code": "42750",
    "ville": "Maizilly",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Malleval",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Marcenod",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Marcilly-le-Châtel",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Marclopt",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Marcoux",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Margerie-Chantagret",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Maringes",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Marlhes",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Marols",
    "dep": "Loire"
  },
  {
    "code": "42750",
    "ville": "Mars",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Merle-Leignec",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Mizérieux",
    "dep": "Loire"
  },
  {
    "code": "42840",
    "ville": "Montagny",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Montarcher",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Montbrison",
    "dep": "Loire"
  },
  {
    "code": "42360",
    "ville": "Montchal",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Montrond-les-Bains",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Montverdun",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Mornand-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42720",
    "ville": "Nandax",
    "dep": "Loire"
  },
  {
    "code": "42470",
    "ville": "Neaux",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Néronde",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Nervieux",
    "dep": "Loire"
  },
  {
    "code": "42590",
    "ville": "Neulise",
    "dep": "Loire"
  },
  {
    "code": "42640",
    "ville": "Noailly",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Les Noës",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "Noirétable",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Nollieux",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Notre-Dame-de-Boisset",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Ouches",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "La Pacaudière",
    "dep": "Loire"
  },
  {
    "code": "42990",
    "ville": "Palogneux",
    "dep": "Loire"
  },
  {
    "code": "42360",
    "ville": "Panissières",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Parigny",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Pavezin",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Pélussin",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Périgneux",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Perreux",
    "dep": "Loire"
  },
  {
    "code": "42590",
    "ville": "Pinay",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Planfoy",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Pommiers-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Poncins",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Pouilly-lès-Feurs",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Pouilly-les-Nonains",
    "dep": "Loire"
  },
  {
    "code": "42720",
    "ville": "Pouilly-sous-Charlieu",
    "dep": "Loire"
  },
  {
    "code": "42630",
    "ville": "Pradines",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Pralong",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Précieux",
    "dep": "Loire"
  },
  {
    "code": "42630",
    "ville": "Régny",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Renaison",
    "dep": "Loire"
  },
  {
    "code": "42150",
    "ville": "La Ricamarie",
    "dep": "Loire"
  },
  {
    "code": "42153",
    "ville": "Riorges",
    "dep": "Loire"
  },
  {
    "code": "42340",
    "ville": "Rivas",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Rive-de-Gier",
    "dep": "Loire"
  },
  {
    "code": "42300",
    "ville": "Roanne",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Roche",
    "dep": "Loire"
  },
  {
    "code": "42230",
    "ville": "Roche-la-Molière",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Roisey",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Rozier-Côtes-d'Aurec",
    "dep": "Loire"
  },
  {
    "code": "42810",
    "ville": "Rozier-en-Donzy",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Sail-les-Bains",
    "dep": "Loire"
  },
  {
    "code": "42890",
    "ville": "Sail-sous-Couzan",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Sainte-Agathe-en-Donzy",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Sainte-Agathe-la-Bouteresse",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Saint-Alban-les-Eaux",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Saint-André-d'Apchon",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Saint-André-le-Puy",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Saint-Appolinard",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Saint-Barthélemy-Lestra",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Saint-Bonnet-des-Quarts",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Saint-Bonnet-le-Château",
    "dep": "Loire"
  },
  {
    "code": "42940",
    "ville": "Saint-Bonnet-le-Courreau",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Saint-Bonnet-les-Oules",
    "dep": "Loire"
  },
  {
    "code": "42400",
    "ville": "Saint-Chamond",
    "dep": "Loire"
  },
  {
    "code": "42320",
    "ville": "Saint-Christo-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42540",
    "ville": "Sainte-Colombe-sur-Gand",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Sainte-Croix-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42160",
    "ville": "Saint-Cyprien",
    "dep": "Loire"
  },
  {
    "code": "42123",
    "ville": "Saint-Cyr-de-Favières",
    "dep": "Loire"
  },
  {
    "code": "42114",
    "ville": "Saint-Cyr-de-Valorges",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Saint-Cyr-les-Vignes",
    "dep": "Loire"
  },
  {
    "code": "42750",
    "ville": "Saint-Denis-de-Cabanne",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Saint-Denis-sur-Coise",
    "dep": "Loire"
  },
  {
    "code": "42111",
    "ville": "Saint-Didier-sur-Rochefort",
    "dep": "Loire"
  },
  {
    "code": "42100",
    "ville": "Saint-Étienne",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Saint-Étienne-le-Molard",
    "dep": "Loire"
  },
  {
    "code": "42640",
    "ville": "Saint-Forgeux-Lespinasse",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Sainte-Foy-Saint-Sulpice",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Saint-Galmier",
    "dep": "Loire"
  },
  {
    "code": "42530",
    "ville": "Saint-Genest-Lerpt",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Saint-Genest-Malifaux",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Genilac",
    "dep": "Loire"
  },
  {
    "code": "42510",
    "ville": "Saint-Georges-de-Baroille",
    "dep": "Loire"
  },
  {
    "code": "42990",
    "ville": "Saint-Georges-en-Couzan",
    "dep": "Loire"
  },
  {
    "code": "42610",
    "ville": "Saint-Georges-Haute-Ville",
    "dep": "Loire"
  },
  {
    "code": "42670",
    "ville": "Saint-Germain-la-Montagne",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Saint-Germain-Laval",
    "dep": "Loire"
  },
  {
    "code": "42640",
    "ville": "Saint-Germain-Lespinasse",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Saint-Haon-le-Châtel",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Saint-Haon-le-Vieux",
    "dep": "Loire"
  },
  {
    "code": "42570",
    "ville": "Saint-Héand",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Saint-Hilaire-Cusson-la-Valmitte",
    "dep": "Loire"
  },
  {
    "code": "42190",
    "ville": "Saint-Hilaire-sous-Charlieu",
    "dep": "Loire"
  },
  {
    "code": "42650",
    "ville": "Saint-Jean-Bonnefonds",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "Saint-Jean-la-Vêtre",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Saint-Jean-Saint-Maurice-sur-Loire",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Saint-Jean-Soleymieux",
    "dep": "Loire"
  },
  {
    "code": "42590",
    "ville": "Saint-Jodard",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Saint-Joseph",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Saint-Julien-d'Oddes",
    "dep": "Loire"
  },
  {
    "code": "42111",
    "ville": "Vêtre-sur-Anzon",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Saint-Julien-Molin-Molette",
    "dep": "Loire"
  },
  {
    "code": "42990",
    "ville": "Saint-Just-en-Bas",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Saint-Just-en-Chevalet",
    "dep": "Loire"
  },
  {
    "code": "42540",
    "ville": "Saint-Just-la-Pendue",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Saint-Laurent-la-Conche",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Saint-Laurent-Rochefort",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Saint-Léger-sur-Roanne",
    "dep": "Loire"
  },
  {
    "code": "42122",
    "ville": "Saint-Marcel-de-Félines",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Saint-Marcel-d'Urfé",
    "dep": "Loire"
  },
  {
    "code": "42680",
    "ville": "Saint-Marcellin-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42620",
    "ville": "Saint-Martin-d'Estréaux",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Saint-Martin-la-Plaine",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Saint-Martin-la-Sauveté",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Saint-Martin-Lestra",
    "dep": "Loire"
  },
  {
    "code": "42240",
    "ville": "Saint-Maurice-en-Gourgois",
    "dep": "Loire"
  },
  {
    "code": "42330",
    "ville": "Saint-Médard-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Saint-Michel-sur-Rhône",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "Saint-Nizier-de-Fornas",
    "dep": "Loire"
  },
  {
    "code": "42190",
    "ville": "Saint-Nizier-sous-Charlieu",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Vézelin-sur-Loire",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Saint-Paul-d'Uzore",
    "dep": "Loire"
  },
  {
    "code": "42240",
    "ville": "Saint-Paul-en-Cornillon",
    "dep": "Loire"
  },
  {
    "code": "42740",
    "ville": "Saint-Paul-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Saint-Pierre-de-Bœuf",
    "dep": "Loire"
  },
  {
    "code": "42190",
    "ville": "Saint-Pierre-la-Noaille",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Saint-Polgues",
    "dep": "Loire"
  },
  {
    "code": "42270",
    "ville": "Saint-Priest-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42830",
    "ville": "Saint-Priest-la-Prugne",
    "dep": "Loire"
  },
  {
    "code": "42590",
    "ville": "Saint-Priest-la-Roche",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "Saint-Priest-la-Vêtre",
    "dep": "Loire"
  },
  {
    "code": "42170",
    "ville": "Saint-Just-Saint-Rambert",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Saint-Régis-du-Coin",
    "dep": "Loire"
  },
  {
    "code": "42370",
    "ville": "Saint-Rirand",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Saint-Romain-d'Urfé",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Saint-Romain-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42640",
    "ville": "Saint-Romain-la-Motte",
    "dep": "Loire"
  },
  {
    "code": "42610",
    "ville": "Saint-Romain-le-Puy",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Saint-Romain-les-Atheux",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Saint-Sauveur-en-Rue",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Saint-Sixte",
    "dep": "Loire"
  },
  {
    "code": "42470",
    "ville": "Saint-Symphorien-de-Lay",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Saint-Thomas-la-Garde",
    "dep": "Loire"
  },
  {
    "code": "42630",
    "ville": "Saint-Victor-sur-Rhins",
    "dep": "Loire"
  },
  {
    "code": "42120",
    "ville": "Saint-Vincent-de-Boisset",
    "dep": "Loire"
  },
  {
    "code": "42440",
    "ville": "Les Salles",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Salt-en-Donzy",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Salvizinet",
    "dep": "Loire"
  },
  {
    "code": "42990",
    "ville": "Sauvain",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Savigneux",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Sevelinges",
    "dep": "Loire"
  },
  {
    "code": "42560",
    "ville": "Soleymieux",
    "dep": "Loire"
  },
  {
    "code": "42290",
    "ville": "Sorbiers",
    "dep": "Loire"
  },
  {
    "code": "42260",
    "ville": "Souternon",
    "dep": "Loire"
  },
  {
    "code": "42450",
    "ville": "Sury-le-Comtal",
    "dep": "Loire"
  },
  {
    "code": "42350",
    "ville": "La Talaudière",
    "dep": "Loire"
  },
  {
    "code": "42660",
    "ville": "Tarentaise",
    "dep": "Loire"
  },
  {
    "code": "42800",
    "ville": "Tartaras",
    "dep": "Loire"
  },
  {
    "code": "42740",
    "ville": "La Terrasse-sur-Dorlay",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "Thélis-la-Combe",
    "dep": "Loire"
  },
  {
    "code": "42580",
    "ville": "La Tour-en-Jarez",
    "dep": "Loire"
  },
  {
    "code": "42380",
    "ville": "La Tourette",
    "dep": "Loire"
  },
  {
    "code": "42130",
    "ville": "Trelins",
    "dep": "Loire"
  },
  {
    "code": "42830",
    "ville": "La Tuilière",
    "dep": "Loire"
  },
  {
    "code": "42210",
    "ville": "Unias",
    "dep": "Loire"
  },
  {
    "code": "42240",
    "ville": "Unieux",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Urbise",
    "dep": "Loire"
  },
  {
    "code": "42550",
    "ville": "Usson-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42110",
    "ville": "Valeille",
    "dep": "Loire"
  },
  {
    "code": "42320",
    "ville": "Valfleury",
    "dep": "Loire"
  },
  {
    "code": "42111",
    "ville": "La Valla-sur-Rochefort",
    "dep": "Loire"
  },
  {
    "code": "42131",
    "ville": "La Valla-en-Gier",
    "dep": "Loire"
  },
  {
    "code": "42340",
    "ville": "Veauche",
    "dep": "Loire"
  },
  {
    "code": "42340",
    "ville": "Veauchette",
    "dep": "Loire"
  },
  {
    "code": "42590",
    "ville": "Vendranges",
    "dep": "Loire"
  },
  {
    "code": "42520",
    "ville": "Véranne",
    "dep": "Loire"
  },
  {
    "code": "42410",
    "ville": "Vérin",
    "dep": "Loire"
  },
  {
    "code": "42600",
    "ville": "Verrières-en-Forez",
    "dep": "Loire"
  },
  {
    "code": "42220",
    "ville": "La Versanne",
    "dep": "Loire"
  },
  {
    "code": "42390",
    "ville": "Villars",
    "dep": "Loire"
  },
  {
    "code": "42155",
    "ville": "Villemontais",
    "dep": "Loire"
  },
  {
    "code": "42300",
    "ville": "Villerest",
    "dep": "Loire"
  },
  {
    "code": "42460",
    "ville": "Villers",
    "dep": "Loire"
  },
  {
    "code": "42780",
    "ville": "Violay",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Viricelles",
    "dep": "Loire"
  },
  {
    "code": "42140",
    "ville": "Virigneux",
    "dep": "Loire"
  },
  {
    "code": "42310",
    "ville": "Vivans",
    "dep": "Loire"
  },
  {
    "code": "42720",
    "ville": "Vougy",
    "dep": "Loire"
  },
  {
    "code": "42430",
    "ville": "Chausseterre",
    "dep": "Loire"
  },
  {
    "code": "43100",
    "ville": "Agnat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43000",
    "ville": "Aiguilhe",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "Allègre",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Alleyrac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Alleyras",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Ally",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Araules",
    "dep": "Haute-Loire"
  },
  {
    "code": "43490",
    "ville": "Arlempdes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Arlet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Arsac-en-Velay",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Aubazat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43110",
    "ville": "Aurec-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Vissac-Auteyrac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Autrac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Auvers",
    "dep": "Haute-Loire"
  },
  {
    "code": "43390",
    "ville": "Auzon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43390",
    "ville": "Azérat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43370",
    "ville": "Bains",
    "dep": "Haute-Loire"
  },
  {
    "code": "43340",
    "ville": "Barges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43210",
    "ville": "Bas-en-Basset",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Beaulieu",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Beaumont",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Beaune-sur-Arzon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Beaux",
    "dep": "Haute-Loire"
  },
  {
    "code": "43590",
    "ville": "Beauzac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Bellevue-la-Montagne",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Berbezit",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Bessamorel",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "La Besseyre-Saint-Mary",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Blanzac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Blassac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Blavozy",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Blesle",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Boisset",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Bonneval",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Borne",
    "dep": "Haute-Loire"
  },
  {
    "code": "43510",
    "ville": "Le Bouchet-Saint-Nicolas",
    "dep": "Haute-Loire"
  },
  {
    "code": "43360",
    "ville": "Bournoncle-Saint-Pierre",
    "dep": "Haute-Loire"
  },
  {
    "code": "43370",
    "ville": "Le Brignon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Brioude",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Brives-Charensac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43510",
    "ville": "Cayres",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "Céaux-d'Allègre",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Cerzat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43000",
    "ville": "Ceyssac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43770",
    "ville": "Chadrac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Chadron",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "La Chaise-Dieu",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Chamalières-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43410",
    "ville": "Chambezon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43400",
    "ville": "Le Chambon-sur-Lignon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43440",
    "ville": "Champagnac-le-Vieux",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Champclause",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Chanaleilles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Chaniat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Chanteuges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "La Chapelle-Bertin",
    "dep": "Haute-Loire"
  },
  {
    "code": "43120",
    "ville": "La Chapelle-d'Aurec",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "La Chapelle-Geneste",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Charraix",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Chaspinhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Chaspuzac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Chassagnes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43440",
    "ville": "Chassignolles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Chastel",
    "dep": "Haute-Loire"
  },
  {
    "code": "43430",
    "ville": "Chaudeyrolles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Chavaniac-Lafayette",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Chazelles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43190",
    "ville": "Chenereilles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Chilhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Chomelix",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "La Chomette",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Cistrières",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Cohade",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Collat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Connangles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43490",
    "ville": "Costaros",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Coubon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Couteuges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Craponne-sur-Arzon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Cronce",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Cubelles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43370",
    "ville": "Cussac-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Desges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Domeyrat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43220",
    "ville": "Dunières",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Espalem",
    "dep": "Haute-Loire"
  },
  {
    "code": "43000",
    "ville": "Espaly-Saint-Marcel",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Esplantas-Vazeilles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Les Estables",
    "dep": "Haute-Loire"
  },
  {
    "code": "43430",
    "ville": "Fay-sur-Lignon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Félines",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Ferrussac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Fix-Saint-Geneys",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Fontannes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Freycenet-la-Cuche",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Freycenet-la-Tour",
    "dep": "Haute-Loire"
  },
  {
    "code": "43250",
    "ville": "Frugerès-les-Mines",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Frugières-le-Pin",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Goudet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Grazac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Grenier-Montgon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Grèzes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Javaugues",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Jax",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Josat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Jullianges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43490",
    "ville": "Lafarre",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Lamothe",
    "dep": "Haute-Loire"
  },
  {
    "code": "43340",
    "ville": "Landos",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Langeac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Lantriac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Lapte",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Laussonne",
    "dep": "Haute-Loire"
  },
  {
    "code": "43440",
    "ville": "Laval-sur-Doulon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Lavaudieu",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Lavoûte-Chilhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Lavoûte-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43410",
    "ville": "Lempdes-sur-Allagnon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43410",
    "ville": "Léotoing",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Lissac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43360",
    "ville": "Lorlanges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Loudes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Lubilhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Malrevers",
    "dep": "Haute-Loire"
  },
  {
    "code": "43210",
    "ville": "Malvalette",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Malvières",
    "dep": "Haute-Loire"
  },
  {
    "code": "43190",
    "ville": "Le Mas-de-Tence",
    "dep": "Haute-Loire"
  },
  {
    "code": "43520",
    "ville": "Mazet-Saint-Voy",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Mazerat-Aurouze",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Mazeyrat-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Mercœur",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Mézères",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Le Monastier-sur-Gazeille",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Monistrol-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43120",
    "ville": "Monistrol-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "Monlet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Montclard",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Le Monteil",
    "dep": "Haute-Loire"
  },
  {
    "code": "43290",
    "ville": "Montfaucon-en-Velay",
    "dep": "Haute-Loire"
  },
  {
    "code": "43290",
    "ville": "Montregard",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Montusclat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Moudeyres",
    "dep": "Haute-Loire"
  },
  {
    "code": "43510",
    "ville": "Ouides",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Paulhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Paulhaguet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Pébrac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Le Pertuis",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Pinols",
    "dep": "Haute-Loire"
  },
  {
    "code": "43000",
    "ville": "Polignac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43330",
    "ville": "Pont-Salomon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43420",
    "ville": "Pradelles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Prades",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Présailles",
    "dep": "Haute-Loire"
  },
  {
    "code": "43000",
    "ville": "Le Puy-en-Velay",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Queyrières",
    "dep": "Haute-Loire"
  },
  {
    "code": "43290",
    "ville": "Raucoules",
    "dep": "Haute-Loire"
  },
  {
    "code": "43340",
    "ville": "Rauret",
    "dep": "Haute-Loire"
  },
  {
    "code": "43130",
    "ville": "Retournac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43220",
    "ville": "Riotord",
    "dep": "Haute-Loire"
  },
  {
    "code": "43810",
    "ville": "Roche-en-Régnier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Rosières",
    "dep": "Haute-Loire"
  },
  {
    "code": "43130",
    "ville": "Saint-André-de-Chalencon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Saint-Arcons-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43420",
    "ville": "Saint-Arcons-de-Barges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Saint-Austremoine",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Saint-Beauzire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Saint-Bérain",
    "dep": "Haute-Loire"
  },
  {
    "code": "43290",
    "ville": "Saint-Bonnet-le-Froid",
    "dep": "Haute-Loire"
  },
  {
    "code": "43340",
    "ville": "Saint-Christophe-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43370",
    "ville": "Saint-Christophe-sur-Dolaison",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Saint-Cirgues",
    "dep": "Haute-Loire"
  },
  {
    "code": "43140",
    "ville": "Saint-Didier-en-Velay",
    "dep": "Haute-Loire"
  },
  {
    "code": "43440",
    "ville": "Saint-Didier-sur-Doulon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43420",
    "ville": "Saint-Étienne-du-Vigan",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Saint-Étienne-Lardeyrol",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Saint-Étienne-sur-Blesle",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Sainte-Eugénie-de-Villeneuve",
    "dep": "Haute-Loire"
  },
  {
    "code": "43330",
    "ville": "Saint-Ferréol-d'Auroure",
    "dep": "Haute-Loire"
  },
  {
    "code": "43250",
    "ville": "Sainte-Florine",
    "dep": "Haute-Loire"
  },
  {
    "code": "43550",
    "ville": "Saint-Front",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Saint-Geneys-près-Saint-Paulien",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Saint-Georges-d'Aurac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Saint-Georges-Lagricol",
    "dep": "Haute-Loire"
  },
  {
    "code": "43700",
    "ville": "Saint-Germain-Laprade",
    "dep": "Haute-Loire"
  },
  {
    "code": "43360",
    "ville": "Saint-Géron",
    "dep": "Haute-Loire"
  },
  {
    "code": "43340",
    "ville": "Saint-Haon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43390",
    "ville": "Saint-Hilaire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Saint-Hostien",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Saint-Ilpize",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Saint-Jean-d'Aubrigoux",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Saint-Jean-de-Nay",
    "dep": "Haute-Loire"
  },
  {
    "code": "43510",
    "ville": "Saint-Jean-Lachalm",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Saint-Jeures",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Saint-Julien-Chapteuil",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Saint-Julien-d'Ance",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Saint-Julien-des-Chazes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Saint-Julien-du-Pinet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43220",
    "ville": "Saint-Julien-Molhesabate",
    "dep": "Haute-Loire"
  },
  {
    "code": "43240",
    "ville": "Saint-Just-Malmont",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Saint-Just-près-Brioude",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Saint-Laurent-Chabreuges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Sainte-Marguerite",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Saint-Martin-de-Fugères",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Saint-Maurice-de-Lignon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Saint-Pal-de-Chalencon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43620",
    "ville": "Saint-Pal-de-Mons",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Saint-Pal-de-Senouire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43420",
    "ville": "Saint-Paul-de-Tartas",
    "dep": "Haute-Loire"
  },
  {
    "code": "43350",
    "ville": "Saint-Paulien",
    "dep": "Haute-Loire"
  },
  {
    "code": "43810",
    "ville": "Saint-Pierre-du-Champ",
    "dep": "Haute-Loire"
  },
  {
    "code": "43260",
    "ville": "Saint-Pierre-Eynac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Saint-Préjet-Armandon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Saint-Préjet-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Saint-Privat-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Saint-Privat-du-Dragon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43620",
    "ville": "Saint-Romain-Lachalm",
    "dep": "Haute-Loire"
  },
  {
    "code": "43600",
    "ville": "Sainte-Sigolène",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Saint-Vénérand",
    "dep": "Haute-Loire"
  },
  {
    "code": "43440",
    "ville": "Saint-Vert",
    "dep": "Haute-Loire"
  },
  {
    "code": "43140",
    "ville": "Saint-Victor-Malescours",
    "dep": "Haute-Loire"
  },
  {
    "code": "43500",
    "ville": "Saint-Victor-sur-Arlanc",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Saint-Vidal",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Saint-Vincent",
    "dep": "Haute-Loire"
  },
  {
    "code": "43150",
    "ville": "Salettes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Salzuit",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Sanssac-l'Église",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Saugues",
    "dep": "Haute-Loire"
  },
  {
    "code": "43140",
    "ville": "La Séauve-sur-Semène",
    "dep": "Haute-Loire"
  },
  {
    "code": "43160",
    "ville": "Sembadel",
    "dep": "Haute-Loire"
  },
  {
    "code": "43510",
    "ville": "Séneujols",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Siaugues-Sainte-Marie",
    "dep": "Haute-Loire"
  },
  {
    "code": "43130",
    "ville": "Solignac-sous-Roche",
    "dep": "Haute-Loire"
  },
  {
    "code": "43370",
    "ville": "Solignac-sur-Loire",
    "dep": "Haute-Loire"
  },
  {
    "code": "43300",
    "ville": "Tailhac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43190",
    "ville": "Tence",
    "dep": "Haute-Loire"
  },
  {
    "code": "43580",
    "ville": "Thoras",
    "dep": "Haute-Loire"
  },
  {
    "code": "43530",
    "ville": "Tiranges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43450",
    "ville": "Torsiac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43210",
    "ville": "Valprivas",
    "dep": "Haute-Loire"
  },
  {
    "code": "43230",
    "ville": "Vals-le-Chastel",
    "dep": "Haute-Loire"
  },
  {
    "code": "43750",
    "ville": "Vals-près-le-Puy",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "Varennes-Saint-Honorat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43430",
    "ville": "Les Vastres",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Vazeilles-Limandre",
    "dep": "Haute-Loire"
  },
  {
    "code": "43170",
    "ville": "Venteuges",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Vergezac",
    "dep": "Haute-Loire"
  },
  {
    "code": "43360",
    "ville": "Vergongheon",
    "dep": "Haute-Loire"
  },
  {
    "code": "43270",
    "ville": "Vernassal",
    "dep": "Haute-Loire"
  },
  {
    "code": "43320",
    "ville": "Le Vernet",
    "dep": "Haute-Loire"
  },
  {
    "code": "43390",
    "ville": "Vézézoux",
    "dep": "Haute-Loire"
  },
  {
    "code": "43100",
    "ville": "Vieille-Brioude",
    "dep": "Haute-Loire"
  },
  {
    "code": "43490",
    "ville": "Vielprat",
    "dep": "Haute-Loire"
  },
  {
    "code": "43380",
    "ville": "Villeneuve-d'Allier",
    "dep": "Haute-Loire"
  },
  {
    "code": "43600",
    "ville": "Les Villettes",
    "dep": "Haute-Loire"
  },
  {
    "code": "43800",
    "ville": "Vorey",
    "dep": "Haute-Loire"
  },
  {
    "code": "43200",
    "ville": "Yssingeaux",
    "dep": "Haute-Loire"
  },
  {
    "code": "44170",
    "ville": "Abbaretz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "Aigrefeuille-sur-Maine",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44150",
    "ville": "Ancenis-Saint-Géréon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44320",
    "ville": "Chaumes-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44410",
    "ville": "Assérac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44460",
    "ville": "Avessac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44115",
    "ville": "Basse-Goulaine",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44740",
    "ville": "Batz-sur-Mer",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44760",
    "ville": "La Bernerie-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44160",
    "ville": "Besné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "Le Bignon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44130",
    "ville": "Blain",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44430",
    "ville": "La Boissière-du-Doré",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44830",
    "ville": "Bouaye",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "Bouée",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44340",
    "ville": "Bouguenais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44580",
    "ville": "Villeneuve-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Boussay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44130",
    "ville": "Bouvron",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44830",
    "ville": "Brains",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44750",
    "ville": "Campbon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44470",
    "ville": "Carquefou",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Casson",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44850",
    "ville": "Le Cellier",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44450",
    "ville": "Divatte-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44410",
    "ville": "La Chapelle-des-Marais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44670",
    "ville": "La Chapelle-Glain",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44330",
    "ville": "La Chapelle-Heulin",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "La Chapelle-Launay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44240",
    "ville": "La Chapelle-sur-Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Châteaubriant",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44690",
    "ville": "Château-Thébaud",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44320",
    "ville": "Chauvé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44640",
    "ville": "Cheix-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44118",
    "ville": "La Chevrolière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Clisson",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44290",
    "ville": "Conquereuil",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44360",
    "ville": "Cordemais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44560",
    "ville": "Corsept",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44220",
    "ville": "Couëron",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44521",
    "ville": "Couffé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44490",
    "ville": "Le Croisic",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44160",
    "ville": "Crossac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44590",
    "ville": "Derval",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44480",
    "ville": "Donges",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44530",
    "ville": "Drefféac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Erbray",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44500",
    "ville": "La Baule-Escoublac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44130",
    "ville": "Fay-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44460",
    "ville": "Fégréac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44660",
    "ville": "Fercé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44320",
    "ville": "Frossay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44130",
    "ville": "Le Gâvre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Gétigné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Gorges",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44520",
    "ville": "Grand-Auverné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44119",
    "ville": "Grandchamp-des-Fontaines",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44290",
    "ville": "Guémené-Penfao",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44530",
    "ville": "Guenrouet",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44350",
    "ville": "Guérande",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44690",
    "ville": "La Haie-Fouassière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44115",
    "ville": "Haute-Goulaine",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44410",
    "ville": "Herbignac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44810",
    "ville": "Héric",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44610",
    "ville": "Indre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44520",
    "ville": "Issé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "Jans",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44440",
    "ville": "Joué-sur-Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44670",
    "ville": "Juigné-des-Moutiers",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44430",
    "ville": "Le Landreau",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "Lavau-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44650",
    "ville": "Legé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44850",
    "ville": "Ligné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44310",
    "ville": "La Limouzinière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44430",
    "ville": "Le Loroux-Bottereau",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Louisfert",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44590",
    "ville": "Lusanger",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44270",
    "ville": "Machecoul-Saint-Même",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44690",
    "ville": "Maisdon-sur-Sèvre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "Malville",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44270",
    "ville": "La Marne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "Marsac-sur-Don",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44290",
    "ville": "Massérac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44470",
    "ville": "Mauves-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44520",
    "ville": "La Meilleraye-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44522",
    "ville": "Mésanger",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44420",
    "ville": "Mesquer",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44780",
    "ville": "Missillac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44520",
    "ville": "Moisdon-la-Rivière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44690",
    "ville": "Monnières",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44620",
    "ville": "La Montagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "Montbert",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44550",
    "ville": "Montoir-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44370",
    "ville": "Montrelais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44590",
    "ville": "Mouais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44760",
    "ville": "Les Moutiers-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44850",
    "ville": "Mouzeil",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44330",
    "ville": "Mouzillon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44200",
    "ville": "Nantes",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Nort-sur-Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44130",
    "ville": "Notre-Dame-des-Landes",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Noyal-sur-Brutz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "Nozay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44700",
    "ville": "Orvault",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44521",
    "ville": "Oudon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44560",
    "ville": "Paimbœuf",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44330",
    "ville": "Le Pallet",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44440",
    "ville": "Pannecé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44270",
    "ville": "Paulx",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44640",
    "ville": "Le Pellerin",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44670",
    "ville": "Petit-Auverné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Petit-Mars",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44290",
    "ville": "Pierric",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44540",
    "ville": "Le Pin",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44420",
    "ville": "Piriac-sur-Mer",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44770",
    "ville": "La Plaine-sur-Mer",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "La Planche",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44630",
    "ville": "Plessé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44160",
    "ville": "Pontchâteau",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44860",
    "ville": "Pont-Saint-Martin",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44210",
    "ville": "Pornic",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44380",
    "ville": "Pornichet",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44710",
    "ville": "Port-Saint-Père",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44522",
    "ville": "Pouillé-les-Côteaux",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44510",
    "ville": "Le Pouliguen",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44770",
    "ville": "Préfailles",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "Prinquiau",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Puceul",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44750",
    "ville": "Quilly",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44330",
    "ville": "La Regrippière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44430",
    "ville": "La Remaudière",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "Remouillé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44400",
    "ville": "Rezé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44440",
    "ville": "Riaillé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44640",
    "ville": "Rouans",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44660",
    "ville": "Rougé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44660",
    "ville": "Ruffigné",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Saffré",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44860",
    "ville": "Saint-Aignan-Grandlieu",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44117",
    "ville": "Saint-André-des-Eaux",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44160",
    "ville": "Sainte-Anne-sur-Brivet",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Saint-Aubin-des-Châteaux",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44250",
    "ville": "Saint-Brevin-les-Pins",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44310",
    "ville": "Saint-Colomban",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44650",
    "ville": "Corcoué-sur-Logne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44270",
    "ville": "Saint-Étienne-de-Mer-Morte",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44360",
    "ville": "Saint-Étienne-de-Montluc",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44690",
    "ville": "Saint-Fiacre-sur-Maine",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44530",
    "ville": "Saint-Gildas-des-Bois",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44800",
    "ville": "Saint-Herblain",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44150",
    "ville": "Vair-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44680",
    "ville": "Saint-Hilaire-de-Chaléons",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Saint-Hilaire-de-Clisson",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44640",
    "ville": "Saint-Jean-de-Boiseau",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44720",
    "ville": "Saint-Joachim",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44450",
    "ville": "Saint-Julien-de-Concelles",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44670",
    "ville": "Saint-Julien-de-Vouvantes",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44710",
    "ville": "Saint-Léger-les-Vignes",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44980",
    "ville": "Sainte-Luce-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44190",
    "ville": "Saint-Lumine-de-Clisson",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44310",
    "ville": "Saint-Lumine-de-Coutais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44410",
    "ville": "Saint-Lyphard",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44550",
    "ville": "Saint-Malo-de-Guersac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44680",
    "ville": "Saint-Mars-de-Coutais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44850",
    "ville": "Saint-Mars-du-Désert",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44540",
    "ville": "Vallons-de-l'Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44730",
    "ville": "Saint-Michel-Chef-Chef",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44350",
    "ville": "Saint-Molf",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44600",
    "ville": "Saint-Nazaire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44460",
    "ville": "Saint-Nicolas-de-Redon",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44680",
    "ville": "Sainte-Pazanne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44320",
    "ville": "Saint-Père-en-Retz",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44310",
    "ville": "Saint-Philbert-de-Grand-Lieu",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44160",
    "ville": "Sainte-Reine-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44230",
    "ville": "Saint-Sébastien-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44320",
    "ville": "Saint-Viaud",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44590",
    "ville": "Saint-Vincent-des-Landes",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44880",
    "ville": "Sautron",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44260",
    "ville": "Savenay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44530",
    "ville": "Sévérac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44590",
    "ville": "Sion-les-Mines",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44840",
    "ville": "Les Sorinières",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Soudan",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44660",
    "ville": "Soulvache",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44240",
    "ville": "Sucé-sur-Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44440",
    "ville": "Teillé",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44360",
    "ville": "Le Temple-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44470",
    "ville": "Thouaré-sur-Loire",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44390",
    "ville": "Les Touches",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44650",
    "ville": "Touvois",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44440",
    "ville": "Trans-sur-Erdre",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "Treffieux",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44119",
    "ville": "Treillières",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44570",
    "ville": "Trignac",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44420",
    "ville": "La Turballe",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44330",
    "ville": "Vallet",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44370",
    "ville": "Loireauxence",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "Vay",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44120",
    "ville": "Vertou",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44116",
    "ville": "Vieillevigne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44360",
    "ville": "Vigneux-de-Bretagne",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44110",
    "ville": "Villepot",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44640",
    "ville": "Vue",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44810",
    "ville": "La Chevallerais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44522",
    "ville": "La Roche-Blanche",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44140",
    "ville": "Geneston",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "44170",
    "ville": "La Grigonnais",
    "dep": "Loire-Atlantique"
  },
  {
    "code": "45230",
    "ville": "Adon",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Aillant-sur-Milleron",
    "dep": "Loiret"
  },
  {
    "code": "45200",
    "ville": "Amilly",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Andonville",
    "dep": "Loiret"
  },
  {
    "code": "45160",
    "ville": "Ardon",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Artenay",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Aschères-le-Marché",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Ascoux",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Attray",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Audeville",
    "dep": "Loiret"
  },
  {
    "code": "45330",
    "ville": "Augerville-la-Rivière",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Aulnay-la-Rivière",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Autruy-sur-Juine",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Autry-le-Châtel",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Auvilliers-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Auxy",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Baccon",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Le Bardon",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Barville-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Batilly-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Batilly-en-Puisaye",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Baule",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Bazoches-les-Gallerandes",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Bazoches-sur-le-Betz",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Beauchamps-sur-Huillard",
    "dep": "Loiret"
  },
  {
    "code": "45190",
    "ville": "Beaugency",
    "dep": "Loiret"
  },
  {
    "code": "45630",
    "ville": "Beaulieu-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Beaune-la-Rolande",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Bellegarde",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Le Bignon-Mirabeau",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Boësses",
    "dep": "Loiret"
  },
  {
    "code": "45760",
    "ville": "Boigny-sur-Bionne",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Boiscommun",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Boismorand",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Boisseaux",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Bondaroy",
    "dep": "Loiret"
  },
  {
    "code": "45460",
    "ville": "Bonnée",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Bonny-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Bordeaux-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45460",
    "ville": "Les Bordes",
    "dep": "Loiret"
  },
  {
    "code": "45430",
    "ville": "Bou",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Bougy-lez-Neuville",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Bouilly-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45140",
    "ville": "Boulay-les-Barres",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Bouzonville-aux-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45460",
    "ville": "Bouzy-la-Forêt",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Boynes",
    "dep": "Loiret"
  },
  {
    "code": "45460",
    "ville": "Bray-Saint-Aignan",
    "dep": "Loiret"
  },
  {
    "code": "45250",
    "ville": "Breteau",
    "dep": "Loiret"
  },
  {
    "code": "45250",
    "ville": "Briare",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Briarres-sur-Essonne",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Bricy",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Bromeilles",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Bucy-le-Roi",
    "dep": "Loiret"
  },
  {
    "code": "45140",
    "ville": "Bucy-Saint-Liphard",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "La Bussière",
    "dep": "Loiret"
  },
  {
    "code": "45120",
    "ville": "Cepoy",
    "dep": "Loiret"
  },
  {
    "code": "45520",
    "ville": "Cercottes",
    "dep": "Loiret"
  },
  {
    "code": "45620",
    "ville": "Cerdon",
    "dep": "Loiret"
  },
  {
    "code": "45360",
    "ville": "Cernoy-en-Berry",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Césarville-Dossainville",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Chailly-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45380",
    "ville": "Chaingy",
    "dep": "Loiret"
  },
  {
    "code": "45120",
    "ville": "Châlette-sur-Loing",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Chambon-la-Forêt",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Champoulet",
    "dep": "Loiret"
  },
  {
    "code": "45400",
    "ville": "Chanteau",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Chantecoq",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "La Chapelle-Onzerain",
    "dep": "Loiret"
  },
  {
    "code": "45380",
    "ville": "La Chapelle-Saint-Mesmin",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "La Chapelle-Saint-Sépulcre",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "La Chapelle-sur-Aveyron",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Chapelon",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Le Charme",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Charmont-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Charsonville",
    "dep": "Loiret"
  },
  {
    "code": "45110",
    "ville": "Châteauneuf-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Château-Renard",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Châtenoy",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Châtillon-Coligny",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Châtillon-le-Roi",
    "dep": "Loiret"
  },
  {
    "code": "45360",
    "ville": "Châtillon-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Chaussy",
    "dep": "Loiret"
  },
  {
    "code": "45430",
    "ville": "Chécy",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Chevannes",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Chevillon-sur-Huillard",
    "dep": "Loiret"
  },
  {
    "code": "45520",
    "ville": "Chevilly",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Chevry-sous-le-Bignon",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Chilleurs-aux-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Les Choux",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Chuelles",
    "dep": "Loiret"
  },
  {
    "code": "45370",
    "ville": "Cléry-Saint-André",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Coinces",
    "dep": "Loiret"
  },
  {
    "code": "45800",
    "ville": "Combleux",
    "dep": "Loiret"
  },
  {
    "code": "45530",
    "ville": "Combreux",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Conflans-sur-Loing",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Corbeilles",
    "dep": "Loiret"
  },
  {
    "code": "45120",
    "ville": "Corquilleroy",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Cortrat",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Coudroy",
    "dep": "Loiret"
  },
  {
    "code": "45720",
    "ville": "Coullons",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Coulmiers",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Courcelles-le-Roi",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Courcy-aux-Loges",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "La Cour-Marigny",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Courtemaux",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Courtempierre",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Courtenay",
    "dep": "Loiret"
  },
  {
    "code": "45190",
    "ville": "Cravant",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Crottes-en-Pithiverais",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Dadonville",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Dammarie-en-Puisaye",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Dammarie-sur-Loing",
    "dep": "Loiret"
  },
  {
    "code": "45570",
    "ville": "Dampierre-en-Burly",
    "dep": "Loiret"
  },
  {
    "code": "45150",
    "ville": "Darvoy",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Desmonts",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Dimancheville",
    "dep": "Loiret"
  },
  {
    "code": "45450",
    "ville": "Donnery",
    "dep": "Loiret"
  },
  {
    "code": "45680",
    "ville": "Dordives",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Douchy-Montcorbon",
    "dep": "Loiret"
  },
  {
    "code": "45370",
    "ville": "Dry",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Échilleuses",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Égry",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Engenville",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Épieds-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Erceville",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Ervauville",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Escrennes",
    "dep": "Loiret"
  },
  {
    "code": "45250",
    "ville": "Escrignelles",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Estouy",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Faverelles",
    "dep": "Loiret"
  },
  {
    "code": "45450",
    "ville": "Fay-aux-Loges",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Feins-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45150",
    "ville": "Férolles",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Ferrières-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45240",
    "ville": "La Ferté-Saint-Aubin",
    "dep": "Loiret"
  },
  {
    "code": "45400",
    "ville": "Fleury-les-Aubrais",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Fontenay-sur-Loing",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Foucherolles",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Fréville-du-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Gaubertin",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Gémigny",
    "dep": "Loiret"
  },
  {
    "code": "45110",
    "ville": "Germigny-des-Prés",
    "dep": "Loiret"
  },
  {
    "code": "45520",
    "ville": "Gidy",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Gien",
    "dep": "Loiret"
  },
  {
    "code": "45120",
    "ville": "Girolles",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Givraines",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Gondreville",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Grangermont",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Greneville-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Griselles",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Guigneville",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Guilly",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Gy-les-Nonains",
    "dep": "Loiret"
  },
  {
    "code": "45520",
    "ville": "Huêtre",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Huisseau-sur-Mauves",
    "dep": "Loiret"
  },
  {
    "code": "45450",
    "ville": "Ingrannes",
    "dep": "Loiret"
  },
  {
    "code": "45140",
    "ville": "Ingré",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Intville-la-Guétard",
    "dep": "Loiret"
  },
  {
    "code": "45620",
    "ville": "Isdes",
    "dep": "Loiret"
  },
  {
    "code": "45150",
    "ville": "Jargeau",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Jouy-en-Pithiverais",
    "dep": "Loiret"
  },
  {
    "code": "45370",
    "ville": "Jouy-le-Potier",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Juranville",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Laas",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Ladon",
    "dep": "Loiret"
  },
  {
    "code": "45740",
    "ville": "Lailly-en-Val",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Langesse",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Léouville",
    "dep": "Loiret"
  },
  {
    "code": "45240",
    "ville": "Ligny-le-Ribault",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Lion-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Lion-en-Sullias",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Lombreuil",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Lorcy",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Lorris",
    "dep": "Loiret"
  },
  {
    "code": "45470",
    "ville": "Loury",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Louzouer",
    "dep": "Loiret"
  },
  {
    "code": "45330",
    "ville": "Le Malesherbois",
    "dep": "Loiret"
  },
  {
    "code": "45240",
    "ville": "Marcilly-en-Villette",
    "dep": "Loiret"
  },
  {
    "code": "45430",
    "ville": "Mardié",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Mareau-aux-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45370",
    "ville": "Mareau-aux-Prés",
    "dep": "Loiret"
  },
  {
    "code": "45760",
    "ville": "Marigny-les-Usages",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Marsainvilliers",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Melleroy",
    "dep": "Loiret"
  },
  {
    "code": "45240",
    "ville": "Ménestreau-en-Villette",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Mérinville",
    "dep": "Loiret"
  },
  {
    "code": "45190",
    "ville": "Messas",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Meung-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45370",
    "ville": "Mézières-lez-Cléry",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Mézières-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Mignères",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Mignerette",
    "dep": "Loiret"
  },
  {
    "code": "45200",
    "ville": "Montargis",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Montbarrois",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Montbouy",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Montcresson",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Montereau",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Montigny",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Montliard",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Mormant-sur-Vernisson",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Morville-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Le Moulinet-sur-Solin",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Moulon",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Nancray-sur-Rimarde",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Nargis",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Nesploy",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Neuville-aux-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "La Neuville-sur-Essonne",
    "dep": "Loiret"
  },
  {
    "code": "45510",
    "ville": "Neuvy-en-Sullias",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Nevoy",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Nibelle",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Nogent-sur-Vernisson",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Noyers",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Oison",
    "dep": "Loiret"
  },
  {
    "code": "45160",
    "ville": "Olivet",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Ondreville-sur-Essonne",
    "dep": "Loiret"
  },
  {
    "code": "45000",
    "ville": "Orléans",
    "dep": "Loiret"
  },
  {
    "code": "45140",
    "ville": "Ormes",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Orville",
    "dep": "Loiret"
  },
  {
    "code": "45250",
    "ville": "Ousson-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Oussoy-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45480",
    "ville": "Outarville",
    "dep": "Loiret"
  },
  {
    "code": "45150",
    "ville": "Ouvrouer-les-Champs",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Ouzouer-des-Champs",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Ouzouer-sous-Bellegarde",
    "dep": "Loiret"
  },
  {
    "code": "45570",
    "ville": "Ouzouer-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45250",
    "ville": "Ouzouer-sur-Trézée",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Pannecières",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Pannes",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Patay",
    "dep": "Loiret"
  },
  {
    "code": "45200",
    "ville": "Paucourt",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Pers-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45360",
    "ville": "Pierrefitte-ès-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Pithiviers",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Pithiviers-le-Vieil",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Poilly-lez-Gien",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Préfontaines",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Presnoy",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Pressigny-les-Pins",
    "dep": "Loiret"
  },
  {
    "code": "45390",
    "ville": "Puiseaux",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Quiers-sur-Bezonde",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Ramoulu",
    "dep": "Loiret"
  },
  {
    "code": "45470",
    "ville": "Rebréchien",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Rouvray-Sainte-Croix",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Rouvres-Saint-Jean",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Rozières-en-Beauce",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Rozoy-le-Vieil",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Ruan",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Saint-Aignan-le-Jaillard",
    "dep": "Loiret"
  },
  {
    "code": "45130",
    "ville": "Saint-Ay",
    "dep": "Loiret"
  },
  {
    "code": "45730",
    "ville": "Saint-Benoît-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Saint-Brisson-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45590",
    "ville": "Saint-Cyr-en-Val",
    "dep": "Loiret"
  },
  {
    "code": "45550",
    "ville": "Saint-Denis-de-l'Hôtel",
    "dep": "Loiret"
  },
  {
    "code": "45560",
    "ville": "Saint-Denis-en-Val",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Saint-Firmin-des-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45360",
    "ville": "Saint-Firmin-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Saint-Florent",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Sainte-Geneviève-des-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Saint-Germain-des-Prés",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Saint-Gondon",
    "dep": "Loiret"
  },
  {
    "code": "45320",
    "ville": "Saint-Hilaire-les-Andrésis",
    "dep": "Loiret"
  },
  {
    "code": "45160",
    "ville": "Saint-Hilaire-Saint-Mesmin",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Saint-Hilaire-sur-Puiseaux",
    "dep": "Loiret"
  },
  {
    "code": "45800",
    "ville": "Saint-Jean-de-Braye",
    "dep": "Loiret"
  },
  {
    "code": "45140",
    "ville": "Saint-Jean-de-la-Ruelle",
    "dep": "Loiret"
  },
  {
    "code": "45650",
    "ville": "Saint-Jean-le-Blanc",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Saint-Loup-des-Vignes",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Saint-Lyé-la-Forêt",
    "dep": "Loiret"
  },
  {
    "code": "45110",
    "ville": "Saint-Martin-d'Abbat",
    "dep": "Loiret"
  },
  {
    "code": "45500",
    "ville": "Saint-Martin-sur-Ocre",
    "dep": "Loiret"
  },
  {
    "code": "45230",
    "ville": "Saint-Maurice-sur-Aveyron",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Saint-Maurice-sur-Fessard",
    "dep": "Loiret"
  },
  {
    "code": "45340",
    "ville": "Saint-Michel",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Saint-Péravy-la-Colombe",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Saint-Père-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45750",
    "ville": "Saint-Pryvé-Saint-Mesmin",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Saint-Sigismond",
    "dep": "Loiret"
  },
  {
    "code": "45640",
    "ville": "Sandillon",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Santeau",
    "dep": "Loiret"
  },
  {
    "code": "45770",
    "ville": "Saran",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Sceaux-du-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45530",
    "ville": "Seichebrières",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "La Selle-en-Hermoy",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "La Selle-sur-le-Bied",
    "dep": "Loiret"
  },
  {
    "code": "45400",
    "ville": "Semoy",
    "dep": "Loiret"
  },
  {
    "code": "45240",
    "ville": "Sennely",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Sermaises",
    "dep": "Loiret"
  },
  {
    "code": "45110",
    "ville": "Sigloy",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Solterre",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Sougy",
    "dep": "Loiret"
  },
  {
    "code": "45450",
    "ville": "Sully-la-Chapelle",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Sully-sur-Loire",
    "dep": "Loiret"
  },
  {
    "code": "45530",
    "ville": "Sury-aux-Bois",
    "dep": "Loiret"
  },
  {
    "code": "45190",
    "ville": "Tavers",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Thignonville",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Thimory",
    "dep": "Loiret"
  },
  {
    "code": "45210",
    "ville": "Thorailles",
    "dep": "Loiret"
  },
  {
    "code": "45420",
    "ville": "Thou",
    "dep": "Loiret"
  },
  {
    "code": "45510",
    "ville": "Tigy",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Tivernon",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Tournoisis",
    "dep": "Loiret"
  },
  {
    "code": "45470",
    "ville": "Traînou",
    "dep": "Loiret"
  },
  {
    "code": "45490",
    "ville": "Treilles-en-Gâtinais",
    "dep": "Loiret"
  },
  {
    "code": "45220",
    "ville": "Triguères",
    "dep": "Loiret"
  },
  {
    "code": "45410",
    "ville": "Trinay",
    "dep": "Loiret"
  },
  {
    "code": "45510",
    "ville": "Vannes-sur-Cosson",
    "dep": "Loiret"
  },
  {
    "code": "45290",
    "ville": "Varennes-Changy",
    "dep": "Loiret"
  },
  {
    "code": "45760",
    "ville": "Vennecy",
    "dep": "Loiret"
  },
  {
    "code": "45260",
    "ville": "Vieilles-Maisons-sur-Joudry",
    "dep": "Loiret"
  },
  {
    "code": "45510",
    "ville": "Vienne-en-Val",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Viglain",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Villamblain",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Villemandeur",
    "dep": "Loiret"
  },
  {
    "code": "45270",
    "ville": "Villemoutiers",
    "dep": "Loiret"
  },
  {
    "code": "45600",
    "ville": "Villemurlin",
    "dep": "Loiret"
  },
  {
    "code": "45310",
    "ville": "Villeneuve-sur-Conie",
    "dep": "Loiret"
  },
  {
    "code": "45170",
    "ville": "Villereau",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Villevoques",
    "dep": "Loiret"
  },
  {
    "code": "45190",
    "ville": "Villorceau",
    "dep": "Loiret"
  },
  {
    "code": "45700",
    "ville": "Vimory",
    "dep": "Loiret"
  },
  {
    "code": "45530",
    "ville": "Vitry-aux-Loges",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Vrigny",
    "dep": "Loiret"
  },
  {
    "code": "45300",
    "ville": "Yèvre-la-Ville",
    "dep": "Loiret"
  },
  {
    "code": "46140",
    "ville": "Albas",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Albiac",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Alvignac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Anglars",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Anglars-Juillac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Anglars-Nozac",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Arcambal",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Les Arques",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Assier",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Aujols",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Autoire",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Aynac",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Bach",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Bagnac-sur-Célé",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Baladou",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Bannes",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Le Bastit",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Beauregard",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Béduer",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Bélaye",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Belfort-du-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Belmont-Bretenoux",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Belmont-Sainte-Foi",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Berganty",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Bétaille",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Biars-sur-Cère",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Bio",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Blars",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Boissières",
    "dep": "Lot"
  },
  {
    "code": "46800",
    "ville": "Porte-du-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Le Bourg",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Boussac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Le Bouyssou",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Bouziès",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Bretenoux",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Brengues",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Cabrerets",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Cadrieu",
    "dep": "Lot"
  },
  {
    "code": "46000",
    "ville": "Cahors",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Cahus",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Caillac",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Cajarc",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Calamane",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Calès",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Calvignac",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Cambayrac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Cambes",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Camboulit",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Camburat",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Caniac-du-Causse",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Capdenac",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Carayac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Cardaillac",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Carennac",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Carlucet",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Carnac-Rouffiac",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Cassagnes",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Castelfranc",
    "dep": "Lot"
  },
  {
    "code": "46170",
    "ville": "Castelnau-Montratier",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Catus",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Cavagnac",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Cazals",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Cénevières",
    "dep": "Lot"
  },
  {
    "code": "46170",
    "ville": "Cézac",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Cieurac",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Concorès",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Concots",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Condat",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Corn",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Cornac",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Couzou",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Cras",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Crayssac",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Crégols",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Cremps",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Cressensac-Sarrazac",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Creysse",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Cuzac",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Cuzance",
    "dep": "Lot"
  },
  {
    "code": "46340",
    "ville": "Dégagnac",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Douelle",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Duravel",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Durbans",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Escamps",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Esclauzels",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Espagnac-Sainte-Eulalie",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Espédaillac",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Espère",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Espeyroux",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Estal",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Fajoles",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Faycelles",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Felzins",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Figeac",
    "dep": "Lot"
  },
  {
    "code": "46170",
    "ville": "Saint-Paul-Flaugnac",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Flaujac-Gare",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Flaujac-Poujols",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Floirac",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Floressas",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Fons",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Fontanes",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Fourmagnac",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Francoulès",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Frayssinet",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Frayssinet-le-Gélat",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Frayssinhes",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Frontenac",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Gagnac-sur-Cère",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Gignac",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Gigouzac",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Gindou",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Ginouillac",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Gintrac",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Girac",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Glanes",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Gorses",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Goujounac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Gourdon",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Gramat",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Gréalou",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Grézels",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Grèzes",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Issendolus",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Issepts",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Les Junies",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Labastide-du-Haut-Mont",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Labastide-du-Vert",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Labastide-Marnhac",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Cœur de Causse",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Labathude",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Laburgade",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Lacapelle-Cabanac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Lacapelle-Marival",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Lacave",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Lachapelle-Auzac",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Ladirat",
    "dep": "Lot"
  },
  {
    "code": "46220",
    "ville": "Lagardelle",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Lalbenque",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Lamagdelaine",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Lamothe-Cassel",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Lamothe-Fénelon",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Lanzac",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Laramière",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Larnagol",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Bellefont-La Rauze",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Larroque-Toirac",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Latouille-Lentillac",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Latronquière",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Lauresses",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Lauzès",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Laval-de-Cère",
    "dep": "Lot"
  },
  {
    "code": "46340",
    "ville": "Lavercantière",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Lavergne",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Lentillac-du-Causse",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Lentillac-Saint-Blaise",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Léobard",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Leyme",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Lherm",
    "dep": "Lot"
  },
  {
    "code": "46170",
    "ville": "Lhospitalet",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Limogne-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Linac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Lissac-et-Mouret",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Livernon",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Loubressac",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Loupiac",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Lugagnac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Lunan",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Lunegarde",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Luzech",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Marcilhac-sur-Célé",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Marminiac",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Martel",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Masclat",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Mauroux",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Maxou",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Mayrinhac-Lentour",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Mechmont",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Mercuès",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Meyronne",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Miers",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Milhac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Molières",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Montamel",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Le Montat",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Montbrun",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Montcabrier",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Montcléra",
    "dep": "Lot"
  },
  {
    "code": "46800",
    "ville": "Montcuq-en-Quercy-Blanc",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Montdoumerc",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Montet-et-Bouxal",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Montfaucon",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Montgesty",
    "dep": "Lot"
  },
  {
    "code": "46800",
    "ville": "Montlauzun",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Montredon",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Montvalent",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Nadaillac-de-Rouge",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Nadillac",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Nuzéjouls",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Orniac",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Padirac",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Parnac",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Payrac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Payrignac",
    "dep": "Lot"
  },
  {
    "code": "46170",
    "ville": "Pern",
    "dep": "Lot"
  },
  {
    "code": "46220",
    "ville": "Pescadoires",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Peyrilles",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Pinsac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Planioles",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Pomarède",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Pontcirq",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Pradines",
    "dep": "Lot"
  },
  {
    "code": "46220",
    "ville": "Prayssac",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Prendeignes",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Promilhanes",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Prudhomat",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Puybrun",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Puyjourdes",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Puy-l'Évêque",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Le Vignon-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Quissac-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46340",
    "ville": "Rampoux",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Reilhac",
    "dep": "Lot"
  },
  {
    "code": "46350",
    "ville": "Reilhaguet",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Reyrevignes",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Rignac",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Le Roc",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Rocamadour",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Rouffilhac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Rudelle",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Rueyres",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Sabadel-Latronquière",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Sabadel-Lauzès",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Saignes",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Saillac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Saint-Bressou",
    "dep": "Lot"
  },
  {
    "code": "46250",
    "ville": "Saint-Caprais",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Céré",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Les Pechs du Vers",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Saint-Chamarand",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Saint-Chels",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Saint-Cirgues",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Saint-Cirq-Lapopie",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Saint-Cirq-Madelon",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Saint-Cirq-Souillaguet",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Saint-Clair",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Sainte-Colombe",
    "dep": "Lot"
  },
  {
    "code": "46800",
    "ville": "Lendou-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46800",
    "ville": "Barguelonne-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Saint-Denis-Catus",
    "dep": "Lot"
  },
  {
    "code": "46600",
    "ville": "Saint-Denis-lès-Martel",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Saint-Félix",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Saint-Germain-du-Bel-Air",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Saint Géry-Vers",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Saint-Hilaire",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Saint-Jean-de-Laur",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Jean-Lespinasse",
    "dep": "Lot"
  },
  {
    "code": "46270",
    "ville": "Saint-Jean-Mirabel",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Laurent-les-Tours",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Saint-Martin-Labouval",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Saint-Martin-le-Redon",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Saint-Maurice-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Saint-Médard",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Médard-de-Presque",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Saint-Médard-Nicourby",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Saint-Michel-de-Bannières",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Saint-Michel-Loubéjou",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Paul-de-Vern",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Saint-Perdoux",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Saint-Pierre-Toirac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Saint-Projet",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Saint-Simon",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Saint-Sozy",
    "dep": "Lot"
  },
  {
    "code": "46160",
    "ville": "Saint-Sulpice",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Vincent-du-Pendit",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Saint-Vincent-Rive-d'Olt",
    "dep": "Lot"
  },
  {
    "code": "46340",
    "ville": "Salviac",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Sauliac-sur-Célé",
    "dep": "Lot"
  },
  {
    "code": "46140",
    "ville": "Sauzet",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Sénaillac-Latronquière",
    "dep": "Lot"
  },
  {
    "code": "46360",
    "ville": "Sénaillac-Lauzès",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Séniergues",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Sérignac",
    "dep": "Lot"
  },
  {
    "code": "46320",
    "ville": "Sonac",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Soturac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Soucirac",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Souillac",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Soulomès",
    "dep": "Lot"
  },
  {
    "code": "46190",
    "ville": "Sousceyrac-en-Quercy",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Strenquels",
    "dep": "Lot"
  },
  {
    "code": "46130",
    "ville": "Tauriac",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Terrou",
    "dep": "Lot"
  },
  {
    "code": "46190",
    "ville": "Teyssieu",
    "dep": "Lot"
  },
  {
    "code": "46150",
    "ville": "Thédirac",
    "dep": "Lot"
  },
  {
    "code": "46500",
    "ville": "Thégra",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Thémines",
    "dep": "Lot"
  },
  {
    "code": "46120",
    "ville": "Théminettes",
    "dep": "Lot"
  },
  {
    "code": "46330",
    "ville": "Tour-de-Faure",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Touzac",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Trespoux-Rassiels",
    "dep": "Lot"
  },
  {
    "code": "46240",
    "ville": "Ussel",
    "dep": "Lot"
  },
  {
    "code": "46310",
    "ville": "Uzech",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Varaire",
    "dep": "Lot"
  },
  {
    "code": "46230",
    "ville": "Vaylats",
    "dep": "Lot"
  },
  {
    "code": "46110",
    "ville": "Vayrac",
    "dep": "Lot"
  },
  {
    "code": "46100",
    "ville": "Viazac",
    "dep": "Lot"
  },
  {
    "code": "46260",
    "ville": "Vidaillac",
    "dep": "Lot"
  },
  {
    "code": "46300",
    "ville": "Le Vigan",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Villesèque",
    "dep": "Lot"
  },
  {
    "code": "46700",
    "ville": "Vire-sur-Lot",
    "dep": "Lot"
  },
  {
    "code": "46200",
    "ville": "Mayrac",
    "dep": "Lot"
  },
  {
    "code": "46210",
    "ville": "Bessonies",
    "dep": "Lot"
  },
  {
    "code": "46400",
    "ville": "Saint-Jean-Lagineste",
    "dep": "Lot"
  },
  {
    "code": "46090",
    "ville": "Saint-Pierre-Lafeuille",
    "dep": "Lot"
  },
  {
    "code": "47000",
    "ville": "Agen",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Agmé",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Agnac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47190",
    "ville": "Aiguillon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Allemans-du-Dropt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47110",
    "ville": "Allez-et-Cazeneuve",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Allons",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Ambrus",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Andiran",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Antagnac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Anthé",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Anzex",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Argenton",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Armillac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Astaffort",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Aubiac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Auradou",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Auriac-sur-Dropt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47480",
    "ville": "Bajamont",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Baleyssagues",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Barbaste",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Bazens",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Beaugas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Beaupuy",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47470",
    "ville": "Beauville",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Beauziac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47300",
    "ville": "Bias",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Birac-sur-Trec",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Blanquefort-sur-Briolance",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47470",
    "ville": "Blaymont",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47550",
    "ville": "Boé",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47240",
    "ville": "Bon-Encontre",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Boudy-de-Beauregard",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Bouglon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47410",
    "ville": "Bourgougnague",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Bourlens",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Bournel",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47320",
    "ville": "Bourran",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Boussès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Brax",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Bruch",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Brugnac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Buzet-sur-Baïse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Cahuzac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Calignac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47430",
    "ville": "Calonges",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Cambes",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Cancon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47440",
    "ville": "Casseneuil",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Cassignas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47240",
    "ville": "Castelculier",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Casteljaloux",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Castella",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Castelmoron-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Castelnaud-de-Gratecambe",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Castelnau-sur-Gupie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Castillonnès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Caubeyres",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Caubon-Saint-Sauveur",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Caudecoste",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47430",
    "ville": "Caumont-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47470",
    "ville": "Cauzac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Cavarc",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Cazideroque",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47320",
    "ville": "Clairac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Clermont-Dessous",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Clermont-Soubiran",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Cocumont",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47450",
    "ville": "Colayrac-Saint-Cirq",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Condezaygues",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Coulx",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Courbiac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Cours",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Couthures-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "La Croix-Blanche",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Cuq",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Cuzorn",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Damazan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Dausse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Dévillac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47110",
    "ville": "Dolmayrac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47470",
    "ville": "Dondas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Doudrac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Douzains",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Durance",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Duras",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47470",
    "ville": "Engayrac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Escassefort",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Esclottes",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Espiens",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Estillac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Fals",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Fargues-sur-Ourbise",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Fauguerolles",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Fauillet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Ferrensac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Feugarolles",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Fieux",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Fongrave",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47510",
    "ville": "Foulayronnes",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Fourques-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Francescas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Fréchou",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Frégimont",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Frespech",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Fumel",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47190",
    "ville": "Galapian",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Gaujac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Gavaudun",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Gontaud-de-Nogaret",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Granges-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Grateloup-Saint-Gayrand",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Grayssas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Grézet-Cavagnan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Guérin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Hautefage-la-Tour",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Hautesvignes",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Houeillès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Jusix",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Labastide-Castel-Amouroux",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Labretonie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Lacapelle-Biron",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Lacaussade",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Lacépède",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Lachapelle",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47320",
    "ville": "Lafitte-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47240",
    "ville": "Lafox",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47190",
    "ville": "Lagarrigue",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Lagruère",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Lagupie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Lalandusse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Lamontjoie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Lannes",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Laparade",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Laperche",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Laplume",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Laroque-Timbaut",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Lasserre",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Laugnac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Laussou",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47410",
    "ville": "Lauzun",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Lavardac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Lavergne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47390",
    "ville": "Layrac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47300",
    "ville": "Lédat",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Lévignac-de-Guyenne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Leyritz-Moncassin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Longueville",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Loubès-Bernac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Lougratte",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Lusignan-Petit",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Madaillan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Marcellus",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Marmande",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Marmont-Pachas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47430",
    "ville": "Le Mas-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Masquières",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Massels",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Massoulès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Mauvezin-sur-Gupie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Mazières-Naresse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Meilhan-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Mézin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Miramont-de-Guyenne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Moirax",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Monbahus",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Monbalen",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Moncaut",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Monclar",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Moncrabeau",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Monflanquin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Montgaillard-en-Albret",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Monheurt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Monségur",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Monsempron-Libos",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Montagnac-sur-Auvignon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Montagnac-sur-Lède",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Montastruc",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Montauriol",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Montaut",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Montayral",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Montesquieu",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Monteton",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Montignac-de-Lauzun",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Montignac-Toupinerie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Montpezat",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Montpouillan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Monviel",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Moulinet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Moustier",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Nérac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47190",
    "ville": "Nicole",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Nomdieu",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47440",
    "ville": "Pailloles",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Pardaillan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Parranquet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47520",
    "ville": "Le Passage",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Paulhiac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Penne-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Peyrière",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Pindères",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Pinel-Hauterive",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Pompiey",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Pompogne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47480",
    "ville": "Pont-du-Casse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Port-Sainte-Marie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Poudenas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Poussignac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Prayssas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Puch-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47300",
    "ville": "Pujols",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Puymiclan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Puymirol",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Puysserampion",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Rayet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Razimet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Réaup-Lisse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "La Réunion",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Rives",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Romestaing",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Roquefort",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Roumagne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Ruffiac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Saint-Antoine-de-Ficalba",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Saint-Astier",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Saint-Aubin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Saint-Avit",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Saint-Barthélemy-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Sainte-Bazeille",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Caprais-de-Lerm",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47410",
    "ville": "Saint-Colomb-de-Lauzun",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Sainte-Colombe-de-Duras",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47300",
    "ville": "Sainte-Colombe-de-Villeneuve",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Sainte-Colombe-en-Bruilhois",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Saint-Étienne-de-Fougères",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Saint-Étienne-de-Villeréal",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Saint-Eutrope-de-Born",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Saint-Front-sur-Lémance",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Sainte-Gemme-Martaillac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Saint-Géraud",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47450",
    "ville": "Saint-Hilaire-de-Lusignan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Saint-Jean-de-Duras",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Jean-de-Thurac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47130",
    "ville": "Saint-Laurent",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Saint-Léger",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Saint-Léon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47110",
    "ville": "Sainte-Livrade-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47430",
    "ville": "Sainte-Marthe",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47700",
    "ville": "Saint-Martin-Curton",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Martin-de-Beauville",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Saint-Martin-de-Villeréal",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Saint-Martin-Petit",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Sainte-Maure-de-Peyriac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Saint-Maurice-de-Lestapel",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Maurin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Saint-Nicolas-de-la-Balerme",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Saint-Pardoux-du-Breuil",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "Saint-Pardoux-Isaac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47290",
    "ville": "Saint-Pastour",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Saint-Pé-Saint-Simon",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Saint-Pierre-de-Buzet",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Pierre-de-Clairac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Saint-Pierre-sur-Dropt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47330",
    "ville": "Saint-Quentin-du-Dropt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Saint-Robert",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Romain-le-Noble",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Saint-Salvy",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Saint-Sardos",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47180",
    "ville": "Saint-Sauveur-de-Meilhan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Saint-Sernin",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Saint-Sixte",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Saint-Sylvestre-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Saint-Urcisse",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Saint-Vincent-de-Lamontjoie",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Saint-Vite",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Salles",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47250",
    "ville": "Samazan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47420",
    "ville": "Sauméjan",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47600",
    "ville": "Saumont",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47340",
    "ville": "Sauvagnas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "La Sauvetat-de-Savères",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47800",
    "ville": "La Sauvetat-du-Dropt",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "La Sauvetat-sur-Lède",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47500",
    "ville": "Sauveterre-la-Lémance",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47220",
    "ville": "Sauveterre-Saint-Denis",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Savignac-de-Duras",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47150",
    "ville": "Savignac-sur-Leyze",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47410",
    "ville": "Ségalas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47360",
    "ville": "Sembas",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47430",
    "ville": "Sénestis",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47410",
    "ville": "Sérignac-Péboudou",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47310",
    "ville": "Sérignac-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47350",
    "ville": "Seyches",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47170",
    "ville": "Sos",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Soumensac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Taillebourg",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47270",
    "ville": "Tayrac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47110",
    "ville": "Le Temple-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Thézac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Thouars-sur-Garonne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Tombebœuf",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Tonneins",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Tourliac",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Tournon-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Tourtrès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Trémons",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47140",
    "ville": "Trentels",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Varès",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47260",
    "ville": "Verteuil-d'Agenais",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Vianne",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47380",
    "ville": "Villebramar",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47160",
    "ville": "Villefranche-du-Queyran",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47120",
    "ville": "Villeneuve-de-Duras",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47300",
    "ville": "Villeneuve-sur-Lot",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47210",
    "ville": "Villeréal",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47400",
    "ville": "Villeton",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47200",
    "ville": "Virazeil",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47230",
    "ville": "Xaintrailles",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "47370",
    "ville": "Saint-Georges",
    "dep": "Lot-et-Garonne"
  },
  {
    "code": "48310",
    "ville": "Albaret-le-Comtal",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Albaret-Sainte-Marie",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Allenc",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Altier",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Antrenas",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Arzenc-d'Apcher",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Arzenc-de-Randon",
    "dep": "Lozère"
  },
  {
    "code": "48130",
    "ville": "Peyre en Aubrac",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "Auroux",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Les Monts-Verts",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Badaroux",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Pied-de-Borne",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Balsièges",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "Banassac-Canilhac",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Barjac",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Barre-des-Cévennes",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Bassurels",
    "dep": "Lozère"
  },
  {
    "code": "48250",
    "ville": "La Bastide-Puylaurent",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Les Bessons",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Blavignac",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Mont Lozère et Goulet",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Les Bondons",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Le Born",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Brenoux",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Brion",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Le Buisson",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "La Canourgue",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Cassagnas",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Chadenet",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "Bel-Air-Val-d'Ance",
    "dep": "Lozère"
  },
  {
    "code": "48230",
    "ville": "Chanac",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Chastanier",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Chastel-Nouvel",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Châteauneuf-de-Randon",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Chauchailles",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Chaudeyrac",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Chaulhac",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Cheylard-l'Évêque",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Bédouès-Cocurès",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Le Collet-de-Dèze",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Cubières",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Cubiérettes",
    "dep": "Lozère"
  },
  {
    "code": "48230",
    "ville": "Cultures",
    "dep": "Lozère"
  },
  {
    "code": "48230",
    "ville": "Esclanèdes",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "La Fage-Montivernoux",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "La Fage-Saint-Julien",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Florac Trois Rivières",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Fontans",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Fournels",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Fraissinet-de-Fourques",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Gabriac",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Gabrias",
    "dep": "Lozère"
  },
  {
    "code": "48150",
    "ville": "Gatuzières",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "Grandrieu",
    "dep": "Lozère"
  },
  {
    "code": "48260",
    "ville": "Grandvals",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Grèzes",
    "dep": "Lozère"
  },
  {
    "code": "48340",
    "ville": "Les Hermaux",
    "dep": "Lozère"
  },
  {
    "code": "48150",
    "ville": "Hures-la-Parade",
    "dep": "Lozère"
  },
  {
    "code": "48320",
    "ville": "Ispagnac",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Julianges",
    "dep": "Lozère"
  },
  {
    "code": "48120",
    "ville": "Lajo",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Langogne",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Lanuéjols",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Laubert",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Les Laubies",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "Laval-du-Tarn",
    "dep": "Lozère"
  },
  {
    "code": "48250",
    "ville": "Luc",
    "dep": "Lozère"
  },
  {
    "code": "48270",
    "ville": "Prinsuéjols-Malbouzon",
    "dep": "Lozère"
  },
  {
    "code": "48210",
    "ville": "La Malène",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Le Malzieu-Forain",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Le Malzieu-Ville",
    "dep": "Lozère"
  },
  {
    "code": "48260",
    "ville": "Marchastel",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Marvejols",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "Massegros Causses Gorges",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Mende",
    "dep": "Lozère"
  },
  {
    "code": "48150",
    "ville": "Meyrueis",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Moissac-Vallée-Française",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Molezon",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Bourgs sur Colagne",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Montbel",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Montrodat",
    "dep": "Lozère"
  },
  {
    "code": "48260",
    "ville": "Nasbinals",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Naussac-Fontanes",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Noalhac",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Palhers",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "La Panouse",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Paulhac-en-Margeride",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Pelouse",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Pierrefiche",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Le Pompidou",
    "dep": "Lozère"
  },
  {
    "code": "48220",
    "ville": "Pont de Montvert - Sud Mont Lozère",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Pourcharesses",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Prévenchères",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Prunières",
    "dep": "Lozère"
  },
  {
    "code": "48260",
    "ville": "Recoules-d'Aubrac",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Recoules-de-Fumas",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Lachamp-Ribennes",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Monts-de-Randon",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Rimeize",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Rocles",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Rousses",
    "dep": "Lozère"
  },
  {
    "code": "48150",
    "ville": "Le Rozier",
    "dep": "Lozère"
  },
  {
    "code": "48120",
    "ville": "Saint-Alban-sur-Limagnole",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Saint-André-Capcèze",
    "dep": "Lozère"
  },
  {
    "code": "48240",
    "ville": "Saint-André-de-Lancize",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Saint-Bauzile",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Saint-Bonnet-de-Chirac",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "Saint Bonnet-Laval",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Saint-Chély-d'Apcher",
    "dep": "Lozère"
  },
  {
    "code": "48210",
    "ville": "Mas-Saint-Chély",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Sainte-Croix-Vallée-Française",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Saint-Denis-en-Margeride",
    "dep": "Lozère"
  },
  {
    "code": "48210",
    "ville": "Gorges du Tarn Causses",
    "dep": "Lozère"
  },
  {
    "code": "48000",
    "ville": "Saint-Étienne-du-Valdonnez",
    "dep": "Lozère"
  },
  {
    "code": "48330",
    "ville": "Saint-Étienne-Vallée-Française",
    "dep": "Lozère"
  },
  {
    "code": "48120",
    "ville": "Sainte-Eulalie",
    "dep": "Lozère"
  },
  {
    "code": "48300",
    "ville": "Saint-Flour-de-Mercoire",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Saint-Frézal-d'Albuges",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Ventalon en Cévennes",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Saint-Gal",
    "dep": "Lozère"
  },
  {
    "code": "48370",
    "ville": "Saint-Germain-de-Calberte",
    "dep": "Lozère"
  },
  {
    "code": "48340",
    "ville": "Saint-Germain-du-Teil",
    "dep": "Lozère"
  },
  {
    "code": "48190",
    "ville": "Sainte-Hélène",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Saint-Hilaire-de-Lavit",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Saint-Jean-la-Fouillouse",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Saint-Juéry",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Saint-Julien-des-Points",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Saint-Laurent-de-Muret",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Cans et Cévennes",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Saint-Laurent-de-Veyrès",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Saint-Léger-de-Peyre",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Saint-Léger-du-Malzieu",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Saint-Martin-de-Boubaux",
    "dep": "Lozère"
  },
  {
    "code": "48110",
    "ville": "Saint-Martin-de-Lansuscle",
    "dep": "Lozère"
  },
  {
    "code": "48160",
    "ville": "Saint-Michel-de-Dèze",
    "dep": "Lozère"
  },
  {
    "code": "48600",
    "ville": "Saint-Paul-le-Froid",
    "dep": "Lozère"
  },
  {
    "code": "48340",
    "ville": "Saint-Pierre-de-Nogaret",
    "dep": "Lozère"
  },
  {
    "code": "48150",
    "ville": "Saint-Pierre-des-Tripiers",
    "dep": "Lozère"
  },
  {
    "code": "48200",
    "ville": "Saint-Pierre-le-Vieux",
    "dep": "Lozère"
  },
  {
    "code": "48240",
    "ville": "Saint-Privat-de-Vallongue",
    "dep": "Lozère"
  },
  {
    "code": "48140",
    "ville": "Saint-Privat-du-Fau",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "Saint-Saturnin",
    "dep": "Lozère"
  },
  {
    "code": "48170",
    "ville": "Saint-Sauveur-de-Ginestoux",
    "dep": "Lozère"
  },
  {
    "code": "48230",
    "ville": "Les Salelles",
    "dep": "Lozère"
  },
  {
    "code": "48100",
    "ville": "Les Salces",
    "dep": "Lozère"
  },
  {
    "code": "48700",
    "ville": "Serverette",
    "dep": "Lozère"
  },
  {
    "code": "48310",
    "ville": "Termes",
    "dep": "Lozère"
  },
  {
    "code": "48500",
    "ville": "La Tieule",
    "dep": "Lozère"
  },
  {
    "code": "48340",
    "ville": "Trélans",
    "dep": "Lozère"
  },
  {
    "code": "48400",
    "ville": "Vebron",
    "dep": "Lozère"
  },
  {
    "code": "48220",
    "ville": "Vialas",
    "dep": "Lozère"
  },
  {
    "code": "48800",
    "ville": "Villefort",
    "dep": "Lozère"
  },
  {
    "code": "49650",
    "ville": "Allonnes",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Tuffalun",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49000",
    "ville": "Angers",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49440",
    "ville": "Angrie",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Antoigné",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49420",
    "ville": "Armaillé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Artannes-sur-Thouet",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49540",
    "ville": "Aubigné-sur-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49240",
    "ville": "Avrillé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49430",
    "ville": "Baracé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49150",
    "ville": "Baugé-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49070",
    "ville": "Beaucouzé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49250",
    "ville": "Beaufort-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49750",
    "ville": "Beaulieu-sur-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49600",
    "ville": "Beaupréau-en-Mauges",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49370",
    "ville": "Bécon-les-Granits",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49122",
    "ville": "Bégrolles-en-Mauges",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Béhuard",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49320",
    "ville": "Blaison-Saint-Sulpice",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49160",
    "ville": "Blou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49080",
    "ville": "Bouchemaine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49520",
    "ville": "Bouillé-Ménard",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49520",
    "ville": "Bourg-l'Évêque",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49650",
    "ville": "Brain-sur-Allonnes",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49390",
    "ville": "La Breille-les-Pins",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49125",
    "ville": "Briollay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49320",
    "ville": "Brissac Loire Aubance",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Brossay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49440",
    "ville": "Candé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49460",
    "ville": "Cantenay-Épinard",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49420",
    "ville": "Carbay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49310",
    "ville": "Cernusson",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "Les Cerqueux",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Bellevigne-les-Châteaux",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49440",
    "ville": "Challain-la-Potherie",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49290",
    "ville": "Chalonnes-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Chambellay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Chenillé-Champteussé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49123",
    "ville": "Champtocé-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49270",
    "ville": "Orée d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49340",
    "ville": "Chanteloup-les-Bois",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "La Chapelle-Saint-Laud",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49330",
    "ville": "Les Hauts-d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49290",
    "ville": "Chaudefonds-sur-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49380",
    "ville": "Terranjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49500",
    "ville": "Chazé-sur-Argos",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49125",
    "ville": "Cheffes",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49120",
    "ville": "Chemillé-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49300",
    "ville": "Cholet",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Cizay-la-Madeleine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49560",
    "ville": "Cléré-sur-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Cornillé-les-Caves",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49690",
    "ville": "Coron",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Corzé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Le Coudray-Macouard",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Courchamps",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49390",
    "ville": "Courléon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49190",
    "ville": "Denée",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Dénezé-sous-Doué",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Distré",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Doué-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49430",
    "ville": "Durtal",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49000",
    "ville": "Écouflant",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49460",
    "ville": "Écuillé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Épieds",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49330",
    "ville": "Étriché",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49460",
    "ville": "Feneu",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49250",
    "ville": "Les Bois d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49590",
    "ville": "Fontevraud-l'Abbaye",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Grez-Neuville",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49123",
    "ville": "Ingrandes-le-Fresne-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "La Jaille-Yvon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Jarzé Villages",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49320",
    "ville": "Les Garennes sur Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49330",
    "ville": "Juvardeil",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49150",
    "ville": "La Lande-Chasles",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49430",
    "ville": "Huillé-Lézigné",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Le Lion-d'Angers",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49440",
    "ville": "Loiré",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49160",
    "ville": "Longué-Jumelles",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Louresse-Rochemenier",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49370",
    "ville": "Val d'Erdre-Auxence",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Marcé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "Maulévrier",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49122",
    "ville": "Le May-sur-Èvre",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Mazé-Milon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49280",
    "ville": "Mazières-en-Mauges",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49770",
    "ville": "Longuenée-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49250",
    "ville": "La Ménitré",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49330",
    "ville": "Miré",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49430",
    "ville": "Montigné-lès-Rairies",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49310",
    "ville": "Montilliers",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49460",
    "ville": "Montreuil-Juigné",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Montreuil-Bellay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Montreuil-sur-Loir",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Montreuil-sur-Maine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49110",
    "ville": "Montrevault-sur-Èvre",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49730",
    "ville": "Montsoreau",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49640",
    "ville": "Morannes sur Sarthe-Daumeray",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49390",
    "ville": "Mouliherne",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49610",
    "ville": "Mozé-sur-Louet",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49610",
    "ville": "Mûrs-Erigné",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49680",
    "ville": "Neuillé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49490",
    "ville": "Noyant-Villages",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49340",
    "ville": "Nuaillé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49730",
    "ville": "Parnay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49560",
    "ville": "Passavant-sur-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49490",
    "ville": "La Pellerine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "La Plaine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49124",
    "ville": "Le Plessis-Grammoire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49410",
    "ville": "Mauges-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49130",
    "ville": "Les Ponts-de-Cé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "La Possonnière",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49420",
    "ville": "Ombrée d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Le Puy-Notre-Dame",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49430",
    "ville": "Les Rairies",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49190",
    "ville": "Rochefort-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49740",
    "ville": "La Romagne",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49350",
    "ville": "Gennes-Val-de-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Rou-Marson",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Saint-Augustin-des-Bois",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49124",
    "ville": "Saint-Barthélemy-d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49280",
    "ville": "Saint-Christophe-du-Bois",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49370",
    "ville": "Saint-Clément-de-la-Place",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49350",
    "ville": "Saint-Clément-des-Levées",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49130",
    "ville": "Sainte-Gemmes-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Saint-Georges-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Saint-Germain-des-Prés",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49130",
    "ville": "Saint-Jean-de-la-Croix",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Saint-Just-sur-Dive",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49750",
    "ville": "Val-du-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49070",
    "ville": "Saint-Lambert-la-Potherie",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49070",
    "ville": "Saint-Léger-de-Linières",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49280",
    "ville": "Saint-Léger-sous-Cholet",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49450",
    "ville": "Sèvremoine",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Saint-Macaire-du-Bois",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Saint-Martin-du-Fouilloux",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49250",
    "ville": "Loire-Authion",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49610",
    "ville": "Saint-Melaine-sur-Aubance",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49310",
    "ville": "Saint-Paul-du-Bois",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49160",
    "ville": "Saint-Philbert-du-Peuple",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49480",
    "ville": "Verrières-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49800",
    "ville": "Sarrigné",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Saumur",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49170",
    "ville": "Savennières",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49330",
    "ville": "Sceaux-d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49500",
    "ville": "Segré-en-Anjou Bleu",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49280",
    "ville": "La Séguinière",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Seiches-sur-le-Loir",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Sermaise",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "Somloire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49610",
    "ville": "Soulaines-sur-Aubance",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49460",
    "ville": "Soulaire-et-Bourg",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Souzay-Champigny",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49280",
    "ville": "La Tessoualle",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Thorigné-d'Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49380",
    "ville": "Bellevigne-en-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49125",
    "ville": "Tiercé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "Toutlemonde",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49800",
    "ville": "Trélazé",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49340",
    "ville": "Trémentines",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49730",
    "ville": "Turquant",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49700",
    "ville": "Les Ulmes",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49730",
    "ville": "Varennes-sur-Loire",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Varrains",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49260",
    "ville": "Vaudelnay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49220",
    "ville": "Erdre-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49390",
    "ville": "Vernantes",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49390",
    "ville": "Vernoil-le-Fourrier",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Verrie",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49340",
    "ville": "Vezins",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49310",
    "ville": "Lys-Haut-Layon",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49400",
    "ville": "Villebernier",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49140",
    "ville": "Rives-du-Loir-en-Anjou",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49680",
    "ville": "Vivy",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "49360",
    "ville": "Yzernay",
    "dep": "Maine-et-Loire"
  },
  {
    "code": "50180",
    "ville": "Agneaux",
    "dep": "Manche"
  },
  {
    "code": "50230",
    "ville": "Agon-Coutainville",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Airel",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Amigny",
    "dep": "Manche"
  },
  {
    "code": "50400",
    "ville": "Anctoville-sur-Boscq",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Anneville-en-Saire",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Appeville",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Aucey-la-Plaine",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Audouville-la-Hubert",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Aumeville-Lestre",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Auvers",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Auxais",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Avranches",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Azeville",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Bacilly",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "La Baleine",
    "dep": "Manche"
  },
  {
    "code": "50720",
    "ville": "Barenton",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Barfleur",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Barneville-Carteret",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "La Barre-de-Semilly",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Baubigny",
    "dep": "Manche"
  },
  {
    "code": "50000",
    "ville": "Baudre",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Baupte",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Beauchamps",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Beaucoudray",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Beauficel",
    "dep": "Manche"
  },
  {
    "code": "50440",
    "ville": "La Hague",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Beauvoir",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Belval",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Benoîtville",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "Bérigny",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Beslon",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Besneville",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Beuvrigny",
    "dep": "Manche"
  },
  {
    "code": "50360",
    "ville": "Beuzeville-la-Bastille",
    "dep": "Manche"
  },
  {
    "code": "50160",
    "ville": "Biéville",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Biniville",
    "dep": "Manche"
  },
  {
    "code": "50560",
    "ville": "Blainville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Blosville",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "La Bloutière",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Boisyvon",
    "dep": "Manche"
  },
  {
    "code": "50360",
    "ville": "La Bonneville",
    "dep": "Manche"
  },
  {
    "code": "50610",
    "ville": "Jullouville",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Bourguenolles",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Boutteville",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Brainville",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Brécey",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Bréhal",
    "dep": "Manche"
  },
  {
    "code": "50110",
    "ville": "Bretteville",
    "dep": "Manche"
  },
  {
    "code": "50430",
    "ville": "Bretteville-sur-Ay",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Breuville",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Bréville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Bricquebec-en-Cotentin",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Bricquebosq",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Bricqueville-la-Blouette",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Bricqueville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Brillevast",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Brix",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Brouains",
    "dep": "Manche"
  },
  {
    "code": "50640",
    "ville": "Buais-Les-Monts",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Cambernon",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Cametours",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Camprond",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Canisy",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Canteloup",
    "dep": "Manche"
  },
  {
    "code": "50580",
    "ville": "Canville-la-Rocque",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Carantilly",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Carentan-les-Marais",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Carneville",
    "dep": "Manche"
  },
  {
    "code": "50740",
    "ville": "Carolles",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Catteville",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Cavigny",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Céaux",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Cérences",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Cerisy-la-Forêt",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Cerisy-la-Salle",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "La Chaise-Baudouin",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Le Grippon",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Champeaux",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Champrepus",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Chanteloup",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "La Chapelle-Cécelin",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "La Chapelle-Urée",
    "dep": "Manche"
  },
  {
    "code": "50870",
    "ville": "Chavoy",
    "dep": "Manche"
  },
  {
    "code": "50110",
    "ville": "Cherbourg-en-Cotentin",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Chérencé-le-Héron",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Clitourps",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "La Colombe",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Colomby",
    "dep": "Manche"
  },
  {
    "code": "50890",
    "ville": "Condé-sur-Vire",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Vicq-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Coudeville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Coulouvray-Boisbenâtre",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Courcy",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Courtils",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Coutances",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Couvains",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Couville",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Crasville",
    "dep": "Manche"
  },
  {
    "code": "50710",
    "ville": "Créances",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Les Cresnays",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Crollon",
    "dep": "Manche"
  },
  {
    "code": "50360",
    "ville": "Crosville-sur-Douve",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Cuves",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Dangy",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Le Dézert",
    "dep": "Manche"
  },
  {
    "code": "50110",
    "ville": "Digosville",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Domjean",
    "dep": "Manche"
  },
  {
    "code": "50350",
    "ville": "Donville-les-Bains",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Doville",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Dragey-Ronthon",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Ducey-Les Chéris",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Écausseville",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Émondeville",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Équilly",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Éroudeville",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "L'Étang-Bertrand",
    "dep": "Manche"
  },
  {
    "code": "50360",
    "ville": "Étienville",
    "dep": "Manche"
  },
  {
    "code": "50840",
    "ville": "Fermanville",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Feugères",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "La Feuillie",
    "dep": "Manche"
  },
  {
    "code": "50580",
    "ville": "Fierville-les-Mines",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Flamanville",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Fleury",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Flottemanville",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Folligny",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Fontenay-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Fourneaux",
    "dep": "Manche"
  },
  {
    "code": "50850",
    "ville": "Le Fresne-Poret",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Fresville",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Gathemo",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Gatteville-le-Phare",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Gavray-sur-Sienne",
    "dep": "Manche"
  },
  {
    "code": "50560",
    "ville": "Geffosses",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Genêts",
    "dep": "Manche"
  },
  {
    "code": "50850",
    "ville": "Ger",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "La Godefroy",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Golleville",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Gonfreville",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Gonneville-Le Theil",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Gorges",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Gouvets",
    "dep": "Manche"
  },
  {
    "code": "50560",
    "ville": "Gouville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Graignes-Mesnil-Angot",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Le Grand-Celland",
    "dep": "Manche"
  },
  {
    "code": "50400",
    "ville": "Granville",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Gratot",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Grimesnil",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Grosville",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Le Guislain",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Le Ham",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Hambye",
    "dep": "Manche"
  },
  {
    "code": "50730",
    "ville": "Hamelin",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Hardinvast",
    "dep": "Manche"
  },
  {
    "code": "50590",
    "ville": "Hauteville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Hauteville-la-Guichard",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Hautteville-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "La Haye-Bellefond",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "La Haye-d'Ectot",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "La Haye",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "La Haye-Pesnel",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Héauville",
    "dep": "Manche"
  },
  {
    "code": "50180",
    "ville": "Thèreval",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Helleville",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Hémevez",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Heugueville-sur-Sienne",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Hiesville",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Hocquigny",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Huberville",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Hudimesnil",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Huisnes-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50540",
    "ville": "Isigny-le-Buat",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Joganville",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Juilley",
    "dep": "Manche"
  },
  {
    "code": "50520",
    "ville": "Juvigny les Vallées",
    "dep": "Manche"
  },
  {
    "code": "50160",
    "ville": "Lamberville",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "La Lande-d'Airou",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Lapenty",
    "dep": "Manche"
  },
  {
    "code": "50430",
    "ville": "Laulne",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Lengronne",
    "dep": "Manche"
  },
  {
    "code": "50430",
    "ville": "Lessay",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Lestre",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Liesville-sur-Douve",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Lieusaint",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Lingeard",
    "dep": "Manche"
  },
  {
    "code": "50660",
    "ville": "Tourneville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Montsenelle",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Les Loges-Marchis",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Les Loges-sur-Brécey",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Lolif",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Longueville",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Le Loreur",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Le Lorey",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "La Lucerne-d'Outremer",
    "dep": "Manche"
  },
  {
    "code": "50870",
    "ville": "Le Luot",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "La Luzerne",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Magneville",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Marcey-les-Grèves",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Marchésieux",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Marcilly",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Margueray",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Marigny-Le-Lozon",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Martinvast",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Maupertuis",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Maupertus-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50880",
    "ville": "La Meauffe",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Méautis",
    "dep": "Manche"
  },
  {
    "code": "50580",
    "ville": "Le Mesnil",
    "dep": "Manche"
  },
  {
    "code": "50520",
    "ville": "Le Mesnil-Adelée",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Le Mesnil-Amey",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Le Mesnil-Aubert",
    "dep": "Manche"
  },
  {
    "code": "50110",
    "ville": "Le Mesnil-au-Val",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Le Mesnil-Eury",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Le Mesnil-Garnier",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Le Mesnil-Gilbert",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Le Mesnillard",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Le Mesnil-Ozenne",
    "dep": "Manche"
  },
  {
    "code": "50000",
    "ville": "Le Mesnil-Rouxelin",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Le Mesnil-Véneron",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Le Mesnil-Villeman",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "La Meurdraquière",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Millières",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Les Moitiers-d'Allonne",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Montabot",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Montaigu-la-Brisette",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Montaigu-les-Bois",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Montbray",
    "dep": "Manche"
  },
  {
    "code": "50490",
    "ville": "Montcuit",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Montebourg",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Montfarville",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Monthuchon",
    "dep": "Manche"
  },
  {
    "code": "50240",
    "ville": "Montjoie-Saint-Martin",
    "dep": "Manche"
  },
  {
    "code": "50590",
    "ville": "Montmartin-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Montpinchon",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "Montrabot",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Montreuil-sur-Lozon",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Le Mont-Saint-Michel",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Moon-sur-Elle",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Morigny",
    "dep": "Manche"
  },
  {
    "code": "50140",
    "ville": "Mortain-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Morville",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "La Mouche",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Moulines",
    "dep": "Manche"
  },
  {
    "code": "50860",
    "ville": "Moyon Villages",
    "dep": "Manche"
  },
  {
    "code": "50490",
    "ville": "Muneville-le-Bingard",
    "dep": "Manche"
  },
  {
    "code": "50290",
    "ville": "Muneville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Nay",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Négreville",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Néhou",
    "dep": "Manche"
  },
  {
    "code": "50140",
    "ville": "Le Neufbourg",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Neufmesnil",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Neuville-au-Plain",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Neuville-en-Beaumont",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Nicorps",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Notre-Dame-de-Cenilly",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Notre-Dame-de-Livoye",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Nouainville",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Octeville-l'Avenel",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Orglandes",
    "dep": "Manche"
  },
  {
    "code": "50660",
    "ville": "Orval sur Sienne",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Ouville",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Ozeville",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Grandparigny",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Percy-en-Normandie",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Périers",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "La Pernelle",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Perriers-en-Beauficel",
    "dep": "Manche"
  },
  {
    "code": "50160",
    "ville": "Le Perron",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Le Petit-Celland",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Picauville",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Pierreville",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Les Pieux",
    "dep": "Manche"
  },
  {
    "code": "50770",
    "ville": "Pirou",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Le Plessis-Lastelle",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Poilley",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Pontaubault",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Pont-Hébert",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Pontorson",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Ponts",
    "dep": "Manche"
  },
  {
    "code": "50580",
    "ville": "Port-Bail-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Précey",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Quettehou",
    "dep": "Manche"
  },
  {
    "code": "50660",
    "ville": "Quettreville-sur-Sienne",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Quibou",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Quinéville",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Raids",
    "dep": "Manche"
  },
  {
    "code": "50000",
    "ville": "Rampan",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Rauville-la-Bigot",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Rauville-la-Place",
    "dep": "Manche"
  },
  {
    "code": "50520",
    "ville": "Reffuveille",
    "dep": "Manche"
  },
  {
    "code": "50590",
    "ville": "Regnéville-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Reigneville-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50570",
    "ville": "Remilly Les Marais",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Réville",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Rocheville",
    "dep": "Manche"
  },
  {
    "code": "50140",
    "ville": "Romagny Fontenay",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Roncey",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Le Rozel",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Sacey",
    "dep": "Manche"
  },
  {
    "code": "50160",
    "ville": "Saint-Amand-Villages",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Saint-André-de-Bohon",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Saint-André-de-l'Épine",
    "dep": "Manche"
  },
  {
    "code": "50380",
    "ville": "Saint-Aubin-des-Préaux",
    "dep": "Manche"
  },
  {
    "code": "50240",
    "ville": "Saint-Aubin-de-Terregatte",
    "dep": "Manche"
  },
  {
    "code": "50140",
    "ville": "Saint-Barthélemy",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Saint-Brice",
    "dep": "Manche"
  },
  {
    "code": "50730",
    "ville": "Saint-Brice-de-Landelles",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Sainte-Cécile",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Saint-Christophe-du-Foc",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Saint-Clair-sur-l'Elle",
    "dep": "Manche"
  },
  {
    "code": "50140",
    "ville": "Saint-Clément-Rancoudray",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Sainte-Colombe",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Saint-Cyr",
    "dep": "Manche"
  },
  {
    "code": "50720",
    "ville": "Saint-Cyr-du-Bailleul",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Saint-Denis-le-Gast",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Saint-Denis-le-Vêtu",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Saint-Floxel",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Saint-Fromond",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Sainte-Geneviève",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Saint-Georges-de-la-Rivière",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Saint-Georges-de-Livoye",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Saint-Georges-d'Elle",
    "dep": "Manche"
  },
  {
    "code": "50720",
    "ville": "Saint-Georges-de-Rouelley",
    "dep": "Manche"
  },
  {
    "code": "50000",
    "ville": "Saint-Georges-Montcocq",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "Saint-Germain-d'Elle",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Saint-Germain-de-Tournebut",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Saint-Germain-de-Varreville",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Saint-Germain-le-Gaillard",
    "dep": "Manche"
  },
  {
    "code": "50430",
    "ville": "Saint-Germain-sur-Ay",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Saint-Germain-sur-Sèves",
    "dep": "Manche"
  },
  {
    "code": "50180",
    "ville": "Saint-Gilles",
    "dep": "Manche"
  },
  {
    "code": "50600",
    "ville": "Saint-Hilaire-du-Harcouët",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Saint-Jacques-de-Néhou",
    "dep": "Manche"
  },
  {
    "code": "50240",
    "ville": "Saint-James",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Saint-Jean-de-Daye",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Saint-Jean-de-la-Haize",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Saint-Jean-de-la-Rivière",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Saint-Jean-de-Savigny",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "Saint-Jean-d'Elle",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Saint-Jean-des-Champs",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Saint-Jean-du-Corail-des-Bois",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Saint-Jean-le-Thomas",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Saint-Joseph",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Saint-Laurent-de-Cuves",
    "dep": "Manche"
  },
  {
    "code": "50240",
    "ville": "Saint-Laurent-de-Terregatte",
    "dep": "Manche"
  },
  {
    "code": "50000",
    "ville": "Saint-Lô",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Saint-Louet-sur-Vire",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Saint-Loup",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Saint-Malo-de-la-Lande",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Saint-Marcouf",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Sainte-Marie-du-Mont",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Saint-Martin-d'Aubigny",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Saint-Martin-d'Audouville",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Saint-Martin-de-Bonfossé",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Saint-Martin-de-Cenilly",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Chaulieu",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Saint-Martin-de-Varreville",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Saint-Martin-le-Bouillant",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Saint-Martin-le-Gréard",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Saint-Maur-des-Bois",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Saint-Maurice-en-Cotentin",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Sainte-Mère-Église",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Saint-Michel-de-Montjoie",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Saint-Nicolas-de-Pierrepont",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Saint-Nicolas-des-Bois",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Saint-Ovin",
    "dep": "Manche"
  },
  {
    "code": "50380",
    "ville": "Saint-Pair-sur-Mer",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Saint-Patrice-de-Claids",
    "dep": "Manche"
  },
  {
    "code": "50870",
    "ville": "Le Parc",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Saint-Pierre-d'Arthéglise",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Saint-Pierre-de-Coutances",
    "dep": "Manche"
  },
  {
    "code": "50810",
    "ville": "Saint-Pierre-de-Semilly",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Saint-Pierre-Église",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Saint-Pierre-Langers",
    "dep": "Manche"
  },
  {
    "code": "50400",
    "ville": "Saint-Planchers",
    "dep": "Manche"
  },
  {
    "code": "50670",
    "ville": "Saint-Pois",
    "dep": "Manche"
  },
  {
    "code": "50220",
    "ville": "Saint-Quentin-sur-le-Homme",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Bourgvallées",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Saint-Sauveur-de-Pierrepont",
    "dep": "Manche"
  },
  {
    "code": "50510",
    "ville": "Saint-Sauveur-la-Pommeraye",
    "dep": "Manche"
  },
  {
    "code": "50490",
    "ville": "Saint-Sauveur-Villages",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Saint-Sauveur-le-Vicomte",
    "dep": "Manche"
  },
  {
    "code": "50190",
    "ville": "Saint-Sébastien-de-Raids",
    "dep": "Manche"
  },
  {
    "code": "50240",
    "ville": "Saint-Senier-de-Beuvron",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Saint-Senier-sous-Avranches",
    "dep": "Manche"
  },
  {
    "code": "50750",
    "ville": "Sainte-Suzanne-sur-Vire",
    "dep": "Manche"
  },
  {
    "code": "50550",
    "ville": "Saint-Vaast-la-Hougue",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Saint-Vigor-des-Monts",
    "dep": "Manche"
  },
  {
    "code": "50500",
    "ville": "Terre-et-Marais",
    "dep": "Manche"
  },
  {
    "code": "50530",
    "ville": "Sartilly-Baie-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Saussemesnil",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Saussey",
    "dep": "Manche"
  },
  {
    "code": "50210",
    "ville": "Savigny",
    "dep": "Manche"
  },
  {
    "code": "50640",
    "ville": "Savigny-le-Vieux",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Sébeville",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Sénoville",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Servon",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Sideville",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Siouville-Hague",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Sortosville-en-Beaumont",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Sortosville",
    "dep": "Manche"
  },
  {
    "code": "50260",
    "ville": "Sottevast",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Sotteville",
    "dep": "Manche"
  },
  {
    "code": "50150",
    "ville": "Sourdeval",
    "dep": "Manche"
  },
  {
    "code": "50870",
    "ville": "Subligny",
    "dep": "Manche"
  },
  {
    "code": "50270",
    "ville": "Surtainville",
    "dep": "Manche"
  },
  {
    "code": "50390",
    "ville": "Taillepied",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Tamerville",
    "dep": "Manche"
  },
  {
    "code": "50170",
    "ville": "Tanis",
    "dep": "Manche"
  },
  {
    "code": "50320",
    "ville": "Le Tanu",
    "dep": "Manche"
  },
  {
    "code": "50640",
    "ville": "Le Teilleul",
    "dep": "Manche"
  },
  {
    "code": "50420",
    "ville": "Tessy-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Teurthéville-Bocage",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Teurthéville-Hague",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Théville",
    "dep": "Manche"
  },
  {
    "code": "50870",
    "ville": "Tirepied-sur-Sée",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Tocqueville",
    "dep": "Manche"
  },
  {
    "code": "50470",
    "ville": "Tollevast",
    "dep": "Manche"
  },
  {
    "code": "50160",
    "ville": "Torigny-les-Villes",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "Tourville-sur-Sienne",
    "dep": "Manche"
  },
  {
    "code": "50340",
    "ville": "Tréauville",
    "dep": "Manche"
  },
  {
    "code": "50620",
    "ville": "Tribehou",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "La Trinité",
    "dep": "Manche"
  },
  {
    "code": "50480",
    "ville": "Turqueville",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Urville",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Vains",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Valcanville",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Valognes",
    "dep": "Manche"
  },
  {
    "code": "50300",
    "ville": "Le Val-Saint-Père",
    "dep": "Manche"
  },
  {
    "code": "50250",
    "ville": "Varenguebec",
    "dep": "Manche"
  },
  {
    "code": "50330",
    "ville": "Varouville",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Le Vast",
    "dep": "Manche"
  },
  {
    "code": "50310",
    "ville": "Vaudreville",
    "dep": "Manche"
  },
  {
    "code": "50200",
    "ville": "La Vendelée",
    "dep": "Manche"
  },
  {
    "code": "50450",
    "ville": "Ver",
    "dep": "Manche"
  },
  {
    "code": "50370",
    "ville": "Vernix",
    "dep": "Manche"
  },
  {
    "code": "50430",
    "ville": "Vesly",
    "dep": "Manche"
  },
  {
    "code": "50760",
    "ville": "Le Vicel",
    "dep": "Manche"
  },
  {
    "code": "50630",
    "ville": "Videcosville",
    "dep": "Manche"
  },
  {
    "code": "50410",
    "ville": "Villebaudon",
    "dep": "Manche"
  },
  {
    "code": "50800",
    "ville": "Villedieu-les-Poêles-Rouffigny",
    "dep": "Manche"
  },
  {
    "code": "50680",
    "ville": "Villiers-Fossard",
    "dep": "Manche"
  },
  {
    "code": "50690",
    "ville": "Virandeville",
    "dep": "Manche"
  },
  {
    "code": "50400",
    "ville": "Yquelon",
    "dep": "Manche"
  },
  {
    "code": "50700",
    "ville": "Yvetot-Bocage",
    "dep": "Manche"
  },
  {
    "code": "51240",
    "ville": "Ablancourt",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Saint-Martin-d'Ablois",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Aigny",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Allemanche-Launay-et-Soyer",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Allemant",
    "dep": "Marne"
  },
  {
    "code": "51250",
    "ville": "Alliancelles",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Ambonnay",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Ambrières",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Anglure",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Angluzelles-et-Courcelles",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Anthenay",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Aougny",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Arcis-le-Ponsart",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Argers",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Arrigny",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Arzillières-Neuville",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Athis",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Aubérive",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Aubilly",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Aulnay-l'Aître",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Aulnay-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Auménancourt",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Auve",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Avenay-Val-d'Or",
    "dep": "Marne"
  },
  {
    "code": "51190",
    "ville": "Avize",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Aÿ-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Baconnes",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Bagneux",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Le Baizil",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Bannay",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Bannes",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Barbonne-Fayel",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Baslieux-lès-Fismes",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Baslieux-sous-Châtillon",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Bassu",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Bassuet",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Baudement",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Baye",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Bazancourt",
    "dep": "Marne"
  },
  {
    "code": "51360",
    "ville": "Beaumont-sur-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Beaunay",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Beine-Nauroy",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Belval-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Belval-sous-Châtillon",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Bergères-lès-Vertus",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Bergères-sous-Montmirail",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Berméricourt",
    "dep": "Marne"
  },
  {
    "code": "51420",
    "ville": "Berru",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Berzieux",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Bétheniville",
    "dep": "Marne"
  },
  {
    "code": "51450",
    "ville": "Bétheny",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Bethon",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Bettancourt-la-Longue",
    "dep": "Marne"
  },
  {
    "code": "51430",
    "ville": "Bezannes",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Bignicourt-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Bignicourt-sur-Saulx",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Billy-le-Grand",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Binarville",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Blacy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Blaise-sous-Arzillières",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Blesme",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Bligny",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Boissy-le-Repos",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Bouchy-Saint-Genest",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Bouilly",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Bouleuse",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Boult-sur-Suippe",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Bourgogne-Fresne",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Boursault",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Bouvancourt",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Bouy",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Bouzy",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Brandonvillers",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Branscourt",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Braux-Sainte-Cohière",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Braux-Saint-Remy",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Bréban",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Le Breuil",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Breuil-sur-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Breuvery-sur-Coole",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Brimont",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Brouillet",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Broussy-le-Grand",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Broussy-le-Petit",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Broyes",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Brugny-Vaudancourt",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Brusson",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Le Buisson",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Bussy-le-Château",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Bussy-le-Repos",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Bussy-Lettrée",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "La Caure",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Caurel",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Cauroy-lès-Hermonville",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "La Celle-sous-Chantemerle",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Cernay-en-Dormois",
    "dep": "Marne"
  },
  {
    "code": "51420",
    "ville": "Cernay-lès-Reims",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Cernon",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Chaintrix-Bierges",
    "dep": "Marne"
  },
  {
    "code": "51000",
    "ville": "Châlons-en-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Châlons-sur-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Chaltrait",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Chambrecy",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Chamery",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Champaubert",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Champfleury",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Champguyon",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Champigneul-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51370",
    "ville": "Champigny",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Champillon",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Champlat-et-Boujacourt",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Champvoisy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Changy",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Chantemerle",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Chapelaine",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "La Chapelle-Felcourt",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "La Chapelle-Lasson",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "La Chapelle-sous-Orbais",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Charleville",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Charmont",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Les Charmontois",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Le Châtelier",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Châtelraould-Saint-Louvent",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Châtillon-sur-Broué",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Châtillon-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Châtillon-sur-Morin",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Châtrices",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Chaudefontaine",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Chaumuzy",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "La Chaussée-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Chavot-Courcourt",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Le Chemin",
    "dep": "Marne"
  },
  {
    "code": "51250",
    "ville": "Cheminon",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Chenay",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Cheniers",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "La Cheppe",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Cheppes-la-Prairie",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Chepy",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Cherville",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Chichey",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Chigny-les-Roses",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Chouilly",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Clamanges",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Clesles",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Cloyes-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Coizard-Joches",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Val-des-Marais",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Compertrix",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Condé-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Conflans-sur-Seine",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Congy",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Connantray-Vaurefroy",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Connantre",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Contault",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Coole",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Coolus",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Corbeil",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Corfélix",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Cormicy",
    "dep": "Marne"
  },
  {
    "code": "51350",
    "ville": "Cormontreuil",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Cormoyeux",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Corribert",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Corrobert",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Corroy",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Coulommes-la-Montagne",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Coupetz",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Coupéville",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Courcelles-Sapicourt",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Courcemain",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Courcy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Courdemanges",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Courgivaux",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Courjeonnet",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Courlandon",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Courmas",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Courtagnon",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Courtémont",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Courthiézy",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Courtisols",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Courville",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Couvrot",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Cramant",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "La Croix-en-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Crugny",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Cuchery",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Cuis",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Cuisles",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Cumières",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Cuperly",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Damery",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Dampierre-au-Temple",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Dampierre-le-Château",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Dampierre-sur-Moivre",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Dizy",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Dommartin-Dampierre",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Dommartin-Lettrée",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Dommartin-sous-Hans",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Dommartin-Varimont",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Dompremy",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Dontrien",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Dormans",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Val-de-Vière",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Drosnay",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Drouilly",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Éclaires",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Écollemont",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Écriennes",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Écueil",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Écury-le-Repos",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Écury-sur-Coole",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Élise-Daucourt",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Épense",
    "dep": "Marne"
  },
  {
    "code": "51200",
    "ville": "Épernay",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "L'Épine",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Époye",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Escardes",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Esclavolles-Lurey",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Les Essarts-lès-Sézanne",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Les Essarts-le-Vicomte",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Esternay",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Étoges",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Étréchy",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Étrepy",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Euvy",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Fagnières",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Faux-Fresnay",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Faux-Vésigneul",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Faverolles-et-Coëmy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Favresse",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Fèrebrianges",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Fère-Champenoise",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Festigny",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Fismes",
    "dep": "Marne"
  },
  {
    "code": "51190",
    "ville": "Flavigny",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Fleury-la-Rivière",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Florent-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Fontaine-Denis-Nuisy",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Fontaine-en-Dormois",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Fontaine-sur-Ay",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "La Forestière",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Francheville",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Le Fresne",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Frignicourt",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Fromentières",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Le Gault-Soigny",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Gaye",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Germaine",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Germigny",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Germinon",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Giffaumont-Champaubert",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Gigny-Bussy",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Givry-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Givry-lès-Loisy",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Gizaucourt",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Glannes",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Gourgançon",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Sainte-Marie-du-Lac-Nuisement",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Les Grandes-Loges",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Granges-sur-Aube",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Gratreuil",
    "dep": "Marne"
  },
  {
    "code": "51190",
    "ville": "Grauves",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Gueux",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Hans",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Haussignémont",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Haussimont",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Hauteville",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Hautvillers",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Heiltz-le-Hutier",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Heiltz-le-Maurupt",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Heiltz-l'Évêque",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Hermonville",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Herpont",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Heutrégiville",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Hourges",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Huiron",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Humbauville",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Igny-Comblizy",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Isles-sur-Suippe",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Isle-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Isse",
    "dep": "Marne"
  },
  {
    "code": "51190",
    "ville": "Les Istres-et-Bury",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Jâlons",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Janvilliers",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Janvry",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Joiselle",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Jonchery-sur-Suippe",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Jonchery-sur-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Jonquery",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Jouy-lès-Reims",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Jussecourt-Minecourt",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Juvigny",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Lachy",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Lagery",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Landricourt",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Larzicourt",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Laval-sur-Tourbe",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Lavannes",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Lenharrée",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Leuvrigny",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Lhéry",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Lignon",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Linthelles",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Linthes",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Lisse-en-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Livry-Louvercy",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Loisy-en-Brie",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Loisy-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Loivre",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Ludes",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Luxémont-et-Villotte",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Maffrécourt",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Magneux",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Mailly-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Mairy-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Maisons-en-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Malmy",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Mancy",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Marcilly-sur-Seine",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Mardeuil",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Mareuil-en-Brie",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Mareuil-le-Port",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Marfaux",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Margerie-Hancourt",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Margny",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Marigny",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Marolles",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Marsangis",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Marson",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Massiges",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Matignicourt-Goncourt",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Matougues",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Maurupt-le-Montois",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Mécringes",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Le Meix-Saint-Epoing",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Le Meix-Tiercelin",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Merfy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Merlaut",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Méry-Prémecy",
    "dep": "Marne"
  },
  {
    "code": "51370",
    "ville": "Les Mesneux",
    "dep": "Marne"
  },
  {
    "code": "51190",
    "ville": "Le Mesnil-sur-Oger",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Minaucourt-le-Mesnil-lès-Hurlus",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Mœurs-Verdey",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Moiremont",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Moivre",
    "dep": "Marne"
  },
  {
    "code": "51470",
    "ville": "Moncetz-Longevas",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Moncetz-l'Abbaye",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Mondement-Montgivroux",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Montbré",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Montgenost",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Montépreux",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Monthelon",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Montigny-sur-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Montmirail",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Montmort-Lucy",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Mont-sur-Courville",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Morangis",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Morsains",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Moslins",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Mourmelon-le-Grand",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Mourmelon-le-Petit",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Moussy",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Muizon",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Mutigny",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Nanteuil-la-Forêt",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Nesle-la-Reposte",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Nesle-le-Repons",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "La Neuville-aux-Bois",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "La Neuville-aux-Larris",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "La Neuville-au-Pont",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Neuvy",
    "dep": "Marne"
  },
  {
    "code": "51420",
    "ville": "Nogent-l'Abbesse",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Noirlieu",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Norrois",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "La Noue",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Nuisement-sur-Coole",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Œuilly",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Ognes",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Oiry",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Olizy",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Omey",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Orbais-l'Abbaye",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Orconte",
    "dep": "Marne"
  },
  {
    "code": "51370",
    "ville": "Ormes",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Outines",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Outrepont",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Oyes",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Pargny-lès-Reims",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Pargny-sur-Saulx",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Passavant-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Passy-Grigny",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Péas",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Les Petites-Loges",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Pévy",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Pierre-Morains",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Pierry",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Pleurs",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Plichancourt",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Plivot",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Pocancy",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Pogny",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Poilly",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Poix",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Pomacle",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Pontfaverger-Moronvilliers",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Ponthion",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Possesse",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Potangis",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Pouillon",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Pourcy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Pringy",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Prosnes",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Prouilly",
    "dep": "Marne"
  },
  {
    "code": "51360",
    "ville": "Prunay",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Puisieulx",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Queudes",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Rapsécourt",
    "dep": "Marne"
  },
  {
    "code": "51520",
    "ville": "Recy",
    "dep": "Marne"
  },
  {
    "code": "51100",
    "ville": "Reims",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Reims-la-Brûlée",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Remicourt",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Cœur-de-la-Vallée",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Reuves",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Réveillon",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Rieux",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Rilly-la-Montagne",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Les Rivières-Henruel",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Romain",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Romery",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Romigny",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Rosnay",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Rouffy",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Rouvroy-Ripont",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Sacy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Saint-Amand-sur-Fion",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Saint-Bon",
    "dep": "Marne"
  },
  {
    "code": "51370",
    "ville": "Saint-Brice-Courcelles",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Saint-Chéron",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Saint-Étienne-au-Temple",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Saint-Étienne-sur-Suippe",
    "dep": "Marne"
  },
  {
    "code": "52100",
    "ville": "Saint-Eulien",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Saint-Euphraise-et-Clairizet",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Sainte-Gemme",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Saint-Germain-la-Ville",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Saint-Gibrien",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Saint-Gilles",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Saint-Hilaire-au-Temple",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Saint-Hilaire-le-Grand",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Saint-Hilaire-le-Petit",
    "dep": "Marne"
  },
  {
    "code": "51160",
    "ville": "Saint-Imoges",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Saint-Jean-devant-Possesse",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Saint-Jean-sur-Moivre",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Saint-Jean-sur-Tourbe",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Saint-Just-Sauvage",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Saint-Léonard",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Saint-Loup",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Saint-Lumier-en-Champagne",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Saint-Lumier-la-Populeuse",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Saint-Mard-sur-Auve",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Saint-Mard-lès-Rouffy",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Saint-Mard-sur-le-Mont",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Sainte-Marie-à-Py",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Saint-Martin-aux-Champs",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Saint-Martin-l'Heureux",
    "dep": "Marne"
  },
  {
    "code": "51520",
    "ville": "Saint-Martin-sur-le-Pré",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Saint-Masmes",
    "dep": "Marne"
  },
  {
    "code": "51470",
    "ville": "Saint-Memmie",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Sainte-Menehould",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Saint-Ouen-Domprot",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Saint-Pierre",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Saint-Quentin-les-Marais",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Saint-Quentin-le-Verger",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Saint-Quentin-sur-Coole",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Saint-Remy-sous-Broyes",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Saint-Remy-sur-Bussy",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Saint-Saturnin",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Saint-Souplet-sur-Py",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Saint-Thierry",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Saint-Thomas-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Saint-Utin",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Saint-Vrain",
    "dep": "Marne"
  },
  {
    "code": "52100",
    "ville": "Sapignicourt",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Sarcy",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Saron-sur-Aube",
    "dep": "Marne"
  },
  {
    "code": "51520",
    "ville": "Sarry",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Saudoy",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Savigny-sur-Ardres",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Scrupt",
    "dep": "Marne"
  },
  {
    "code": "51490",
    "ville": "Selles",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Sept-Saulx",
    "dep": "Marne"
  },
  {
    "code": "51250",
    "ville": "Sermaize-les-Bains",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Sermiers",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Servon-Melzicourt",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Serzy-et-Prin",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Sézanne",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Sillery",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Sivry-Ante",
    "dep": "Marne"
  },
  {
    "code": "51520",
    "ville": "Sogny-aux-Moulins",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Sogny-en-l'Angle",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Soizy-aux-Bois",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Somme-Bionne",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Sommepy-Tahure",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Sommesous",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Somme-Suippe",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Somme-Tourbe",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Somme-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Somme-Yèvre",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Sompuis",
    "dep": "Marne"
  },
  {
    "code": "51290",
    "ville": "Somsois",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Songy",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Souain-Perthes-lès-Hurlus",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Soudé",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Soudron",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Soulanges",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Soulières",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Suippes",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Suizy-le-Franc",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Taissy",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Talus-Saint-Prix",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Val de Livre",
    "dep": "Marne"
  },
  {
    "code": "51230",
    "ville": "Thaas",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Thibie",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Thiéblemont-Farémont",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Thil",
    "dep": "Marne"
  },
  {
    "code": "51370",
    "ville": "Thillois",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Le Thoult-Trosnay",
    "dep": "Marne"
  },
  {
    "code": "51360",
    "ville": "Val-de-Vesle",
    "dep": "Marne"
  },
  {
    "code": "51460",
    "ville": "Tilloy-et-Bellay",
    "dep": "Marne"
  },
  {
    "code": "51430",
    "ville": "Tinqueux",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Togny-aux-Bœufs",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Tours-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Tramery",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Trécon",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Tréfols",
    "dep": "Marne"
  },
  {
    "code": "51380",
    "ville": "Trépail",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Treslon",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Trigny",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Trois-Fontaines-l'Abbaye",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Trois-Puits",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Troissy",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Unchair",
    "dep": "Marne"
  },
  {
    "code": "51400",
    "ville": "Vadenay",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Valmy",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Vanault-le-Châtel",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Vanault-les-Dames",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Vandeuil",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Vandières",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Vassimont-et-Chapelaine",
    "dep": "Marne"
  },
  {
    "code": "51320",
    "ville": "Vatry",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Vauchamps",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Vauciennes",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Vauclerc",
    "dep": "Marne"
  },
  {
    "code": "51380",
    "ville": "Vaudemange",
    "dep": "Marne"
  },
  {
    "code": "51600",
    "ville": "Vaudesincourt",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Vavray-le-Grand",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Vavray-le-Petit",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Vélye",
    "dep": "Marne"
  },
  {
    "code": "51140",
    "ville": "Ventelay",
    "dep": "Marne"
  },
  {
    "code": "51480",
    "ville": "Venteuil",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Verdon",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Vernancourt",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Verneuil",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Verrières",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Vert-Toulon",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Blancs-Coteaux",
    "dep": "Marne"
  },
  {
    "code": "51360",
    "ville": "Verzenay",
    "dep": "Marne"
  },
  {
    "code": "51380",
    "ville": "Verzy",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Vésigneul-sur-Marne",
    "dep": "Marne"
  },
  {
    "code": "51520",
    "ville": "La Veuve",
    "dep": "Marne"
  },
  {
    "code": "51210",
    "ville": "Le Vézier",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Le Vieil-Dampierre",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Vienne-la-Ville",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Vienne-le-Château",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Ville-Dommange",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Ville-en-Selve",
    "dep": "Marne"
  },
  {
    "code": "51170",
    "ville": "Ville-en-Tardenois",
    "dep": "Marne"
  },
  {
    "code": "51310",
    "ville": "Villeneuve-la-Lionne",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "La Villeneuve-lès-Charleville",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Villeneuve-Renneville-Chevigny",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Villeneuve-Saint-Vistre-et-Villevotte",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Villers-Allerand",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Villers-aux-Bois",
    "dep": "Marne"
  },
  {
    "code": "51500",
    "ville": "Villers-aux-Nœuds",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Villers-en-Argonne",
    "dep": "Marne"
  },
  {
    "code": "51220",
    "ville": "Villers-Franqueux",
    "dep": "Marne"
  },
  {
    "code": "51510",
    "ville": "Villers-le-Château",
    "dep": "Marne"
  },
  {
    "code": "51250",
    "ville": "Villers-le-Sec",
    "dep": "Marne"
  },
  {
    "code": "51380",
    "ville": "Villers-Marmery",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Villeseneux",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "La Ville-sous-Orbais",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Ville-sur-Tourbe",
    "dep": "Marne"
  },
  {
    "code": "51270",
    "ville": "Villevenard",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Villiers-aux-Corneilles",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Vinay",
    "dep": "Marne"
  },
  {
    "code": "51700",
    "ville": "Vincelles",
    "dep": "Marne"
  },
  {
    "code": "51120",
    "ville": "Vindey",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Virginy",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Vitry-en-Perthois",
    "dep": "Marne"
  },
  {
    "code": "51240",
    "ville": "Vitry-la-Ville",
    "dep": "Marne"
  },
  {
    "code": "51300",
    "ville": "Vitry-le-François",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Voilemont",
    "dep": "Marne"
  },
  {
    "code": "51260",
    "ville": "Vouarces",
    "dep": "Marne"
  },
  {
    "code": "51340",
    "ville": "Vouillers",
    "dep": "Marne"
  },
  {
    "code": "51130",
    "ville": "Vouzy",
    "dep": "Marne"
  },
  {
    "code": "51150",
    "ville": "Vraux",
    "dep": "Marne"
  },
  {
    "code": "51390",
    "ville": "Vrigny",
    "dep": "Marne"
  },
  {
    "code": "51330",
    "ville": "Vroil",
    "dep": "Marne"
  },
  {
    "code": "51800",
    "ville": "Wargemoulin-Hurlus",
    "dep": "Marne"
  },
  {
    "code": "51110",
    "ville": "Warmeriville",
    "dep": "Marne"
  },
  {
    "code": "51420",
    "ville": "Witry-lès-Reims",
    "dep": "Marne"
  },
  {
    "code": "51530",
    "ville": "Magenta",
    "dep": "Marne"
  },
  {
    "code": "52340",
    "ville": "Ageville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Aigremont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Aillianville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Aingoulaincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Aizanville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Allichamps",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Ambonville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Andelot-Blancheville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Andilly-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Annéville-la-Prairie",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Annonville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Anrosey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Aprey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Arbigny-sous-Varennes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Arbot",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Arc-en-Barrois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Arnancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Attancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Aubepierre-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Auberive",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Audeloncourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Aujeurres",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Aulnoy-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Autigny-le-Grand",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Autigny-le-Petit",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Autreville-sur-la-Renne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Avrecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Bailly-aux-Forges",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Baissey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Bannes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Bassoncourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Baudrecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Bay-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52260",
    "ville": "Beauchemin",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Belmont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52270",
    "ville": "Roches-Bettaincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Bettancourt-la-Ferrée",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Beurville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52340",
    "ville": "Biesles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Bize",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Blaisy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Blécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Blessonville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Blumeray",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Bologne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Bonnecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Bourbonne-les-Bains",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Bourdons-sur-Rognon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Bourg",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Bourg-Sainte-Marie",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Bourmont-entre-Meuse-et-Mouzon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Bouzancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Brachay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Brainville-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Braux-le-Châtel",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Brennes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Brethenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Breuvannes-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Briaucourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Bricon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Brousseval",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Bugnières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Champsevraine",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Busson",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Buxières-lès-Clefmont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Buxières-lès-Villiers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Ceffonds",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Celles-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Celsoy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Cerisières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Chalancey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Chalindrey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Vals-des-Tilles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Chalvraines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Chambroncourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52410",
    "ville": "Chamouilley",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Champigneulles-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Champigny-lès-Langres",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Champigny-sous-Varennes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Chancenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Changey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52260",
    "ville": "Chanoy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Chantraines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Charmes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Charmes-en-l'Angle",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Charmes-la-Grande",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Chassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Châteauvillain",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Chatenay-Mâcheron",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Chatenay-Vaudin",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Chatonrupt-Sommermont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Chaudenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Chauffourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Chaumont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Chaumont-la-Ville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52170",
    "ville": "Chevillon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Chézeaux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Chamarandes-Choignes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Choilley-Dardenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Choiseul",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Cirey-lès-Mareilles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Cirey-sur-Blaise",
    "dep": "Haute-Marne"
  },
  {
    "code": "52370",
    "ville": "Cirfontaines-en-Azois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Cirfontaines-en-Ornois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Clefmont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Clinchamp",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Cohons",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Coiffy-le-Bas",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Coiffy-le-Haut",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Colmier-le-Bas",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Colmier-le-Haut",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Colombey les Deux Églises",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Condes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Consigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Coublanc",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Coupray",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Courcelles-en-Montagne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Courcelles-sur-Blaise",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Cour-l'Évêque",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Culmont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Curel",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Curmont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Cusey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Cuves",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Daillancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Daillecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Dammartin-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Dampierre",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Damrémont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Dancevoir",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Darmannes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Dinteville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Domblain",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Dommarien",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Dommartin-le-Franc",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Dommartin-le-Saint-Père",
    "dep": "Haute-Marne"
  },
  {
    "code": "52270",
    "ville": "Domremy-Landéville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Doncourt-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Donjeux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52270",
    "ville": "Doulaincourt-Saucourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Doulevant-le-Château",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Doulevant-le-Petit",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Échenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52290",
    "ville": "Éclaron-Braucourt-Sainte-Livière",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Ecot-la-Combe",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Effincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Enfonvelle",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Épizon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Le Val-d'Esnoms",
    "dep": "Haute-Marne"
  },
  {
    "code": "52340",
    "ville": "Esnouveaux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Euffigneix",
    "dep": "Haute-Marne"
  },
  {
    "code": "52410",
    "ville": "Eurville-Bienville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Farincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52260",
    "ville": "Faverolles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Fayl-Billot",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Fays",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Ferrière-et-Lafolie",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Flagey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Flammerécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52170",
    "ville": "Fontaines-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Forcey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Foulain",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Frampas",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Frécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Fresnes-sur-Apance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Froncles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Fronville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Genevrières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "La Genevroye",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Germaines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Germainvilliers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Germay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Germisay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Giey-sur-Aujon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Gillancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Gillaumé",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Gilley",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Graffigny-Chemin",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Grandchamp",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Grenant",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Gudmont-Villiers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Guindrecourt-aux-Ormes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Guindrecourt-sur-Blaise",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Guyonvelle",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Hâcourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Hallignicourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Harréville-les-Chanteurs",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Heuilley-le-Grand",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Haute-Amance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Huilliécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52290",
    "ville": "Humbécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Humberville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Humes-Jorquenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Illoud",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Is-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Isômes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Joinville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Jonchery",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Juzennecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Lachapelle-en-Blaisy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Lafauche",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Laferté-sur-Amance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Laferté-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Lamancine",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Laneuvelle",
    "dep": "Haute-Marne"
  },
  {
    "code": "52170",
    "ville": "Bayard-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Laneuville-à-Rémy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Laneuville-au-Pont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Langres",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Lanques-sur-Rognon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Lanty-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Larivière-Arnoncourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Latrecey-Ormoy-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Lavernoy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Laville-aux-Bois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Lavilleneuve",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Lavilleneuve-au-Roi",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Lecey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Leffonds",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Leschères-sur-le-Blaiseron",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Leuchey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Leurville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Levécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Lezéville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Liffol-le-Petit",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Les Loges",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Longchamp",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Longeau-Percey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Louvemont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Louvières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Luzy-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Maâtz",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Magneux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Maisoncelles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Maizières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Maizières-sur-Amance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Malaincourt-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Mandres-la-Côte",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Manois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52260",
    "ville": "Marac",
    "dep": "Haute-Marne"
  },
  {
    "code": "52370",
    "ville": "Maranville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Marbéville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Marcilly-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Mardor",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Mareilles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Marnay-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Mathons",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Melay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Mennouveaux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Merrey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Mertrud",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Meures",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Millières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Mirbel",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Moëslains",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Montcharvot",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Montheries",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "La Porte du Der",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Val-de-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Montot-sur-Rognon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Montreuil-sur-Blaise",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Montreuil-sur-Thonnance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Morancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Morionvilliers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Mouilleron",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Mussey-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52170",
    "ville": "Narcy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Neuilly-l'Évêque",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Neuilly-sur-Suize",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Neuvelle-lès-Voisey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Ninville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Nogent",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Noidant-Chatenoy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Noidant-le-Rocheux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Nomécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Noncourt-sur-le-Rongeant",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Noyers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Nully",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Occey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Orbigny-au-Mont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Orbigny-au-Val",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Orcevaux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Orges",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Ormancey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Ormoy-lès-Sexfontaines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Orquevaux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Osne-le-Val",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Oudincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Outremécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Ozières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Le Pailly",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Palaiseul",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Pansey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Parnoy-en-Bassigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Paroy-sur-Saulx",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Peigney",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Perrancey-les-Vieux-Moulins",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Perrogney-les-Fontaines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Perrusse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Perthes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Pierremont-sur-Amance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Pisseloup",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Planrupt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Plesnoy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Poinsenot",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Poinson-lès-Fayl",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Poinson-lès-Grancey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Poinson-lès-Nogent",
    "dep": "Haute-Marne"
  },
  {
    "code": "52360",
    "ville": "Poiseul",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Poissons",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Pont-la-Ville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Le Châtelet-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Poulangy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Praslay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Le Montsaugeonnais",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Pressigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Prez-sous-Lafauche",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Rives Dervoises",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Rachecourt-Suzémont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52170",
    "ville": "Rachecourt-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Rançonnières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Rangecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52370",
    "ville": "Rennepont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Reynel",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Riaucourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Richebourg",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Rimaucourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Rivières-le-Bois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Rivière-les-Fosses",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Rizaucourt-Buchey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Rochefort-sur-la-Côte",
    "dep": "Haute-Marne"
  },
  {
    "code": "52410",
    "ville": "Roches-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Rochetaillée",
    "dep": "Haute-Marne"
  },
  {
    "code": "52260",
    "ville": "Rolampont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Romain-sur-Meuse",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Rouécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Rouelles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Rougeux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Rouvres-sur-Aube",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Rouvroy-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Rupt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Sailly",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Saint-Blin",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Saint-Broingt-le-Bois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Saint-Broingt-les-Fosses",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Saint-Ciergues",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Saint-Dizier",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Saints-Geosmes",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Saint-Loup-sur-Aujon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Saint-Martin-lès-Langres",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Saint-Maurice",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Saint-Thiébault",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Saint-Urbain-Maconcourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Saint-Vallier-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Sarcey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Sarrey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Saudron",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Saulles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52140",
    "ville": "Saulxures",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Savigny",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Semilly",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Semoutiers-Montsaon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Serqueux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Sexfontaines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Signéville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Silvarouvres",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Sommancourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Sommerécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Sommevoire",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Soncourt-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Soulaucourt-sur-Mouzon",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Soyers",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Suzannecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Ternat",
    "dep": "Haute-Marne"
  },
  {
    "code": "52220",
    "ville": "Thilleux",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Thivet",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Thol-lès-Millières",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Thonnance-lès-Joinville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52230",
    "ville": "Thonnance-les-Moulins",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Torcenay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Tornay",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Treix",
    "dep": "Haute-Marne"
  },
  {
    "code": "52110",
    "ville": "Trémilly",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Troisfontaines-la-Ville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Vaillant",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Valcourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Valleret",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Valleroy",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Varennes-sur-Amance",
    "dep": "Haute-Marne"
  },
  {
    "code": "52150",
    "ville": "Vaudrecourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52330",
    "ville": "Vaudrémont",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Vauxbons",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Vaux-sur-Blaise",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Vaux-sur-Saint-Urbain",
    "dep": "Haute-Marne"
  },
  {
    "code": "52300",
    "ville": "Vecqueville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Velles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Verbiesles",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Verseilles-le-Bas",
    "dep": "Haute-Marne"
  },
  {
    "code": "52250",
    "ville": "Verseilles-le-Haut",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Vesaignes-sous-Lafauche",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Vesaignes-sur-Marne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Vesvres-sous-Chalancey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Vicq",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Viéville",
    "dep": "Haute-Marne"
  },
  {
    "code": "52700",
    "ville": "Vignes-la-Côte",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Vignory",
    "dep": "Haute-Marne"
  },
  {
    "code": "52120",
    "ville": "Villars-en-Azois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Villars-Santenoge",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Ville-en-Blaisois",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Villegusien-le-Lac",
    "dep": "Haute-Marne"
  },
  {
    "code": "52100",
    "ville": "Villiers-en-Lieu",
    "dep": "Haute-Marne"
  },
  {
    "code": "52000",
    "ville": "Villiers-le-Sec",
    "dep": "Haute-Marne"
  },
  {
    "code": "52190",
    "ville": "Villiers-lès-Aprey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52210",
    "ville": "Villiers-sur-Suize",
    "dep": "Haute-Marne"
  },
  {
    "code": "52600",
    "ville": "Violot",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Vitry-en-Montagne",
    "dep": "Haute-Marne"
  },
  {
    "code": "52800",
    "ville": "Vitry-lès-Nogent",
    "dep": "Haute-Marne"
  },
  {
    "code": "52160",
    "ville": "Vivey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Voillecomte",
    "dep": "Haute-Marne"
  },
  {
    "code": "52400",
    "ville": "Voisey",
    "dep": "Haute-Marne"
  },
  {
    "code": "52200",
    "ville": "Voisines",
    "dep": "Haute-Marne"
  },
  {
    "code": "52500",
    "ville": "Voncourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52320",
    "ville": "Vouécourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52310",
    "ville": "Vraincourt",
    "dep": "Haute-Marne"
  },
  {
    "code": "52240",
    "ville": "Vroncourt-la-Côte",
    "dep": "Haute-Marne"
  },
  {
    "code": "52130",
    "ville": "Wassy",
    "dep": "Haute-Marne"
  },
  {
    "code": "53940",
    "ville": "Ahuillé",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Alexain",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Ambrières-les-Vallées",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Andouillé",
    "dep": "Mayenne"
  },
  {
    "code": "53210",
    "ville": "Argentré",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "Aron",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Arquenay",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Assé-le-Bérenger",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "Astillé",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Athée",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Averton",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "La Baconnière",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Bais",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Val-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53350",
    "ville": "Ballots",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Bannes",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "La Bazoge-Montpinçon",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "La Bazouge-de-Chemeré",
    "dep": "Mayenne"
  },
  {
    "code": "53470",
    "ville": "La Bazouge-des-Alleux",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Bazougers",
    "dep": "Mayenne"
  },
  {
    "code": "53320",
    "ville": "Beaulieu-sur-Oudon",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Beaumont-Pied-de-Bœuf",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "Belgeard",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Bierné-les-Villages",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Le Bignon-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "La Bigottière",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "La Boissière",
    "dep": "Mayenne"
  },
  {
    "code": "53960",
    "ville": "Bonchamp-lès-Laval",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "Bouchamps-lès-Craon",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Bouère",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Bouessay",
    "dep": "Mayenne"
  },
  {
    "code": "53370",
    "ville": "Boulay-les-Ifs",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Le Bourgneuf-la-Forêt",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Bourgon",
    "dep": "Mayenne"
  },
  {
    "code": "53350",
    "ville": "Brains-sur-les-Marches",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Brecé",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "Brée",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "La Brûlatte",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Le Buret",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Carelles",
    "dep": "Mayenne"
  },
  {
    "code": "53420",
    "ville": "Chailland",
    "dep": "Mayenne"
  },
  {
    "code": "53470",
    "ville": "Châlons-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53640",
    "ville": "Champéon",
    "dep": "Mayenne"
  },
  {
    "code": "53370",
    "ville": "Champfrémont",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Champgenéteux",
    "dep": "Mayenne"
  },
  {
    "code": "53810",
    "ville": "Changé",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Chantrigné",
    "dep": "Mayenne"
  },
  {
    "code": "53950",
    "ville": "La Chapelle-Anthenaise",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "La Chapelle-au-Riboul",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "La Chapelle-Craonnaise",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "La Chapelle-Rainsouin",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Charchigné",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Château-Gontier-sur-Mayenne",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Châtelain",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Châtillon-sur-Colmont",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Chemazé",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Chémeré-le-Roi",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Chérancé",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Chevaigné-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Colombiers-du-Plessis",
    "dep": "Mayenne"
  },
  {
    "code": "53470",
    "ville": "Commer",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "Congrier",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Contest",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "Cosmes",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Cossé-en-Champagne",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "Cossé-le-Vivien",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Coudray",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Couesmes-Vaucé",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Couptrain",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "Courbeveille",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Courcité",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Craon",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Crennes-sur-Fraubée",
    "dep": "Mayenne"
  },
  {
    "code": "53380",
    "ville": "La Croixille",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "La Cropte",
    "dep": "Mayenne"
  },
  {
    "code": "53540",
    "ville": "Cuillé",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Daon",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Denazé",
    "dep": "Mayenne"
  },
  {
    "code": "53190",
    "ville": "Désertines",
    "dep": "Mayenne"
  },
  {
    "code": "53190",
    "ville": "La Dorée",
    "dep": "Mayenne"
  },
  {
    "code": "53260",
    "ville": "Entrammes",
    "dep": "Mayenne"
  },
  {
    "code": "53500",
    "ville": "Ernée",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Évron",
    "dep": "Mayenne"
  },
  {
    "code": "53350",
    "ville": "Fontaine-Couverte",
    "dep": "Mayenne"
  },
  {
    "code": "53260",
    "ville": "Forcé",
    "dep": "Mayenne"
  },
  {
    "code": "53190",
    "ville": "Fougerolles-du-Plessis",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Fromentières",
    "dep": "Mayenne"
  },
  {
    "code": "53540",
    "ville": "Gastines",
    "dep": "Mayenne"
  },
  {
    "code": "53940",
    "ville": "Le Genest-Saint-Isle",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Gennes-Longuefuye",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "Gesnes",
    "dep": "Mayenne"
  },
  {
    "code": "53370",
    "ville": "Gesvres",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Gorron",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "La Gravelle",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "Grazay",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Grez-en-Bouère",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "La Haie-Traversaine",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Le Ham",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Hambers",
    "dep": "Mayenne"
  },
  {
    "code": "53640",
    "ville": "Hardanges",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Hercé",
    "dep": "Mayenne"
  },
  {
    "code": "53640",
    "ville": "Le Horps",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "Houssay",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Le Housseau-Brétignolles",
    "dep": "Mayenne"
  },
  {
    "code": "53970",
    "ville": "L'Huisserie",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Izé",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Javron-les-Chapelles",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Jublains",
    "dep": "Mayenne"
  },
  {
    "code": "53380",
    "ville": "Juvigné",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Prée-d'Anjou",
    "dep": "Mayenne"
  },
  {
    "code": "53190",
    "ville": "Landivy",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Larchamp",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Lassay-les-Châteaux",
    "dep": "Mayenne"
  },
  {
    "code": "53540",
    "ville": "Laubrières",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Launay-Villiers",
    "dep": "Mayenne"
  },
  {
    "code": "53000",
    "ville": "Laval",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Lesbois",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Levaré",
    "dep": "Mayenne"
  },
  {
    "code": "53140",
    "ville": "Lignières-Orgères",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "Livet",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Livré-la-Touche",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "La Roche-Neuville",
    "dep": "Mayenne"
  },
  {
    "code": "53320",
    "ville": "Loiron-Ruillé",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Loupfougères",
    "dep": "Mayenne"
  },
  {
    "code": "53950",
    "ville": "Louverné",
    "dep": "Mayenne"
  },
  {
    "code": "53210",
    "ville": "Louvigné",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Madré",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Maisoncelles-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53440",
    "ville": "Marcillé-la-Ville",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Marigné-Peuton",
    "dep": "Mayenne"
  },
  {
    "code": "53470",
    "ville": "Martigné-sur-Mayenne",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Mayenne",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Mée",
    "dep": "Mayenne"
  },
  {
    "code": "53200",
    "ville": "Ménil",
    "dep": "Mayenne"
  },
  {
    "code": "53230",
    "ville": "Méral",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Meslay-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Mézangers",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Montaudin",
    "dep": "Mayenne"
  },
  {
    "code": "53500",
    "ville": "Montenay",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Montflours",
    "dep": "Mayenne"
  },
  {
    "code": "53970",
    "ville": "Montigné-le-Brillant",
    "dep": "Mayenne"
  },
  {
    "code": "53320",
    "ville": "Montjean",
    "dep": "Mayenne"
  },
  {
    "code": "53640",
    "ville": "Montreuil-Poulay",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "Montsûrs",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Moulay",
    "dep": "Mayenne"
  },
  {
    "code": "53150",
    "ville": "Neau",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Neuilly-le-Vendin",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Niafles",
    "dep": "Mayenne"
  },
  {
    "code": "53970",
    "ville": "Nuillé-sur-Vicoin",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Olivet",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Oisseau",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "Origné",
    "dep": "Mayenne"
  },
  {
    "code": "53140",
    "ville": "La Pallu",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Parigné-sur-Braye",
    "dep": "Mayenne"
  },
  {
    "code": "53260",
    "ville": "Parné-sur-Roc",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Le Pas",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "La Pellerine",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "Peuton",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Placé",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Pommerieux",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Pontmain",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Port-Brillet",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Préaux",
    "dep": "Mayenne"
  },
  {
    "code": "53140",
    "ville": "Pré-en-Pail-Saint-Samson",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "Quelaines-Saint-Gault",
    "dep": "Mayenne"
  },
  {
    "code": "53370",
    "ville": "Ravigny",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "Renazé",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Rennes-en-Grenouilles",
    "dep": "Mayenne"
  },
  {
    "code": "53640",
    "ville": "Le Ribay",
    "dep": "Mayenne"
  },
  {
    "code": "53350",
    "ville": "La Roë",
    "dep": "Mayenne"
  },
  {
    "code": "53390",
    "ville": "La Rouaudière",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Ruillé-Froid-Fonds",
    "dep": "Mayenne"
  },
  {
    "code": "53470",
    "ville": "Sacé",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Saint-Aignan-de-Couptrain",
    "dep": "Mayenne"
  },
  {
    "code": "53390",
    "ville": "Saint-Aignan-sur-Roë",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Saint-Aubin-du-Désert",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Saint-Aubin-Fosse-Louvain",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Saint-Baudelle",
    "dep": "Mayenne"
  },
  {
    "code": "53940",
    "ville": "Saint-Berthevin",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Saint-Berthevin-la-Tannière",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Saint-Brice",
    "dep": "Mayenne"
  },
  {
    "code": "53140",
    "ville": "Saint-Calais-du-Désert",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Saint-Charles-la-Forêt",
    "dep": "Mayenne"
  },
  {
    "code": "53140",
    "ville": "Saint-Cyr-en-Pail",
    "dep": "Mayenne"
  },
  {
    "code": "53320",
    "ville": "Saint-Cyr-le-Gravelais",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Saint-Denis-d'Anjou",
    "dep": "Mayenne"
  },
  {
    "code": "53500",
    "ville": "Saint-Denis-de-Gastines",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Saint-Denis-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Saint-Ellier-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53390",
    "ville": "Saint-Erblon",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Saint-Fraimbault-de-Prières",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Sainte-Gemmes-le-Robert",
    "dep": "Mayenne"
  },
  {
    "code": "53100",
    "ville": "Saint-Georges-Buttavent",
    "dep": "Mayenne"
  },
  {
    "code": "53480",
    "ville": "Saint-Georges-le-Fléchard",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Saint-Georges-sur-Erve",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Saint-Germain-d'Anxure",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Saint-Germain-de-Coulamer",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Saint-Germain-le-Fouilloux",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Saint-Germain-le-Guillaume",
    "dep": "Mayenne"
  },
  {
    "code": "53380",
    "ville": "Saint-Hilaire-du-Maine",
    "dep": "Mayenne"
  },
  {
    "code": "53270",
    "ville": "Blandouet-Saint Jean",
    "dep": "Mayenne"
  },
  {
    "code": "53240",
    "ville": "Saint-Jean-sur-Mayenne",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Saint-Julien-du-Terroux",
    "dep": "Mayenne"
  },
  {
    "code": "53480",
    "ville": "Saint-Léger",
    "dep": "Mayenne"
  },
  {
    "code": "53290",
    "ville": "Saint-Loup-du-Dorat",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Saint-Loup-du-Gast",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Sainte-Marie-du-Bois",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Saint-Mars-du-Désert",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Saint-Mars-sur-Colmont",
    "dep": "Mayenne"
  },
  {
    "code": "53220",
    "ville": "Saint-Mars-sur-la-Futaie",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "Saint-Martin-du-Limet",
    "dep": "Mayenne"
  },
  {
    "code": "53350",
    "ville": "Saint-Michel-de-la-Roë",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Saint-Ouën-des-Toits",
    "dep": "Mayenne"
  },
  {
    "code": "53500",
    "ville": "Saint-Pierre-des-Landes",
    "dep": "Mayenne"
  },
  {
    "code": "53370",
    "ville": "Saint-Pierre-des-Nids",
    "dep": "Mayenne"
  },
  {
    "code": "53410",
    "ville": "Saint-Pierre-la-Cour",
    "dep": "Mayenne"
  },
  {
    "code": "53270",
    "ville": "Saint-Pierre-sur-Erve",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Vimartin-sur-Orthe",
    "dep": "Mayenne"
  },
  {
    "code": "53540",
    "ville": "Saint-Poix",
    "dep": "Mayenne"
  },
  {
    "code": "53400",
    "ville": "Saint-Quentin-les-Anges",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "Saint-Saturnin-du-Limet",
    "dep": "Mayenne"
  },
  {
    "code": "53270",
    "ville": "Sainte-Suzanne-et-Chammes",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Saint-Thomas-de-Courceriers",
    "dep": "Mayenne"
  },
  {
    "code": "53340",
    "ville": "Saulges",
    "dep": "Mayenne"
  },
  {
    "code": "53800",
    "ville": "La Selle-Craonnaise",
    "dep": "Mayenne"
  },
  {
    "code": "53390",
    "ville": "Senonnes",
    "dep": "Mayenne"
  },
  {
    "code": "53360",
    "ville": "Simplé",
    "dep": "Mayenne"
  },
  {
    "code": "53300",
    "ville": "Soucé",
    "dep": "Mayenne"
  },
  {
    "code": "53210",
    "ville": "Soulgé-sur-Ouette",
    "dep": "Mayenne"
  },
  {
    "code": "53110",
    "ville": "Thubœuf",
    "dep": "Mayenne"
  },
  {
    "code": "53270",
    "ville": "Thorigné-en-Charnie",
    "dep": "Mayenne"
  },
  {
    "code": "53270",
    "ville": "Torcé-Viviers-en-Charnie",
    "dep": "Mayenne"
  },
  {
    "code": "53160",
    "ville": "Trans",
    "dep": "Mayenne"
  },
  {
    "code": "53480",
    "ville": "Vaiges",
    "dep": "Mayenne"
  },
  {
    "code": "53500",
    "ville": "Vautorte",
    "dep": "Mayenne"
  },
  {
    "code": "53120",
    "ville": "Vieuvy",
    "dep": "Mayenne"
  },
  {
    "code": "53700",
    "ville": "Villaines-la-Juhel",
    "dep": "Mayenne"
  },
  {
    "code": "53250",
    "ville": "Villepail",
    "dep": "Mayenne"
  },
  {
    "code": "53170",
    "ville": "Villiers-Charlemagne",
    "dep": "Mayenne"
  },
  {
    "code": "53600",
    "ville": "Voutré",
    "dep": "Mayenne"
  },
  {
    "code": "54610",
    "ville": "Abaucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Abbéville-lès-Conflans",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Aboncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Affléville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Affracourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54770",
    "ville": "Agincourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54460",
    "ville": "Aingeray",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Allain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Allamont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54112",
    "ville": "Allamps",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Allondrelle-la-Malmaison",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54770",
    "ville": "Amance",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Amenoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Ancerviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Anderny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Andilly",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Angomont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Anoux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Ansauville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Anthelupt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Armaucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54530",
    "ville": "Arnaville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Arracourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Arraye-et-Han",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54510",
    "ville": "Art-sur-Meurthe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Athienville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Atton",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54580",
    "ville": "Auboué",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Audun-le-Roman",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Autrepierre",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Autreville-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54160",
    "ville": "Autrey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Avillers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Avrainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Avricourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Avril",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Azelot",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Azerailles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Baccarat",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Badonviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Bagneux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Bainville-aux-Miroirs",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54550",
    "ville": "Bainville-sur-Madon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Barbas",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Barbonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Barisey-au-Plain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Barisey-la-Côte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Les Baroches",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Baslieux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Bathelémont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54980",
    "ville": "Batilly",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Battigny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Bauzemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Bayon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Bayonville-sur-Mad",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Bazailles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Beaumont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Béchamps",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Belleau",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54940",
    "ville": "Belleville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Bénaménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Benney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Bernécourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Bertrambois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Bertrichamps",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54640",
    "ville": "Bettainvillers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Beuveille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Beuvezin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Beuvillers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Bey-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Bezange-la-Grande",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Bezaumont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Bicqueley",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Bienville-la-Petite",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Bionville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Blainville-sur-l'Eau",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Blâmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Blémerey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Blénod-lès-Pont-à-Mousson",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Blénod-lès-Toul",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Boismont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Boncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Bonviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54111",
    "ville": "Mont-Bonvillers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Borville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Boucq",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Bouillonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Bouvron",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54770",
    "ville": "Bouxières-aux-Chênes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54136",
    "ville": "Bouxières-aux-Dames",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Bouxières-sous-Froidmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Bouzanville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Brainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Bralleville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Bratte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54190",
    "ville": "Bréhain-la-Ville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Bréménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Brémoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Val de Briey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Brin-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Brouville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Bruley",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Bruville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Buissoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Bulligny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Bures",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Buriville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Burthecourt-aux-Chênes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54134",
    "ville": "Ceintrey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54420",
    "ville": "Cerville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54230",
    "ville": "Chaligny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Chambley-Bussières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Champenoux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Champey-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54250",
    "ville": "Champigneulles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Chanteheux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Chaouilley",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Charency-Vezin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Charey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Charmes-la-Côte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Charmois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Chaudeney-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54230",
    "ville": "Chavigny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Chazelles-sur-Albe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Chenevières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Chenicourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54720",
    "ville": "Chenières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Choloy-Ménillot",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Cirey-sur-Vezouze",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Clayeures",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Clémery",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Clérey-sur-Brenon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Coincourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Colmey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Colombey-les-Belles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Conflans-en-Jarnisy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54870",
    "ville": "Cons-la-Grandville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54400",
    "ville": "Cosnes-et-Romain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Courbesseaux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Courcelles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Coyviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Crantenoy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Crépey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Crévéchamps",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Crévic",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Crézilles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Crion",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Croismare",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54680",
    "ville": "Crusnes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54670",
    "ville": "Custines",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54720",
    "ville": "Cutry",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Damelevières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Dampvitoux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Deneuvre",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Deuxville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Diarville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Dieulouard",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Dolcourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Dombasle-sur-Meurthe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Domèvre-en-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Domèvre-sur-Vezouze",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54119",
    "ville": "Domgermain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Domjevin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Dommarie-Eulmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54130",
    "ville": "Dommartemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Dommartin-la-Chaussée",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Dommartin-lès-Toul",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54770",
    "ville": "Dommartin-sous-Amance",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Domprix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Domptail-en-l'Air",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Doncourt-lès-Conflans",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Doncourt-lès-Longuyon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Drouville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Écrouves",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Einvaux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Einville-au-Jard",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Emberménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Épiez-sur-Chiers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Éply",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Erbéviller-sur-Amezule",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54680",
    "ville": "Errouville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Essey-et-Maizerais",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Essey-la-Côte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54270",
    "ville": "Essey-lès-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Étreval",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54690",
    "ville": "Eulmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Euvezin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Faulx",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Favières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Fécocourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Fenneviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Ferrières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Fey-en-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Fillières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Flainval",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54630",
    "ville": "Flavigny-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54710",
    "ville": "Fléville-devant-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Fléville-Lixières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Flin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Flirey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Fontenoy-la-Joûte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54840",
    "ville": "Fontenoy-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Forcelles-Saint-Gorgon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Forcelles-sous-Gugney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54570",
    "ville": "Foug",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Fraimbois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Fraisnes-en-Saintois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Francheville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Franconville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Fréménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Frémonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Fresnois-la-Montagne",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Friauville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54160",
    "ville": "Frolois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54390",
    "ville": "Frouard",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Froville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Gélacourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Gélaucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Gellenoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Gémonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Gerbécourt-et-Haplemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Gerbéviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Germiny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Germonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Gézoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54112",
    "ville": "Gibeaumeix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54780",
    "ville": "Giraumont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Giriviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Glonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Gogney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Gondrecourt-Aix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54840",
    "ville": "Gondreville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Gondrexon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54730",
    "ville": "Gorcy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Goviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Grand-Failly",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Grimonviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Gripport",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Griscourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Grosrouvres",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Gugney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Gye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Hablainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Hagéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Haigneville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Halloville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Hammeville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Hamonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Hannonville-Suzémont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Haraucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Harbouey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Haroué",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Hatrize",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54860",
    "ville": "Haucourt-Moulaine",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Haudonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Haussonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54180",
    "ville": "Heillecourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Hénaménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Herbéviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Hériménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54440",
    "ville": "Herserange",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Hoéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54310",
    "ville": "Homécourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Houdelmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54180",
    "ville": "Houdemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Houdreville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Housséville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Hudiviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54590",
    "ville": "Hussigny-Godbrange",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Igney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Jaillon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Jarny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54140",
    "ville": "Jarville-la-Malgrange",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Jaulny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54114",
    "ville": "Jeandelaincourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Jeandelize",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Jevoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Jezainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54240",
    "ville": "Jœuf",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Jolivet",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Joppécourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Jouaville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Joudreville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Juvrecourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Labry",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Lachapelle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Lagney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54770",
    "ville": "Laître-sous-Amance",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54720",
    "ville": "Laix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Lalœuf",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Lamath",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Landécourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Landremont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54970",
    "ville": "Landres",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Laneuvelotte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Laneuveville-aux-Bois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54570",
    "ville": "Laneuveville-derrière-Foug",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Laneuveville-devant-Bayon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54410",
    "ville": "Laneuveville-devant-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Lanfroicourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Lantéfontaine",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54950",
    "ville": "Laronxe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54520",
    "ville": "Laxou",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54690",
    "ville": "Lay-Saint-Christophe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54570",
    "ville": "Lay-Saint-Remy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Lebeuville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Leintrey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Lemainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Leménil-Mitry",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Lenoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Lesménils",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Létricourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54720",
    "ville": "Lexy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Leyr",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Limey-Remenauville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Lironville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54460",
    "ville": "Liverdun",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Loisy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54810",
    "ville": "Longlaville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Longuyon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54400",
    "ville": "Longwy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Lorey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Loromontzey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Lubey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Lucey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54710",
    "ville": "Ludres",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Lunéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Lupcourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54129",
    "ville": "Magnières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Maidières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Mailly-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Mairy-Mainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Maixe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54550",
    "ville": "Maizières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Malavillers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54670",
    "ville": "Malleloy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54220",
    "ville": "Malzéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Mamey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Mandres-aux-Quatre-Tours",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Mangonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Manoncourt-en-Vermois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Manoncourt-en-Woëvre",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Manonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Manonviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Marainviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54820",
    "ville": "Marbache",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54230",
    "ville": "Maron",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Mars-la-Tour",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Marthemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Martincourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Mattexey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54320",
    "ville": "Maxéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Mazerulles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Méhoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Ménil-la-Tour",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54960",
    "ville": "Mercy-le-Bas",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Mercy-le-Haut",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54850",
    "ville": "Méréville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Merviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54850",
    "ville": "Messein",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54135",
    "ville": "Mexy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Mignéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54670",
    "ville": "Millery",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Minorville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54580",
    "ville": "Moineville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Moivrons",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Moncel-lès-Lunéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Moncel-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Montauville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Montenoy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Montigny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54870",
    "ville": "Montigny-sur-Chiers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Mont-l'Étroit",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Mont-le-Vignoble",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Montreux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54350",
    "ville": "Mont-Saint-Martin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Mont-sur-Meurthe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54920",
    "ville": "Morfontaine",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Moriviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Morville-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Mouacourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Mouaville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Mousson",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54660",
    "ville": "Moutiers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54113",
    "ville": "Moutrot",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54118",
    "ville": "Moyen",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Murville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54100",
    "ville": "Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Neufmaisons",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54230",
    "ville": "Neuves-Maisons",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Neuviller-lès-Badonviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Neuviller-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Nomeny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Nonhigny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Norroy-le-Sec",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Norroy-lès-Pont-à-Mousson",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Noviant-aux-Prés",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Ochey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Ogéviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Ognéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Olley",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Omelmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Onville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Ormes-et-Ville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Othe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54150",
    "ville": "Ozerailles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Pagney-derrière-Barine",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54530",
    "ville": "Pagny-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Pannes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Parey-Saint-Césaire",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Parroy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Parux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Petit-Failly",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Petitmont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Pettonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Pexonne",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Phlin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Piennes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Pierre-la-Treiche",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Pierre-Percée",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Pierrepont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54160",
    "ville": "Pierreville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54340",
    "ville": "Pompey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Pont-à-Mousson",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54550",
    "ville": "Pont-Saint-Vincent",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Port-sur-Seille",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54116",
    "ville": "Praye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54530",
    "ville": "Prény",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Preutin-Higny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54160",
    "ville": "Pulligny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Pulney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54425",
    "ville": "Pulnoy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Puxe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Puxieux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Quevilloncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Raon-lès-Leau",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Raucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Raville-sur-Sânon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Réchicourt-la-Petite",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Réclonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Rehainviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Reherrey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54430",
    "ville": "Réhon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Reillon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Rembercourt-sur-Mad",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Remenoville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Réméréville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Remoncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Repaix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54630",
    "ville": "Richardménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Rogéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Romain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Rosières-aux-Salines",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Rosières-en-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Rouves",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Roville-devant-Bayon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Royaumeix",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Rozelieures",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Saffais",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54580",
    "ville": "Saint-Ail",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Saint-Baussant",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Saint-Boingt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54950",
    "ville": "Saint-Clément",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "Saint-Firmin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Sainte-Geneviève",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Saint-Germain",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Saint-Jean-lès-Longuyon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Saint-Julien-lès-Gorze",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Saint-Marcel",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Saint-Mard",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Saint-Martin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Saint-Maurice-aux-Forges",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54130",
    "ville": "Saint-Max",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Saint-Nicolas-de-Port",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Sainte-Pôle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54730",
    "ville": "Saint-Pancré",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Saint-Remimont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Saint-Rémy-aux-Bois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Saint-Sauveur",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Saint-Supplet",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Saizerais",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Sancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Sanzey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54650",
    "ville": "Saulnes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Saulxerotte",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54420",
    "ville": "Saulxures-lès-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Saulxures-lès-Vannes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Saxon-Sion",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Seichamps",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Seicheprey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Selaincourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Seranville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Serres",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54560",
    "ville": "Serrouville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54550",
    "ville": "Sexey-aux-Forges",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Sionviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Sivry",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Sommerviller",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Sornéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Sponville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Tanconville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54116",
    "ville": "Tantonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Tellancourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Thélod",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54930",
    "ville": "They-sous-Vaudemont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54610",
    "ville": "Thézey-Saint-Martin",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Thiaucourt-Regniéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Thiaville-sur-Meurthe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Thiébauménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54880",
    "ville": "Thil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Thorey-Lyautey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54170",
    "ville": "Thuilley-aux-Groseilles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Thumeréville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54190",
    "ville": "Tiercelet",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54510",
    "ville": "Tomblaine",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Tonnoy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Toul",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Tramont-Émy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Tramont-Lassus",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Tramont-Saint-André",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54385",
    "ville": "Tremblecourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54750",
    "ville": "Trieux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54570",
    "ville": "Trondes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Tronville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54640",
    "ville": "Tucquegnieux",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54870",
    "ville": "Ugny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54112",
    "ville": "Uruffe",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Vacqueville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54480",
    "ville": "Val-et-Châtillon",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Valhey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54910",
    "ville": "Valleroy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Vallois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Vandelainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54115",
    "ville": "Vandeléville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54121",
    "ville": "Vandières",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54500",
    "ville": "Vandœuvre-lès-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54112",
    "ville": "Vannes-le-Châtel",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54110",
    "ville": "Varangéville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54122",
    "ville": "Vathiménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Vaucourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Vaudémont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Vaudeville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Vaudigny",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54120",
    "ville": "Vaxainville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Vého",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54840",
    "ville": "Bois-de-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54280",
    "ville": "Velaine-sous-Amance",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Velle-sur-Moselle",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54540",
    "ville": "Veney",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54830",
    "ville": "Vennezey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54450",
    "ville": "Verdenal",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Vézelise",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Viéville-en-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54360",
    "ville": "Vigneulles",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Vilcey-sur-Trey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Villacourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Ville-au-Montois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Ville-au-Val",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Villecey-sur-Mad",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54210",
    "ville": "Ville-en-Vermois",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54730",
    "ville": "Ville-Houdlémont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54380",
    "ville": "Villers-en-Haye",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54870",
    "ville": "Villers-la-Chèvre",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54920",
    "ville": "Villers-la-Montagne",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Villers-le-Rond",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54760",
    "ville": "Villers-lès-Moivrons",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54600",
    "ville": "Villers-lès-Nancy",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Villers-sous-Prény",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54190",
    "ville": "Villerupt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Ville-sur-Yron",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Villette",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54840",
    "ville": "Villey-le-Sec",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54200",
    "ville": "Villey-Saint-Étienne",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54290",
    "ville": "Virecourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54123",
    "ville": "Viterne",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Vitrey",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Vitrimont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54700",
    "ville": "Vittonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54260",
    "ville": "Viviers-sur-Chiers",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54134",
    "ville": "Voinémont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54330",
    "ville": "Vroncourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54890",
    "ville": "Waville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54470",
    "ville": "Xammes",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54300",
    "ville": "Xermaménil",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54990",
    "ville": "Xeuilley",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54740",
    "ville": "Xirocourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54490",
    "ville": "Xivry-Circourt",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54800",
    "ville": "Xonville",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Xousse",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54370",
    "ville": "Xures",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "54620",
    "ville": "Han-devant-Pierrepont",
    "dep": "Meurthe-et-Moselle"
  },
  {
    "code": "55130",
    "ville": "Abainville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Abaucourt-Hautecourt",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Aincreville",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Amanty",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Ambly-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Amel-sur-l'Étang",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Ancemont",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Ancerville",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Andernay",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Apremont-la-Forêt",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Arrancy-sur-Crusnes",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Aubréville",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Aulnois-en-Perthois",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Autrécourt-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Autréville-Saint-Lambert",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Avillers-Sainte-Croix",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Avioth",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Avocourt",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Azannes-et-Soumazannes",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Baâlon",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Badonvilliers-Gérauvilliers",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Bannoncourt",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Bantheville",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Bar-le-Duc",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Baudonvilliers",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Baudrémont",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Baulny",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Bazeilles-sur-Othain",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Bazincourt-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Beauclair",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Beaufort-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Beaulieu-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Beaumont-en-Verdunois",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Beausite",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Behonne",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Belleray",
    "dep": "Meuse"
  },
  {
    "code": "55430",
    "ville": "Belleville-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Belrain",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Belrupt-en-Verdunois",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Beney-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Béthelainville",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Béthincourt",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Beurey-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Bezonvaux",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Biencourt-sur-Orge",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Billy-sous-Mangiennes",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Bislée",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Blanzée",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Boinville-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Boncourt-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Bonnet",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Bonzée",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Le Bouchon-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Bouconville-sur-Madt",
    "dep": "Meuse"
  },
  {
    "code": "55240",
    "ville": "Bouligny",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Bouquemont",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Boureuilles",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Bovée-sur-Barboure",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Boviolles",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Brabant-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Brabant-le-Roi",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Brabant-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Brandeville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Braquis",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Bras-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Brauvilliers",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Bréhéville",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Breux",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Brieulles-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Brillon-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Brixey-aux-Chanoines",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Brizeaux",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Brocourt-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Brouennes",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Broussey-en-Blois",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Broussey-Raulecourt",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Bure",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Burey-en-Vaux",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Burey-la-Côte",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Buxières-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Buzy-Darmont",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Cesse",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Chaillon",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Chalaines",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Champneuville",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Champougny",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Chardogne",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Charny-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Charpentry",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Chassey-Beaupré",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Châtillon-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Chattancourt",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Chaumont-devant-Damvillers",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Chaumont-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Chauvency-le-Château",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Chauvency-Saint-Hubert",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Chauvoncourt",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Cheppy",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Chonville-Malaumont",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Cierges-sous-Montfaucon",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Le Claon",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Clermont-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Cléry-le-Grand",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Cléry-le-Petit",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Combles-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Combres-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Commercy",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Les Hauts-de-Chée",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Consenvoye",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Contrisson",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Courcelles-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Courcelles-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Courouvre",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Cousances-les-Forges",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Couvertpuis",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Couvonges",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Cuisy",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Culey",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Cumières-le-Mort-Homme",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Cunel",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Dagonville",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Dainville-Bertheléville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Damloup",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Dammarie-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Damvillers",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Dannevoux",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Delouze-Rosières",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Delut",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Demange-Baudignécourt",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Dieppe-sous-Douaumont",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Dieue-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Dombasle-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Dombras",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Dommartin-la-Montagne",
    "dep": "Meuse"
  },
  {
    "code": "55240",
    "ville": "Dommary-Baroncourt",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Dompcevrin",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Dompierre-aux-Bois",
    "dep": "Meuse"
  },
  {
    "code": "55240",
    "ville": "Domremy-la-Canne",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Doncourt-aux-Templiers",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Doulcon",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Dugny-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Dun-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Duzey",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Écouviez",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Écurey-en-Verdunois",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Eix",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Les Éparges",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Épiez-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Épinonville",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Érize-la-Brûlée",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Érize-la-Petite",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Érize-Saint-Dizier",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Erneville-aux-Bois",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Esnes-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Étain",
    "dep": "Meuse"
  },
  {
    "code": "55240",
    "ville": "Éton",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Étraye",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Euville",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Èvres",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Fains-Véel",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Flassigny",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Fleury-devant-Douaumont",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Foameix-Ornel",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Fontaines-Saint-Clair",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Forges-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Foucaucourt-sur-Thabas",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Fouchères-aux-Bois",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Frémeréville-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Fresnes-au-Mont",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Fresnes-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Froidos",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Fromeréville-les-Vallons",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Fromezey",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Futeau",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Génicourt-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Gercourt-et-Drillancourt",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Géry",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Gesnes-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Gimécourt",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Gincrey",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Girauvoisin",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Givrauval",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Gondrecourt-le-Château",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Gouraincourt",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Goussaincourt",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Gremilly",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Grimaucourt-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Grimaucourt-près-Sampigny",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Guerpont",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Gussainville",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Haironville",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Halles-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Han-lès-Juvigny",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Hannonville-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Han-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Harville",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Haudainville",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Haudiomont",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Haumont-près-Samogneux",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Heippes",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Hennemont",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Herbeuville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Herméville-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Heudicourt-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Hévilliers",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Horville-en-Ornois",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Houdelaincourt",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Inor",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Ippécourt",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Iré-le-Sec",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Les Islettes",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Les Trois-Domaines",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Jametz",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Jonville-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Jouy-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Geville",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Julvécourt",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Juvigny-en-Perthois",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Juvigny-sur-Loison",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Kœur-la-Grande",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Kœur-la-Petite",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Labeuville",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Lachalade",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Lachaussée",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Lacroix-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Lahaymeix",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Lahayville",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Laheycourt",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Laimont",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Lamorville",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Lamouilly",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Landrecourt-Lempire",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Laneuville-au-Rupt",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Laneuville-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Lanhères",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Latour-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Lavallée",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Lavincourt",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Lavoye",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Lemmes",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Lérouville",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Levoncourt",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Lignières-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Ligny-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Liny-devant-Dun",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Lion-devant-Dun",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Lisle-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "L'Isle-en-Rigault",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Lissey",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Loisey",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Loison",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Longeaux",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Longchamps-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Longeville-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Loupmont",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Louppy-le-Château",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Louppy-sur-Loison",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Louvemont-Côte-du-Poivre",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Luzy-Saint-Martin",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Maizeray",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Maizey",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Malancourt",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Mandres-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Mangiennes",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Manheulles",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Marchéville-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Marre",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Marson-sur-Barboure",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Martincourt-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Marville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Maucourt-sur-Orne",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Maulan",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Mauvages",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Maxey-sur-Vaise",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Mécrin",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Méligny-le-Grand",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Méligny-le-Petit",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Menaucourt",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Ménil-aux-Bois",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Ménil-la-Horgne",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Ménil-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Merles-sur-Loison",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Milly-sur-Bradon",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Mogeville",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Mognéville",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Moirey-Flabas-Crépion",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Montblainville",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Montbras",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Mont-devant-Sassey",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Montfaucon-d'Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Les Monthairons",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Montiers-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Montigny-devant-Sassey",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Montigny-lès-Vaucouleurs",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Montmédy",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Montplonne",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Montsec",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Montzéville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Moranville",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Morgemoulin",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Chanteraine",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Morley",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Mouilly",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Moulainville",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Moulins-Saint-Hubert",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Moulotte",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Mouzay",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Murvaux",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Val-d'Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Muzeray",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Naives-en-Blois",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Naives-Rosières",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Naix-aux-Forges",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Nançois-le-Grand",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Nançois-sur-Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Nant-le-Grand",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Nant-le-Petit",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Nantillois",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Nantois",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Nepvant",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Nettancourt",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Le Neufour",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Neuville-en-Verdunois",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Neuville-lès-Vaucouleurs",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Neuville-sur-Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Neuvilly-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Nicey-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Nixéville-Blercourt",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Nonsard-Lamarche",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Nouillonpont",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Noyers-Auzécourt",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Nubécourt",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Olizy-sur-Chiers",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Ornes",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Osches",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Ourches-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Pagny-la-Blanche-Côte",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Pagny-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Pareid",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Parfondrupt",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Les Paroches",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Peuvillers",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Pierrefitte-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Pillon",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Pintheville",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Pont-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Pouilly-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Pretz-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Quincy-Landzécourt",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Rambluzin-et-Benoite-Vaux",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Rambucourt",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Rancourt-sur-Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Ranzières",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Rarécourt",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Récicourt",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Récourt-le-Creux",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Reffroy",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Regnéville-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Rembercourt-Sommaisne",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Remennecourt",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Remoiville",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Resson",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Revigny-sur-Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Réville-aux-Bois",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Riaville",
    "dep": "Meuse"
  },
  {
    "code": "55290",
    "ville": "Ribeaucourt",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Richecourt",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Rigny-la-Salle",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Rigny-Saint-Martin",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Robert-Espagne",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Les Roises",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Romagne-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Romagne-sous-Montfaucon",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Ronvaux",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Raival",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Rouvres-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Rouvrois-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Rouvrois-sur-Othain",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Rumont",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Rupt-aux-Nonains",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Rupt-devant-Saint-Mihiel",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Rupt-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Rupt-sur-Othain",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Saint-Amand-sur-Ornain",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Saint-André-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Saint-Aubin-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Saint-Germain-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Saint-Hilaire-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Saint-Jean-lès-Buzy",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Saint-Joire",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Saint-Julien-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Saint-Laurent-sur-Othain",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Saint-Maurice-sous-les-Côtes",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Saint-Mihiel",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Saint-Pierrevillers",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Saint-Remy-la-Calonne",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Salmagne",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Sampigny",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Samogneux",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Sassey-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Saudrupt",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Saulmory-Villefranche",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Saulvaux",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Saulx-lès-Champlon",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Sauvigny",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Sauvoy",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Savonnières-devant-Bar",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Savonnières-en-Perthois",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Seigneulles",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Senon",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Senoncourt-les-Maujouy",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Septsarges",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Sepvigny",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Seuzey",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Silmont",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Sivry-la-Perche",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Sivry-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55320",
    "ville": "Sommedieue",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Sommeilles",
    "dep": "Meuse"
  },
  {
    "code": "55170",
    "ville": "Sommelonne",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Sorbey",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Sorcy-Saint-Martin",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Les Souhesmes-Rampont",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Souilly",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Spincourt",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Stainville",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Stenay",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Taillancourt",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Tannois",
    "dep": "Meuse"
  },
  {
    "code": "55840",
    "ville": "Thierville-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Thillombois",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Thillot",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Thonne-la-Long",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Thonne-le-Thil",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Thonne-les-Près",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Thonnelle",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Tilly-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Trémont-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Trésauvaux",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Tréveray",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Seuil-d'Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Cousances-lès-Triconville",
    "dep": "Meuse"
  },
  {
    "code": "55310",
    "ville": "Tronville-en-Barrois",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Troussey",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Troyon",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Ugny-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Vacherauville",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Vadelaincourt",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Vadonville",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Varennes-en-Argonne",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Varnéville",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Valbois",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Vassincourt",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Vaubecourt",
    "dep": "Meuse"
  },
  {
    "code": "55140",
    "ville": "Vaucouleurs",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Vaudeville-le-Haut",
    "dep": "Meuse"
  },
  {
    "code": "55230",
    "ville": "Vaudoncourt",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Vauquois",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Douaumont-Vaux",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Vaux-lès-Palameix",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Vavincourt",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Velaines",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Velosnes",
    "dep": "Meuse"
  },
  {
    "code": "55100",
    "ville": "Verdun",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Verneuil-Grand",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Verneuil-Petit",
    "dep": "Meuse"
  },
  {
    "code": "55270",
    "ville": "Véry",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Vigneulles-lès-Hattonchâtel",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Vigneul-sous-Montmédy",
    "dep": "Meuse"
  },
  {
    "code": "55200",
    "ville": "Vignot",
    "dep": "Meuse"
  },
  {
    "code": "55600",
    "ville": "Villécloye",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Ville-devant-Belrain",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Ville-devant-Chaumont",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Ville-en-Woëvre",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Villeroy-sur-Méholle",
    "dep": "Meuse"
  },
  {
    "code": "55800",
    "ville": "Villers-aux-Vents",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Villers-devant-Dun",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Villers-le-Sec",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Villers-lès-Mangiennes",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Villers-sous-Pareid",
    "dep": "Meuse"
  },
  {
    "code": "55220",
    "ville": "Villers-sur-Meuse",
    "dep": "Meuse"
  },
  {
    "code": "55120",
    "ville": "Ville-sur-Cousances",
    "dep": "Meuse"
  },
  {
    "code": "55000",
    "ville": "Ville-sur-Saulx",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Villotte-devant-Louppy",
    "dep": "Meuse"
  },
  {
    "code": "55260",
    "ville": "Villotte-sur-Aire",
    "dep": "Meuse"
  },
  {
    "code": "55110",
    "ville": "Vilosnes-Haraumont",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Vittarville",
    "dep": "Meuse"
  },
  {
    "code": "55190",
    "ville": "Void-Vacon",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Vouthon-Bas",
    "dep": "Meuse"
  },
  {
    "code": "55130",
    "ville": "Vouthon-Haut",
    "dep": "Meuse"
  },
  {
    "code": "55250",
    "ville": "Waly",
    "dep": "Meuse"
  },
  {
    "code": "55400",
    "ville": "Warcq",
    "dep": "Meuse"
  },
  {
    "code": "55160",
    "ville": "Watronville",
    "dep": "Meuse"
  },
  {
    "code": "55150",
    "ville": "Wavrille",
    "dep": "Meuse"
  },
  {
    "code": "55500",
    "ville": "Willeroncourt",
    "dep": "Meuse"
  },
  {
    "code": "55700",
    "ville": "Wiseppe",
    "dep": "Meuse"
  },
  {
    "code": "55210",
    "ville": "Woël",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Woimbey",
    "dep": "Meuse"
  },
  {
    "code": "55300",
    "ville": "Xivray-et-Marvoisin",
    "dep": "Meuse"
  },
  {
    "code": "56350",
    "ville": "Allaire",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Ambon",
    "dep": "Morbihan"
  },
  {
    "code": "56610",
    "ville": "Arradon",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Arzal",
    "dep": "Morbihan"
  },
  {
    "code": "56640",
    "ville": "Arzon",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Augan",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Auray",
    "dep": "Morbihan"
  },
  {
    "code": "56870",
    "ville": "Baden",
    "dep": "Morbihan"
  },
  {
    "code": "56360",
    "ville": "Bangor",
    "dep": "Morbihan"
  },
  {
    "code": "56150",
    "ville": "Baud",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Béganne",
    "dep": "Morbihan"
  },
  {
    "code": "56380",
    "ville": "Beignon",
    "dep": "Morbihan"
  },
  {
    "code": "56550",
    "ville": "Belz",
    "dep": "Morbihan"
  },
  {
    "code": "56240",
    "ville": "Berné",
    "dep": "Morbihan"
  },
  {
    "code": "56230",
    "ville": "Berric",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Bignan",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Billiers",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Billio",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Bohal",
    "dep": "Morbihan"
  },
  {
    "code": "56700",
    "ville": "Brandérion",
    "dep": "Morbihan"
  },
  {
    "code": "56390",
    "ville": "Brandivy",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Brech",
    "dep": "Morbihan"
  },
  {
    "code": "56580",
    "ville": "Bréhan",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Brignac",
    "dep": "Morbihan"
  },
  {
    "code": "56310",
    "ville": "Bubry",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Buléon",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Caden",
    "dep": "Morbihan"
  },
  {
    "code": "56240",
    "ville": "Calan",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Camoël",
    "dep": "Morbihan"
  },
  {
    "code": "56330",
    "ville": "Camors",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Campénéac",
    "dep": "Morbihan"
  },
  {
    "code": "56910",
    "ville": "Carentoir",
    "dep": "Morbihan"
  },
  {
    "code": "56340",
    "ville": "Carnac",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Caro",
    "dep": "Morbihan"
  },
  {
    "code": "56850",
    "ville": "Caudan",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "La Chapelle-Neuve",
    "dep": "Morbihan"
  },
  {
    "code": "56620",
    "ville": "Cléguer",
    "dep": "Morbihan"
  },
  {
    "code": "56480",
    "ville": "Cléguérec",
    "dep": "Morbihan"
  },
  {
    "code": "56390",
    "ville": "Colpo",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Concoret",
    "dep": "Morbihan"
  },
  {
    "code": "56200",
    "ville": "Cournon",
    "dep": "Morbihan"
  },
  {
    "code": "56230",
    "ville": "Le Cours",
    "dep": "Morbihan"
  },
  {
    "code": "56950",
    "ville": "Crach",
    "dep": "Morbihan"
  },
  {
    "code": "56580",
    "ville": "Crédin",
    "dep": "Morbihan"
  },
  {
    "code": "56540",
    "ville": "Le Croisty",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "La Croix-Helléan",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Cruguel",
    "dep": "Morbihan"
  },
  {
    "code": "56750",
    "ville": "Damgan",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Elven",
    "dep": "Morbihan"
  },
  {
    "code": "56410",
    "ville": "Erdeven",
    "dep": "Morbihan"
  },
  {
    "code": "56410",
    "ville": "Étel",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "Évriguet",
    "dep": "Morbihan"
  },
  {
    "code": "56320",
    "ville": "Le Faouët",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Férel",
    "dep": "Morbihan"
  },
  {
    "code": "56200",
    "ville": "Les Fougerêts",
    "dep": "Morbihan"
  },
  {
    "code": "56200",
    "ville": "La Gacilly",
    "dep": "Morbihan"
  },
  {
    "code": "56680",
    "ville": "Gâvres",
    "dep": "Morbihan"
  },
  {
    "code": "56530",
    "ville": "Gestel",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Gourhel",
    "dep": "Morbihan"
  },
  {
    "code": "56110",
    "ville": "Gourin",
    "dep": "Morbihan"
  },
  {
    "code": "56390",
    "ville": "Grand-Champ",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "La Grée-Saint-Laurent",
    "dep": "Morbihan"
  },
  {
    "code": "56590",
    "ville": "Groix",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Guégon",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Guéhenno",
    "dep": "Morbihan"
  },
  {
    "code": "56920",
    "ville": "Gueltas",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Guémené-sur-Scorff",
    "dep": "Morbihan"
  },
  {
    "code": "56150",
    "ville": "Guénin",
    "dep": "Morbihan"
  },
  {
    "code": "56380",
    "ville": "Guer",
    "dep": "Morbihan"
  },
  {
    "code": "56310",
    "ville": "Guern",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Le Guerno",
    "dep": "Morbihan"
  },
  {
    "code": "56520",
    "ville": "Guidel",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Guillac",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "Guilliers",
    "dep": "Morbihan"
  },
  {
    "code": "56560",
    "ville": "Guiscriff",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Helléan",
    "dep": "Morbihan"
  },
  {
    "code": "56700",
    "ville": "Hennebont",
    "dep": "Morbihan"
  },
  {
    "code": "56450",
    "ville": "Le Hézo",
    "dep": "Morbihan"
  },
  {
    "code": "56170",
    "ville": "Hœdic",
    "dep": "Morbihan"
  },
  {
    "code": "56170",
    "ville": "Île-d'Houat",
    "dep": "Morbihan"
  },
  {
    "code": "56780",
    "ville": "Île-aux-Moines",
    "dep": "Morbihan"
  },
  {
    "code": "56840",
    "ville": "Île-d'Arz",
    "dep": "Morbihan"
  },
  {
    "code": "56240",
    "ville": "Inguiniel",
    "dep": "Morbihan"
  },
  {
    "code": "56650",
    "ville": "Inzinzac-Lochrist",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Josselin",
    "dep": "Morbihan"
  },
  {
    "code": "56920",
    "ville": "Kerfourn",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Kergrist",
    "dep": "Morbihan"
  },
  {
    "code": "56700",
    "ville": "Kervignac",
    "dep": "Morbihan"
  },
  {
    "code": "56690",
    "ville": "Landaul",
    "dep": "Morbihan"
  },
  {
    "code": "56690",
    "ville": "Landévant",
    "dep": "Morbihan"
  },
  {
    "code": "56600",
    "ville": "Lanester",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Langoëlan",
    "dep": "Morbihan"
  },
  {
    "code": "56630",
    "ville": "Langonnet",
    "dep": "Morbihan"
  },
  {
    "code": "56440",
    "ville": "Languidic",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Forges de Lanouée",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Lantillac",
    "dep": "Morbihan"
  },
  {
    "code": "56240",
    "ville": "Lanvaudan",
    "dep": "Morbihan"
  },
  {
    "code": "56320",
    "ville": "Lanvénégen",
    "dep": "Morbihan"
  },
  {
    "code": "56870",
    "ville": "Larmor-Baden",
    "dep": "Morbihan"
  },
  {
    "code": "56260",
    "ville": "Larmor-Plage",
    "dep": "Morbihan"
  },
  {
    "code": "56230",
    "ville": "Larré",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Lauzach",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Lignol",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Limerzel",
    "dep": "Morbihan"
  },
  {
    "code": "56460",
    "ville": "Lizio",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Locmalo",
    "dep": "Morbihan"
  },
  {
    "code": "56360",
    "ville": "Locmaria",
    "dep": "Morbihan"
  },
  {
    "code": "56390",
    "ville": "Locmaria-Grand-Champ",
    "dep": "Morbihan"
  },
  {
    "code": "56740",
    "ville": "Locmariaquer",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Locminé",
    "dep": "Morbihan"
  },
  {
    "code": "56570",
    "ville": "Locmiquélic",
    "dep": "Morbihan"
  },
  {
    "code": "56550",
    "ville": "Locoal-Mendon",
    "dep": "Morbihan"
  },
  {
    "code": "56390",
    "ville": "Locqueltas",
    "dep": "Morbihan"
  },
  {
    "code": "56100",
    "ville": "Lorient",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Loyat",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Malansac",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Malestroit",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Malguénac",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Marzan",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Mauron",
    "dep": "Morbihan"
  },
  {
    "code": "56310",
    "ville": "Melrand",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "Ménéac",
    "dep": "Morbihan"
  },
  {
    "code": "56700",
    "ville": "Merlevenez",
    "dep": "Morbihan"
  },
  {
    "code": "56320",
    "ville": "Meslan",
    "dep": "Morbihan"
  },
  {
    "code": "56890",
    "ville": "Meucon",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Missiriac",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "Mohon",
    "dep": "Morbihan"
  },
  {
    "code": "56230",
    "ville": "Molac",
    "dep": "Morbihan"
  },
  {
    "code": "56380",
    "ville": "Monteneuf",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Monterblanc",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Montertelot",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Moréac",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Moustoir-Ac",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Muzillac",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Évellys",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Néant-sur-Yvel",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Neulliac",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Nivillac",
    "dep": "Morbihan"
  },
  {
    "code": "56690",
    "ville": "Nostang",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "Noyal-Muzillac",
    "dep": "Morbihan"
  },
  {
    "code": "56920",
    "ville": "Noyal-Pontivy",
    "dep": "Morbihan"
  },
  {
    "code": "56360",
    "ville": "Le Palais",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Péaule",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Peillac",
    "dep": "Morbihan"
  },
  {
    "code": "56760",
    "ville": "Pénestin",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Persquen",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Plaudren",
    "dep": "Morbihan"
  },
  {
    "code": "56890",
    "ville": "Plescop",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Pleucadeuc",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Pleugriffet",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Ploemel",
    "dep": "Morbihan"
  },
  {
    "code": "56270",
    "ville": "Ploemeur",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Ploërdut",
    "dep": "Morbihan"
  },
  {
    "code": "56880",
    "ville": "Ploeren",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Ploërmel",
    "dep": "Morbihan"
  },
  {
    "code": "56240",
    "ville": "Plouay",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Plougoumelen",
    "dep": "Morbihan"
  },
  {
    "code": "56340",
    "ville": "Plouharnel",
    "dep": "Morbihan"
  },
  {
    "code": "56680",
    "ville": "Plouhinec",
    "dep": "Morbihan"
  },
  {
    "code": "56770",
    "ville": "Plouray",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Pluherlin",
    "dep": "Morbihan"
  },
  {
    "code": "56420",
    "ville": "Plumelec",
    "dep": "Morbihan"
  },
  {
    "code": "56310",
    "ville": "Pluméliau-Bieuzy",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Plumelin",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Plumergat",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Pluneret",
    "dep": "Morbihan"
  },
  {
    "code": "56330",
    "ville": "Pluvigner",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Pontivy",
    "dep": "Morbihan"
  },
  {
    "code": "56620",
    "ville": "Pont-Scorff",
    "dep": "Morbihan"
  },
  {
    "code": "56380",
    "ville": "Porcaro",
    "dep": "Morbihan"
  },
  {
    "code": "56290",
    "ville": "Port-Louis",
    "dep": "Morbihan"
  },
  {
    "code": "56320",
    "ville": "Priziac",
    "dep": "Morbihan"
  },
  {
    "code": "56230",
    "ville": "Questembert",
    "dep": "Morbihan"
  },
  {
    "code": "56530",
    "ville": "Quéven",
    "dep": "Morbihan"
  },
  {
    "code": "56170",
    "ville": "Quiberon",
    "dep": "Morbihan"
  },
  {
    "code": "56310",
    "ville": "Quistinic",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Radenac",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Réguiny",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Réminiac",
    "dep": "Morbihan"
  },
  {
    "code": "56670",
    "ville": "Riantec",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Rieux",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "La Roche-Bernard",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Rochefort-en-Terre",
    "dep": "Morbihan"
  },
  {
    "code": "56460",
    "ville": "Val d'Oust",
    "dep": "Morbihan"
  },
  {
    "code": "56580",
    "ville": "Rohan",
    "dep": "Morbihan"
  },
  {
    "code": "56110",
    "ville": "Roudouallec",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Ruffiac",
    "dep": "Morbihan"
  },
  {
    "code": "56110",
    "ville": "Le Saint",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Saint-Abraham",
    "dep": "Morbihan"
  },
  {
    "code": "56480",
    "ville": "Saint-Aignan",
    "dep": "Morbihan"
  },
  {
    "code": "56500",
    "ville": "Saint-Allouestre",
    "dep": "Morbihan"
  },
  {
    "code": "56450",
    "ville": "Saint-Armel",
    "dep": "Morbihan"
  },
  {
    "code": "56890",
    "ville": "Saint-Avé",
    "dep": "Morbihan"
  },
  {
    "code": "56150",
    "ville": "Saint-Barthélemy",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Saint-Brieuc-de-Mauron",
    "dep": "Morbihan"
  },
  {
    "code": "56480",
    "ville": "Sainte-Brigitte",
    "dep": "Morbihan"
  },
  {
    "code": "56540",
    "ville": "Saint-Caradec-Trégomel",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Saint-Congard",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Saint-Dolay",
    "dep": "Morbihan"
  },
  {
    "code": "56920",
    "ville": "Saint-Gérand-Croixanvec",
    "dep": "Morbihan"
  },
  {
    "code": "56730",
    "ville": "Saint-Gildas-de-Rhuys",
    "dep": "Morbihan"
  },
  {
    "code": "56920",
    "ville": "Saint-Gonnery",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Saint-Gorgon",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Saint-Gravé",
    "dep": "Morbihan"
  },
  {
    "code": "56460",
    "ville": "Saint-Guyomard",
    "dep": "Morbihan"
  },
  {
    "code": "56700",
    "ville": "Sainte-Hélène",
    "dep": "Morbihan"
  },
  {
    "code": "56220",
    "ville": "Saint-Jacut-les-Pins",
    "dep": "Morbihan"
  },
  {
    "code": "56660",
    "ville": "Saint-Jean-Brévelay",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Saint-Jean-la-Poterie",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Saint-Laurent-sur-Oust",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Saint-Léry",
    "dep": "Morbihan"
  },
  {
    "code": "56380",
    "ville": "Saint-Malo-de-Beignon",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "Saint-Malo-des-Trois-Fontaines",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Saint-Marcel",
    "dep": "Morbihan"
  },
  {
    "code": "56200",
    "ville": "Saint-Martin-sur-Oust",
    "dep": "Morbihan"
  },
  {
    "code": "56910",
    "ville": "Saint-Nicolas-du-Tertre",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Saint-Nolff",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Saint-Perreux",
    "dep": "Morbihan"
  },
  {
    "code": "56470",
    "ville": "Saint-Philibert",
    "dep": "Morbihan"
  },
  {
    "code": "56510",
    "ville": "Saint-Pierre-Quiberon",
    "dep": "Morbihan"
  },
  {
    "code": "56120",
    "ville": "Saint-Servant",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Saint-Thuriau",
    "dep": "Morbihan"
  },
  {
    "code": "56540",
    "ville": "Saint-Tugdual",
    "dep": "Morbihan"
  },
  {
    "code": "56350",
    "ville": "Saint-Vincent-sur-Oust",
    "dep": "Morbihan"
  },
  {
    "code": "56370",
    "ville": "Sarzeau",
    "dep": "Morbihan"
  },
  {
    "code": "56360",
    "ville": "Sauzon",
    "dep": "Morbihan"
  },
  {
    "code": "56160",
    "ville": "Séglien",
    "dep": "Morbihan"
  },
  {
    "code": "56860",
    "ville": "Séné",
    "dep": "Morbihan"
  },
  {
    "code": "56460",
    "ville": "Sérent",
    "dep": "Morbihan"
  },
  {
    "code": "56480",
    "ville": "Silfiac",
    "dep": "Morbihan"
  },
  {
    "code": "56300",
    "ville": "Le Sourn",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Sulniac",
    "dep": "Morbihan"
  },
  {
    "code": "56450",
    "ville": "Surzur",
    "dep": "Morbihan"
  },
  {
    "code": "56800",
    "ville": "Taupont",
    "dep": "Morbihan"
  },
  {
    "code": "56130",
    "ville": "Théhillac",
    "dep": "Morbihan"
  },
  {
    "code": "56450",
    "ville": "Theix-Noyalo",
    "dep": "Morbihan"
  },
  {
    "code": "56370",
    "ville": "Le Tour-du-Parc",
    "dep": "Morbihan"
  },
  {
    "code": "56140",
    "ville": "Tréal",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Trédion",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "Treffléan",
    "dep": "Morbihan"
  },
  {
    "code": "56430",
    "ville": "Tréhorenteuc",
    "dep": "Morbihan"
  },
  {
    "code": "56490",
    "ville": "La Trinité-Porhoët",
    "dep": "Morbihan"
  },
  {
    "code": "56470",
    "ville": "La Trinité-sur-Mer",
    "dep": "Morbihan"
  },
  {
    "code": "56190",
    "ville": "La Trinité-Surzur",
    "dep": "Morbihan"
  },
  {
    "code": "56000",
    "ville": "Vannes",
    "dep": "Morbihan"
  },
  {
    "code": "56250",
    "ville": "La Vraie-Croix",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Le Bono",
    "dep": "Morbihan"
  },
  {
    "code": "56400",
    "ville": "Sainte-Anne-d'Auray",
    "dep": "Morbihan"
  },
  {
    "code": "56540",
    "ville": "Kernascléden",
    "dep": "Morbihan"
  },
  {
    "code": "57920",
    "ville": "Aboncourt",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Aboncourt-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Abreschviller",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Achain",
    "dep": "Moselle"
  },
  {
    "code": "57412",
    "ville": "Achen",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Adaincourt",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Adelange",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Ajoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Alaincourt-la-Côte",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Albestroff",
    "dep": "Moselle"
  },
  {
    "code": "57440",
    "ville": "Algrange",
    "dep": "Moselle"
  },
  {
    "code": "57515",
    "ville": "Alsting",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Altrippe",
    "dep": "Moselle"
  },
  {
    "code": "57730",
    "ville": "Altviller",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Alzing",
    "dep": "Moselle"
  },
  {
    "code": "57865",
    "ville": "Amanvillers",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Amelécourt",
    "dep": "Moselle"
  },
  {
    "code": "57360",
    "ville": "Amnéville",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Ancerville",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Ancy-Dornot",
    "dep": "Moselle"
  },
  {
    "code": "57440",
    "ville": "Angevillers",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Antilly",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Anzeling",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Apach",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Arraincourt",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Argancy",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Arriance",
    "dep": "Moselle"
  },
  {
    "code": "57680",
    "ville": "Arry",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Ars-Laquenexy",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Ars-sur-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57405",
    "ville": "Arzviller",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Aspach",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Assenoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Attilloncourt",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Aube",
    "dep": "Moselle"
  },
  {
    "code": "57390",
    "ville": "Audun-le-Tiche",
    "dep": "Moselle"
  },
  {
    "code": "57685",
    "ville": "Augny",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Aulnois-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57710",
    "ville": "Aumetz",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Avricourt",
    "dep": "Moselle"
  },
  {
    "code": "57300",
    "ville": "Ay-sur-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Azoudange",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Bacourt",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Baerenthal",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Bambiderstroff",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Bannay",
    "dep": "Moselle"
  },
  {
    "code": "57050",
    "ville": "Le Ban-Saint-Martin",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Barchain",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Baronville",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Barst",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Bassing",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Baudrecourt",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Bazoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Bébing",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Béchy",
    "dep": "Moselle"
  },
  {
    "code": "57460",
    "ville": "Behren-lès-Forbach",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Bellange",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Bénestroff",
    "dep": "Moselle"
  },
  {
    "code": "57800",
    "ville": "Béning-lès-Saint-Avold",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Berg-sur-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Bérig-Vintrange",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Berling",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Bermering",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Berthelming",
    "dep": "Moselle"
  },
  {
    "code": "57310",
    "ville": "Bertrange",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Berviller-en-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Bettange",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Bettborn",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Bettelainville",
    "dep": "Moselle"
  },
  {
    "code": "57800",
    "ville": "Betting",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Bettviller",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Beux",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Beyren-lès-Sierck",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Bezange-la-Petite",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Bibiche",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Bickenholtz",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Bidestroff",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Biding",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Bining",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Bioncourt",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Bionville-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Belles-Forêts",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Bisten-en-Lorraine",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Bistroff",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Bitche",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Blanche-Église",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Bliesbruck",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Blies-Ébersing",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Blies-Guersviller",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Boucheporn",
    "dep": "Moselle"
  },
  {
    "code": "57655",
    "ville": "Boulange",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Boulay-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Bourgaltroff",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Bourdonnay",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Bourscheid",
    "dep": "Moselle"
  },
  {
    "code": "57460",
    "ville": "Bousbach",
    "dep": "Moselle"
  },
  {
    "code": "57310",
    "ville": "Bousse",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Bousseviller",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Boust",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Boustroff",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Bouzonville",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Bréhain",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Breidenbach",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Breistroff-la-Grande",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Brettnach",
    "dep": "Moselle"
  },
  {
    "code": "57535",
    "ville": "Bronvaux",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Brouck",
    "dep": "Moselle"
  },
  {
    "code": "57565",
    "ville": "Brouderdorff",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Brouviller",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Brulange",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Buchy",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Buding",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Budling",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Buhl-Lorraine",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Burlioncourt",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Burtoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Cappel",
    "dep": "Moselle"
  },
  {
    "code": "57490",
    "ville": "Carling",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Cattenom",
    "dep": "Moselle"
  },
  {
    "code": "57365",
    "ville": "Chailly-lès-Ennery",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Chambrey",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Chanville",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Charleville-sous-Bois",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Charly-Oradour",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Château-Bréhain",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Château-Rouge",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Château-Salins",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Château-Voué",
    "dep": "Moselle"
  },
  {
    "code": "57160",
    "ville": "Châtel-Saint-Germain",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Chémery-les-Deux",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Cheminot",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Chenois",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Chérisey",
    "dep": "Moselle"
  },
  {
    "code": "57245",
    "ville": "Chesny",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Chicourt",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Chieulles",
    "dep": "Moselle"
  },
  {
    "code": "57185",
    "ville": "Clouange",
    "dep": "Moselle"
  },
  {
    "code": "57800",
    "ville": "Cocheren",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Coincy",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Coin-lès-Cuvry",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Coin-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Colligny-Maizery",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Colmen",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Condé-Northen",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Conthil",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Contz-les-Bains",
    "dep": "Moselle"
  },
  {
    "code": "57680",
    "ville": "Corny-sur-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Coume",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Courcelles-Chaussy",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Courcelles-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Craincourt",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Créhange",
    "dep": "Moselle"
  },
  {
    "code": "57150",
    "ville": "Creutzwald",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Cutting",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Cuvry",
    "dep": "Moselle"
  },
  {
    "code": "57850",
    "ville": "Dabo",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Dalem",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Dalhain",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Dalstein",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Danne-et-Quatre-Vents",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Dannelbourg",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Delme",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Denting",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Desseling",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Destry",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Diane-Capelle",
    "dep": "Moselle"
  },
  {
    "code": "57980",
    "ville": "Diebling",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Dieuze",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Diffembach-lès-Hellimer",
    "dep": "Moselle"
  },
  {
    "code": "57925",
    "ville": "Distroff",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Dolving",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Domnom-lès-Dieuze",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Donjeux",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Donnelay",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Ébersviller",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Éblange",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Éguelshardt",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Eincheville",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Elvange",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Elzange",
    "dep": "Moselle"
  },
  {
    "code": "57415",
    "ville": "Enchenberg",
    "dep": "Moselle"
  },
  {
    "code": "57365",
    "ville": "Ennery",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Entrange",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Epping",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Erching",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Ernestviller",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Erstroff",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Escherange",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Les Étangs",
    "dep": "Moselle"
  },
  {
    "code": "57412",
    "ville": "Etting",
    "dep": "Moselle"
  },
  {
    "code": "57460",
    "ville": "Etzling",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Évrange",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Failly",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Falck",
    "dep": "Moselle"
  },
  {
    "code": "57290",
    "ville": "Fameck",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Farébersviller",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Farschviller",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Faulquemont",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Fénétrange",
    "dep": "Moselle"
  },
  {
    "code": "57280",
    "ville": "Fèves",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Féy",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Filstroff",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Fixem",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Flastroff",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Fleisheim",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Flétrange",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Fleury",
    "dep": "Moselle"
  },
  {
    "code": "57365",
    "ville": "Flévy",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Flocourt",
    "dep": "Moselle"
  },
  {
    "code": "57190",
    "ville": "Florange",
    "dep": "Moselle"
  },
  {
    "code": "57600",
    "ville": "Folkling",
    "dep": "Moselle"
  },
  {
    "code": "57730",
    "ville": "Folschviller",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Fonteny",
    "dep": "Moselle"
  },
  {
    "code": "57650",
    "ville": "Fontoy",
    "dep": "Moselle"
  },
  {
    "code": "57600",
    "ville": "Forbach",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Fossieux",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Foulcrey",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Fouligny",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Foville",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Francaltroff",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Fraquelfing",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Frauenberg",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Freistroff",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Frémery",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Frémestroff",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Fresnes-en-Saulnois",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Freybouse",
    "dep": "Moselle"
  },
  {
    "code": "57800",
    "ville": "Freyming-Merlebach",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Fribourg",
    "dep": "Moselle"
  },
  {
    "code": "57175",
    "ville": "Gandrange",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Garrebourg",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Gavisse",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Gelucourt",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Gerbécourt",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Givrycourt",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Glatigny",
    "dep": "Moselle"
  },
  {
    "code": "57620",
    "ville": "Goetzenbruck",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Goin",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Gomelange",
    "dep": "Moselle"
  },
  {
    "code": "57815",
    "ville": "Gondrexange",
    "dep": "Moselle"
  },
  {
    "code": "57680",
    "ville": "Gorze",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Gosselming",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Gravelotte",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Grémecey",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Gréning",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Grindorff-Bizing",
    "dep": "Moselle"
  },
  {
    "code": "57520",
    "ville": "Grosbliederstroff",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Gros-Réderching",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Grostenquin",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Grundviller",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Guebenhouse",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Guébestroff",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Guéblange-lès-Dieuze",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Le Val-de-Guéblange",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Guébling",
    "dep": "Moselle"
  },
  {
    "code": "57310",
    "ville": "Guénange",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Val-de-Bride",
    "dep": "Moselle"
  },
  {
    "code": "57470",
    "ville": "Guenviller",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Guermange",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Guerstling",
    "dep": "Moselle"
  },
  {
    "code": "57880",
    "ville": "Guerting",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Guessling-Hémering",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Guinglange",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Guinkirchen",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Guinzeling",
    "dep": "Moselle"
  },
  {
    "code": "57405",
    "ville": "Guntzviller",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Haboudange",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Hagen",
    "dep": "Moselle"
  },
  {
    "code": "57300",
    "ville": "Hagondange",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Hallering",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Halstroff",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Basse-Ham",
    "dep": "Moselle"
  },
  {
    "code": "57880",
    "ville": "Ham-sous-Varsberg",
    "dep": "Moselle"
  },
  {
    "code": "57910",
    "ville": "Hambach",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Hampont",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Hangviller",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Hannocourt",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Han-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Hanviller",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Haraucourt-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Hargarten-aux-Mines",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Harprich",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Harreberg",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Hartzviller",
    "dep": "Moselle"
  },
  {
    "code": "57850",
    "ville": "Haselbourg",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Haspelschiedt",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Hattigny",
    "dep": "Moselle"
  },
  {
    "code": "57280",
    "ville": "Hauconcourt",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Haut-Clocher",
    "dep": "Moselle"
  },
  {
    "code": "57650",
    "ville": "Havange",
    "dep": "Moselle"
  },
  {
    "code": "57700",
    "ville": "Hayange",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Hayes",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Hazembourg",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Heining-lès-Bouzonville",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Hellering-lès-Fénétrange",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Hellimer",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Helstroff",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Hémilly",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Héming",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Henridorff",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Henriville",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Hérange",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Hermelange",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Herny",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Hertzing",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Hesse",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Hestroff",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Hettange-Grande",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Hilbesheim",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Hilsprich",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Hinckange",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Holacourt",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Holling",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Holving",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Hombourg-Budange",
    "dep": "Moselle"
  },
  {
    "code": "57470",
    "ville": "Hombourg-Haut",
    "dep": "Moselle"
  },
  {
    "code": "57405",
    "ville": "Hommarting",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Hommert",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Honskirch",
    "dep": "Moselle"
  },
  {
    "code": "57490",
    "ville": "L'Hôpital",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Hoste",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Hottviller",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Hultehouse",
    "dep": "Moselle"
  },
  {
    "code": "57990",
    "ville": "Hundling",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Hunting",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Ibigny",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Illange",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Imling",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Inglange",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Insming",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Insviller",
    "dep": "Moselle"
  },
  {
    "code": "57990",
    "ville": "Ippling",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Jallaucourt",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Jouy-aux-Arches",
    "dep": "Moselle"
  },
  {
    "code": "57245",
    "ville": "Jury",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Jussy",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Juvelize",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Juville",
    "dep": "Moselle"
  },
  {
    "code": "57412",
    "ville": "Kalhausen",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Kanfen",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Kappelkinger",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Kédange-sur-Canner",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Kemplich",
    "dep": "Moselle"
  },
  {
    "code": "57460",
    "ville": "Kerbach",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Kerling-lès-Sierck",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Kerprich-aux-Bois",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Kirsch-lès-Sierck",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Kirschnaumen",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Kirviller",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Klang",
    "dep": "Moselle"
  },
  {
    "code": "57240",
    "ville": "Knutange",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Kœnigsmacker",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Haute-Kontz",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Kuntzig",
    "dep": "Moselle"
  },
  {
    "code": "57730",
    "ville": "Lachambre",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Lafrimbolle",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Lagarde",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Lambach",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Landange",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Landroff",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Laneuveville-lès-Lorquin",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Laneuveville-en-Saulnois",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Langatte",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Languimberg",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Laning",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Laquenexy",
    "dep": "Moselle"
  },
  {
    "code": "57385",
    "ville": "Laudrefang",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Laumesfeld",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Launstroff",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Lelling",
    "dep": "Moselle"
  },
  {
    "code": "57620",
    "ville": "Lemberg",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Lemoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Lemud",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Lengelsheim",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Léning",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Lesse",
    "dep": "Moselle"
  },
  {
    "code": "57160",
    "ville": "Lessy",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Ley",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Leyviller",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Lezey",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Lidrezing",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Liederschiedt",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Liéhon",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Lindre-Basse",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Lindre-Haute",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Liocourt",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Lixheim",
    "dep": "Moselle"
  },
  {
    "code": "57520",
    "ville": "Lixing-lès-Rouhling",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Lixing-lès-Saint-Avold",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Lhor",
    "dep": "Moselle"
  },
  {
    "code": "57650",
    "ville": "Lommerange",
    "dep": "Moselle"
  },
  {
    "code": "57050",
    "ville": "Longeville-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57740",
    "ville": "Longeville-lès-Saint-Avold",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Lorquin",
    "dep": "Moselle"
  },
  {
    "code": "57050",
    "ville": "Lorry-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Lorry-Mardigny",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Lostroff",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Loudrefing",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Loupershouse",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Loutzviller",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Louvigny",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Lubécourt",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Lucy",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Luppy",
    "dep": "Moselle"
  },
  {
    "code": "57935",
    "ville": "Luttange",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Lutzelbourg",
    "dep": "Moselle"
  },
  {
    "code": "57730",
    "ville": "Macheren",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Mainvillers",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Maizeroy",
    "dep": "Moselle"
  },
  {
    "code": "57280",
    "ville": "Maizières-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Maizières-lès-Vic",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Malaucourt-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Malling",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Malroy",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Manderen-Ritzing",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Manhoué",
    "dep": "Moselle"
  },
  {
    "code": "57100",
    "ville": "Manom",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Many",
    "dep": "Moselle"
  },
  {
    "code": "57535",
    "ville": "Marange-Silvange",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Marange-Zondrange",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Marieulles",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Marimont-lès-Bénestroff",
    "dep": "Moselle"
  },
  {
    "code": "57155",
    "ville": "Marly",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Marsal",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Marsilly",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Marthille",
    "dep": "Moselle"
  },
  {
    "code": "57140",
    "ville": "La Maxe",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Maxstadt",
    "dep": "Moselle"
  },
  {
    "code": "57245",
    "ville": "Mécleuves",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Mégange",
    "dep": "Moselle"
  },
  {
    "code": "57960",
    "ville": "Meisenthal",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Menskirch",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Merschweiller",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Merten",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Métairies-Saint-Quirin",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Metting",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Metz",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Metzeresche",
    "dep": "Moselle"
  },
  {
    "code": "57940",
    "ville": "Metzervisse",
    "dep": "Moselle"
  },
  {
    "code": "57980",
    "ville": "Metzing",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Mey",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Mittelbronn",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Mittersheim",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Molring",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Momerstroff",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Moncheux",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Moncourt",
    "dep": "Moselle"
  },
  {
    "code": "57300",
    "ville": "Mondelange",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Mondorff",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Monneren",
    "dep": "Moselle"
  },
  {
    "code": "57415",
    "ville": "Montbronn",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Montdidier",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Montenach",
    "dep": "Moselle"
  },
  {
    "code": "57950",
    "ville": "Montigny-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57860",
    "ville": "Montois-la-Montagne",
    "dep": "Moselle"
  },
  {
    "code": "57645",
    "ville": "Ogy-Montoy-Flanville",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Morhange",
    "dep": "Moselle"
  },
  {
    "code": "57600",
    "ville": "Morsbach",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Morville-lès-Vic",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Morville-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57160",
    "ville": "Moulins-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57770",
    "ville": "Moussey",
    "dep": "Moselle"
  },
  {
    "code": "57620",
    "ville": "Mouterhouse",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Moyenvic",
    "dep": "Moselle"
  },
  {
    "code": "57250",
    "ville": "Moyeuvre-Grande",
    "dep": "Moselle"
  },
  {
    "code": "57250",
    "ville": "Moyeuvre-Petite",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Mulcey",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Munster",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Narbéfontaine",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Nébing",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Nelling",
    "dep": "Moselle"
  },
  {
    "code": "57700",
    "ville": "Neufchef",
    "dep": "Moselle"
  },
  {
    "code": "57910",
    "ville": "Neufgrange",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Neufmoulins",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Neufvillage",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Neunkirchen-lès-Bouzonville",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Niderhoff",
    "dep": "Moselle"
  },
  {
    "code": "57565",
    "ville": "Niderviller",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Niederstinzel",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Niedervisse",
    "dep": "Moselle"
  },
  {
    "code": "57240",
    "ville": "Nilvange",
    "dep": "Moselle"
  },
  {
    "code": "57790",
    "ville": "Nitting",
    "dep": "Moselle"
  },
  {
    "code": "57645",
    "ville": "Noisseville",
    "dep": "Moselle"
  },
  {
    "code": "57140",
    "ville": "Norroy-le-Veneur",
    "dep": "Moselle"
  },
  {
    "code": "57645",
    "ville": "Nouilly",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Nousseviller-lès-Bitche",
    "dep": "Moselle"
  },
  {
    "code": "57990",
    "ville": "Nousseviller-Saint-Nabor",
    "dep": "Moselle"
  },
  {
    "code": "57680",
    "ville": "Novéant-sur-Moselle",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Oberdorff",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Obergailbach",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Oberstinzel",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Obervisse",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Obreck",
    "dep": "Moselle"
  },
  {
    "code": "57600",
    "ville": "Œting",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Ommeray",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Oriocourt",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Ormersviller",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Orny",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Oron",
    "dep": "Moselle"
  },
  {
    "code": "57840",
    "ville": "Ottange",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Ottonville",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Oudrenne",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pagny-lès-Goin",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Pange",
    "dep": "Moselle"
  },
  {
    "code": "57245",
    "ville": "Peltre",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Petit-Réderching",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Petit-Tenquin",
    "dep": "Moselle"
  },
  {
    "code": "57540",
    "ville": "Petite-Rosselle",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Pettoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Pévange",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Phalsbourg",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Philippsbourg",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Piblange",
    "dep": "Moselle"
  },
  {
    "code": "57120",
    "ville": "Pierrevillers",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Plaine-de-Walsch",
    "dep": "Moselle"
  },
  {
    "code": "57050",
    "ville": "Plappeville",
    "dep": "Moselle"
  },
  {
    "code": "57140",
    "ville": "Plesnois",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pommérieux",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pontoy",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Pontpierre",
    "dep": "Moselle"
  },
  {
    "code": "57890",
    "ville": "Porcelette",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Postroff",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pouilly",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pournoy-la-Chétive",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Pournoy-la-Grasse",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Prévocourt",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Puttelange-aux-Lacs",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Puttelange-lès-Thionville",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Puttigny",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Puzieux",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Racrange",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Rahling",
    "dep": "Moselle"
  },
  {
    "code": "57700",
    "ville": "Ranguevaux",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Raville",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Réchicourt-le-Château",
    "dep": "Moselle"
  },
  {
    "code": "57390",
    "ville": "Rédange",
    "dep": "Moselle"
  },
  {
    "code": "57445",
    "ville": "Réding",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Rémelfang",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Rémelfing",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Rémeling",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Rémering",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Rémering-lès-Puttelange",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Rémilly",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Réning",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Basse-Rentgen",
    "dep": "Moselle"
  },
  {
    "code": "57645",
    "ville": "Retonfey",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Rettel",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Reyersviller",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Rezonville-Vionville",
    "dep": "Moselle"
  },
  {
    "code": "57810",
    "ville": "Rhodes",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Riche",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Richeling",
    "dep": "Moselle"
  },
  {
    "code": "57270",
    "ville": "Richemont",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Richeval",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Rimling",
    "dep": "Moselle"
  },
  {
    "code": "57840",
    "ville": "Rochonvillers",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Rodalbe",
    "dep": "Moselle"
  },
  {
    "code": "57570",
    "ville": "Rodemack",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Rohrbach-lès-Bitche",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Rolbing",
    "dep": "Moselle"
  },
  {
    "code": "57120",
    "ville": "Rombas",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Romelfing",
    "dep": "Moselle"
  },
  {
    "code": "57860",
    "ville": "Roncourt",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Roppeviller",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Rorbach-lès-Dieuze",
    "dep": "Moselle"
  },
  {
    "code": "57800",
    "ville": "Rosbruck",
    "dep": "Moselle"
  },
  {
    "code": "57780",
    "ville": "Rosselange",
    "dep": "Moselle"
  },
  {
    "code": "57520",
    "ville": "Rouhling",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Roupeldange",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Roussy-le-Village",
    "dep": "Moselle"
  },
  {
    "code": "57160",
    "ville": "Rozérieulles",
    "dep": "Moselle"
  },
  {
    "code": "57310",
    "ville": "Rurange-lès-Thionville",
    "dep": "Moselle"
  },
  {
    "code": "57390",
    "ville": "Russange",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Rustroff",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Sailly-Achâtel",
    "dep": "Moselle"
  },
  {
    "code": "57500",
    "ville": "Saint-Avold",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Sainte-Barbe",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Saint-Epvre",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Saint-François-Lacroix",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Saint-Georges",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Saint-Hubert",
    "dep": "Moselle"
  },
  {
    "code": "57930",
    "ville": "Saint-Jean-de-Bassel",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Saint-Jean-Kourtzerode",
    "dep": "Moselle"
  },
  {
    "code": "57510",
    "ville": "Saint-Jean-Rohrbach",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Saint-Julien-lès-Metz",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Saint-Jure",
    "dep": "Moselle"
  },
  {
    "code": "57820",
    "ville": "Saint-Louis",
    "dep": "Moselle"
  },
  {
    "code": "57620",
    "ville": "Saint-Louis-lès-Bitche",
    "dep": "Moselle"
  },
  {
    "code": "57255",
    "ville": "Sainte-Marie-aux-Chênes",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Saint-Médard",
    "dep": "Moselle"
  },
  {
    "code": "57855",
    "ville": "Saint-Privat-la-Montagne",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Saint-Quirin",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Sainte-Ruffine",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Salonnes",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Sanry-lès-Vigy",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Sanry-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Sarralbe",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Sarraltroff",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Sarrebourg",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Sarreguemines",
    "dep": "Moselle"
  },
  {
    "code": "57905",
    "ville": "Sarreinsming",
    "dep": "Moselle"
  },
  {
    "code": "57140",
    "ville": "Saulny",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Schalbach",
    "dep": "Moselle"
  },
  {
    "code": "57412",
    "ville": "Schmittviller",
    "dep": "Moselle"
  },
  {
    "code": "57400",
    "ville": "Schneckenbusch",
    "dep": "Moselle"
  },
  {
    "code": "57350",
    "ville": "Schœneck",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Schorbach",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Schwerdorff",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Schweyen",
    "dep": "Moselle"
  },
  {
    "code": "57160",
    "ville": "Scy-Chazelles",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Secourt",
    "dep": "Moselle"
  },
  {
    "code": "57455",
    "ville": "Seingbouse",
    "dep": "Moselle"
  },
  {
    "code": "57280",
    "ville": "Semécourt",
    "dep": "Moselle"
  },
  {
    "code": "57290",
    "ville": "Serémange-Erzange",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Servigny-lès-Raville",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Servigny-lès-Sainte-Barbe",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Sierck-les-Bains",
    "dep": "Moselle"
  },
  {
    "code": "57410",
    "ville": "Siersthal",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Sillegny",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Silly-en-Saulnois",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Silly-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Solgne",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Sorbey",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Sotzeling",
    "dep": "Moselle"
  },
  {
    "code": "57960",
    "ville": "Soucht",
    "dep": "Moselle"
  },
  {
    "code": "57350",
    "ville": "Spicheren",
    "dep": "Moselle"
  },
  {
    "code": "57350",
    "ville": "Stiring-Wendel",
    "dep": "Moselle"
  },
  {
    "code": "57230",
    "ville": "Sturzelbronn",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Suisse",
    "dep": "Moselle"
  },
  {
    "code": "57525",
    "ville": "Talange",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Tarquimpol",
    "dep": "Moselle"
  },
  {
    "code": "57980",
    "ville": "Tenteling",
    "dep": "Moselle"
  },
  {
    "code": "57180",
    "ville": "Terville",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Téterchen",
    "dep": "Moselle"
  },
  {
    "code": "57385",
    "ville": "Teting-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57450",
    "ville": "Théding",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Thicourt",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Thimonville",
    "dep": "Moselle"
  },
  {
    "code": "57100",
    "ville": "Thionville",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Thonville",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Tincry",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Torcheville",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Tragny",
    "dep": "Moselle"
  },
  {
    "code": "57300",
    "ville": "Trémery",
    "dep": "Moselle"
  },
  {
    "code": "57710",
    "ville": "Tressange",
    "dep": "Moselle"
  },
  {
    "code": "57385",
    "ville": "Tritteling-Redlach",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Troisfontaines",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Tromborn",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Turquestein-Blancrupt",
    "dep": "Moselle"
  },
  {
    "code": "57270",
    "ville": "Uckange",
    "dep": "Moselle"
  },
  {
    "code": "57660",
    "ville": "Vahl-Ebersing",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Vahl-lès-Bénestroff",
    "dep": "Moselle"
  },
  {
    "code": "57380",
    "ville": "Vahl-lès-Faulquemont",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Vallerange",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Valmestroff",
    "dep": "Moselle"
  },
  {
    "code": "57730",
    "ville": "Valmont",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Valmunster",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Vannecourt",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Vantoux",
    "dep": "Moselle"
  },
  {
    "code": "57070",
    "ville": "Vany",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Varize-Vaudoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57880",
    "ville": "Varsberg",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Vasperviller",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Vatimont",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Vaudreching",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Vaux",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Vaxy",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Veckersviller",
    "dep": "Moselle"
  },
  {
    "code": "57920",
    "ville": "Veckring",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Velving",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Vergaville",
    "dep": "Moselle"
  },
  {
    "code": "57130",
    "ville": "Vernéville",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Verny",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Vescheim",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Vibersviller",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Vic-sur-Seille",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Vieux-Lixheim",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Haute-Vigneulles",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Vigny",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Vigy",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Viller",
    "dep": "Moselle"
  },
  {
    "code": "57530",
    "ville": "Villers-Stoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Villers-sur-Nied",
    "dep": "Moselle"
  },
  {
    "code": "57550",
    "ville": "Villing",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Vilsberg",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Virming",
    "dep": "Moselle"
  },
  {
    "code": "57185",
    "ville": "Vitry-sur-Orne",
    "dep": "Moselle"
  },
  {
    "code": "57670",
    "ville": "Vittersbourg",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Vittoncourt",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Viviers",
    "dep": "Moselle"
  },
  {
    "code": "57580",
    "ville": "Voimhaut",
    "dep": "Moselle"
  },
  {
    "code": "57220",
    "ville": "Volmerange-lès-Boulay",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Volmerange-les-Mines",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Volmunster",
    "dep": "Moselle"
  },
  {
    "code": "57940",
    "ville": "Volstroff",
    "dep": "Moselle"
  },
  {
    "code": "57560",
    "ville": "Voyer",
    "dep": "Moselle"
  },
  {
    "code": "57640",
    "ville": "Vry",
    "dep": "Moselle"
  },
  {
    "code": "57420",
    "ville": "Vulmont",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Waldhouse",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Waldweistroff",
    "dep": "Moselle"
  },
  {
    "code": "57480",
    "ville": "Waldwisse",
    "dep": "Moselle"
  },
  {
    "code": "57720",
    "ville": "Walschbronn",
    "dep": "Moselle"
  },
  {
    "code": "57870",
    "ville": "Walscheid",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Waltembourg",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Wiesviller",
    "dep": "Moselle"
  },
  {
    "code": "57430",
    "ville": "Willerwald",
    "dep": "Moselle"
  },
  {
    "code": "57635",
    "ville": "Wintersbourg",
    "dep": "Moselle"
  },
  {
    "code": "57905",
    "ville": "Wittring",
    "dep": "Moselle"
  },
  {
    "code": "57320",
    "ville": "Vœlfling-lès-Bouzonville",
    "dep": "Moselle"
  },
  {
    "code": "57200",
    "ville": "Wœlfling-lès-Sarreguemines",
    "dep": "Moselle"
  },
  {
    "code": "57140",
    "ville": "Woippy",
    "dep": "Moselle"
  },
  {
    "code": "57915",
    "ville": "Woustviller",
    "dep": "Moselle"
  },
  {
    "code": "57170",
    "ville": "Wuisse",
    "dep": "Moselle"
  },
  {
    "code": "57630",
    "ville": "Xanrey",
    "dep": "Moselle"
  },
  {
    "code": "57590",
    "ville": "Xocourt",
    "dep": "Moselle"
  },
  {
    "code": "57830",
    "ville": "Xouaxange",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Yutz",
    "dep": "Moselle"
  },
  {
    "code": "57340",
    "ville": "Zarbeling",
    "dep": "Moselle"
  },
  {
    "code": "57905",
    "ville": "Zetting",
    "dep": "Moselle"
  },
  {
    "code": "57370",
    "ville": "Zilling",
    "dep": "Moselle"
  },
  {
    "code": "57690",
    "ville": "Zimming",
    "dep": "Moselle"
  },
  {
    "code": "57260",
    "ville": "Zommange",
    "dep": "Moselle"
  },
  {
    "code": "57330",
    "ville": "Zoufftgen",
    "dep": "Moselle"
  },
  {
    "code": "57890",
    "ville": "Diesen",
    "dep": "Moselle"
  },
  {
    "code": "57970",
    "ville": "Stuckange",
    "dep": "Moselle"
  },
  {
    "code": "58110",
    "ville": "Achun",
    "dep": "Nièvre"
  },
  {
    "code": "58200",
    "ville": "Alligny-Cosne",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Alligny-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Alluy",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Amazy",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Anlezy",
    "dep": "Nièvre"
  },
  {
    "code": "58450",
    "ville": "Annay",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Anthien",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Arbourse",
    "dep": "Nièvre"
  },
  {
    "code": "58430",
    "ville": "Arleuf",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Armes",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Arquian",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Arthel",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Arzembouy",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Asnan",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Asnois",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Aunay-en-Bazois",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Authiou",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Avrée",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Avril-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Azy-le-Vif",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Bazoches",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Bazolles",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Béard",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Beaulieu",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Beaumont-la-Ferrière",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Beaumont-Sardolles",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Beuvron",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Biches",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Billy-Chevannes",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Billy-sur-Oisy",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Bitry",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Blismes",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Bona",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Bouhy",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Brassy",
    "dep": "Nièvre"
  },
  {
    "code": "58460",
    "ville": "Breugnon",
    "dep": "Nièvre"
  },
  {
    "code": "58530",
    "ville": "Brèves",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Brinay",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Brinon-sur-Beuvron",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Bulcy",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Bussy-la-Pesle",
    "dep": "Nièvre"
  },
  {
    "code": "58440",
    "ville": "La Celle-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "La Celle-sur-Nièvre",
    "dep": "Nièvre"
  },
  {
    "code": "58340",
    "ville": "Cercy-la-Tour",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Cervon",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Cessy-les-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Chalaux",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Challement",
    "dep": "Nièvre"
  },
  {
    "code": "58000",
    "ville": "Challuy",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Champallement",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Champlemy",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Champlin",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Champvert",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Champvoux",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Chantenay-Saint-Imbert",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "La Chapelle-Saint-André",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "La Charité-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Charrin",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Chasnay",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Château-Chinon (Ville)",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Château-Chinon (Campagne)",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Châteauneuf-Val-de-Bargis",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Châtillon-en-Bazois",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Châtin",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Chaulgnes",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Chaumard",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Chaumot",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Chazeuil",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Chevannes-Changy",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Chevenon",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Chevroches",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Chiddes",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Chitry-les-Mines",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Chougny",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Ciez",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Cizely",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Clamecy",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "La Collancelle",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Colméry",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Corancy",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Corbigny",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Corvol-d'Embernard",
    "dep": "Nièvre"
  },
  {
    "code": "58460",
    "ville": "Corvol-l'Orgueilleux",
    "dep": "Nièvre"
  },
  {
    "code": "58200",
    "ville": "Cosne-Cours-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Cossaye",
    "dep": "Nièvre"
  },
  {
    "code": "58660",
    "ville": "Coulanges-lès-Nevers",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Couloutre",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Courcelles",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Crux-la-Ville",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Cuncy-lès-Varzy",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Dampierre-sous-Bouhy",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Decize",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Devay",
    "dep": "Nièvre"
  },
  {
    "code": "58340",
    "ville": "Diennes-Aubigny",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Dirol",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Dommartin",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Dompierre-sur-Nièvre",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Donzy",
    "dep": "Nièvre"
  },
  {
    "code": "58530",
    "ville": "Dornecy",
    "dep": "Nièvre"
  },
  {
    "code": "58390",
    "ville": "Dornes",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Druy-Parigny",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Dun-les-Places",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Dun-sur-Grandry",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Empury",
    "dep": "Nièvre"
  },
  {
    "code": "58410",
    "ville": "Entrains-sur-Nohain",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Epiry",
    "dep": "Nièvre"
  },
  {
    "code": "58430",
    "ville": "Fâchin",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "La Fermeté",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Fertrève",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Fléty",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Fleury-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Flez-Cuzy",
    "dep": "Nièvre"
  },
  {
    "code": "58600",
    "ville": "Fourchambault",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Fours",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Frasnay-Reugny",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Gâcogne",
    "dep": "Nièvre"
  },
  {
    "code": "58600",
    "ville": "Garchizy",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Garchy",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Germenay",
    "dep": "Nièvre"
  },
  {
    "code": "58320",
    "ville": "Germigny-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Gien-sur-Cure",
    "dep": "Nièvre"
  },
  {
    "code": "58470",
    "ville": "Gimouille",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Giry",
    "dep": "Nièvre"
  },
  {
    "code": "58370",
    "ville": "Glux-en-Glenne",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Gouloux",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Grenois",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Guérigny",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Guipy",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Héry",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Imphy",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Isenay",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Jailly",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Lamenay-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Langeron",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Lanty",
    "dep": "Nièvre"
  },
  {
    "code": "58370",
    "ville": "Larochemillay",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Lavault-de-Frétoy",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Limanton",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Limon",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Livry",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Lormes",
    "dep": "Nièvre"
  },
  {
    "code": "58380",
    "ville": "Lucenay-lès-Aix",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Lurcy-le-Bourg",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Luthenay-Uxeloup",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Luzy",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Lys",
    "dep": "Nièvre"
  },
  {
    "code": "58260",
    "ville": "La Machine",
    "dep": "Nièvre"
  },
  {
    "code": "58470",
    "ville": "Magny-Cours",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Magny-Lormes",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "La Maison-Dieu",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "La Marche",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Marcy",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Marigny-l'Église",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Mars-sur-Allier",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Marigny-sur-Yonne",
    "dep": "Nièvre"
  },
  {
    "code": "58180",
    "ville": "Marzy",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Maux",
    "dep": "Nièvre"
  },
  {
    "code": "58410",
    "ville": "Menestreau",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Menou",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Mesves-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Metz-le-Comte",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Mhère",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Millay",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Moissy-Moulinot",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Monceaux-le-Comte",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Montapas",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Montambert",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Montaron",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Montenoison",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Mont-et-Marré",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Montigny-aux-Amognes",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Montigny-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58340",
    "ville": "Montigny-sur-Canne",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Montreuillon",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Montsauche-les-Settons",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Moraches",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Moulins-Engilbert",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Mouron-sur-Yonne",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Moussy",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Moux-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Murlin",
    "dep": "Nièvre"
  },
  {
    "code": "58440",
    "ville": "Myennes",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Nannay",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Narcy",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Neuffontaines",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Neuilly",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Neuville-lès-Decize",
    "dep": "Nièvre"
  },
  {
    "code": "58450",
    "ville": "Neuvy-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58000",
    "ville": "Nevers",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "La Nocle-Maulaix",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Nolay",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Nuars",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Oisy",
    "dep": "Nièvre"
  },
  {
    "code": "58370",
    "ville": "Onlay",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Ouagne",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Oudan",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Ougny",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Oulon",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Vaux d'Amognes",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Ouroux-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Parigny-la-Rose",
    "dep": "Nièvre"
  },
  {
    "code": "58320",
    "ville": "Parigny-les-Vaux",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Pazy",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Perroy",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Planchez",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Poil",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Poiseux",
    "dep": "Nièvre"
  },
  {
    "code": "58200",
    "ville": "Pougny",
    "dep": "Nièvre"
  },
  {
    "code": "58320",
    "ville": "Pougues-les-Eaux",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Pouilly-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Pouques-Lormes",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Pousseaux",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Prémery",
    "dep": "Nièvre"
  },
  {
    "code": "58360",
    "ville": "Préporché",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Raveau",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Rémilly",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Rix",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Rouy",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Ruages",
    "dep": "Nièvre"
  },
  {
    "code": "58470",
    "ville": "Saincaize-Meauce",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Saint-Agnan",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Saint-Amand-en-Puisaye",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Saint-Andelain",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Saint-André-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Saint-Aubin-des-Chaumes",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Saint-Aubin-les-Forges",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Saint-Benin-d'Azy",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Saint-Benin-des-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Saint-Bonnot",
    "dep": "Nièvre"
  },
  {
    "code": "58230",
    "ville": "Saint-Brisson",
    "dep": "Nièvre"
  },
  {
    "code": "58220",
    "ville": "Sainte-Colombe-des-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Saint-Didier",
    "dep": "Nièvre"
  },
  {
    "code": "58000",
    "ville": "Saint-Éloi",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Saint-Firmin",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Saint-Franchy",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Saint-Germain-Chassenay",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Saint-Germain-des-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58340",
    "ville": "Saint-Gratien-Savigny",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Saint-Hilaire-en-Morvan",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Saint-Hilaire-Fontaine",
    "dep": "Nièvre"
  },
  {
    "code": "58360",
    "ville": "Saint-Honoré-les-Bains",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Saint-Jean-aux-Amognes",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Saint-Laurent-l'Abbaye",
    "dep": "Nièvre"
  },
  {
    "code": "58120",
    "ville": "Saint-Léger-de-Fougeret",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Saint-Léger-des-Vignes",
    "dep": "Nièvre"
  },
  {
    "code": "58200",
    "ville": "Saint-Loup-des-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58350",
    "ville": "Saint-Malo-en-Donziois",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Sainte-Marie",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Saint-Martin-d'Heuille",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Saint-Martin-du-Puy",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Saint-Martin-sur-Nohain",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Saint-Maurice",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Saint-Ouen-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Saint-Parize-en-Viry",
    "dep": "Nièvre"
  },
  {
    "code": "58490",
    "ville": "Saint-Parize-le-Châtel",
    "dep": "Nièvre"
  },
  {
    "code": "58200",
    "ville": "Saint-Père",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Saint-Péreuse",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Saint-Pierre-du-Mont",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Saint-Pierre-le-Moûtier",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Saint-Quentin-sur-Nohain",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Saint-Révérien",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Saint-Saulge",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Saint-Seine",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Saint-Sulpice",
    "dep": "Nièvre"
  },
  {
    "code": "58310",
    "ville": "Saint-Vérain",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Saizy",
    "dep": "Nièvre"
  },
  {
    "code": "58800",
    "ville": "Sardy-lès-Épiry",
    "dep": "Nièvre"
  },
  {
    "code": "58160",
    "ville": "Sauvigny-les-Bois",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Savigny-Poil-Fol",
    "dep": "Nièvre"
  },
  {
    "code": "58330",
    "ville": "Saxi-Bourdon",
    "dep": "Nièvre"
  },
  {
    "code": "58360",
    "ville": "Sémelay",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Sermages",
    "dep": "Nièvre"
  },
  {
    "code": "58000",
    "ville": "Sermoise-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58700",
    "ville": "Sichamps",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Sougy-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Suilly-la-Tour",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Surgy",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Taconnay",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Talon",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Tamnay-en-Bazois",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Tannay",
    "dep": "Nièvre"
  },
  {
    "code": "58170",
    "ville": "Tazilly",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Teigny",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Ternant",
    "dep": "Nièvre"
  },
  {
    "code": "58250",
    "ville": "Thaix",
    "dep": "Nièvre"
  },
  {
    "code": "58260",
    "ville": "Thianges",
    "dep": "Nièvre"
  },
  {
    "code": "58110",
    "ville": "Tintury",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Toury-Lurcy",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Toury-sur-Jour",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Tracy-sur-Loire",
    "dep": "Nièvre"
  },
  {
    "code": "58240",
    "ville": "Tresnay",
    "dep": "Nièvre"
  },
  {
    "code": "58260",
    "ville": "Trois-Vèvres",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Tronsanges",
    "dep": "Nièvre"
  },
  {
    "code": "58460",
    "ville": "Trucy-l'Orgueilleux",
    "dep": "Nièvre"
  },
  {
    "code": "58130",
    "ville": "Urzy",
    "dep": "Nièvre"
  },
  {
    "code": "58290",
    "ville": "Vandenesse",
    "dep": "Nièvre"
  },
  {
    "code": "58400",
    "ville": "Varennes-lès-Narcy",
    "dep": "Nièvre"
  },
  {
    "code": "58640",
    "ville": "Varennes-Vauzelles",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Varzy",
    "dep": "Nièvre"
  },
  {
    "code": "58140",
    "ville": "Vauclaix",
    "dep": "Nièvre"
  },
  {
    "code": "58300",
    "ville": "Verneuil",
    "dep": "Nièvre"
  },
  {
    "code": "58150",
    "ville": "Vielmanay",
    "dep": "Nièvre"
  },
  {
    "code": "58190",
    "ville": "Vignol",
    "dep": "Nièvre"
  },
  {
    "code": "58370",
    "ville": "Villapourçon",
    "dep": "Nièvre"
  },
  {
    "code": "58210",
    "ville": "Villiers-le-Sec",
    "dep": "Nièvre"
  },
  {
    "code": "58270",
    "ville": "Ville-Langy",
    "dep": "Nièvre"
  },
  {
    "code": "58500",
    "ville": "Villiers-sur-Yonne",
    "dep": "Nièvre"
  },
  {
    "code": "58420",
    "ville": "Vitry-Laché",
    "dep": "Nièvre"
  },
  {
    "code": "59268",
    "ville": "Abancourt",
    "dep": "Nord"
  },
  {
    "code": "59215",
    "ville": "Abscon",
    "dep": "Nord"
  },
  {
    "code": "59149",
    "ville": "Aibes",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Aix-en-Pévèle",
    "dep": "Nord"
  },
  {
    "code": "59251",
    "ville": "Allennes-les-Marais",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Amfroipret",
    "dep": "Nord"
  },
  {
    "code": "59194",
    "ville": "Anhiers",
    "dep": "Nord"
  },
  {
    "code": "59580",
    "ville": "Aniche",
    "dep": "Nord"
  },
  {
    "code": "59650",
    "ville": "Villeneuve-d'Ascq",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Anneux",
    "dep": "Nord"
  },
  {
    "code": "59112",
    "ville": "Annœullin",
    "dep": "Nord"
  },
  {
    "code": "59186",
    "ville": "Anor",
    "dep": "Nord"
  },
  {
    "code": "59152",
    "ville": "Anstaing",
    "dep": "Nord"
  },
  {
    "code": "59410",
    "ville": "Anzin",
    "dep": "Nord"
  },
  {
    "code": "59151",
    "ville": "Arleux",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Armbouts-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59280",
    "ville": "Armentières",
    "dep": "Nord"
  },
  {
    "code": "59285",
    "ville": "Arnèke",
    "dep": "Nord"
  },
  {
    "code": "59269",
    "ville": "Artres",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Assevent",
    "dep": "Nord"
  },
  {
    "code": "59551",
    "ville": "Attiches",
    "dep": "Nord"
  },
  {
    "code": "59265",
    "ville": "Aubencheul-au-Bac",
    "dep": "Nord"
  },
  {
    "code": "59165",
    "ville": "Auberchicourt",
    "dep": "Nord"
  },
  {
    "code": "59249",
    "ville": "Aubers",
    "dep": "Nord"
  },
  {
    "code": "59265",
    "ville": "Aubigny-au-Bac",
    "dep": "Nord"
  },
  {
    "code": "59494",
    "ville": "Aubry-du-Hainaut",
    "dep": "Nord"
  },
  {
    "code": "59950",
    "ville": "Auby",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Auchy-lez-Orchies",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Audignies",
    "dep": "Nord"
  },
  {
    "code": "59300",
    "ville": "Aulnoy-lez-Valenciennes",
    "dep": "Nord"
  },
  {
    "code": "59620",
    "ville": "Aulnoye-Aymeries",
    "dep": "Nord"
  },
  {
    "code": "59710",
    "ville": "Avelin",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Avesnelles",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Avesnes-sur-Helpe",
    "dep": "Nord"
  },
  {
    "code": "59129",
    "ville": "Avesnes-les-Aubert",
    "dep": "Nord"
  },
  {
    "code": "59296",
    "ville": "Avesnes-le-Sec",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Awoingt",
    "dep": "Nord"
  },
  {
    "code": "59138",
    "ville": "Bachant",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Bachy",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Bailleul",
    "dep": "Nord"
  },
  {
    "code": "59780",
    "ville": "Baisieux",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Baives",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Bambecque",
    "dep": "Nord"
  },
  {
    "code": "59266",
    "ville": "Banteux",
    "dep": "Nord"
  },
  {
    "code": "59554",
    "ville": "Bantigny",
    "dep": "Nord"
  },
  {
    "code": "59266",
    "ville": "Bantouzelle",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Bas-Lieu",
    "dep": "Nord"
  },
  {
    "code": "59480",
    "ville": "La Bassée",
    "dep": "Nord"
  },
  {
    "code": "59221",
    "ville": "Bauvin",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Bavay",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Bavinchove",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Bazuel",
    "dep": "Nord"
  },
  {
    "code": "59134",
    "ville": "Beaucamps-Ligny",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Beaudignies",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Beaufort",
    "dep": "Nord"
  },
  {
    "code": "59540",
    "ville": "Beaumont-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Beaurain",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Beaurepaire-sur-Sambre",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Beaurieux",
    "dep": "Nord"
  },
  {
    "code": "59157",
    "ville": "Beauvois-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59135",
    "ville": "Bellaing",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Bellignies",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Bérelles",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Bergues",
    "dep": "Nord"
  },
  {
    "code": "59145",
    "ville": "Berlaimont",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Bermerain",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Bermeries",
    "dep": "Nord"
  },
  {
    "code": "59235",
    "ville": "Bersée",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Bersillies",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Berthen",
    "dep": "Nord"
  },
  {
    "code": "59980",
    "ville": "Bertry",
    "dep": "Nord"
  },
  {
    "code": "59540",
    "ville": "Béthencourt",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Bettignies",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Bettrechies",
    "dep": "Nord"
  },
  {
    "code": "59216",
    "ville": "Beugnies",
    "dep": "Nord"
  },
  {
    "code": "59192",
    "ville": "Beuvrages",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Beuvry-la-Forêt",
    "dep": "Nord"
  },
  {
    "code": "59217",
    "ville": "Bévillers",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Bierne",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Bissezeele",
    "dep": "Nord"
  },
  {
    "code": "59173",
    "ville": "Blaringhem",
    "dep": "Nord"
  },
  {
    "code": "59268",
    "ville": "Blécourt",
    "dep": "Nord"
  },
  {
    "code": "59299",
    "ville": "Boeschepe",
    "dep": "Nord"
  },
  {
    "code": "59189",
    "ville": "Boëseghem",
    "dep": "Nord"
  },
  {
    "code": "59280",
    "ville": "Bois-Grenier",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Bollezeele",
    "dep": "Nord"
  },
  {
    "code": "59910",
    "ville": "Bondues",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Borre",
    "dep": "Nord"
  },
  {
    "code": "59111",
    "ville": "Bouchain",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Boulogne-sur-Helpe",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Bourbourg",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Bourghelles",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Boursies",
    "dep": "Nord"
  },
  {
    "code": "59166",
    "ville": "Bousbecque",
    "dep": "Nord"
  },
  {
    "code": "59222",
    "ville": "Bousies",
    "dep": "Nord"
  },
  {
    "code": "59178",
    "ville": "Bousignies",
    "dep": "Nord"
  },
  {
    "code": "59149",
    "ville": "Bousignies-sur-Roc",
    "dep": "Nord"
  },
  {
    "code": "59217",
    "ville": "Boussières-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Boussières-sur-Sambre",
    "dep": "Nord"
  },
  {
    "code": "59168",
    "ville": "Boussois",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Bouvignies",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Bouvines",
    "dep": "Nord"
  },
  {
    "code": "59123",
    "ville": "Bray-Dunes",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Briastre",
    "dep": "Nord"
  },
  {
    "code": "59178",
    "ville": "Brillon",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Brouckerque",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Broxeele",
    "dep": "Nord"
  },
  {
    "code": "59860",
    "ville": "Bruay-sur-l'Escaut",
    "dep": "Nord"
  },
  {
    "code": "59490",
    "ville": "Bruille-lez-Marchiennes",
    "dep": "Nord"
  },
  {
    "code": "59199",
    "ville": "Bruille-Saint-Amand",
    "dep": "Nord"
  },
  {
    "code": "59151",
    "ville": "Brunémont",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Bry",
    "dep": "Nord"
  },
  {
    "code": "59151",
    "ville": "Bugnicourt",
    "dep": "Nord"
  },
  {
    "code": "59137",
    "ville": "Busigny",
    "dep": "Nord"
  },
  {
    "code": "59285",
    "ville": "Buysscheure",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Caëstre",
    "dep": "Nord"
  },
  {
    "code": "59161",
    "ville": "Cagnoncles",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Cambrai",
    "dep": "Nord"
  },
  {
    "code": "59133",
    "ville": "Camphin-en-Carembault",
    "dep": "Nord"
  },
  {
    "code": "59780",
    "ville": "Camphin-en-Pévèle",
    "dep": "Nord"
  },
  {
    "code": "59267",
    "ville": "Cantaing-sur-Escaut",
    "dep": "Nord"
  },
  {
    "code": "59169",
    "ville": "Cantin",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Capelle",
    "dep": "Nord"
  },
  {
    "code": "59160",
    "ville": "Capinghem",
    "dep": "Nord"
  },
  {
    "code": "59242",
    "ville": "Cappelle-en-Pévèle",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Cappelle-Brouck",
    "dep": "Nord"
  },
  {
    "code": "59180",
    "ville": "Cappelle-la-Grande",
    "dep": "Nord"
  },
  {
    "code": "59217",
    "ville": "Carnières",
    "dep": "Nord"
  },
  {
    "code": "59112",
    "ville": "Carnin",
    "dep": "Nord"
  },
  {
    "code": "59244",
    "ville": "Cartignies",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Cassel",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Le Cateau-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Catillon-sur-Sambre",
    "dep": "Nord"
  },
  {
    "code": "59217",
    "ville": "Cattenières",
    "dep": "Nord"
  },
  {
    "code": "59540",
    "ville": "Caudry",
    "dep": "Nord"
  },
  {
    "code": "59191",
    "ville": "Caullery",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Cauroir",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Cerfontaine",
    "dep": "Nord"
  },
  {
    "code": "59930",
    "ville": "La Chapelle-d'Armentières",
    "dep": "Nord"
  },
  {
    "code": "59230",
    "ville": "Château-l'Abbaye",
    "dep": "Nord"
  },
  {
    "code": "59147",
    "ville": "Chemy",
    "dep": "Nord"
  },
  {
    "code": "59152",
    "ville": "Chéreng",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Choisies",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Clairfayts",
    "dep": "Nord"
  },
  {
    "code": "59225",
    "ville": "Clary",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Cobrieux",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Colleret",
    "dep": "Nord"
  },
  {
    "code": "59560",
    "ville": "Comines",
    "dep": "Nord"
  },
  {
    "code": "59163",
    "ville": "Condé-sur-l'Escaut",
    "dep": "Nord"
  },
  {
    "code": "59210",
    "ville": "Coudekerque-Branche",
    "dep": "Nord"
  },
  {
    "code": "59552",
    "ville": "Courchelettes",
    "dep": "Nord"
  },
  {
    "code": "59149",
    "ville": "Cousolre",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Coutiches",
    "dep": "Nord"
  },
  {
    "code": "59279",
    "ville": "Craywick",
    "dep": "Nord"
  },
  {
    "code": "59154",
    "ville": "Crespin",
    "dep": "Nord"
  },
  {
    "code": "59258",
    "ville": "Crèvecœur-sur-l'Escaut",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Crochte",
    "dep": "Nord"
  },
  {
    "code": "59170",
    "ville": "Croix",
    "dep": "Nord"
  },
  {
    "code": "59222",
    "ville": "Croix-Caluyau",
    "dep": "Nord"
  },
  {
    "code": "59553",
    "ville": "Cuincy",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Curgies",
    "dep": "Nord"
  },
  {
    "code": "59268",
    "ville": "Cuvillers",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Cysoing",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Damousies",
    "dep": "Nord"
  },
  {
    "code": "59187",
    "ville": "Dechy",
    "dep": "Nord"
  },
  {
    "code": "59127",
    "ville": "Dehéries",
    "dep": "Nord"
  },
  {
    "code": "59220",
    "ville": "Denain",
    "dep": "Nord"
  },
  {
    "code": "59890",
    "ville": "Deûlémont",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Dimechaux",
    "dep": "Nord"
  },
  {
    "code": "59216",
    "ville": "Dimont",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Doignies",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Dompierre-sur-Helpe",
    "dep": "Nord"
  },
  {
    "code": "59500",
    "ville": "Douai",
    "dep": "Nord"
  },
  {
    "code": "59282",
    "ville": "Douchy-les-Mines",
    "dep": "Nord"
  },
  {
    "code": "59940",
    "ville": "Le Doulieu",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Dourlers",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Drincham",
    "dep": "Nord"
  },
  {
    "code": "59140",
    "ville": "Dunkerque",
    "dep": "Nord"
  },
  {
    "code": "59173",
    "ville": "Ebblinghem",
    "dep": "Nord"
  },
  {
    "code": "59176",
    "ville": "Écaillon",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Eccles",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Éclaibes",
    "dep": "Nord"
  },
  {
    "code": "59620",
    "ville": "Écuélin",
    "dep": "Nord"
  },
  {
    "code": "59114",
    "ville": "Eecke",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Élesmes",
    "dep": "Nord"
  },
  {
    "code": "59127",
    "ville": "Élincourt",
    "dep": "Nord"
  },
  {
    "code": "59580",
    "ville": "Émerchicourt",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Emmerin",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Englefontaine",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Englos",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Ennetières-en-Weppes",
    "dep": "Nord"
  },
  {
    "code": "59710",
    "ville": "Ennevelin",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Eppe-Sauvage",
    "dep": "Nord"
  },
  {
    "code": "59169",
    "ville": "Erchin",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Eringhem",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Erquinghem-le-Sec",
    "dep": "Nord"
  },
  {
    "code": "59193",
    "ville": "Erquinghem-Lys",
    "dep": "Nord"
  },
  {
    "code": "59171",
    "ville": "Erre",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Escarmain",
    "dep": "Nord"
  },
  {
    "code": "59124",
    "ville": "Escaudain",
    "dep": "Nord"
  },
  {
    "code": "59161",
    "ville": "Escaudœuvres",
    "dep": "Nord"
  },
  {
    "code": "59278",
    "ville": "Escautpont",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Escobecques",
    "dep": "Nord"
  },
  {
    "code": "59127",
    "ville": "Esnes",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Esquelbecq",
    "dep": "Nord"
  },
  {
    "code": "59553",
    "ville": "Esquerchin",
    "dep": "Nord"
  },
  {
    "code": "59940",
    "ville": "Estaires",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Estourmel",
    "dep": "Nord"
  },
  {
    "code": "59151",
    "ville": "Estrées",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Estreux",
    "dep": "Nord"
  },
  {
    "code": "59161",
    "ville": "Eswars",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Eth",
    "dep": "Nord"
  },
  {
    "code": "59219",
    "ville": "Étrœungt",
    "dep": "Nord"
  },
  {
    "code": "59295",
    "ville": "Estrun",
    "dep": "Nord"
  },
  {
    "code": "59155",
    "ville": "Faches-Thumesnil",
    "dep": "Nord"
  },
  {
    "code": "59300",
    "ville": "Famars",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Faumont",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Le Favril",
    "dep": "Nord"
  },
  {
    "code": "59247",
    "ville": "Féchain",
    "dep": "Nord"
  },
  {
    "code": "59750",
    "ville": "Feignies",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Felleries",
    "dep": "Nord"
  },
  {
    "code": "59179",
    "ville": "Fenain",
    "dep": "Nord"
  },
  {
    "code": "59169",
    "ville": "Férin",
    "dep": "Nord"
  },
  {
    "code": "59610",
    "ville": "Féron",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Ferrière-la-Grande",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Ferrière-la-Petite",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "La Flamengrie",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Flaumont-Waudrechies",
    "dep": "Nord"
  },
  {
    "code": "59128",
    "ville": "Flers-en-Escrebieux",
    "dep": "Nord"
  },
  {
    "code": "59267",
    "ville": "Flesquières",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Flêtre",
    "dep": "Nord"
  },
  {
    "code": "59158",
    "ville": "Flines-lès-Mortagne",
    "dep": "Nord"
  },
  {
    "code": "59148",
    "ville": "Flines-lez-Raches",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Floursies",
    "dep": "Nord"
  },
  {
    "code": "59219",
    "ville": "Floyon",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Fontaine-au-Bois",
    "dep": "Nord"
  },
  {
    "code": "59157",
    "ville": "Fontaine-au-Pire",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Fontaine-Notre-Dame",
    "dep": "Nord"
  },
  {
    "code": "59222",
    "ville": "Forest-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59510",
    "ville": "Forest-sur-Marque",
    "dep": "Nord"
  },
  {
    "code": "59610",
    "ville": "Fourmies",
    "dep": "Nord"
  },
  {
    "code": "59134",
    "ville": "Fournes-en-Weppes",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Frasnoy",
    "dep": "Nord"
  },
  {
    "code": "59236",
    "ville": "Frelinghien",
    "dep": "Nord"
  },
  {
    "code": "59970",
    "ville": "Fresnes-sur-Escaut",
    "dep": "Nord"
  },
  {
    "code": "59234",
    "ville": "Fressain",
    "dep": "Nord"
  },
  {
    "code": "59268",
    "ville": "Fressies",
    "dep": "Nord"
  },
  {
    "code": "59273",
    "ville": "Fretin",
    "dep": "Nord"
  },
  {
    "code": "59249",
    "ville": "Fromelles",
    "dep": "Nord"
  },
  {
    "code": "59242",
    "ville": "Genech",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Ghissignies",
    "dep": "Nord"
  },
  {
    "code": "59122",
    "ville": "Ghyvelde",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Glageon",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Godewaersvelde",
    "dep": "Nord"
  },
  {
    "code": "59169",
    "ville": "Gœulzin",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Gognies-Chaussée",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Gommegnies",
    "dep": "Nord"
  },
  {
    "code": "59147",
    "ville": "Gondecourt",
    "dep": "Nord"
  },
  {
    "code": "59231",
    "ville": "Gonnelieu",
    "dep": "Nord"
  },
  {
    "code": "59253",
    "ville": "La Gorgue",
    "dep": "Nord"
  },
  {
    "code": "59231",
    "ville": "Gouzeaucourt",
    "dep": "Nord"
  },
  {
    "code": "59244",
    "ville": "Grand-Fayt",
    "dep": "Nord"
  },
  {
    "code": "59760",
    "ville": "Grande-Synthe",
    "dep": "Nord"
  },
  {
    "code": "59153",
    "ville": "Grand-Fort-Philippe",
    "dep": "Nord"
  },
  {
    "code": "59820",
    "ville": "Gravelines",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "La Groise",
    "dep": "Nord"
  },
  {
    "code": "59152",
    "ville": "Gruson",
    "dep": "Nord"
  },
  {
    "code": "59287",
    "ville": "Guesnain",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Gussignies",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Hallennes-lez-Haubourdin",
    "dep": "Nord"
  },
  {
    "code": "59250",
    "ville": "Halluin",
    "dep": "Nord"
  },
  {
    "code": "59151",
    "ville": "Hamel",
    "dep": "Nord"
  },
  {
    "code": "59496",
    "ville": "Hantay",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Hardifort",
    "dep": "Nord"
  },
  {
    "code": "59138",
    "ville": "Hargnies",
    "dep": "Nord"
  },
  {
    "code": "59178",
    "ville": "Hasnon",
    "dep": "Nord"
  },
  {
    "code": "59198",
    "ville": "Haspres",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Haubourdin",
    "dep": "Nord"
  },
  {
    "code": "59191",
    "ville": "Haucourt-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59121",
    "ville": "Haulchin",
    "dep": "Nord"
  },
  {
    "code": "59294",
    "ville": "Haussy",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Haut-Lieu",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Hautmont",
    "dep": "Nord"
  },
  {
    "code": "59255",
    "ville": "Haveluy",
    "dep": "Nord"
  },
  {
    "code": "59660",
    "ville": "Haverskerque",
    "dep": "Nord"
  },
  {
    "code": "59268",
    "ville": "Haynecourt",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Hazebrouck",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Hecq",
    "dep": "Nord"
  },
  {
    "code": "59171",
    "ville": "Hélesmes",
    "dep": "Nord"
  },
  {
    "code": "59510",
    "ville": "Hem",
    "dep": "Nord"
  },
  {
    "code": "59247",
    "ville": "Hem-Lenglet",
    "dep": "Nord"
  },
  {
    "code": "59199",
    "ville": "Hergnies",
    "dep": "Nord"
  },
  {
    "code": "59195",
    "ville": "Hérin",
    "dep": "Nord"
  },
  {
    "code": "59134",
    "ville": "Herlies",
    "dep": "Nord"
  },
  {
    "code": "59147",
    "ville": "Herrin",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Herzeele",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Hestrud",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Holque",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Hondeghem",
    "dep": "Nord"
  },
  {
    "code": "59122",
    "ville": "Hondschoote",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Hon-Hergies",
    "dep": "Nord"
  },
  {
    "code": "59980",
    "ville": "Honnechy",
    "dep": "Nord"
  },
  {
    "code": "59266",
    "ville": "Honnecourt-sur-Escaut",
    "dep": "Nord"
  },
  {
    "code": "59111",
    "ville": "Hordain",
    "dep": "Nord"
  },
  {
    "code": "59171",
    "ville": "Hornaing",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Houdain-lez-Bavay",
    "dep": "Nord"
  },
  {
    "code": "59263",
    "ville": "Houplin-Ancoisne",
    "dep": "Nord"
  },
  {
    "code": "59116",
    "ville": "Houplines",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Houtkerque",
    "dep": "Nord"
  },
  {
    "code": "59492",
    "ville": "Hoymille",
    "dep": "Nord"
  },
  {
    "code": "59480",
    "ville": "Illies",
    "dep": "Nord"
  },
  {
    "code": "59540",
    "ville": "Inchy",
    "dep": "Nord"
  },
  {
    "code": "59141",
    "ville": "Iwuy",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Jenlain",
    "dep": "Nord"
  },
  {
    "code": "59460",
    "ville": "Jeumont",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Jolimetz",
    "dep": "Nord"
  },
  {
    "code": "59122",
    "ville": "Killem",
    "dep": "Nord"
  },
  {
    "code": "59167",
    "ville": "Lallaing",
    "dep": "Nord"
  },
  {
    "code": "59130",
    "ville": "Lambersart",
    "dep": "Nord"
  },
  {
    "code": "59552",
    "ville": "Lambres-lez-Douai",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Landas",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Landrecies",
    "dep": "Nord"
  },
  {
    "code": "59390",
    "ville": "Lannoy",
    "dep": "Nord"
  },
  {
    "code": "59219",
    "ville": "Larouillies",
    "dep": "Nord"
  },
  {
    "code": "59553",
    "ville": "Lauwin-Planque",
    "dep": "Nord"
  },
  {
    "code": "59226",
    "ville": "Lecelles",
    "dep": "Nord"
  },
  {
    "code": "59259",
    "ville": "Lécluse",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Lederzeele",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Ledringhem",
    "dep": "Nord"
  },
  {
    "code": "59115",
    "ville": "Leers",
    "dep": "Nord"
  },
  {
    "code": "59495",
    "ville": "Leffrinckoucke",
    "dep": "Nord"
  },
  {
    "code": "59258",
    "ville": "Lesdain",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Lez-Fontaine",
    "dep": "Nord"
  },
  {
    "code": "59810",
    "ville": "Lesquin",
    "dep": "Nord"
  },
  {
    "code": "59620",
    "ville": "Leval",
    "dep": "Nord"
  },
  {
    "code": "59287",
    "ville": "Lewarde",
    "dep": "Nord"
  },
  {
    "code": "59260",
    "ville": "Lezennes",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Liessies",
    "dep": "Nord"
  },
  {
    "code": "59111",
    "ville": "Lieu-Saint-Amand",
    "dep": "Nord"
  },
  {
    "code": "59191",
    "ville": "Ligny-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59260",
    "ville": "Lille",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Limont-Fontaine",
    "dep": "Nord"
  },
  {
    "code": "59126",
    "ville": "Linselles",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Locquignol",
    "dep": "Nord"
  },
  {
    "code": "59182",
    "ville": "Loffre",
    "dep": "Nord"
  },
  {
    "code": "59840",
    "ville": "Lompret",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "La Longueville",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Looberghe",
    "dep": "Nord"
  },
  {
    "code": "59279",
    "ville": "Loon-Plage",
    "dep": "Nord"
  },
  {
    "code": "59120",
    "ville": "Loos",
    "dep": "Nord"
  },
  {
    "code": "59156",
    "ville": "Lourches",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Louvignies-Quesnoy",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Louvil",
    "dep": "Nord"
  },
  {
    "code": "59720",
    "ville": "Louvroil",
    "dep": "Nord"
  },
  {
    "code": "59173",
    "ville": "Lynde",
    "dep": "Nord"
  },
  {
    "code": "59390",
    "ville": "Lys-lez-Lannoy",
    "dep": "Nord"
  },
  {
    "code": "59110",
    "ville": "La Madeleine",
    "dep": "Nord"
  },
  {
    "code": "59233",
    "ville": "Maing",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Mairieux",
    "dep": "Nord"
  },
  {
    "code": "59134",
    "ville": "Le Maisnil",
    "dep": "Nord"
  },
  {
    "code": "59127",
    "ville": "Malincourt",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Marbaix",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Marchiennes",
    "dep": "Nord"
  },
  {
    "code": "59159",
    "ville": "Marcoing",
    "dep": "Nord"
  },
  {
    "code": "59700",
    "ville": "Marcq-en-Barœul",
    "dep": "Nord"
  },
  {
    "code": "59252",
    "ville": "Marcq-en-Ostrevent",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Maresches",
    "dep": "Nord"
  },
  {
    "code": "59238",
    "ville": "Maretz",
    "dep": "Nord"
  },
  {
    "code": "59770",
    "ville": "Marly",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Maroilles",
    "dep": "Nord"
  },
  {
    "code": "59164",
    "ville": "Marpent",
    "dep": "Nord"
  },
  {
    "code": "59520",
    "ville": "Marquette-lez-Lille",
    "dep": "Nord"
  },
  {
    "code": "59252",
    "ville": "Marquette-en-Ostrevant",
    "dep": "Nord"
  },
  {
    "code": "59274",
    "ville": "Marquillies",
    "dep": "Nord"
  },
  {
    "code": "59241",
    "ville": "Masnières",
    "dep": "Nord"
  },
  {
    "code": "59176",
    "ville": "Masny",
    "dep": "Nord"
  },
  {
    "code": "59172",
    "ville": "Mastaing",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Maubeuge",
    "dep": "Nord"
  },
  {
    "code": "59158",
    "ville": "Maulde",
    "dep": "Nord"
  },
  {
    "code": "59980",
    "ville": "Maurois",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Mazinghien",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Mecquignies",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Merckeghem",
    "dep": "Nord"
  },
  {
    "code": "59710",
    "ville": "Mérignies",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Merris",
    "dep": "Nord"
  },
  {
    "code": "59660",
    "ville": "Merville",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Méteren",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Millam",
    "dep": "Nord"
  },
  {
    "code": "59178",
    "ville": "Millonfosse",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Mœuvres",
    "dep": "Nord"
  },
  {
    "code": "59620",
    "ville": "Monceau-Saint-Waast",
    "dep": "Nord"
  },
  {
    "code": "59224",
    "ville": "Monchaux-sur-Écaillon",
    "dep": "Nord"
  },
  {
    "code": "59283",
    "ville": "Moncheaux",
    "dep": "Nord"
  },
  {
    "code": "59234",
    "ville": "Monchecourt",
    "dep": "Nord"
  },
  {
    "code": "59370",
    "ville": "Mons-en-Barœul",
    "dep": "Nord"
  },
  {
    "code": "59246",
    "ville": "Mons-en-Pévèle",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Montay",
    "dep": "Nord"
  },
  {
    "code": "59225",
    "ville": "Montigny-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59182",
    "ville": "Montigny-en-Ostrevent",
    "dep": "Nord"
  },
  {
    "code": "59227",
    "ville": "Montrécourt",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Morbecque",
    "dep": "Nord"
  },
  {
    "code": "59158",
    "ville": "Mortagne-du-Nord",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Mouchin",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Moustier-en-Fagne",
    "dep": "Nord"
  },
  {
    "code": "59420",
    "ville": "Mouvaux",
    "dep": "Nord"
  },
  {
    "code": "59161",
    "ville": "Naves",
    "dep": "Nord"
  },
  {
    "code": "59940",
    "ville": "Neuf-Berquin",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Neuf-Mesnil",
    "dep": "Nord"
  },
  {
    "code": "59218",
    "ville": "Neuville-en-Avesnois",
    "dep": "Nord"
  },
  {
    "code": "59960",
    "ville": "Neuville-en-Ferrain",
    "dep": "Nord"
  },
  {
    "code": "59239",
    "ville": "La Neuville",
    "dep": "Nord"
  },
  {
    "code": "59554",
    "ville": "Neuville-Saint-Rémy",
    "dep": "Nord"
  },
  {
    "code": "59293",
    "ville": "Neuville-sur-Escaut",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Neuvilly",
    "dep": "Nord"
  },
  {
    "code": "59850",
    "ville": "Nieppe",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Niergnies",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Nieurlet",
    "dep": "Nord"
  },
  {
    "code": "59230",
    "ville": "Nivelle",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Nomain",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Noordpeene",
    "dep": "Nord"
  },
  {
    "code": "59139",
    "ville": "Noyelles-lès-Seclin",
    "dep": "Nord"
  },
  {
    "code": "59159",
    "ville": "Noyelles-sur-Escaut",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Noyelles-sur-Sambre",
    "dep": "Nord"
  },
  {
    "code": "59282",
    "ville": "Noyelles-sur-Selle",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Obies",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Obrechies",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Ochtezeele",
    "dep": "Nord"
  },
  {
    "code": "59970",
    "ville": "Odomez",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Ohain",
    "dep": "Nord"
  },
  {
    "code": "59195",
    "ville": "Oisy",
    "dep": "Nord"
  },
  {
    "code": "59264",
    "ville": "Onnaing",
    "dep": "Nord"
  },
  {
    "code": "59122",
    "ville": "Oost-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Orchies",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Ors",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Orsinval",
    "dep": "Nord"
  },
  {
    "code": "59162",
    "ville": "Ostricourt",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Oudezeele",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Oxelaëre",
    "dep": "Nord"
  },
  {
    "code": "59295",
    "ville": "Paillencourt",
    "dep": "Nord"
  },
  {
    "code": "59146",
    "ville": "Pecquencourt",
    "dep": "Nord"
  },
  {
    "code": "59840",
    "ville": "Pérenchies",
    "dep": "Nord"
  },
  {
    "code": "59273",
    "ville": "Péronne-en-Mélantois",
    "dep": "Nord"
  },
  {
    "code": "59494",
    "ville": "Petite-Forêt",
    "dep": "Nord"
  },
  {
    "code": "59244",
    "ville": "Petit-Fayt",
    "dep": "Nord"
  },
  {
    "code": "59133",
    "ville": "Phalempin",
    "dep": "Nord"
  },
  {
    "code": "59284",
    "ville": "Pitgam",
    "dep": "Nord"
  },
  {
    "code": "59218",
    "ville": "Poix-du-Nord",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Pommereuil",
    "dep": "Nord"
  },
  {
    "code": "59710",
    "ville": "Pont-à-Marcq",
    "dep": "Nord"
  },
  {
    "code": "59138",
    "ville": "Pont-sur-Sambre",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Potelle",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Pradelles",
    "dep": "Nord"
  },
  {
    "code": "59840",
    "ville": "Prémesques",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Préseau",
    "dep": "Nord"
  },
  {
    "code": "59288",
    "ville": "Preux-au-Bois",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Preux-au-Sart",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Prisches",
    "dep": "Nord"
  },
  {
    "code": "59121",
    "ville": "Prouvy",
    "dep": "Nord"
  },
  {
    "code": "59267",
    "ville": "Proville",
    "dep": "Nord"
  },
  {
    "code": "59185",
    "ville": "Provin",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Quaëdypre",
    "dep": "Nord"
  },
  {
    "code": "59243",
    "ville": "Quarouble",
    "dep": "Nord"
  },
  {
    "code": "59269",
    "ville": "Quérénaing",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Le Quesnoy",
    "dep": "Nord"
  },
  {
    "code": "59890",
    "ville": "Quesnoy-sur-Deûle",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Quiévelon",
    "dep": "Nord"
  },
  {
    "code": "59920",
    "ville": "Quiévrechain",
    "dep": "Nord"
  },
  {
    "code": "59214",
    "ville": "Quiévy",
    "dep": "Nord"
  },
  {
    "code": "59194",
    "ville": "Râches",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Radinghem-en-Weppes",
    "dep": "Nord"
  },
  {
    "code": "59554",
    "ville": "Raillencourt-Sainte-Olle",
    "dep": "Nord"
  },
  {
    "code": "59283",
    "ville": "Raimbeaucourt",
    "dep": "Nord"
  },
  {
    "code": "59177",
    "ville": "Rainsars",
    "dep": "Nord"
  },
  {
    "code": "59590",
    "ville": "Raismes",
    "dep": "Nord"
  },
  {
    "code": "59161",
    "ville": "Ramillies",
    "dep": "Nord"
  },
  {
    "code": "59177",
    "ville": "Ramousies",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Raucourt-au-Bois",
    "dep": "Nord"
  },
  {
    "code": "59245",
    "ville": "Recquignies",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Rejet-de-Beaulieu",
    "dep": "Nord"
  },
  {
    "code": "59173",
    "ville": "Renescure",
    "dep": "Nord"
  },
  {
    "code": "59980",
    "ville": "Reumont",
    "dep": "Nord"
  },
  {
    "code": "59122",
    "ville": "Rexpoëde",
    "dep": "Nord"
  },
  {
    "code": "59159",
    "ville": "Ribécourt-la-Tour",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Rieulay",
    "dep": "Nord"
  },
  {
    "code": "59277",
    "ville": "Rieux-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Robersart",
    "dep": "Nord"
  },
  {
    "code": "59172",
    "ville": "Rœulx",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Rombies-et-Marchipont",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Romeries",
    "dep": "Nord"
  },
  {
    "code": "59790",
    "ville": "Ronchin",
    "dep": "Nord"
  },
  {
    "code": "59223",
    "ville": "Roncq",
    "dep": "Nord"
  },
  {
    "code": "59286",
    "ville": "Roost-Warendin",
    "dep": "Nord"
  },
  {
    "code": "59230",
    "ville": "Rosult",
    "dep": "Nord"
  },
  {
    "code": "59100",
    "ville": "Roubaix",
    "dep": "Nord"
  },
  {
    "code": "59169",
    "ville": "Roucourt",
    "dep": "Nord"
  },
  {
    "code": "59131",
    "ville": "Rousies",
    "dep": "Nord"
  },
  {
    "code": "59220",
    "ville": "Rouvignies",
    "dep": "Nord"
  },
  {
    "code": "59285",
    "ville": "Rubrouck",
    "dep": "Nord"
  },
  {
    "code": "59258",
    "ville": "Les Rues-des-Vignes",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Ruesnes",
    "dep": "Nord"
  },
  {
    "code": "59226",
    "ville": "Rumegies",
    "dep": "Nord"
  },
  {
    "code": "59281",
    "ville": "Rumilly-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59554",
    "ville": "Sailly-lez-Cambrai",
    "dep": "Nord"
  },
  {
    "code": "59390",
    "ville": "Sailly-lez-Lannoy",
    "dep": "Nord"
  },
  {
    "code": "59262",
    "ville": "Sainghin-en-Mélantois",
    "dep": "Nord"
  },
  {
    "code": "59184",
    "ville": "Sainghin-en-Weppes",
    "dep": "Nord"
  },
  {
    "code": "59177",
    "ville": "Sains-du-Nord",
    "dep": "Nord"
  },
  {
    "code": "59230",
    "ville": "Saint-Amand-les-Eaux",
    "dep": "Nord"
  },
  {
    "code": "59350",
    "ville": "Saint-André-lez-Lille",
    "dep": "Nord"
  },
  {
    "code": "59188",
    "ville": "Saint-Aubert",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Saint-Aubin",
    "dep": "Nord"
  },
  {
    "code": "59163",
    "ville": "Saint-Aybert",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Saint-Benin",
    "dep": "Nord"
  },
  {
    "code": "59820",
    "ville": "Saint-Georges-sur-l'Aa",
    "dep": "Nord"
  },
  {
    "code": "59292",
    "ville": "Saint-Hilaire-lez-Cambrai",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Saint-Hilaire-sur-Helpe",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Saint-Jans-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Sainte-Marie-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Saint-Martin-sur-Écaillon",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Saint-Momelin",
    "dep": "Nord"
  },
  {
    "code": "59630",
    "ville": "Saint-Pierre-Brouck",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Saint-Python",
    "dep": "Nord"
  },
  {
    "code": "59620",
    "ville": "Saint-Remy-Chaussée",
    "dep": "Nord"
  },
  {
    "code": "59330",
    "ville": "Saint-Remy-du-Nord",
    "dep": "Nord"
  },
  {
    "code": "59880",
    "ville": "Saint-Saulve",
    "dep": "Nord"
  },
  {
    "code": "59360",
    "ville": "Saint-Souplet",
    "dep": "Nord"
  },
  {
    "code": "59114",
    "ville": "Saint-Sylvestre-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59188",
    "ville": "Saint-Vaast-en-Cambrésis",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Saint-Waast",
    "dep": "Nord"
  },
  {
    "code": "59218",
    "ville": "Salesches",
    "dep": "Nord"
  },
  {
    "code": "59496",
    "ville": "Salomé",
    "dep": "Nord"
  },
  {
    "code": "59310",
    "ville": "Saméon",
    "dep": "Nord"
  },
  {
    "code": "59268",
    "ville": "Sancourt",
    "dep": "Nord"
  },
  {
    "code": "59211",
    "ville": "Santes",
    "dep": "Nord"
  },
  {
    "code": "59230",
    "ville": "Sars-et-Rosières",
    "dep": "Nord"
  },
  {
    "code": "59216",
    "ville": "Sars-Poteries",
    "dep": "Nord"
  },
  {
    "code": "59145",
    "ville": "Sassegnies",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Saultain",
    "dep": "Nord"
  },
  {
    "code": "59227",
    "ville": "Saulzoir",
    "dep": "Nord"
  },
  {
    "code": "59990",
    "ville": "Sebourg",
    "dep": "Nord"
  },
  {
    "code": "59113",
    "ville": "Seclin",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Sémeries",
    "dep": "Nord"
  },
  {
    "code": "59440",
    "ville": "Semousies",
    "dep": "Nord"
  },
  {
    "code": "59174",
    "ville": "La Sentinelle",
    "dep": "Nord"
  },
  {
    "code": "59269",
    "ville": "Sepmeries",
    "dep": "Nord"
  },
  {
    "code": "59320",
    "ville": "Sequedin",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Séranvillers-Forenville",
    "dep": "Nord"
  },
  {
    "code": "59173",
    "ville": "Sercus",
    "dep": "Nord"
  },
  {
    "code": "59450",
    "ville": "Sin-le-Noble",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Socx",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Solesmes",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Solre-le-Château",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Solrinnes",
    "dep": "Nord"
  },
  {
    "code": "59490",
    "ville": "Somain",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Sommaing",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Spycker",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Staple",
    "dep": "Nord"
  },
  {
    "code": "59189",
    "ville": "Steenbecque",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Steene",
    "dep": "Nord"
  },
  {
    "code": "59114",
    "ville": "Steenvoorde",
    "dep": "Nord"
  },
  {
    "code": "59181",
    "ville": "Steenwerck",
    "dep": "Nord"
  },
  {
    "code": "59270",
    "ville": "Strazeele",
    "dep": "Nord"
  },
  {
    "code": "59550",
    "ville": "Taisnières-en-Thiérache",
    "dep": "Nord"
  },
  {
    "code": "59570",
    "ville": "Taisnières-sur-Hon",
    "dep": "Nord"
  },
  {
    "code": "59175",
    "ville": "Templemars",
    "dep": "Nord"
  },
  {
    "code": "59242",
    "ville": "Templeuve-en-Pévèle",
    "dep": "Nord"
  },
  {
    "code": "59114",
    "ville": "Terdeghem",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Téteghem-Coudekerque-Village",
    "dep": "Nord"
  },
  {
    "code": "59224",
    "ville": "Thiant",
    "dep": "Nord"
  },
  {
    "code": "59189",
    "ville": "Thiennes",
    "dep": "Nord"
  },
  {
    "code": "59163",
    "ville": "Thivencelle",
    "dep": "Nord"
  },
  {
    "code": "59239",
    "ville": "Thumeries",
    "dep": "Nord"
  },
  {
    "code": "59141",
    "ville": "Thun-l'Évêque",
    "dep": "Nord"
  },
  {
    "code": "59158",
    "ville": "Thun-Saint-Amand",
    "dep": "Nord"
  },
  {
    "code": "59141",
    "ville": "Thun-Saint-Martin",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Tilloy-lez-Marchiennes",
    "dep": "Nord"
  },
  {
    "code": "59554",
    "ville": "Tilloy-lez-Cambrai",
    "dep": "Nord"
  },
  {
    "code": "59390",
    "ville": "Toufflers",
    "dep": "Nord"
  },
  {
    "code": "59200",
    "ville": "Tourcoing",
    "dep": "Nord"
  },
  {
    "code": "59551",
    "ville": "Tourmignies",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Trélon",
    "dep": "Nord"
  },
  {
    "code": "59152",
    "ville": "Tressin",
    "dep": "Nord"
  },
  {
    "code": "59125",
    "ville": "Trith-Saint-Léger",
    "dep": "Nord"
  },
  {
    "code": "59980",
    "ville": "Troisvilles",
    "dep": "Nord"
  },
  {
    "code": "59229",
    "ville": "Uxem",
    "dep": "Nord"
  },
  {
    "code": "59300",
    "ville": "Valenciennes",
    "dep": "Nord"
  },
  {
    "code": "59218",
    "ville": "Vendegies-au-Bois",
    "dep": "Nord"
  },
  {
    "code": "59213",
    "ville": "Vendegies-sur-Écaillon",
    "dep": "Nord"
  },
  {
    "code": "59175",
    "ville": "Vendeville",
    "dep": "Nord"
  },
  {
    "code": "59227",
    "ville": "Verchain-Maugré",
    "dep": "Nord"
  },
  {
    "code": "59237",
    "ville": "Verlinghem",
    "dep": "Nord"
  },
  {
    "code": "59730",
    "ville": "Vertain",
    "dep": "Nord"
  },
  {
    "code": "59970",
    "ville": "Vicq",
    "dep": "Nord"
  },
  {
    "code": "59271",
    "ville": "Viesly",
    "dep": "Nord"
  },
  {
    "code": "59232",
    "ville": "Vieux-Berquin",
    "dep": "Nord"
  },
  {
    "code": "59690",
    "ville": "Vieux-Condé",
    "dep": "Nord"
  },
  {
    "code": "59138",
    "ville": "Vieux-Mesnil",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Vieux-Reng",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Villereau",
    "dep": "Nord"
  },
  {
    "code": "59234",
    "ville": "Villers-au-Tertre",
    "dep": "Nord"
  },
  {
    "code": "59188",
    "ville": "Villers-en-Cauchies",
    "dep": "Nord"
  },
  {
    "code": "59297",
    "ville": "Villers-Guislain",
    "dep": "Nord"
  },
  {
    "code": "59142",
    "ville": "Villers-Outréaux",
    "dep": "Nord"
  },
  {
    "code": "59231",
    "ville": "Villers-Plouich",
    "dep": "Nord"
  },
  {
    "code": "59530",
    "ville": "Villers-Pol",
    "dep": "Nord"
  },
  {
    "code": "59600",
    "ville": "Villers-Sire-Nicole",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Volckerinckhove",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Vred",
    "dep": "Nord"
  },
  {
    "code": "59261",
    "ville": "Wahagnies",
    "dep": "Nord"
  },
  {
    "code": "59127",
    "ville": "Walincourt-Selvigny",
    "dep": "Nord"
  },
  {
    "code": "59135",
    "ville": "Wallers",
    "dep": "Nord"
  },
  {
    "code": "59132",
    "ville": "Wallers-en-Fagne",
    "dep": "Nord"
  },
  {
    "code": "59190",
    "ville": "Wallon-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59400",
    "ville": "Wambaix",
    "dep": "Nord"
  },
  {
    "code": "59118",
    "ville": "Wambrechies",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Wandignies-Hamage",
    "dep": "Nord"
  },
  {
    "code": "59830",
    "ville": "Wannehain",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Wargnies-le-Grand",
    "dep": "Nord"
  },
  {
    "code": "59144",
    "ville": "Wargnies-le-Petit",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Warhem",
    "dep": "Nord"
  },
  {
    "code": "59870",
    "ville": "Warlaing",
    "dep": "Nord"
  },
  {
    "code": "59560",
    "ville": "Warneton",
    "dep": "Nord"
  },
  {
    "code": "59252",
    "ville": "Wasnes-au-Bac",
    "dep": "Nord"
  },
  {
    "code": "59290",
    "ville": "Wasquehal",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Watten",
    "dep": "Nord"
  },
  {
    "code": "59139",
    "ville": "Wattignies",
    "dep": "Nord"
  },
  {
    "code": "59680",
    "ville": "Wattignies-la-Victoire",
    "dep": "Nord"
  },
  {
    "code": "59150",
    "ville": "Wattrelos",
    "dep": "Nord"
  },
  {
    "code": "59220",
    "ville": "Wavrechain-sous-Denain",
    "dep": "Nord"
  },
  {
    "code": "59111",
    "ville": "Wavrechain-sous-Faulx",
    "dep": "Nord"
  },
  {
    "code": "59136",
    "ville": "Wavrin",
    "dep": "Nord"
  },
  {
    "code": "59119",
    "ville": "Waziers",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Wemaers-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59117",
    "ville": "Wervicq-Sud",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "West-Cappel",
    "dep": "Nord"
  },
  {
    "code": "59134",
    "ville": "Wicres",
    "dep": "Nord"
  },
  {
    "code": "59212",
    "ville": "Wignehies",
    "dep": "Nord"
  },
  {
    "code": "59780",
    "ville": "Willems",
    "dep": "Nord"
  },
  {
    "code": "59740",
    "ville": "Willies",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Winnezeele",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Wormhout",
    "dep": "Nord"
  },
  {
    "code": "59143",
    "ville": "Wulverdinghe",
    "dep": "Nord"
  },
  {
    "code": "59380",
    "ville": "Wylder",
    "dep": "Nord"
  },
  {
    "code": "59470",
    "ville": "Zegerscappel",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Zermezeele",
    "dep": "Nord"
  },
  {
    "code": "59123",
    "ville": "Zuydcoote",
    "dep": "Nord"
  },
  {
    "code": "59670",
    "ville": "Zuytpeene",
    "dep": "Nord"
  },
  {
    "code": "59272",
    "ville": "Don",
    "dep": "Nord"
  },
  {
    "code": "60220",
    "ville": "Abancourt",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Abbecourt",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Abbeville-Saint-Lucien",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Achy",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Acy-en-Multien",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Les Ageux",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Agnetz",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Airion",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Allonne",
    "dep": "Oise"
  },
  {
    "code": "60110",
    "ville": "Amblainville",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Amy",
    "dep": "Oise"
  },
  {
    "code": "60570",
    "ville": "Andeville",
    "dep": "Oise"
  },
  {
    "code": "60940",
    "ville": "Angicourt",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Angivillers",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Angy",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Ansacq",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Ansauvillers",
    "dep": "Oise"
  },
  {
    "code": "60162",
    "ville": "Antheuil-Portes",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Antilly",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Appilly",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Apremont",
    "dep": "Oise"
  },
  {
    "code": "60880",
    "ville": "Armancourt",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Arsy",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Attichy",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Auchy-la-Montagne",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Auger-Saint-Vincent",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Aumont-en-Halatte",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Auneuil",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Auteuil",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Autheuil-en-Valois",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Autrêches",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Avilly-Saint-Léonard",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Avrechy",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Avricourt",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Avrigny",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Babœuf",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Bacouël",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Bailleul-le-Soc",
    "dep": "Oise"
  },
  {
    "code": "60930",
    "ville": "Bailleul-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Bailleval",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Bailly",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Balagny-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Barbery",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Bargny",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Baron",
    "dep": "Oise"
  },
  {
    "code": "60113",
    "ville": "Baugy",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Bazancourt",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Bazicourt",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Beaudéduit",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Beaugies-sous-Bois",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Beaulieu-les-Fontaines",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Beaumont-les-Nonains",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Beaurains-lès-Noyon",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Beaurepaire",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Beauvais",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Beauvoir",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Béhéricourt",
    "dep": "Oise"
  },
  {
    "code": "60540",
    "ville": "Belle-Église",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Belloy",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Berlancourt",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Berneuil-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Berneuil-sur-Aisne",
    "dep": "Oise"
  },
  {
    "code": "60370",
    "ville": "Berthecourt",
    "dep": "Oise"
  },
  {
    "code": "60129",
    "ville": "Béthancourt-en-Valois",
    "dep": "Oise"
  },
  {
    "code": "60320",
    "ville": "Béthisy-Saint-Martin",
    "dep": "Oise"
  },
  {
    "code": "60320",
    "ville": "Béthisy-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Betz",
    "dep": "Oise"
  },
  {
    "code": "60280",
    "ville": "Bienville",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Biermont",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Bitry",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Blacourt",
    "dep": "Oise"
  },
  {
    "code": "60460",
    "ville": "Blaincourt-lès-Précy",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Blancfossé",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Blargies",
    "dep": "Oise"
  },
  {
    "code": "60860",
    "ville": "Blicourt",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Blincourt",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Boissy-Fresnoy",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Bonlier",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Bonneuil-les-Eaux",
    "dep": "Oise"
  },
  {
    "code": "60123",
    "ville": "Bonneuil-en-Valois",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Bonnières",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Bonvillers",
    "dep": "Oise"
  },
  {
    "code": "60820",
    "ville": "Boran-sur-Oise",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Borest",
    "dep": "Oise"
  },
  {
    "code": "60540",
    "ville": "Bornel",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Boubiers",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Bouconvillers",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Bouillancy",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Boullarre",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Boulogne-la-Grasse",
    "dep": "Oise"
  },
  {
    "code": "60141",
    "ville": "Boursonne",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Boury-en-Vexin",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Boutencourt",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Bouvresse",
    "dep": "Oise"
  },
  {
    "code": "60113",
    "ville": "Braisnes-sur-Aronde",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Brasseuse",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Brégy",
    "dep": "Oise"
  },
  {
    "code": "60870",
    "ville": "Brenouille",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Bresles",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Breteuil",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Brétigny",
    "dep": "Oise"
  },
  {
    "code": "60840",
    "ville": "Breuil-le-Sec",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Breuil-le-Vert",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Briot",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Brombos",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Broquiers",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Broyes",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Brunvillers-la-Motte",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Bucamps",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Buicourt",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Bulles",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Bury",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Bussy",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Caisnes",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Cambronne-lès-Ribécourt",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Cambronne-lès-Clermont",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Campagne",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Campeaux",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Campremy",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Candor",
    "dep": "Oise"
  },
  {
    "code": "60680",
    "ville": "Canly",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Cannectancourt",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Canny-sur-Matz",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Canny-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Carlepont",
    "dep": "Oise"
  },
  {
    "code": "60840",
    "ville": "Catenoy",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Catheux",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Catigny",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Catillon-Fumechon",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Cauffry",
    "dep": "Oise"
  },
  {
    "code": "60730",
    "ville": "Cauvigny",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Cempuis",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Cernoy",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Chamant",
    "dep": "Oise"
  },
  {
    "code": "60230",
    "ville": "Chambly",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Chambors",
    "dep": "Oise"
  },
  {
    "code": "60500",
    "ville": "Chantilly",
    "dep": "Oise"
  },
  {
    "code": "60520",
    "ville": "La Chapelle-en-Serval",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Chaumont-en-Vexin",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Chavençon",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Chelles",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Chepoix",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Chevincourt",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Chèvreville",
    "dep": "Oise"
  },
  {
    "code": "60710",
    "ville": "Chevrières",
    "dep": "Oise"
  },
  {
    "code": "60138",
    "ville": "Chiry-Ourscamp",
    "dep": "Oise"
  },
  {
    "code": "60750",
    "ville": "Choisy-au-Bac",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Choisy-la-Victoire",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Choqueuse-les-Bénards",
    "dep": "Oise"
  },
  {
    "code": "60940",
    "ville": "Cinqueux",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Cires-lès-Mello",
    "dep": "Oise"
  },
  {
    "code": "60280",
    "ville": "Clairoix",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Clermont",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Coivrel",
    "dep": "Oise"
  },
  {
    "code": "60200",
    "ville": "Compiègne",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Conchy-les-Pots",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Conteville",
    "dep": "Oise"
  },
  {
    "code": "60110",
    "ville": "Corbeil-Cerf",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Cormeilles",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Le Coudray-Saint-Germer",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Le Coudray-sur-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Coudun",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Couloisy",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Courcelles-Epayelles",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Courcelles-lès-Gisors",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Courteuil",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Courtieux",
    "dep": "Oise"
  },
  {
    "code": "60580",
    "ville": "Coye-la-Forêt",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Cramoisy",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Crapeaumesnil",
    "dep": "Oise"
  },
  {
    "code": "60100",
    "ville": "Creil",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Crépy-en-Valois",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Cressonsacq",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Crèvecœur-le-Grand",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Crèvecœur-le-Petit",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Crillon",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Crisolles",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Le Crocq",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Croissy-sur-Celle",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Croutoy",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Crouy-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Cuignières",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Cuigy-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Cuise-la-Motte",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Cuts",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Cuvergnon",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Cuvilly",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Cuy",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Daméraucourt",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Dargies",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Delincourt",
    "dep": "Oise"
  },
  {
    "code": "60790",
    "ville": "La Drenne",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Dieudonné",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Dives",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Doméliers",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Domfront",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Dompierre",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Duvy",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Écuvilly",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Élencourt",
    "dep": "Oise"
  },
  {
    "code": "60157",
    "ville": "Élincourt-Sainte-Marguerite",
    "dep": "Oise"
  },
  {
    "code": "60123",
    "ville": "Éméville",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Énencourt-Léage",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "La Corne-en-Vexin",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Épineuse",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Éragny-sur-Epte",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Ercuis",
    "dep": "Oise"
  },
  {
    "code": "60950",
    "ville": "Ermenonville",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Ernemont-Boutavent",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Erquery",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Erquinvillers",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Escames",
    "dep": "Oise"
  },
  {
    "code": "60110",
    "ville": "Esches",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Escles-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Espaubourg",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Esquennoy",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Essuiles",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Estrées-Saint-Denis",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Étavigny",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Étouy",
    "dep": "Oise"
  },
  {
    "code": "60330",
    "ville": "Ève",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Évricourt",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Fay-les-Étangs",
    "dep": "Oise"
  },
  {
    "code": "60680",
    "ville": "Le Fayel",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Le Fay-Saint-Quentin",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Feigneux",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Ferrières",
    "dep": "Oise"
  },
  {
    "code": "60960",
    "ville": "Feuquières",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Fitz-James",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Flavacourt",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Flavy-le-Meldeux",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Fléchy",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Fleurines",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Fleury",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Fontaine-Bonneleau",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Fontaine-Chaalis",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Fontaine-Lavaganne",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Fontaine-Saint-Lucien",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Fontenay-Torcy",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Formerie",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Fouilleuse",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Fouilloy",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Foulangues",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Fouquenies",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Fouquerolles",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Fournival",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Francastel",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Francières",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Fréniches",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Montchevreuil",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Fresne-Léguillon",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Fresnières",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Fresnoy-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60127",
    "ville": "Fresnoy-la-Rivière",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Fresnoy-le-Luat",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Le Frestoy-Vaux",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Frétoy-le-Château",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Frocourt",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Froissy",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Le Gallet",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Gannes",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Gaudechart",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Genvry",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Gerberoy",
    "dep": "Oise"
  },
  {
    "code": "60129",
    "ville": "Gilocourt",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Giraumont",
    "dep": "Oise"
  },
  {
    "code": "60129",
    "ville": "Glaignes",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Glatigny",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Godenvillers",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Goincourt",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Golancourt",
    "dep": "Oise"
  },
  {
    "code": "60117",
    "ville": "Gondreville",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Gourchelles",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Gournay-sur-Aronde",
    "dep": "Oise"
  },
  {
    "code": "60270",
    "ville": "Gouvieux",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Gouy-les-Groseillers",
    "dep": "Oise"
  },
  {
    "code": "60680",
    "ville": "Grandfresnoy",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Grandvillers-aux-Bois",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Grandvilliers",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Grandrû",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Grémévillers",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Grez",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Guignecourt",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Guiscard",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Gury",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Hadancourt-le-Haut-Clocher",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Hainvillers",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Halloy",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Hannaches",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Le Hamel",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Hanvoile",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Hardivillers",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Haucourt",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Haudivillers",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Hautbos",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Haute-Épine",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Hautefontaine",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Hécourt",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Heilles",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Hémévillers",
    "dep": "Oise"
  },
  {
    "code": "60119",
    "ville": "Hénonville",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Herchies",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "La Hérelle",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Héricourt-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60370",
    "ville": "Hermes",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Hétomesnil",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Hodenc-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Hodenc-l'Évêque",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Hondainville",
    "dep": "Oise"
  },
  {
    "code": "60710",
    "ville": "Houdancourt",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "La Houssoye",
    "dep": "Oise"
  },
  {
    "code": "60141",
    "ville": "Ivors",
    "dep": "Oise"
  },
  {
    "code": "60173",
    "ville": "Ivry-le-Temple",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Jaméricourt",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Janville",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Jaulzy",
    "dep": "Oise"
  },
  {
    "code": "60880",
    "ville": "Jaux",
    "dep": "Oise"
  },
  {
    "code": "60680",
    "ville": "Jonquières",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Jouy-sous-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Juvignies",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Laberlière",
    "dep": "Oise"
  },
  {
    "code": "60570",
    "ville": "Laboissière-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Labosse",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Labruyère",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Lachapelle-aux-Pots",
    "dep": "Oise"
  },
  {
    "code": "60730",
    "ville": "Lachapelle-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Lachapelle-sous-Gerberoy",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Lachaussée-du-Bois-d'Écu",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Lachelle",
    "dep": "Oise"
  },
  {
    "code": "60610",
    "ville": "Lacroix-Saint-Ouen",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Lafraye",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Lagny",
    "dep": "Oise"
  },
  {
    "code": "60330",
    "ville": "Lagny-le-Sec",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Laigneville",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Lalande-en-Son",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Lalandelle",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Lamécourt",
    "dep": "Oise"
  },
  {
    "code": "60260",
    "ville": "Lamorlaye",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Lannoy-Cuillère",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Larbroye",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Lassigny",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Lataule",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Lattainville",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Lavacquerie",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Laverrière",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Laversines",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Lavilletertre",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Léglantiers",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Lévignen",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Lhéraule",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Liancourt",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Liancourt-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Libermont",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Lierville",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Lieuvillers",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Lihus",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Litz",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Loconville",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Longueil-Annel",
    "dep": "Oise"
  },
  {
    "code": "60126",
    "ville": "Longueil-Sainte-Marie",
    "dep": "Oise"
  },
  {
    "code": "60110",
    "ville": "Lormaison",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Loueuse",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Luchy",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Machemont",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Maignelay-Montigny",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Maimbeville",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Maisoncelle-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Maisoncelle-Tuilerie",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Marest-sur-Matz",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Mareuil-la-Motte",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Mareuil-sur-Ourcq",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Margny-aux-Cerises",
    "dep": "Oise"
  },
  {
    "code": "60280",
    "ville": "Margny-lès-Compiègne",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Margny-sur-Matz",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Marolles",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Marquéglise",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Marseille-en-Beauvaisis",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Martincourt",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Maucourt",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Maulers",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Maysel",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Mélicocq",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Mello",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Ménévillers",
    "dep": "Oise"
  },
  {
    "code": "60110",
    "ville": "Méru",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Méry-la-Bataille",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Le Mesnil-Conteville",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Le Mesnil-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Le Mesnil-Saint-Firmin",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Le Mesnil-sur-Bulles",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Le Mesnil-Théribus",
    "dep": "Oise"
  },
  {
    "code": "60880",
    "ville": "Le Meux",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Milly-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Mogneville",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Moliens",
    "dep": "Oise"
  },
  {
    "code": "60940",
    "ville": "Monceaux",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Monceaux-l'Abbaye",
    "dep": "Oise"
  },
  {
    "code": "60113",
    "ville": "Monchy-Humières",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Monchy-Saint-Éloi",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Mondescourt",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Monneville",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Montagny-en-Vexin",
    "dep": "Oise"
  },
  {
    "code": "60950",
    "ville": "Montagny-Sainte-Félicité",
    "dep": "Oise"
  },
  {
    "code": "60160",
    "ville": "Montataire",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Montépilloy",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Montgérain",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Montiers",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Montjavoult",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Mont-l'Évêque",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Montlognon",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Montmacq",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Montmartin",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Montreuil-sur-Brêche",
    "dep": "Oise"
  },
  {
    "code": "60134",
    "ville": "Montreuil-sur-Thérain",
    "dep": "Oise"
  },
  {
    "code": "60119",
    "ville": "Monts",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Le Mont-Saint-Adrien",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Morangles",
    "dep": "Oise"
  },
  {
    "code": "60127",
    "ville": "Morienval",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Morlincourt",
    "dep": "Oise"
  },
  {
    "code": "60128",
    "ville": "Mortefontaine",
    "dep": "Oise"
  },
  {
    "code": "60570",
    "ville": "Mortefontaine-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Mortemer",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Morvillers",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Mory-Montcrux",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Mouchy-le-Châtel",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Moulin-sous-Touvent",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Mouy",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Moyenneville",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Moyvillers",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Muidorge",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Muirancourt",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Mureaumont",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Nampcel",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Nanteuil-le-Haudouin",
    "dep": "Oise"
  },
  {
    "code": "60320",
    "ville": "Néry",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Neufchelles",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Neufvy-sur-Aronde",
    "dep": "Oise"
  },
  {
    "code": "60530",
    "ville": "Neuilly-en-Thelle",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Neuilly-sous-Clermont",
    "dep": "Oise"
  },
  {
    "code": "60119",
    "ville": "Neuville-Bosc",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "La Neuville-en-Hez",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "La Neuville-Roy",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "La Neuville-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "La Neuville-sur-Oudeuil",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "La Neuville-sur-Ressons",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "La Neuville-Vault",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Nivillers",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Noailles",
    "dep": "Oise"
  },
  {
    "code": "60180",
    "ville": "Nogent-sur-Oise",
    "dep": "Oise"
  },
  {
    "code": "60840",
    "ville": "Nointel",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Noirémont",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Noroy",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Nourard-le-Franc",
    "dep": "Oise"
  },
  {
    "code": "60730",
    "ville": "Novillers",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Noyers-Saint-Martin",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Noyon",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Offoy",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Ognes",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Ognolles",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Omécourt",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Ons-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Ormoy-le-Davien",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Ormoy-Villers",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Oroër",
    "dep": "Oise"
  },
  {
    "code": "60129",
    "ville": "Orrouy",
    "dep": "Oise"
  },
  {
    "code": "60560",
    "ville": "Orry-la-Ville",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Orvillers-Sorel",
    "dep": "Oise"
  },
  {
    "code": "60860",
    "ville": "Oudeuil",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Oursel-Maison",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Paillart",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Parnes",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Passel",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Péroy-les-Gombries",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Pierrefitte-en-Beauvaisis",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Pierrefonds",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Pimprez",
    "dep": "Oise"
  },
  {
    "code": "60860",
    "ville": "Pisseleu",
    "dep": "Oise"
  },
  {
    "code": "60128",
    "ville": "Plailly",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Plainval",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Plainville",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Le Plessier-sur-Bulles",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Le Plessier-sur-Saint-Just",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Plessis-de-Roye",
    "dep": "Oise"
  },
  {
    "code": "60330",
    "ville": "Le Plessis-Belleville",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Le Plessis-Brion",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Le Plessis-Patte-d'Oie",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Le Ployron",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Ponchon",
    "dep": "Oise"
  },
  {
    "code": "60520",
    "ville": "Pontarmé",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Pont-l'Évêque",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Pontoise-lès-Noyon",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Pontpoint",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Pont-Sainte-Maxence",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Porcheux",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Porquéricourt",
    "dep": "Oise"
  },
  {
    "code": "60790",
    "ville": "Pouilly",
    "dep": "Oise"
  },
  {
    "code": "60460",
    "ville": "Précy-sur-Oise",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Prévillers",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Pronleroy",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Puiseux-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60540",
    "ville": "Puiseux-le-Hauberger",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Puits-la-Vallée",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Quesmy",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Le Quesnel-Aubry",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Quincampoix-Fleuzy",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Quinquempoix",
    "dep": "Oise"
  },
  {
    "code": "60155",
    "ville": "Rainvillers",
    "dep": "Oise"
  },
  {
    "code": "60290",
    "ville": "Rantigny",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Raray",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Ravenel",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Réez-Fosse-Martin",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Reilly",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Rémécourt",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Rémérangles",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Remy",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Ressons-sur-Matz",
    "dep": "Oise"
  },
  {
    "code": "60153",
    "ville": "Rethondes",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Reuil-sur-Brêche",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Rhuis",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Ribécourt-Dreslincourt",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Ricquebourg",
    "dep": "Oise"
  },
  {
    "code": "60870",
    "ville": "Rieux",
    "dep": "Oise"
  },
  {
    "code": "60126",
    "ville": "Rivecourt",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Roberval",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Rochy-Condé",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Rocquemont",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Rocquencourt",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Romescamps",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Rosières",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Rosoy",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Rosoy-en-Multien",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Rotangy",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Rothois",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Rousseloy",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Rouville",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Rouvillers",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Rouvres-en-Multien",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Rouvroy-les-Merles",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Royaucourt",
    "dep": "Oise"
  },
  {
    "code": "60690",
    "ville": "Roy-Boissy",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Roye-sur-Matz",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "La Rue-Saint-Pierre",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Rully",
    "dep": "Oise"
  },
  {
    "code": "60117",
    "ville": "Russy-Bémont",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Sacy-le-Grand",
    "dep": "Oise"
  },
  {
    "code": "60190",
    "ville": "Sacy-le-Petit",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Sains-Morainvillers",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Saint-André-Farivillers",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Saint-Arnoult",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Saint-Aubin-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60600",
    "ville": "Saint-Aubin-sous-Erquery",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Saint-Crépin-aux-Bois",
    "dep": "Oise"
  },
  {
    "code": "60149",
    "ville": "Saint-Crépin-Ibouvillers",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Saint-Deniscourt",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Saint-Étienne-Roilaye",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Sainte-Eusoye",
    "dep": "Oise"
  },
  {
    "code": "60370",
    "ville": "Saint-Félix",
    "dep": "Oise"
  },
  {
    "code": "60730",
    "ville": "Sainte-Geneviève",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Saint-Germain-la-Poterie",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Saint-Germer-de-Fly",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Saintines",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Saint-Jean-aux-Bois",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Saint-Just-en-Chaussée",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Saint-Léger-aux-Bois",
    "dep": "Oise"
  },
  {
    "code": "60155",
    "ville": "Saint-Léger-en-Bray",
    "dep": "Oise"
  },
  {
    "code": "60340",
    "ville": "Saint-Leu-d'Esserent",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Saint-Martin-aux-Bois",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Saint-Martin-le-Nœud",
    "dep": "Oise"
  },
  {
    "code": "60700",
    "ville": "Saint-Martin-Longueau",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Saint-Maur",
    "dep": "Oise"
  },
  {
    "code": "60740",
    "ville": "Saint-Maximin",
    "dep": "Oise"
  },
  {
    "code": "60860",
    "ville": "Saint-Omer-en-Chaussée",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Saint-Paul",
    "dep": "Oise"
  },
  {
    "code": "60850",
    "ville": "Saint-Pierre-es-Champs",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Saint-Pierre-lès-Bitry",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Saint-Quentin-des-Prés",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Saint-Remy-en-l'Eau",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Saint-Samson-la-Poterie",
    "dep": "Oise"
  },
  {
    "code": "60320",
    "ville": "Saint-Sauveur",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Saint-Sulpice",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Saint-Thibault",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Saint-Vaast-de-Longmont",
    "dep": "Oise"
  },
  {
    "code": "60660",
    "ville": "Saint-Vaast-lès-Mello",
    "dep": "Oise"
  },
  {
    "code": "60220",
    "ville": "Saint-Valery",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Salency",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Sarcus",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Sarnois",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Le Saulchoy",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Savignies",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Sempigny",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Senantes",
    "dep": "Oise"
  },
  {
    "code": "60300",
    "ville": "Senlis",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Senots",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Serans",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Sérévillers",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Sérifontaine",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Sermaize",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Séry-Magneval",
    "dep": "Oise"
  },
  {
    "code": "60330",
    "ville": "Silly-le-Long",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Silly-Tillard",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Solente",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Sommereux",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Songeons",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Sully",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Suzoy",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Talmontiers",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Tartigny",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Therdonne",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Thérines",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Thibivillers",
    "dep": "Oise"
  },
  {
    "code": "60520",
    "ville": "Thiers-sur-Thève",
    "dep": "Oise"
  },
  {
    "code": "60310",
    "ville": "Thiescourt",
    "dep": "Oise"
  },
  {
    "code": "60210",
    "ville": "Thieuloy-Saint-Antoine",
    "dep": "Oise"
  },
  {
    "code": "60480",
    "ville": "Thieux",
    "dep": "Oise"
  },
  {
    "code": "60160",
    "ville": "Thiverny",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Thourotte",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Thury-en-Valois",
    "dep": "Oise"
  },
  {
    "code": "60250",
    "ville": "Thury-sous-Clermont",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Tillé",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Tourly",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Tracy-le-Mont",
    "dep": "Oise"
  },
  {
    "code": "60170",
    "ville": "Tracy-le-Val",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Tricot",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Trie-Château",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Trie-la-Ville",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Troissereux",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Trosly-Breuil",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Troussencourt",
    "dep": "Oise"
  },
  {
    "code": "60800",
    "ville": "Trumilly",
    "dep": "Oise"
  },
  {
    "code": "60730",
    "ville": "Ully-Saint-Georges",
    "dep": "Oise"
  },
  {
    "code": "60790",
    "ville": "Valdampierre",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Valescourt",
    "dep": "Oise"
  },
  {
    "code": "60490",
    "ville": "Vandélicourt",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Varesnes",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "Varinfroy",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Vauchelles",
    "dep": "Oise"
  },
  {
    "code": "60117",
    "ville": "Vauciennes",
    "dep": "Oise"
  },
  {
    "code": "60240",
    "ville": "Vaudancourt",
    "dep": "Oise"
  },
  {
    "code": "60590",
    "ville": "Le Vaumain",
    "dep": "Oise"
  },
  {
    "code": "60117",
    "ville": "Vaumoise",
    "dep": "Oise"
  },
  {
    "code": "60390",
    "ville": "Le Vauroux",
    "dep": "Oise"
  },
  {
    "code": "60510",
    "ville": "Velennes",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Vendeuil-Caply",
    "dep": "Oise"
  },
  {
    "code": "60280",
    "ville": "Venette",
    "dep": "Oise"
  },
  {
    "code": "60950",
    "ville": "Ver-sur-Launette",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Verberie",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Verderel-lès-Sauqueuse",
    "dep": "Oise"
  },
  {
    "code": "60140",
    "ville": "Verderonne",
    "dep": "Oise"
  },
  {
    "code": "60550",
    "ville": "Verneuil-en-Halatte",
    "dep": "Oise"
  },
  {
    "code": "60440",
    "ville": "Versigny",
    "dep": "Oise"
  },
  {
    "code": "60117",
    "ville": "Vez",
    "dep": "Oise"
  },
  {
    "code": "60360",
    "ville": "Viefvillers",
    "dep": "Oise"
  },
  {
    "code": "60350",
    "ville": "Vieux-Moulin",
    "dep": "Oise"
  },
  {
    "code": "60162",
    "ville": "Vignemont",
    "dep": "Oise"
  },
  {
    "code": "60400",
    "ville": "Ville",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Villembray",
    "dep": "Oise"
  },
  {
    "code": "60175",
    "ville": "Villeneuve-les-Sablons",
    "dep": "Oise"
  },
  {
    "code": "60890",
    "ville": "La Villeneuve-sous-Thury",
    "dep": "Oise"
  },
  {
    "code": "60410",
    "ville": "Villeneuve-sur-Verberie",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Villers-Saint-Barthélemy",
    "dep": "Oise"
  },
  {
    "code": "60810",
    "ville": "Villers-Saint-Frambourg-Ognon",
    "dep": "Oise"
  },
  {
    "code": "60620",
    "ville": "Villers-Saint-Genest",
    "dep": "Oise"
  },
  {
    "code": "60870",
    "ville": "Villers-Saint-Paul",
    "dep": "Oise"
  },
  {
    "code": "60134",
    "ville": "Villers-Saint-Sépulcre",
    "dep": "Oise"
  },
  {
    "code": "60340",
    "ville": "Villers-sous-Saint-Leu",
    "dep": "Oise"
  },
  {
    "code": "60650",
    "ville": "Villers-sur-Auchy",
    "dep": "Oise"
  },
  {
    "code": "60860",
    "ville": "Villers-sur-Bonnières",
    "dep": "Oise"
  },
  {
    "code": "60150",
    "ville": "Villers-sur-Coudun",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Villers-Vermont",
    "dep": "Oise"
  },
  {
    "code": "60120",
    "ville": "Villers-Vicomte",
    "dep": "Oise"
  },
  {
    "code": "60640",
    "ville": "Villeselve",
    "dep": "Oise"
  },
  {
    "code": "60500",
    "ville": "Vineuil-Saint-Firmin",
    "dep": "Oise"
  },
  {
    "code": "60112",
    "ville": "Vrocourt",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Wacquemoulin",
    "dep": "Oise"
  },
  {
    "code": "60380",
    "ville": "Wambez",
    "dep": "Oise"
  },
  {
    "code": "60430",
    "ville": "Warluis",
    "dep": "Oise"
  },
  {
    "code": "60130",
    "ville": "Wavignies",
    "dep": "Oise"
  },
  {
    "code": "60420",
    "ville": "Welles-Pérennes",
    "dep": "Oise"
  },
  {
    "code": "60000",
    "ville": "Aux Marais",
    "dep": "Oise"
  },
  {
    "code": "61000",
    "ville": "Alençon",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Almenêches",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Appenai-sous-Bellême",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Argentan",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Athis-Val de Rouvre",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Aube",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Aubry-le-Panthou",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Aubusson",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Auguaise",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Aunay-les-Bois",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Aunou-le-Faucon",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Aunou-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Les Authieux-du-Puits",
    "dep": "Orne"
  },
  {
    "code": "61470",
    "ville": "Avernes-Saint-Gourgon",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Avoine",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Avrilly",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Bailleul",
    "dep": "Orne"
  },
  {
    "code": "61450",
    "ville": "Banvou",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Barville",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Bazoches-au-Houlme",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Bazoches-sur-Hoëne",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Bazoque",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Beaufai",
    "dep": "Orne"
  },
  {
    "code": "61190",
    "ville": "Beaulieu",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Beauvain",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Belfonds",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Bellavilliers",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Bellême",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "La Bellière",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Bellou-en-Houlme",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Bellou-le-Trichard",
    "dep": "Orne"
  },
  {
    "code": "61340",
    "ville": "Berd'huis",
    "dep": "Orne"
  },
  {
    "code": "61430",
    "ville": "Berjou",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "Bizou",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Boëcé",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Boissei-la-Lande",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Cour-Maugis sur Huisne",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Boitron",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Bonnefoi",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Bonsmoulins",
    "dep": "Orne"
  },
  {
    "code": "61470",
    "ville": "Le Bosc-Renoult",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Boucé",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Le Bouillon",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Brethel",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Bretoncelles",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Brieux",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Briouze",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Brullemail",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Buré",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Bures",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Bursard",
    "dep": "Orne"
  },
  {
    "code": "61430",
    "ville": "Cahan",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Caligny",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Camembert",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Canapville",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Carrouges",
    "dep": "Orne"
  },
  {
    "code": "61330",
    "ville": "Ceaucé",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Le Cercueil",
    "dep": "Orne"
  },
  {
    "code": "61000",
    "ville": "Cerisé",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Cerisy-Belle-Étoile",
    "dep": "Orne"
  },
  {
    "code": "61260",
    "ville": "Ceton",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Chahains",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Chailloué",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Le Chalange",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Champcerie",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Le Champ-de-la-Pierre",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Les Champeaux",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Champeaux-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Champ-Haut",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Champosoult",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Champsecret",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Chandai",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Chanu",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Chapelle-au-Moine",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Chapelle-Biche",
    "dep": "Orne"
  },
  {
    "code": "61140",
    "ville": "Rives d'Andaine",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "La Chapelle-Montligeon",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "La Chapelle-près-Sées",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "La Chapelle-Souëf",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "La Chapelle-Viel",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Le Château-d'Almenêches",
    "dep": "Orne"
  },
  {
    "code": "61450",
    "ville": "Le Châtellier",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Chaumont",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "La Chaux",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Chemilli",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Ciral",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Cisai-Saint-Aubin",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Colombiers",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Comblot",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Commeaux",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Sablons sur Huisne",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Condé-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Corbon",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Coudehard",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Coulimer",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Coulmer",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Coulonces",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "La Coulonche",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Coulonges-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Courgeon",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Courgeoût",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Courtomer",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Craménil",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Croisilles",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Crouttes",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Crulai",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Cuissai",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Dame-Marie",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Damigny",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Domfront en Poiraie",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Dompierre",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Durcet",
    "dep": "Orne"
  },
  {
    "code": "61440",
    "ville": "Échalou",
    "dep": "Orne"
  },
  {
    "code": "61370",
    "ville": "Échauffour",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Écorcei",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Écorches",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Écouché-les-Vallées",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Essay",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Faverolles",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Fay",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Feings",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "La Ferrière-au-Doyen",
    "dep": "Orne"
  },
  {
    "code": "61450",
    "ville": "La Ferrière-aux-Étangs",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "La Ferrière-Béchet",
    "dep": "Orne"
  },
  {
    "code": "61420",
    "ville": "La Ferrière-Bochard",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Ferrières-la-Verrerie",
    "dep": "Orne"
  },
  {
    "code": "61550",
    "ville": "La Ferté-en-Ouche",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "La Ferté Macé",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Flers",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Fleuré",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Fontaine-les-Bassets",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Francheville",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "La Fresnaie-Fayel",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Fresnay-le-Samson",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Gacé",
    "dep": "Orne"
  },
  {
    "code": "61420",
    "ville": "Gandelain",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Gâprée",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Les Genettes",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "La Genevraie",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Giel-Courteilles",
    "dep": "Orne"
  },
  {
    "code": "61310",
    "ville": "Ginai",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Godisson",
    "dep": "Orne"
  },
  {
    "code": "61550",
    "ville": "La Gonfrière",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Monts-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Le Grais",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Belforêt-en-Perche",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Guêprei",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Guerquesalles",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Habloville",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Hauterive",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Héloup",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "L'Hôme-Chamondot",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Igé",
    "dep": "Orne"
  },
  {
    "code": "61190",
    "ville": "Irai",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Joué-du-Bois",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Joué-du-Plain",
    "dep": "Orne"
  },
  {
    "code": "61140",
    "ville": "Juvigny Val d'Andaine",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Juvigny-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Lalacelle",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "L'Aigle",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Laleu",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "La Lande-de-Goult",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "La Lande-de-Lougé",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Lande-Patry",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Lande-Saint-Siméon",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Landigou",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Landisacq",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Larré",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Lignères",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Lignou",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "L'Orée-d'Écouves",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Loisail",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "Longny les Villages",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Lonlay-l'Abbaye",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Lonlay-le-Tesson",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Lonrai",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Lougé-sur-Maire",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Louvières-en-Auge",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Macé",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "La Madeleine-Bouvet",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "Le Mage",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Magny-le-Désert",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Mahéru",
    "dep": "Orne"
  },
  {
    "code": "61350",
    "ville": "Mantilly",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Marchemaisons",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Mardilly",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Mauves-sur-Huisne",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Médavy",
    "dep": "Orne"
  },
  {
    "code": "61410",
    "ville": "Méhoudin",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Le Mêle-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Le Ménil-Bérard",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Le Ménil-de-Briouze",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Le Ménil-Broût",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Le Ménil-Ciboult",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Ménil-Erreux",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Ménil-Froger",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Ménil-Gondouin",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Le Ménil-Guyon",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Ménil-Hermei",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Ménil-Hubert-en-Exmes",
    "dep": "Orne"
  },
  {
    "code": "61430",
    "ville": "Ménil-Hubert-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Le Ménil-Scelleur",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Le Ménil-Vicomte",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Ménil-Vin",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "Les Menus",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Le Merlerault",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Merri",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "La Mesnière",
    "dep": "Orne"
  },
  {
    "code": "61440",
    "ville": "Messei",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Mieuxcé",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Moncy",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Montabard",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Montchevrel",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Montgaudry",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Montilly-sur-Noireau",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Montmerrei",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Mont-Ormel",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Montreuil-au-Houlme",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Montreuil-la-Cambe",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Montsecret-Clairefougère",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Mortagne-au-Perche",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Mortrée",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "La Motte-Fouquet",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Moulins-la-Marche",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Moulins-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Moutiers-au-Perche",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Neauphe-sous-Essai",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Neauphe-sur-Dive",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Nécy",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Neuilly-le-Bisson",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Neuville-sur-Touques",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Neuvy-au-Houlme",
    "dep": "Orne"
  },
  {
    "code": "61340",
    "ville": "Perche en Nocé",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Nonant-le-Pin",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Occagnes",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Ommoy",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Orgères",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Origny-le-Roux",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Pacé",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Parfondeval",
    "dep": "Orne"
  },
  {
    "code": "61290",
    "ville": "Le Pas-Saint-l'Homer",
    "dep": "Orne"
  },
  {
    "code": "61350",
    "ville": "Passais Villages",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Perrou",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Pervenchères",
    "dep": "Orne"
  },
  {
    "code": "61310",
    "ville": "Le Pin-au-Haras",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Le Pin-la-Garenne",
    "dep": "Orne"
  },
  {
    "code": "61370",
    "ville": "Planches",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Le Plantis",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Pointel",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Pontchardon",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Pouvrai",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Putanges-le-Lac",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Écouves",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Rai",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Rânes",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Rémalard en Perche",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Le Renouard",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Résenlieu",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Réveillon",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Ri",
    "dep": "Orne"
  },
  {
    "code": "61420",
    "ville": "La Roche-Mabile",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Roiville",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Rônai",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Rouperroux",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Sai",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Saint-Agnan-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Saint-André-de-Briouze",
    "dep": "Orne"
  },
  {
    "code": "61440",
    "ville": "Saint-André-de-Messei",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Saint-Aquilin-de-Corbion",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Saint-Aubin-d'Appenai",
    "dep": "Orne"
  },
  {
    "code": "61470",
    "ville": "Saint-Aubin-de-Bonneval",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Saint-Aubin-de-Courteraie",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Saint-Bômer-les-Forges",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Saint-Brice",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Saint-Brice-sous-Rânes",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Saint-Céneri-le-Gérei",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Sainte-Céronne-lès-Mortagne",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Saint-Christophe-de-Chaulieu",
    "dep": "Orne"
  },
  {
    "code": "61570",
    "ville": "Boischampré",
    "dep": "Orne"
  },
  {
    "code": "61490",
    "ville": "Saint-Clair-de-Halouze",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Saint-Cyr-la-Rosière",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Saint-Denis-sur-Huisne",
    "dep": "Orne"
  },
  {
    "code": "61420",
    "ville": "Saint-Denis-sur-Sarthon",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Saint-Ellier-les-Bois",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Saint-Evroult-de-Montfort",
    "dep": "Orne"
  },
  {
    "code": "61550",
    "ville": "Saint-Evroult-Notre-Dame-du-Bois",
    "dep": "Orne"
  },
  {
    "code": "61350",
    "ville": "Saint-Fraimbault",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Saint-Fulgent-des-Ormes",
    "dep": "Orne"
  },
  {
    "code": "61370",
    "ville": "Sainte-Gauburge-Sainte-Colombe",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Saint-Georges-d'Annebecq",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Saint-Georges-des-Groseillers",
    "dep": "Orne"
  },
  {
    "code": "61470",
    "ville": "Saint-Germain-d'Aunay",
    "dep": "Orne"
  },
  {
    "code": "61240",
    "ville": "Saint-Germain-de-Clairefeuille",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Saint-Germain-de-la-Coudre",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Saint-Germain-des-Grois",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Saint-Germain-de-Martigny",
    "dep": "Orne"
  },
  {
    "code": "61000",
    "ville": "Saint-Germain-du-Corbéis",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Saint-Germain-le-Vieux",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Saint-Gervais-des-Sablons",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Saint-Gervais-du-Perron",
    "dep": "Orne"
  },
  {
    "code": "61700",
    "ville": "Saint-Gilles-des-Marais",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Saint-Hilaire-de-Briouze",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Saint-Hilaire-le-Châtel",
    "dep": "Orne"
  },
  {
    "code": "61340",
    "ville": "Saint-Hilaire-sur-Erre",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Saint-Hilaire-sur-Risle",
    "dep": "Orne"
  },
  {
    "code": "61430",
    "ville": "Sainte-Honorine-la-Chardonne",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Sainte-Honorine-la-Guillaume",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Saint-Jouin-de-Blavou",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Saint-Julien-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Saint-Lambert-sur-Dive",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Saint-Langis-lès-Mortagne",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Saint-Léger-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Saint-Léonard-des-Parcs",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Saint-Mard-de-Réno",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Sainte-Marguerite-de-Carrouges",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Sainte-Marie-la-Robert",
    "dep": "Orne"
  },
  {
    "code": "61350",
    "ville": "Saint-Mars-d'Égrenne",
    "dep": "Orne"
  },
  {
    "code": "61270",
    "ville": "Les Aspres",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Saint-Martin-d'Écublei",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Saint-Martin-des-Landes",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Saint-Martin-des-Pézerits",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Saint-Martin-du-Vieux-Bellême",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Saint-Martin-l'Aiguillon",
    "dep": "Orne"
  },
  {
    "code": "61190",
    "ville": "Charencey",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Saint-Michel-Tubœuf",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Saint-Nicolas-des-Bois",
    "dep": "Orne"
  },
  {
    "code": "61550",
    "ville": "Saint-Nicolas-de-Sommaire",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Sainte-Opportune",
    "dep": "Orne"
  },
  {
    "code": "61560",
    "ville": "Saint-Ouen-de-Sécherouvre",
    "dep": "Orne"
  },
  {
    "code": "61410",
    "ville": "Saint-Ouen-le-Brisoult",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Saint-Ouen-sur-Iton",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Saint-Patrice-du-Désert",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "Saint-Paul",
    "dep": "Orne"
  },
  {
    "code": "61430",
    "ville": "Saint-Philbert-sur-Orne",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Saint-Pierre-d'Entremont",
    "dep": "Orne"
  },
  {
    "code": "61370",
    "ville": "Saint-Pierre-des-Loges",
    "dep": "Orne"
  },
  {
    "code": "61790",
    "ville": "Saint-Pierre-du-Regard",
    "dep": "Orne"
  },
  {
    "code": "61340",
    "ville": "Saint-Pierre-la-Bruyère",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Saint-Quentin-de-Blavou",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Saint-Quentin-les-Chardonnets",
    "dep": "Orne"
  },
  {
    "code": "61350",
    "ville": "Saint-Roch-sur-Égrenne",
    "dep": "Orne"
  },
  {
    "code": "61320",
    "ville": "Saint-Sauveur-de-Carrouges",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Sainte-Scolasse-sur-Sarthe",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Saint-Sulpice-sur-Risle",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Saint-Symphorien-des-Bruyères",
    "dep": "Orne"
  },
  {
    "code": "61220",
    "ville": "Saires-la-Verrerie",
    "dep": "Orne"
  },
  {
    "code": "61470",
    "ville": "Sap-en-Auge",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "Le Sap-André",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Sarceaux",
    "dep": "Orne"
  },
  {
    "code": "61600",
    "ville": "Les Monts d'Andaine",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Sées",
    "dep": "Orne"
  },
  {
    "code": "61100",
    "ville": "La Selle-la-Forge",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Semallé",
    "dep": "Orne"
  },
  {
    "code": "61200",
    "ville": "Sévigny",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Sevrai",
    "dep": "Orne"
  },
  {
    "code": "61310",
    "ville": "Gouffern en Auge",
    "dep": "Orne"
  },
  {
    "code": "61380",
    "ville": "Soligny-la-Trappe",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Suré",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Tanques",
    "dep": "Orne"
  },
  {
    "code": "61500",
    "ville": "Tanville",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Tellières-le-Plessis",
    "dep": "Orne"
  },
  {
    "code": "61410",
    "ville": "Tessé-Froulay",
    "dep": "Orne"
  },
  {
    "code": "61140",
    "ville": "Bagnoles de l'Orne Normandie",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Val-au-Perche",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Ticheville",
    "dep": "Orne"
  },
  {
    "code": "61800",
    "ville": "Tinchebray-Bocage",
    "dep": "Orne"
  },
  {
    "code": "61330",
    "ville": "Torchamp",
    "dep": "Orne"
  },
  {
    "code": "61550",
    "ville": "Touquettes",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Tournai-sur-Dive",
    "dep": "Orne"
  },
  {
    "code": "61190",
    "ville": "Tourouvre au Perche",
    "dep": "Orne"
  },
  {
    "code": "61390",
    "ville": "Trémont",
    "dep": "Orne"
  },
  {
    "code": "61230",
    "ville": "La Trinité-des-Laitiers",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Trun",
    "dep": "Orne"
  },
  {
    "code": "61250",
    "ville": "Valframbert",
    "dep": "Orne"
  },
  {
    "code": "61130",
    "ville": "Vaunoise",
    "dep": "Orne"
  },
  {
    "code": "61170",
    "ville": "Les Ventes-de-Bourse",
    "dep": "Orne"
  },
  {
    "code": "61190",
    "ville": "La Ventrouze",
    "dep": "Orne"
  },
  {
    "code": "61110",
    "ville": "Verrières",
    "dep": "Orne"
  },
  {
    "code": "61360",
    "ville": "Vidai",
    "dep": "Orne"
  },
  {
    "code": "61150",
    "ville": "Vieux-Pont",
    "dep": "Orne"
  },
  {
    "code": "61160",
    "ville": "Villedieu-lès-Bailleul",
    "dep": "Orne"
  },
  {
    "code": "61400",
    "ville": "Villiers-sous-Mortagne",
    "dep": "Orne"
  },
  {
    "code": "61120",
    "ville": "Vimoutiers",
    "dep": "Orne"
  },
  {
    "code": "61300",
    "ville": "Vitrai-sous-Laigle",
    "dep": "Orne"
  },
  {
    "code": "61210",
    "ville": "Les Yveteaux",
    "dep": "Orne"
  },
  {
    "code": "62153",
    "ville": "Ablain-Saint-Nazaire",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Ablainzevelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62320",
    "ville": "Acheville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Achicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Achiet-le-Grand",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Achiet-le-Petit",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62144",
    "ville": "Acq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Acquin-Westbécourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Adinfer",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Affringues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62161",
    "ville": "Agnez-lès-Duisans",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Agnières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Agny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Aire-sur-la-Lys",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Airon-Notre-Dame",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Airon-Saint-Vaast",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Aix-en-Ergny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Aix-en-Issart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62160",
    "ville": "Aix-Noulette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Alembon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Alette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Alincthun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62157",
    "ville": "Allouagne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Alquines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62164",
    "ville": "Ambleteuse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Ambricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Ambrines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Ames",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62260",
    "ville": "Amettes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Amplier",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Andres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62143",
    "ville": "Angres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62880",
    "ville": "Annay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62149",
    "ville": "Annequin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62232",
    "ville": "Annezin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Anvin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Anzin-Saint-Aubin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Ardres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Arleux-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62510",
    "ville": "Arques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62000",
    "ville": "Arras",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Athies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62730",
    "ville": "Les Attaques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Attin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Aubigny-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Aubin-Saint-Vaast",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Aubrometz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62260",
    "ville": "Auchel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Auchy-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Auchy-lès-Hesdin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62138",
    "ville": "Auchy-les-Mines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Audembert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Audincthun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62179",
    "ville": "Audinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Audrehem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62164",
    "ville": "Audresselles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Audruicq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Aumerval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Autingues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Auxi-le-Château",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Averdoingt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Avesnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Avesnes-le-Comte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Avesnes-lès-Bapaume",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62210",
    "ville": "Avion",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Avondance",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Avroult",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Ayette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Azincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Bailleul-aux-Cornailles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Bailleul-lès-Pernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Bailleulmont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Bailleul-Sir-Berthoult",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Bailleulval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Baincthun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Bainghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Bajus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Balinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Bancourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Bapaume",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Baralle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Barastre",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62620",
    "ville": "Barlin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Barly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Basseux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "Bavincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Bayenghem-lès-Éperlecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Bayenghem-lès-Seninghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Bazinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Béalencourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Beaudricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Beaufort-Blavincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Beaulencourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Beaumerie-Saint-Martin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Beaumetz-lès-Aire",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Beaumetz-lès-Cambrai",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Beaumetz-lès-Loges",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Beaurains",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Beaurainville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Beauvois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Bécourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Béhagnies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Bellebrune",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Belle-et-Houllefort",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Bellonne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62410",
    "ville": "Bénifontaine",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62600",
    "ville": "Berck",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Bergueneuse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Berlencourt-le-Cauroy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Berles-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Berles-Monchel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Bermicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Berneville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Bernieulles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Bertincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Béthonsart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62400",
    "ville": "Béthune",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Beugin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Beugnâtre",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Beugny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Beussent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Beutin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Beuvrequen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62660",
    "ville": "Beuvry",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Bezinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Biache-Saint-Vaast",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Biefvillers-lès-Bapaume",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Bienvillers-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Bihucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62138",
    "ville": "Billy-Berclau",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62420",
    "ville": "Billy-Montigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Bimont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62173",
    "ville": "Blairville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Blangerval-Blangermont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Blangy-sur-Ternoise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62575",
    "ville": "Blendecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Bléquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Blessy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Blingel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Boffles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Boiry-Becquerelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Boiry-Notre-Dame",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62175",
    "ville": "Boiry-Saint-Martin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62175",
    "ville": "Boiry-Sainte-Rictrude",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62320",
    "ville": "Bois-Bernard",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Boisdinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Boisjean",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62175",
    "ville": "Boisleux-au-Mont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62175",
    "ville": "Boisleux-Saint-Marc",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Bomy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Bonnières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Bonningues-lès-Ardres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Bonningues-lès-Calais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Boubers-lès-Hesmond",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Boubers-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62200",
    "ville": "Boulogne-sur-Mer",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Bouquehault",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Bourecq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Bouret-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Bourlon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Bournonville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Bours",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62132",
    "ville": "Boursin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Bourthes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Bouvelinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62172",
    "ville": "Bouvigny-Boyeffles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Boyaval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Boyelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62117",
    "ville": "Brebières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Brêmes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Brévillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Bréxent-Énocq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Brimeux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62700",
    "ville": "Bruay-la-Buissière",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Brunembert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Brias",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Bucquoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Buire-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Buire-le-Sec",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Buissy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Bullecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62160",
    "ville": "Bully-les-Mines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Buneville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62151",
    "ville": "Burbure",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Bus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Busnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62132",
    "ville": "Caffiers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62182",
    "ville": "Cagnicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62100",
    "ville": "Calais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62470",
    "ville": "Calonne-Ricouart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Calonne-sur-la-Lys",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "La Calotterie",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62470",
    "ville": "Camblain-Châtelain",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Cambligneul",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Camblain-l'Abbé",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62149",
    "ville": "Cambrin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62176",
    "ville": "Camiers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Campagne-lès-Boulonnais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Campagne-lès-Guines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Campagne-lès-Hesdin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Campagne-lès-Wardrecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Campigneulles-les-Grandes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Campigneulles-les-Petites",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Canettemont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Canlers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Capelle-Fermont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Capelle-lès-Hesdin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62144",
    "ville": "Carency",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Carly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62220",
    "ville": "Carvin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "La Cauchie",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62260",
    "ville": "Cauchy-à-la-Tour",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Caucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Caumont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Cavron-Saint-Martin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Chelers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Chériennes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Chérisy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62920",
    "ville": "Chocques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Clairmarais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Clenleu",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Clerques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Cléty",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Colembert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Colline-Beaumont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "La Comté",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Conchil-le-Temple",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Conchy-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Condette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Contes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62126",
    "ville": "Conteville-lès-Boulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Conteville-en-Ternois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62231",
    "ville": "Coquelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62112",
    "ville": "Corbehem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Cormont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Couin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "Coullemont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62137",
    "ville": "Coulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Coulomby",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Coupelle-Neuve",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Coupelle-Vieille",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Courcelles-le-Comte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62970",
    "ville": "Courcelles-lès-Lens",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62710",
    "ville": "Courrières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Courset",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62136",
    "ville": "La Couture",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "Couturelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Coyecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Crémarest",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Crépy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Créquy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Croisette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Croisilles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Croix-en-Ternois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62780",
    "ville": "Cucq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62149",
    "ville": "Cuinchy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62000",
    "ville": "Dainville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62187",
    "ville": "Dannes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62129",
    "ville": "Delettes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Denier",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Dennebrœucq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Desvres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62460",
    "ville": "Diéval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62460",
    "ville": "Divion",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Dohem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Douchy-lès-Ayette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Doudeauville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62119",
    "ville": "Dourges",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Douriez",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62138",
    "ville": "Douvrin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62320",
    "ville": "Drocourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62131",
    "ville": "Drouvin-le-Marais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62161",
    "ville": "Duisans",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Dury",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Echinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Éclimeux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Écoivres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Écourt-Saint-Quentin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Écoust-Saint-Mein",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Ecquedecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62129",
    "ville": "Ecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Écuires",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Écurie",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62300",
    "ville": "Éleu-dit-Leauwette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Elnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Embry",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62145",
    "ville": "Enquin-lez-Guinegatte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Enquin-sur-Baillons",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Éperlecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Épinoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Eps",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62224",
    "ville": "Équihen-Plage",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Équirre",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Ergny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Érin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Erny-Saint-Julien",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Ervillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62179",
    "ville": "Escalles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Escœuilles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Esquerdes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62400",
    "ville": "Essars",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62880",
    "ville": "Estevelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Estrée",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62145",
    "ville": "Estrée-Blanche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Estrée-Cauchy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Estréelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Estrée-Wamin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Étaing",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Étaples",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Éterpigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62161",
    "ville": "Étrun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62141",
    "ville": "Évin-Malmaison",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Famechon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Fampoux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Farbus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Fauquembergues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Favreuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Febvin-Palfart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62260",
    "ville": "Ferfay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Ferques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62149",
    "ville": "Festubert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Feuchy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62173",
    "ville": "Ficheux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Fiefs",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62132",
    "ville": "Fiennes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Fillièvres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Fléchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Flers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62840",
    "ville": "Fleurbaix",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Fleury",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Floringhem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Foncquevillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Fontaine-lès-Boulans",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Fontaine-lès-Croisilles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Fontaine-lès-Hermans",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Fontaine-l'Étalon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Fortel-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Fosseux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Foufflin-Ricametz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62232",
    "ville": "Fouquereuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62232",
    "ville": "Fouquières-lès-Béthune",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62740",
    "ville": "Fouquières-lès-Lens",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Framecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Frémicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Frencq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Fresnes-lès-Montauban",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Fresnicourt-le-Dolmen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Fresnoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Fresnoy-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Fressin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62185",
    "ville": "Fréthun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Frévent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Frévillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Frévin-Capelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Fruges",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Galametz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Gauchin-Légal",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Gauchin-Verloingt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Gaudiempré",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Gavrelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Gennes-Ivergny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Givenchy-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Givenchy-le-Noble",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62149",
    "ville": "Givenchy-lès-la-Bassée",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Gomiécourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Gommecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62920",
    "ville": "Gonnehem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62199",
    "ville": "Gosnay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Gouves",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Gouy-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62530",
    "ville": "Gouy-Servins",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Gouy-en-Ternois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Gouy-Saint-André",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62112",
    "ville": "Gouy-sous-Bellonne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62147",
    "ville": "Graincourt-lès-Havrincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Grand-Rullecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62160",
    "ville": "Grenay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Grévillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Grigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Grincourt-lès-Pas",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62600",
    "ville": "Groffliers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62330",
    "ville": "Guarbecque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Guémappe",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Guemps",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Guigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Guinecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Guînes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Guisy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Habarcq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62940",
    "ville": "Haillicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62138",
    "ville": "Haisnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Halinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62570",
    "ville": "Hallines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Halloy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Hamblain-les-Prés",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Hamelincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Ham-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Hames-Boucres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Hannescamps",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Haplincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Haravesnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62132",
    "ville": "Hardinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62440",
    "ville": "Harnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Haucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62144",
    "ville": "Haute-Avesnes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Hautecloque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Hauteville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Haut-Loquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62147",
    "ville": "Havrincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Hébuterne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62570",
    "ville": "Helfaut",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62182",
    "ville": "Hendecourt-lès-Cagnicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62175",
    "ville": "Hendecourt-lès-Ransart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Héninel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62110",
    "ville": "Hénin-Beaumont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Hénin-sur-Cojeul",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Henneveux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Hénu",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Herbinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Héricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "La Herlière",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Herlincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Herlin-le-Sec",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Herly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Hermaville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62132",
    "ville": "Hermelinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62147",
    "ville": "Hermies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Hermin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Hernicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62530",
    "ville": "Hersin-Coupigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62179",
    "ville": "Hervelinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62196",
    "ville": "Hesdigneul-lès-Béthune",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Hesdigneul-lès-Boulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Hesdin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Hesdin-l'Abbé",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Hesmond",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Hestrus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Heuchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62575",
    "ville": "Heuringhem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Hézecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62232",
    "ville": "Hinges",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Hocquinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62620",
    "ville": "Houchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Houdain",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Houlle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Houvin-Houvigneul",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Hubersent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Huby-Saint-Leu",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Huclier",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Hucqueliers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62410",
    "ville": "Hulluch",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "Humbercamps",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Humbert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Humerœuille",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Humières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Inchy-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Incourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62129",
    "ville": "Bellinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Inxent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62330",
    "ville": "Isbergues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Isques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Ivergny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Izel-lès-Équerchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Izel-lès-Hameau",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Journy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62122",
    "ville": "Labeuvrière",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62113",
    "ville": "Labourse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Labroye",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Lacres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62159",
    "ville": "Lagnicourt-Marcel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Laires",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Lambres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Landrethun-le-Nord",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Landrethun-lès-Ardres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62122",
    "ville": "Lapugnoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Lattre-Saint-Quentin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62840",
    "ville": "Laventie",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Lebiez",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Lebucquière",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Léchelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Ledinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Lefaux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62790",
    "ville": "Leforest",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62300",
    "ville": "Lens",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Lépine",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Lespesses",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Lespinoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62136",
    "ville": "Lestrem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Leubringhen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Leulinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Leulinghen-Bernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Licques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Liencourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Lières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62145",
    "ville": "Liettres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62800",
    "ville": "Liévin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Lignereuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Ligny-lès-Aire",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Ligny-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Ligny-Saint-Flochel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Ligny-Thilloy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62190",
    "ville": "Lillers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Linghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Linzeux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Lisbourg",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62400",
    "ville": "Locon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "La Loge",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Loison-sur-Créquoise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62218",
    "ville": "Loison-sous-Lens",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Longfossé",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62219",
    "ville": "Longuenesse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Longueville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Longvilliers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62750",
    "ville": "Loos-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62840",
    "ville": "Lorgies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Lottinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Louches",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62540",
    "ville": "Lozinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Lugy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Lumbres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "La Madelaine-sous-Montreuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Magnicourt-en-Comte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Magnicourt-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Maintenay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Maisnil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62620",
    "ville": "Maisnil-lès-Ruitz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Maisoncelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Maizières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Mametz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Manin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Maninghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Maninghen-Henne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Marant",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62730",
    "ville": "Marck",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Marconne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Marconnelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Marenla",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Maresquel-Ecquemicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Marest",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Maresville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62540",
    "ville": "Marles-les-Mines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Marles-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62161",
    "ville": "Marœuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Marquay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Marquion",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Marquise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Martinpuich",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Matringhem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62670",
    "ville": "Mazingarbe",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Mazinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Mencas",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Menneville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Mentque-Nortbécourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Mercatel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Merck-Saint-Liévin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62680",
    "ville": "Méricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62155",
    "ville": "Merlimont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Metz-en-Couture",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62410",
    "ville": "Meurchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Mingoval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Moncheaux-lès-Frévent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Monchel-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Monchiet",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Monchy-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Monchy-Breton",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Monchy-Cayeux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Monchy-le-Preux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Mondicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Mont-Bernanchon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Montcavrel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Montenescourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62640",
    "ville": "Montigny-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Montreuil-sur-Mer",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62144",
    "ville": "Mont-Saint-Éloi",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Monts-en-Ternois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Morchies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Moringhem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Morval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62159",
    "ville": "Mory",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Moulle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Mouriez",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Moyenneville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Muncq-Nieurlet",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Nabringhen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Nédon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Nédonchel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Nempont-Saint-Firmin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62152",
    "ville": "Nesles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62152",
    "ville": "Neufchâtel-Hardelot",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Neulette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62840",
    "ville": "Neuve-Chapelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Neuville-au-Cornet",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Neuville-Bourjonval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Neuville-Saint-Vaast",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Neuville-sous-Montreuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Neuville-Vitasse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Neuvireuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Nielles-lès-Bléquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Nielles-lès-Ardres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62185",
    "ville": "Nielles-lès-Calais",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Nœux-lès-Auxi",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62290",
    "ville": "Nœux-les-Mines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Nordausques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Noreuil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Norrent-Fontes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Nortkerque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Nort-Leulinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Nouvelle-Église",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62950",
    "ville": "Noyelles-Godault",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Noyelles-lès-Humières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62980",
    "ville": "Noyelles-lès-Vermelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Noyelles-sous-Bellonne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62221",
    "ville": "Noyelles-sous-Lens",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Noyellette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Noyelle-Vion",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Nuncq-Hautecôte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62920",
    "ville": "Oblinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Œuf-en-Ternois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Offekerque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Offin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Offrethun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62590",
    "ville": "Oignies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Oisy-le-Verger",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Oppy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Orville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Ostreville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62460",
    "ville": "Ourton",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62230",
    "ville": "Outreau",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Ouve-Wirquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62215",
    "ville": "Oye-Plage",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Palluel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Le Parcq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Parenty",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Pas-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Pelves",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Penin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Pernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62126",
    "ville": "Pernes-lès-Boulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62231",
    "ville": "Peuplingues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Pierremont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62570",
    "ville": "Pihem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62340",
    "ville": "Pihen-lès-Guînes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62126",
    "ville": "Pittefaux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Planques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Plouvain",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Bouin-Plumoison",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Polincove",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Pommera",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Pommier",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Le Ponchel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62880",
    "ville": "Pont-à-Vendin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62480",
    "ville": "Le Portel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Prédefin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Pressy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Preures",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Pronville-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62116",
    "ville": "Puisieux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Quéant",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Quelmes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Quercamps",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Quernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Le Quesnoy-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Quesques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Questrecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Quiéry-la-Motte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Quiestède",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Quilen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Quœux-Haut-Maînil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Racquinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Radinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Ramecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Rang-du-Fliers",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62173",
    "ville": "Ransart",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Raye-sur-Authie",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62129",
    "ville": "Saint-Augustin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Rebergues",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62150",
    "ville": "Rebreuve-Ranchicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Rebreuve-sur-Canche",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Rebreuviette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Reclinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Récourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Recques-sur-Course",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Recques-sur-Hem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Regnauville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Rely",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Remilly-Wirquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Rémy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Renty",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62720",
    "ville": "Rety",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62136",
    "ville": "Richebourg",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Riencourt-lès-Bapaume",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62182",
    "ville": "Riencourt-lès-Cagnicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Rimboval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62720",
    "ville": "Rinxent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62173",
    "ville": "Rivière",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Robecq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Roclincourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Rocquigny",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62610",
    "ville": "Rodelinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Roëllecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62118",
    "ville": "Rœux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Rollancourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Rombly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Roquetoire",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Rougefay",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Roussent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62320",
    "ville": "Rouvroy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Royon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Ruisseauville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62620",
    "ville": "Ruitz",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Rumaucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Rumilly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Ruminghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Ruyaulcourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Sachin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Sailly-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Sailly-en-Ostrevent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62113",
    "ville": "Sailly-Labourse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62840",
    "ville": "Sailly-sur-la-Lys",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62114",
    "ville": "Sains-en-Gohelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Sains-lès-Fressin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Sains-lès-Marquion",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Sains-lès-Pernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Saint-Amand",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Saint-Aubin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Sainte-Austreberthe",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Sainte-Catherine",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62990",
    "ville": "Saint-Denœux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Saint-Étienne-au-Mont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Saint-Floris",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Saint-Folquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Saint-Georges",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Saint-Hilaire-Cottes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Saint-Inglevert",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Saint-Josse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Saint-Laurent-Blangy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Saint-Léger",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "Saint-Léonard",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Sainte-Marie-Kerque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Saint-Martin-lez-Tatinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62280",
    "ville": "Saint-Martin-Boulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Saint-Martin-Choquel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Saint-Martin-d'Hardinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Saint-Martin-sur-Cojeul",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Saint-Michel-sous-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Saint-Michel-sur-Ternoise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62223",
    "ville": "Saint-Nicolas",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Saint-Omer",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62162",
    "ville": "Saint-Omer-Capelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Saint-Pol-sur-Ternoise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Saint-Rémy-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62185",
    "ville": "Saint-Tricat",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62350",
    "ville": "Saint-Venant",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62430",
    "ville": "Sallaumines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Salperwick",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Samer",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62231",
    "ville": "Sangatte",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Sanghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62121",
    "ville": "Sapignies",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Le Sars",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Sars-le-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Sarton",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Sauchy-Cauchy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Sauchy-Lestrée",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62860",
    "ville": "Saudemont",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62870",
    "ville": "Saulchoy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62158",
    "ville": "Saulty",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Savy-Berlette",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Selles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Sempy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Seninghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Senlecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Senlis",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Séricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62910",
    "ville": "Serques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62530",
    "ville": "Servins",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Setques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Sibiville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Simencourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Siracourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Sombrin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Sorrus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62111",
    "ville": "Souastre",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62153",
    "ville": "Souchez",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Le Souich",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62850",
    "ville": "Surques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Sus-Saint-Léger",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Tangry",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62179",
    "ville": "Tardinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Teneur",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Ternas",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Thélus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62129",
    "ville": "Thérouanne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Thiembronne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "La Thieuloye",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Thièvres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Tigny-Noyelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Tilloy-lès-Hermaville",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Tilloy-lès-Mofflaines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62134",
    "ville": "Tilly-Capelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Tilques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Tincques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Tingry",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Tollent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Torcy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Tortefontaine",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Tortequesne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62520",
    "ville": "Le Touquet-Paris-Plage",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Tournehem-sur-la-Hem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Tramecourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Le Transloy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62147",
    "ville": "Trescault",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Troisvaux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Tubersent",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62270",
    "ville": "Vacquerie-le-Boucq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Vacqueriette-Erquières",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62550",
    "ville": "Valhuon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62131",
    "ville": "Vaudricourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Vaudringhem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Vaulx",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62159",
    "ville": "Vaulx-Vraucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Vélu",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62232",
    "ville": "Vendin-lès-Béthune",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62880",
    "ville": "Vendin-le-Vieil",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Verchin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62560",
    "ville": "Verchocq",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Verlincthun",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62980",
    "ville": "Vermelles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62113",
    "ville": "Verquigneul",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62131",
    "ville": "Verquin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Verton",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Vieil-Hesdin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62136",
    "ville": "Vieille-Chapelle",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62162",
    "ville": "Vieille-Église",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Vieil-Moutier",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62144",
    "ville": "Villers-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Villers-au-Flos",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Villers-Brûlin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62690",
    "ville": "Villers-Châtel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62182",
    "ville": "Villers-lès-Cagnicourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Villers-l'Hôpital",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62127",
    "ville": "Villers-Sir-Simon",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Vimy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62310",
    "ville": "Vincly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62138",
    "ville": "Violaines",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62156",
    "ville": "Vis-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62490",
    "ville": "Vitry-en-Artois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62180",
    "ville": "Waben",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62250",
    "ville": "Wacquinghen",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Wail",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62217",
    "ville": "Wailly",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62170",
    "ville": "Wailly-Beaucamp",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62140",
    "ville": "Wambercourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Wamin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62128",
    "ville": "Wancourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Wanquetin",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Wardrecques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62450",
    "ville": "Warlencourt-Eaucourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62760",
    "ville": "Warlincourt-lès-Pas",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62123",
    "ville": "Warlus",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62810",
    "ville": "Warluzel",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62142",
    "ville": "Le Wast",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Beauvoir-Wavans",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Wavrans-sur-l'Aa",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62130",
    "ville": "Wavrans-sur-Ternoise",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62960",
    "ville": "Westrehem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Wicquinghem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62630",
    "ville": "Widehem",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62830",
    "ville": "Wierre-au-Bois",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62720",
    "ville": "Wierre-Effroy",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62770",
    "ville": "Willeman",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62390",
    "ville": "Willencourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62580",
    "ville": "Willerval",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62930",
    "ville": "Wimereux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62126",
    "ville": "Wimille",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62410",
    "ville": "Wingles",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62240",
    "ville": "Wirwignes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62380",
    "ville": "Wismes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62219",
    "ville": "Wisques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62179",
    "ville": "Wissant",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Witternesse",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62120",
    "ville": "Wittes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62570",
    "ville": "Wizernes",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62650",
    "ville": "Zoteux",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62890",
    "ville": "Zouafques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62500",
    "ville": "Zudausques",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62370",
    "ville": "Zutkerque",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62820",
    "ville": "Libercourt",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62360",
    "ville": "La Capelle-lès-Boulogne",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "62124",
    "ville": "Ytres",
    "dep": "Pas-de-Calais"
  },
  {
    "code": "63260",
    "ville": "Aigueperse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63980",
    "ville": "Aix-la-Fayette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Ambert",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63770",
    "ville": "Les Ancizes-Comps",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Antoingt",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Anzat-le-Luguet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Apchat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63250",
    "ville": "Arconsat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Ardes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Arlanc",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Ars-les-Favets",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Artonne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Aubiat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63170",
    "ville": "Aubière",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Aubusson-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63930",
    "ville": "Augerolles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Augnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63510",
    "ville": "Aulnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Aurières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63114",
    "ville": "Authezat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Auzat-la-Combelle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63590",
    "ville": "Auzelles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63690",
    "ville": "Avèze",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Ayat-sur-Sioule",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63970",
    "ville": "Aydat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Baffie",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63810",
    "ville": "Bagnols",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Bansat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Bas-et-Lezat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Beaulieu",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63110",
    "ville": "Beaumont",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Beaumont-lès-Randan",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63116",
    "ville": "Beauregard-l'Évêque",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Beauregard-Vendon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Bergonne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63480",
    "ville": "Bertignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63610",
    "ville": "Besse-et-Saint-Anastaise",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Beurières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Billom",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63640",
    "ville": "Biollet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63112",
    "ville": "Blanzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Blot-l'Église",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Bongheat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Bort-l'Étang",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Boudes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63150",
    "ville": "La Bourboule",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63760",
    "ville": "Bourg-Lastic",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63910",
    "ville": "Bouzel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Brassac-les-Mines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Brenat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Le Breuil-sur-Couze",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63820",
    "ville": "Briffons",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Le Broc",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Bromont-Lamothe",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Brousse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63880",
    "ville": "Le Brugeron",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Bulhon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Busséol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Bussières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Bussières-et-Pruns",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Buxières-sous-Montaigut",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63118",
    "ville": "Cébazat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63620",
    "ville": "La Celle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Ceilloux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63250",
    "ville": "Celles-sur-Durolle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "La Cellette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63670",
    "ville": "Le Cendre",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63122",
    "ville": "Ceyrat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Ceyssat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63250",
    "ville": "Chabreloche",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Chadeleuf",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Chalus",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63400",
    "ville": "Chamalières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63980",
    "ville": "Chambon-sur-Dolore",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63790",
    "ville": "Chambon-sur-Lac",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Champagnat-le-Jeune",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Champeix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Champétières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Champs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63530",
    "ville": "Chanat-la-Mouteyre",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Chanonat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Chapdes-Beaufort",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63590",
    "ville": "La Chapelle-Agnon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "La Chapelle-Marcousse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "La Chapelle-sur-Usson",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Chappes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Chaptuzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Charbonnier-les-Mines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Charbonnières-les-Varennes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Charbonnières-les-Vieilles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63640",
    "ville": "Charensat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Charnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Chas",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Chassagne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63680",
    "ville": "Chastreix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63119",
    "ville": "Châteaugay",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Châteauneuf-les-Bains",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Château-sur-Cher",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Châteldon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63140",
    "ville": "Châtel-Guyon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63660",
    "ville": "La Chaulme",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Chaumont-le-Bourg",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63117",
    "ville": "Chauriat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Chavaroux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Le Cheix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Chidrac",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63740",
    "ville": "Cisternes-la-Forêt",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Clémensat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Clerlande",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63100",
    "ville": "Clermont-Ferrand",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Collanges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Combrailles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Combronde",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63610",
    "ville": "Compains",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Condat-en-Combraille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Condat-lès-Montboissier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63730",
    "ville": "Corent",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63114",
    "ville": "Coudes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Courgoul",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Cournols",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63800",
    "ville": "Cournon-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Courpière",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Le Crest",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Crevant-Laveine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63810",
    "ville": "Cros",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "La Crouzille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Culhat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63590",
    "ville": "Cunlhat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Dauzat-sur-Vodable",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Davayat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Domaize",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Doranges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63300",
    "ville": "Dorat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Dore-l'Église",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Durmignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63830",
    "ville": "Durtol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63980",
    "ville": "Échandelys",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Effiat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63850",
    "ville": "Égliseneuve-d'Entraigues",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Égliseneuve-des-Liards",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Égliseneuve-près-Billom",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63840",
    "ville": "Églisolles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Ennezat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Entraigues",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63530",
    "ville": "Enval",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63300",
    "ville": "Escoutoux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Espinasse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63850",
    "ville": "Espinchal",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Espirat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Estandeuil",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Esteil",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Fayet-le-Château",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63630",
    "ville": "Fayet-Ronaye",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63620",
    "ville": "Fernoël",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Aulhat-Flat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "La Forie",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63980",
    "ville": "Fournols",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63740",
    "ville": "Gelles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63360",
    "ville": "Gerzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63620",
    "ville": "Giat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Gignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Gimeaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Glaine-Montaigut",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63850",
    "ville": "La Godivelle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "La Goutelle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Gouttières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Grandeyrolles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Grandrif",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63890",
    "ville": "Grandval",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Herment",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Heume-l'Église",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Isserteaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Issoire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63990",
    "ville": "Job",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Joze",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Jozerand",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Jumeaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63690",
    "ville": "Labessette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Lachaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Lamontgie",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Landogne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Lapeyrouse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Laps",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63820",
    "ville": "Laqueuille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63690",
    "ville": "Larodde",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63760",
    "ville": "Lastic",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63680",
    "ville": "La Tour-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63370",
    "ville": "Lempdes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Lempty",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Lezoux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Limons",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Lisseuil",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Loubeyrat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Ludesse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63360",
    "ville": "Lussat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Luzillat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Madriat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Malauzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63510",
    "ville": "Malintrat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Manglieu",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Manzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63480",
    "ville": "Marat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Marcillat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Mareugheol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Maringues",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63940",
    "ville": "Marsac-en-Livradois",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Marsat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63430",
    "ville": "Les Martres-d'Artière",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63730",
    "ville": "Les Martres-de-Veyre",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Martres-sur-Morge",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Mauzun",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Mayres",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Mazaye",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Mazoires",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Medeyrolles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Meilhaud",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63560",
    "ville": "Menat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Ménétrol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63750",
    "ville": "Messeix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63115",
    "ville": "Mur-sur-Allier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63730",
    "ville": "Mirefleurs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Miremont",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Moissat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63890",
    "ville": "Le Monestier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63650",
    "ville": "La Monnerie-le-Montel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Mons",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Montaigut-en-Combraille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Montaigut-le-Blanc",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Montcel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63240",
    "ville": "Mont-Dore",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Montel-de-Gelat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Montfermy",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Montmorin",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Montpensier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63114",
    "ville": "Montpeyroux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Moriat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Moureuille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Chambaron sur Morge",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Mozac",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63150",
    "ville": "Murat-le-Quaire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63790",
    "ville": "Murol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Nébouzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Néronde-sur-Dore",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Neschers",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63560",
    "ville": "Neuf-Église",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Neuville",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Noalhat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63830",
    "ville": "Nohanent",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Nonette-Orsonnette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Novacelles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Olby",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63880",
    "ville": "Olliergues",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Olloix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63880",
    "ville": "Olmet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Orbeil",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63670",
    "ville": "Orcet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63870",
    "ville": "Orcines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Orcival",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Orléat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63550",
    "ville": "Palladuc",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Pardines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Parent",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Parentignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Paslières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63170",
    "ville": "Pérignat-lès-Sarliève",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63800",
    "ville": "Pérignat-sur-Allier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Perpezat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Perrier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63920",
    "ville": "Peschadoires",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Peslières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Pessat-Villeneuve",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63113",
    "ville": "Picherande",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Pignols",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Pionsat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63730",
    "ville": "Plauzat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Pontaumur",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63430",
    "ville": "Pont-du-Château",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Pontgibaud",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Pouzol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Les Pradeaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Prompsat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Prondines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Pulvérières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Puy-Guillaume",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Puy-Saint-Gulmier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Le Quartier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63780",
    "ville": "Queuille",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Randan",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Ravel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Reignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63930",
    "ville": "La Renaudie",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Rentières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Riom",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63290",
    "ville": "Ris",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63670",
    "ville": "La Roche-Blanche",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Roche-Charles-la-Mayrand",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Roche-d'Agoux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Rochefort-Montagne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63800",
    "ville": "La Roche-Noire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63540",
    "ville": "Romagnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63130",
    "ville": "Royat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63840",
    "ville": "Saillant",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Sainte-Agathe",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Saint-Agoulin",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Saint-Alyre-d'Arlanc",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63420",
    "ville": "Saint-Alyre-ès-Montagne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63890",
    "ville": "Saint-Amant-Roche-Savine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Saint-Amant-Tallende",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Saint-André-le-Coq",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Saint-Angel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63660",
    "ville": "Saint-Anthème",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Saint-Avit",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Saint-Babel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63360",
    "ville": "Saint-Beauzire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63630",
    "ville": "Saint-Bonnet-le-Bourg",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63630",
    "ville": "Saint-Bonnet-le-Chastel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63800",
    "ville": "Saint-Bonnet-lès-Allier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Saint-Bonnet-près-Orcival",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Saint-Bonnet-près-Riom",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Sainte-Catherine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Sainte-Christine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Saint-Cirgues-sur-Couze",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63660",
    "ville": "Saint-Clément-de-Valorgue",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Saint-Clément-de-Régnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Saint-Denis-Combarnazat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Saint-Dier-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Saint-Diéry",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63680",
    "ville": "Saint-Donat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63890",
    "ville": "Saint-Éloy-la-Glacière",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Saint-Éloy-les-Mines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Saint-Étienne-des-Champs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Saint-Étienne-sur-Usson",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Saint-Ferréol-des-Côtes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Saint-Floret",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Saint-Flour-l'Étang",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Saint-Gal-sur-Sioule",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63122",
    "ville": "Saint-Genès-Champanelle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63850",
    "ville": "Saint-Genès-Champespe",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Saint-Genès-du-Retz",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Saint-Genès-la-Tourette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63780",
    "ville": "Saint-Georges-de-Mons",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63800",
    "ville": "Saint-Georges-sur-Allier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Saint-Germain-près-Herment",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Saint-Germain-Lembron",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63630",
    "ville": "Saint-Germain-l'Herm",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Saint-Gervais-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63880",
    "ville": "Saint-Gervais-sous-Meymont",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Saint-Gervazy",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Saint-Hérent",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Saint-Hilaire-la-Croix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Saint-Hilaire-les-Monges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Saint-Hilaire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Saint-Ignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Saint-Jacques-d'Ambur",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Saint-Jean-d'Heurs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Saint-Jean-des-Ollières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Saint-Jean-en-Val",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Saint-Jean-Saint-Gervais",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63160",
    "ville": "Saint-Julien-de-Coppel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Saint-Julien-la-Geneste",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63820",
    "ville": "Saint-Julien-Puy-Lavèze",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Saint-Just",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Saint-Laure",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Saint-Maigner",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Saint-Martin-des-Olmes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63570",
    "ville": "Saint-Martin-des-Plains",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Saint-Martin-d'Ollières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Saint-Maurice-près-Pionsat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Saint-Maurice",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Saint-Myon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63710",
    "ville": "Saint-Nectaire",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Saint-Ours",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Saint-Pardoux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63610",
    "ville": "Saint-Pierre-Colamine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63480",
    "ville": "Saint-Pierre-la-Bourlhonne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63230",
    "ville": "Saint-Pierre-le-Chastel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Saint-Pierre-Roche",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Saint-Priest-Bramefant",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63640",
    "ville": "Saint-Priest-des-Champs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Saint-Quentin-sur-Sauxillanges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Saint-Quintin-sur-Sioule",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63440",
    "ville": "Saint-Rémy-de-Blot",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Saint-Rémy-de-Chargnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63550",
    "ville": "Saint-Rémy-sur-Durolle",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63660",
    "ville": "Saint-Romain",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Saint-Sandoux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Saint-Saturnin",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63950",
    "ville": "Saint-Sauves-d'Auvergne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63220",
    "ville": "Saint-Sauveur-la-Sagne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63760",
    "ville": "Saint-Sulpice",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Saint-Sylvestre-Pragoulin",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63790",
    "ville": "Saint-Victor-la-Rivière",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63550",
    "ville": "Saint-Victor-Montvianeix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Saint-Vincent",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Saint-Yvoine",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Sallèdes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Sardon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63970",
    "ville": "Saulzet-le-Froid",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63390",
    "ville": "Sauret-Besserve",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Saurier",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Sauvagnat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Sauvagnat-Sainte-Marthe",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63840",
    "ville": "Sauvessanges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63730",
    "ville": "La Sauvetat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Sauviat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Sauxillanges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63750",
    "ville": "Savennes",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63530",
    "ville": "Sayat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Sermentizon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63560",
    "ville": "Servant",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63190",
    "ville": "Seychalles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63690",
    "ville": "Singles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Solignat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Sugères",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Surat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63450",
    "ville": "Tallende",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63690",
    "ville": "Tauves",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63460",
    "ville": "Teilhède",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63560",
    "ville": "Teilhet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Ternant-les-Eaux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63300",
    "ville": "Thiers",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Thiolières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Thuret",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Tortebesse",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63590",
    "ville": "Tours-sur-Meymont",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Tourzel-Ronzières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Tralaigues",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63810",
    "ville": "Trémouille-Saint-Loup",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63520",
    "ville": "Trézioux",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63490",
    "ville": "Usson",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63610",
    "ville": "Valbeleix",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63600",
    "ville": "Valcivières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Valz-sous-Châteauneuf",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63720",
    "ville": "Varennes-sur-Morge",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Varennes-sur-Usson",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63910",
    "ville": "Vassel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63260",
    "ville": "Vensat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Vergheas",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63580",
    "ville": "Le Vernet-Chaméane",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63710",
    "ville": "Le Vernet-Sainte-Marguerite",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63470",
    "ville": "Verneugheol",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63210",
    "ville": "Vernines",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63320",
    "ville": "Verrières",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63910",
    "ville": "Vertaizon",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63480",
    "ville": "Vertolaye",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63960",
    "ville": "Veyre-Monton",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Vichel",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Vic-le-Comte",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63340",
    "ville": "Villeneuve",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63310",
    "ville": "Villeneuve-les-Cerfs",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63380",
    "ville": "Villossanges",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63350",
    "ville": "Vinzelles",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63330",
    "ville": "Virlet",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63250",
    "ville": "Viscomtat",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63410",
    "ville": "Vitrac",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63840",
    "ville": "Viverols",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63500",
    "ville": "Vodable",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63620",
    "ville": "Voingt",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Vollore-Montagne",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63120",
    "ville": "Vollore-Ville",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63530",
    "ville": "Volvic",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63700",
    "ville": "Youx",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63270",
    "ville": "Yronde-et-Buron",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "63200",
    "ville": "Yssac-la-Tourette",
    "dep": "Puy-de-Dôme"
  },
  {
    "code": "64460",
    "ville": "Aast",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Abère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Abidos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Abitain",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Abos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Accous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Agnos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Ahaxe-Alciette-Bascassan",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64210",
    "ville": "Ahetze",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Aïcirits-Camou-Suhast",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Aincille",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Ainharp",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Ainhice-Mongelos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Ainhoa",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Alçay-Alçabéhéty-Sunharette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64430",
    "ville": "Aldudes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Alos-Sibas-Abense",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Amendeuix-Oneix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Amorots-Succos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Andoins",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Andrein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Angaïs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64600",
    "ville": "Anglet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Angous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Anhaux",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Anos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Anoye",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Aramits",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Arancou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Araujuzon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Araux",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Arbérats-Sillègue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64210",
    "ville": "Arbonne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Arbouet-Sussaute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Arbus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64200",
    "ville": "Arcangues",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Aren",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Arette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Aressy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Argagnon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Argelos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Arget",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Arhansus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Armendarits",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Arnéguy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Arnos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Aroue-Ithorots-Olhaïby",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Arrast-Larrebieu",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Arraute-Charritte",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Arricau-Bordes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Arrien",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Arros-de-Nay",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Arrosès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Arthez-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Arthez-d'Asson",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Artigueloutan",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Artiguelouve",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Artix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Arudy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Arzacq-Arraziguet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64660",
    "ville": "Asasp-Arros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64310",
    "ville": "Ascain",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Ascarat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Assat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Asson",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Aste-Béon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Astis",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Athos-Aspis",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Aubertin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Aubin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Aubous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Audaux",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Auga",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Auriac",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Aurions-Idernes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Aussevielle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Aussurucq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Auterrive",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Autevielle-Saint-Martin-Bideren",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Aydie",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Aydius",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Ayherre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Baigts-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Balansun",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Baleix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Baliracq-Maumusson",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Baliros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64430",
    "ville": "Banca",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Barcus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64520",
    "ville": "Bardos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Barinque",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Barraute-Camu",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64530",
    "ville": "Barzun",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Bassillon-Vauzé",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Bastanès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64200",
    "ville": "Bassussarry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Baudreix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64100",
    "ville": "Bayonne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Bédeille",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Bedous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Béguios",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Béhasque-Lapiste",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Béhorléguy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Bellocq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Bénéjacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64440",
    "ville": "Béost",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Bentayou-Sérée",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Bérenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Bergouey-Viellenave",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Bernadets",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Berrogain-Laruns",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Bescat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Bésingrand",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Bétracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Beuste",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Beyrie-sur-Joyeuse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Beyrie-en-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64200",
    "ville": "Biarritz",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64520",
    "ville": "Bidache",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64780",
    "ville": "Bidarray",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64210",
    "ville": "Bidart",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Bidos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Bielle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Bilhères",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64140",
    "ville": "Billère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64700",
    "ville": "Biriatou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Biron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Bizanos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Boeil-Bezing",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Bonloc",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Bonnut",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Borce",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Bordères",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Bordes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Bosdarros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64340",
    "ville": "Boucau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Boueilh-Boueilho-Lasque",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Bougarber",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Bouillon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Boumourt",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Bourdettes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Bournos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Briscous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Bruges-Capbis-Mifaget",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Bugnein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Bunus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Burgaronne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Buros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Burosse-Mendousse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Bussunarits-Sarrasquette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Bustince-Iriberry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64680",
    "ville": "Buziet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Buzy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Cabidos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Cadillon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Cambo-les-Bains",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64520",
    "ville": "Came",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Camou-Cihigue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Cardesse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Caro",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Carrère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Carresse-Cassaber",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Castagnède",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Casteide-Cami",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Casteide-Candau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Casteide-Doat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Castéra-Loubix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Castet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Castetbon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Castétis",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Castetnau-Camblong",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Castetner",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Castetpugon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Castillon (Canton d'Arthez-de-Béarn)",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Castillon (Canton de Lembeye)",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Caubios-Loos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Cescau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Cette-Eygun",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Charre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Charritte-de-Bas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Chéraute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64500",
    "ville": "Ciboure",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Claracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Coarraze",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Conchez-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Corbère-Abères",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Coslédaà-Lube-Boast",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Coublucq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Crouseilles",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Cuqueron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Denguin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Diusse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Doazon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Dognen",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Domezain-Berraute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Doumy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64440",
    "ville": "Eaux-Bonnes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Escos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Escot",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64870",
    "ville": "Escou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Escoubès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64870",
    "ville": "Escout",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Escurès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Eslourenties-Daban",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Espéchède",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Espelette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Espès-Undurein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Espiute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Espoey",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Esquiule",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Estérençuby",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Estialescq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Estos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Etcharry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Etchebar",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Etsaut",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Eysus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Ance Féas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Fichous-Riumayou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Gabaston",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Gabat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Gamarthe",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Gan",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Garindein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Garlède-Mondebat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Garlin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Garos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Garris",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Gayon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Gelos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64530",
    "ville": "Ger",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Gerderest",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Gère-Bélesten",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Géronce",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Gestas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Géus-d'Arzacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Geüs-d'Oloron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Goès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Gomer",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Gotein-Libarrenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64210",
    "ville": "Guéthary",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64520",
    "ville": "Guiche",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Guinarthe-Parenties",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Gurmençon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Gurs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Hagetaubin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64480",
    "ville": "Halsou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Hasparren",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Haut-de-Bosdarros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Haux",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Hélette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64700",
    "ville": "Hendaye",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64680",
    "ville": "Herrère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Higuères-Souye",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "L'Hôpital-d'Orion",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "L'Hôpital-Saint-Blaise",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Hosta",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Hours",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Ibarrolle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Idaux-Mendy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Idron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Igon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Iholdy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Ilharre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64780",
    "ville": "Irissarry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Irouléguy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Ispoure",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Issor",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Isturits",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Itxassou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Izeste",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Jasses",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64480",
    "ville": "Jatxou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Jaxu",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Jurançon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Juxue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Laà-Mondrans",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Laàs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Labastide-Cézéracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "La Bastide-Clairence",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Labastide-Monréjeau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Labastide-Villefranche",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64530",
    "ville": "Labatmale",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Labatut-Figuières",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Labets-Biscay",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Labeyrie",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Lacadée",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Lacarre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Lacarry-Arhan-Charritte-de-Haut",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Lacommande",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Lacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Lagor",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Lagos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Laguinge-Restoue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64990",
    "ville": "Lahonce",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Lahontan",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Lahourcade",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lalongue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Lalonquette",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Lamayou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Lanne-en-Barétous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lannecaube",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Lanneplaà",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Lantabat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Larceveau-Arros-Cibits",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Laroin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64560",
    "ville": "Larrau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64480",
    "ville": "Larressore",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Larreule",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Larribar-Sorhapuru",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64440",
    "ville": "Laruns",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Lasclaveries",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Lasse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lasserre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Lasseube",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64290",
    "ville": "Lasseubetat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Lay-Lamidou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Lecumberry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Ledeuix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Lée",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Lées-Athas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lembeye",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Lème",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Léren",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Lescar",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Lescun",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lespielle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Lespourcy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Lestelle-Bétharram",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Lichans-Sunhar",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Lichos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64560",
    "ville": "Licq-Athérey",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Limendous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64530",
    "ville": "Livron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Lohitzun-Oyhercq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Lombia",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Lonçon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64140",
    "ville": "Lons",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Loubieng",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Louhossoa",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64570",
    "ville": "Lourdios-Ichère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Lourenties",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Louvie-Juzon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64440",
    "ville": "Louvie-Soubiron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Louvigny",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Luc-Armau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Lucarré",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Lucgarier",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Lucq-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64660",
    "ville": "Lurbe-Saint-Christau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Lussagnet-Lusson",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Luxe-Sumberraute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Lys",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Macaye",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Malaussanne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Mascaraàs-Haron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Maslacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Masparraute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Maspie-Lalonquère-Juillacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Maucor",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Mauléon-Licharre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Maure",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Mazères-Lezons",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Mazerolles",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Méharin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Meillon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Mendionde",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Menditte",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Mendive",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Méracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Méritein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Mesplède",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Mialos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Miossens-Lanusse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Mirepeix",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Momas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Momy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Monassut-Audiracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Moncaup",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Moncayolle-Larrory-Mendibieu",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Moncla",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Monein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Monpezat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Monségur",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Mont",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Montagut",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Montaner",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64121",
    "ville": "Montardon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Montaut",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Mont-Disse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Montfort",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Montory",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Morlaàs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Morlanne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64990",
    "ville": "Mouguerre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Mouhous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Moumour",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Mourenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Musculdy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Nabas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64510",
    "ville": "Narcastet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Narp",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Navailles-Angos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Navarrenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Nay",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Noguères",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Nousty",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Ogenne-Camptort",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64680",
    "ville": "Ogeu-les-Bains",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Oloron-Sainte-Marie",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Oraàs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Ordiarp",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Orègue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Orin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Orion",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Orriule",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Orsanco",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Orthez",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Os-Marsillon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Ossas-Suhare",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Osse-en-Aspe",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Ossenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Osserain-Rivareyte",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64780",
    "ville": "Ossès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Ostabat-Asme",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Ouillon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Ousse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Ozenx-Montestrucq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Pagolle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Parbayse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Pardies",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Pardies-Piétat",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64000",
    "ville": "Pau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Peyrelongue-Abos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Piets-Plasence-Moustrou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Poey-de-Lescar",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Poey-d'Oloron",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Pomps",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Ponson-Debat-Pouts",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Ponson-Dessus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64530",
    "ville": "Pontacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64460",
    "ville": "Pontiacq-Viellepinte",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Portet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Pouliacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Poursiugues-Boucoue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Préchacq-Josbaig",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Préchacq-Navarrenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Précilhon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Puyoô",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Ramous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Rébénacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Ribarrouy",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Riupeyrous",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Rivehaute",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Rontignon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Roquiague",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Saint-Abit",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Saint-Armou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Saint-Boès",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Saint-Castin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Sainte-Colome",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Saint-Dos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64560",
    "ville": "Sainte-Engrâce",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Saint-Esteben",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64430",
    "ville": "Saint-Étienne-de-Baïgorry",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Saint-Faust",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Saint-Girons-en-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Saint-Gladie-Arrive-Munein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Saint-Goin",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Saint-Jammes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64500",
    "ville": "Saint-Jean-de-Luz",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Saint-Jean-le-Vieux",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Saint-Jean-Pied-de-Port",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Saint-Jean-Poudge",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Saint-Just-Ibarre",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Saint-Laurent-Bretagne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64640",
    "ville": "Saint-Martin-d'Arberoue",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64780",
    "ville": "Saint-Martin-d'Arrossa",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Saint-Médard",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Saint-Michel",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Saint-Palais",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Saint-Pé-de-Léren",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64310",
    "ville": "Saint-Pée-sur-Nivelle",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64990",
    "ville": "Saint-Pierre-d'Irube",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64800",
    "ville": "Saint-Vincent",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64270",
    "ville": "Salies-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Salles-Mongiscard",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Sallespisse",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64520",
    "ville": "Sames",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Samsons-Lion",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64310",
    "ville": "Sare",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Sarpourenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Sarrance",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Saubole",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Saucède",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Sauguis-Saint-Étienne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64300",
    "ville": "Sault-de-Navailles",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Sauvagnon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Sauvelade",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64390",
    "ville": "Sauveterre-de-Béarn",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Séby",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Sedze-Maubecq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Sedzère",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Séméacq-Blachon",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64320",
    "ville": "Sendets",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64121",
    "ville": "Serres-Castet",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Serres-Morlaàs",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Serres-Sainte-Marie",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64260",
    "ville": "Sévignacq-Meyracq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Sévignacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64350",
    "ville": "Simacourbe",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Siros",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64420",
    "ville": "Soumoulou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64250",
    "ville": "Souraïde",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64780",
    "ville": "Suhescun",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Sus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Susmiou",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Tabaille-Usquain",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Tadousse-Ussau",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Tardets-Sorholus",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Taron-Sadirac-Viellenave",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64360",
    "ville": "Tarsacq",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Thèze",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64470",
    "ville": "Trois-Villes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64220",
    "ville": "Uhart-Cize",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64120",
    "ville": "Uhart-Mixe",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64990",
    "ville": "Urcuit",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64490",
    "ville": "Urdos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64430",
    "ville": "Urepel",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64160",
    "ville": "Urost",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64700",
    "ville": "Urrugne",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64240",
    "ville": "Urt",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64480",
    "ville": "Ustaritz",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64370",
    "ville": "Uzan",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64230",
    "ville": "Uzein",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64110",
    "ville": "Uzos",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64400",
    "ville": "Verdets",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64330",
    "ville": "Vialer",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64170",
    "ville": "Viellenave-d'Arthez",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64190",
    "ville": "Viellenave-de-Navarrenx",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64150",
    "ville": "Vielleségure",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64410",
    "ville": "Vignes",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64990",
    "ville": "Villefranque",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64130",
    "ville": "Viodos-Abense-de-Bas",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "64450",
    "ville": "Viven",
    "dep": "Pyrénées-Atlantiques"
  },
  {
    "code": "65260",
    "ville": "Adast",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Adé",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Adervielle-Pouchergues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Agos-Vidalos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Allier",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65440",
    "ville": "Ancizan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65390",
    "ville": "Andrest",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Anères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65690",
    "ville": "Angos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Les Angles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Anla",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Ansost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Antichan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Antin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Antist",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Aragnouet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65560",
    "ville": "Arbéost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Arcizac-Adour",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Arcizac-ez-Angles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Arcizans-Avant",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Arcizans-Dessus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Ardengost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Argelès-Bagnères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Argelès-Gazost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Aries-Espénan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Arné",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Arras-en-Lavedan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Arreau",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Arrens-Marsous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Arrodets-ez-Angles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Arrodets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Artagnan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Artalens-Souin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Artiguemy",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Artigues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Aspin-Aure",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Aspin-en-Lavedan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Asque",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Asté",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Astugue",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Aubarède",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Aucun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Aulon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65800",
    "ville": "Aureilhan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65390",
    "ville": "Aurensan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Auriébat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Avajan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65660",
    "ville": "Aventignan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Averan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Aveux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Avezac-Prat-Lahitte",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Ayros-Arbouix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Ayzac-Ost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Azereix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Azet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Bagnères-de-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Banios",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Barbachen",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65690",
    "ville": "Barbazan-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Barbazan-Dessus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Bareilles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Barlest",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Barrancoueu",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Barry",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Barthe",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "La Barthe-de-Neste",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Bartrès",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Batsère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65460",
    "ville": "Bazet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Bazillac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Bazordan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Bazus-Aure",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Bazus-Neste",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Beaucens",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65710",
    "ville": "Beaudéan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Bégole",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Bénac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Benqué-Molère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Berbérust-Lias",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Bernac-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Bernac-Dessus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Bernadets-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Bernadets-Dessus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Bertren",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Betbèze",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Betpouey",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Betpouy",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Bettes",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65410",
    "ville": "Beyrède-Jumet-Camous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Bize",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Bizous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Bonnefont",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Bonnemazon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Bonrepos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Boô-Silhen",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65590",
    "ville": "Bordères-Louron",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Bordères-sur-l'Échez",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Bordes",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Bouilh-Devant",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Bouilh-Péreuilh",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Boulin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Bourg-de-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Bourisp",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Bourréac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65460",
    "ville": "Bours",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Bramevaque",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Bugard",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Bulan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Bun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Burg",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Buzon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Cabanac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Cadéac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Cadeilhan-Trachère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Caharet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Caixon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Calavanté",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Camalès",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65710",
    "ville": "Campan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Camparan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Campistrous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Campuzan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Capvern",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Castelbajac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Castelnau-Magnoac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Castelnau-Rivière-Basse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Castelvieilh",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Castéra-Lanusse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Castéra-Lou",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Casterets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Castillon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Caubous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Caussade-Rivière",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65110",
    "ville": "Cauterets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Cazarilh",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65590",
    "ville": "Cazaux-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Cazaux-Fréchet-Anéran-Camors",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Chelle-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Chelle-Spou",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Cheust",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Chèze",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65800",
    "ville": "Chis",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Cieutat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Cizos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Clarac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Clarens",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Collongues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Coussan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Créchets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Devèze",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Dours",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Ens",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Esbareich",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Escala",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Escaunets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Escondeaux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Esconnets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Escots",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Escoubès-Pouts",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Esparros",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Espèche",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Espieilh",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Esquièze-Sère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Estaing",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Estampures",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Estarvielle",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Estensan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Esterre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Estirac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Ferrère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65560",
    "ville": "Ferrières",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Fontrailles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Fréchède",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Fréchendets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Fréchet-Aure",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Fréchou-Fréchet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Gaillagos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Galan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Galez",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Gardères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Gaudent",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Gaussan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Gayan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Gazave",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Gazost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Gavarnie-Gèdre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Gembrie",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Générest",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Génos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Gensac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ger",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Gerde",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Germ",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Germs-sur-l'Oussouet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Geu",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Gez",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Gez-ez-Angles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Gonez",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Gouaux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Goudon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Gourgue",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Grailhen",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Grézian",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Grust",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Guchan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Guchen",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Guizerix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Hachan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Hagedet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Hauban",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Hautaget",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Hèches",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Hères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Hibarette",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Hiis",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Hitte",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65310",
    "ville": "Horgues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Houeydets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Hourc",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65420",
    "ville": "Ibos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65410",
    "ville": "Ilhet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Ilheu",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Izaourt",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Izaux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Jacque",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Jarret",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Jézeau",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65290",
    "ville": "Juillan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Julos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Juncalas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Labassère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Labastide",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Labatut-Rivière",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Laborde",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Lacassagne",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Lafitole",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Lagarde",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Lagrange",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Arrayou-Lahitte",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Lahitte-Toupière",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Lalanne",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Lalanne-Trie",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65310",
    "ville": "Laloubère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Lamarque-Pontacq",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Lamarque-Rustaing",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Laméac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Lançon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Lanespède",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Lanne",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Lannemezan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Lansac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Lapeyre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Laran",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Larreule",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Larroque",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Lascazères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Laslades",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Lassales",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Lau-Balagnas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Layrisse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Lescurry",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Lespouey",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Lézignan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Lhez",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Liac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Libaros",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Lies",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Lizos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Lombrès",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Lomné",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Lortet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Loubajac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Loucrup",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65510",
    "ville": "Loudenvielle",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Loudervielle",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65290",
    "ville": "Louey",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Louit",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Lourdes",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Loures-Barousse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Lubret-Saint-Luc",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Luby-Betmont",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Luc",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Lugagnan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Luquet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Lustar",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Lutilhous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Luz-Saint-Sauveur",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Madiran",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Mansan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Marquerie",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Marsac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Marsas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Marseillan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Mascaras",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Maubourguet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Mauléon-Barousse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Mauvezin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Mazères-de-Neste",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Mazerolles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Mazouau",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Mérilheu",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Mingot",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Momères",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Monfaucon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Monléon-Magnoac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65670",
    "ville": "Monlong",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Mont",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Montastruc",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Montégut",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Montgaillard",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65690",
    "ville": "Montignac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Montoussé",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Montsérié",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Moulédous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Moumoulous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Mun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Nestier",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Neuilh",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Nistos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Nouilhan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65310",
    "ville": "Odos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Oléac-Debat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Oléac-Dessus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Omex",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Ordizan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Organ",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Orieux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Orignac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Orincles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65800",
    "ville": "Orleix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Oroix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Osmets",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ossen",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65380",
    "ville": "Ossun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ossun-ez-Angles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Oueilloux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Ourde",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ourdis-Cotdoussan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ourdon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65490",
    "ville": "Oursbelille",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ousté",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Ouzous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Ozon",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Pailhac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Paréac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Péré",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Peyraube",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Peyret-Saint-André",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Peyriguère",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65270",
    "ville": "Peyrouse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Peyrun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65260",
    "ville": "Pierrefitte-Nestalas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Pinas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Pintac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Poueyferré",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Poumarous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Pouy",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Pouyastruc",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Pouzac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Préchac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Pujo",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Puntous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Puydarrieux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Rabastens-de-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Recurt",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Réjaumont",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Ricaud",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65590",
    "ville": "Ris",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Sabalos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Sabarros",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Sacoué",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Sadournin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Sailhan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65250",
    "ville": "Saint-Arroman",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Saint-Créac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Saint-Lanne",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Saint-Lary-Soulan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Saint-Laurent-de-Neste",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Saint-Lézer",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Sainte-Marie",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Saint-Martin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Saint-Pastous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Saint-Paul",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65270",
    "ville": "Saint-Pé-de-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Saint-Savin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Saint-Sever-de-Rustan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Saléchan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Saligos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Salles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Salles-Adour",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Samuran",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Sanous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Sariac-Magnoac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Sarlabous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65390",
    "ville": "Sarniguet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Sarp",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65410",
    "ville": "Sarrancolin",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Sarriac-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65600",
    "ville": "Sarrouilles",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Sassis",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Sauveterre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Sazos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Ségalas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Ségus",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Seich",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65600",
    "ville": "Séméac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Sénac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Sentous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Sère-en-Lavedan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Sère-Lanso",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Séron",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Sère-Rustaing",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Sers",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Siarrouy",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Sinzos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Siradan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Sireix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Sombrun",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Soréac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Sost",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Soublecause",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65430",
    "ville": "Soues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65260",
    "ville": "Soulom",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Souyeaux",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Tajan",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Talazac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65320",
    "ville": "Tarasteix",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65000",
    "ville": "Tarbes",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Thèbe",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Thermes-Magnoac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65350",
    "ville": "Thuy",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Tibiran-Jaunac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65130",
    "ville": "Tilhouse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Tostat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65190",
    "ville": "Tournay",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Tournous-Darré",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65330",
    "ville": "Tournous-Devant",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Tramezaïgues",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Trébons",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Trie-sur-Baïse",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65370",
    "ville": "Troubat",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Trouley-Labarthe",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Tuzaguet",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65300",
    "ville": "Uglas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65140",
    "ville": "Ugnouas",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Uz",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Uzer",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Vic-en-Bigorre",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Vidou",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Vidouze",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Viella",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65360",
    "ville": "Vielle-Adour",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Vielle-Aure",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65240",
    "ville": "Vielle-Louron",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65400",
    "ville": "Vier-Bordes",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Vieuzos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Viey",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65100",
    "ville": "Viger",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65170",
    "ville": "Vignec",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65700",
    "ville": "Villefranque",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65260",
    "ville": "Villelongue",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65220",
    "ville": "Villembits",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65230",
    "ville": "Villemur",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Villenave-près-Béarn",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65500",
    "ville": "Villenave-près-Marsac",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Viscos",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65200",
    "ville": "Visker",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65120",
    "ville": "Barèges",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "65150",
    "ville": "Cantaous",
    "dep": "Hautes-Pyrénées"
  },
  {
    "code": "66480",
    "ville": "L'Albère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Alénya",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66110",
    "ville": "Amélie-les-Bains-Palalda",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Les Angles",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Angoustrine-Villeneuve-des-Escaldes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Ansignan",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Arboussols",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66700",
    "ville": "Argelès-sur-Mer",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66150",
    "ville": "Arles-sur-Tech",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Ayguatébia-Talau",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66670",
    "ville": "Bages",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66540",
    "ville": "Baho",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Baillestavy",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66390",
    "ville": "Baixas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Banyuls-dels-Aspres",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66650",
    "ville": "Banyuls-sur-Mer",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66420",
    "ville": "Le Barcarès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66110",
    "ville": "La Bastide",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Bélesta",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Bolquère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66430",
    "ville": "Bompas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Boule-d'Amont",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Bouleternère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66160",
    "ville": "Le Boulou",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Bourg-Madame",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66620",
    "ville": "Brouilla",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "La Cabanasse",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66330",
    "ville": "Cabestany",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Caixas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Calce",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66400",
    "ville": "Calmeilles",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Camélas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Campôme",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Campoussy",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Canaveilles",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66140",
    "ville": "Canet-en-Roussillon",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66680",
    "ville": "Canohès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Caramany",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Casefabre",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Cases-de-Pène",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Cassagnes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66820",
    "ville": "Casteil",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Castelnou",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Catllar",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Caudiès-de-Fenouillèdes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Caudiès-de-Conflent",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66290",
    "ville": "Cerbère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66400",
    "ville": "Céret",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66530",
    "ville": "Claira",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Clara-Villerach",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Codalet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66190",
    "ville": "Collioure",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Conat",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Corbère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Corbère-les-Cabanes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66820",
    "ville": "Corneilla-de-Conflent",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66550",
    "ville": "Corneilla-la-Rivière",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Corneilla-del-Vercol",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66150",
    "ville": "Corsavy",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66260",
    "ville": "Coustouges",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Dorres",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66480",
    "ville": "Les Cluses",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66120",
    "ville": "Égat",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Elne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Enveitg",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Err",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Escaro",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Espira-de-l'Agly",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Espira-de-Conflent",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66310",
    "ville": "Estagel",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Estavar",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Estoher",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Eus",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Eyne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Feilluns",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Fenouillet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66820",
    "ville": "Fillols",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Finestret",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Fontpédrouse",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Fontrabiouse",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Formiguères",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Fosse",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Fourques",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66820",
    "ville": "Fuilla",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Glorianes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Ille-sur-Têt",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Joch",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Jujols",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66230",
    "ville": "Lamanère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Lansac",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66740",
    "ville": "Laroque-des-Albères",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Latour-Bas-Elne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Latour-de-Carol",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Latour-de-France",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Lesquerde",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "La Llagonne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Llauro",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Llo",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Llupia",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Mantet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Marquixanes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Los Masos",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Matemale",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66480",
    "ville": "Maureillas-las-Illas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66460",
    "ville": "Maury",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66170",
    "ville": "Millas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Molitg-les-Bains",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Montalba-le-Château",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Montauriol",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66110",
    "ville": "Montbolo",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Montescot",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66740",
    "ville": "Montesquieu-des-Albères",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66150",
    "ville": "Montferrer",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Mont-Louis",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Montner",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Mosset",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66340",
    "ville": "Nahuja",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66170",
    "ville": "Néfiach",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Nohèdes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Nyer",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66120",
    "ville": "Font-Romeu-Odeillo-Via",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Olette",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66400",
    "ville": "Oms",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Opoul-Périllos",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Oreilla",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66560",
    "ville": "Ortaffa",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66340",
    "ville": "Osséja",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66340",
    "ville": "Palau-de-Cerdagne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66690",
    "ville": "Palau-del-Vidre",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Passa",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66000",
    "ville": "Perpignan",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66480",
    "ville": "Le Perthus",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Peyrestortes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Pézilla-de-Conflent",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66370",
    "ville": "Pézilla-la-Rivière",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66380",
    "ville": "Pia",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Planès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Planèzes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66450",
    "ville": "Pollestres",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Ponteilla",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Porta",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Porté-Puymorens",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66660",
    "ville": "Port-Vendres",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Prades",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66230",
    "ville": "Prats-de-Mollo-la-Preste",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Prats-de-Sournia",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Prugnanes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Prunet-et-Belpuig",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Puyvalador",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Py",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Rabouillet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Railleu",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Rasiguères",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Réal",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66400",
    "ville": "Reynès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Ria-Sirach",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Rigarda",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Rivesaltes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Rodès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Sahorre",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Saillagouse",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66690",
    "ville": "Saint-André",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Saint-Arnac",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Sainte-Colombe-de-la-Commanderie",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66750",
    "ville": "Saint-Cyprien",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66240",
    "ville": "Saint-Estève",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66170",
    "ville": "Saint-Féliu-d'Amont",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66170",
    "ville": "Saint-Féliu-d'Avall",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66740",
    "ville": "Saint-Génis-des-Fontaines",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66510",
    "ville": "Saint-Hippolyte",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Saint-Jean-Lasseille",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66490",
    "ville": "Saint-Jean-Pla-de-Corts",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66260",
    "ville": "Saint-Laurent-de-Cerdans",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66250",
    "ville": "Saint-Laurent-de-la-Salanque",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66800",
    "ville": "Sainte-Léocadie",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66470",
    "ville": "Sainte-Marie-la-Mer",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66110",
    "ville": "Saint-Marsal",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Saint-Martin-de-Fenouillet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Saint-Michel-de-Llotes",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66570",
    "ville": "Saint-Nazaire",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Saint-Paul-de-Fenouillet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Saint-Pierre-dels-Forcats",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66280",
    "ville": "Saleilles",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Salses-le-Château",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Sansa",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66210",
    "ville": "Sauto",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Serdinya",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66230",
    "ville": "Serralongue",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66270",
    "ville": "Le Soler",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66690",
    "ville": "Sorède",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Souanyas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Sournia",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66400",
    "ville": "Taillet",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Tarerach",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66120",
    "ville": "Targasonne",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66110",
    "ville": "Taulis",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Taurinya",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66720",
    "ville": "Tautavel",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66230",
    "ville": "Le Tech",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Terrats",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66200",
    "ville": "Théza",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66360",
    "ville": "Thuès-Entre-Valls",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Thuir",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Tordères",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66440",
    "ville": "Torreilles",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66350",
    "ville": "Toulouges",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Tresserre",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66130",
    "ville": "Trévillach",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Trilla",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Trouillas",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66760",
    "ville": "Ur",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Urbanya",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66340",
    "ville": "Valcebollère",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Valmanya",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66820",
    "ville": "Vernet-les-Bains",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66500",
    "ville": "Villefranche-de-Conflent",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66410",
    "ville": "Villelongue-de-la-Salanque",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66740",
    "ville": "Villelongue-dels-Monts",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66300",
    "ville": "Villemolaque",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66180",
    "ville": "Villeneuve-de-la-Raho",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66610",
    "ville": "Villeneuve-la-Rivière",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66320",
    "ville": "Vinça",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66600",
    "ville": "Vingrau",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66220",
    "ville": "Vira",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66490",
    "ville": "Vivès",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "66730",
    "ville": "Le Vivier",
    "dep": "Pyrénées-Orientales"
  },
  {
    "code": "67204",
    "ville": "Achenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Adamswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Albé",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Sommerau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Alteckendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Altenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Altorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Altwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Andlau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Artolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Aschbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Asswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Avolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Baerendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Balbronn",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Baldenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Barembach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Barr",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Bassemberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67500",
    "ville": "Batzendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67930",
    "ville": "Beinheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Bellefosse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Belmont",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Benfeld",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Berg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Bergbieten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Bernardswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Bernardvillé",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Bernolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Berstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Berstheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Bettwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Biblisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67720",
    "ville": "Bietlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Bilwisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Bindernheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67800",
    "ville": "Bischheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Bischholtz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67870",
    "ville": "Bischoffsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Bischwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Bissert",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Bitschhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67113",
    "ville": "Blaesheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Blancherupt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67650",
    "ville": "Blienschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67530",
    "ville": "Bœrsch",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Bœsenbiesen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Bolsenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67860",
    "ville": "Boofzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Bootzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Bosselshausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Bossendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Bourg-Bruche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Bourgheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Bouxwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Breitenau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Breitenbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67112",
    "ville": "Breuschwickersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "La Broque",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Brumath",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Buswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Buhl",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Burbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Bust",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Butten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67730",
    "ville": "Châtenois",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Cleebourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67510",
    "ville": "Climbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Colroy-la-Roche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Cosswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Crastatt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Crœttwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Dachstein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Dahlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67770",
    "ville": "Dalhunden",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Dambach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67650",
    "ville": "Dambach-la-Ville",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Dangolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Daubensand",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Dauendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Dehlingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Dettwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Diebolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Diedendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Dieffenbach-au-Val",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Dieffenbach-lès-Wœrth",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67650",
    "ville": "Dieffenthal",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Diemeringen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Dimbsthal",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Dingsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Dinsheim-sur-Bruche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Domfessel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Donnenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Dorlisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Dossenheim-Kochersberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Dossenheim-sur-Zinsel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Drachenbronn-Birlenbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Drulingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67410",
    "ville": "Drusenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Duntzenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Duppigheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Durningen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Durrenbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Durstel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Duttlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Eberbach-Seltz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Ebersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Ebersmunster",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Eckartswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67201",
    "ville": "Eckbolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67550",
    "ville": "Eckwersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Eichhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Elsenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67710",
    "ville": "Wangenbourg-Engenthal",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Engwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67960",
    "ville": "Entzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67680",
    "ville": "Epfig",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Erckartswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Ergersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Ernolsheim-Bruche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Ernolsheim-lès-Saverne",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Erstein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67114",
    "ville": "Eschau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Eschbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Eschbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Eschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Ettendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Eywiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67640",
    "ville": "Fegersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Fessenheim-le-Bas",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Flexbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Forstfeld",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67580",
    "ville": "Forstheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Fort-Louis",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Fouchy",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Fouday",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Friedolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67860",
    "ville": "Friesenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Frœschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Frohmuhl",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Furchhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Furdenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67760",
    "ville": "Gambsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67118",
    "ville": "Geispolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Geiswiller-Zœbersdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Gerstheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Gertwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Geudertheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Gœrlingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Gœrsdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Gottenhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Gottesheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Gougenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Goxwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Grandfontaine",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Grassendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Grendelbruch",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Gresswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Gries",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67870",
    "ville": "Griesheim-près-Molsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Griesheim-sur-Souffel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Gumbrechtshoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Gundershoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Gunstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Gungwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Haegen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67500",
    "ville": "Haguenau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Handschuheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67980",
    "ville": "Hangenbieten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Harskirchen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67690",
    "ville": "Hatten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Hattmatt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Hegeney",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Heidolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Heiligenberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Heiligenstein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Hengwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Herbitzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Herbsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67850",
    "ville": "Herrlisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Hessenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Hilsenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Hindisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Hinsbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Hinsingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Hipsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Hirschland",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Hochfelden",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Hochstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67800",
    "ville": "Hœnheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67720",
    "ville": "Hœrdt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Hoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Hohengœft",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Hohfrankenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Le Hohwald",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67810",
    "ville": "Holtzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Hunspach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Hurtigheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Huttendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Huttenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67640",
    "ville": "Ichtratzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67400",
    "ville": "Illkirch-Graffenstaden",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Ingenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Ingolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Ingwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67880",
    "ville": "Innenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Issenhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Ittenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Itterswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Neugartheim-Ittlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Jetterswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Kaltenhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Kauffenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Keffenach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Kertzfeld",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Keskastel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67930",
    "ville": "Kesseldorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Kienheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67840",
    "ville": "Kilstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Kindwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Kintzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Kirchheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Kirrberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Kirrwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Kleingœft",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Knœrsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Kogenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Kolbsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67880",
    "ville": "Krautergersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Krautwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Kriegsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Kurtzenhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Kuttolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Kutzenhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Lalaye",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67450",
    "ville": "Lampertheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Lampertsloch",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Landersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Langensoultzbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67580",
    "ville": "Laubach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67630",
    "ville": "Lauterbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67510",
    "ville": "Lembach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Leutenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Lichtenberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Limersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67380",
    "ville": "Lingolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67640",
    "ville": "Lipsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Littenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Lixhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Lobsann",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Lochwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Lohr",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Lorentzen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Lupstein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Lutzelhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Mackenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Mackwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Maennolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Maisonsgoutte",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Marckolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Marlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Marmoutier",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Matzenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Meistratzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Melsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Memmelshoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Menchhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Merkwiller-Pechelbronn",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67580",
    "ville": "Mertzwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67580",
    "ville": "Mietesheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Minversheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Mittelbergheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67206",
    "ville": "Mittelhausbergen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Mittelschaeffolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Mollkirch",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Molsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67670",
    "ville": "Mommenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Monswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Morsbronn-les-Bains",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Morschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Mothern",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Muhlbach-sur-Bruche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Mulhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Munchhausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67450",
    "ville": "Mundolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Mussig",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Muttersholtz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Mutzenhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Mutzig",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Natzwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67630",
    "ville": "Neewiller-près-Lauterbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Neubois",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Neuhaeusel",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Neuve-Église",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Neuviller-la-Roche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Neuwiller-lès-Saverne",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Niederbronn-les-Bains",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67280",
    "ville": "Niederhaslach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67207",
    "ville": "Niederhausbergen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67630",
    "ville": "Niederlauterbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Niedermodern",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Niedernai",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Niederrœdern",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67500",
    "ville": "Niederschaeffolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Niedersoultzbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67510",
    "ville": "Niedersteinbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Nordheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Nordhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67680",
    "ville": "Nothalten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Obenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67660",
    "ville": "Betschdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Oberbronn",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Oberdorf-Spachbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67280",
    "ville": "Oberhaslach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67205",
    "ville": "Oberhausbergen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Oberhoffen-lès-Wissembourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Oberhoffen-sur-Moder",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Oberlauterbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Obermodern-Zutzendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Obernai",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Oberrœdern",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67203",
    "ville": "Oberschaeffolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Seebach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Obersoultzbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67510",
    "ville": "Obersteinbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Odratzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67970",
    "ville": "Oermingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67850",
    "ville": "Offendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Offwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67590",
    "ville": "Ohlungen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Ohnenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Olwisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Orschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67990",
    "ville": "Osthoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Osthouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67540",
    "ville": "Ostwald",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Ottersthal",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Otterswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67530",
    "ville": "Ottrott",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Ottwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Petersbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "La Petite-Pierre",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Val-de-Moder",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Pfalzweyer",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Pfulgriesheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Plaine",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67115",
    "ville": "Plobsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Preuschdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67490",
    "ville": "Printzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Puberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67117",
    "ville": "Quatzenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Rangen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Ranrupt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Ratzwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Rauwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Reichsfeld",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Reichshoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67116",
    "ville": "Reichstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Reinhardsmunster",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Reipertswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Retschwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Reutenbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Rexingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67860",
    "ville": "Rhinau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Richtolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Riedseltz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Rimsdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Ringendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67690",
    "ville": "Rittershoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Rœschwoog",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Rohr",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67410",
    "ville": "Rohrwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Romanswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Roppenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67560",
    "ville": "Rosenwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67560",
    "ville": "Rosheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Rossfeld",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Rosteig",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67570",
    "ville": "Rothau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Rothbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Rott",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Rottelsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67480",
    "ville": "Rountzenheim-Auenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Russ",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Saales",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Saasenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Saessolsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Saint-Blaise-la-Roche",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Saint-Jean-Saverne",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Saint-Martin",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Saint-Maurice",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67530",
    "ville": "Saint-Nabor",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Saint-Pierre",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Saint-Pierre-Bois",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Salmbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Sand",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Sarre-Union",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Sarrewerden",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67420",
    "ville": "Saulxures",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Saverne",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Schaeffersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Schaffhouse-près-Seltz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Schalkendorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Scharrachbergheim-Irmstett",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67630",
    "ville": "Scheibenhard",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Scherlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67750",
    "ville": "Scherwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Schillersdorf",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67300",
    "ville": "Schiltigheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Schirmeck",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Schirrhein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67240",
    "ville": "Schirrhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Schleithal",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Schnersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Schœnau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Schœnbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Schœnenbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Schopperten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67590",
    "ville": "Schweighouse-sur-Moder",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Schwenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Schwindratzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67390",
    "ville": "Schwobsheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67600",
    "ville": "Sélestat",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Seltz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Sermersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67770",
    "ville": "Sessenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Siegen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Siewiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Siltzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Solbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67460",
    "ville": "Souffelweyersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67620",
    "ville": "Soufflenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Soultz-les-Bains",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Soultz-sous-Forêts",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Sparsbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67770",
    "ville": "Stattmatten",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Steige",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67790",
    "ville": "Steinbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Steinseltz",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67190",
    "ville": "Still",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Stotzheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67000",
    "ville": "Strasbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Struth",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Stundwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Stutzheim-Offenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67920",
    "ville": "Sundhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67250",
    "ville": "Surbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Thal-Drulingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Thal-Marmoutier",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Thanvillé",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Tieffenbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Traenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Triembach-au-Val",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Trimbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Truchtersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Uhlwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67350",
    "ville": "Uhrwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Urbeis",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67280",
    "ville": "Urmatt",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67150",
    "ville": "Uttenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Uttenhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67330",
    "ville": "Uttwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67210",
    "ville": "Valff",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67730",
    "ville": "La Vancelle",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67550",
    "ville": "Vendenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67220",
    "ville": "Villé",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Vœllerdingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Volksberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Wahlenheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Walbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Waldersbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67430",
    "ville": "Waldhambach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Waldolwisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67670",
    "ville": "Waltenheim-sur-Zorn",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67520",
    "ville": "Wangen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67610",
    "ville": "La Wantzenau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Wasselonne",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Weinbourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Weislingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67500",
    "ville": "Weitbruch",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67340",
    "ville": "Weiterswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Westhoffen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Westhouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67440",
    "ville": "Westhouse-Marmoutier",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67320",
    "ville": "Weyer",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67720",
    "ville": "Weyersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Wickersheim-Wilshausen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Wildersbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Willgottheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67270",
    "ville": "Wilwisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Wimmenau",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Windstein",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67510",
    "ville": "Wingen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Wingen-sur-Moder",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67170",
    "ville": "Wingersheim les Quatre Bans",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67590",
    "ville": "Wintershouse",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67470",
    "ville": "Wintzenbach",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Wintzenheim-Kochersberg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67130",
    "ville": "Wisches",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67160",
    "ville": "Wissembourg",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67230",
    "ville": "Witternheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67670",
    "ville": "Wittersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67820",
    "ville": "Wittisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67370",
    "ville": "Wiwersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67360",
    "ville": "Wœrth",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67202",
    "ville": "Wolfisheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67260",
    "ville": "Wolfskirchen",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67700",
    "ville": "Wolschheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67120",
    "ville": "Wolxheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Zehnacker",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67310",
    "ville": "Zeinheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67140",
    "ville": "Zellwiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67110",
    "ville": "Zinswiller",
    "dep": "Bas-Rhin"
  },
  {
    "code": "67290",
    "ville": "Zittersheim",
    "dep": "Bas-Rhin"
  },
  {
    "code": "68600",
    "ville": "Algolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Altenach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Altkirch",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68410",
    "ville": "Ammerschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Bernwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68280",
    "ville": "Andolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68280",
    "ville": "Appenwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Artzenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Aspach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Aspach-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Aspach-Michelbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Attenschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68150",
    "ville": "Aubure",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68390",
    "ville": "Baldersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Balgau",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Ballersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Balschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Baltzenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68490",
    "ville": "Bantzenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68870",
    "ville": "Bartenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68390",
    "ville": "Battenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68980",
    "ville": "Beblenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Bellemagny",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Bendorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68630",
    "ville": "Bennwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Berentzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68750",
    "ville": "Bergheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Bergholtz",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Bergholtzzell",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Berrwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68560",
    "ville": "Bettendorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Bettlach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Biederthal",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Biesheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Biltzheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Bischwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Bisel",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68620",
    "ville": "Bitschwiller-lès-Thann",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Blodelsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68730",
    "ville": "Blotzheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68540",
    "ville": "Bollwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68650",
    "ville": "Le Bonhomme",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Bourbach-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Bourbach-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Bouxwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Bréchaumont",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68380",
    "ville": "Breitenbach-Haut-Rhin",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Bretten",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68870",
    "ville": "Brinckheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Bruebach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68350",
    "ville": "Brunstatt-Didenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Buethwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68530",
    "ville": "Buhl",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68520",
    "ville": "Burnhaupt-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68520",
    "ville": "Burnhaupt-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Buschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Carspach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Cernay",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68490",
    "ville": "Chalampé",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Chavannes-sur-l'Étang",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68000",
    "ville": "Colmar",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Courtavon",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Dannemarie",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Dessenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Diefmatten",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Dietwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Dolleren",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Durlinsdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Durmenach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Durrenentzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Eglingen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Eguisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Elbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Emlingen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Saint-Bernard",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68190",
    "ville": "Ensisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Eschbach-au-Val",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Eschentzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Eteimbes",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Falkwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Feldbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68540",
    "ville": "Feldkirch",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Fellering",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Ferrette",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Fessenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Fislis",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Flaxlanden",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Folgensbourg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Fortschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Franken",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68240",
    "ville": "Fréland",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Friesen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Frœningen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Fulleren",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68990",
    "ville": "Galfingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68690",
    "ville": "Geishouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Geispitzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Geiswasser",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Gildwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68760",
    "ville": "Goldbach-Altenbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Gommersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Griesbach-au-Val",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Grussenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Gueberschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Guebwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68970",
    "ville": "Guémar",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Guevenatten",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68116",
    "ville": "Guewenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68250",
    "ville": "Gundolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Gunsbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Habsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Hagenbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Hagenthal-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Hagenthal-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Hartmannswiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Hattstatt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Hausgauen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Hecken",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Hégenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Heidwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68560",
    "ville": "Heimersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68990",
    "ville": "Heimsbrunn",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Heiteren",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Heiwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Helfrantzkirch",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Herrlisheim-près-Colmar",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Hésingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Hettenschlag",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Hindlingen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68560",
    "ville": "Hirsingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68118",
    "ville": "Hirtzbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Hirtzfelden",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Hochstatt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Hohrod",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Porte du Ried",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68490",
    "ville": "Hombourg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68180",
    "ville": "Horbourg-Wihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68125",
    "ville": "Houssen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68150",
    "ville": "Hunawihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Hundsbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68330",
    "ville": "Huningue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Husseren-les-Châteaux",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Husseren-Wesserling",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Illfurth",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68970",
    "ville": "Illhaeusern",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68110",
    "ville": "Illzach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68040",
    "ville": "Ingersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Issenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Jebsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Jettingen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Jungholtz",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Kappelen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Katzenthal",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68240",
    "ville": "Kaysersberg Vignoble",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68680",
    "ville": "Kembs",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Kiffis",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68260",
    "ville": "Kingersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Kirchberg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Knœringue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Kœstlach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Kœtzingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68820",
    "ville": "Kruth",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Kunheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68910",
    "ville": "Labaroche",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Landser",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68650",
    "ville": "Lapoutroie",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Largitzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68610",
    "ville": "Lautenbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68610",
    "ville": "Lautenbachzell",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Lauw",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68800",
    "ville": "Leimbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Levoncourt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Leymen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Liebenswiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Liebsdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68660",
    "ville": "Lièpvre",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Ligsdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Linsdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68610",
    "ville": "Linthal",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68280",
    "ville": "Logelheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Lucelle",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Luemschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Valdieu-Lutran",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Luttenbach-près-Munster",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Lutter",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68460",
    "ville": "Lutterbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Magny",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Magstatt-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Magstatt-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68550",
    "ville": "Malmerspach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Manspach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Masevaux-Niederbruck",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Mertzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Merxheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68380",
    "ville": "Metzeral",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68890",
    "ville": "Meyenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68730",
    "ville": "Michelbach-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Michelbach-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68630",
    "ville": "Mittelwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68380",
    "ville": "Mittlach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Mitzach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Mœrnach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Mollau",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Montreux-Jeune",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Montreux-Vieux",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Mooslargue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68690",
    "ville": "Moosch",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68790",
    "ville": "Morschwiller-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Le Haut Soultzbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Muespach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Muespach-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68380",
    "ville": "Muhlbach-sur-Munster",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68200",
    "ville": "Mulhouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Munchhouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Munster",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Muntzenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68250",
    "ville": "Munwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68530",
    "ville": "Murbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Nambsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Neuf-Brisach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Neuwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Niederentzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Niederhergheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Niedermorschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68680",
    "ville": "Niffer",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Oberbruck",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68960",
    "ville": "Illtal",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Oberentzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Oberhergheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Oberlarg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Obermorschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Obermorschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Obersaasheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68830",
    "ville": "Oderen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Oltingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68370",
    "ville": "Orbey",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Orschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68570",
    "ville": "Osenbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68150",
    "ville": "Ostheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68490",
    "ville": "Ottmarsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68490",
    "ville": "Petit-Landau",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68250",
    "ville": "Pfaffenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68120",
    "ville": "Pfastatt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Pfetterhouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68840",
    "ville": "Pulversheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Raedersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68190",
    "ville": "Raedersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68800",
    "ville": "Rammersmatt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Ranspach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68730",
    "ville": "Ranspach-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Ranspach-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Rantzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68890",
    "ville": "Réguisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68950",
    "ville": "Reiningue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Retzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68150",
    "ville": "Ribeauvillé",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68120",
    "ville": "Richwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68400",
    "ville": "Riedisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Riespach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Rimbach-près-Guebwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Rimbach-près-Masevaux",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Rimbachzell",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68340",
    "ville": "Riquewihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68170",
    "ville": "Rixheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68800",
    "ville": "Roderen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68590",
    "ville": "Rodern",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Roggenhouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Romagny",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68660",
    "ville": "Rombach-le-Franc",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Roppentzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68590",
    "ville": "Rorschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68128",
    "ville": "Rosenau",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68250",
    "ville": "Rouffach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68560",
    "ville": "Ruederbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68270",
    "ville": "Ruelisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Rustenhart",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68740",
    "ville": "Rumersheim-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68550",
    "ville": "Saint-Amarin",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Saint-Cosme",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68160",
    "ville": "Sainte-Croix-aux-Mines",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68127",
    "ville": "Sainte-Croix-en-Plaine",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68590",
    "ville": "Saint-Hippolyte",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68300",
    "ville": "Saint-Louis",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68160",
    "ville": "Sainte-Marie-aux-Mines",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Saint-Ulrich",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68390",
    "ville": "Sausheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Schlierbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68520",
    "ville": "Schweighouse-Thann",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Schwoben",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Sentheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Seppois-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Seppois-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Sewen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Sickert",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Sierentz",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68380",
    "ville": "Sondernach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Sondersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Soppe-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68360",
    "ville": "Soultz-Haut-Rhin",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Soultzbach-les-Bains",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Soultzeren",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68570",
    "ville": "Soultzmatt",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Spechbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68850",
    "ville": "Staffelfelden",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Steinbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Steinbrunn-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Steinbrunn-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Steinsoultz",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68780",
    "ville": "Sternenberg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Stetten",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68470",
    "ville": "Storckensohn",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68140",
    "ville": "Stosswihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Strueth",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68280",
    "ville": "Sundhoffen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Tagolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Tagsdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68800",
    "ville": "Thann",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68590",
    "ville": "Thannenkirch",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Traubach-le-Bas",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Traubach-le-Haut",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Turckheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68580",
    "ville": "Ueberstrass",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Uffheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Uffholtz",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68190",
    "ville": "Ungersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68121",
    "ville": "Urbès",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Urschenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Vieux-Ferrette",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68800",
    "ville": "Vieux-Thann",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68128",
    "ville": "Village-Neuf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68420",
    "ville": "Vœgtlinshoffen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Vogelgrun",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Volgelsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Wahlbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Walbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68640",
    "ville": "Waldighofen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Walheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68510",
    "ville": "Waltenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Wasserbourg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68700",
    "ville": "Wattwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Weckolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68290",
    "ville": "Wegscheid",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68220",
    "ville": "Wentzwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Werentzhouse",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68250",
    "ville": "Westhalten",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68920",
    "ville": "Wettolsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Wickerschwihr",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68320",
    "ville": "Widensolen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Wihr-au-Val",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68820",
    "ville": "Wildenstein",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68960",
    "ville": "Willer",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68760",
    "ville": "Willer-sur-Thur",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Winkel",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68920",
    "ville": "Wintzenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68310",
    "ville": "Wittelsheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68270",
    "ville": "Wittenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Wittersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68210",
    "ville": "Wolfersdorf",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68600",
    "ville": "Wolfgantzen",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68480",
    "ville": "Wolschwiller",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68500",
    "ville": "Wuenheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68130",
    "ville": "Zaessingue",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68340",
    "ville": "Zellenberg",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68720",
    "ville": "Zillisheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68230",
    "ville": "Zimmerbach",
    "dep": "Haut-Rhin"
  },
  {
    "code": "68440",
    "ville": "Zimmersheim",
    "dep": "Haut-Rhin"
  },
  {
    "code": "69170",
    "ville": "Affoux",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Aigueperse",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Albigny-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Alix",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Ambérieux",
    "dep": "Rhône"
  },
  {
    "code": "69550",
    "ville": "Amplepuis",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Ampuis",
    "dep": "Rhône"
  },
  {
    "code": "69490",
    "ville": "Ancy",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Anse",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "L'Arbresle",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Les Ardillats",
    "dep": "Rhône"
  },
  {
    "code": "69400",
    "ville": "Arnas",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Aveize",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Azolette",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Bagnols",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Beaujeu",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Belleville-en-Beaujolais",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Belmont-d'Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Bessenay",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Bibost",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Blacé",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Val d'Oingt",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Le Breuil",
    "dep": "Rhône"
  },
  {
    "code": "69530",
    "ville": "Brignais",
    "dep": "Rhône"
  },
  {
    "code": "69126",
    "ville": "Brindas",
    "dep": "Rhône"
  },
  {
    "code": "69500",
    "ville": "Bron",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Brullioles",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Brussieu",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Bully",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Cailloux-sur-Fontaines",
    "dep": "Rhône"
  },
  {
    "code": "69300",
    "ville": "Caluire-et-Cuire",
    "dep": "Rhône"
  },
  {
    "code": "69840",
    "ville": "Cenves",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Cercié",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Chambost-Allières",
    "dep": "Rhône"
  },
  {
    "code": "69770",
    "ville": "Chambost-Longessaigne",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Chamelet",
    "dep": "Rhône"
  },
  {
    "code": "69410",
    "ville": "Champagne-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69590",
    "ville": "La Chapelle-sur-Coise",
    "dep": "Rhône"
  },
  {
    "code": "69630",
    "ville": "Chaponost",
    "dep": "Rhône"
  },
  {
    "code": "69260",
    "ville": "Charbonnières-les-Bains",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Charentay",
    "dep": "Rhône"
  },
  {
    "code": "69390",
    "ville": "Charly",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Charnay",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Chasselay",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Châtillon",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Chaussan",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Chazay-d'Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69840",
    "ville": "Chénas",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Chénelette",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Les Chères",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Chessy",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Chevinay",
    "dep": "Rhône"
  },
  {
    "code": "69115",
    "ville": "Chiroubles",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Civrieux-d'Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Claveisolles",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Cogny",
    "dep": "Rhône"
  },
  {
    "code": "69590",
    "ville": "Coise",
    "dep": "Rhône"
  },
  {
    "code": "69660",
    "ville": "Collonges-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Condrieu",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Corcelles-en-Beaujolais",
    "dep": "Rhône"
  },
  {
    "code": "69470",
    "ville": "Cours",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Courzieu",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Couzon-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69290",
    "ville": "Craponne",
    "dep": "Rhône"
  },
  {
    "code": "69550",
    "ville": "Cublize",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Curis-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69570",
    "ville": "Dardilly",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Denicé",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Dième",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Dommartin",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Dracé",
    "dep": "Rhône"
  },
  {
    "code": "69850",
    "ville": "Duerne",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Échalas",
    "dep": "Rhône"
  },
  {
    "code": "69130",
    "ville": "Écully",
    "dep": "Rhône"
  },
  {
    "code": "69840",
    "ville": "Émeringes",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Éveux",
    "dep": "Rhône"
  },
  {
    "code": "69820",
    "ville": "Fleurie",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Fleurieu-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Fleurieux-sur-l'Arbresle",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Fontaines-Saint-Martin",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Fontaines-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69340",
    "ville": "Francheville",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Frontenas",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Givors",
    "dep": "Rhône"
  },
  {
    "code": "69400",
    "ville": "Gleizé",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Grandris",
    "dep": "Rhône"
  },
  {
    "code": "69290",
    "ville": "Grézieu-la-Varenne",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Grézieu-le-Marché",
    "dep": "Rhône"
  },
  {
    "code": "69520",
    "ville": "Grigny",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Les Haies",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Les Halles",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Haute-Rivoire",
    "dep": "Rhône"
  },
  {
    "code": "69540",
    "ville": "Irigny",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Joux",
    "dep": "Rhône"
  },
  {
    "code": "69840",
    "ville": "Juliénas",
    "dep": "Rhône"
  },
  {
    "code": "69840",
    "ville": "Jullié",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Lacenas",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Lachassagne",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Lamure-sur-Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Lancié",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Lantignié",
    "dep": "Rhône"
  },
  {
    "code": "69590",
    "ville": "Larajasse",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Légny",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Lentilly",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Létra",
    "dep": "Rhône"
  },
  {
    "code": "69400",
    "ville": "Limas",
    "dep": "Rhône"
  },
  {
    "code": "69760",
    "ville": "Limonest",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Lissieu",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Loire-sur-Rhône",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Longes",
    "dep": "Rhône"
  },
  {
    "code": "69770",
    "ville": "Longessaigne",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Lozanne",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Lucenay",
    "dep": "Rhône"
  },
  {
    "code": "69000",
    "ville": "Lyon",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Marchampt",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Marcilly-d'Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Marcy",
    "dep": "Rhône"
  },
  {
    "code": "69280",
    "ville": "Marcy-l'Étoile",
    "dep": "Rhône"
  },
  {
    "code": "69550",
    "ville": "Meaux-la-Montagne",
    "dep": "Rhône"
  },
  {
    "code": "69510",
    "ville": "Messimy",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Meys",
    "dep": "Rhône"
  },
  {
    "code": "69390",
    "ville": "Millery",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Moiré",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Deux-Grosnes",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Montagny",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Montmelas-Saint-Sorlin",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Montromant",
    "dep": "Rhône"
  },
  {
    "code": "69770",
    "ville": "Montrottier",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Morancé",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Mornant",
    "dep": "Rhône"
  },
  {
    "code": "69350",
    "ville": "La Mulatière",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Neuville-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Odenas",
    "dep": "Rhône"
  },
  {
    "code": "69530",
    "ville": "Orliénas",
    "dep": "Rhône"
  },
  {
    "code": "69600",
    "ville": "Oullins-Pierre-Bénite",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Le Perréon",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Poleymieux-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69290",
    "ville": "Pollionnay",
    "dep": "Rhône"
  },
  {
    "code": "69590",
    "ville": "Pomeys",
    "dep": "Rhône"
  },
  {
    "code": "69480",
    "ville": "Pommiers",
    "dep": "Rhône"
  },
  {
    "code": "69490",
    "ville": "Vindry-sur-Turdine",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Porte des Pierres Dorées",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Poule-les-Écharmeaux",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Propières",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Quincié-en-Beaujolais",
    "dep": "Rhône"
  },
  {
    "code": "69650",
    "ville": "Quincieux",
    "dep": "Rhône"
  },
  {
    "code": "69470",
    "ville": "Ranchal",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Régnié-Durette",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Riverie",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Rivolet",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Rochetaillée-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69550",
    "ville": "Ronno",
    "dep": "Rhône"
  },
  {
    "code": "69510",
    "ville": "Rontalon",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Sain-Bel",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Salles-Arbuissonnas-en-Beaujolais",
    "dep": "Rhône"
  },
  {
    "code": "69490",
    "ville": "Sarcey",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Les Sauvages",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Savigny",
    "dep": "Rhône"
  },
  {
    "code": "69510",
    "ville": "Soucieu-en-Jarrest",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Sourcieux-les-Mines",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Souzy",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Beauvallon",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Saint-André-la-Côte",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Saint-Appolinaire",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Saint-Bonnet-des-Bruyères",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Saint-Bonnet-le-Troncy",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Sainte-Catherine",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Saint-Clément-de-Vers",
    "dep": "Rhône"
  },
  {
    "code": "69930",
    "ville": "Saint-Clément-les-Places",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Saint-Clément-sur-Valsonne",
    "dep": "Rhône"
  },
  {
    "code": "69560",
    "ville": "Sainte-Colombe",
    "dep": "Rhône"
  },
  {
    "code": "69280",
    "ville": "Sainte-Consorce",
    "dep": "Rhône"
  },
  {
    "code": "69450",
    "ville": "Saint-Cyr-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Saint-Cyr-le-Chatoux",
    "dep": "Rhône"
  },
  {
    "code": "69560",
    "ville": "Saint-Cyr-sur-le-Rhône",
    "dep": "Rhône"
  },
  {
    "code": "69370",
    "ville": "Saint-Didier-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Saint-Didier-sur-Beaujeu",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Saint-Étienne-des-Oullières",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Saint-Étienne-la-Varenne",
    "dep": "Rhône"
  },
  {
    "code": "69190",
    "ville": "Saint-Fons",
    "dep": "Rhône"
  },
  {
    "code": "69490",
    "ville": "Saint-Forgeux",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Sainte-Foy-l'Argentière",
    "dep": "Rhône"
  },
  {
    "code": "69110",
    "ville": "Sainte-Foy-lès-Lyon",
    "dep": "Rhône"
  },
  {
    "code": "69610",
    "ville": "Saint-Genis-l'Argentière",
    "dep": "Rhône"
  },
  {
    "code": "69230",
    "ville": "Saint-Genis-Laval",
    "dep": "Rhône"
  },
  {
    "code": "69290",
    "ville": "Saint-Genis-les-Ollières",
    "dep": "Rhône"
  },
  {
    "code": "69830",
    "ville": "Saint-Georges-de-Reneins",
    "dep": "Rhône"
  },
  {
    "code": "69650",
    "ville": "Saint-Germain-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Saint-Germain-Nuelles",
    "dep": "Rhône"
  },
  {
    "code": "69790",
    "ville": "Saint-Igny-de-Vers",
    "dep": "Rhône"
  },
  {
    "code": "69380",
    "ville": "Saint-Jean-des-Vignes",
    "dep": "Rhône"
  },
  {
    "code": "69550",
    "ville": "Saint-Jean-la-Bussière",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Saint-Julien",
    "dep": "Rhône"
  },
  {
    "code": "69690",
    "ville": "Saint-Julien-sur-Bibost",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Saint-Just-d'Avray",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Saint-Lager",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Saint-Laurent-d'Agny",
    "dep": "Rhône"
  },
  {
    "code": "69930",
    "ville": "Saint-Laurent-de-Chamousset",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Saint-Marcel-l'Éclairé",
    "dep": "Rhône"
  },
  {
    "code": "69850",
    "ville": "Saint-Martin-en-Haut",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Chabanière",
    "dep": "Rhône"
  },
  {
    "code": "69870",
    "ville": "Saint-Nizier-d'Azergues",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Sainte-Paule",
    "dep": "Rhône"
  },
  {
    "code": "69210",
    "ville": "Saint-Pierre-la-Palud",
    "dep": "Rhône"
  },
  {
    "code": "69270",
    "ville": "Saint-Romain-au-Mont-d'Or",
    "dep": "Rhône"
  },
  {
    "code": "69490",
    "ville": "Saint-Romain-de-Popey",
    "dep": "Rhône"
  },
  {
    "code": "69560",
    "ville": "Saint-Romain-en-Gal",
    "dep": "Rhône"
  },
  {
    "code": "69700",
    "ville": "Saint-Romain-en-Gier",
    "dep": "Rhône"
  },
  {
    "code": "69590",
    "ville": "Saint-Symphorien-sur-Coise",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Saint-Vérand",
    "dep": "Rhône"
  },
  {
    "code": "69240",
    "ville": "Saint-Vincent-de-Reins",
    "dep": "Rhône"
  },
  {
    "code": "69440",
    "ville": "Taluyers",
    "dep": "Rhône"
  },
  {
    "code": "69220",
    "ville": "Taponas",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Tarare",
    "dep": "Rhône"
  },
  {
    "code": "69160",
    "ville": "Tassin-la-Demi-Lune",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Ternand",
    "dep": "Rhône"
  },
  {
    "code": "69620",
    "ville": "Theizé",
    "dep": "Rhône"
  },
  {
    "code": "69240",
    "ville": "Thizy-les-Bourgs",
    "dep": "Rhône"
  },
  {
    "code": "69510",
    "ville": "Thurins",
    "dep": "Rhône"
  },
  {
    "code": "69890",
    "ville": "La Tour-de-Salvagny",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Trèves",
    "dep": "Rhône"
  },
  {
    "code": "69420",
    "ville": "Tupin-et-Semons",
    "dep": "Rhône"
  },
  {
    "code": "69170",
    "ville": "Valsonne",
    "dep": "Rhône"
  },
  {
    "code": "69670",
    "ville": "Vaugneray",
    "dep": "Rhône"
  },
  {
    "code": "69120",
    "ville": "Vaulx-en-Velin",
    "dep": "Rhône"
  },
  {
    "code": "69460",
    "ville": "Vaux-en-Beaujolais",
    "dep": "Rhône"
  },
  {
    "code": "69820",
    "ville": "Vauxrenard",
    "dep": "Rhône"
  },
  {
    "code": "69200",
    "ville": "Vénissieux",
    "dep": "Rhône"
  },
  {
    "code": "69390",
    "ville": "Vernaison",
    "dep": "Rhône"
  },
  {
    "code": "69430",
    "ville": "Vernay",
    "dep": "Rhône"
  },
  {
    "code": "69770",
    "ville": "Villechenève",
    "dep": "Rhône"
  },
  {
    "code": "69400",
    "ville": "Villefranche-sur-Saône",
    "dep": "Rhône"
  },
  {
    "code": "69640",
    "ville": "Ville-sur-Jarnioux",
    "dep": "Rhône"
  },
  {
    "code": "69100",
    "ville": "Villeurbanne",
    "dep": "Rhône"
  },
  {
    "code": "69910",
    "ville": "Villié-Morgon",
    "dep": "Rhône"
  },
  {
    "code": "69390",
    "ville": "Vourles",
    "dep": "Rhône"
  },
  {
    "code": "69510",
    "ville": "Yzeron",
    "dep": "Rhône"
  },
  {
    "code": "69970",
    "ville": "Chaponnay",
    "dep": "Rhône"
  },
  {
    "code": "69680",
    "ville": "Chassieu",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Communay",
    "dep": "Rhône"
  },
  {
    "code": "69960",
    "ville": "Corbas",
    "dep": "Rhône"
  },
  {
    "code": "69150",
    "ville": "Décines-Charpieu",
    "dep": "Rhône"
  },
  {
    "code": "69320",
    "ville": "Feyzin",
    "dep": "Rhône"
  },
  {
    "code": "69740",
    "ville": "Genas",
    "dep": "Rhône"
  },
  {
    "code": "69730",
    "ville": "Genay",
    "dep": "Rhône"
  },
  {
    "code": "69330",
    "ville": "Jonage",
    "dep": "Rhône"
  },
  {
    "code": "69330",
    "ville": "Jons",
    "dep": "Rhône"
  },
  {
    "code": "69970",
    "ville": "Marennes",
    "dep": "Rhône"
  },
  {
    "code": "69330",
    "ville": "Meyzieu",
    "dep": "Rhône"
  },
  {
    "code": "69780",
    "ville": "Mions",
    "dep": "Rhône"
  },
  {
    "code": "69250",
    "ville": "Montanay",
    "dep": "Rhône"
  },
  {
    "code": "69330",
    "ville": "Pusignan",
    "dep": "Rhône"
  },
  {
    "code": "69140",
    "ville": "Rillieux-la-Pape",
    "dep": "Rhône"
  },
  {
    "code": "69720",
    "ville": "Saint-Bonnet-de-Mure",
    "dep": "Rhône"
  },
  {
    "code": "69720",
    "ville": "Saint-Laurent-de-Mure",
    "dep": "Rhône"
  },
  {
    "code": "69780",
    "ville": "Saint-Pierre-de-Chandieu",
    "dep": "Rhône"
  },
  {
    "code": "69800",
    "ville": "Saint-Priest",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Saint-Symphorien-d'Ozon",
    "dep": "Rhône"
  },
  {
    "code": "69580",
    "ville": "Sathonay-Camp",
    "dep": "Rhône"
  },
  {
    "code": "69580",
    "ville": "Sathonay-Village",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Sérézin-du-Rhône",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Simandres",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Solaize",
    "dep": "Rhône"
  },
  {
    "code": "69360",
    "ville": "Ternay",
    "dep": "Rhône"
  },
  {
    "code": "69780",
    "ville": "Toussieu",
    "dep": "Rhône"
  },
  {
    "code": "69125",
    "ville": "Colombier-Saugnieu",
    "dep": "Rhône"
  },
  {
    "code": "70300",
    "ville": "Abelcourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Aboncourt-Gesincourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Achey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Adelans-et-le-Val-de-Bithaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Aillevans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70320",
    "ville": "Aillevillers-et-Lyaumont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Ailloncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Ainvelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Aisey-et-Richecourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Alaincourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70280",
    "ville": "Amage",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Amance",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Ambiévillers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Amblans-et-Velotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Amoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Amont-et-Effreney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Anchenoncourt-et-Chazel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Ancier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Andelarre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Andelarrot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Andornay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Angirey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Anjeux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Apremont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Arbecey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Arc-lès-Gray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Argillières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Aroz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Arpenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Arsans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Athesans-Étroitefontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Attricourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Augicourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Aulx-lès-Cromary",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Autet",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Authoison",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Autoreille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Autrey-lès-Cerre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Autrey-lès-Gray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Autrey-le-Vay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Auvet-et-la-Chapelotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Auxon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Avrigney-Virey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Les Aynans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Baignes",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Bard-lès-Pesmes",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Barges",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "La Barre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "La Basse-Vaivre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Bassigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Les Bâties",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Battrans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Baudoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Baulay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Bay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Beaujeu-Saint-Vallier-Pierrejux-et-Quitteur",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Beaumotte-Aubertans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Beaumotte-lès-Pin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70290",
    "ville": "Belfahy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Belmont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Belonchamp",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Belverne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Besnans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Betaucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Betoncourt-lès-Brotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Betoncourt-Saint-Pancras",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Betoncourt-sur-Mance",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Beulotte-Saint-Laurent",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Beveuge",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Blondefontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Bonboillon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Bonnevent-Velloreille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Borey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Bougey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Bougnon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Bouhans-et-Feurg",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Bouhans-lès-Lure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Bouhans-lès-Montbozon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Bouligney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Boulot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Boult",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Bourbévelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Bourguignon-lès-Conflans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Bourguignon-lès-la-Charité",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Bourguignon-lès-Morey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Boursières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Bousseraucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Bresilley",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Breuches",
    "dep": "Haute-Saône"
  },
  {
    "code": "70280",
    "ville": "Breuchotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Breurey-lès-Faverney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Brevilliers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Briaucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Brotte-lès-Luxeuil",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Brotte-lès-Ray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Broye-les-Loups-et-Verfontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Broye-Aubigney-Montseugny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Brussey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70280",
    "ville": "La Bruyère",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Bucey-lès-Gy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Bucey-lès-Traves",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Buffignécourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Bussières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Buthiers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Calmoutier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Cemboing",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Cenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Cendrecourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Cerre-lès-Noroy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Chagey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Châlonvillars",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Chambornay-lès-Bellevaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Chambornay-lès-Pin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70290",
    "ville": "Champagney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Champey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Champlitte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Champtonnay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Champvans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Chancey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Chantes",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "La Chapelle-lès-Luxeuil",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "La Chapelle-Saint-Quillain",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Charcenne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Chargey-lès-Gray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Chargey-lès-Port",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Chariez",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Charmes-Saint-Valbert",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Charmoille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Chassey-lès-Montbozon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Chassey-lès-Scey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Châteney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Châtenois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Chaumercenne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Chauvirey-le-Châtel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Chauvirey-le-Vieil",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Chaux-la-Lotière",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Chaux-lès-Port",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Chavanne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Chemilly",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Chenebier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Chenevrey-et-Morogne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Chevigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Choye",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Cintrey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Cirey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Citers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Citey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Clairegoutte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Clans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Cognières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Coisevaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Colombe-lès-Vesoul",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Colombier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Colombotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Combeaufontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Comberjon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Conflandey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Conflans-sur-Lanterne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Confracourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Contréglise",
    "dep": "Haute-Saône"
  },
  {
    "code": "70320",
    "ville": "Corbenay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "La Corbière",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Cordonnet",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Cornot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Corravillers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Corre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "La Côte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Coulevon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Courchaton",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Courcuire",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Courmont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Courtesoult-et-Gatey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Couthenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Cresancey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "La Creuse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Crevans-et-la-Chapelle-lès-Granges",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Creveney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Cromary",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Cubry-lès-Faverney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Cugney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Cult",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Cuve",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Dambenoît-lès-Colombe",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Dampierre-lès-Conflans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Dampierre-sur-Linotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Dampierre-sur-Salon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Dampvalley-lès-Colombe",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Dampvalley-Saint-Pancras",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Delain",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Demangevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "La Demie",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Denèvre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Échavanne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Échenans-sous-Mont-Vaudois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Échenoz-la-Méline",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Échenoz-le-Sec",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Écromagny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Écuelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Éhuns",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Équevilley",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Errevet",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Esboz-Brest",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Esmoulières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Esmoulins",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Esprels",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Essertenne-et-Cecey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Étobon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Étrelles-et-la-Montbleuse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Étuz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Fahy-lès-Autrey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Fallon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Faucogney-et-la-Mer",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Faverney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Faymont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Fédry",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Ferrières-lès-Ray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Ferrières-lès-Scey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Les Fessey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Filain",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Flagy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Fleurey-lès-Faverney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Fleurey-lès-Lavoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Fleurey-lès-Saint-Loup",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Fondremand",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Fontaine-lès-Luxeuil",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Fontenois-la-Ville",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Fontenois-lès-Montbozon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Fouchécourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Fougerolles-Saint-Valbert",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Fouvent-Saint-Andoche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Frahier-et-Chatebier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Francalmont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Franchevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Francourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Framont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Frasne-le-Château",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Frédéric-Fontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Fresne-Saint-Mamès",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Fresse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Fretigney-et-Velloreille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Froideconche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Froideterre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Frotey-lès-Lure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Frotey-lès-Vesoul",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Genevreuille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Genevrey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Georfans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Germigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Gevigney-et-Mercey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Gézier-et-Fontenelay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Girefontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Gouhenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Gourgeon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Grammont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Grandecourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Grandvelle-et-le-Perrenot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Granges-la-Ville",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Granges-le-Bourg",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Grattery",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Gray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Gray-la-Ville",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Gy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70440",
    "ville": "Haut-du-Them-Château-Lambert",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Hautevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Héricourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Hugier",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Hurecourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Hyet",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Igny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Jasney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Jonvelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Jussey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Lambrey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Lantenot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "La Lanterne-et-les-Armonts",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Larians-et-Munans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Larret",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Lavigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Lavoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Lieffrans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Lieucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Liévans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Linexert",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Lœuilley",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Lomont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Longevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "La Longine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Loulans-Verchamp",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Lure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Luxeuil-les-Bains",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Luze",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Lyoffans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Magnivray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Magnoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Le Magnoray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Les Magny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Magny-Danigon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Magny-Jobert",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Magny-lès-Jussey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Magny-Vernois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Mailleroncourt-Charette",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Mailleroncourt-Saint-Pancras",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Mailley-et-Chazelot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Maizières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "La Malachère",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Malans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Malbouhans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Malvillers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Mandrevillars",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Mantoche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Marast",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Marnay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Maussans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Mélecey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Melin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Melincourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Mélisey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Membrey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Menoux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Mercey-sur-Saône",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Mersuay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Meurcourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Mignavillers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Moffans-et-Vacheresse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Moimay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Molay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Mollans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "La Montagne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Montagney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Montarlot-lès-Rioz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Montboillon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Montbozon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Montcey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Montcourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Montdoré",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Montessaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Montigny-lès-Cherlieu",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Montigny-lès-Vesoul",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Montjustin-et-Velotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Villers-Chemin-et-Mont-lès-Étrelles",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Mont-le-Vernois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Montot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Mont-Saint-Léger",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Montureux-et-Prantigny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Montureux-lès-Baulay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "La Roche-Morey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Motey-Besuche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Nantilly",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Navenne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Neurey-en-Vaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Neurey-lès-la-Demie",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Neuvelle-lès-Cromary",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Neuvelle-lès-la-Charité",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "La Neuvelle-lès-Lure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "La Neuvelle-lès-Scey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Noidans-le-Ferroux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Noidans-lès-Vesoul",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Noiron",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Noroy-le-Bourg",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Oigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Oiselay-et-Grachaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Onay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Oppenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Oricourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Ormenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Ormoiche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Ormoy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Ouge",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Ovanches",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Oyrières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Palante",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Passavant-la-Rochère",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Pennesières",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Percey-le-Grand",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Perrouse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Pesmes",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Pierrecourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Pin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "La Pisseure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Plainemont",
    "dep": "Haute-Saône"
  },
  {
    "code": "70290",
    "ville": "Plancher-Bas",
    "dep": "Haute-Saône"
  },
  {
    "code": "70290",
    "ville": "Plancher-les-Mines",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Polaincourt-et-Clairefontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Pomoy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Pontcey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "La Romaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Pont-du-Bois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Pont-sur-l'Ognon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Port-sur-Saône",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Poyans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Preigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "La Proiselière-et-Langle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Provenchère",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Purgerot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Pusey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Pusy-et-Épenoux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "La Quarte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Quenoche",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Quers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Quincey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70280",
    "ville": "Raddon-et-Chapendu",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Raincourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Ranzevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Ray-sur-Saône",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Raze",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Recologne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Recologne-lès-Rioz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Renaucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "La Grande-Résie",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "La Résie-Saint-Martin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Rignovelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Rigny",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Rioz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Roche-et-Raucourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Roche-sur-Linotte-et-Sorans-les-Cordiers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "La Rochelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70250",
    "ville": "Ronchamp",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Rosey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "La Rosière",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Rosières-sur-Mance",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Roye",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Ruhans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Rupt-sur-Saône",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Saint-Barthélemy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70280",
    "ville": "Saint-Bresson",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Saint-Broing",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Saint-Ferjeux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Saint-Gand",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Saint-Germain",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Saint-Loup-Nantouard",
    "dep": "Haute-Saône"
  },
  {
    "code": "70800",
    "ville": "Saint-Loup-sur-Semouse",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Saint-Marcel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "Sainte-Marie-en-Chanois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Sainte-Marie-en-Chaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Sainte-Reine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Saint-Rémy-en-Comté",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Saint-Sauveur",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Saint-Sulpice",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Saponcourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Saulnot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Saulx",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Sauvigney-lès-Gray",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Sauvigney-lès-Pesmes",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Savoyeux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Scey-sur-Saône-et-Saint-Albin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Scye",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Secenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Selles",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Semmadon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Senargent-Mignafans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Senoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70440",
    "ville": "Servance-Miellin",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Servigney",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Seveux-Motey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Soing-Cubry-Charentenay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Sorans-lès-Breurey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Sornay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Tartécourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70270",
    "ville": "Ternuay-Melay-et-Saint-Hilaire",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Theuley",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Thieffrans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Thiénans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Tincey-et-Pontrebeau",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Traitiéfontaine",
    "dep": "Haute-Saône"
  },
  {
    "code": "70360",
    "ville": "Traves",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Le Tremblois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Trémoins",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Trésilley",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Tromarey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Vadans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Vaite",
    "dep": "Haute-Saône"
  },
  {
    "code": "70320",
    "ville": "La Vaivre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Vaivre-et-Montoille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70140",
    "ville": "Valay",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Le Val-de-Gouhenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Vallerois-le-Bois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Vallerois-Lorioz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "Le Val-Saint-Éloi",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Vandelans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Vanne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Vantoux-et-Longevelle",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Varogne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70600",
    "ville": "Vars",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Vauchoux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Vauconcourt-Nervezain",
    "dep": "Haute-Saône"
  },
  {
    "code": "70210",
    "ville": "Vauvillers",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Vaux-le-Moncelot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Velesmes-Échevanne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Velet",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Vellechevreux-et-Courbenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Velleclaire",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Vellefaux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Vellefrey-et-Vellefrange",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Vellefrie",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Velleguindry-et-Levrecey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Velle-le-Châtel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Velleminfroy",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Vellemoz",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Vellexon-Queutrey-et-Vaudey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Velloreille-lès-Choye",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Velorcey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70100",
    "ville": "Venère",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "La Vergenne",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Venisey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Vereux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Verlans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Vernois-sur-Mance",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "La Vernotte",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Vesoul",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Villafans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Villargent",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Villars-le-Pautel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70160",
    "ville": "La Villedieu-en-Fontenette",
    "dep": "Haute-Saône"
  },
  {
    "code": "70700",
    "ville": "Villefrancon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "La Villeneuve-Bellenoye-et-la-Maize",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Villeparois",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Villers-Bouton",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Villersexel",
    "dep": "Haute-Saône"
  },
  {
    "code": "70110",
    "ville": "Villers-la-Ville",
    "dep": "Haute-Saône"
  },
  {
    "code": "70000",
    "ville": "Villers-le-Sec",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Villers-lès-Luxeuil",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Villers-Pater",
    "dep": "Haute-Saône"
  },
  {
    "code": "70170",
    "ville": "Villers-sur-Port",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Villers-sur-Saulnot",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Villers-Vaudey",
    "dep": "Haute-Saône"
  },
  {
    "code": "70240",
    "ville": "Vilory",
    "dep": "Haute-Saône"
  },
  {
    "code": "70300",
    "ville": "Visoncourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Vitrey-sur-Mance",
    "dep": "Haute-Saône"
  },
  {
    "code": "70310",
    "ville": "La Voivre",
    "dep": "Haute-Saône"
  },
  {
    "code": "70180",
    "ville": "Volon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70190",
    "ville": "Voray-sur-l'Ognon",
    "dep": "Haute-Saône"
  },
  {
    "code": "70500",
    "ville": "Vougécourt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Vouhenans",
    "dep": "Haute-Saône"
  },
  {
    "code": "70150",
    "ville": "Vregille",
    "dep": "Haute-Saône"
  },
  {
    "code": "70400",
    "ville": "Vyans-le-Val",
    "dep": "Haute-Saône"
  },
  {
    "code": "70130",
    "ville": "Vy-le-Ferroux",
    "dep": "Haute-Saône"
  },
  {
    "code": "70200",
    "ville": "Vy-lès-Lure",
    "dep": "Haute-Saône"
  },
  {
    "code": "70120",
    "ville": "Vy-lès-Rupt",
    "dep": "Haute-Saône"
  },
  {
    "code": "70230",
    "ville": "Vy-lès-Filain",
    "dep": "Haute-Saône"
  },
  {
    "code": "71290",
    "ville": "L'Abergement-de-Cuisery",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "L'Abergement-Sainte-Colombe",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Allerey-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Allériot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Aluze",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Amanzé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Ameugny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Anglure-sous-Dun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71550",
    "ville": "Anost",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Antully",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Anzy-le-Duc",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Artaix",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Authumes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Autun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Auxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Azé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Ballore",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Bantanges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Barizey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Barnay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Baron",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Baudemont",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "Baudrières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Baugy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Beaubery",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Beaumont-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Beaurepaire-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Beauvernois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Bellevesvre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Bergesserin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Berzé-le-Châtel",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Berzé-la-Ville",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Bey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Bissey-sous-Cruchaud",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Bissy-la-Mâconnaise",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Bissy-sous-Uxelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Bissy-sur-Fley",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71710",
    "ville": "Les Bizots",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Blanot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71450",
    "ville": "Blanzy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Bois-Sainte-Marie",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Bonnay-Saint-Ythaire",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Les Bordes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Bosjean",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Bouhans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "La Boulaye",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Bourbon-Lancy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Bourg-le-Comte",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Bourgvilain",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Bouzeron",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Boyer",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Bragny-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Branges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Bray",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Bresse-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71670",
    "ville": "Le Breuil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Briant",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Brienne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Brion",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Broye",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Bruailles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Buffières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Burgy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Burnand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Burzy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Bussières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Buxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Céron",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Cersot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Chagny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Chaintré",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Chalmoux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71100",
    "ville": "Chalon-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Chambilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Chamilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Champagnat",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Champagny-sous-Uxelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Champforgeuil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Champlecy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Chânes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "21340",
    "ville": "Change",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Changy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Chapaize",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "La Chapelle-au-Mans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "La Chapelle-de-Bragny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "La Chapelle-de-Guinchay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "La Chapelle-du-Mont-de-France",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "La Chapelle-Naude",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "La Chapelle-Saint-Sauveur",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "La Chapelle-sous-Brancion",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "La Chapelle-sous-Dun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "La Chapelle-sous-Uchon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71470",
    "ville": "La Chapelle-Thècle",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Charbonnat",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Charbonnières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Chardonnay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Charette-Varennes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71100",
    "ville": "La Charmée",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71710",
    "ville": "Charmoy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Charnay-lès-Chalon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71850",
    "ville": "Charnay-lès-Mâcon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Charolles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Charrecey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Chasselas",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Chassey-le-Camp",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Chassigny-sous-Dun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Chassy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Château",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71740",
    "ville": "Châteauneuf",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Châtel-Moron",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Châtenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Châtenoy-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71880",
    "ville": "Châtenoy-le-Royal",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Chaudenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Chauffailles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "La Chaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Cheilly-lès-Maranges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Chenay-le-Châtel",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Chenôves",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Chérizet",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Chevagny-les-Chevrières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Chevagny-sur-Guye",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Chiddes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Chissey-en-Morvan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Chissey-lès-Mâcon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Ciel",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Ciry-le-Noble",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "La Clayette",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Navour-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Clessé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Clessy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Cluny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Collonge-en-Charollais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Collonge-la-Madeleine",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Colombier-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71990",
    "ville": "La Comelle",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Condal",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Cordesse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Cormatin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Cortambert",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Cortevaix",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Coublanc",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Couches",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71680",
    "ville": "Crêches-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Créot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71760",
    "ville": "Cressy-sur-Somme",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71200",
    "ville": "Le Creusot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Crissey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Cronat",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Cruzille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Cuiseaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Cuisery",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Culles-les-Roches",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Curbigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Curdin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Curgy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Curtil-sous-Buffières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Curtil-sous-Burnand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71550",
    "ville": "Cussy-en-Morvan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Cuzy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Damerey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Dampierre-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Davayé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Demigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Dennevy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Dettey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Devrouze",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Dezize-lès-Maranges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Diconne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Digoin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Dommartin-lès-Cuiseaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Dompierre-les-Ormes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Dompierre-sous-Sanvignes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Donzy-le-Pertuis",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Dracy-le-Fort",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Dracy-lès-Couches",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Dracy-Saint-Loup",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Dyo",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Écuelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Écuisses",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Épertully",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Épervans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Épinac",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Essertenne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Étang-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Étrigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Farges-lès-Chalon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Farges-lès-Mâcon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Le Fay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Flacey-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Flagy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Fleury-la-Montagne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Fley",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Fontaines",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Fontenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Fragnes-La Loyère",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Frangy-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "La Frette",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Fretterans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Frontenard",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Frontenaud",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Fuissé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Génelard",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "La Genête",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Genouilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71590",
    "ville": "Gergy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Germagny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Germolles-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Gibles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Gigny-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Gilly-sur-Loire",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Givry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Gourdon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71990",
    "ville": "La Grande-Verrière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71430",
    "ville": "Grandvaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Granges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Grevilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71760",
    "ville": "Grury",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Guerfand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Les Guerreaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Gueugnon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "La Guiche",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Hautefond",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "L'Hôpital-le-Mercier",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Huilly-sur-Seille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71870",
    "ville": "Hurigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Igé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Igornay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Iguerande",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71760",
    "ville": "Issy-l'Évêque",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Jalogny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Jambles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Joncy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Joudes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Jouvençon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Jugy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Juif",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Jully-lès-Buxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Lacrost",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Laives",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71870",
    "ville": "Laizé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Laizy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Lalheue",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Lans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Lays-sur-le-Doubs",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Lesme",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Lessard-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Lessard-le-National",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Leynes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Ligny-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Loisy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Longepierre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Louhans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Lournand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Lucenay-l'Évêque",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Lugny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Lugny-lès-Charolles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71100",
    "ville": "Lux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71000",
    "ville": "Mâcon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Mailly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Malay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Maltat",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Mancey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Marcigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Marcilly-la-Gueurce",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Marcilly-lès-Buxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Marigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Le Rousset-Marizy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71760",
    "ville": "Marly-sous-Issy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Marly-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71710",
    "ville": "Marmagne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Marnay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Martailly-lès-Brancion",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Martigny-le-Comte",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Mary",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Massilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Matour",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Mazille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Melay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Mellecey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71470",
    "ville": "Ménetreuil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Mercurey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Mervans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Messey-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Mesvres",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Milly-Lamartine",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Le Miroir",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Mont",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Montagny-lès-Buxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Montagny-près-Louhans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Montbellet",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Montceau-les-Mines",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Montceaux-l'Étoile",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Montceaux-Ragny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71710",
    "ville": "Montcenis",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Montchanin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Montcony",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Montcoy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Monthelon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Montjay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Mont-lès-Seurre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Montmelard",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Montmort",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71470",
    "ville": "Montpont-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Montret",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Mont-Saint-Vincent",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Morey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Morlet",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Mornay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Moroges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "La Motte-Saint-Jean",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Mouthier-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Mussy-sous-Dun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Nanton",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Navilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Neuvy-Grandchamp",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Nochize",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Ormes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Oslon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Oudry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Ouroux-sous-le-Bois-Sainte-Marie",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "Ouroux-sur-Saône",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Oyé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Ozenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Ozolles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71430",
    "ville": "Palinges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Palleau",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Paray-le-Monial",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Paris-l'Hôpital",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Passy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Péronne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Perrecy-les-Forges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Perreuil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Perrigny-sur-Loire",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "La Petite-Verrière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Pierreclos",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Pierre-de-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Le Planois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Plottes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Poisson",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Pontoux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71230",
    "ville": "Pouilloux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Pourlans",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Pressy-sous-Dondin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Préty",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Prissé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Prizy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Pruzilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Le Puley",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "La Racineuse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Rancy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Ratenelle",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Ratte",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Reclesne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Remigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Rigny-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "La Roche-Vineuse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Romanèche-Thorins",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71470",
    "ville": "Romenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Rosey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71550",
    "ville": "Roussillon-en-Morvan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Royer",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Rully",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Sagy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Saillenard",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Sailly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71160",
    "ville": "Saint-Agnan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Saint-Albain",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Saint-Ambreuil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Saint-Amour-Bellevue",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Saint-André-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Saint-André-le-Désert",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71430",
    "ville": "Saint-Aubin-en-Charollais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Saint-Aubin-sur-Loire",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71300",
    "ville": "Saint-Berain-sous-Sanvignes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Saint-Bérain-sur-Dheune",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Boil",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71340",
    "ville": "Saint-Bonnet-de-Cray",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Saint-Bonnet-de-Joux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71430",
    "ville": "Saint-Bonnet-de-Vieille-Vigne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Saint-Bonnet-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Sainte-Cécile",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "Saint-Christophe-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Christophe-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Clément-sur-Guye",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71470",
    "ville": "Sainte-Croix-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Saint-Cyr",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Saint-Denis-de-Vaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Désert",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Saint-Didier-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Saint-Didier-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Saint-Didier-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71740",
    "ville": "Saint-Edmond",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Saint-Émiland",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "Saint-Étienne-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Saint-Eugène",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Saint-Eusèbe",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71670",
    "ville": "Saint-Firmin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Saint-Forgeot",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Sainte-Foy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Saint-Gengoux-de-Scissé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Gengoux-le-National",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Saint-Germain-du-Bois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71370",
    "ville": "Saint-Germain-du-Plain",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Germain-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Germain-lès-Buxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Saint-Gervais-en-Vallière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Saint-Gervais-sur-Couches",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Saint-Gilles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Sainte-Hélène",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Huruge",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71170",
    "ville": "Saint-Igny-de-Roche",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Saint-Jean-de-Vaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Saint-Jean-de-Trézy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Julien-de-Civry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Saint-Julien-de-Jonzy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Saint-Julien-sur-Dheune",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Saint-Laurent-d'Andenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Laurent-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Saint-Léger-du-Bois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Saint-Léger-lès-Paray",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71990",
    "ville": "Saint-Léger-sous-Beuvray",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Saint-Léger-sous-la-Bussière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Saint-Léger-sur-Dheune",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Saint-Loup-Géanges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Saint-Loup-de-Varennes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71380",
    "ville": "Saint-Marcel",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Marcelin-de-Cray",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Saint-Mard-de-Vaux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71118",
    "ville": "Saint-Martin-Belle-Roche",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Martin-d'Auxy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Saint-Martin-de-Commune",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71740",
    "ville": "Saint-Martin-de-Lixy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Saint-Martin-de-Salencey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Saint-Martin-du-Lac",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Saint-Martin-du-Mont",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Martin-du-Tartre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Saint-Martin-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Saint-Martin-en-Gâtinois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Martin-la-Patrouille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71640",
    "ville": "Saint-Martin-sous-Montaigu",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Saint-Maurice-de-Satonnay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Maurice-des-Champs",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Saint-Maurice-en-Rivière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71740",
    "ville": "Saint-Maurice-lès-Châteauneuf",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Saint-Maurice-lès-Couches",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Saint-Micaud",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Saint-Nizier-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71670",
    "ville": "Saint-Pierre-de-Varennes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Saint-Pierre-le-Vieux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Saint-Point",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Privé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71990",
    "ville": "Saint-Prix",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Racho",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Sainte-Radegonde",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71100",
    "ville": "Saint-Rémy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71230",
    "ville": "Saint-Romain-sous-Gourdon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71420",
    "ville": "Saint-Romain-sous-Versigny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71200",
    "ville": "Saint-Sernin-du-Bois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71510",
    "ville": "Saint-Sernin-du-Plain",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Saint-Symphorien-d'Ancelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71710",
    "ville": "Saint-Symphorien-de-Marmagne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Saint-Symphorien-des-Bois",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Saint-Usuge",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saint-Vallerin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71230",
    "ville": "Saint-Vallier",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71570",
    "ville": "Saint-Vérand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Saint-Vincent-des-Prés",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Saint-Vincent-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71430",
    "ville": "Saint-Vincent-Bragny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Saint-Yan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Saisy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "La Salle",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Salornay-sur-Guye",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71150",
    "ville": "Sampigny-lès-Maranges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71000",
    "ville": "Sancé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Santilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71410",
    "ville": "Sanvignes-les-Mines",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Sarry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Sassangy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Sassenay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Saules",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Saunières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Savianges",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71580",
    "ville": "Savigny-en-Revermont",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Savigny-sur-Grosne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Savigny-sur-Seille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "La Celle-en-Morvan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Semur-en-Brionnais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Sennecey-le-Grand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Senozan",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Sens-sur-Seille",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Sercy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Serley",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Sermesse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Serrières",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71310",
    "ville": "Serrigny-en-Bresse",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71100",
    "ville": "Sevrey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Sigy-le-Châtel",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "Simandre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Simard",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Sivignon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Sologny",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Solutré-Pouilly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71540",
    "ville": "Sommant",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Sornay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Suin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71360",
    "ville": "Sully",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "La Tagnière",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "Taizé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71740",
    "ville": "Tancon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71330",
    "ville": "Le Tartre",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71400",
    "ville": "Tavernay",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Thil-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Thurey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71490",
    "ville": "Tintry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71210",
    "ville": "Torcy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Torpes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71320",
    "ville": "Toulon-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Tournus",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Toutenant",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Tramayes",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Trambly",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71520",
    "ville": "Trivy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Tronchy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71290",
    "ville": "La Truchère",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Uchizy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71190",
    "ville": "Uchon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Uxeau",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Vareilles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Varenne-l'Arconce",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Varennes-le-Grand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71000",
    "ville": "Varennes-lès-Mâcon",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Varenne-Saint-Germain",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71480",
    "ville": "Varennes-Saint-Sauveur",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Varennes-sous-Dun",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71800",
    "ville": "Vauban",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Vaudebarrier",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71460",
    "ville": "Vaux-en-Pré",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Vendenesse-lès-Charolles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71130",
    "ville": "Vendenesse-sur-Arroux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71350",
    "ville": "Verdun-sur-le-Doubs",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Vergisson",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71440",
    "ville": "Vérissey",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71590",
    "ville": "Verjux",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71220",
    "ville": "Verosvres",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71240",
    "ville": "Vers",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Versaugues",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71960",
    "ville": "Verzé",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71700",
    "ville": "Le Villars",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71620",
    "ville": "Villegaudin",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71270",
    "ville": "Clux-Villeneuve",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71390",
    "ville": "Villeneuve-en-Montagne",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71500",
    "ville": "Vincelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71110",
    "ville": "Vindecy",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71250",
    "ville": "La Vineuse sur Fregande",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71680",
    "ville": "Vinzelles",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Viré",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71530",
    "ville": "Virey-le-Grand",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71120",
    "ville": "Viry",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Vitry-en-Charollais",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71140",
    "ville": "Vitry-sur-Loire",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71600",
    "ville": "Volesvres",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "71260",
    "ville": "Fleurville",
    "dep": "Saône-et-Loire"
  },
  {
    "code": "72650",
    "ville": "Aigné",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Aillières-Beauvoir",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Allonnes",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Amné",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Ancinnes",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Arçonnay",
    "dep": "Sarthe"
  },
  {
    "code": "72370",
    "ville": "Ardenay-sur-Mérize",
    "dep": "Sarthe"
  },
  {
    "code": "72230",
    "ville": "Arnage",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Arthezé",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Asnières-sur-Vègre",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Assé-le-Boisne",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Assé-le-Riboul",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Aubigné-Racan",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Les Aulneaux",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Auvers-le-Hamon",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Auvers-sous-Montfaucon",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Avesnes-en-Saosnois",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Avessé",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Avezé",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Avoise",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "Le Bailleul",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Ballon-Saint Mars",
    "dep": "Sarthe"
  },
  {
    "code": "72650",
    "ville": "La Bazoge",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "Bazouges Cré sur Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Beaufay",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "Beaumont-sur-Dême",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Beaumont-Pied-de-Bœuf",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Beaumont-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Beillé",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Berfay",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Bérus",
    "dep": "Sarthe"
  },
  {
    "code": "72310",
    "ville": "Bessé-sur-Braye",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Béthon",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Blèves",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Boëssé-le-Sec",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Bonnétable",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "La Bosse",
    "dep": "Sarthe"
  },
  {
    "code": "72390",
    "ville": "Bouër",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Bouloire",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Bourg-le-Roi",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Bousse",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "Brains-sur-Gée",
    "dep": "Sarthe"
  },
  {
    "code": "72370",
    "ville": "Le Breil-sur-Mérize",
    "dep": "Sarthe"
  },
  {
    "code": "72250",
    "ville": "Brette-les-Pins",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Briosne-lès-Sables",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "La Bruère-sur-Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Brûlon",
    "dep": "Sarthe"
  },
  {
    "code": "72330",
    "ville": "Cérans-Foulletourte",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "Chahaignes",
    "dep": "Sarthe"
  },
  {
    "code": "72250",
    "ville": "Challes",
    "dep": "Sarthe"
  },
  {
    "code": "72470",
    "ville": "Champagné",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Champfleur",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Champrond",
    "dep": "Sarthe"
  },
  {
    "code": "72560",
    "ville": "Changé",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Chantenay-Villedieu",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "La Chapelle-aux-Choux",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "La Chapelle-d'Aligné",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "La Chapelle-du-Bois",
    "dep": "Sarthe"
  },
  {
    "code": "72310",
    "ville": "La Chapelle-Huon",
    "dep": "Sarthe"
  },
  {
    "code": "72650",
    "ville": "La Chapelle-Saint-Aubin",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "La Chapelle-Saint-Fray",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "La Chapelle-Saint-Rémy",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "La Chartre-sur-le-Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Chassillé",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Montval-sur-Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72510",
    "ville": "Château-l'Hermitage",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "Chaufour-Notre-Dame",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Chemiré-en-Charnie",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Chemiré-le-Gaudin",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Chenay",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Chenu",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Chérancé",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Chérisay",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Cherré-Au",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Chevillé",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "Clermont-Créans",
    "dep": "Sarthe"
  },
  {
    "code": "72310",
    "ville": "Cogners",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Commerveil",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Conflans-sur-Anille",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Congé-sur-Orne",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Conlie",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Connerré",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Contilly",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Cormes",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Coudrecieux",
    "dep": "Sarthe"
  },
  {
    "code": "72190",
    "ville": "Coulaines",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "Coulans-sur-Gée",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Coulongé",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Courcebœufs",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Courcelles-la-Forêt",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Courcemont",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Courcival",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Courdemanche",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Courgains",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Courgenard",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Courtillers",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Crannes-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Crissé",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "Crosmières",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Cures",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Dangeul",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "Degré",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Dehault",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Dissay-sous-Courcillon",
    "dep": "Sarthe"
  },
  {
    "code": "72390",
    "ville": "Dollon",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Domfront-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Doucelles",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Douillet",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Duneau",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Dureil",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Écommoy",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Écorpain",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Épineu-le-Chevreuil",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Étival-lès-le-Mans",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Val-d'Étangson",
    "dep": "Sarthe"
  },
  {
    "code": "72470",
    "ville": "Fatines",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "Fay",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Fercé-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "La Ferté-Bernard",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Fillé",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Flée",
    "dep": "Sarthe"
  },
  {
    "code": "72330",
    "ville": "La Fontaine-Saint-Martin",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Fontenay-sur-Vègre",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Villeneuve-en-Perseigne",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Fresnay-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Fyé",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Gesnes-le-Gandelin",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Grandchamp",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Le Grand-Lucé",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Gréez-sur-Roc",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Le Grez",
    "dep": "Sarthe"
  },
  {
    "code": "72230",
    "ville": "Guécélard",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "La Guierche",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Jauzé",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Joué-en-Charnie",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Joué-l'Abbé",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Juigné-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Juillé",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Jupilles",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "La Flèche",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Laigné-en-Belin",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Lamnay",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Lavardin",
    "dep": "Sarthe"
  },
  {
    "code": "72390",
    "ville": "Lavaré",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Lavernat",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "Lhomme",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Ligron",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Livet-en-Saosnois",
    "dep": "Sarthe"
  },
  {
    "code": "72450",
    "ville": "Lombron",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Longnes",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Louailles",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Loué",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Louplande",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Louvigny",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Louzes",
    "dep": "Sarthe"
  },
  {
    "code": "72390",
    "ville": "Le Luart",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Luceau",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Lucé-sous-Ballon",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Luché-Pringé",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Le Lude",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Maigné",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Maisoncelles",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Malicorne-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Mamers",
    "dep": "Sarthe"
  },
  {
    "code": "72100",
    "ville": "Le Mans",
    "dep": "Sarthe"
  },
  {
    "code": "72510",
    "ville": "Mansigné",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "Marçon",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Mareil-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72200",
    "ville": "Mareil-sur-Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Maresché",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Marigné-Laillé",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Marollette",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Marolles-les-Braults",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Marolles-lès-Saint-Calais",
    "dep": "Sarthe"
  },
  {
    "code": "72360",
    "ville": "Mayet",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Les Mées",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Melleray",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Meurcé",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Mézeray",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Mézières-sur-Ponthouin",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Mézières-sous-Lavardin",
    "dep": "Sarthe"
  },
  {
    "code": "72650",
    "ville": "La Milesse",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Moitron-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72230",
    "ville": "Moncé-en-Belin",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Moncé-en-Saosnois",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Monhoudou",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Montaillé",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Montbizot",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Montmirail",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Montreuil-le-Chétif",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Montreuil-le-Henri",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Mont-Saint-Jean",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Moulins-le-Carbonnel",
    "dep": "Sarthe"
  },
  {
    "code": "72230",
    "ville": "Mulsanne",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Nauvay",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Neufchâtel-en-Saosnois",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Neuvillalais",
    "dep": "Sarthe"
  },
  {
    "code": "72190",
    "ville": "Neuville-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Neuvillette-en-Charnie",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Bernay-Neuvy-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Nogent-le-Bernard",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Nogent-sur-Loir",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Nouans",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Noyen-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72370",
    "ville": "Nuillé-le-Jalais",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Oisseau-le-Petit",
    "dep": "Sarthe"
  },
  {
    "code": "72330",
    "ville": "Oizé",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Panon",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Parcé-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Parennes",
    "dep": "Sarthe"
  },
  {
    "code": "72330",
    "ville": "Parigné-le-Pôlin",
    "dep": "Sarthe"
  },
  {
    "code": "72250",
    "ville": "Parigné-l'Évêque",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Notre-Dame-du-Pé",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Peray",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Pezé-le-Robert",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Piacé",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Pincé",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Pirmil",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Pizieux",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Poillé-sur-Vègre",
    "dep": "Sarthe"
  },
  {
    "code": "72450",
    "ville": "Montfort-le-Gesnois",
    "dep": "Sarthe"
  },
  {
    "code": "72510",
    "ville": "Pontvallain",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Précigné",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Préval",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Prévelles",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Pruillé-le-Chétif",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Pruillé-l'Éguillé",
    "dep": "Sarthe"
  },
  {
    "code": "72550",
    "ville": "La Quinte",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Rahay",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "René",
    "dep": "Sarthe"
  },
  {
    "code": "72510",
    "ville": "Requeil",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Roëzé-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Rouessé-Fontaine",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Rouessé-Vassé",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Rouez",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Rouillon",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Rouperroux-le-Coquet",
    "dep": "Sarthe"
  },
  {
    "code": "72230",
    "ville": "Ruaudin",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Ruillé-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72340",
    "ville": "Loir en Vallée",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Sablé-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Saint-Aignan",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Aubin-de-Locquenay",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Saint-Aubin-des-Coudrais",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Saint-Biez-en-Belin",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Saint-Calais",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Calez-en-Saosnois",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Saint-Célerin",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Sainte-Cérotte",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Saint-Christophe-du-Jambet",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Saint-Christophe-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72460",
    "ville": "Saint-Corneille",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Saint-Cosme-en-Vairais",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Saint-Denis-des-Coudrais",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Saint-Denis-d'Orques",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Saint-Georges-de-la-Couée",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Saint-Georges-du-Bois",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Saint-Georges-du-Rosay",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Georges-le-Gaultier",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Saint-Germain-d'Arcé",
    "dep": "Sarthe"
  },
  {
    "code": "72120",
    "ville": "Saint-Gervais-de-Vic",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Saint-Gervais-en-Belin",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Sainte-Jamme-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Saint-Jean-d'Assé",
    "dep": "Sarthe"
  },
  {
    "code": "72510",
    "ville": "Saint-Jean-de-la-Motte",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Saint-Jean-des-Échelles",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Saint-Jean-du-Bois",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Léonard-des-Bois",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Longis",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Saint-Maixent",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Saint-Marceau",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Saint-Mars-de-Locquenay",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Saint-Mars-d'Outillé",
    "dep": "Sarthe"
  },
  {
    "code": "72470",
    "ville": "Saint-Mars-la-Brière",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Saint-Martin-des-Monts",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Saint-Michel-de-Chavaignes",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Ouen-de-Mimbré",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Saint-Ouen-en-Belin",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Saint-Ouen-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Saint-Paterne - Le Chevain",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Paul-le-Gaultier",
    "dep": "Sarthe"
  },
  {
    "code": "72190",
    "ville": "Saint-Pavace",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Saint-Pierre-de-Chevillé",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Saint-Pierre-des-Bois",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Pierre-des-Ormes",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Saint-Pierre-du-Lorouër",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Saint-Rémy-de-Sillé",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Rémy-des-Monts",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Rémy-du-Val",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Sainte-Sabine-sur-Longève",
    "dep": "Sarthe"
  },
  {
    "code": "72650",
    "ville": "Saint-Saturnin",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Saint-Symphorien",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Saint-Ulphace",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Saint-Victeur",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saint-Vincent-des-Prés",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Saint-Vincent-du-Lorouër",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Saosnes",
    "dep": "Sarthe"
  },
  {
    "code": "72360",
    "ville": "Sarcé",
    "dep": "Sarthe"
  },
  {
    "code": "72190",
    "ville": "Sargé-lès-le-Mans",
    "dep": "Sarthe"
  },
  {
    "code": "72460",
    "ville": "Savigné-l'Évêque",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Savigné-sous-le-Lude",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Sceaux-sur-Huisne",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Ségrie",
    "dep": "Sarthe"
  },
  {
    "code": "72390",
    "ville": "Semur-en-Vallon",
    "dep": "Sarthe"
  },
  {
    "code": "72140",
    "ville": "Sillé-le-Guillaume",
    "dep": "Sarthe"
  },
  {
    "code": "72460",
    "ville": "Sillé-le-Philippe",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Solesmes",
    "dep": "Sarthe"
  },
  {
    "code": "72130",
    "ville": "Sougé-le-Ganelon",
    "dep": "Sarthe"
  },
  {
    "code": "72380",
    "ville": "Souillé",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Souligné-Flacé",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Souligné-sous-Ballon",
    "dep": "Sarthe"
  },
  {
    "code": "72370",
    "ville": "Soulitré",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Souvigné-sur-Même",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Souvigné-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72700",
    "ville": "Spay",
    "dep": "Sarthe"
  },
  {
    "code": "72370",
    "ville": "Surfonds",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "La Suze-sur-Sarthe",
    "dep": "Sarthe"
  },
  {
    "code": "72430",
    "ville": "Tassé",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Tassillé",
    "dep": "Sarthe"
  },
  {
    "code": "72290",
    "ville": "Teillé",
    "dep": "Sarthe"
  },
  {
    "code": "72220",
    "ville": "Teloché",
    "dep": "Sarthe"
  },
  {
    "code": "72240",
    "ville": "Tennie",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Terrehault",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Théligny",
    "dep": "Sarthe"
  },
  {
    "code": "72260",
    "ville": "Thoigné",
    "dep": "Sarthe"
  },
  {
    "code": "72610",
    "ville": "Thoiré-sous-Contensor",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Thoiré-sur-Dinan",
    "dep": "Sarthe"
  },
  {
    "code": "72800",
    "ville": "Thorée-les-Pins",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Thorigné-sur-Dué",
    "dep": "Sarthe"
  },
  {
    "code": "72110",
    "ville": "Torcé-en-Vallée",
    "dep": "Sarthe"
  },
  {
    "code": "72650",
    "ville": "Trangé",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Tresson",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Le Tronchet",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Tuffé Val de la Chéronne",
    "dep": "Sarthe"
  },
  {
    "code": "72500",
    "ville": "Vaas",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Valennes",
    "dep": "Sarthe"
  },
  {
    "code": "72540",
    "ville": "Vallon-sur-Gée",
    "dep": "Sarthe"
  },
  {
    "code": "72310",
    "ville": "Vancé",
    "dep": "Sarthe"
  },
  {
    "code": "72360",
    "ville": "Verneil-le-Chétif",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Vernie",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Vezot",
    "dep": "Sarthe"
  },
  {
    "code": "72320",
    "ville": "Vibraye",
    "dep": "Sarthe"
  },
  {
    "code": "72600",
    "ville": "Villaines-la-Carelle",
    "dep": "Sarthe"
  },
  {
    "code": "72400",
    "ville": "Villaines-la-Gonais",
    "dep": "Sarthe"
  },
  {
    "code": "72150",
    "ville": "Villaines-sous-Lucé",
    "dep": "Sarthe"
  },
  {
    "code": "72270",
    "ville": "Villaines-sous-Malicorne",
    "dep": "Sarthe"
  },
  {
    "code": "72300",
    "ville": "Vion",
    "dep": "Sarthe"
  },
  {
    "code": "72350",
    "ville": "Viré-en-Champagne",
    "dep": "Sarthe"
  },
  {
    "code": "72170",
    "ville": "Vivoin",
    "dep": "Sarthe"
  },
  {
    "code": "72210",
    "ville": "Voivres-lès-le-Mans",
    "dep": "Sarthe"
  },
  {
    "code": "72440",
    "ville": "Volnay",
    "dep": "Sarthe"
  },
  {
    "code": "72160",
    "ville": "Vouvray-sur-Huisne",
    "dep": "Sarthe"
  },
  {
    "code": "72330",
    "ville": "Yvré-le-Pôlin",
    "dep": "Sarthe"
  },
  {
    "code": "72530",
    "ville": "Yvré-l'Évêque",
    "dep": "Sarthe"
  },
  {
    "code": "73610",
    "ville": "Aiguebelette-le-Lac",
    "dep": "Savoie"
  },
  {
    "code": "73260",
    "ville": "Grand-Aigueblanche",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Aillon-le-Jeune",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Aillon-le-Vieux",
    "dep": "Savoie"
  },
  {
    "code": "73210",
    "ville": "Aime-la-Plagne",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Aiton",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Aix-les-Bains",
    "dep": "Savoie"
  },
  {
    "code": "73410",
    "ville": "Entrelacs",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Albertville",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Albiez-le-Jeune",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Albiez-Montrond",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Allondaz",
    "dep": "Savoie"
  },
  {
    "code": "73550",
    "ville": "Les Allues",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Apremont",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Arbin",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Argentine",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Arith",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Arvillard",
    "dep": "Savoie"
  },
  {
    "code": "73610",
    "ville": "Attignat-Oncin",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Aussois",
    "dep": "Savoie"
  },
  {
    "code": "73260",
    "ville": "Les Avanchers-Valmorel",
    "dep": "Savoie"
  },
  {
    "code": "73240",
    "ville": "Avressieux",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Avrieux",
    "dep": "Savoie"
  },
  {
    "code": "73470",
    "ville": "Ayn",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "La Balme",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Barberaz",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Barby",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Bassens",
    "dep": "Savoie"
  },
  {
    "code": "73540",
    "ville": "La Bâthie",
    "dep": "Savoie"
  },
  {
    "code": "73360",
    "ville": "La Bauche",
    "dep": "Savoie"
  },
  {
    "code": "73270",
    "ville": "Beaufort",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Bellecombe-en-Bauges",
    "dep": "Savoie"
  },
  {
    "code": "73330",
    "ville": "Belmont-Tramonet",
    "dep": "Savoie"
  },
  {
    "code": "73480",
    "ville": "Bessans",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Betton-Bettonet",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Billième",
    "dep": "Savoie"
  },
  {
    "code": "73410",
    "ville": "La Biolle",
    "dep": "Savoie"
  },
  {
    "code": "73480",
    "ville": "Bonneval-sur-Arc",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Bonvillard",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Bonvillaret",
    "dep": "Savoie"
  },
  {
    "code": "73370",
    "ville": "Bourdeau",
    "dep": "Savoie"
  },
  {
    "code": "73370",
    "ville": "Le Bourget-du-Lac",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Bourget-en-Huile",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Bourgneuf",
    "dep": "Savoie"
  },
  {
    "code": "73700",
    "ville": "Bourg-Saint-Maurice",
    "dep": "Savoie"
  },
  {
    "code": "73350",
    "ville": "Bozel",
    "dep": "Savoie"
  },
  {
    "code": "73570",
    "ville": "Brides-les-Bains",
    "dep": "Savoie"
  },
  {
    "code": "73520",
    "ville": "La Bridoire",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Brison-Saint-Innocent",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Césarches",
    "dep": "Savoie"
  },
  {
    "code": "73730",
    "ville": "Cevins",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Challes-les-Eaux",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Chambéry",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "La Chambre",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Chamousset",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Chamoux-sur-Gelon",
    "dep": "Savoie"
  },
  {
    "code": "73240",
    "ville": "Champagneux",
    "dep": "Savoie"
  },
  {
    "code": "73350",
    "ville": "Champagny-en-Vanoise",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Champ-Laurent",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Chanaz",
    "dep": "Savoie"
  },
  {
    "code": "73660",
    "ville": "La Chapelle",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "La Chapelle-Blanche",
    "dep": "Savoie"
  },
  {
    "code": "73370",
    "ville": "La Chapelle-du-Mont-du-Chat",
    "dep": "Savoie"
  },
  {
    "code": "73700",
    "ville": "Les Chapelles",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "La Chapelle-Saint-Martin",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Châteauneuf",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "Le Châtelard",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "La Chavanne",
    "dep": "Savoie"
  },
  {
    "code": "73660",
    "ville": "Les Chavannes-en-Maurienne",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Chignin",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Chindrieux",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Cléry",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Cognin",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "Cohennoz",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Coise-Saint-Jean-Pied-Gauthier",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "La Compôte",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Conjux",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Corbel",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "Crest-Voland",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "La Croix-de-la-Rochette",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Cruet",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Curienne",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Les Déserts",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Détrier",
    "dep": "Savoie"
  },
  {
    "code": "73330",
    "ville": "Domessin",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "Doucy-en-Bauges",
    "dep": "Savoie"
  },
  {
    "code": "73420",
    "ville": "Drumettaz-Clarafond",
    "dep": "Savoie"
  },
  {
    "code": "73610",
    "ville": "Dullin",
    "dep": "Savoie"
  },
  {
    "code": "73360",
    "ville": "Les Échelles",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "École",
    "dep": "Savoie"
  },
  {
    "code": "73670",
    "ville": "Entremont-le-Vieux",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Épierre",
    "dep": "Savoie"
  },
  {
    "code": "73540",
    "ville": "Esserts-Blay",
    "dep": "Savoie"
  },
  {
    "code": "73350",
    "ville": "Feissons-sur-Salins",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "Flumet",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Fontcouverte-la-Toussuire",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Fourneaux",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Freney",
    "dep": "Savoie"
  },
  {
    "code": "73250",
    "ville": "Fréterive",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Frontenex",
    "dep": "Savoie"
  },
  {
    "code": "73470",
    "ville": "Gerbaix",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "La Giettaz",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Gilly-sur-Isère",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Grésy-sur-Aix",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Grésy-sur-Isère",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Grignon",
    "dep": "Savoie"
  },
  {
    "code": "73600",
    "ville": "Hautecour",
    "dep": "Savoie"
  },
  {
    "code": "73620",
    "ville": "Hauteluce",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Hauteville",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "La Tour-en-Maurienne",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Jacob-Bellecombette",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Jarrier",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "Jarsy",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Jongieux",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Laissaud",
    "dep": "Savoie"
  },
  {
    "code": "73210",
    "ville": "Landry",
    "dep": "Savoie"
  },
  {
    "code": "73610",
    "ville": "Lépin-le-Lac",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Lescheraines",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Loisieux",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Lucey",
    "dep": "Savoie"
  },
  {
    "code": "73210",
    "ville": "La Plagne Tarentaise",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Porte-de-Savoie",
    "dep": "Savoie"
  },
  {
    "code": "73470",
    "ville": "Marcieux",
    "dep": "Savoie"
  },
  {
    "code": "73400",
    "ville": "Marthod",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Mercury",
    "dep": "Savoie"
  },
  {
    "code": "73420",
    "ville": "Méry",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Meyrieux-Trouet",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Modane",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Les Mollettes",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Montagnole",
    "dep": "Savoie"
  },
  {
    "code": "73350",
    "ville": "Montagny",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Montailleur",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Montcel",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Montendry",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Montgilbert",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Monthion",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Montmélian",
    "dep": "Savoie"
  },
  {
    "code": "73870",
    "ville": "Montricher-Albanne",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Montsapey",
    "dep": "Savoie"
  },
  {
    "code": "73700",
    "ville": "Montvalezan",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Montvernier",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "La Motte-en-Bauges",
    "dep": "Savoie"
  },
  {
    "code": "73290",
    "ville": "La Motte-Servolex",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Motz",
    "dep": "Savoie"
  },
  {
    "code": "73600",
    "ville": "Moûtiers",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Mouxy",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Myans",
    "dep": "Savoie"
  },
  {
    "code": "73470",
    "ville": "Nances",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "Notre-Dame-de-Bellecombe",
    "dep": "Savoie"
  },
  {
    "code": "73260",
    "ville": "La Léchère",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Notre-Dame-des-Millières",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Notre-Dame-du-Cruet",
    "dep": "Savoie"
  },
  {
    "code": "73600",
    "ville": "Notre-Dame-du-Pré",
    "dep": "Savoie"
  },
  {
    "code": "73470",
    "ville": "Novalaise",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Le Noyer",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Ontex",
    "dep": "Savoie"
  },
  {
    "code": "73140",
    "ville": "Orelle",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Pallud",
    "dep": "Savoie"
  },
  {
    "code": "73210",
    "ville": "Peisey-Nancroix",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Planaise",
    "dep": "Savoie"
  },
  {
    "code": "73350",
    "ville": "Planay",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Plancherine",
    "dep": "Savoie"
  },
  {
    "code": "73330",
    "ville": "Le Pont-de-Beauvoisin",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Le Pontet",
    "dep": "Savoie"
  },
  {
    "code": "73710",
    "ville": "Pralognan-la-Vanoise",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Presle",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Pugny-Chatenod",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Puygros",
    "dep": "Savoie"
  },
  {
    "code": "73720",
    "ville": "Queige",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Val-d'Arc",
    "dep": "Savoie"
  },
  {
    "code": "73490",
    "ville": "La Ravoire",
    "dep": "Savoie"
  },
  {
    "code": "73240",
    "ville": "Rochefort",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Valgelon-La Rochette",
    "dep": "Savoie"
  },
  {
    "code": "73730",
    "ville": "Rognaix",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Rotherens",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Ruffieux",
    "dep": "Savoie"
  },
  {
    "code": "73610",
    "ville": "Saint-Alban-de-Montbel",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Saint-Alban-d'Hurtières",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint-Alban-des-Villards",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Saint-Alban-Leysse",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Saint-André",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint-Avre",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Saint-Baldoph",
    "dep": "Savoie"
  },
  {
    "code": "73520",
    "ville": "Saint-Béron",
    "dep": "Savoie"
  },
  {
    "code": "73120",
    "ville": "Courchevel",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Saint-Cassin",
    "dep": "Savoie"
  },
  {
    "code": "73360",
    "ville": "Saint-Christophe",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint-Colomban-des-Villards",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint-Étienne-de-Cuines",
    "dep": "Savoie"
  },
  {
    "code": "73640",
    "ville": "Sainte-Foy-Tarentaise",
    "dep": "Savoie"
  },
  {
    "code": "73360",
    "ville": "Saint-Franc",
    "dep": "Savoie"
  },
  {
    "code": "73340",
    "ville": "Saint-François-de-Sales",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint François Longchamp",
    "dep": "Savoie"
  },
  {
    "code": "73240",
    "ville": "Saint-Genix-les-Villages",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Saint-Georges-d'Hurtières",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Sainte-Hélène-du-Lac",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Sainte-Hélène-sur-Isère",
    "dep": "Savoie"
  },
  {
    "code": "73530",
    "ville": "Saint-Jean-d'Arves",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Saint-Jean-d'Arvey",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Saint-Jean-de-Chevelu",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Saint-Jean-de-Couz",
    "dep": "Savoie"
  },
  {
    "code": "73250",
    "ville": "Saint-Jean-de-la-Porte",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Saint-Jean-de-Maurienne",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "Saint-Jeoire-Prieuré",
    "dep": "Savoie"
  },
  {
    "code": "73870",
    "ville": "Saint-Julien-Mont-Denis",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Saint-Léger",
    "dep": "Savoie"
  },
  {
    "code": "73600",
    "ville": "Saint-Marcel",
    "dep": "Savoie"
  },
  {
    "code": "73240",
    "ville": "Sainte-Marie-d'Alvey",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Sainte-Marie-de-Cuines",
    "dep": "Savoie"
  },
  {
    "code": "73140",
    "ville": "Saint-Martin-d'Arc",
    "dep": "Savoie"
  },
  {
    "code": "73440",
    "ville": "Les Belleville",
    "dep": "Savoie"
  },
  {
    "code": "73140",
    "ville": "Saint-Martin-de-la-Porte",
    "dep": "Savoie"
  },
  {
    "code": "73130",
    "ville": "Saint-Martin-sur-la-Chambre",
    "dep": "Savoie"
  },
  {
    "code": "73140",
    "ville": "Saint-Michel-de-Maurienne",
    "dep": "Savoie"
  },
  {
    "code": "73590",
    "ville": "Saint-Nicolas-la-Chapelle",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Saint-Offenge",
    "dep": "Savoie"
  },
  {
    "code": "73410",
    "ville": "Saint-Ours",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Saint-Pancrace",
    "dep": "Savoie"
  },
  {
    "code": "73730",
    "ville": "Saint-Paul-sur-Isère",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Saint-Paul-sur-Yenne",
    "dep": "Savoie"
  },
  {
    "code": "73250",
    "ville": "Saint-Pierre-d'Albigny",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Saint-Pierre-d'Alvey",
    "dep": "Savoie"
  },
  {
    "code": "73220",
    "ville": "Saint-Pierre-de-Belleville",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Saint-Pierre-de-Curtille",
    "dep": "Savoie"
  },
  {
    "code": "73670",
    "ville": "Saint-Pierre-d'Entremont",
    "dep": "Savoie"
  },
  {
    "code": "73360",
    "ville": "Saint-Pierre-de-Genebroz",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Saint-Pierre-de-Soucy",
    "dep": "Savoie"
  },
  {
    "code": "73630",
    "ville": "Sainte-Reine",
    "dep": "Savoie"
  },
  {
    "code": "73660",
    "ville": "Saint-Rémy-de-Maurienne",
    "dep": "Savoie"
  },
  {
    "code": "73530",
    "ville": "Saint-Sorlin-d'Arves",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Saint-Sulpice",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Saint-Thibaud-de-Couz",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Saint-Vital",
    "dep": "Savoie"
  },
  {
    "code": "73600",
    "ville": "Salins-Fontaine",
    "dep": "Savoie"
  },
  {
    "code": "73700",
    "ville": "Séez",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Serrières-en-Chautagne",
    "dep": "Savoie"
  },
  {
    "code": "73000",
    "ville": "Sonnaz",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "La Table",
    "dep": "Savoie"
  },
  {
    "code": "73480",
    "ville": "Val-Cenis",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Thénésol",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Thoiry",
    "dep": "Savoie"
  },
  {
    "code": "73190",
    "ville": "La Thuile",
    "dep": "Savoie"
  },
  {
    "code": "73320",
    "ville": "Tignes",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Tournon",
    "dep": "Savoie"
  },
  {
    "code": "73790",
    "ville": "Tours-en-Savoie",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Traize",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Tresserve",
    "dep": "Savoie"
  },
  {
    "code": "73100",
    "ville": "Trévignin",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "La Trinité",
    "dep": "Savoie"
  },
  {
    "code": "73400",
    "ville": "Ugine",
    "dep": "Savoie"
  },
  {
    "code": "73150",
    "ville": "Val-d'Isère",
    "dep": "Savoie"
  },
  {
    "code": "73450",
    "ville": "Valloire",
    "dep": "Savoie"
  },
  {
    "code": "73450",
    "ville": "Valmeinier",
    "dep": "Savoie"
  },
  {
    "code": "73200",
    "ville": "Venthon",
    "dep": "Savoie"
  },
  {
    "code": "73330",
    "ville": "Verel-de-Montbel",
    "dep": "Savoie"
  },
  {
    "code": "73230",
    "ville": "Verel-Pragondran",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Le Verneil",
    "dep": "Savoie"
  },
  {
    "code": "73460",
    "ville": "Verrens-Arvey",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Verthemex",
    "dep": "Savoie"
  },
  {
    "code": "73800",
    "ville": "Villard-d'Héry",
    "dep": "Savoie"
  },
  {
    "code": "73390",
    "ville": "Villard-Léger",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Villard-Sallet",
    "dep": "Savoie"
  },
  {
    "code": "73270",
    "ville": "Villard-sur-Doron",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Villarembert",
    "dep": "Savoie"
  },
  {
    "code": "73300",
    "ville": "Villargondran",
    "dep": "Savoie"
  },
  {
    "code": "73500",
    "ville": "Villarodin-Bourget",
    "dep": "Savoie"
  },
  {
    "code": "73640",
    "ville": "Villaroger",
    "dep": "Savoie"
  },
  {
    "code": "73110",
    "ville": "Villaroux",
    "dep": "Savoie"
  },
  {
    "code": "73160",
    "ville": "Vimines",
    "dep": "Savoie"
  },
  {
    "code": "73310",
    "ville": "Vions",
    "dep": "Savoie"
  },
  {
    "code": "73420",
    "ville": "Viviers-du-Lac",
    "dep": "Savoie"
  },
  {
    "code": "73420",
    "ville": "Voglans",
    "dep": "Savoie"
  },
  {
    "code": "73170",
    "ville": "Yenne",
    "dep": "Savoie"
  },
  {
    "code": "74360",
    "ville": "Abondance",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Alby-sur-Chéran",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74290",
    "ville": "Alex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Allèves",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Allinges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Allonzier-la-Caille",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Amancy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Ambilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Andilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74000",
    "ville": "Annecy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Annemasse",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Anthy-sur-Léman",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Arâches-la-Frasse",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74930",
    "ville": "Arbusigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Archamps",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Arenthon",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Argonay",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Armoy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74380",
    "ville": "Arthaz-Pont-Notre-Dame",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Ayse",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Ballaison",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "La Balme-de-Sillingy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "La Balme-de-Thuy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Bassy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74430",
    "ville": "La Baume",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Beaumont",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74470",
    "ville": "Bellevaux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Bernex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74430",
    "ville": "Le Biot",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Bloye",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74290",
    "ville": "Bluffy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Boëge",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Bogève",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74380",
    "ville": "Bonne",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74360",
    "ville": "Bonnevaux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Bonneville",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74890",
    "ville": "Bons-en-Chablais",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Bossey",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Le Bouchet-Mont-Charvin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Boussy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74890",
    "ville": "Brenthonne",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Brizon",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Burdignin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Cercier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Cernex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74550",
    "ville": "Cervens",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Chainaz-les-Frasses",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Challonges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74400",
    "ville": "Chamonix-Mont-Blanc",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Champanges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74360",
    "ville": "La Chapelle-d'Abondance",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "La Chapelle-Rambaud",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74410",
    "ville": "La Chapelle-Saint-Maurice",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Chapeiry",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Charvonnex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74390",
    "ville": "Châtel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Châtillon-sur-Cluses",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Chaumont",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Chavannaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74650",
    "ville": "Chavanod",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Chêne-en-Semine",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Chênex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Chens-sur-Léman",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Chessenaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Chevaline",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Chevenoz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Chevrier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Chilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Choisy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Clarafond-Arcine",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Clermont",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Les Clefs",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74220",
    "ville": "La Clusaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Cluses",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Collonges-sous-Salève",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74920",
    "ville": "Combloux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74170",
    "ville": "Les Contamines-Montjoie",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Contamine-Sarzin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Contamine-sur-Arve",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Copponex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74700",
    "ville": "Cordon",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Cornier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74110",
    "ville": "La Côte-d'Arbroz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74380",
    "ville": "Cranves-Sales",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Crempigny-Bonneguête",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Cruseilles",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Cusy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Cuvat",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74120",
    "ville": "Demi-Quartier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Desingy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Dingy-en-Vuache",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Dingy-Saint-Clair",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74700",
    "ville": "Domancy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Doussard",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Douvaine",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74550",
    "ville": "Draillant",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Droisy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74410",
    "ville": "Duingt",
    "dep": "Haute-Savoie"
  },
  {
    "code": "01200",
    "ville": "Éloise",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74410",
    "ville": "Entrevernes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Epagny Metz-Tessy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74110",
    "ville": "Essert-Romand",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Etaux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Étercy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Étrembières",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Évian-les-Bains",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Excenevex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Faucigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Faverges-Seythenex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Feigères",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74890",
    "ville": "Fessy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Féternes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Fillinges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "La Forclaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Franclens",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Frangy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74240",
    "ville": "Gaillard",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74260",
    "ville": "Les Gets",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Giez",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74450",
    "ville": "Le Grand-Bornand",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74570",
    "ville": "Groisy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Gruffy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Habère-Lullin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Habère-Poche",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Hauteville-sur-Fier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Héry-sur-Alby",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74310",
    "ville": "Les Houches",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Jonzier-Épagny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Juvigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Larringes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Lathuile",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74320",
    "ville": "Leschaux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Loisin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Lornay",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Lovagny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74380",
    "ville": "Lucinges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Lugrin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74470",
    "ville": "Lullin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74890",
    "ville": "Lully",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Lyaud",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Machilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Magland",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Manigod",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Marcellaz-Albanais",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Marcellaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Margencel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74970",
    "ville": "Marignier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Marigny-Saint-Marcel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Marin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Val de Chaise",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Marlioz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74460",
    "ville": "Marnaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Massingy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Massongy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Maxilly-sur-Léman",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74120",
    "ville": "Megève",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74490",
    "ville": "Mégevette",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Meillerie",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74290",
    "ville": "Menthon-Saint-Bernard",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Menthonnex-en-Bornes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Menthonnex-sous-Clermont",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Mésigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Messery",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74440",
    "ville": "Mieussy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Minzier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74560",
    "ville": "Monnetier-Mornex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74600",
    "ville": "Montagny-les-Lanches",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74110",
    "ville": "Montriond",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Mont-Saxonnex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74440",
    "ville": "Morillon",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74110",
    "ville": "Morzine",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Moye",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74560",
    "ville": "La Muraz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Mûres",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Musièges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Nancy-sur-Cluses",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74380",
    "ville": "Nangy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Nâves-Parmelan",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Nernier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Neuvecelle",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Neydens",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Nonglard",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Novel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74490",
    "ville": "Onnion",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74550",
    "ville": "Orcier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74190",
    "ville": "Passy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Peillonnex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74550",
    "ville": "Perrignier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74930",
    "ville": "Pers-Jussy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Glières-Val-de-Borne",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Poisy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74120",
    "ville": "Praz-sur-Arly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Présilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Publier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74600",
    "ville": "Quintal",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74930",
    "ville": "Reignier-Ésery",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74950",
    "ville": "Le Reposoir",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Reyvroz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74440",
    "ville": "La Rivière-Enverse",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "La Roche-sur-Foron",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Rumilly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Saint-André-de-Boëge",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Saint-Blaise",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Saint-Cergues",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Saint-Eusèbe",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74410",
    "ville": "Saint-Eustache",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Saint-Félix",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Saint-Ferréol",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Saint-Germain-sur-Rhône",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74170",
    "ville": "Saint-Gervais-les-Bains",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Saint-Gingolph",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74430",
    "ville": "Saint-Jean-d'Aulps",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74450",
    "ville": "Saint-Jean-de-Sixt",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Saint-Jean-de-Tholome",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74490",
    "ville": "Saint-Jeoire",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74410",
    "ville": "Saint-Jorioz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Saint-Julien-en-Genevois",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Saint-Laurent",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Saint-Paul-en-Chablais",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Saint-Pierre-en-Faucigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Saint-Sigismond",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74800",
    "ville": "Saint-Sixt",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Saint-Sylvestre",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Sales",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74700",
    "ville": "Sallanches",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Sallenôves",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74340",
    "ville": "Samoëns",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Le Sappey",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Savigny",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Saxel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74930",
    "ville": "Scientrier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Sciez",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74950",
    "ville": "Scionzier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Serraval",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74310",
    "ville": "Servoz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74320",
    "ville": "Sevrier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Seyssel",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74430",
    "ville": "Seytroux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74330",
    "ville": "Sillingy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74740",
    "ville": "Sixt-Fer-à-Cheval",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74210",
    "ville": "Talloires-Montmin",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74440",
    "ville": "Taninges",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74300",
    "ville": "Thyez",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Thollon-les-Mémises",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Thônes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "Thonon-les-Bains",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Fillière",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Thusy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "La Tour",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74910",
    "ville": "Usinens",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74360",
    "ville": "Vacheresse",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74470",
    "ville": "Vailly",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Valleiry",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Vallières-sur-Fier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74660",
    "ville": "Vallorcine",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74270",
    "ville": "Vanzy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Vaulx",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Veigy-Foncenex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74440",
    "ville": "Verchaix",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74200",
    "ville": "La Vernaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74160",
    "ville": "Vers",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74150",
    "ville": "Versonnex",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Vétraz-Monthoux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74290",
    "ville": "Veyrier-du-Lac",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74420",
    "ville": "Villard",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74230",
    "ville": "Les Villards-sur-Thônes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74370",
    "ville": "Villaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Ville-en-Sallaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74100",
    "ville": "Ville-la-Grand",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Villy-le-Bouveret",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Villy-le-Pelloux",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74500",
    "ville": "Vinzier",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74580",
    "ville": "Viry",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74540",
    "ville": "Viuz-la-Chiésaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74250",
    "ville": "Viuz-en-Sallaz",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74130",
    "ville": "Vougy",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74350",
    "ville": "Vovray-en-Bornes",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74520",
    "ville": "Vulbens",
    "dep": "Haute-Savoie"
  },
  {
    "code": "74140",
    "ville": "Yvoire",
    "dep": "Haute-Savoie"
  },
  {
    "code": "75000",
    "ville": "Paris",
    "dep": "Paris"
  },
  {
    "code": "76190",
    "ville": "Allouville-Bellefosse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Alvimare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Ambrumesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76920",
    "ville": "Amfreville-la-Mi-Voie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Amfreville-les-Champs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76710",
    "ville": "Anceaumeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Ancourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Ancourteville-sur-Héricourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Ancretiéville-Saint-Victor",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Ancretteville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Angerville-Bailleul",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Angerville-la-Martel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Angerville-l'Orcher",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Angiens",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Anglesqueville-la-Bras-Long",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Anglesqueville-l'Esneval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Val-de-Saâne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Anneville-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Anneville-Ambourville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Annouville-Vilmesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Anquetierville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Anvéville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Ardouval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Argueil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76880",
    "ville": "Arques-la-Bataille",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Aubéguimont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Aubermesnil-aux-Érables",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Aubermesnil-Beaumais",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Auberville-la-Manuel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Auberville-la-Renault",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76720",
    "ville": "Val-de-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Aumale",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Auppegard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Authieux-Ratiéville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Les Authieux-sur-le-Port-Saint-Ouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Autigny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Les Hauts-de-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Auvilliers",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Auzebosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Auzouville-l'Esneval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Auzouville-sur-Ry",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Auzouville-sur-Saâne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Avesnes-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Avesnes-en-Val",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Avremesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Bacqueville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Bailleul-Neuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Baillolet",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Bailly-en-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Baons-le-Comte",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Bardouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76360",
    "ville": "Barentin",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Baromesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Bazinval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Beaubec-la-Rosière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Beaumont-le-Hareng",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Beauval-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Beaurepaire",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76870",
    "ville": "Beaussault",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Beautot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Beauvoir-en-Lyons",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Bec-de-Mortagne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76240",
    "ville": "Belbeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Bellencombre",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Bellengreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Belleville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "La Bellière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Belmesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Bénarville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Bénesville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Bénouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Bernières",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Bertheauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Bertreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Bertreville-Saint-Ouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Bertrimont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Berville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Berville-sur-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Beuzeville-la-Grenier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Beuzeville-la-Guérard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Beuzevillette",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Bézancourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Bierville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76420",
    "ville": "Bihorel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Biville-la-Baignarde",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Biville-la-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Blacqueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Blainville-Crevon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Blangy-sur-Bresle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76240",
    "ville": "Bonsecours",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Blosseville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Le Bocasse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Bois-d'Ennebourg",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Bois-Guilbert",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76230",
    "ville": "Bois-Guillaume",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Bois-Héroult",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Bois-Himont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Bois-l'Évêque",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Le Bois-Robert",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Boissay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Bolbec",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Bolleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Boos",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Bordeaux-Saint-Clair",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Bornambusc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Bosc-Bérenger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Bosc-Bordel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Bosc-Édeline",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Callengeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76710",
    "ville": "Bosc-Guérard-Saint-Adrien",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Bosc-Hyons",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Bosc-le-Hard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Bosc-Mesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Bosville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Boudeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Bouelles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76530",
    "ville": "La Bouille",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Bourdainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Le Bourg-Dun",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Bourville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76360",
    "ville": "Bouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Brachy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Bracquetuit",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Bradiancourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Brametot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Bréauté",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Brémontier-Merval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Bretteville-du-Grand-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Bretteville-Saint-Laurent",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Buchy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Bully",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Bures-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Butot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Cailleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Cailly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Calleville-les-Deux-Églises",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Campneuseville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Canehan",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Canouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76380",
    "ville": "Canteleu",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Canville-les-Deux-Églises",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Cany-Barville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Carville-la-Folletière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Carville-Pot-de-Fer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Le Catelier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Catenay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Rives-en-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76320",
    "ville": "Caudebec-lès-Elbeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Le Caule-Sainte-Beuve",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76930",
    "ville": "Cauville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Les Cent-Acres",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "La Cerlangue",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "La Chapelle-du-Bourgay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "La Chapelle-Saint-Ouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "La Chapelle-sur-Dun",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "La Chaussée",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Cideville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Clais",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Clasville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Claville-Motteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76410",
    "ville": "Cléon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Clères",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Cleuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Cléville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Cliponville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Colleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Colmesnil-Manneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Compainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Conteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Contremoulins",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Cottévrard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Crasville-la-Mallet",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Crasville-la-Rocquefort",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76910",
    "ville": "Criel-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "La Crique",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76111",
    "ville": "Criquebeuf-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Criquetot-le-Mauconduit",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Criquetot-l'Esneval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Criquetot-sur-Longueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Criquetot-sur-Ouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Criquiers",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Critot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Croisy-sur-Andelle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Croixdalle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Croix-Mare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76720",
    "ville": "Cropus",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Crosville-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Cuverville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Cuverville-sur-Yères",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Cuy-Saint-Fiacre",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Dampierre-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Dampierre-Saint-Nicolas",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Dancourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Darnétal",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Daubeuf-Serville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Dénestanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76250",
    "ville": "Déville-lès-Rouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Dieppe",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Doudeauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Doudeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Douvrend",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Drosay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Duclair",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Écalles-Alix",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Écrainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Écretteville-lès-Baons",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Écretteville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Ectot-l'Auber",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76970",
    "ville": "Ectot-lès-Baons",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Elbeuf-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Elbeuf-sur-Andelle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76500",
    "ville": "Elbeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Életot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Ellecourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Émanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Envermeu",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Envronville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Épinay-sur-Duclair",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76133",
    "ville": "Épouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Épretot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Épreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Ermenouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Ernemont-la-Villette",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Ernemont-sur-Buchy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Esclavelles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76710",
    "ville": "Eslettes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Esteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Étaimpuis",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Étainhus",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Étalleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Étalondes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Étoutteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Étretat",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Eu",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Fallencourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Terres-de-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Fécamp",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Ferrières-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "La Ferté-Saint-Samson",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Fesques",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "La Feuillie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76970",
    "ville": "Flamanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Flamets-Frétils",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Flocques",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Fongueusemare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Fontaine-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76290",
    "ville": "Fontaine-la-Mallet",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Fontaine-le-Bourg",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Fontaine-le-Dun",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Fontaine-sous-Préaux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "La Fontelaye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76290",
    "ville": "Fontenay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Forges-les-Eaux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Foucarmont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Foucart",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Fréauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "La Frénaye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76410",
    "ville": "Freneuse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Fresles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Fresnay-le-Long",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Fresne-le-Plan",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Fresnoy-Folny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Fresquiennes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Freulleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Saint Martin de l'If",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Frichemesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Froberville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Fry",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Fultot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "La Gaillarde",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76870",
    "ville": "Gaillefontaine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76700",
    "ville": "Gainneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Gancourt-Saint-Étienne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Ganzeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Gerponville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Gerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Goderville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Gommerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Gonfreville-Caillot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76700",
    "ville": "Gonfreville-l'Orcher",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Gonnetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Gonneville-la-Mallet",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Gonneville-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Gonzeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Goupillières",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Gournay-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Gouy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Graimbouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Grainville-la-Teinturière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Grainville-sur-Ry",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Grainville-Ymauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Grand-Camp",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76530",
    "ville": "Grand-Couronne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Grandcourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76950",
    "ville": "Les Grandes-Ventes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76120",
    "ville": "Le Grand-Quevilly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Graval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Grèges",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76970",
    "ville": "Grémonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76810",
    "ville": "Greuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Grigneuseville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Gruchet-le-Valasse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76810",
    "ville": "Gruchet-Saint-Siméon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Grugny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Grumesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Guerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Gueures",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Gueutteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Gueutteville-les-Grès",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "La Hallotière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Le Hanouard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Harcanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76700",
    "ville": "Harfleur",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Hattenville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Haucourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Haudricourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Haussez",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Hautot-l'Auvray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Hautot-le-Vatois",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Hautot-Saint-Sulpice",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Hautot-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76113",
    "ville": "Hautot-sur-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76620",
    "ville": "Le Havre",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "La Haye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Héberville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76840",
    "ville": "Hénouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Héricourt-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Hermanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Hermeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Le Héron",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Héronchelles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76720",
    "ville": "Heugleville-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Heuqueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76940",
    "ville": "Heurteauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Hodeng-au-Bosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Hodeng-Hodenger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Houdetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76770",
    "ville": "Le Houlme",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76770",
    "ville": "Houppeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Houquetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "La Houssaye-Béranger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Hugleville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Les Ifs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Illois",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Imbleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76117",
    "ville": "Incheville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Ingouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76230",
    "ville": "Isneauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Jumièges",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Lamberville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Lammerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Landes-Vieilles-et-Neuves",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Lanquetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Lestanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Lillebonne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Limésy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Limpiville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Lindebeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Lintot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Lintot-les-Bois",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Les Loges",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76500",
    "ville": "La Londe",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Londinières",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Longmesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Longroy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76860",
    "ville": "Longueil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Longuerue",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Longueville-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Louvetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Lucy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76810",
    "ville": "Luneray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76940",
    "ville": "Arelaune-en-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76770",
    "ville": "Malaunay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Malleville-les-Grès",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76133",
    "ville": "Manéglise",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Manéhouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Maniquerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Manneville-ès-Plains",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Manneville-la-Goupil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76290",
    "ville": "Mannevillette",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76150",
    "ville": "Maromme",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Marques",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Martainville-Épreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76880",
    "ville": "Martigny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Martin-Église",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Massy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Mathonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Maucomble",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Maulévrier-Sainte-Gertrude",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76530",
    "ville": "Mauny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Mauquenchy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Mélamare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Melleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Ménerval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Ménonval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Mentheville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Mésangueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Mesnières-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Le Mesnil-Durdent",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76240",
    "ville": "Le Mesnil-Esnard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Mesnil-Follemprise",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Le Mesnil-Lieubray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Mesnil-Mauger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Mesnil-Panneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Mesnil-Raoul",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Le Mesnil-Réaume",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Le Mesnil-sous-Jumièges",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Meulers",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Millebosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Mirville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Molagnies",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Monchaux-Soreng",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Monchy-sur-Eu",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Mont-Cauvaire",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Montérolier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76380",
    "ville": "Montigny",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76290",
    "ville": "Montivilliers",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Montmain",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76850",
    "ville": "Montreuil-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Montroty",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76130",
    "ville": "Mont-Saint-Aignan",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76710",
    "ville": "Montville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Morgny-la-Pommeraye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Mortemer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Morville-sur-Andelle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76970",
    "ville": "Motteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76530",
    "ville": "Moulineaux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Muchedent",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Nesle-Hodeng",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Nesle-Normandeuse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Neufbosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Neufchâtel-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76220",
    "ville": "Neuf-Marché",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "La Neuville-Chant-d'Oisel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Neuville-Ferrières",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Néville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Nointot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Nolléval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Normanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76330",
    "ville": "Norville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Notre-Dame-d'Aliermont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76940",
    "ville": "Notre-Dame-de-Bliquetuit",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76960",
    "ville": "Notre-Dame-de-Bondeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Franqueville-Saint-Pierre",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Port-Jérôme-sur-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76133",
    "ville": "Notre-Dame-du-Bec",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Notre-Dame-du-Parc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Nullemont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Ocqueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76930",
    "ville": "Octeville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Offranville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Oherville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76350",
    "ville": "Oissel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Omonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76500",
    "ville": "Orival",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Osmoy-Saint-Valery",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Ouainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Oudalle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Ourville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Ouville-l'Abbaye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76860",
    "ville": "Ouville-la-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Paluel",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Parc-d'Anxtot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Pavilly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76650",
    "ville": "Petit-Couronne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76140",
    "ville": "Le Petit-Quevilly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76330",
    "ville": "Petiville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Pierrecourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Pierrefiques",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Pierreval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76360",
    "ville": "Pissy-Pôville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Pleine-Sève",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Pommereux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Pommeréval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Ponts-et-Marais",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "La Poterie-Cap-d'Antifer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Préaux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Prétot-Vicquemare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Preuseville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Puisenval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76840",
    "ville": "Quevillon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Quévreville-la-Poterie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76860",
    "ville": "Quiberville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Quièvrecourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76230",
    "ville": "Quincampoix",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Raffetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Rainfreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Réalcamp",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Rebets",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "La Remuée",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Rétonval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Reuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Ricarville-du-Val",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Richemont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Rieux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Riville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Robertot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Rocquefort",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Rocquemont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76700",
    "ville": "Rogerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76133",
    "ville": "Rolleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Roncherolles-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Roncherolles-sur-le-Vivier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Ronchois",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Rosay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76100",
    "ville": "Rouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Roumare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Routes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Rouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Rouvray-Catillon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Rouxmesnil-Bouteilles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Royville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "La Rue-Saint-Pierre",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Ry",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Saâne-Saint-Just",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76113",
    "ville": "Sahurs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Sainneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76310",
    "ville": "Sainte-Adresse",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Sainte-Agathe-d'Aliermont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Saint-Aignan-sur-Ry",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Saint-André-sur-Cailly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Saint-Antoine-la-Forêt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Saint-Arnoult",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Saint-Aubin-Celloville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Saint-Aubin-de-Crétot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Saint-Aubin-Épinay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76410",
    "ville": "Saint-Aubin-lès-Elbeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Saint-Aubin-le-Cauf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Saint-Aubin-Routot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Saint-Aubin-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Saint-Aubin-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76570",
    "ville": "Sainte-Austreberthe",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Sainte-Beuve-en-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Saint-Clair-sur-les-Monts",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Sainte-Colombe",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Saint-Crespin",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Sainte-Croix-sur-Buchy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76860",
    "ville": "Saint-Denis-d'Aclon",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Saint-Denis-le-Thiboult",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Denis-sur-Scie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76800",
    "ville": "Saint-Étienne-du-Rouvray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Saint-Eustache-la-Forêt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Sainte-Foy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Sainte-Geneviève",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Saint-Georges-sur-Fontaine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Saint-Germain-des-Essourts",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Saint-Germain-d'Étables",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Saint-Germain-sous-Cailly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Saint-Germain-sur-Eaulne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Saint-Gilles-de-Crétot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Saint-Gilles-de-la-Neuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Sainte-Hélène-Bondeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Saint-Hellier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Saint-Honoré",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Saint-Jacques-d'Aliermont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Saint-Jacques-sur-Darnétal",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Saint-Jean-de-Folleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Saint-Jean-de-la-Neuville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76150",
    "ville": "Saint-Jean-du-Cardonnay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Saint-Jouin-Bruneval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76700",
    "ville": "Saint-Laurent-de-Brèvedent",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Saint-Laurent-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Saint-Léger-aux-Bois",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Saint-Léger-du-Bourg-Denis",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Saint-Léonard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Saint-Lucien",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Maclou-de-Folleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Saint-Maclou-la-Brière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Saint-Mards",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76119",
    "ville": "Sainte-Marguerite-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Morienne",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Sainte-Marguerite-sur-Duclair",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Sainte-Marie-au-Bosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Sainte-Marie-des-Champs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Saint-Martin-aux-Arbres",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Saint-Martin-au-Bosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Saint-Martin-aux-Buneaux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76840",
    "ville": "Saint-Martin-de-Boscherville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76133",
    "ville": "Saint-Martin-du-Bec",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76290",
    "ville": "Saint-Martin-du-Manoir",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "Saint-Martin-du-Vivier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76370",
    "ville": "Petit-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Saint-Martin-le-Gaillard",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Saint-Martin-l'Hortier",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Saint-Martin-Osmonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76330",
    "ville": "Saint-Maurice-d'Ételan",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Saint-Michel-d'Halescourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Saint-Nicolas-d'Aliermont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76490",
    "ville": "Saint-Nicolas-de-la-Haie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "Saint-Nicolas-de-la-Taille",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Ouen-du-Breuil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Saint-Ouen-le-Mauger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Saint-Ouen-sous-Bailly",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Saint-Paër",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Pierre-Bénouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76113",
    "ville": "Saint-Pierre-de-Manneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Saint-Pierre-des-Jonquières",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Saint-Pierre-de-Varengeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Saint-Pierre-en-Port",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Saint-Pierre-en-Val",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76320",
    "ville": "Saint-Pierre-lès-Elbeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Saint-Pierre-le-Vieux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Saint-Pierre-le-Viger",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Saint-Rémy-Boscrocourt",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Saint-Riquier-en-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Saint-Riquier-ès-Plains",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Saint-Romain-de-Colbosc",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Saint-Saëns",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Saint-Saire",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Saint-Sauveur-d'Émalleville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Saint-Sylvain",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76510",
    "ville": "Saint-Vaast-d'Équiqueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Saint-Vaast-Dieppedalle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Vaast-du-Val",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76460",
    "ville": "Saint-Valery-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Saint-Victor-l'Abbaye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Saint-Vigor-d'Ymonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Saint-Vincent-Cramesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Sandouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Sassetot-le-Malgardé",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Sassetot-le-Mauconduit",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Sasseville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76630",
    "ville": "Sauchay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Saumont-la-Poterie",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Sauqueville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Saussay",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Sausseuzemare-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Senneville-sur-Fécamp",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Sept-Meules",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Serqueux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76116",
    "ville": "Servaville-Salmonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Sierville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76780",
    "ville": "Sigy-en-Bray",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Smermesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Sommery",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Sommesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Sorquainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76300",
    "ville": "Sotteville-lès-Rouen",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76410",
    "ville": "Sotteville-sous-le-Val",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76740",
    "ville": "Sotteville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Tancarville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Thérouldeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Theuville-aux-Maillots",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Thiergeville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Thiétreville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Thil-Manneville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76440",
    "ville": "Le Thil-Riberpré",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Thiouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76790",
    "ville": "Le Tilleul",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Tocqueville-en-Caux",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Tocqueville-les-Murs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Torcy-le-Grand",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76590",
    "ville": "Torcy-le-Petit",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Le Torp-Mesnil",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Tôtes",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Touffreville-la-Corbeline",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76910",
    "ville": "Touffreville-sur-Eu",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76410",
    "ville": "Tourville-la-Rivière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Tourville-les-Ifs",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76550",
    "ville": "Tourville-sur-Arques",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76400",
    "ville": "Toussaint",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76580",
    "ville": "Le Trait",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Trémauville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76470",
    "ville": "Le Tréport",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76170",
    "ville": "La Trinité-du-Mont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76430",
    "ville": "Les Trois-Pierres",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76210",
    "ville": "Trouville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Turretot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76380",
    "ville": "Val-de-la-Haye",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Valliquerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Valmont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76119",
    "ville": "Varengeville-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Varneville-Bretteville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76890",
    "ville": "Vassonville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76270",
    "ville": "Vatierville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Vattetot-sous-Beaumont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76111",
    "ville": "Vattetot-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76940",
    "ville": "Vatteville-la-Rue",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76150",
    "ville": "La Vaupalière",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Veauville-lès-Quelles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76730",
    "ville": "Vénestanville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Butot-Vénesville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76680",
    "ville": "Ventes-Saint-Rémy",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Vergetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76980",
    "ville": "Veules-les-Roses",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Veulettes-sur-Mer",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Vibeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76750",
    "ville": "Vieux-Manoir",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76390",
    "ville": "Vieux-Rouen-sur-Bresle",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76160",
    "ville": "La Vieux-Rue",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76280",
    "ville": "Villainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76360",
    "ville": "Villers-Écalles",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76340",
    "ville": "Villers-sous-Foucarmont",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76260",
    "ville": "Villy-sur-Yères",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Vinnemerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76110",
    "ville": "Virville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76450",
    "ville": "Vittefleur",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76660",
    "ville": "Wanchy-Capval",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76480",
    "ville": "Yainville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76640",
    "ville": "Yébleron",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76760",
    "ville": "Yerville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76520",
    "ville": "Ymare",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76111",
    "ville": "Yport",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76540",
    "ville": "Ypreville-Biville",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76690",
    "ville": "Yquebeuf",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76560",
    "ville": "Yvecrique",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76190",
    "ville": "Yvetot",
    "dep": "Seine-Maritime"
  },
  {
    "code": "76530",
    "ville": "Yville-sur-Seine",
    "dep": "Seine-Maritime"
  },
  {
    "code": "77760",
    "ville": "Achères-la-Forêt",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Amillis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Amponville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Andrezel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Annet-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77630",
    "ville": "Arbonne-la-Forêt",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Argentières",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Armentières-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Arville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Aubepierre-Ozouer-le-Repos",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Aufferville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Augers-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Aulnoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77210",
    "ville": "Avon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Baby",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77167",
    "ville": "Bagneaux-sur-Loing",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77700",
    "ville": "Bailly-Romainvilliers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77118",
    "ville": "Balloy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77970",
    "ville": "Bannost-Villegagnon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Barbey",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77630",
    "ville": "Barbizon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77910",
    "ville": "Barcy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Bassevelle",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77118",
    "ville": "Bazoches-lès-Bray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Beauchery-Saint-Martin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Beaumont-du-Gâtinais",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Beauvoir",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Bellot",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Bernay-Vilbert",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Beton-Bazoches",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77970",
    "ville": "Bezalles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77115",
    "ville": "Blandy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Blennes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77970",
    "ville": "Boisdon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77590",
    "ville": "Bois-le-Roi",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77350",
    "ville": "Boissettes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77350",
    "ville": "Boissise-la-Bertrand",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77310",
    "ville": "Boissise-le-Roi",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Boissy-aux-Cailles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77169",
    "ville": "Boissy-le-Châtel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Boitron",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Bombon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Bougligny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Boulancourt",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Bouleurs",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77780",
    "ville": "Bourron-Marlotte",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Boutigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77620",
    "ville": "Bransles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Bray-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Bréau",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77170",
    "ville": "Brie-Comte-Robert",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "La Brosse-Montceaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77177",
    "ville": "Brou-sur-Chantereine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Burcy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Bussières",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Bussy-Saint-Georges",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Bussy-Saint-Martin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Buthiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Cannes-Écluse",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Carnetin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77515",
    "ville": "La Celle-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Cély",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Cerneux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77240",
    "ville": "Cesson",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Cessoy-en-Montois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Chailly-en-Bière",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Chailly-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77460",
    "ville": "Chaintreaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77171",
    "ville": "Chalautre-la-Grande",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Chalautre-la-Petite",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77144",
    "ville": "Chalifert",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Chalmaison",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77910",
    "ville": "Chambry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Chamigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77430",
    "ville": "Champagne-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Champcenest",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Champdeuil",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Champeaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77420",
    "ville": "Champs-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77660",
    "ville": "Changis-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Chanteloup-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "La Chapelle-Gauthier",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "La Chapelle-Iger",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "La Chapelle-la-Reine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "La Chapelle-Rablais",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "La Chapelle-Saint-Sulpice",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Les Chapelles-Bourbon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "La Chapelle-Moutils",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Charmentray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Charny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77590",
    "ville": "Chartrettes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Chartronges",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Châteaubleau",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Château-Landon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77820",
    "ville": "Le Châtelet-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77126",
    "ville": "Châtenay-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77167",
    "ville": "Châtenoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77820",
    "ville": "Châtillon-la-Borde",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Châtres",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77169",
    "ville": "Chauffry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Chaumes-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77500",
    "ville": "Chelles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Chenoise-Cucharmoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Chenou",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77700",
    "ville": "Chessy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Chevrainvilliers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Chevru",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77173",
    "ville": "Chevry-Cossigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Chevry-en-Sereine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Choisy-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77730",
    "ville": "Citry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Claye-Souilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Clos-Fontaine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Cocherel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77090",
    "ville": "Collégien",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77380",
    "ville": "Combs-la-Ville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77290",
    "ville": "Compans",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Conches-sur-Gondoire",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Condé-Sainte-Libiaire",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Congis-sur-Thérouanne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77170",
    "ville": "Coubert",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77860",
    "ville": "Couilly-Pont-aux-Dames",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77840",
    "ville": "Coulombs-en-Valois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Coulommes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Coulommiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77700",
    "ville": "Coupvray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77126",
    "ville": "Courcelles-en-Bassée",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Courchamp",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Courpalay",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Courquetaine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Courtacon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Courtomer",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77181",
    "ville": "Courtry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77154",
    "ville": "Coutençon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Coutevroult",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Crécy-la-Chapelle",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77124",
    "ville": "Crégy-lès-Meaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Crèvecœur-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Crisenoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77183",
    "ville": "Croissy-Beaubourg",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "La Croix-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77840",
    "ville": "Crouy-sur-Ourcq",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Cuisy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Dagny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77190",
    "ville": "Dammarie-les-Lys",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Dammartin-en-Goële",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77163",
    "ville": "Dammartin-sur-Tigeaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Dampmart",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77140",
    "ville": "Darvault",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Dhuisy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Diant",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Donnemarie-Dontilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Dormelles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Doue",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77139",
    "ville": "Douy-la-Ramée",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77830",
    "ville": "Échouboulains",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77820",
    "ville": "Les Écrennes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77126",
    "ville": "Égligny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77620",
    "ville": "Égreville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77184",
    "ville": "Émerainville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Esbly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Esmans",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77139",
    "ville": "Étrépilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77157",
    "ville": "Everly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77166",
    "ville": "Évry-Grégy-sur-Yerre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77515",
    "ville": "Faremoutiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77220",
    "ville": "Favières",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77167",
    "ville": "Faÿ-lès-Nemours",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77133",
    "ville": "Féricy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77150",
    "ville": "Férolles-Attilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77164",
    "ville": "Ferrières-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "La Ferté-Gaucher",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "La Ferté-sous-Jouarre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Flagy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Fleury-en-Bière",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77300",
    "ville": "Fontainebleau",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Fontaine-Fourches",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77590",
    "ville": "Fontaine-le-Port",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Fontains",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Fontenailles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Fontenay-Trésigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Forfry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Forges",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Fouju",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Fresnes-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Frétoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Fromont",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Fublaines",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Garentreville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Gastins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77690",
    "ville": "La Genevraye",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77910",
    "ville": "Germigny-l'Évêque",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77840",
    "ville": "Germigny-sous-Coulombs",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Gesvres-le-Chapitre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Giremoutiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Gironville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77114",
    "ville": "Gouaix",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Gouvernes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "La Grande-Paroisse",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Grandpuits-Bailly-Carrois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77118",
    "ville": "Gravon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Gressy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77220",
    "ville": "Gretz-Armainvilliers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77880",
    "ville": "Grez-sur-Loing",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77166",
    "ville": "Grisy-Suisnes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Grisy-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Guérard",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Guercheville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Guermantes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Guignes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Gurcy-le-Châtel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77515",
    "ville": "Hautefeuille",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "La Haute-Maison",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77850",
    "ville": "Héricy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77114",
    "ville": "Hermé",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Hondevilliers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "La Houssaye-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Ichy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Isles-les-Meldeuses",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Isles-lès-Villenoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Iverny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Jablines",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Jaignes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Jaulnes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77600",
    "ville": "Jossigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77640",
    "ville": "Jouarre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77970",
    "ville": "Jouy-le-Châtel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Jouy-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Juilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Jutigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Lagny-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Larchant",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77148",
    "ville": "Laval-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77171",
    "ville": "Léchelle",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Lescherolles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Lesches",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77150",
    "ville": "Lésigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Leudon-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77127",
    "ville": "Lieusaint",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77550",
    "ville": "Limoges-Fourches",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77550",
    "ville": "Lissy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77220",
    "ville": "Liverdy-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77000",
    "ville": "Livry-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Lizines",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Lizy-sur-Ourcq",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77185",
    "ville": "Lognes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Longperrier",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Longueville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Lorrez-le-Bocage-Préaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Louan-Villegruis-Fontaine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Luisetaines",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Lumigny-Nesles-Ormeaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77138",
    "ville": "Luzancy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77133",
    "ville": "Machault",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "La Madeleine-sur-Loing",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77700",
    "ville": "Magny-le-Hongre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Maincy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Maisoncelles-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Maisoncelles-en-Gâtinais",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Maison-Rouge",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Marchémoret",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77139",
    "ville": "Marcilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Les Marêts",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77100",
    "ville": "Mareuil-lès-Meaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Marles-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Marolles-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Marolles-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Mary-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Mauperthuis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77990",
    "ville": "Mauregard",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77145",
    "ville": "May-en-Multien",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77100",
    "ville": "Meaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77350",
    "ville": "Le Mée-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Meigneux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Meilleray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77000",
    "ville": "Melun",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77171",
    "ville": "Melz-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77730",
    "ville": "Méry-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77990",
    "ville": "Le Mesnil-Amelot",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Messy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Misy-sur-Yonne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77290",
    "ville": "Mitry-Mory",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Moisenay",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77550",
    "ville": "Moissy-Cramayel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77570",
    "ville": "Mondreville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Mons-en-Montois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Montceaux-lès-Meaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77151",
    "ville": "Montceaux-lès-Provins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77140",
    "ville": "Montcourt-Fromonville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Montdauphin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Montenils",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Montereau-Fault-Yonne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Montereau-sur-le-Jard",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77144",
    "ville": "Montévrain",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Montgé-en-Goële",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77122",
    "ville": "Monthyon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Montigny-le-Guesdier",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Montigny-Lencoup",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77690",
    "ville": "Montigny-sur-Loing",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Montmachoux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Montolivet",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Montry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77250",
    "ville": "Moret-Loing-et-Orvanne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Mormant",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77163",
    "ville": "Mortcerf",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Mortery",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Mouroux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Mousseaux-lès-Bray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Moussy-le-Neuf",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Moussy-le-Vieux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Mouy-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77176",
    "ville": "Nandy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Nangis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Nanteau-sur-Essonne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Nanteau-sur-Lunain",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77100",
    "ville": "Nanteuil-lès-Meaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77730",
    "ville": "Nanteuil-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Nantouillet",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77140",
    "ville": "Nemours",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77124",
    "ville": "Chauconin-Neufmontiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77610",
    "ville": "Neufmoutiers-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77186",
    "ville": "Noisiel",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Noisy-Rudignon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77123",
    "ville": "Noisy-sur-École",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77140",
    "ville": "Nonville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77114",
    "ville": "Noyen-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77890",
    "ville": "Obsonville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Ocquerre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77178",
    "ville": "Oissery",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Orly-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77134",
    "ville": "Les Ormes-sur-Voulzie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77167",
    "ville": "Ormesson",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77280",
    "ville": "Othis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77330",
    "ville": "Ozoir-la-Ferrière",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Ozouer-le-Voulgis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Paley",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77830",
    "ville": "Pamfou",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Paroy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Passy-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77970",
    "ville": "Pécy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77124",
    "ville": "Penchard",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Perthes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77131",
    "ville": "Pézarches",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Pierre-Levée",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77181",
    "ville": "Le Pin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Le Plessis-aux-Bois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Le Plessis-Feu-Aussoux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Le Plessis-l'Évêque",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Le Plessis-Placy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Poigny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Poincy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77167",
    "ville": "Poligny",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77515",
    "ville": "Pommeuse",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Pomponne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77340",
    "ville": "Pontault-Combault",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77135",
    "ville": "Pontcarré",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Précy-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77220",
    "ville": "Presles-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77310",
    "ville": "Pringy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Provins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77139",
    "ville": "Puisieux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Quiers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77860",
    "ville": "Quincy-Voisins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Rampillon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77550",
    "ville": "Réau",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Rebais",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Recloses",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Remauville",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Reuil-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77000",
    "ville": "La Rochette",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77680",
    "ville": "Roissy-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Rouilly",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Rouvres",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Rozay-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Rubelles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Rumont",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Rupéreux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77730",
    "ville": "Saâcy-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Sablonnières",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77515",
    "ville": "Saint-Augustin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Sainte-Aulde",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Saint-Barthélemy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Saint-Brice",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Sainte-Colombe",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Saint-Cyr-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Saint-Denis-lès-Rebais",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77310",
    "ville": "Saint-Fargeau-Ponthierry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Saint-Fiacre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Saint-Germain-Laval",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Saint-Germain-Laxis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77169",
    "ville": "Saint-Germain-sous-Doue",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Saint-Germain-sur-École",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77860",
    "ville": "Saint-Germain-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Saint-Hilliers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77660",
    "ville": "Saint-Jean-les-Deux-Jumeaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Saint-Just-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Saint-Léger",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Saint-Loup-de-Naud",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77670",
    "ville": "Saint-Mammès",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Saint-Mard",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Saint-Mars-Vieux-Maisons",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Saint-Martin-des-Champs",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Saint-Martin-du-Boschet",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77630",
    "ville": "Saint-Martin-en-Bière",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Saint-Méry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Saint-Mesmes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77720",
    "ville": "Saint-Ouen-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77750",
    "ville": "Saint-Ouen-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77178",
    "ville": "Saint-Pathus",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77140",
    "ville": "Saint-Pierre-lès-Nemours",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Saint-Rémy-de-la-Vanne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77120",
    "ville": "Beautheil-Saints",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Saint-Sauveur-lès-Bray",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77930",
    "ville": "Saint-Sauveur-sur-École",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77169",
    "ville": "Saint-Siméon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77165",
    "ville": "Saint-Soupplets",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Saint-Thibault-des-Vignes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77148",
    "ville": "Salins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Sammeron",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77920",
    "ville": "Samois-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77210",
    "ville": "Samoreau",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Sancy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77320",
    "ville": "Sancy-lès-Provins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77176",
    "ville": "Savigny-le-Temple",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Savins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77240",
    "ville": "Seine-Port",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Sept-Sorts",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77700",
    "ville": "Serris",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77170",
    "ville": "Servon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77640",
    "ville": "Signy-Signets",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Sigy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77115",
    "ville": "Sivry-Courtry",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Sognolles-en-Montois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77111",
    "ville": "Soignolles-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77650",
    "ville": "Soisy-Bouy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77111",
    "ville": "Solers",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77460",
    "ville": "Souppes-sur-Loing",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77171",
    "ville": "Sourdun",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Tancrou",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Thénisy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Thieux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77810",
    "ville": "Thomery",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77400",
    "ville": "Thorigny-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Thoury-Férottes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77163",
    "ville": "Tigeaux",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "La Tombe",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77200",
    "ville": "Torcy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77131",
    "ville": "Touquin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77220",
    "ville": "Tournan-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77123",
    "ville": "Tousson",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "La Trétoire",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Treuzy-Levelay",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Trilbardou",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Trilport",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Trocy-en-Multien",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Ury",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77260",
    "ville": "Ussy-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77360",
    "ville": "Vaires-sur-Marne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77830",
    "ville": "Valence-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Vanvillé",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Varennes-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77910",
    "ville": "Varreddes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Vaucourtois",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77123",
    "ville": "Le Vaudoué",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77141",
    "ville": "Vaudoy-en-Brie",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77000",
    "ville": "Vaux-le-Pénil",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Vaux-sur-Lunain",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77440",
    "ville": "Vendrest",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Verdelot",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Verneuil-l'Étang",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77670",
    "ville": "Vernou-la-Celle-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77240",
    "ville": "Vert-Saint-Denis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77370",
    "ville": "Vieux-Champagne",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77450",
    "ville": "Vignely",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Villebéon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77250",
    "ville": "Villecerf",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77710",
    "ville": "Villemaréchal",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77470",
    "ville": "Villemareuil",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77250",
    "ville": "Villemer",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Villenauxe-la-Petite",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77174",
    "ville": "Villeneuve-le-Comte",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77154",
    "ville": "Villeneuve-les-Bordes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77174",
    "ville": "Villeneuve-Saint-Denis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Villeneuve-sous-Dammartin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77510",
    "ville": "Villeneuve-sur-Bellot",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77124",
    "ville": "Villenoy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77270",
    "ville": "Villeparisis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Villeroy",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77130",
    "ville": "Ville-Saint-Jacques",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77410",
    "ville": "Villevaudé",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77190",
    "ville": "Villiers-en-Bière",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Villiers-Saint-Georges",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77760",
    "ville": "Villiers-sous-Grez",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Villiers-sur-Morin",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77114",
    "ville": "Villiers-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77480",
    "ville": "Villuis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77520",
    "ville": "Vimpelles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77230",
    "ville": "Vinantes",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77139",
    "ville": "Vincy-Manœuvre",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77540",
    "ville": "Voinsles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77950",
    "ville": "Voisenon",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77580",
    "ville": "Voulangis",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77560",
    "ville": "Voulton",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77940",
    "ville": "Voulx",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77160",
    "ville": "Vulaines-lès-Provins",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77870",
    "ville": "Vulaines-sur-Seine",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "77390",
    "ville": "Yèbles",
    "dep": "Seine-et-Marne"
  },
  {
    "code": "78660",
    "ville": "Ablis",
    "dep": "Yvelines"
  },
  {
    "code": "78260",
    "ville": "Achères",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "Adainville",
    "dep": "Yvelines"
  },
  {
    "code": "78240",
    "ville": "Aigremont",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Allainville",
    "dep": "Yvelines"
  },
  {
    "code": "78580",
    "ville": "Les Alluets-le-Roi",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Andelu",
    "dep": "Yvelines"
  },
  {
    "code": "78570",
    "ville": "Andrésy",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Arnouville-lès-Mantes",
    "dep": "Yvelines"
  },
  {
    "code": "78410",
    "ville": "Aubergenville",
    "dep": "Yvelines"
  },
  {
    "code": "78610",
    "ville": "Auffargis",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Auffreville-Brasseuil",
    "dep": "Yvelines"
  },
  {
    "code": "78126",
    "ville": "Aulnay-sur-Mauldre",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Auteuil",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Autouillet",
    "dep": "Yvelines"
  },
  {
    "code": "78870",
    "ville": "Bailly",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Bazainville",
    "dep": "Yvelines"
  },
  {
    "code": "78580",
    "ville": "Bazemont",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Bazoches-sur-Guyonne",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Béhoust",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Bennecourt",
    "dep": "Yvelines"
  },
  {
    "code": "78650",
    "ville": "Beynes",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Blaru",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Boinville-en-Mantois",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Boinville-le-Gaillard",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Boinvilliers",
    "dep": "Yvelines"
  },
  {
    "code": "78390",
    "ville": "Bois-d'Arcy",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Boissets",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "La Boissière-École",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Boissy-Mauvoisin",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Boissy-sans-Avoir",
    "dep": "Yvelines"
  },
  {
    "code": "78830",
    "ville": "Bonnelles",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Bonnières-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78410",
    "ville": "Bouafle",
    "dep": "Yvelines"
  },
  {
    "code": "78380",
    "ville": "Bougival",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "Bourdonné",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Breuil-Bois-Robert",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Bréval",
    "dep": "Yvelines"
  },
  {
    "code": "78610",
    "ville": "Les Bréviaires",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Brueil-en-Vexin",
    "dep": "Yvelines"
  },
  {
    "code": "78530",
    "ville": "Buc",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Buchelay",
    "dep": "Yvelines"
  },
  {
    "code": "78830",
    "ville": "Bullion",
    "dep": "Yvelines"
  },
  {
    "code": "78955",
    "ville": "Carrières-sous-Poissy",
    "dep": "Yvelines"
  },
  {
    "code": "78420",
    "ville": "Carrières-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78720",
    "ville": "La Celle-les-Bordes",
    "dep": "Yvelines"
  },
  {
    "code": "78170",
    "ville": "La Celle-Saint-Cloud",
    "dep": "Yvelines"
  },
  {
    "code": "78720",
    "ville": "Cernay-la-Ville",
    "dep": "Yvelines"
  },
  {
    "code": "78240",
    "ville": "Chambourcy",
    "dep": "Yvelines"
  },
  {
    "code": "78570",
    "ville": "Chanteloup-les-Vignes",
    "dep": "Yvelines"
  },
  {
    "code": "78130",
    "ville": "Chapet",
    "dep": "Yvelines"
  },
  {
    "code": "78117",
    "ville": "Châteaufort",
    "dep": "Yvelines"
  },
  {
    "code": "78400",
    "ville": "Chatou",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Chaufour-lès-Bonnières",
    "dep": "Yvelines"
  },
  {
    "code": "78450",
    "ville": "Chavenay",
    "dep": "Yvelines"
  },
  {
    "code": "78150",
    "ville": "Le Chesnay-Rocquencourt",
    "dep": "Yvelines"
  },
  {
    "code": "78460",
    "ville": "Chevreuse",
    "dep": "Yvelines"
  },
  {
    "code": "78460",
    "ville": "Choisel",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Civry-la-Forêt",
    "dep": "Yvelines"
  },
  {
    "code": "78120",
    "ville": "Clairefontaine-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78340",
    "ville": "Les Clayes-sous-Bois",
    "dep": "Yvelines"
  },
  {
    "code": "78310",
    "ville": "Coignières",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "Condé-sur-Vesgre",
    "dep": "Yvelines"
  },
  {
    "code": "78700",
    "ville": "Conflans-Sainte-Honorine",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Courgent",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Cravent",
    "dep": "Yvelines"
  },
  {
    "code": "78121",
    "ville": "Crespières",
    "dep": "Yvelines"
  },
  {
    "code": "78290",
    "ville": "Croissy-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78111",
    "ville": "Dammartin-en-Serve",
    "dep": "Yvelines"
  },
  {
    "code": "78720",
    "ville": "Dampierre-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Dannemarie",
    "dep": "Yvelines"
  },
  {
    "code": "78810",
    "ville": "Davron",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Drocourt",
    "dep": "Yvelines"
  },
  {
    "code": "78920",
    "ville": "Ecquevilly",
    "dep": "Yvelines"
  },
  {
    "code": "78990",
    "ville": "Élancourt",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Émancé",
    "dep": "Yvelines"
  },
  {
    "code": "78680",
    "ville": "Épône",
    "dep": "Yvelines"
  },
  {
    "code": "78690",
    "ville": "Les Essarts-le-Roi",
    "dep": "Yvelines"
  },
  {
    "code": "78620",
    "ville": "L'Étang-la-Ville",
    "dep": "Yvelines"
  },
  {
    "code": "78740",
    "ville": "Évecquemont",
    "dep": "Yvelines"
  },
  {
    "code": "78410",
    "ville": "La Falaise",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Favrieux",
    "dep": "Yvelines"
  },
  {
    "code": "78810",
    "ville": "Feucherolles",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Flacourt",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Flexanville",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Flins-Neuve-Église",
    "dep": "Yvelines"
  },
  {
    "code": "78410",
    "ville": "Flins-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78520",
    "ville": "Follainville-Dennemont",
    "dep": "Yvelines"
  },
  {
    "code": "78330",
    "ville": "Fontenay-le-Fleury",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Fontenay-Mauvoisin",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Fontenay-Saint-Père",
    "dep": "Yvelines"
  },
  {
    "code": "78840",
    "ville": "Freneuse",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Gaillon-sur-Montcient",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Galluis",
    "dep": "Yvelines"
  },
  {
    "code": "78950",
    "ville": "Gambais",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Gambaiseuil",
    "dep": "Yvelines"
  },
  {
    "code": "78890",
    "ville": "Garancières",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Gargenville",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Gazeran",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Gommecourt",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Goupillières",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Goussonville",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "Grandchamp",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Gressey",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Grosrouvre",
    "dep": "Yvelines"
  },
  {
    "code": "78520",
    "ville": "Guernes",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Guerville",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Guitrancourt",
    "dep": "Yvelines"
  },
  {
    "code": "78280",
    "ville": "Guyancourt",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Hardricourt",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Hargeville",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "La Hauteville",
    "dep": "Yvelines"
  },
  {
    "code": "78580",
    "ville": "Herbeville",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Hermeray",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Houdan",
    "dep": "Yvelines"
  },
  {
    "code": "78800",
    "ville": "Houilles",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Issou",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Jambville",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Notre-Dame-de-la-Mer",
    "dep": "Yvelines"
  },
  {
    "code": "78760",
    "ville": "Jouars-Pontchartrain",
    "dep": "Yvelines"
  },
  {
    "code": "78350",
    "ville": "Jouy-en-Josas",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Jouy-Mauvoisin",
    "dep": "Yvelines"
  },
  {
    "code": "78580",
    "ville": "Jumeauville",
    "dep": "Yvelines"
  },
  {
    "code": "78820",
    "ville": "Juziers",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Lainville-en-Vexin",
    "dep": "Yvelines"
  },
  {
    "code": "78320",
    "ville": "Lévis-Saint-Nom",
    "dep": "Yvelines"
  },
  {
    "code": "78520",
    "ville": "Limay",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Limetz-Villez",
    "dep": "Yvelines"
  },
  {
    "code": "78350",
    "ville": "Les Loges-en-Josas",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Lommoye",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Longnes",
    "dep": "Yvelines"
  },
  {
    "code": "78730",
    "ville": "Longvilliers",
    "dep": "Yvelines"
  },
  {
    "code": "78430",
    "ville": "Louveciennes",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Magnanville",
    "dep": "Yvelines"
  },
  {
    "code": "78114",
    "ville": "Magny-les-Hameaux",
    "dep": "Yvelines"
  },
  {
    "code": "78600",
    "ville": "Maisons-Laffitte",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Mantes-la-Jolie",
    "dep": "Yvelines"
  },
  {
    "code": "78711",
    "ville": "Mantes-la-Ville",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Marcq",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Mareil-le-Guyon",
    "dep": "Yvelines"
  },
  {
    "code": "78750",
    "ville": "Mareil-Marly",
    "dep": "Yvelines"
  },
  {
    "code": "78124",
    "ville": "Mareil-sur-Mauldre",
    "dep": "Yvelines"
  },
  {
    "code": "78160",
    "ville": "Marly-le-Roi",
    "dep": "Yvelines"
  },
  {
    "code": "78580",
    "ville": "Maule",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Maulette",
    "dep": "Yvelines"
  },
  {
    "code": "78780",
    "ville": "Maurecourt",
    "dep": "Yvelines"
  },
  {
    "code": "78310",
    "ville": "Maurepas",
    "dep": "Yvelines"
  },
  {
    "code": "78670",
    "ville": "Médan",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Ménerville",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Méré",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Méricourt",
    "dep": "Yvelines"
  },
  {
    "code": "78600",
    "ville": "Le Mesnil-le-Roi",
    "dep": "Yvelines"
  },
  {
    "code": "78320",
    "ville": "Le Mesnil-Saint-Denis",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Les Mesnuls",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Meulan-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78970",
    "ville": "Mézières-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Mézy-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78940",
    "ville": "Millemont",
    "dep": "Yvelines"
  },
  {
    "code": "78470",
    "ville": "Milon-la-Chapelle",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Mittainville",
    "dep": "Yvelines"
  },
  {
    "code": "78840",
    "ville": "Moisson",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Mondreville",
    "dep": "Yvelines"
  },
  {
    "code": "78124",
    "ville": "Montainville",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Montalet-le-Bois",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Montchauvet",
    "dep": "Yvelines"
  },
  {
    "code": "78360",
    "ville": "Montesson",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Montfort-l'Amaury",
    "dep": "Yvelines"
  },
  {
    "code": "78180",
    "ville": "Montigny-le-Bretonneux",
    "dep": "Yvelines"
  },
  {
    "code": "78630",
    "ville": "Morainvilliers",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Mousseaux-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Mulcent",
    "dep": "Yvelines"
  },
  {
    "code": "78130",
    "ville": "Les Mureaux",
    "dep": "Yvelines"
  },
  {
    "code": "78640",
    "ville": "Neauphle-le-Château",
    "dep": "Yvelines"
  },
  {
    "code": "78640",
    "ville": "Neauphle-le-Vieux",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Neauphlette",
    "dep": "Yvelines"
  },
  {
    "code": "78410",
    "ville": "Nézel",
    "dep": "Yvelines"
  },
  {
    "code": "78590",
    "ville": "Noisy-le-Roi",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Oinville-sur-Montcient",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Orcemont",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Orgerus",
    "dep": "Yvelines"
  },
  {
    "code": "78630",
    "ville": "Orgeval",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Orphin",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Orsonville",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Orvilliers",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Osmoy",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Paray-Douaville",
    "dep": "Yvelines"
  },
  {
    "code": "78230",
    "ville": "Le Pecq",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Perdreauville",
    "dep": "Yvelines"
  },
  {
    "code": "78610",
    "ville": "Le Perray-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78370",
    "ville": "Plaisir",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Poigny-la-Forêt",
    "dep": "Yvelines"
  },
  {
    "code": "78300",
    "ville": "Poissy",
    "dep": "Yvelines"
  },
  {
    "code": "78730",
    "ville": "Ponthévrard",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Porcheville",
    "dep": "Yvelines"
  },
  {
    "code": "78560",
    "ville": "Le Port-Marly",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Prunay-le-Temple",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Prunay-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78940",
    "ville": "La Queue-les-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Raizeux",
    "dep": "Yvelines"
  },
  {
    "code": "78120",
    "ville": "Rambouillet",
    "dep": "Yvelines"
  },
  {
    "code": "78590",
    "ville": "Rennemoulin",
    "dep": "Yvelines"
  },
  {
    "code": "78550",
    "ville": "Richebourg",
    "dep": "Yvelines"
  },
  {
    "code": "78730",
    "ville": "Rochefort-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "Rolleboise",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Rosay",
    "dep": "Yvelines"
  },
  {
    "code": "78710",
    "ville": "Rosny-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78440",
    "ville": "Sailly",
    "dep": "Yvelines"
  },
  {
    "code": "78730",
    "ville": "Saint-Arnoult-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78210",
    "ville": "Saint-Cyr-l'École",
    "dep": "Yvelines"
  },
  {
    "code": "78720",
    "ville": "Saint-Forget",
    "dep": "Yvelines"
  },
  {
    "code": "78640",
    "ville": "Saint-Germain-de-la-Grange",
    "dep": "Yvelines"
  },
  {
    "code": "78112",
    "ville": "Saint-Germain-en-Laye",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Saint-Hilarion",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Saint-Illiers-la-Ville",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Saint-Illiers-le-Bois",
    "dep": "Yvelines"
  },
  {
    "code": "78470",
    "ville": "Saint-Lambert",
    "dep": "Yvelines"
  },
  {
    "code": "78610",
    "ville": "Saint-Léger-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78660",
    "ville": "Saint-Martin-de-Bréthencourt",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Saint-Martin-des-Champs",
    "dep": "Yvelines"
  },
  {
    "code": "78520",
    "ville": "Saint-Martin-la-Garenne",
    "dep": "Yvelines"
  },
  {
    "code": "78730",
    "ville": "Sainte-Mesme",
    "dep": "Yvelines"
  },
  {
    "code": "78860",
    "ville": "Saint-Nom-la-Bretèche",
    "dep": "Yvelines"
  },
  {
    "code": "78470",
    "ville": "Saint-Rémy-lès-Chevreuse",
    "dep": "Yvelines"
  },
  {
    "code": "78690",
    "ville": "Saint-Rémy-l'Honoré",
    "dep": "Yvelines"
  },
  {
    "code": "78500",
    "ville": "Sartrouville",
    "dep": "Yvelines"
  },
  {
    "code": "78650",
    "ville": "Saulx-Marchais",
    "dep": "Yvelines"
  },
  {
    "code": "78720",
    "ville": "Senlisse",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Septeuil",
    "dep": "Yvelines"
  },
  {
    "code": "78200",
    "ville": "Soindres",
    "dep": "Yvelines"
  },
  {
    "code": "78120",
    "ville": "Sonchamp",
    "dep": "Yvelines"
  },
  {
    "code": "78910",
    "ville": "Tacoignières",
    "dep": "Yvelines"
  },
  {
    "code": "78113",
    "ville": "Le Tartre-Gaudran",
    "dep": "Yvelines"
  },
  {
    "code": "78980",
    "ville": "Le Tertre-Saint-Denis",
    "dep": "Yvelines"
  },
  {
    "code": "78250",
    "ville": "Tessancourt-sur-Aubette",
    "dep": "Yvelines"
  },
  {
    "code": "78850",
    "ville": "Thiverval-Grignon",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Thoiry",
    "dep": "Yvelines"
  },
  {
    "code": "78790",
    "ville": "Tilly",
    "dep": "Yvelines"
  },
  {
    "code": "78117",
    "ville": "Toussus-le-Noble",
    "dep": "Yvelines"
  },
  {
    "code": "78190",
    "ville": "Trappes",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Le Tremblay-sur-Mauldre",
    "dep": "Yvelines"
  },
  {
    "code": "78510",
    "ville": "Triel-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78740",
    "ville": "Vaux-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78140",
    "ville": "Vélizy-Villacoublay",
    "dep": "Yvelines"
  },
  {
    "code": "78480",
    "ville": "Verneuil-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78540",
    "ville": "Vernouillet",
    "dep": "Yvelines"
  },
  {
    "code": "78320",
    "ville": "La Verrière",
    "dep": "Yvelines"
  },
  {
    "code": "78000",
    "ville": "Versailles",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Vert",
    "dep": "Yvelines"
  },
  {
    "code": "78110",
    "ville": "Le Vésinet",
    "dep": "Yvelines"
  },
  {
    "code": "78490",
    "ville": "Vicq",
    "dep": "Yvelines"
  },
  {
    "code": "78125",
    "ville": "Vieille-Église-en-Yvelines",
    "dep": "Yvelines"
  },
  {
    "code": "78270",
    "ville": "La Villeneuve-en-Chevrie",
    "dep": "Yvelines"
  },
  {
    "code": "78670",
    "ville": "Villennes-sur-Seine",
    "dep": "Yvelines"
  },
  {
    "code": "78450",
    "ville": "Villepreux",
    "dep": "Yvelines"
  },
  {
    "code": "78930",
    "ville": "Villette",
    "dep": "Yvelines"
  },
  {
    "code": "78770",
    "ville": "Villiers-le-Mahieu",
    "dep": "Yvelines"
  },
  {
    "code": "78640",
    "ville": "Villiers-Saint-Frédéric",
    "dep": "Yvelines"
  },
  {
    "code": "78220",
    "ville": "Viroflay",
    "dep": "Yvelines"
  },
  {
    "code": "78960",
    "ville": "Voisins-le-Bretonneux",
    "dep": "Yvelines"
  },
  {
    "code": "79240",
    "ville": "L'Absie",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Adilly",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Aiffres",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Airvault",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Allonne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79350",
    "ville": "Amailloux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Amuré",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Arçais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Ardin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79150",
    "ville": "Argentonnay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79290",
    "ville": "Loretz-d'Argenton",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Asnières-en-Poitou",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Assais-les-Jumeaux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Aubigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Aubigny",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Augé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Availles-Thouarsais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Avon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Azay-le-Brûlé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Azay-sur-Thouet",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Beaulieu-sous-Parthenay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79370",
    "ville": "Beaussais-Vitré",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Beauvoir-sur-Niort",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Béceleuf",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79000",
    "ville": "Bessines",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79300",
    "ville": "Boismé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "La Boissière-en-Gâtine",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Bougon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Le Bourdet",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Boussais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79260",
    "ville": "La Crèche",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79300",
    "ville": "Bressuire",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Bretignolles",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Brieuil-sur-Chizé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79290",
    "ville": "Brion-près-Thouet",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Brioux-sur-Boutonne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Brûlain",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Le Busseau",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Caunay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79370",
    "ville": "Celles-sur-Belle",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Cerizay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79290",
    "ville": "Val en Vignes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Fontivillié",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Champdeniers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79320",
    "ville": "Chanteloup",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "La Chapelle-Bâton",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "La Chapelle-Bertrand",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "La Chapelle-Pouilloux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79430",
    "ville": "La Chapelle-Saint-Laurent",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Beugnon-Thireuil",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Plaine-d'Argenson",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79700",
    "ville": "Mauléon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Châtillon-sur-Thouet",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79180",
    "ville": "Chauray",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Chef-Boutonne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Chenay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Chérigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79410",
    "ville": "Cherveux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Chey",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79350",
    "ville": "Chiché",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Le Chillou",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Chizé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Cirières",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Clavé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79350",
    "ville": "Clessé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Clussais-la-Pommeraie",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Combrand",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79510",
    "ville": "Coulon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Coulonges-sur-l'Autize",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Coulonges-Thouarsais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79440",
    "ville": "Courlay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Cours",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Les Châteliers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Couture-d'Argenson",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Doux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79410",
    "ville": "Échiré",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Ensigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Épannes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Exireuil",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Exoudun",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79350",
    "ville": "Faye-l'Abbesse",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Faye-sur-Ardin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79450",
    "ville": "Fénery",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Fenioux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "La Ferrière-en-Parthenay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Fomperron",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Fontenille-Saint-Martin-d'Entraigues",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79380",
    "ville": "La Forêt-sur-Sèvre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Les Forges",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Fors",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Les Fosses",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "La Foye-Monjault",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79260",
    "ville": "François",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79370",
    "ville": "Fressines",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Frontenay-Rohan-Rohan",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Geay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79150",
    "ville": "Genneton",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Germond-Rouvre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Glénay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Gourgé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Alloinay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Granzay-Gript",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Les Groseillers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Valdelaume",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Irais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Juillé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Juscorps",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Lageon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Largeasse",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Lezay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Lhoumois",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Limalonges",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Lorigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Loubigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Loubillé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Louin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Louzy",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Luché-sur-Brioux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Luché-Thouarsais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Lusseray",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Luzay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79460",
    "ville": "Magné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Mairé-Levescault",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79500",
    "ville": "Maisonnay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Maisontiers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Marigny",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Marnes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Mauzé-sur-le-Mignon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "Mazières-en-Gâtine",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79500",
    "ville": "Melle",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Melleran",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Ménigoute",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Messé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79320",
    "ville": "Moncoutant-sur-Sèvre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Montalembert",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Montravers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "La Mothe-Saint-Héray",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79370",
    "ville": "Aigondigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Nanteuil",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Neuvy-Bouin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79000",
    "ville": "Niort",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79250",
    "ville": "Nueil-les-Aubiers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Plaine-et-Vallées",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Oroux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Paizay-le-Chapt",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Pamplie",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Pamproux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Parthenay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Pas-de-Jeu",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Périgné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Pers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79700",
    "ville": "La Petite-Boissière",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "La Peyratte",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Pierrefitte",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79140",
    "ville": "Le Pin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Pliboux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Pompaire",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Pougne-Hérisson",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Prahecq",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Prailles-La Couarde",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Pressigny",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Prin-Deyrançon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Puihardy",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Reffannes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Le Retail",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "La Rochénard",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Rom",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79260",
    "ville": "Romans",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79700",
    "ville": "Saint-Amand-sur-Sèvre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79380",
    "ville": "Saint-André-sur-Sèvre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79300",
    "ville": "Saint-Aubin-du-Plain",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79450",
    "ville": "Saint-Aubin-le-Cloud",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Saint-Christophe-sur-Roc",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79150",
    "ville": "Voulmentin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Saint-Coutant",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Saint-Cyr-la-Lande",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Sainte-Eanne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79410",
    "ville": "Saint-Gelais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Sainte-Gemme",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79500",
    "ville": "Marcillé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Saint-Généroux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Saint-Georges-de-Noisné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Saint-Georges-de-Rex",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Saint-Germain-de-Longue-Chaume",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Saint-Germier",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Saint-Hilaire-la-Palud",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Saint-Jacques-de-Thouars",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Saint-Jean-de-Thouars",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Saint-Laurs",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Saint-Léger-de-Montbrun",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Saint-Lin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79600",
    "ville": "Saint-Loup-Lamairé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Saint-Maixent-de-Beugné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Saint-Maixent-l'École",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "Saint-Marc-la-Lande",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Saint-Martin-de-Bernegoue",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Saint-Martin-de-Mâcon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Saint-Martin-de-Saint-Maixent",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79290",
    "ville": "Saint-Martin-de-Sanzay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Saint-Martin-du-Fouilloux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79150",
    "ville": "Saint Maurice Étusson",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79410",
    "ville": "Saint-Maxire",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79260",
    "ville": "Sainte-Néomaye",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Sainte-Ouenne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "Saint-Pardoux-Soutiers",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Saint-Paul-en-Gâtine",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79700",
    "ville": "Saint-Pierre-des-Échaubrognes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Saint-Pompain",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79410",
    "ville": "Saint-Rémy",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Saint-Romans-des-Champs",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79500",
    "ville": "Saint-Romans-lès-Melle",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Sainte-Soline",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Saint-Symphorien",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79330",
    "ville": "Saint-Varent",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Sainte-Verge",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79500",
    "ville": "Saint-Vincent-la-Châtre",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79400",
    "ville": "Saivres",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Salles",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Sansais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Saurais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79190",
    "ville": "Sauzé-Vaussais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79000",
    "ville": "Sciecq",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Scillé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Secondigné-sur-Belle",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79130",
    "ville": "Secondigny",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Séligné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Sepvret",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Soudan",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79800",
    "ville": "Souvigné",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Surin",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Le Tallud",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79390",
    "ville": "Thénezay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Thouars",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79100",
    "ville": "Tourtenay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Trayes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79210",
    "ville": "Val-du-Mignon",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Vallans",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Vançais",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79270",
    "ville": "Le Vanneau-Irleau",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79120",
    "ville": "Vanzay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79340",
    "ville": "Vasles",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Vausseroux",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79420",
    "ville": "Vautebis",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79240",
    "ville": "Vernoux-en-Gâtine",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Vernoux-sur-Boutonne",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "Verruyes",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Le Vert",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79200",
    "ville": "Viennay",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Villefollet",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79110",
    "ville": "Villemain",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79360",
    "ville": "Villiers-en-Bois",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79160",
    "ville": "Villiers-en-Plaine",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79170",
    "ville": "Villiers-sur-Chizé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79310",
    "ville": "Vouhé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79230",
    "ville": "Vouillé",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "79220",
    "ville": "Xaintray",
    "dep": "Deux-Sèvres"
  },
  {
    "code": "80100",
    "ville": "Abbeville",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Ablaincourt-Pressoir",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Acheux-en-Amiénois",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Acheux-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Agenville",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Agenvillers",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Aigneville",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Ailly-le-Haut-Clocher",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Ailly-sur-Noye",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Ailly-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Airaines",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Aizecourt-le-Bas",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Aizecourt-le-Haut",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Albert",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Allaines",
    "dep": "Somme"
  },
  {
    "code": "80130",
    "ville": "Allenay",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Allery",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Allonville",
    "dep": "Somme"
  },
  {
    "code": "80090",
    "ville": "Amiens",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Andainville",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Andechy",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Argœuves",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Argoules",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Arguel",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Armancourt",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Arquèves",
    "dep": "Somme"
  },
  {
    "code": "80820",
    "ville": "Arrest",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Arry",
    "dep": "Somme"
  },
  {
    "code": "80910",
    "ville": "Arvillers",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Assainvillers",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Assevillers",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Athies",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Aubercourt",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Aubigny",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Aubvillers",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Auchonvillers",
    "dep": "Somme"
  },
  {
    "code": "80460",
    "ville": "Ault",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Aumâtre",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Aumont",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Autheux",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Authie",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Authieule",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Authuille",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Avelesges",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Aveluy",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Avesnes-Chaussoy",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Ayencourt",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Bacouel-sur-Selle",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Bailleul",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Baizieux",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Balâtre",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Barleux",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Barly",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Bavelincourt",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Bayencourt",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Bayonvillers",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Bazentin",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Béalcourt",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Beaucamps-le-Jeune",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Beaucamps-le-Vieux",
    "dep": "Somme"
  },
  {
    "code": "80770",
    "ville": "Beauchamps",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Beaucourt-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Beaucourt-sur-l'Ancre",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Beaucourt-sur-l'Hallue",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Beaufort-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Beaumetz",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Beaumont-Hamel",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Beauquesne",
    "dep": "Somme"
  },
  {
    "code": "80630",
    "ville": "Beauval",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Bécordel-Bécourt",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Becquigny",
    "dep": "Somme"
  },
  {
    "code": "80870",
    "ville": "Béhen",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Béhencourt",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Bellancourt",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Belleuse",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Belloy-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Belloy-Saint-Léonard",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Belloy-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Bergicourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Bermesnil",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Bernâtre",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Bernaville",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Bernay-en-Ponthieu",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Bernes",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Berneuil",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Berny-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Bertangles",
    "dep": "Somme"
  },
  {
    "code": "80850",
    "ville": "Berteaucourt-les-Dames",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Berteaucourt-lès-Thennes",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Bertrancourt",
    "dep": "Somme"
  },
  {
    "code": "80130",
    "ville": "Béthencourt-sur-Mer",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Béthencourt-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Bettembos",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Bettencourt-Rivière",
    "dep": "Somme"
  },
  {
    "code": "80610",
    "ville": "Bettencourt-Saint-Ouen",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Beuvraignes",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Biaches",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Biarre",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Biencourt",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Billancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Blangy-sous-Poix",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Blangy-Tronville",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Boisbergues",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Le Boisle",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Boismont",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Bonnay",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Bonneville",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Bosquel",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Bouchavesnes-Bergen",
    "dep": "Somme"
  },
  {
    "code": "80910",
    "ville": "Bouchoir",
    "dep": "Somme"
  },
  {
    "code": "80830",
    "ville": "Bouchon",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Boufflers",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Bougainville",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Bouillancourt-en-Séry",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Bouillancourt-la-Bataille",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Bouquemaison",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Bourdon",
    "dep": "Somme"
  },
  {
    "code": "80130",
    "ville": "Bourseville",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Boussicourt",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Bouttencourt",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Bouvaincourt-sur-Bresle",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Bouvincourt-en-Vermandois",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Bouzincourt",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Bovelles",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Boves",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Braches",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Brailly-Cornehotte",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Brassy",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Bray-lès-Mareuil",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Bray-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Breilly",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Bresle",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Breuil",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Brévillers",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Brie",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Briquemesnil-Floxicourt",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Brocourt",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Brouchy",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Brucamps",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Brutelles",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Buigny-l'Abbé",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Buigny-lès-Gamaches",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Buigny-Saint-Maclou",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Buire-Courcelles",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Buire-sur-l'Ancre",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Bus-la-Mésière",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Bus-lès-Artois",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Bussu",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Bussus-Bussuel",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Bussy-lès-Daours",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Bussy-lès-Poix",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Buverchy",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Cachy",
    "dep": "Somme"
  },
  {
    "code": "80330",
    "ville": "Cagny",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Cahon",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Caix",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Cambron",
    "dep": "Somme"
  },
  {
    "code": "80450",
    "ville": "Camon",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Camps-en-Amiénois",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Canaples",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Canchy",
    "dep": "Somme"
  },
  {
    "code": "80750",
    "ville": "Candas",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Cannessières",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Cantigny",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Caours",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Cappy",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Cardonnette",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Le Cardonnois",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Carrépuis",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Cartigny",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Caulières",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Cavillon",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Cayeux-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80410",
    "ville": "Cayeux-sur-Mer",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Cerisy-Buleux",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Cerisy",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Champien",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Chaulnes",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "La Chaussée-Tirancourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Chaussoy-Epagny",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "La Chavatte",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Chépy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Chilly",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Chipilly",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Chirmont",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Chuignes",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Chuignolles",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Citerne",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Cizancourt",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Clairy-Saulchoix",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Cléry-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80510",
    "ville": "Cocquerel",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Coigneux",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Coisy",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Colincamps",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Combles",
    "dep": "Somme"
  },
  {
    "code": "80890",
    "ville": "Condé-Folie",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Contalmaison",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Contay",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Conteville",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Contre",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Conty",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Corbie",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Cottenchy",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Coullemelle",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Coulonvillers",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Courcelette",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Courcelles-au-Bois",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Courcelles-sous-Moyencourt",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Courcelles-sous-Thoix",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Courtemanche",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Cramont",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Crécy-en-Ponthieu",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Crémery",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Cressy-Omencourt",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Creuse",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Croix-Moligneaux",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Croixrault",
    "dep": "Somme"
  },
  {
    "code": "80550",
    "ville": "Le Crotoy",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Crouy-Saint-Pierre",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Curchy",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Curlu",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Damery",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Dancourt-Popincourt",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Daours",
    "dep": "Somme"
  },
  {
    "code": "80570",
    "ville": "Dargnies",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Davenescourt",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Démuin",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Dernancourt",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Devise",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Doingt",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Domart-en-Ponthieu",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Domart-sur-la-Luce",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Domesmont",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Dominois",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Domléger-Longvillers",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Dommartin",
    "dep": "Somme"
  },
  {
    "code": "80980",
    "ville": "Dompierre-Becquincourt",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Dompierre-sur-Authie",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Domqueur",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Domvast",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Doudelainville",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Douilly",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Doullens",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Dreuil-lès-Amiens",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Driencourt",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Dromesnil",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Drucat",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Dury",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Eaucourt-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "L'Échelle-Saint-Aurin",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Éclusier-Vaux",
    "dep": "Somme"
  },
  {
    "code": "80570",
    "ville": "Embreville",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Englebelmer",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Ennemain",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Épagne-Épagnette",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Épaumesnil",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Épécamps",
    "dep": "Somme"
  },
  {
    "code": "80740",
    "ville": "Épehy",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Épénancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Éplessier",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Eppeville",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Équancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Équennes-Éramecourt",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Erches",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Ercheu",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Ercourt",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Ergnies",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Érondelle",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Esclainvillers",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Esmery-Hallon",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Essertaux",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Estrébœuf",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Estrées-Deniécourt",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Estrées-lès-Crécy",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Estrées-sur-Noye",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Étalon",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Ételfay",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Éterpigny",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Étinehem-Méricourt",
    "dep": "Somme"
  },
  {
    "code": "80830",
    "ville": "L'Étoile",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Étréjust",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Étricourt-Manancourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "La Faloise",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Falvy",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Famechon",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Faverolles",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Favières",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Fay",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Ferrières",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Fescamps",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Feuillères",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Feuquières-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80750",
    "ville": "Fienvillers",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Fignières",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Fins",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Flaucourt",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Flers",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Flers-sur-Noye",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Flesselles",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Fleury",
    "dep": "Somme"
  },
  {
    "code": "80420",
    "ville": "Flixecourt",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Fluy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Folies",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Folleville",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Fonches-Fonchette",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Fontaine-le-Sec",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Fontaine-lès-Cappy",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Fontaine-sous-Montdidier",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Fontaine-sur-Maye",
    "dep": "Somme"
  },
  {
    "code": "80510",
    "ville": "Fontaine-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Forceville",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Forceville-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Forest-l'Abbaye",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Forest-Montiers",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Fort-Mahon-Plage",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Fossemanant",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Foucaucourt-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Foucaucourt-Hors-Nesle",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Fouencamps",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Fouilloy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Fouquescourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Fourcigny",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Fourdrinoy",
    "dep": "Somme"
  },
  {
    "code": "80131",
    "ville": "Framerville-Rainecourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Framicourt",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Francières",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Franleu",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Franqueville",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Fransart",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Fransu",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Fransures",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Franvillers",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Fréchencourt",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Frémontiers",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Fresnes-Mazancourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Fresnes-Tilloloy",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Fresneville",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Fresnoy-Andainville",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Fresnoy-au-Val",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Fresnoy-en-Chaussée",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Fresnoy-lès-Roye",
    "dep": "Somme"
  },
  {
    "code": "80390",
    "ville": "Fressenneville",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Frettecuisse",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Frettemeule",
    "dep": "Somme"
  },
  {
    "code": "80460",
    "ville": "Friaucourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Fricamps",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Fricourt",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Frise",
    "dep": "Somme"
  },
  {
    "code": "80130",
    "ville": "Friville-Escarbotin",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Frohen-sur-Authie",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Froyelles",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Frucourt",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Gamaches",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Gapennes",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Gauville",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Gentelles",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Gézaincourt",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Ginchy",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Glisy",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Gorenflos",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Gorges",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Goyencourt",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Grandcourt",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Grand-Laviers",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Gratibus",
    "dep": "Somme"
  },
  {
    "code": "80680",
    "ville": "Grattepanche",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Grébault-Mesnil",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Grivesnes",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Grivillers",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Grouches-Luchuel",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Gruny",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Guerbigny",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Gueschart",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Gueudecourt",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Guignemicourt",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Guillaucourt",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Guillemont",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Guizancourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Guyencourt-sur-Noye",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Guyencourt-Saulcourt",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Hailles",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Hallencourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Hallivillers",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Halloy-lès-Pernois",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Hallu",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Ham",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Le Hamel",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Hamelet",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Hancourt",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Hangard",
    "dep": "Somme"
  },
  {
    "code": "80134",
    "ville": "Hangest-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Hangest-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80131",
    "ville": "Harbonnières",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Hardecourt-aux-Bois",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Harponville",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Hattencourt",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Hautvillers-Ouville",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Havernas",
    "dep": "Somme"
  },
  {
    "code": "80680",
    "ville": "Hébécourt",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Hédauville",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Heilly",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Hem-Hardinval",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Hem-Monacu",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Hénencourt",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Herbécourt",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Hérissart",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Herleville",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Herly",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Hervilly",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Hesbécourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Hescamps",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Heucourt-Croquoison",
    "dep": "Somme"
  },
  {
    "code": "80122",
    "ville": "Heudicourt",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Heuzecourt",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Hiermont",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Hombleux",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Hornoy-le-Bourg",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Huchenneville",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Humbercourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Huppy",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Ignaucourt",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Inval-Boiron",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Irles",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Jumel",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Laboissière-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Lachapelle",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Lafresguimont-Saint-Martin",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Lahoussoye",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Laleu",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Lamaronde",
    "dep": "Somme"
  },
  {
    "code": "80450",
    "ville": "Lamotte-Brebière",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Lamotte-Buleux",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Lamotte-Warfusée",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Lanchères",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Languevoisin-Quiquery",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Lanches-Saint-Hilaire",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Laucourt",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Laviéville",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Lawarde-Mauger-l'Hortoy",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Léalvillers",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Lesbœufs",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Liancourt-Fosse",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Licourt",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Liéramont",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Liercourt",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Ligescourt",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Lignières",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Lignières-Châtelain",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Lignières-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Lihons",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Limeux",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Liomer",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Ô-de-Selle",
    "dep": "Somme"
  },
  {
    "code": "80510",
    "ville": "Long",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Longavesnes",
    "dep": "Somme"
  },
  {
    "code": "80510",
    "ville": "Longpré-les-Corps-Saints",
    "dep": "Somme"
  },
  {
    "code": "80330",
    "ville": "Longueau",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Longueval",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Longuevillette",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Louvencourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Louvrechy",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Lucheux",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Machiel",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Machy",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Mailly-Maillet",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Mailly-Raineval",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Maisnières",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Maison-Ponthieu",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Maison-Roland",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Maizicourt",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Malpart",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Carnoy-Mametz",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Marcelcave",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Marché-Allouarde",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Marchélepot-Misery",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Marestmontiers",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Mareuil-Caubert",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Maricourt",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Marieux",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Marlers",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Marquaix",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Marquivillers",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Martainneville",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Matigny",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Maucourt",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Maurepas",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Le Mazis",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Méaulte",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Méharicourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Meigneux",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Le Meillard",
    "dep": "Somme"
  },
  {
    "code": "80520",
    "ville": "Méneslies",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Méréaucourt",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Mérélessart",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Méricourt-l'Abbé",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Méricourt-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80350",
    "ville": "Mers-les-Bains",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Le Mesge",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Mesnil-Bruntel",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Mesnil-Domqueur",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Mesnil-en-Arrouaise",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Mesnil-Martinsart",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Mesnil-Saint-Georges",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Mesnil-Saint-Nicaise",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Métigny",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Mézerolles",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Mézières-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Miannay",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Millencourt",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Millencourt-en-Ponthieu",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Miraumont",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Mirvaux",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Moislains",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Molliens-au-Bois",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Molliens-Dreuil",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Monchy-Lagache",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Mons-Boubert",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Estrées-Mons",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Monsures",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Montagne-Fayel",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Montauban-de-Picardie",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Montdidier",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Montigny-sur-l'Hallue",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Montigny-les-Jongleurs",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Montonvillers",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Fieffes-Montrelet",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Morchain",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Morcourt",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Moreuil",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Morisel",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Morlancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Morvillers-Saint-Saturnin",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Mouflers",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Mouflières",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Moyencourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Moyencourt-lès-Poix",
    "dep": "Somme"
  },
  {
    "code": "80870",
    "ville": "Moyenneville",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Muille-Villette",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Nampont",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Namps-Maisnil",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Nampty",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Naours",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Nesle",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Nesle-l'Hôpital",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Neslette",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Neufmoulin",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Neuilly-le-Dien",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Neuilly-l'Hôpital",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Neuville-au-Bois",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Neuville-Coppegueule",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "La Neuville-lès-Bray",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "La Neuville-Sire-Bernard",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Neuvillette",
    "dep": "Somme"
  },
  {
    "code": "80390",
    "ville": "Nibas",
    "dep": "Somme"
  },
  {
    "code": "80860",
    "ville": "Nouvion",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Noyelles-en-Chaussée",
    "dep": "Somme"
  },
  {
    "code": "80860",
    "ville": "Noyelles-sur-Mer",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Nurlu",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Occoches",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Ochancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Offignies",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Offoy",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Oisemont",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Oissy",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Oneux",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Oresmaux",
    "dep": "Somme"
  },
  {
    "code": "80460",
    "ville": "Oust-Marest",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Outrebois",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Ovillers-la-Boisselle",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Pargny",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Parvillers-le-Quesnoy",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Pendé",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Pernois",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Péronne",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Hypercourt",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Picquigny",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Piennes-Onvillers",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Pierregot",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Trois-Rivières",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Pissy",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Plachy-Buyon",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Le Plessier-Rozainvillers",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Pœuilly",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Poix-de-Picardie",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Ponches-Estruval",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Pont-de-Metz",
    "dep": "Somme"
  },
  {
    "code": "80860",
    "ville": "Ponthoile",
    "dep": "Somme"
  },
  {
    "code": "80115",
    "ville": "Pont-Noyelles",
    "dep": "Somme"
  },
  {
    "code": "80580",
    "ville": "Pont-Remy",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Port-le-Grand",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Potte",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Poulainville",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Pozières",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Prouville",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Prouzel",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Proyart",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Puchevillers",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Punchy",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Puzeaux",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Pys",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Quend",
    "dep": "Somme"
  },
  {
    "code": "80115",
    "ville": "Querrieu",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Le Quesne",
    "dep": "Somme"
  },
  {
    "code": "80118",
    "ville": "Le Quesnel",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Quesnoy-le-Montant",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Quesnoy-sur-Airaines",
    "dep": "Somme"
  },
  {
    "code": "80710",
    "ville": "Quevauvillers",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Quiry-le-Sec",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Quivières",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Raincheval",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Rainneville",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Ramburelles",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Rambures",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Rancourt",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Regnière-Écluse",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Remaisnil",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Remaugies",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Remiencourt",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Rethonvillers",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Revelles",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Ribeaucourt",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Ribemont-sur-Ancre",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Riencourt",
    "dep": "Somme"
  },
  {
    "code": "80136",
    "ville": "Rivery",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Rogy",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Roiglise",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Roisel",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Rollot",
    "dep": "Somme"
  },
  {
    "code": "80740",
    "ville": "Ronssoy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Rosières-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Rouvrel",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Rouvroy-en-Santerre",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Rouy-le-Grand",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Rouy-le-Petit",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Roye",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Rubempré",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Rubescourt",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Rue",
    "dep": "Somme"
  },
  {
    "code": "80680",
    "ville": "Rumigny",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Saigneville",
    "dep": "Somme"
  },
  {
    "code": "80970",
    "ville": "Sailly-Flibeaucourt",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Sailly-Laurette",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Sailly-le-Sec",
    "dep": "Somme"
  },
  {
    "code": "80360",
    "ville": "Sailly-Saillisel",
    "dep": "Somme"
  },
  {
    "code": "80680",
    "ville": "Sains-en-Amiénois",
    "dep": "Somme"
  },
  {
    "code": "80370",
    "ville": "Saint-Acheul",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Saint-Aubin-Montenoy",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Saint-Aubin-Rivière",
    "dep": "Somme"
  },
  {
    "code": "80960",
    "ville": "Saint-Blimont",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Saint-Christ-Briost",
    "dep": "Somme"
  },
  {
    "code": "80680",
    "ville": "Saint-Fuscien",
    "dep": "Somme"
  },
  {
    "code": "80430",
    "ville": "Saint-Germain-sur-Bresle",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Saint-Gratien",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Saint-Léger-lès-Authie",
    "dep": "Somme"
  },
  {
    "code": "80780",
    "ville": "Saint-Léger-lès-Domart",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Saint-Léger-sur-Bresle",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Saint-Mard",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Saint-Maulvis",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Saint-Maxent",
    "dep": "Somme"
  },
  {
    "code": "80610",
    "ville": "Saint-Ouen",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Saint-Quentin-en-Tourmont",
    "dep": "Somme"
  },
  {
    "code": "80880",
    "ville": "Saint-Quentin-la-Motte-Croix-au-Bailly",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Saint-Riquier",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Saint-Sauflieu",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Saint-Sauveur",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Sainte-Segrée",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Saint-Valery-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Saint-Vaast-en-Chaussée",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Saisseval",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Saleux",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Salouël",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Sancourt",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Saulchoy-sous-Poix",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Sauvillers-Mongival",
    "dep": "Somme"
  },
  {
    "code": "80470",
    "ville": "Saveuse",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Senarpont",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Senlis-le-Sec",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Sentelie",
    "dep": "Somme"
  },
  {
    "code": "80540",
    "ville": "Seux",
    "dep": "Somme"
  },
  {
    "code": "80490",
    "ville": "Sorel-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Sorel",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Soues",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Sourdon",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Soyécourt",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Surcamps",
    "dep": "Somme"
  },
  {
    "code": "80340",
    "ville": "Suzanne",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Tailly",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Talmas",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Templeux-la-Fosse",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Templeux-le-Guérard",
    "dep": "Somme"
  },
  {
    "code": "80600",
    "ville": "Terramesnil",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Tertry",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Thennes",
    "dep": "Somme"
  },
  {
    "code": "80440",
    "ville": "Thézy-Glimont",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Thiepval",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Thieulloy-l'Abbaye",
    "dep": "Somme"
  },
  {
    "code": "80290",
    "ville": "Thieulloy-la-Ville",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Thièvres",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Thoix",
    "dep": "Somme"
  },
  {
    "code": "80250",
    "ville": "Thory",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Tilloloy",
    "dep": "Somme"
  },
  {
    "code": "80220",
    "ville": "Tilloy-Floriville",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Tincourt-Boucly",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Le Titre",
    "dep": "Somme"
  },
  {
    "code": "80870",
    "ville": "Tœufles",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Tours-en-Vimeu",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Toutencourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Le Translay",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Treux",
    "dep": "Somme"
  },
  {
    "code": "80130",
    "ville": "Tully",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Ugny-l'Équipée",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Vadencourt",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Vaire-sous-Corbie",
    "dep": "Somme"
  },
  {
    "code": "80210",
    "ville": "Valines",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Varennes",
    "dep": "Somme"
  },
  {
    "code": "80560",
    "ville": "Vauchelles-lès-Authie",
    "dep": "Somme"
  },
  {
    "code": "80620",
    "ville": "Vauchelles-lès-Domart",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Vauchelles-les-Quesnoy",
    "dep": "Somme"
  },
  {
    "code": "80230",
    "ville": "Vaudricourt",
    "dep": "Somme"
  },
  {
    "code": "80131",
    "ville": "Vauvillers",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Vaux-en-Amiénois",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Vaux-Marquenneville",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Vaux-sur-Somme",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Vecquemont",
    "dep": "Somme"
  },
  {
    "code": "80160",
    "ville": "Velennes",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Vercourt",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Vergies",
    "dep": "Somme"
  },
  {
    "code": "80320",
    "ville": "Vermandovillers",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Verpillières",
    "dep": "Somme"
  },
  {
    "code": "80480",
    "ville": "Vers-sur-Selle",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "La Vicogne",
    "dep": "Somme"
  },
  {
    "code": "80650",
    "ville": "Vignacourt",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Villecourt",
    "dep": "Somme"
  },
  {
    "code": "80420",
    "ville": "Ville-le-Marclet",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Villeroy",
    "dep": "Somme"
  },
  {
    "code": "80110",
    "ville": "Villers-aux-Érables",
    "dep": "Somme"
  },
  {
    "code": "80260",
    "ville": "Villers-Bocage",
    "dep": "Somme"
  },
  {
    "code": "80800",
    "ville": "Villers-Bretonneux",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Villers-Campsart",
    "dep": "Somme"
  },
  {
    "code": "80200",
    "ville": "Villers-Carbonnel",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Villers-Faucon",
    "dep": "Somme"
  },
  {
    "code": "80700",
    "ville": "Villers-lès-Roye",
    "dep": "Somme"
  },
  {
    "code": "80690",
    "ville": "Villers-sous-Ailly",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Villers-Tournelle",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Villers-sur-Authie",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Ville-sur-Ancre",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Vironchaux",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Vismes",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Vitz-sur-Authie",
    "dep": "Somme"
  },
  {
    "code": "80400",
    "ville": "Voyennes",
    "dep": "Somme"
  },
  {
    "code": "80240",
    "ville": "Vraignes-en-Vermandois",
    "dep": "Somme"
  },
  {
    "code": "80640",
    "ville": "Vraignes-lès-Hornoy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Vrély",
    "dep": "Somme"
  },
  {
    "code": "80120",
    "ville": "Vron",
    "dep": "Somme"
  },
  {
    "code": "80670",
    "ville": "Wargnies",
    "dep": "Somme"
  },
  {
    "code": "80300",
    "ville": "Warloy-Baillon",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Warlus",
    "dep": "Somme"
  },
  {
    "code": "80500",
    "ville": "Warsy",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Warvillers",
    "dep": "Somme"
  },
  {
    "code": "80170",
    "ville": "Wiencourt-l'Équipée",
    "dep": "Somme"
  },
  {
    "code": "80270",
    "ville": "Wiry-au-Mont",
    "dep": "Somme"
  },
  {
    "code": "80460",
    "ville": "Woignarue",
    "dep": "Somme"
  },
  {
    "code": "80520",
    "ville": "Woincourt",
    "dep": "Somme"
  },
  {
    "code": "80140",
    "ville": "Woirel",
    "dep": "Somme"
  },
  {
    "code": "80190",
    "ville": "Y",
    "dep": "Somme"
  },
  {
    "code": "80135",
    "ville": "Yaucourt-Bussus",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Yvrench",
    "dep": "Somme"
  },
  {
    "code": "80150",
    "ville": "Yvrencheux",
    "dep": "Somme"
  },
  {
    "code": "80520",
    "ville": "Yzengremer",
    "dep": "Somme"
  },
  {
    "code": "80310",
    "ville": "Yzeux",
    "dep": "Somme"
  },
  {
    "code": "80132",
    "ville": "Yonval",
    "dep": "Somme"
  },
  {
    "code": "81470",
    "ville": "Aguts",
    "dep": "Tarn"
  },
  {
    "code": "81200",
    "ville": "Aiguefonde",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Alban",
    "dep": "Tarn"
  },
  {
    "code": "81000",
    "ville": "Albi",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Albine",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Algans",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Alos",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Almayrac",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Amarens",
    "dep": "Tarn"
  },
  {
    "code": "81430",
    "ville": "Ambialet",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Ambres",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Andillac",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Andouque",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Anglès",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Appelle",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Arfons",
    "dep": "Tarn"
  },
  {
    "code": "81360",
    "ville": "Arifat",
    "dep": "Tarn"
  },
  {
    "code": "81160",
    "ville": "Arthès",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Assac",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Aussac",
    "dep": "Tarn"
  },
  {
    "code": "81200",
    "ville": "Aussillon",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Bannières",
    "dep": "Tarn"
  },
  {
    "code": "81320",
    "ville": "Barre",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Beauvais-sur-Tescou",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Belcastel",
    "dep": "Tarn"
  },
  {
    "code": "81430",
    "ville": "Bellegarde-Marsal",
    "dep": "Tarn"
  },
  {
    "code": "81540",
    "ville": "Belleserre",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Berlats",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Bernac",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Bertre",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Le Bez",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Blan",
    "dep": "Tarn"
  },
  {
    "code": "81400",
    "ville": "Blaye-les-Mines",
    "dep": "Tarn"
  },
  {
    "code": "81490",
    "ville": "Boissezon",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Bournazel",
    "dep": "Tarn"
  },
  {
    "code": "81660",
    "ville": "Bout-du-Pont-de-Larn",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Brassac",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Brens",
    "dep": "Tarn"
  },
  {
    "code": "81390",
    "ville": "Briatexte",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Brousse",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Broze",
    "dep": "Tarn"
  },
  {
    "code": "81100",
    "ville": "Burlats",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Busque",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Cabanès",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Les Cabannes",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Cadalen",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Cadix",
    "dep": "Tarn"
  },
  {
    "code": "81130",
    "ville": "Cagnac-les-Mines",
    "dep": "Tarn"
  },
  {
    "code": "81540",
    "ville": "Cahuzac",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Cambon-lès-Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Cahuzac-sur-Vère",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Cambon",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Cambounès",
    "dep": "Tarn"
  },
  {
    "code": "81580",
    "ville": "Cambounet-sur-le-Sor",
    "dep": "Tarn"
  },
  {
    "code": "81540",
    "ville": "Les Cammazes",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Campagnac",
    "dep": "Tarn"
  },
  {
    "code": "81570",
    "ville": "Carbes",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Carlus",
    "dep": "Tarn"
  },
  {
    "code": "81400",
    "ville": "Carmaux",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Castanet",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Fontrieu",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Castelnau-de-Lévis",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Castelnau-de-Montmiral",
    "dep": "Tarn"
  },
  {
    "code": "81100",
    "ville": "Castres",
    "dep": "Tarn"
  },
  {
    "code": "81200",
    "ville": "Caucalières",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Cestayrols",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Combefa",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Cordes-sur-Ciel",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Coufouleux",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Courris",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Crespin",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Crespinet",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Cunac",
    "dep": "Tarn"
  },
  {
    "code": "81570",
    "ville": "Cuq",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Cuq-Toulza",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Curvalle",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Damiatte",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Dénat",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Donnazac",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Dourgne",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Le Dourn",
    "dep": "Tarn"
  },
  {
    "code": "81540",
    "ville": "Durfort",
    "dep": "Tarn"
  },
  {
    "code": "81290",
    "ville": "Escoussens",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Lacapelle-Escroux",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Espérausses",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Fayssac",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Fauch",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Faussergues",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Fénols",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Fiac",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Florentin",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Fraissines",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Frausseilles",
    "dep": "Tarn"
  },
  {
    "code": "81430",
    "ville": "Le Fraysse",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Fréjairolles",
    "dep": "Tarn"
  },
  {
    "code": "81570",
    "ville": "Fréjeville",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Gaillac",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Garrevaques",
    "dep": "Tarn"
  },
  {
    "code": "81450",
    "ville": "Le Garric",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Garrigues",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Gijounet",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Giroussens",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Graulhet",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Grazac",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Itzac",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Jonquières",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Jouqueviel",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Labarthe-Bleys",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Labastide-de-Lévis",
    "dep": "Tarn"
  },
  {
    "code": "81400",
    "ville": "Labastide-Gabausse",
    "dep": "Tarn"
  },
  {
    "code": "81270",
    "ville": "Labastide-Rouairoux",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Labastide-Saint-Georges",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Labessière-Candeil",
    "dep": "Tarn"
  },
  {
    "code": "81100",
    "ville": "Laboulbène",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Laboutarie",
    "dep": "Tarn"
  },
  {
    "code": "81290",
    "ville": "Labruguière",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Lacabarède",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Lacapelle-Pinet",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Lacapelle-Ségalar",
    "dep": "Tarn"
  },
  {
    "code": "81230",
    "ville": "Lacaune",
    "dep": "Tarn"
  },
  {
    "code": "81330",
    "ville": "Lacaze",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Lacougotte-Cadoul",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Lacroisille",
    "dep": "Tarn"
  },
  {
    "code": "81210",
    "ville": "Lacrouzette",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Lagardiolle",
    "dep": "Tarn"
  },
  {
    "code": "81090",
    "ville": "Lagarrigue",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Lagrave",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Guitalens-L'Albarède",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Lamillarié",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Lamontélarié",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Laparrouquial",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Larroque",
    "dep": "Tarn"
  },
  {
    "code": "81260",
    "ville": "Lasfaillades",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Lasgraisses",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Lautrec",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Lédas-et-Penthiès",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Lempaut",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Lescout",
    "dep": "Tarn"
  },
  {
    "code": "81380",
    "ville": "Lescure-d'Albigeois",
    "dep": "Tarn"
  },
  {
    "code": "81310",
    "ville": "Lisle-sur-Tarn",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Livers-Cazelles",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Lombers",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Loubers",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Loupiac",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Lugan",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Magrin",
    "dep": "Tarn"
  },
  {
    "code": "81130",
    "ville": "Mailhoc",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Marnaves",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Marssac-sur-Tarn",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Marzens",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Le Masnau-Massuguiès",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Massac-Séran",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Massaguel",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Massals",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Maurens-Scopont",
    "dep": "Tarn"
  },
  {
    "code": "81200",
    "ville": "Mazamet",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Mézens",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Milhars",
    "dep": "Tarn"
  },
  {
    "code": "81130",
    "ville": "Milhavet",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Miolles",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Mirandol-Bourgnounac",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Missècle",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Monestiés",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Montans",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Montauriol",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Montcabrier",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Montdragon",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Montdurausse",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Montels",
    "dep": "Tarn"
  },
  {
    "code": "81210",
    "ville": "Montfa",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Montgaillard",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Montgey",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Montirat",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Montpinier",
    "dep": "Tarn"
  },
  {
    "code": "81360",
    "ville": "Montredon-Labessonnié",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Mont-Roc",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Montrosier",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Montvalen",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Moularès",
    "dep": "Tarn"
  },
  {
    "code": "81300",
    "ville": "Moulayrès",
    "dep": "Tarn"
  },
  {
    "code": "81320",
    "ville": "Moulin-Mage",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Mouzens",
    "dep": "Tarn"
  },
  {
    "code": "81430",
    "ville": "Mouzieys-Teulet",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Mouzieys-Panens",
    "dep": "Tarn"
  },
  {
    "code": "81320",
    "ville": "Murat-sur-Vèbre",
    "dep": "Tarn"
  },
  {
    "code": "81320",
    "ville": "Nages",
    "dep": "Tarn"
  },
  {
    "code": "81710",
    "ville": "Navès",
    "dep": "Tarn"
  },
  {
    "code": "81490",
    "ville": "Noailhac",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Noailles",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Orban",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Padiès",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Palleville",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Pampelonne",
    "dep": "Tarn"
  },
  {
    "code": "81310",
    "ville": "Parisot",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Paulinet",
    "dep": "Tarn"
  },
  {
    "code": "81660",
    "ville": "Payrin-Augmontel",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Péchaudier",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Penne",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Peyregoux",
    "dep": "Tarn"
  },
  {
    "code": "81310",
    "ville": "Peyrole",
    "dep": "Tarn"
  },
  {
    "code": "81660",
    "ville": "Pont-de-Larn",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Poudis",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Poulan-Pouzols",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Prades",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Pratviel",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Puéchoursi",
    "dep": "Tarn"
  },
  {
    "code": "81390",
    "ville": "Puybegon",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Puycalvel",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Puycelsi",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Puygouzon",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Puylaurens",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Rabastens",
    "dep": "Tarn"
  },
  {
    "code": "81330",
    "ville": "Rayssac",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Réalmont",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Le Rialet",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Le Riols",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Rivières",
    "dep": "Tarn"
  },
  {
    "code": "81210",
    "ville": "Roquecourbe",
    "dep": "Tarn"
  },
  {
    "code": "81800",
    "ville": "Roquemaure",
    "dep": "Tarn"
  },
  {
    "code": "81470",
    "ville": "Roquevidal",
    "dep": "Tarn"
  },
  {
    "code": "81400",
    "ville": "Rosières",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Rouairoux",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Rouffiac",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Terre-de-Bancalié",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Roussayrolles",
    "dep": "Tarn"
  },
  {
    "code": "81290",
    "ville": "Saint-Affrique-les-Montagnes",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Saint-Agnan",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Saint-Amancet",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Saint-Amans-Soult",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Saint-Amans-Valtoret",
    "dep": "Tarn"
  },
  {
    "code": "81250",
    "ville": "Saint-André",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Saint-Avit",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Saint-Beauzile",
    "dep": "Tarn"
  },
  {
    "code": "81400",
    "ville": "Saint-Benoît-de-Carmaux",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Saint-Christophe",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Sainte-Cécile-du-Cayrou",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Saint-Cirgue",
    "dep": "Tarn"
  },
  {
    "code": "81390",
    "ville": "Saint-Gauzens",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Sainte-Gemme",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Saint-Genest-de-Contest",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Saint-Germain-des-Prés",
    "dep": "Tarn"
  },
  {
    "code": "81210",
    "ville": "Saint-Germier",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Saint-Grégoire",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Saint-Jean-de-Marcel",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Saint-Jean-de-Rives",
    "dep": "Tarn"
  },
  {
    "code": "81210",
    "ville": "Saint-Jean-de-Vals",
    "dep": "Tarn"
  },
  {
    "code": "81160",
    "ville": "Saint-Juéry",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Saint-Julien-du-Puy",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Saint-Julien-Gaulène",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Saint-Lieux-lès-Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Saint-Marcel-Campes",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Saint-Martin-Laguépie",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Saint-Michel-Labadié",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Saint-Michel-de-Vax",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Saint-Paul-Cap-de-Joux",
    "dep": "Tarn"
  },
  {
    "code": "81330",
    "ville": "Saint-Pierre-de-Trivisy",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Saint-Salvi-de-Carcavès",
    "dep": "Tarn"
  },
  {
    "code": "81490",
    "ville": "Saint-Salvy-de-la-Balme",
    "dep": "Tarn"
  },
  {
    "code": "81700",
    "ville": "Saint-Sernin-lès-Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81370",
    "ville": "Saint-Sulpice-la-Pointe",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Saint-Urcisse",
    "dep": "Tarn"
  },
  {
    "code": "81710",
    "ville": "Saïx",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Saliès",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Salles",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Salvagnac",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Saussenac",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Sauveterre",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "La Sauzière-Saint-Jean",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Le Ségur",
    "dep": "Tarn"
  },
  {
    "code": "81570",
    "ville": "Sémalens",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Senaux",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Senouillac",
    "dep": "Tarn"
  },
  {
    "code": "81990",
    "ville": "Le Sequestre",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Sérénac",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Serviès",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Sieurac",
    "dep": "Tarn"
  },
  {
    "code": "81540",
    "ville": "Sorèze",
    "dep": "Tarn"
  },
  {
    "code": "81580",
    "ville": "Soual",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Souel",
    "dep": "Tarn"
  },
  {
    "code": "81130",
    "ville": "Taïx",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Tanus",
    "dep": "Tarn"
  },
  {
    "code": "81630",
    "ville": "Tauriac",
    "dep": "Tarn"
  },
  {
    "code": "81600",
    "ville": "Técou",
    "dep": "Tarn"
  },
  {
    "code": "81120",
    "ville": "Teillet",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Terssac",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Teulat",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Teyssode",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Tonnac",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Tréban",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Trébas",
    "dep": "Tarn"
  },
  {
    "code": "81190",
    "ville": "Trévien",
    "dep": "Tarn"
  },
  {
    "code": "81330",
    "ville": "Vabre",
    "dep": "Tarn"
  },
  {
    "code": "81350",
    "ville": "Valderiès",
    "dep": "Tarn"
  },
  {
    "code": "81090",
    "ville": "Valdurenque",
    "dep": "Tarn"
  },
  {
    "code": "81340",
    "ville": "Valence-d'Albigeois",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Vaour",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Veilhes",
    "dep": "Tarn"
  },
  {
    "code": "81440",
    "ville": "Vénès",
    "dep": "Tarn"
  },
  {
    "code": "81110",
    "ville": "Verdalle",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Le Verdier",
    "dep": "Tarn"
  },
  {
    "code": "81530",
    "ville": "Viane",
    "dep": "Tarn"
  },
  {
    "code": "81570",
    "ville": "Vielmur-sur-Agout",
    "dep": "Tarn"
  },
  {
    "code": "81140",
    "ville": "Vieux",
    "dep": "Tarn"
  },
  {
    "code": "81430",
    "ville": "Villefranche-d'Albigeois",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Villeneuve-lès-Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81130",
    "ville": "Villeneuve-sur-Vère",
    "dep": "Tarn"
  },
  {
    "code": "81170",
    "ville": "Vindrac-Alayrac",
    "dep": "Tarn"
  },
  {
    "code": "81240",
    "ville": "Le Vintrou",
    "dep": "Tarn"
  },
  {
    "code": "81640",
    "ville": "Virac",
    "dep": "Tarn"
  },
  {
    "code": "81220",
    "ville": "Viterbe",
    "dep": "Tarn"
  },
  {
    "code": "81500",
    "ville": "Viviers-lès-Lavaur",
    "dep": "Tarn"
  },
  {
    "code": "81290",
    "ville": "Viviers-lès-Montagnes",
    "dep": "Tarn"
  },
  {
    "code": "81150",
    "ville": "Sainte-Croix",
    "dep": "Tarn"
  },
  {
    "code": "82290",
    "ville": "Albefeuille-Lagarde",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82350",
    "ville": "Albias",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Angeville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Asques",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Aucamville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Auterive",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82220",
    "ville": "Auty",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Auvillar",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Balignac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Bardigues",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82290",
    "ville": "Barry-d'Islemade",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Les Barthes",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Beaumont-de-Lomagne",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Beaupuy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Belbèze-en-Lomagne",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Belvèze",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Bessens",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Bioule",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82200",
    "ville": "Boudou",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Bouillac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Bouloc-en-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Bourg-de-Visa",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Bourret",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Brassac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82710",
    "ville": "Bressols",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Bruniquel",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Campsas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Canals",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Castanet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Castelferrus",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Castelmayran",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Castelsagrat",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Castelsarrasin",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Castéra-Bouzet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Caumont",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Le Causé",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82300",
    "ville": "Caussade",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Caylus",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82440",
    "ville": "Cayrac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Cayriech",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82140",
    "ville": "Cazals",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Cazes-Mondenard",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Comberouger",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Corbarieu",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Cordes-Tolosannes",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Coutures",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Cumont",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Dieupentale",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Donzac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Dunes",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82390",
    "ville": "Durfort-Lacapelette",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Escatalens",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Escazeaux",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Espalais",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Esparsac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Espinas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Fabas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Fajolles",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Faudoas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Fauroux",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82140",
    "ville": "Féneyrols",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Finhan",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Garganvillar",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Gariès",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Gasques",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82230",
    "ville": "Génébrières",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Gensac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Gimat",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82330",
    "ville": "Ginals",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Glatens",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Goas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Golfech",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Goudourville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Gramont",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Grisolles",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "L'Honor-de-Cos",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82220",
    "ville": "Labarthe",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Labastide-de-Penne",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Labastide-Saint-Pierre",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Labastide-du-Temple",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Labourgade",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Lacapelle-Livron",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Lachapelle",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Lacour",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82290",
    "ville": "Lacourt-Saint-Pierre",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Lafitte",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "Lafrançaise",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82250",
    "ville": "Laguépie",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82360",
    "ville": "Lamagistère",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "Lamothe-Capdeville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Lamothe-Cumont",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Lapenche",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Larrazet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Lauzerte",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Lavaurette",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82290",
    "ville": "La Ville-Dieu-du-Temple",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Lavit",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82230",
    "ville": "Léojac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82200",
    "ville": "Lizac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Loze",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82200",
    "ville": "Malause",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Mansonville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Marignac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Marsac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Mas-Grenier",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Maubec",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Maumusson",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82290",
    "ville": "Meauzac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Merles",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82440",
    "ville": "Mirabel",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Miramont-de-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82200",
    "ville": "Moissac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82220",
    "ville": "Molières",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Monbéqui",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82230",
    "ville": "Monclar-de-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Montagudet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Montaigu-de-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Montaïn",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82270",
    "ville": "Montalzat",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "Montastruc",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82000",
    "ville": "Montauban",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Montbarla",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Montbartier",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82290",
    "ville": "Montbeton",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Montech",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82300",
    "ville": "Monteils",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82200",
    "ville": "Montesquieu",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82270",
    "ville": "Montfermier",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Montgaillard",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Montjoi",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82270",
    "ville": "Montpezat-de-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Montricoux",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Mouillac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Nègrepelisse",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Nohic",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Orgueil",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Parisot",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Perville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Le Pin",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "Piquecos",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Pommevic",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82170",
    "ville": "Pompignan",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Poupas",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82220",
    "ville": "Puycornet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Puygaillard-de-Quercy",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Puygaillard-de-Lomagne",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Puylagarde",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Puylaroque",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82440",
    "ville": "Réalville",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Reyniès",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Roquecor",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82100",
    "ville": "Saint-Aignan",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Saint-Amans-du-Pech",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Saint-Amans-de-Pellagal",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82140",
    "ville": "Saint-Antonin-Noble-Val",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Saint-Arroumex",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Saint-Beauzeil",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Saint-Cirice",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82300",
    "ville": "Saint-Cirq",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Saint-Clair",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82410",
    "ville": "Saint-Étienne-de-Tulmont",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Saint-Georges",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82120",
    "ville": "Saint-Jean-du-Bouzet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Sainte-Juliette",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Saint-Loup",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Saint-Michel",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Saint-Nauphary",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Saint-Nazaire-de-Valentane",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82210",
    "ville": "Saint-Nicolas-de-la-Grave",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Saint-Paul-d'Espis",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82700",
    "ville": "Saint-Porquier",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82160",
    "ville": "Saint-Projet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Saint-Sardos",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82300",
    "ville": "Saint-Vincent-d'Autéjac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Saint-Vincent-Lespinasse",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82230",
    "ville": "La Salvetat-Belmontet",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Sauveterre",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Savenès",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82240",
    "ville": "Septfonds",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Sérignac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82340",
    "ville": "Sistels",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82190",
    "ville": "Touffailles",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82110",
    "ville": "Tréjouls",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82800",
    "ville": "Vaïssac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82150",
    "ville": "Valeilles",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82400",
    "ville": "Valence",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82330",
    "ville": "Varen",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Varennes",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82220",
    "ville": "Vazerac",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82600",
    "ville": "Verdun-sur-Garonne",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82330",
    "ville": "Verfeil",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82230",
    "ville": "Verlhac-Tescou",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82500",
    "ville": "Vigueron",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82370",
    "ville": "Villebrumier",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "82130",
    "ville": "Villemade",
    "dep": "Tarn-et-Garonne"
  },
  {
    "code": "83600",
    "ville": "Les Adrets-de-l'Estérel",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Aiguines",
    "dep": "Var"
  },
  {
    "code": "83111",
    "ville": "Ampus",
    "dep": "Var"
  },
  {
    "code": "83460",
    "ville": "Les Arcs",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Artignosc-sur-Verdon",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Artigues",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Aups",
    "dep": "Var"
  },
  {
    "code": "83600",
    "ville": "Bagnols-en-Forêt",
    "dep": "Var"
  },
  {
    "code": "83150",
    "ville": "Bandol",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Bargème",
    "dep": "Var"
  },
  {
    "code": "83830",
    "ville": "Bargemon",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Barjols",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "La Bastide",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Baudinard-sur-Verdon",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Bauduen",
    "dep": "Var"
  },
  {
    "code": "83330",
    "ville": "Le Beausset",
    "dep": "Var"
  },
  {
    "code": "83210",
    "ville": "Belgentier",
    "dep": "Var"
  },
  {
    "code": "83890",
    "ville": "Besse-sur-Issole",
    "dep": "Var"
  },
  {
    "code": "83230",
    "ville": "Bormes-les-Mimosas",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Le Bourguet",
    "dep": "Var"
  },
  {
    "code": "83149",
    "ville": "Bras",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Brenon",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "Brignoles",
    "dep": "Var"
  },
  {
    "code": "83119",
    "ville": "Brue-Auriac",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Cabasse",
    "dep": "Var"
  },
  {
    "code": "83740",
    "ville": "La Cadière-d'Azur",
    "dep": "Var"
  },
  {
    "code": "83830",
    "ville": "Callas",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Callian",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "Camps-la-Source",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Le Cannet-des-Maures",
    "dep": "Var"
  },
  {
    "code": "83570",
    "ville": "Carcès",
    "dep": "Var"
  },
  {
    "code": "83660",
    "ville": "Carnoules",
    "dep": "Var"
  },
  {
    "code": "83320",
    "ville": "Carqueiranne",
    "dep": "Var"
  },
  {
    "code": "83330",
    "ville": "Le Castellet",
    "dep": "Var"
  },
  {
    "code": "83240",
    "ville": "Cavalaire-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "La Celle",
    "dep": "Var"
  },
  {
    "code": "83300",
    "ville": "Châteaudouble",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Châteauvert",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Châteauvieux",
    "dep": "Var"
  },
  {
    "code": "83830",
    "ville": "Claviers",
    "dep": "Var"
  },
  {
    "code": "83310",
    "ville": "Cogolin",
    "dep": "Var"
  },
  {
    "code": "83610",
    "ville": "Collobrières",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Comps-sur-Artuby",
    "dep": "Var"
  },
  {
    "code": "83570",
    "ville": "Correns",
    "dep": "Var"
  },
  {
    "code": "83570",
    "ville": "Cotignac",
    "dep": "Var"
  },
  {
    "code": "83260",
    "ville": "La Crau",
    "dep": "Var"
  },
  {
    "code": "83420",
    "ville": "La Croix-Valmer",
    "dep": "Var"
  },
  {
    "code": "83390",
    "ville": "Cuers",
    "dep": "Var"
  },
  {
    "code": "83300",
    "ville": "Draguignan",
    "dep": "Var"
  },
  {
    "code": "83570",
    "ville": "Entrecasteaux",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Esparron",
    "dep": "Var"
  },
  {
    "code": "83330",
    "ville": "Évenos",
    "dep": "Var"
  },
  {
    "code": "83210",
    "ville": "La Farlède",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Fayence",
    "dep": "Var"
  },
  {
    "code": "83830",
    "ville": "Figanières",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Flassans-sur-Issole",
    "dep": "Var"
  },
  {
    "code": "83780",
    "ville": "Flayosc",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Forcalqueiret",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Fox-Amphoux",
    "dep": "Var"
  },
  {
    "code": "83600",
    "ville": "Fréjus",
    "dep": "Var"
  },
  {
    "code": "83130",
    "ville": "La Garde",
    "dep": "Var"
  },
  {
    "code": "83680",
    "ville": "La Garde-Freinet",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Garéoult",
    "dep": "Var"
  },
  {
    "code": "83580",
    "ville": "Gassin",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Ginasservis",
    "dep": "Var"
  },
  {
    "code": "83590",
    "ville": "Gonfaron",
    "dep": "Var"
  },
  {
    "code": "83310",
    "ville": "Grimaud",
    "dep": "Var"
  },
  {
    "code": "83400",
    "ville": "Hyères",
    "dep": "Var"
  },
  {
    "code": "83980",
    "ville": "Le Lavandou",
    "dep": "Var"
  },
  {
    "code": "83250",
    "ville": "La Londe-les-Maures",
    "dep": "Var"
  },
  {
    "code": "83510",
    "ville": "Lorgues",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Le Luc",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "La Martre",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Les Mayons",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Mazaugues",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Méounes-lès-Montrieux",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Moissac-Bellevue",
    "dep": "Var"
  },
  {
    "code": "83310",
    "ville": "La Môle",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Mons",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Montauroux",
    "dep": "Var"
  },
  {
    "code": "83131",
    "ville": "Montferrat",
    "dep": "Var"
  },
  {
    "code": "83570",
    "ville": "Montfort-sur-Argens",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Montmeyan",
    "dep": "Var"
  },
  {
    "code": "83920",
    "ville": "La Motte",
    "dep": "Var"
  },
  {
    "code": "83490",
    "ville": "Le Muy",
    "dep": "Var"
  },
  {
    "code": "83860",
    "ville": "Nans-les-Pins",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Néoules",
    "dep": "Var"
  },
  {
    "code": "83470",
    "ville": "Ollières",
    "dep": "Var"
  },
  {
    "code": "83190",
    "ville": "Ollioules",
    "dep": "Var"
  },
  {
    "code": "83390",
    "ville": "Pierrefeu-du-Var",
    "dep": "Var"
  },
  {
    "code": "83790",
    "ville": "Pignans",
    "dep": "Var"
  },
  {
    "code": "83640",
    "ville": "Plan-d'Aups-Sainte-Baume",
    "dep": "Var"
  },
  {
    "code": "83120",
    "ville": "Le Plan-de-la-Tour",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Pontevès",
    "dep": "Var"
  },
  {
    "code": "83470",
    "ville": "Pourcieux",
    "dep": "Var"
  },
  {
    "code": "83910",
    "ville": "Pourrières",
    "dep": "Var"
  },
  {
    "code": "83220",
    "ville": "Le Pradet",
    "dep": "Var"
  },
  {
    "code": "83480",
    "ville": "Puget-sur-Argens",
    "dep": "Var"
  },
  {
    "code": "83390",
    "ville": "Puget-Ville",
    "dep": "Var"
  },
  {
    "code": "83350",
    "ville": "Ramatuelle",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Régusse",
    "dep": "Var"
  },
  {
    "code": "83200",
    "ville": "Le Revest-les-Eaux",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Rians",
    "dep": "Var"
  },
  {
    "code": "13780",
    "ville": "Riboux",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Rocbaron",
    "dep": "Var"
  },
  {
    "code": "83520",
    "ville": "Roquebrune-sur-Argens",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "La Roquebrussanne",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "La Roque-Esclapon",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "Rougiers",
    "dep": "Var"
  },
  {
    "code": "83136",
    "ville": "Sainte-Anastasie-sur-Issole",
    "dep": "Var"
  },
  {
    "code": "83270",
    "ville": "Saint-Cyr-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Saint-Julien",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Saint-Martin-de-Pallières",
    "dep": "Var"
  },
  {
    "code": "83120",
    "ville": "Sainte-Maxime",
    "dep": "Var"
  },
  {
    "code": "83470",
    "ville": "Saint-Maximin-la-Sainte-Baume",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Saint-Paul-en-Forêt",
    "dep": "Var"
  },
  {
    "code": "83530",
    "ville": "Saint-Raphaël",
    "dep": "Var"
  },
  {
    "code": "83990",
    "ville": "Saint-Tropez",
    "dep": "Var"
  },
  {
    "code": "83640",
    "ville": "Saint-Zacharie",
    "dep": "Var"
  },
  {
    "code": "83690",
    "ville": "Salernes",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Les Salles-sur-Verdon",
    "dep": "Var"
  },
  {
    "code": "83110",
    "ville": "Sanary-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Seillans",
    "dep": "Var"
  },
  {
    "code": "83470",
    "ville": "Seillons-Source-d'Argens",
    "dep": "Var"
  },
  {
    "code": "83500",
    "ville": "La Seyne-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83870",
    "ville": "Signes",
    "dep": "Var"
  },
  {
    "code": "83690",
    "ville": "Sillans-la-Cascade",
    "dep": "Var"
  },
  {
    "code": "83140",
    "ville": "Six-Fours-les-Plages",
    "dep": "Var"
  },
  {
    "code": "83210",
    "ville": "Solliès-Pont",
    "dep": "Var"
  },
  {
    "code": "83210",
    "ville": "Solliès-Toucas",
    "dep": "Var"
  },
  {
    "code": "83210",
    "ville": "Solliès-Ville",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Tanneron",
    "dep": "Var"
  },
  {
    "code": "83460",
    "ville": "Taradeau",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Tavernes",
    "dep": "Var"
  },
  {
    "code": "83340",
    "ville": "Le Thoronet",
    "dep": "Var"
  },
  {
    "code": "83000",
    "ville": "Toulon",
    "dep": "Var"
  },
  {
    "code": "83440",
    "ville": "Tourrettes",
    "dep": "Var"
  },
  {
    "code": "83690",
    "ville": "Tourtour",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "Tourves",
    "dep": "Var"
  },
  {
    "code": "83720",
    "ville": "Trans-en-Provence",
    "dep": "Var"
  },
  {
    "code": "83840",
    "ville": "Trigance",
    "dep": "Var"
  },
  {
    "code": "83143",
    "ville": "Le Val",
    "dep": "Var"
  },
  {
    "code": "83160",
    "ville": "La Valette-du-Var",
    "dep": "Var"
  },
  {
    "code": "83670",
    "ville": "Varages",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "La Verdière",
    "dep": "Var"
  },
  {
    "code": "83630",
    "ville": "Vérignon",
    "dep": "Var"
  },
  {
    "code": "83550",
    "ville": "Vidauban",
    "dep": "Var"
  },
  {
    "code": "83690",
    "ville": "Villecroze",
    "dep": "Var"
  },
  {
    "code": "83560",
    "ville": "Vinon-sur-Verdon",
    "dep": "Var"
  },
  {
    "code": "83170",
    "ville": "Vins-sur-Caramy",
    "dep": "Var"
  },
  {
    "code": "83820",
    "ville": "Rayol-Canadel-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83430",
    "ville": "Saint-Mandrier-sur-Mer",
    "dep": "Var"
  },
  {
    "code": "83510",
    "ville": "Saint-Antonin-du-Var",
    "dep": "Var"
  },
  {
    "code": "84210",
    "ville": "Althen-des-Paluds",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Ansouis",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Apt",
    "dep": "Vaucluse"
  },
  {
    "code": "84810",
    "ville": "Aubignan",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Aurel",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Auribeau",
    "dep": "Vaucluse"
  },
  {
    "code": "84000",
    "ville": "Avignon",
    "dep": "Vaucluse"
  },
  {
    "code": "84330",
    "ville": "Le Barroux",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "La Bastide-des-Jourdans",
    "dep": "Vaucluse"
  },
  {
    "code": "84120",
    "ville": "La Bastidonne",
    "dep": "Vaucluse"
  },
  {
    "code": "84210",
    "ville": "Le Beaucet",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "Beaumes-de-Venise",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Beaumettes",
    "dep": "Vaucluse"
  },
  {
    "code": "84120",
    "ville": "Beaumont-de-Pertuis",
    "dep": "Vaucluse"
  },
  {
    "code": "84340",
    "ville": "Beaumont-du-Ventoux",
    "dep": "Vaucluse"
  },
  {
    "code": "84370",
    "ville": "Bédarrides",
    "dep": "Vaucluse"
  },
  {
    "code": "84410",
    "ville": "Bédoin",
    "dep": "Vaucluse"
  },
  {
    "code": "84570",
    "ville": "Blauvac",
    "dep": "Vaucluse"
  },
  {
    "code": "84500",
    "ville": "Bollène",
    "dep": "Vaucluse"
  },
  {
    "code": "84480",
    "ville": "Bonnieux",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Brantes",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Buisson",
    "dep": "Vaucluse"
  },
  {
    "code": "84480",
    "ville": "Buoux",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Cabrières-d'Aigues",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Cabrières-d'Avignon",
    "dep": "Vaucluse"
  },
  {
    "code": "84160",
    "ville": "Cadenet",
    "dep": "Vaucluse"
  },
  {
    "code": "84860",
    "ville": "Caderousse",
    "dep": "Vaucluse"
  },
  {
    "code": "84290",
    "ville": "Cairanne",
    "dep": "Vaucluse"
  },
  {
    "code": "84850",
    "ville": "Camaret-sur-Aigues",
    "dep": "Vaucluse"
  },
  {
    "code": "84330",
    "ville": "Caromb",
    "dep": "Vaucluse"
  },
  {
    "code": "84200",
    "ville": "Carpentras",
    "dep": "Vaucluse"
  },
  {
    "code": "84750",
    "ville": "Caseneuve",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Castellet-en-Luberon",
    "dep": "Vaucluse"
  },
  {
    "code": "84510",
    "ville": "Caumont-sur-Durance",
    "dep": "Vaucluse"
  },
  {
    "code": "84300",
    "ville": "Cavaillon",
    "dep": "Vaucluse"
  },
  {
    "code": "84470",
    "ville": "Châteauneuf-de-Gadagne",
    "dep": "Vaucluse"
  },
  {
    "code": "84230",
    "ville": "Châteauneuf-du-Pape",
    "dep": "Vaucluse"
  },
  {
    "code": "84460",
    "ville": "Cheval-Blanc",
    "dep": "Vaucluse"
  },
  {
    "code": "84350",
    "ville": "Courthézon",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Crestet",
    "dep": "Vaucluse"
  },
  {
    "code": "84410",
    "ville": "Crillon-le-Brave",
    "dep": "Vaucluse"
  },
  {
    "code": "84160",
    "ville": "Cucuron",
    "dep": "Vaucluse"
  },
  {
    "code": "84320",
    "ville": "Entraigues-sur-la-Sorgue",
    "dep": "Vaucluse"
  },
  {
    "code": "84340",
    "ville": "Entrechaux",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Faucon",
    "dep": "Vaucluse"
  },
  {
    "code": "84410",
    "ville": "Flassan",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Gargas",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Gignac",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "Gigondas",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Gordes",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Goult",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Grambois",
    "dep": "Vaucluse"
  },
  {
    "code": "84600",
    "ville": "Grillon",
    "dep": "Vaucluse"
  },
  {
    "code": "84800",
    "ville": "L'Isle-sur-la-Sorgue",
    "dep": "Vaucluse"
  },
  {
    "code": "84450",
    "ville": "Jonquerettes",
    "dep": "Vaucluse"
  },
  {
    "code": "84150",
    "ville": "Jonquières",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Joucas",
    "dep": "Vaucluse"
  },
  {
    "code": "84480",
    "ville": "Lacoste",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "Lafare",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Lagarde-d'Apt",
    "dep": "Vaucluse"
  },
  {
    "code": "84290",
    "ville": "Lagarde-Paréol",
    "dep": "Vaucluse"
  },
  {
    "code": "84800",
    "ville": "Lagnes",
    "dep": "Vaucluse"
  },
  {
    "code": "84840",
    "ville": "Lamotte-du-Rhône",
    "dep": "Vaucluse"
  },
  {
    "code": "84840",
    "ville": "Lapalud",
    "dep": "Vaucluse"
  },
  {
    "code": "84360",
    "ville": "Lauris",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Lioux",
    "dep": "Vaucluse"
  },
  {
    "code": "84870",
    "ville": "Loriol-du-Comtat",
    "dep": "Vaucluse"
  },
  {
    "code": "84160",
    "ville": "Lourmarin",
    "dep": "Vaucluse"
  },
  {
    "code": "84340",
    "ville": "Malaucène",
    "dep": "Vaucluse"
  },
  {
    "code": "84570",
    "ville": "Malemort-du-Comtat",
    "dep": "Vaucluse"
  },
  {
    "code": "84660",
    "ville": "Maubec",
    "dep": "Vaucluse"
  },
  {
    "code": "84380",
    "ville": "Mazan",
    "dep": "Vaucluse"
  },
  {
    "code": "84560",
    "ville": "Ménerbes",
    "dep": "Vaucluse"
  },
  {
    "code": "84360",
    "ville": "Mérindol",
    "dep": "Vaucluse"
  },
  {
    "code": "84570",
    "ville": "Méthamis",
    "dep": "Vaucluse"
  },
  {
    "code": "84120",
    "ville": "Mirabeau",
    "dep": "Vaucluse"
  },
  {
    "code": "84330",
    "ville": "Modène",
    "dep": "Vaucluse"
  },
  {
    "code": "84430",
    "ville": "Mondragon",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Monieux",
    "dep": "Vaucluse"
  },
  {
    "code": "84170",
    "ville": "Monteux",
    "dep": "Vaucluse"
  },
  {
    "code": "84310",
    "ville": "Morières-lès-Avignon",
    "dep": "Vaucluse"
  },
  {
    "code": "84570",
    "ville": "Mormoiron",
    "dep": "Vaucluse"
  },
  {
    "code": "84550",
    "ville": "Mornas",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "La Motte-d'Aigues",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Murs",
    "dep": "Vaucluse"
  },
  {
    "code": "84580",
    "ville": "Oppède",
    "dep": "Vaucluse"
  },
  {
    "code": "84100",
    "ville": "Orange",
    "dep": "Vaucluse"
  },
  {
    "code": "84210",
    "ville": "Pernes-les-Fontaines",
    "dep": "Vaucluse"
  },
  {
    "code": "84120",
    "ville": "Pertuis",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Peypin-d'Aigues",
    "dep": "Vaucluse"
  },
  {
    "code": "84420",
    "ville": "Piolenc",
    "dep": "Vaucluse"
  },
  {
    "code": "84130",
    "ville": "Le Pontet",
    "dep": "Vaucluse"
  },
  {
    "code": "84360",
    "ville": "Puget",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Puyméras",
    "dep": "Vaucluse"
  },
  {
    "code": "84160",
    "ville": "Puyvert",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Rasteau",
    "dep": "Vaucluse"
  },
  {
    "code": "84600",
    "ville": "Richerenches",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Roaix",
    "dep": "Vaucluse"
  },
  {
    "code": "84440",
    "ville": "Robion",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "La Roque-Alric",
    "dep": "Vaucluse"
  },
  {
    "code": "84210",
    "ville": "La Roque-sur-Pernes",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Roussillon",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Rustrel",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Sablet",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Saignon",
    "dep": "Vaucluse"
  },
  {
    "code": "84290",
    "ville": "Sainte-Cécile-les-Vignes",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Saint-Christol",
    "dep": "Vaucluse"
  },
  {
    "code": "84210",
    "ville": "Saint-Didier",
    "dep": "Vaucluse"
  },
  {
    "code": "84330",
    "ville": "Saint-Hippolyte-le-Graveyron",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Saint-Léger-du-Ventoux",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Saint-Marcellin-lès-Vaison",
    "dep": "Vaucluse"
  },
  {
    "code": "84750",
    "ville": "Saint-Martin-de-Castillon",
    "dep": "Vaucluse"
  },
  {
    "code": "84760",
    "ville": "Saint-Martin-de-la-Brasque",
    "dep": "Vaucluse"
  },
  {
    "code": "84220",
    "ville": "Saint-Pantaléon",
    "dep": "Vaucluse"
  },
  {
    "code": "84330",
    "ville": "Saint-Pierre-de-Vassols",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Saint-Romain-en-Viennois",
    "dep": "Vaucluse"
  },
  {
    "code": "84290",
    "ville": "Saint-Roman-de-Malegarde",
    "dep": "Vaucluse"
  },
  {
    "code": "84490",
    "ville": "Saint-Saturnin-lès-Apt",
    "dep": "Vaucluse"
  },
  {
    "code": "84450",
    "ville": "Saint-Saturnin-lès-Avignon",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Saint-Trinit",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Sannes",
    "dep": "Vaucluse"
  },
  {
    "code": "84260",
    "ville": "Sarrians",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Sault",
    "dep": "Vaucluse"
  },
  {
    "code": "84800",
    "ville": "Saumane-de-Vaucluse",
    "dep": "Vaucluse"
  },
  {
    "code": "84390",
    "ville": "Savoillan",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Séguret",
    "dep": "Vaucluse"
  },
  {
    "code": "84830",
    "ville": "Sérignan-du-Comtat",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Sivergues",
    "dep": "Vaucluse"
  },
  {
    "code": "84700",
    "ville": "Sorgues",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "Suzette",
    "dep": "Vaucluse"
  },
  {
    "code": "84300",
    "ville": "Taillades",
    "dep": "Vaucluse"
  },
  {
    "code": "84250",
    "ville": "Le Thor",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "La Tour-d'Aigues",
    "dep": "Vaucluse"
  },
  {
    "code": "84850",
    "ville": "Travaillan",
    "dep": "Vaucluse"
  },
  {
    "code": "84100",
    "ville": "Uchaux",
    "dep": "Vaucluse"
  },
  {
    "code": "84190",
    "ville": "Vacqueyras",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Vaison-la-Romaine",
    "dep": "Vaucluse"
  },
  {
    "code": "84600",
    "ville": "Valréas",
    "dep": "Vaucluse"
  },
  {
    "code": "84800",
    "ville": "Fontaine-de-Vaucluse",
    "dep": "Vaucluse"
  },
  {
    "code": "84160",
    "ville": "Vaugines",
    "dep": "Vaucluse"
  },
  {
    "code": "84270",
    "ville": "Vedène",
    "dep": "Vaucluse"
  },
  {
    "code": "84740",
    "ville": "Velleron",
    "dep": "Vaucluse"
  },
  {
    "code": "84210",
    "ville": "Venasque",
    "dep": "Vaucluse"
  },
  {
    "code": "84750",
    "ville": "Viens",
    "dep": "Vaucluse"
  },
  {
    "code": "84400",
    "ville": "Villars",
    "dep": "Vaucluse"
  },
  {
    "code": "84110",
    "ville": "Villedieu",
    "dep": "Vaucluse"
  },
  {
    "code": "84530",
    "ville": "Villelaure",
    "dep": "Vaucluse"
  },
  {
    "code": "84570",
    "ville": "Villes-sur-Auzon",
    "dep": "Vaucluse"
  },
  {
    "code": "84150",
    "ville": "Violès",
    "dep": "Vaucluse"
  },
  {
    "code": "84820",
    "ville": "Visan",
    "dep": "Vaucluse"
  },
  {
    "code": "84240",
    "ville": "Vitrolles-en-Lubéron",
    "dep": "Vaucluse"
  },
  {
    "code": "85460",
    "ville": "L'Aiguillon-la-Presqu'île",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "L'Aiguillon-sur-Vie",
    "dep": "Vendée"
  },
  {
    "code": "85190",
    "ville": "Aizenay",
    "dep": "Vendée"
  },
  {
    "code": "85750",
    "ville": "Angles",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Antigny",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Apremont",
    "dep": "Vendée"
  },
  {
    "code": "85430",
    "ville": "Aubigny-Les Clouzeaux",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Auchay-sur-Vendée",
    "dep": "Vendée"
  },
  {
    "code": "85440",
    "ville": "Avrillé",
    "dep": "Vendée"
  },
  {
    "code": "85630",
    "ville": "Barbâtre",
    "dep": "Vendée"
  },
  {
    "code": "85550",
    "ville": "La Barre-de-Monts",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Bazoges-en-Paillers",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Bazoges-en-Pareds",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Beaufou",
    "dep": "Vendée"
  },
  {
    "code": "85190",
    "ville": "Beaulieu-sous-la-Roche",
    "dep": "Vendée"
  },
  {
    "code": "85500",
    "ville": "Beaurepaire",
    "dep": "Vendée"
  },
  {
    "code": "85230",
    "ville": "Beauvoir-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Bellevigny",
    "dep": "Vendée"
  },
  {
    "code": "85490",
    "ville": "Benet",
    "dep": "Vendée"
  },
  {
    "code": "85610",
    "ville": "La Bernardière",
    "dep": "Vendée"
  },
  {
    "code": "85560",
    "ville": "Le Bernard",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Bessay",
    "dep": "Vendée"
  },
  {
    "code": "85710",
    "ville": "Bois-de-Céné",
    "dep": "Vendée"
  },
  {
    "code": "85600",
    "ville": "La Boissière-de-Montaigu",
    "dep": "Vendée"
  },
  {
    "code": "85430",
    "ville": "La Boissière-des-Landes",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Bouillé-Courdault",
    "dep": "Vendée"
  },
  {
    "code": "85230",
    "ville": "Bouin",
    "dep": "Vendée"
  },
  {
    "code": "85510",
    "ville": "Le Boupère",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Bourneau",
    "dep": "Vendée"
  },
  {
    "code": "85480",
    "ville": "Bournezeau",
    "dep": "Vendée"
  },
  {
    "code": "85470",
    "ville": "Bretignolles-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "La Bretonnière-la-Claye",
    "dep": "Vendée"
  },
  {
    "code": "85260",
    "ville": "Les Brouzils",
    "dep": "Vendée"
  },
  {
    "code": "85530",
    "ville": "La Bruffière",
    "dep": "Vendée"
  },
  {
    "code": "85410",
    "ville": "La Caillère-Saint-Hilaire",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Chaillé-les-Marais",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "La Chaize-Giraud",
    "dep": "Vendée"
  },
  {
    "code": "85310",
    "ville": "La Chaize-le-Vicomte",
    "dep": "Vendée"
  },
  {
    "code": "85300",
    "ville": "Challans",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Champagné-les-Marais",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Le Champ-Saint-Père",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Chantonnay",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "La Chapelle-Hermier",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "La Chapelle-Palluau",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "La Chapelle-Thémer",
    "dep": "Vendée"
  },
  {
    "code": "85400",
    "ville": "Chasnais",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "La Châtaigneraie",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Château-Guibert",
    "dep": "Vendée"
  },
  {
    "code": "85710",
    "ville": "Châteauneuf",
    "dep": "Vendée"
  },
  {
    "code": "85140",
    "ville": "Chauché",
    "dep": "Vendée"
  },
  {
    "code": "85250",
    "ville": "Chavagnes-en-Paillers",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Chavagnes-les-Redoux",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Cheffois",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Coëx",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Commequiers",
    "dep": "Vendée"
  },
  {
    "code": "85260",
    "ville": "La Copechagnière",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Corpe",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "La Couture",
    "dep": "Vendée"
  },
  {
    "code": "85610",
    "ville": "Cugand",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Curzon",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Damvix",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Doix lès Fontaines",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Dompierre-sur-Yon",
    "dep": "Vendée"
  },
  {
    "code": "85590",
    "ville": "Les Epesses",
    "dep": "Vendée"
  },
  {
    "code": "85740",
    "ville": "L'Épine",
    "dep": "Vendée"
  },
  {
    "code": "85140",
    "ville": "Essarts-en-Bocage",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Falleron",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Faymoreau",
    "dep": "Vendée"
  },
  {
    "code": "85800",
    "ville": "Le Fenouiller",
    "dep": "Vendée"
  },
  {
    "code": "85280",
    "ville": "La Ferrière",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Sèvremont",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Fontenay-le-Comte",
    "dep": "Vendée"
  },
  {
    "code": "85480",
    "ville": "Fougeré",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Foussais-Payré",
    "dep": "Vendée"
  },
  {
    "code": "85300",
    "ville": "Froidfond",
    "dep": "Vendée"
  },
  {
    "code": "85710",
    "ville": "La Garnache",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "La Gaubretière",
    "dep": "Vendée"
  },
  {
    "code": "85190",
    "ville": "La Genétouze",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Le Girouard",
    "dep": "Vendée"
  },
  {
    "code": "85800",
    "ville": "Givrand",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Le Givre",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Grand'Landes",
    "dep": "Vendée"
  },
  {
    "code": "85440",
    "ville": "Grosbreuil",
    "dep": "Vendée"
  },
  {
    "code": "85580",
    "ville": "Grues",
    "dep": "Vendée"
  },
  {
    "code": "85770",
    "ville": "Le Gué-de-Velluire",
    "dep": "Vendée"
  },
  {
    "code": "85680",
    "ville": "La Guérinière",
    "dep": "Vendée"
  },
  {
    "code": "85260",
    "ville": "L'Herbergement",
    "dep": "Vendée"
  },
  {
    "code": "85500",
    "ville": "Les Herbiers",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "L'Hermenault",
    "dep": "Vendée"
  },
  {
    "code": "85770",
    "ville": "L'Île-d'Elle",
    "dep": "Vendée"
  },
  {
    "code": "85340",
    "ville": "L'Île-d'Olonne",
    "dep": "Vendée"
  },
  {
    "code": "85350",
    "ville": "L'Île-d'Yeu",
    "dep": "Vendée"
  },
  {
    "code": "85520",
    "ville": "Jard-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "La Jaudonnière",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "La Jonchère",
    "dep": "Vendée"
  },
  {
    "code": "85400",
    "ville": "Lairoux",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Landeronde",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Les Landes-Genusson",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Landevieille",
    "dep": "Vendée"
  },
  {
    "code": "85370",
    "ville": "Le Langon",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Liez",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Loge-Fougereuse",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Longèves",
    "dep": "Vendée"
  },
  {
    "code": "85560",
    "ville": "Longeville-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85400",
    "ville": "Luçon",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Les Lucs-sur-Boulogne",
    "dep": "Vendée"
  },
  {
    "code": "85190",
    "ville": "Maché",
    "dep": "Vendée"
  },
  {
    "code": "85400",
    "ville": "Les Magnils-Reigniers",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Maillé",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Maillezais",
    "dep": "Vendée"
  },
  {
    "code": "85590",
    "ville": "Mallièvre",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Mareuil-sur-Lay-Dissais",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Marillet",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "Marsais-Sainte-Radégonde",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Martinet",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Le Mazeau",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "La Meilleraie-Tillay",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Menomblet",
    "dep": "Vendée"
  },
  {
    "code": "85140",
    "ville": "La Merlatière",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Mervent",
    "dep": "Vendée"
  },
  {
    "code": "85500",
    "ville": "Mesnard-la-Barotière",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Monsireigne",
    "dep": "Vendée"
  },
  {
    "code": "85600",
    "ville": "Montaigu-Vendée",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Montournais",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Montreuil",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Moreilles",
    "dep": "Vendée"
  },
  {
    "code": "85290",
    "ville": "Mortagne-sur-Sèvre",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Les Achards",
    "dep": "Vendée"
  },
  {
    "code": "85640",
    "ville": "Mouchamps",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Mouilleron-Saint-Germain",
    "dep": "Vendée"
  },
  {
    "code": "85000",
    "ville": "Mouilleron-le-Captif",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Moutiers-les-Mauxfaits",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Moutiers-sur-le-Lay",
    "dep": "Vendée"
  },
  {
    "code": "85370",
    "ville": "Mouzeuil-Saint-Martin",
    "dep": "Vendée"
  },
  {
    "code": "85370",
    "ville": "Nalliers",
    "dep": "Vendée"
  },
  {
    "code": "85310",
    "ville": "Nesmy",
    "dep": "Vendée"
  },
  {
    "code": "85430",
    "ville": "Nieul-le-Dolent",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Rives-d'Autise",
    "dep": "Vendée"
  },
  {
    "code": "85330",
    "ville": "Noirmoutier-en-l'Île",
    "dep": "Vendée"
  },
  {
    "code": "85690",
    "ville": "Notre-Dame-de-Monts",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "L'Orbrie",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Palluau",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Péault",
    "dep": "Vendée"
  },
  {
    "code": "85300",
    "ville": "Le Perrier",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "Petosse",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Les Pineaux",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Pissotte",
    "dep": "Vendée"
  },
  {
    "code": "85770",
    "ville": "Les Velluire-sur-Vendée",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Le Poiré-sur-Vie",
    "dep": "Vendée"
  },
  {
    "code": "85440",
    "ville": "Poiroux",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "Pouillé",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Pouzauges",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Puy-de-Serre",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Puyravault",
    "dep": "Vendée"
  },
  {
    "code": "85250",
    "ville": "La Rabatelière",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Réaumur",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "La Réorthe",
    "dep": "Vendée"
  },
  {
    "code": "85270",
    "ville": "Notre-Dame-de-Riez",
    "dep": "Vendée"
  },
  {
    "code": "85620",
    "ville": "Rocheservière",
    "dep": "Vendée"
  },
  {
    "code": "85000",
    "ville": "La Roche-sur-Yon",
    "dep": "Vendée"
  },
  {
    "code": "85510",
    "ville": "Rochetrejoux",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Rosnay",
    "dep": "Vendée"
  },
  {
    "code": "85180",
    "ville": "Les Sables-d'Olonne",
    "dep": "Vendée"
  },
  {
    "code": "85250",
    "ville": "Saint-André-Goule-d'Oie",
    "dep": "Vendée"
  },
  {
    "code": "85260",
    "ville": "Montréverd",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Saint-Aubin-des-Ormeaux",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Saint-Aubin-la-Plaine",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Saint-Avaugourd-des-Landes",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Saint-Benoist-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Sainte-Cécile",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Saint-Christophe-du-Ligneron",
    "dep": "Vendée"
  },
  {
    "code": "85410",
    "ville": "Saint-Cyr-des-Gâts",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Saint-Cyr-en-Talmondais",
    "dep": "Vendée"
  },
  {
    "code": "85580",
    "ville": "Saint-Denis-du-Payré",
    "dep": "Vendée"
  },
  {
    "code": "85170",
    "ville": "Saint-Denis-la-Chevasse",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Saint-Étienne-de-Brillouet",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Saint-Étienne-du-Bois",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Sainte-Flaive-des-Loups",
    "dep": "Vendée"
  },
  {
    "code": "85310",
    "ville": "Rives de l'Yon",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Sainte-Foy",
    "dep": "Vendée"
  },
  {
    "code": "85250",
    "ville": "Saint-Fulgent",
    "dep": "Vendée"
  },
  {
    "code": "85400",
    "ville": "Sainte-Gemme-la-Plaine",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Saint-Georges-de-Pointindoux",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Saint-Germain-de-Prinçay",
    "dep": "Vendée"
  },
  {
    "code": "85230",
    "ville": "Saint-Gervais",
    "dep": "Vendée"
  },
  {
    "code": "85800",
    "ville": "Saint-Gilles-Croix-de-Vie",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Sainte-Hermine",
    "dep": "Vendée"
  },
  {
    "code": "85270",
    "ville": "Saint-Hilaire-de-Riez",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Saint-Hilaire-des-Loges",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Saint-Hilaire-de-Voust",
    "dep": "Vendée"
  },
  {
    "code": "85440",
    "ville": "Saint-Hilaire-la-Forêt",
    "dep": "Vendée"
  },
  {
    "code": "85480",
    "ville": "Saint-Hilaire-le-Vouhis",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Saint-Jean-de-Beugné",
    "dep": "Vendée"
  },
  {
    "code": "85160",
    "ville": "Saint-Jean-de-Monts",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Saint-Juire-Champgillon",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Saint-Julien-des-Landes",
    "dep": "Vendée"
  },
  {
    "code": "85410",
    "ville": "Saint-Laurent-de-la-Salle",
    "dep": "Vendée"
  },
  {
    "code": "85290",
    "ville": "Saint-Laurent-sur-Sèvre",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Saint-Maixent-sur-Vie",
    "dep": "Vendée"
  },
  {
    "code": "85590",
    "ville": "Saint-Malô-du-Bois",
    "dep": "Vendée"
  },
  {
    "code": "85590",
    "ville": "Saint-Mars-la-Réorthe",
    "dep": "Vendée"
  },
  {
    "code": "85470",
    "ville": "Brem-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Saint-Martin-de-Fraigneau",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "Saint-Martin-des-Fontaines",
    "dep": "Vendée"
  },
  {
    "code": "85140",
    "ville": "Saint-Martin-des-Noyers",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Saint-Martin-des-Tilleuls",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Saint-Martin-Lars-en-Sainte-Hermine",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Saint-Mathurin",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Saint-Maurice-des-Noues",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Saint-Maurice-le-Girard",
    "dep": "Vendée"
  },
  {
    "code": "85700",
    "ville": "Saint-Mesmin",
    "dep": "Vendée"
  },
  {
    "code": "85580",
    "ville": "Saint-Michel-en-l'Herm",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Saint-Michel-le-Cloucq",
    "dep": "Vendée"
  },
  {
    "code": "85500",
    "ville": "Saint-Paul-en-Pareds",
    "dep": "Vendée"
  },
  {
    "code": "85670",
    "ville": "Saint-Paul-Mont-Penit",
    "dep": "Vendée"
  },
  {
    "code": "85320",
    "ville": "Sainte-Pexine",
    "dep": "Vendée"
  },
  {
    "code": "85660",
    "ville": "Saint-Philbert-de-Bouaine",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Saint-Pierre-du-Chemin",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Saint-Pierre-le-Vieux",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Saint-Prouant",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Sainte-Radégonde-des-Noyers",
    "dep": "Vendée"
  },
  {
    "code": "85220",
    "ville": "Saint-Révérend",
    "dep": "Vendée"
  },
  {
    "code": "85420",
    "ville": "Saint-Sigismond",
    "dep": "Vendée"
  },
  {
    "code": "85230",
    "ville": "Saint-Urbain",
    "dep": "Vendée"
  },
  {
    "code": "85570",
    "ville": "Saint-Valérien",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Saint-Vincent-Sterlanges",
    "dep": "Vendée"
  },
  {
    "code": "85540",
    "ville": "Saint-Vincent-sur-Graon",
    "dep": "Vendée"
  },
  {
    "code": "85520",
    "ville": "Saint-Vincent-sur-Jard",
    "dep": "Vendée"
  },
  {
    "code": "85300",
    "ville": "Sallertaine",
    "dep": "Vendée"
  },
  {
    "code": "85200",
    "ville": "Sérigné",
    "dep": "Vendée"
  },
  {
    "code": "85110",
    "ville": "Sigournais",
    "dep": "Vendée"
  },
  {
    "code": "85300",
    "ville": "Soullans",
    "dep": "Vendée"
  },
  {
    "code": "85310",
    "ville": "Le Tablier",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "La Taillée",
    "dep": "Vendée"
  },
  {
    "code": "85390",
    "ville": "Tallud-Sainte-Gemme",
    "dep": "Vendée"
  },
  {
    "code": "85440",
    "ville": "Talmont-Saint-Hilaire",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Terval",
    "dep": "Vendée"
  },
  {
    "code": "85210",
    "ville": "Thiré",
    "dep": "Vendée"
  },
  {
    "code": "85480",
    "ville": "Thorigny",
    "dep": "Vendée"
  },
  {
    "code": "85410",
    "ville": "Rives-du-Fougerais",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Tiffauges",
    "dep": "Vendée"
  },
  {
    "code": "85360",
    "ville": "La Tranche-sur-Mer",
    "dep": "Vendée"
  },
  {
    "code": "85600",
    "ville": "Treize-Septiers",
    "dep": "Vendée"
  },
  {
    "code": "85590",
    "ville": "Treize-Vents",
    "dep": "Vendée"
  },
  {
    "code": "85580",
    "ville": "Triaize",
    "dep": "Vendée"
  },
  {
    "code": "85150",
    "ville": "Vairé",
    "dep": "Vendée"
  },
  {
    "code": "85190",
    "ville": "Venansault",
    "dep": "Vendée"
  },
  {
    "code": "85250",
    "ville": "Vendrennes",
    "dep": "Vendée"
  },
  {
    "code": "85130",
    "ville": "Chanverrie",
    "dep": "Vendée"
  },
  {
    "code": "85770",
    "ville": "Vix",
    "dep": "Vendée"
  },
  {
    "code": "85450",
    "ville": "Vouillé-les-Marais",
    "dep": "Vendée"
  },
  {
    "code": "85120",
    "ville": "Vouvant",
    "dep": "Vendée"
  },
  {
    "code": "85240",
    "ville": "Xanton-Chassenon",
    "dep": "Vendée"
  },
  {
    "code": "86430",
    "ville": "Adriers",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Amberre",
    "dep": "Vienne"
  },
  {
    "code": "86700",
    "ville": "Anché",
    "dep": "Vienne"
  },
  {
    "code": "86260",
    "ville": "Angles-sur-l'Anglin",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Angliers",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Antigny",
    "dep": "Vienne"
  },
  {
    "code": "86100",
    "ville": "Antran",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Arçay",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "Archigny",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Aslonnes",
    "dep": "Vienne"
  },
  {
    "code": "86430",
    "ville": "Asnières-sur-Blour",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Asnois",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Aulnay",
    "dep": "Vienne"
  },
  {
    "code": "86530",
    "ville": "Availles-en-Châtellerault",
    "dep": "Vienne"
  },
  {
    "code": "86460",
    "ville": "Availles-Limouzine",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Avanton",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Ayron",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Basses",
    "dep": "Vienne"
  },
  {
    "code": "86130",
    "ville": "Beaumont Saint-Cyr",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "Bellefonds",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Berrie",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Berthegon",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Béruges",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Béthines",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Beuxes",
    "dep": "Vienne"
  },
  {
    "code": "86580",
    "ville": "Biard",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Bignoux",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Blanzay",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Bonnes",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "Bonneuil-Matours",
    "dep": "Vienne"
  },
  {
    "code": "86410",
    "ville": "Bouresse",
    "dep": "Vienne"
  },
  {
    "code": "86390",
    "ville": "Bourg-Archambault",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Bournand",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Brigueil-le-Chantre",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Brion",
    "dep": "Vienne"
  },
  {
    "code": "86510",
    "ville": "Brux",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "La Bussière",
    "dep": "Vienne"
  },
  {
    "code": "86180",
    "ville": "Buxerolles",
    "dep": "Vienne"
  },
  {
    "code": "37160",
    "ville": "Buxeuil",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Ceaux-en-Loudun",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Celle-Lévescault",
    "dep": "Vienne"
  },
  {
    "code": "86530",
    "ville": "Cenon-sur-Vienne",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Cernay",
    "dep": "Vienne"
  },
  {
    "code": "86380",
    "ville": "Chabournay",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Chalais",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Chalandray",
    "dep": "Vienne"
  },
  {
    "code": "86510",
    "ville": "Champagné-le-Sec",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Champagné-Saint-Hilaire",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Champigny en Rochereau",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Champniers",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "La Chapelle-Bâton",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "La Chapelle-Moulière",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Chapelle-Viviers",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Charroux",
    "dep": "Vienne"
  },
  {
    "code": "86360",
    "ville": "Chasseneuil-du-Poitou",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Chatain",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Château-Garnier",
    "dep": "Vienne"
  },
  {
    "code": "86370",
    "ville": "Château-Larcher",
    "dep": "Vienne"
  },
  {
    "code": "86100",
    "ville": "Châtellerault",
    "dep": "Vienne"
  },
  {
    "code": "86510",
    "ville": "Chaunay",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "La Chaussée",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Chauvigny",
    "dep": "Vienne"
  },
  {
    "code": "86450",
    "ville": "Chenevelles",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Cherves",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Chiré-en-Montreuil",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Chouppes",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Cissé",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Civaux",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Civray",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "La Roche-Rigault",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Cloué",
    "dep": "Vienne"
  },
  {
    "code": "86490",
    "ville": "Colombiers",
    "dep": "Vienne"
  },
  {
    "code": "86700",
    "ville": "Valence-en-Poitou",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Coulombiers",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Coulonges-les-Hérolles",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Coussay",
    "dep": "Vienne"
  },
  {
    "code": "86270",
    "ville": "Coussay-les-Bois",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Craon",
    "dep": "Vienne"
  },
  {
    "code": "86240",
    "ville": "Croutelle",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Cuhon",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Curçay-sur-Dive",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Curzay-sur-Vonne",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Dangé-Saint-Romain",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Dercé",
    "dep": "Vienne"
  },
  {
    "code": "86410",
    "ville": "Dienné",
    "dep": "Vienne"
  },
  {
    "code": "86130",
    "ville": "Dissay",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Doussay",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "La Ferrière-Airoux",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Fleix",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Fleuré",
    "dep": "Vienne"
  },
  {
    "code": "86240",
    "ville": "Fontaine-le-Comte",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Frozes",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Gençay",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Genouillé",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Gizay",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Glénouze",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Gouex",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "La Grimaudière",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Guesnes",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Haims",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Ingrandes",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "L'Isle-Jourdain",
    "dep": "Vienne"
  },
  {
    "code": "86240",
    "ville": "Iteuil",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Jardres",
    "dep": "Vienne"
  },
  {
    "code": "86380",
    "ville": "Jaunay-Marigny",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Jazeneuil",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Jouhet",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Journet",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Joussé",
    "dep": "Vienne"
  },
  {
    "code": "86390",
    "ville": "Lathus-Saint-Rémy",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Latillé",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Lauthiers",
    "dep": "Vienne"
  },
  {
    "code": "86470",
    "ville": "Boivre-la-Vallée",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Lavoux",
    "dep": "Vienne"
  },
  {
    "code": "86450",
    "ville": "Leigné-les-Bois",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Leignes-sur-Fontaine",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Leigné-sur-Usseau",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Lencloître",
    "dep": "Vienne"
  },
  {
    "code": "86270",
    "ville": "Lésigny",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Leugny",
    "dep": "Vienne"
  },
  {
    "code": "86410",
    "ville": "Lhommaizé",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Liglet",
    "dep": "Vienne"
  },
  {
    "code": "86240",
    "ville": "Ligugé",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Linazay",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Liniers",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Lizant",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Loudun",
    "dep": "Vienne"
  },
  {
    "code": "86430",
    "ville": "Luchapt",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Lusignan",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Lussac-les-Châteaux",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Magné",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Maillé",
    "dep": "Vienne"
  },
  {
    "code": "86270",
    "ville": "Mairé",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Maisonneuve",
    "dep": "Vienne"
  },
  {
    "code": "86370",
    "ville": "Marçay",
    "dep": "Vienne"
  },
  {
    "code": "86370",
    "ville": "Marigny-Chemereau",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Marnay",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Martaizé",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Massognes",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Maulay",
    "dep": "Vienne"
  },
  {
    "code": "86460",
    "ville": "Mauprévoir",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Mazerolles",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Mazeuil",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Messemé",
    "dep": "Vienne"
  },
  {
    "code": "86550",
    "ville": "Mignaloux-Beauvoir",
    "dep": "Vienne"
  },
  {
    "code": "86440",
    "ville": "Migné-Auxances",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "Millac",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Mirebeau",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Moncontour",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Mondion",
    "dep": "Vienne"
  },
  {
    "code": "86360",
    "ville": "Montamisé",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "Monthoiron",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Montmorillon",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Monts-sur-Guesnes",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Morton",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Moulismes",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "Moussac",
    "dep": "Vienne"
  },
  {
    "code": "86430",
    "ville": "Mouterre-sur-Blourde",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Mouterre-Silly",
    "dep": "Vienne"
  },
  {
    "code": "86530",
    "ville": "Naintré",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Nalliers",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "Nérignac",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Neuville-de-Poitou",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Nieuil-l'Espoir",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Nouaillé-Maupertuis",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Nueil-sous-Faye",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Orches",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Les Ormes",
    "dep": "Vienne"
  },
  {
    "code": "86380",
    "ville": "Ouzilly",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Oyré",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Paizay-le-Sec",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Payroux",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Persac",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Pindray",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Plaisance",
    "dep": "Vienne"
  },
  {
    "code": "86450",
    "ville": "Pleumartin",
    "dep": "Vienne"
  },
  {
    "code": "86000",
    "ville": "Poitiers",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Port-de-Piles",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Pouançay",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Pouant",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Pouillé",
    "dep": "Vienne"
  },
  {
    "code": "86460",
    "ville": "Pressac",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Prinçay",
    "dep": "Vienne"
  },
  {
    "code": "86260",
    "ville": "La Puye",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "Queaux",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Quinçay",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Ranton",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Raslay",
    "dep": "Vienne"
  },
  {
    "code": "86270",
    "ville": "La Roche-Posay",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Roches-Prémarie-Andillé",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Roiffé",
    "dep": "Vienne"
  },
  {
    "code": "86700",
    "ville": "Romagne",
    "dep": "Vienne"
  },
  {
    "code": "86480",
    "ville": "Rouillé",
    "dep": "Vienne"
  },
  {
    "code": "86280",
    "ville": "Saint-Benoît",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Saint-Christophe",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Saint-Clair",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Saint-Gaudent",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Saint-Genest-d'Ambière",
    "dep": "Vienne"
  },
  {
    "code": "86130",
    "ville": "Saint-Georges-lès-Baillargeaux",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Saint-Germain",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Saint-Gervais-les-Trois-Clochers",
    "dep": "Vienne"
  },
  {
    "code": "86330",
    "ville": "Saint-Jean-de-Sauves",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Saint-Julien-l'Ars",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Saint-Laon",
    "dep": "Vienne"
  },
  {
    "code": "86410",
    "ville": "Saint-Laurent-de-Jourdes",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Saint-Léger-de-Montbrillais",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Saint-Léomer",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Valdivienne",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Saint-Martin-l'Ars",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Saint-Maurice-la-Clouère",
    "dep": "Vienne"
  },
  {
    "code": "86260",
    "ville": "Saint-Pierre-de-Maillé",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Saint-Pierre-d'Exideuil",
    "dep": "Vienne"
  },
  {
    "code": "86300",
    "ville": "Sainte-Radégonde",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Saint-Rémy-sur-Creuse",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Saint-Romain",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Saint-Sauvant",
    "dep": "Vienne"
  },
  {
    "code": "86100",
    "ville": "Senillé-Saint-Sauveur",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Saint-Savin",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Val-de-Comporté",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Saint-Secondin",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Saires",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Saix",
    "dep": "Vienne"
  },
  {
    "code": "86200",
    "ville": "Sammarçolles",
    "dep": "Vienne"
  },
  {
    "code": "86600",
    "ville": "Sanxay",
    "dep": "Vienne"
  },
  {
    "code": "86500",
    "ville": "Saulgé",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Savigné",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Savigny-Lévescault",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Savigny-sous-Faye",
    "dep": "Vienne"
  },
  {
    "code": "86140",
    "ville": "Scorbé-Clairvaux",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Sérigny",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Sèvres-Anxaumont",
    "dep": "Vienne"
  },
  {
    "code": "86320",
    "ville": "Sillars",
    "dep": "Vienne"
  },
  {
    "code": "86240",
    "ville": "Smarves",
    "dep": "Vienne"
  },
  {
    "code": "86160",
    "ville": "Sommières-du-Clain",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Sossais",
    "dep": "Vienne"
  },
  {
    "code": "86250",
    "ville": "Surin",
    "dep": "Vienne"
  },
  {
    "code": "86800",
    "ville": "Tercé",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Ternay",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "Thollet",
    "dep": "Vienne"
  },
  {
    "code": "86110",
    "ville": "Thurageau",
    "dep": "Vienne"
  },
  {
    "code": "86540",
    "ville": "Thuré",
    "dep": "Vienne"
  },
  {
    "code": "86290",
    "ville": "La Trimouille",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Les Trois-Moutiers",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Usseau",
    "dep": "Vienne"
  },
  {
    "code": "86350",
    "ville": "Usson-du-Poitou",
    "dep": "Vienne"
  },
  {
    "code": "86220",
    "ville": "Vaux-sur-Vienne",
    "dep": "Vienne"
  },
  {
    "code": "86230",
    "ville": "Vellèches",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Saint-Martin-la-Pallu",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "Vernon",
    "dep": "Vienne"
  },
  {
    "code": "86410",
    "ville": "Verrières",
    "dep": "Vienne"
  },
  {
    "code": "86420",
    "ville": "Verrue",
    "dep": "Vienne"
  },
  {
    "code": "86120",
    "ville": "Vézières",
    "dep": "Vienne"
  },
  {
    "code": "86260",
    "ville": "Vicq-sur-Gartempe",
    "dep": "Vienne"
  },
  {
    "code": "86150",
    "ville": "Le Vigeant",
    "dep": "Vienne"
  },
  {
    "code": "86340",
    "ville": "La Villedieu-du-Clain",
    "dep": "Vienne"
  },
  {
    "code": "86310",
    "ville": "Villemort",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Villiers",
    "dep": "Vienne"
  },
  {
    "code": "86370",
    "ville": "Vivonne",
    "dep": "Vienne"
  },
  {
    "code": "86190",
    "ville": "Vouillé",
    "dep": "Vienne"
  },
  {
    "code": "86400",
    "ville": "Voulême",
    "dep": "Vienne"
  },
  {
    "code": "86700",
    "ville": "Voulon",
    "dep": "Vienne"
  },
  {
    "code": "86580",
    "ville": "Vouneuil-sous-Biard",
    "dep": "Vienne"
  },
  {
    "code": "86210",
    "ville": "Vouneuil-sur-Vienne",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Vouzailles",
    "dep": "Vienne"
  },
  {
    "code": "86170",
    "ville": "Yversay",
    "dep": "Vienne"
  },
  {
    "code": "87700",
    "ville": "Aixe-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87240",
    "ville": "Ambazac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Arnac-la-Poste",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Augne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87220",
    "ville": "Aureil",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87360",
    "ville": "Azat-le-Ris",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87290",
    "ville": "Balledent",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "La Bazeuge",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Beaumont-du-Lac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Bellac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Berneuil",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87370",
    "ville": "Bersac-sur-Rivalier",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87250",
    "ville": "Bessines-sur-Gartempe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87700",
    "ville": "Beynac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87340",
    "ville": "Les Billanges",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Blanzac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Blond",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87220",
    "ville": "Boisseuil",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87270",
    "ville": "Bonnac-la-Côte",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87110",
    "ville": "Bosmie-l'Aiguille",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Breuilaufa",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Le Buis",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87460",
    "ville": "Bujaleuf",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Burgnac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Bussière-Galant",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87320",
    "ville": "Val-d'Oire-et-Gartempe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Les Cars",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87200",
    "ville": "Chaillac-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87500",
    "ville": "Le Chalard",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Châlus",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Chamboret",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87150",
    "ville": "Champagnac-la-Rivière",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Champnétery",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Champsac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "La Chapelle-Montbrandeix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87270",
    "ville": "Chaptelat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Château-Chervix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Châteauneuf-la-Forêt",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87290",
    "ville": "Châteauponsac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Le Châtenet-en-Dognon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87460",
    "ville": "Cheissoux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87600",
    "ville": "Chéronnac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87520",
    "ville": "Cieux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87310",
    "ville": "Cognac-la-Forêt",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Compreignac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87920",
    "ville": "Condat-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87500",
    "ville": "Coussac-Bonneval",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87270",
    "ville": "Couzeix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "La Croisille-sur-Briance",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "La Croix-sur-Gartempe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Cromac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87150",
    "ville": "Cussac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "Dinsac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Dompierre-les-Églises",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Domps",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "Le Dorat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Dournazac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Droux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Eybouleuf",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87220",
    "ville": "Eyjeaux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Eymoutiers",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87220",
    "ville": "Feytiat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Flavignac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87250",
    "ville": "Folles",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87250",
    "ville": "Fromental",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Gajoubert",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "La Geneytouse",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87500",
    "ville": "Glandon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Glanges",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87310",
    "ville": "Gorre",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Les Grands-Chézeaux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87170",
    "ville": "Isle",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87370",
    "ville": "Jabreilles-les-Bordes",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Janailhac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87520",
    "ville": "Javerdat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87340",
    "ville": "La Jonchère-Saint-Maurice",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87890",
    "ville": "Jouac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Jourgnac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87500",
    "ville": "Ladignac-le-Long",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87370",
    "ville": "Laurière",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Lavignac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87100",
    "ville": "Limoges",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Linards",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87360",
    "ville": "Lussac-les-Églises",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Magnac-Bourg",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Magnac-Laval",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Mailhac-sur-Benaize",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "Maisonnais-sur-Tardoire",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "Marval",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Masléon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Meilhac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Meuzac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "La Meyze",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Val d'Issoire",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Moissannes",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Montrol-Sénard",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Mortemart",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Nantiat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Nedde",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Neuvic-Entier",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Nexon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87510",
    "ville": "Nieul",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Nouic",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "Oradour-Saint-Genest",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87520",
    "ville": "Oradour-sur-Glane",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87150",
    "ville": "Oradour-sur-Vayres",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87230",
    "ville": "Pageas",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87410",
    "ville": "Le Palais-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87350",
    "ville": "Panazol",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "Pensol",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Peyrat-de-Bellac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87470",
    "ville": "Peyrat-le-Château",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87510",
    "ville": "Peyrilhac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Pierre-Buffière",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "La Porcherie",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87290",
    "ville": "Rancon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87640",
    "ville": "Razès",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Rempnat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Rilhac-Lastours",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87570",
    "ville": "Rilhac-Rancon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87600",
    "ville": "Rochechouart",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "La Roche-l'Abeille",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Saint-Pardoux-le-Lac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Royères",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Roziers-Saint-Georges",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87720",
    "ville": "Saillat-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Saint-Amand-le-Petit",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87290",
    "ville": "Saint-Amand-Magnazeix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87120",
    "ville": "Sainte-Anne-Saint-Priest",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87310",
    "ville": "Saint-Auvent",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87150",
    "ville": "Saint-Bazile",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Saint-Bonnet-Briance",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Saint-Bonnet-de-Bellac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87200",
    "ville": "Saint-Brice-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87310",
    "ville": "Saint-Cyr",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Saint-Denis-des-Murs",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87510",
    "ville": "Saint-Gence",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Saint-Genest-sur-Roselle",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Saint-Georges-les-Landes",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Saint-Germain-les-Belles",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Saint-Gilles-les-Forêts",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Saint-Hilaire-Bonneval",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Saint-Hilaire-la-Treille",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Saint-Hilaire-les-Places",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Saint-Jean-Ligoure",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87510",
    "ville": "Saint-Jouvent",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87460",
    "ville": "Saint-Julien-le-Petit",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87200",
    "ville": "Saint-Junien",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Saint-Junien-les-Combes",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87590",
    "ville": "Saint-Just-le-Martel",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87240",
    "ville": "Saint-Laurent-les-Églises",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87310",
    "ville": "Saint-Laurent-sur-Gorre",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87340",
    "ville": "Saint-Léger-la-Montagne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Saint-Léger-Magnazeix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Saint-Léonard-de-Noblat",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87420",
    "ville": "Sainte-Marie-de-Vaux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87330",
    "ville": "Saint-Martial-sur-Isop",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87200",
    "ville": "Saint-Martin-de-Jussac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87360",
    "ville": "Saint-Martin-le-Mault",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87700",
    "ville": "Saint-Martin-le-Vieux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Saint-Martin-Terressus",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "Saint-Mathieu",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Saint-Maurice-les-Brousses",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Saint-Méard",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87300",
    "ville": "Saint-Ouen-sur-Gartempe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Saint-Paul",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87800",
    "ville": "Saint-Priest-Ligoure",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87700",
    "ville": "Saint-Priest-sous-Aixe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87480",
    "ville": "Saint-Priest-Taurion",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87210",
    "ville": "Saint-Sornin-la-Marche",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87290",
    "ville": "Saint-Sornin-Leulac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87370",
    "ville": "Saint-Sulpice-Laurière",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87160",
    "ville": "Saint-Sulpice-les-Feuilles",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87240",
    "ville": "Saint-Sylvestre",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87420",
    "ville": "Saint-Victurnien",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87380",
    "ville": "Saint-Vitte-sur-Briance",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87500",
    "ville": "Saint-Yrieix-la-Perche",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87700",
    "ville": "Saint-Yrieix-sous-Aixe",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87440",
    "ville": "Les Salles-Lavauguyon",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87400",
    "ville": "Sauviat-sur-Vige",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87620",
    "ville": "Séreilhac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87110",
    "ville": "Solignac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Surdoux",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87130",
    "ville": "Sussac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87360",
    "ville": "Tersannes",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Thouron",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87140",
    "ville": "Vaulry",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87600",
    "ville": "Vayres",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87360",
    "ville": "Verneuil-Moustiers",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87430",
    "ville": "Verneuil-sur-Vienne",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87520",
    "ville": "Veyrac",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87260",
    "ville": "Vicq-sur-Breuilh",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87600",
    "ville": "Videix",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87110",
    "ville": "Le Vigen",
    "dep": "Haute-Vienne"
  },
  {
    "code": "87190",
    "ville": "Villefavard",
    "dep": "Haute-Vienne"
  },
  {
    "code": "88270",
    "ville": "Les Ableuvenettes",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Ahéville",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Aingeville",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Ainvelle",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Allarmont",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Ambacourt",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Ameuvelle",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Anglemont",
    "dep": "Vosges"
  },
  {
    "code": "88650",
    "ville": "Anould",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Aouze",
    "dep": "Vosges"
  },
  {
    "code": "88380",
    "ville": "Arches",
    "dep": "Vosges"
  },
  {
    "code": "88380",
    "ville": "Archettes",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Aroffe",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "Arrentès-de-Corcieux",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Attignéville",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Attigny",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Aulnois",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Autigny-la-Tour",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Autreville",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Autrey",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Auzainvilliers",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Avillers",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Avrainville",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Avranville",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Aydoilles",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Badménil-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "La Baffe",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "La Vôge-les-Bains",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Bainville-aux-Saules",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Balléville",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "Ban-de-Laveline",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Ban-de-Sapt",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Barbey-Seroux",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Barville",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Basse-sur-le-Rupt",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Battexey",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Baudricourt",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Bayecourt",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Bazegney",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Bazien",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Bazoilles-et-Ménil",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Bazoilles-sur-Meuse",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Beaufremont",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Beauménil",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Begnécourt",
    "dep": "Vosges"
  },
  {
    "code": "88370",
    "ville": "Bellefontaine",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Belmont-lès-Darney",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Belmont-sur-Buttant",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Belmont-sur-Vair",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Belrupt",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Belval",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "Bertrimoutier",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Bettegney-Saint-Brice",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Bettoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Le Beulay",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Biécourt",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "Biffontaine",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Blémerey",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Bleurville",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Blevaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Bocquegney",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Bois-de-Champ",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Bonvillet",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Boulaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88470",
    "ville": "La Bourgonce",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Bouxières-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Bouxurulles",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Bouzemont",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Brantigny",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Brechainville",
    "dep": "Vosges"
  },
  {
    "code": "88250",
    "ville": "La Bresse",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Brouvelieures",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Brû",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Bruyères",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Bulgnéville",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Bult",
    "dep": "Vosges"
  },
  {
    "code": "88540",
    "ville": "Bussang",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Celles-sur-Plaine",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Certilleux",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Chamagne",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Champdray",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Champ-le-Duc",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Chantraine",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "La Chapelle-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "La Chapelle-devant-Bruyères",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Charmes",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Charmois-devant-Bruyères",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Charmois-l'Orgueilleux",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Châtas",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Châtel-sur-Moselle",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Châtenois",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Châtillon-sur-Saône",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Chauffecourt",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Chaumousey",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Chavelot",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Chef-Haut",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Cheniménil",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Chermisey",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Circourt",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Circourt-sur-Mouzon",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Claudon",
    "dep": "Vosges"
  },
  {
    "code": "88230",
    "ville": "Ban-sur-Meurthe-Clefcy",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Clérey-la-Côte",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Le Clerjus",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Cleurie",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Clézentaine",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Coinches",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Combrimont",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Contrexéville",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "Corcieux",
    "dep": "Vosges"
  },
  {
    "code": "88310",
    "ville": "Cornimont",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Courcelles-sous-Châtenois",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Coussey",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Crainvilliers",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "La Croix-aux-Mines",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Damas-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Damas-et-Bettegney",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Damblain",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Darney",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Darney-aux-Chênes",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Darnieulles",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Deinvillers",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Denipaire",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Derbamont",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Destord",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Deycimont",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Deyvillers",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Dignonville",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Dinozé",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Docelles",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Dogneville",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Dolaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Dombasle-devant-Darney",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Dombasle-en-Xaintois",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Dombrot-le-Sec",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Dombrot-sur-Vair",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Domèvre-sur-Avière",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Domèvre-sur-Durbion",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Domèvre-sous-Montfort",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Domfaing",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Domjulien",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Dommartin-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88200",
    "ville": "Dommartin-lès-Remiremont",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Dommartin-lès-Vallois",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Dommartin-sur-Vraine",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Dompaire",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Dompierre",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Domptail",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Domrémy-la-Pucelle",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Domvallier",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Doncières",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Dounoux",
    "dep": "Vosges"
  },
  {
    "code": "88510",
    "ville": "Éloyes",
    "dep": "Vosges"
  },
  {
    "code": "88650",
    "ville": "Entre-deux-Eaux",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Épinal",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Escles",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Esley",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Essegney",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Estrennes",
    "dep": "Vosges"
  },
  {
    "code": "88480",
    "ville": "Étival-Clairefontaine",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Évaux-et-Ménil",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Faucompierre",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Fauconcourt",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Fays",
    "dep": "Vosges"
  },
  {
    "code": "88360",
    "ville": "Ferdrupt",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Fignévelle",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Fiménil",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Florémont",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Fomerey",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Fontenay",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Fontenoy-le-Château",
    "dep": "Vosges"
  },
  {
    "code": "88530",
    "ville": "La Forge",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Les Forges",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Fouchécourt",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Frain",
    "dep": "Vosges"
  },
  {
    "code": "88230",
    "ville": "Fraize",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Frapelle",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Frebécourt",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Fremifontaine",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Frenelle-la-Grande",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Frenelle-la-Petite",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Frénois",
    "dep": "Vosges"
  },
  {
    "code": "88160",
    "ville": "Fresse-sur-Moselle",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Fréville",
    "dep": "Vosges"
  },
  {
    "code": "88440",
    "ville": "Frizon",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Gelvécourt-et-Adompt",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "Gemaingoutte",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Gemmelaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Gendreville",
    "dep": "Vosges"
  },
  {
    "code": "88400",
    "ville": "Gérardmer",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Gerbamont",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "Gerbépal",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Gignéville",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Gigney",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Girancourt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Gircourt-lès-Viéville",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Girecourt-sur-Durbion",
    "dep": "Vosges"
  },
  {
    "code": "88340",
    "ville": "Girmont-Val-d'Ajol",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Gironcourt-sur-Vraine",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Godoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88190",
    "ville": "Golbey",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Gorhey",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Grand",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "La Grande-Fosse",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Grandrupt-de-Bains",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Grandrupt",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Grandvillers",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Granges-Aumontzey",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Greux",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Grignoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Gruey-lès-Surance",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Gugnécourt",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Gugney-aux-Aulx",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Hadigny-les-Verrières",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Hadol",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Hagécourt",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Hagnéville-et-Roncourt",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Haillainville",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Harchéchamp",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Hardancourt",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Haréville",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Harmonville",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Harol",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "La Haye",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Hennecourt",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Hennezel",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Hergugney",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Herpelmont",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Houécourt",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Houéville",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Housseras",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "La Houssière",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Hurbache",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Hymont",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Igney",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Isches",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Jainvillotte",
    "dep": "Vosges"
  },
  {
    "code": "88550",
    "ville": "Jarménil",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Jeanménil",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Jésonville",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Jeuxey",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Jorxey",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Jubainville",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Jussarupt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Juvaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Lamarche",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Landaville",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Langley",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Laval-sur-Vologne",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Laveline-devant-Bruyères",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Laveline-du-Houx",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Légéville-et-Bonfays",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Lemmecourt",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Lépanges-sur-Vologne",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Lerrain",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Lesseux",
    "dep": "Vosges"
  },
  {
    "code": "88400",
    "ville": "Liézey",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Liffol-le-Grand",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Lignéville",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Lironcourt",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Longchamp",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Longchamp-sous-Châtenois",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Lubine",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Lusse",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Luvigny",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Maconcourt",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Madecourt",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Madegney",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Madonne-et-Lamerey",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Malaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88650",
    "ville": "Mandray",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Mandres-sur-Vair",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Marainville-sur-Madon",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Marey",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Maroncourt",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Martigny-les-Bains",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Martigny-les-Gerbonvaux",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Martinvelle",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Mattaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Maxey-sur-Meuse",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Mazeley",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Mazirot",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Médonville",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Méménil",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Ménarmont",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Ménil-en-Xaintois",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Ménil-de-Senones",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Ménil-sur-Belvitte",
    "dep": "Vosges"
  },
  {
    "code": "88160",
    "ville": "Le Ménil",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Midrevaux",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Mirecourt",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Moncel-sur-Vair",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Le Mont",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Mont-lès-Lamarche",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Mont-lès-Neufchâteau",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Monthureux-le-Sec",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Monthureux-sur-Saône",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Montmotier",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Morelmaison",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Moriville",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Morizécourt",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Mortagne",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Morville",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Moussey",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Moyemont",
    "dep": "Vosges"
  },
  {
    "code": "88420",
    "ville": "Moyenmoutier",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Nayemont-les-Fosses",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Neufchâteau",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "La Neuveville-devant-Lépanges",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "La Neuveville-sous-Châtenois",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "La Neuveville-sous-Montfort",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Neuvillers-sur-Fave",
    "dep": "Vosges"
  },
  {
    "code": "88440",
    "ville": "Nomexy",
    "dep": "Vosges"
  },
  {
    "code": "88470",
    "ville": "Nompatelize",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Nonville",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Nonzeville",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Norroy",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Nossoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Oëlleville",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Offroicourt",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Ollainville",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Ortoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Padoux",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Pair-et-Grandrupt",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Pallegney",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Parey-sous-Montfort",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Pargny-sous-Mureau",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "La Petite-Fosse",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "La Petite-Raon",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Pierrefitte",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Pierrepont-sur-l'Arentèle",
    "dep": "Vosges"
  },
  {
    "code": "88230",
    "ville": "Plainfaing",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Pleuvezain",
    "dep": "Vosges"
  },
  {
    "code": "88370",
    "ville": "Plombières-les-Bains",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Pompierre",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Pont-lès-Bonfays",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Pont-sur-Madon",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Portieux",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Les Poulières",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Poussay",
    "dep": "Vosges"
  },
  {
    "code": "88550",
    "ville": "Pouxeux",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Prey",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Provenchères-lès-Darney",
    "dep": "Vosges"
  },
  {
    "code": "88490",
    "ville": "Provenchères-et-Colroy",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Le Puid",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Punerot",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Puzieux",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Racécourt",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Rainville",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Rambervillers",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Ramecourt",
    "dep": "Vosges"
  },
  {
    "code": "88160",
    "ville": "Ramonchamp",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Rancourt",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Raon-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Raon-l'Étape",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Raon-sur-Plaine",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Rapey",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "Raves",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Rebeuville",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Regnévelle",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Regney",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Rehaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88640",
    "ville": "Rehaupal",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Relanges",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Remicourt",
    "dep": "Vosges"
  },
  {
    "code": "88200",
    "ville": "Remiremont",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Remoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Remomeix",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Removille",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Renauvoid",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Repel",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Robécourt",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Rochesson",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Rollainville",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Romain-aux-Bois",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Romont",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Les Rouges-Eaux",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Le Roulier",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Rouvres-en-Xaintois",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Rouvres-la-Chétive",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Roville-aux-Chênes",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Rozerotte",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Rozières-sur-Mouzon",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Rugney",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Ruppes",
    "dep": "Vosges"
  },
  {
    "code": "88360",
    "ville": "Rupt-sur-Moselle",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Saint-Amé",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Sainte-Barbe",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Saint-Baslemont",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Saint-Benoît-la-Chipotte",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Saint-Dié-des-Vosges",
    "dep": "Vosges"
  },
  {
    "code": "88200",
    "ville": "Saint-Étienne-lès-Remiremont",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Saint-Genest",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Saint-Gorgon",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Sainte-Hélène",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Saint-Jean-d'Ormont",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Saint-Julien",
    "dep": "Vosges"
  },
  {
    "code": "88650",
    "ville": "Saint-Léonard",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Sainte-Marguerite",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Saint-Maurice-sur-Mortagne",
    "dep": "Vosges"
  },
  {
    "code": "88560",
    "ville": "Saint-Maurice-sur-Moselle",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Saint-Menge",
    "dep": "Vosges"
  },
  {
    "code": "88470",
    "ville": "Saint-Michel-sur-Meurthe",
    "dep": "Vosges"
  },
  {
    "code": "88200",
    "ville": "Saint-Nabord",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Saint-Ouen-lès-Parey",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Saint-Paul",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Saint-Pierremont",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Saint-Prancher",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Saint-Remimont",
    "dep": "Vosges"
  },
  {
    "code": "88480",
    "ville": "Saint-Remy",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Saint-Stail",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Saint-Vallier",
    "dep": "Vosges"
  },
  {
    "code": "88470",
    "ville": "La Salle",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Sanchey",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Sandaucourt",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Sans-Vallois",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Sapois",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Sartes",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Le Saulcy",
    "dep": "Vosges"
  },
  {
    "code": "88580",
    "ville": "Saulcy-sur-Meurthe",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Saulxures-lès-Bulgnéville",
    "dep": "Vosges"
  },
  {
    "code": "88290",
    "ville": "Saulxures-sur-Moselotte",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Sauville",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Savigny",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Senaide",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Senones",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Senonges",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Seraumont",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Sercœur",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Serécourt",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Serocourt",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Sionne",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Socourt",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Soncourt",
    "dep": "Vosges"
  },
  {
    "code": "88630",
    "ville": "Soulosse-sous-Saint-Élophe",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Suriauville",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Le Syndicat",
    "dep": "Vosges"
  },
  {
    "code": "88100",
    "ville": "Taintrux",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Tendon",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Thaon-les-Vosges",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "They-sous-Montfort",
    "dep": "Vosges"
  },
  {
    "code": "88290",
    "ville": "Thiéfosse",
    "dep": "Vosges"
  },
  {
    "code": "88160",
    "ville": "Le Thillot",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Thiraucourt",
    "dep": "Vosges"
  },
  {
    "code": "88530",
    "ville": "Le Tholy",
    "dep": "Vosges"
  },
  {
    "code": "88410",
    "ville": "Les Thons",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Thuillières",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Tignécourt",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Tilleux",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Tollaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Totainville",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Trampot",
    "dep": "Vosges"
  },
  {
    "code": "88300",
    "ville": "Tranqueville-Graux",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Trémonzey",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Ubexy",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Uriménil",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Urville",
    "dep": "Vosges"
  },
  {
    "code": "88390",
    "ville": "Uxegney",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Uzemain",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "La Vacheresse-et-la-Rouillie",
    "dep": "Vosges"
  },
  {
    "code": "88120",
    "ville": "Vagney",
    "dep": "Vosges"
  },
  {
    "code": "88340",
    "ville": "Le Val-d'Ajol",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Valfroicourt",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Valleroy-aux-Saules",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Valleroy-le-Sec",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Les Vallois",
    "dep": "Vosges"
  },
  {
    "code": "88230",
    "ville": "Le Valtin",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Varmonzey",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Vaubexy",
    "dep": "Vosges"
  },
  {
    "code": "88000",
    "ville": "Vaudéville",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Vaudoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Vaxoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88200",
    "ville": "Vecoux",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Velotte-et-Tatignécourt",
    "dep": "Vosges"
  },
  {
    "code": "88310",
    "ville": "Ventron",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Le Vermont",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Vervezelle",
    "dep": "Vosges"
  },
  {
    "code": "88110",
    "ville": "Vexaincourt",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Vicherey",
    "dep": "Vosges"
  },
  {
    "code": "88430",
    "ville": "Vienville",
    "dep": "Vosges"
  },
  {
    "code": "88210",
    "ville": "Vieux-Moulin",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Villers",
    "dep": "Vosges"
  },
  {
    "code": "88270",
    "ville": "Ville-sur-Illon",
    "dep": "Vosges"
  },
  {
    "code": "88150",
    "ville": "Villoncourt",
    "dep": "Vosges"
  },
  {
    "code": "88320",
    "ville": "Villotte",
    "dep": "Vosges"
  },
  {
    "code": "88350",
    "ville": "Villouxel",
    "dep": "Vosges"
  },
  {
    "code": "88600",
    "ville": "Viménil",
    "dep": "Vosges"
  },
  {
    "code": "88450",
    "ville": "Vincey",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Viocourt",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Vioménil",
    "dep": "Vosges"
  },
  {
    "code": "88800",
    "ville": "Vittel",
    "dep": "Vosges"
  },
  {
    "code": "88260",
    "ville": "Viviers-le-Gras",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Viviers-lès-Offroicourt",
    "dep": "Vosges"
  },
  {
    "code": "88470",
    "ville": "La Voivre",
    "dep": "Vosges"
  },
  {
    "code": "88240",
    "ville": "Les Voivres",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Vomécourt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Vomécourt-sur-Madon",
    "dep": "Vosges"
  },
  {
    "code": "88170",
    "ville": "Vouxey",
    "dep": "Vosges"
  },
  {
    "code": "88140",
    "ville": "Vrécourt",
    "dep": "Vosges"
  },
  {
    "code": "88500",
    "ville": "Vroville",
    "dep": "Vosges"
  },
  {
    "code": "88520",
    "ville": "Wisembach",
    "dep": "Vosges"
  },
  {
    "code": "88700",
    "ville": "Xaffévillers",
    "dep": "Vosges"
  },
  {
    "code": "88460",
    "ville": "Xamontarupt",
    "dep": "Vosges"
  },
  {
    "code": "88130",
    "ville": "Xaronval",
    "dep": "Vosges"
  },
  {
    "code": "88220",
    "ville": "Xertigny",
    "dep": "Vosges"
  },
  {
    "code": "88400",
    "ville": "Xonrupt-Longemer",
    "dep": "Vosges"
  },
  {
    "code": "88330",
    "ville": "Zincourt",
    "dep": "Vosges"
  },
  {
    "code": "89800",
    "ville": "Aigremont",
    "dep": "Yonne"
  },
  {
    "code": "89710",
    "ville": "Montholon",
    "dep": "Yonne"
  },
  {
    "code": "89390",
    "ville": "Aisy-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Ancy-le-Franc",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Ancy-le-Libre",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Andryes",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Angely",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Annay-la-Côte",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Annay-sur-Serein",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Annéot",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Annoux",
    "dep": "Yonne"
  },
  {
    "code": "89380",
    "ville": "Appoigny",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Arces-Dilo",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Arcy-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Argentenay",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Argenteuil-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Armeau",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Arthonnay",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Asnières-sous-Bois",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Asquins",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Athie",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Augy",
    "dep": "Yonne"
  },
  {
    "code": "89000",
    "ville": "Auxerre",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Avallon",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Bagneaux",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Baon",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Bassou",
    "dep": "Yonne"
  },
  {
    "code": "89460",
    "ville": "Bazarnes",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Beaumont",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Beauvilliers",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Beauvoir",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Beine",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Bellechaume",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "La Belliole",
    "dep": "Yonne"
  },
  {
    "code": "89410",
    "ville": "Béon",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Bernouil",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Béru",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Bessy-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Beugnon",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Bierry-les-Belles-Fontaines",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Blacy",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Blannay",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Bleigny-le-Carreau",
    "dep": "Yonne"
  },
  {
    "code": "89220",
    "ville": "Bléneau",
    "dep": "Yonne"
  },
  {
    "code": "89770",
    "ville": "Bœurs-en-Othe",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Bois-d'Arcy",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Bonnard",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Les Bordes",
    "dep": "Yonne"
  },
  {
    "code": "89113",
    "ville": "Branches",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Brannay",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Brienon-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Brion",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Brosses",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Bussières",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Bussy-en-Othe",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Bussy-le-Repos",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Butteaux",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Carisey",
    "dep": "Yonne"
  },
  {
    "code": "89116",
    "ville": "La Celle-Saint-Cyr",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Censy",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Cérilly",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Cerisiers",
    "dep": "Yonne"
  },
  {
    "code": "89410",
    "ville": "Cézy",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Chablis",
    "dep": "Yonne"
  },
  {
    "code": "89770",
    "ville": "Chailley",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Chamoux",
    "dep": "Yonne"
  },
  {
    "code": "89220",
    "ville": "Champcevrais",
    "dep": "Yonne"
  },
  {
    "code": "89350",
    "ville": "Champignelles",
    "dep": "Yonne"
  },
  {
    "code": "89340",
    "ville": "Champigny",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Champlay",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Champlost",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Champs-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Chamvres",
    "dep": "Yonne"
  },
  {
    "code": "89260",
    "ville": "La Chapelle-sur-Oreuse",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "La Chapelle-Vaupelteigne",
    "dep": "Yonne"
  },
  {
    "code": "89113",
    "ville": "Charbuy",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Charentenay",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Charmoy",
    "dep": "Yonne"
  },
  {
    "code": "89120",
    "ville": "Charny Orée de Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Chassignelles",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Chassy",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Chastellux-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Châtel-Censoir",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Châtel-Gérard",
    "dep": "Yonne"
  },
  {
    "code": "89340",
    "ville": "Chaumont",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Chaumot",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Chemilly-sur-Serein",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Chemilly-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Cheney",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Cheny",
    "dep": "Yonne"
  },
  {
    "code": "89690",
    "ville": "Chéroy",
    "dep": "Yonne"
  },
  {
    "code": "89600",
    "ville": "Chéu",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Chevannes",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Chichée",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Chichery",
    "dep": "Yonne"
  },
  {
    "code": "89530",
    "ville": "Chitry",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Les Clérimois",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Collan",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Collemiers",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Compigny",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Cornant",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Coulangeron",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Coulanges-la-Vineuse",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Coulanges-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Coulours",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Courgenay",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Courgis",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Courlon-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Courson-les-Carrières",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Courtoin",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Courtois-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Coutarnoux",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Crain",
    "dep": "Yonne"
  },
  {
    "code": "89460",
    "ville": "Deux Rivières",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Cruzy-le-Châtel",
    "dep": "Yonne"
  },
  {
    "code": "89390",
    "ville": "Cry",
    "dep": "Yonne"
  },
  {
    "code": "89116",
    "ville": "Cudot",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Cussy-les-Forges",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Cuy",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Dannemoine",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Diges",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Dissangis",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Dixmont",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Dollot",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Domats",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Domecy-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Domecy-sur-le-Vault",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Dracy",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Druyes-les-Belles-Fontaines",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Dyé",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Égleny",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Égriselles-le-Bocage",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Épineau-les-Voves",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Épineuil",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Escamps",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Escolives-Sainte-Camille",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Esnon",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Étais-la-Sauvin",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Étaule",
    "dep": "Yonne"
  },
  {
    "code": "89510",
    "ville": "Étigny",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Étivey",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Évry",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "La Ferté-Loupière",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Festigny",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Flacy",
    "dep": "Yonne"
  },
  {
    "code": "89113",
    "ville": "Fleury-la-Vallée",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Fleys",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Flogny-la-Chapelle",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Foissy-lès-Vézelay",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Foissy-sur-Vanne",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Fontaine-la-Gaillarde",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Fontaines",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Fontenay-près-Chablis",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Fontenay-près-Vézelay",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Fontenay-sous-Fouronnes",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Fontenoy",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Fouchères",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Fournaudin",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Fouronnes",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Fresnes",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Fulvy",
    "dep": "Yonne"
  },
  {
    "code": "89600",
    "ville": "Germigny",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Gigny",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Girolles",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Gisy-les-Nobles",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Givry",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Gland",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Grimault",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Gron",
    "dep": "Yonne"
  },
  {
    "code": "89113",
    "ville": "Valravillon",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Guillon-Terre-Plaine",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Gurgy",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Gy-l'Évêque",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Hauterive",
    "dep": "Yonne"
  },
  {
    "code": "89550",
    "ville": "Héry",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Irancy",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Island",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "L'Isle-sur-Serein",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Jaulges",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Joigny",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Jouancy",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Joux-la-Ville",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Jouy",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Jully",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Junay",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Jussy",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Lailly",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Lain",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Lainsecq",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Lalande",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Laroche-Saint-Cydroine",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Lasson",
    "dep": "Yonne"
  },
  {
    "code": "89170",
    "ville": "Lavau",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Leugny",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Levis",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Lézinnes",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Lichères-près-Aigremont",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Lichères-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Lignorelles",
    "dep": "Yonne"
  },
  {
    "code": "89144",
    "ville": "Ligny-le-Châtel",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Lindry",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Lixy",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Looze",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Lucy-le-Bois",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Lucy-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89480",
    "ville": "Lucy-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Magny",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Maillot",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Mailly-la-Ville",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Mailly-le-Château",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Malay-le-Grand",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Malay-le-Petit",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Maligny",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Marmeaux",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Marsangy",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Massangis",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Mélisey",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Menades",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Mercy",
    "dep": "Yonne"
  },
  {
    "code": "89144",
    "ville": "Méré",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Merry-la-Vallée",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Merry-Sec",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Merry-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Mézilles",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Michery",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Migé",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Migennes",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Môlay",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Molinons",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Molosmes",
    "dep": "Yonne"
  },
  {
    "code": "89470",
    "ville": "Monéteau",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Montacher-Villegardin",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Montigny-la-Resle",
    "dep": "Yonne"
  },
  {
    "code": "89660",
    "ville": "Montillot",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Montréal",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Mont-Saint-Sulpice",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Mouffy",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Moulins-en-Tonnerrois",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Moulins-sur-Ouanne",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Moutiers-en-Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Nailly",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Neuvy-Sautour",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Nitry",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Noé",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Noyers",
    "dep": "Yonne"
  },
  {
    "code": "89390",
    "ville": "Nuits",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Les Ormes",
    "dep": "Yonne"
  },
  {
    "code": "89400",
    "ville": "Ormoy",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Ouanne",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Pacy-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Pailly",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Parly",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Paron",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Paroy-en-Othe",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Paroy-sur-Tholon",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Pasilly",
    "dep": "Yonne"
  },
  {
    "code": "89510",
    "ville": "Passy",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Percey",
    "dep": "Yonne"
  },
  {
    "code": "89000",
    "ville": "Perrigny",
    "dep": "Yonne"
  },
  {
    "code": "89390",
    "ville": "Perrigny-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Pierre-Perthuis",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Piffonds",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Pimelles",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Pisy",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Plessis-Saint-Jean",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Poilly-sur-Serein",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Poilly-sur-Tholon",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Pontaubert",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Pontigny",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Pont-sur-Vanne",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Pont-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89260",
    "ville": "La Postolle",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Pourrain",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Précy-le-Sec",
    "dep": "Yonne"
  },
  {
    "code": "89116",
    "ville": "Précy-sur-Vrin",
    "dep": "Yonne"
  },
  {
    "code": "89460",
    "ville": "Prégilbert",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Préhy",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Provency",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Quarré-les-Tombes",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Quenne",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Quincerot",
    "dep": "Yonne"
  },
  {
    "code": "89390",
    "ville": "Ravières",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Roffey",
    "dep": "Yonne"
  },
  {
    "code": "89220",
    "ville": "Rogny-les-Sept-Écluses",
    "dep": "Yonne"
  },
  {
    "code": "89170",
    "ville": "Ronchères",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Rosoy",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Rousson",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Rouvray",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Rugny",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Sainpuits",
    "dep": "Yonne"
  },
  {
    "code": "89340",
    "ville": "Saint-Agnan",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Saint-André-en-Terre-Plaine",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Le Val d'Ocre",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Saint-Aubin-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Saint-Brancher",
    "dep": "Yonne"
  },
  {
    "code": "89530",
    "ville": "Saint-Bris-le-Vineux",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Saint-Clément",
    "dep": "Yonne"
  },
  {
    "code": "89440",
    "ville": "Sainte-Colombe",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Saint-Cyr-les-Colons",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Saint-Denis-lès-Sens",
    "dep": "Yonne"
  },
  {
    "code": "89170",
    "ville": "Saint-Fargeau",
    "dep": "Yonne"
  },
  {
    "code": "89600",
    "ville": "Saint-Florentin",
    "dep": "Yonne"
  },
  {
    "code": "89000",
    "ville": "Saint-Georges-sur-Baulche",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Saint-Germain-des-Champs",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Saint-Julien-du-Sault",
    "dep": "Yonne"
  },
  {
    "code": "89630",
    "ville": "Saint-Léger-Vauban",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Saint-Loup-d'Ordon",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Sainte-Magnance",
    "dep": "Yonne"
  },
  {
    "code": "89170",
    "ville": "Saint-Martin-des-Champs",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Saint-Martin-d'Ordon",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Saint-Martin-du-Tertre",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Saint-Martin-sur-Armançon",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Saint-Maurice-aux-Riches-Hommes",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Saint-Maurice-le-Vieil",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Saint-Maurice-Thizouaille",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Saint-Moré",
    "dep": "Yonne"
  },
  {
    "code": "89460",
    "ville": "Sainte-Pallaye",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Saint-Père",
    "dep": "Yonne"
  },
  {
    "code": "89220",
    "ville": "Saint-Privé",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Saints-en-Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Saint-Sauveur-en-Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Saint-Sérotin",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Saint-Valérien",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Sainte-Vertu",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Saligny",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Sambourg",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Santigny",
    "dep": "Yonne"
  },
  {
    "code": "89310",
    "ville": "Sarry",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Sauvigny-le-Beuréal",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Sauvigny-le-Bois",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Savigny-en-Terre-Plaine",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Savigny-sur-Clairis",
    "dep": "Yonne"
  },
  {
    "code": "89250",
    "ville": "Seignelay",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Sementron",
    "dep": "Yonne"
  },
  {
    "code": "89710",
    "ville": "Senan",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Sennevoy-le-Bas",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Sennevoy-le-Haut",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Sens",
    "dep": "Yonne"
  },
  {
    "code": "89116",
    "ville": "Sépeaux-Saint Romain",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Serbonnes",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Sergines",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Sermizelles",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Serrigny",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Sery",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Les Sièges",
    "dep": "Yonne"
  },
  {
    "code": "89110",
    "ville": "Sommecaise",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Sormery",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Soucy",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Sougères-en-Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Soumaintrain",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Stigny",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Subligny",
    "dep": "Yonne"
  },
  {
    "code": "89560",
    "ville": "Les Hauts de Forterre",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Talcy",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Tanlay",
    "dep": "Yonne"
  },
  {
    "code": "89350",
    "ville": "Tannerre-en-Puisaye",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Tharoiseau",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Tharot",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Les Vallées de la Vanne",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Thizy",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Thorey",
    "dep": "Yonne"
  },
  {
    "code": "89260",
    "ville": "Thorigny-sur-Oreuse",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Thory",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Thury",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Tissey",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Tonnerre",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Toucy",
    "dep": "Yonne"
  },
  {
    "code": "89520",
    "ville": "Treigny-Perreuse-Sainte-Colombe",
    "dep": "Yonne"
  },
  {
    "code": "89430",
    "ville": "Trichey",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Tronchoy",
    "dep": "Yonne"
  },
  {
    "code": "89460",
    "ville": "Trucy-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89570",
    "ville": "Turny",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Val-de-Mercy",
    "dep": "Yonne"
  },
  {
    "code": "89580",
    "ville": "Vallan",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Vallery",
    "dep": "Yonne"
  },
  {
    "code": "89144",
    "ville": "Varennes",
    "dep": "Yonne"
  },
  {
    "code": "89420",
    "ville": "Vassy-sous-Pisy",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Vaudeurs",
    "dep": "Yonne"
  },
  {
    "code": "89200",
    "ville": "Vault-de-Lugny",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Vaumort",
    "dep": "Yonne"
  },
  {
    "code": "89210",
    "ville": "Venizy",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Venouse",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Venoy",
    "dep": "Yonne"
  },
  {
    "code": "89600",
    "ville": "Vergigny",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Verlin",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Vermenton",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Vernoy",
    "dep": "Yonne"
  },
  {
    "code": "89510",
    "ville": "Véron",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Vézannes",
    "dep": "Yonne"
  },
  {
    "code": "89450",
    "ville": "Vézelay",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Vézinnes",
    "dep": "Yonne"
  },
  {
    "code": "89340",
    "ville": "Villeblevin",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Villebougis",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Villechétive",
    "dep": "Yonne"
  },
  {
    "code": "89300",
    "ville": "Villecien",
    "dep": "Yonne"
  },
  {
    "code": "89240",
    "ville": "Villefargeau",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Villemanoche",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Villenavotte",
    "dep": "Yonne"
  },
  {
    "code": "89150",
    "ville": "Villeneuve-la-Dondagre",
    "dep": "Yonne"
  },
  {
    "code": "89340",
    "ville": "Villeneuve-la-Guyard",
    "dep": "Yonne"
  },
  {
    "code": "89190",
    "ville": "Villeneuve-l'Archevêque",
    "dep": "Yonne"
  },
  {
    "code": "89350",
    "ville": "Villeneuve-les-Genêts",
    "dep": "Yonne"
  },
  {
    "code": "89230",
    "ville": "Villeneuve-Saint-Salves",
    "dep": "Yonne"
  },
  {
    "code": "89500",
    "ville": "Villeneuve-sur-Yonne",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Villeperrot",
    "dep": "Yonne"
  },
  {
    "code": "89100",
    "ville": "Villeroy",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Villethierry",
    "dep": "Yonne"
  },
  {
    "code": "89330",
    "ville": "Villevallier",
    "dep": "Yonne"
  },
  {
    "code": "89260",
    "ville": "Perceneige",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Villiers-les-Hauts",
    "dep": "Yonne"
  },
  {
    "code": "89320",
    "ville": "Villiers-Louis",
    "dep": "Yonne"
  },
  {
    "code": "89130",
    "ville": "Villiers-Saint-Benoît",
    "dep": "Yonne"
  },
  {
    "code": "89360",
    "ville": "Villiers-Vineux",
    "dep": "Yonne"
  },
  {
    "code": "89740",
    "ville": "Villon",
    "dep": "Yonne"
  },
  {
    "code": "89800",
    "ville": "Villy",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Vincelles",
    "dep": "Yonne"
  },
  {
    "code": "89290",
    "ville": "Vincelottes",
    "dep": "Yonne"
  },
  {
    "code": "89140",
    "ville": "Vinneuf",
    "dep": "Yonne"
  },
  {
    "code": "89160",
    "ville": "Vireaux",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Viviers",
    "dep": "Yonne"
  },
  {
    "code": "89260",
    "ville": "Voisines",
    "dep": "Yonne"
  },
  {
    "code": "89270",
    "ville": "Voutenay-sur-Cure",
    "dep": "Yonne"
  },
  {
    "code": "89700",
    "ville": "Yrouerre",
    "dep": "Yonne"
  },
  {
    "code": "90400",
    "ville": "Andelnans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Angeot",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90170",
    "ville": "Anjoutey",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90800",
    "ville": "Argiésans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Auxelles-Bas",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Auxelles-Haut",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90800",
    "ville": "Banvillars",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90800",
    "ville": "Bavilliers",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90500",
    "ville": "Beaucourt",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90000",
    "ville": "Belfort",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Bermont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90160",
    "ville": "Bessoncourt",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Bethonvilliers",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Boron",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Botans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Bourg-sous-Châtelet",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Bourogne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Brebotte",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90130",
    "ville": "Bretagne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90800",
    "ville": "Buc",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Charmois",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90700",
    "ville": "Châtenois-les-Forges",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90330",
    "ville": "Chaux",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Chavanatte",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Chavannes-les-Grands",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90340",
    "ville": "Chèvremont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Courcelles",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Courtelevant",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Cravanche",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Croix",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Cunelières",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Danjoutin",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Delle",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90160",
    "ville": "Denney",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Dorans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Eguenigue",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Éloie",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90850",
    "ville": "Essert",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90170",
    "ville": "Étueffont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90350",
    "ville": "Évette-Salbert",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Faverois",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Felon",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Fêche-l'Église",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Florimont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Fontaine",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90340",
    "ville": "Fontenelle",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Foussemagne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Frais",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Froidefontaine",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Giromagny",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90600",
    "ville": "Grandvillars",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Grosmagny",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Grosne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Joncherey",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Lachapelle-sous-Chaux",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90360",
    "ville": "Lachapelle-sous-Rougemont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Lacollonge",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Lagrange",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90170",
    "ville": "Lamadeleine-Val-des-Anges",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Larivière",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Lebetain",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Lepuix-Neuf",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Lepuix",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Leval",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Menoncourt",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Meroux-Moval",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90120",
    "ville": "Méziré",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90500",
    "ville": "Montbouton",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90130",
    "ville": "Montreux-Château",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90120",
    "ville": "Morvillars",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90340",
    "ville": "Novillard",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Offemont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90160",
    "ville": "Pérouse",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90130",
    "ville": "Petit-Croix",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90360",
    "ville": "Petitefontaine",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90170",
    "ville": "Petitmagny",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Phaffans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90370",
    "ville": "Réchésy",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Autrechêne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90140",
    "ville": "Recouvrance",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Reppe",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Riervescemont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Romagny-sous-Rougemont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90380",
    "ville": "Roppe",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Rougegoutte",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Rougemont-le-Château",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Saint-Dizier-l'Évêque",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90110",
    "ville": "Saint-Germain-le-Châtelet",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Sermamagny",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Sevenans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Suarce",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Thiancourt",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Trévenans",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90800",
    "ville": "Urcerey",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Valdoie",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90150",
    "ville": "Vauthiermont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Vellescot",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90200",
    "ville": "Vescemont",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90300",
    "ville": "Vétrigne",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90400",
    "ville": "Vézelois",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "90100",
    "ville": "Villars-le-Sec",
    "dep": "Territoire de Belfort"
  },
  {
    "code": "91150",
    "ville": "Abbéville-la-Rivière",
    "dep": "Essonne"
  },
  {
    "code": "91670",
    "ville": "Angerville",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Angervilliers",
    "dep": "Essonne"
  },
  {
    "code": "91290",
    "ville": "Arpajon",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Arrancourt",
    "dep": "Essonne"
  },
  {
    "code": "91200",
    "ville": "Athis-Mons",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Authon-la-Plaine",
    "dep": "Essonne"
  },
  {
    "code": "91830",
    "ville": "Auvernaux",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Auvers-Saint-Georges",
    "dep": "Essonne"
  },
  {
    "code": "91630",
    "ville": "Avrainville",
    "dep": "Essonne"
  },
  {
    "code": "91160",
    "ville": "Ballainvilliers",
    "dep": "Essonne"
  },
  {
    "code": "91610",
    "ville": "Ballancourt-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Baulne",
    "dep": "Essonne"
  },
  {
    "code": "91570",
    "ville": "Bièvres",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Blandy",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Boigneville",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Bois-Herpin",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Boissy-la-Rivière",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Boissy-le-Cutté",
    "dep": "Essonne"
  },
  {
    "code": "91870",
    "ville": "Boissy-le-Sec",
    "dep": "Essonne"
  },
  {
    "code": "91790",
    "ville": "Boissy-sous-Saint-Yon",
    "dep": "Essonne"
  },
  {
    "code": "91070",
    "ville": "Bondoufle",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Boullay-les-Troux",
    "dep": "Essonne"
  },
  {
    "code": "91850",
    "ville": "Bouray-sur-Juine",
    "dep": "Essonne"
  },
  {
    "code": "91800",
    "ville": "Boussy-Saint-Antoine",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Boutervilliers",
    "dep": "Essonne"
  },
  {
    "code": "91820",
    "ville": "Boutigny-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91880",
    "ville": "Bouville",
    "dep": "Essonne"
  },
  {
    "code": "91220",
    "ville": "Brétigny-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91650",
    "ville": "Breuillet",
    "dep": "Essonne"
  },
  {
    "code": "91650",
    "ville": "Breux-Jouy",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Brières-les-Scellés",
    "dep": "Essonne"
  },
  {
    "code": "91640",
    "ville": "Briis-sous-Forges",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Brouy",
    "dep": "Essonne"
  },
  {
    "code": "91800",
    "ville": "Brunoy",
    "dep": "Essonne"
  },
  {
    "code": "91680",
    "ville": "Bruyères-le-Châtel",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Buno-Bonnevaux",
    "dep": "Essonne"
  },
  {
    "code": "91440",
    "ville": "Bures-sur-Yvette",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Cerny",
    "dep": "Essonne"
  },
  {
    "code": "91780",
    "ville": "Chalo-Saint-Mars",
    "dep": "Essonne"
  },
  {
    "code": "91740",
    "ville": "Chalou-Moulineux",
    "dep": "Essonne"
  },
  {
    "code": "91730",
    "ville": "Chamarande",
    "dep": "Essonne"
  },
  {
    "code": "91750",
    "ville": "Champcueil",
    "dep": "Essonne"
  },
  {
    "code": "91160",
    "ville": "Champlan",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Champmotteux",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Chatignonville",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Chauffour-lès-Étréchy",
    "dep": "Essonne"
  },
  {
    "code": "91630",
    "ville": "Cheptainville",
    "dep": "Essonne"
  },
  {
    "code": "91750",
    "ville": "Chevannes",
    "dep": "Essonne"
  },
  {
    "code": "91380",
    "ville": "Chilly-Mazarin",
    "dep": "Essonne"
  },
  {
    "code": "91100",
    "ville": "Corbeil-Essonnes",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Corbreuse",
    "dep": "Essonne"
  },
  {
    "code": "91830",
    "ville": "Le Coudray-Montceaux",
    "dep": "Essonne"
  },
  {
    "code": "91490",
    "ville": "Courances",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Courdimanche-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91680",
    "ville": "Courson-Monteloup",
    "dep": "Essonne"
  },
  {
    "code": "91560",
    "ville": "Crosne",
    "dep": "Essonne"
  },
  {
    "code": "91490",
    "ville": "Dannemois",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "D'Huison-Longueville",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Dourdan",
    "dep": "Essonne"
  },
  {
    "code": "91210",
    "ville": "Draveil",
    "dep": "Essonne"
  },
  {
    "code": "91540",
    "ville": "Écharcon",
    "dep": "Essonne"
  },
  {
    "code": "91520",
    "ville": "Égly",
    "dep": "Essonne"
  },
  {
    "code": "91860",
    "ville": "Épinay-sous-Sénart",
    "dep": "Essonne"
  },
  {
    "code": "91360",
    "ville": "Épinay-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Étampes",
    "dep": "Essonne"
  },
  {
    "code": "91450",
    "ville": "Étiolles",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Étréchy",
    "dep": "Essonne"
  },
  {
    "code": "91080",
    "ville": "Évry-Courcouronnes",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "La Ferté-Alais",
    "dep": "Essonne"
  },
  {
    "code": "91700",
    "ville": "Fleury-Mérogis",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Fontaine-la-Rivière",
    "dep": "Essonne"
  },
  {
    "code": "91640",
    "ville": "Fontenay-lès-Briis",
    "dep": "Essonne"
  },
  {
    "code": "91540",
    "ville": "Fontenay-le-Vicomte",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "La Forêt-le-Roi",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "La Forêt-Sainte-Croix",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Forges-les-Bains",
    "dep": "Essonne"
  },
  {
    "code": "91190",
    "ville": "Gif-sur-Yvette",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Gironville-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91400",
    "ville": "Gometz-la-Ville",
    "dep": "Essonne"
  },
  {
    "code": "91940",
    "ville": "Gometz-le-Châtel",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Les Granges-le-Roi",
    "dep": "Essonne"
  },
  {
    "code": "91350",
    "ville": "Grigny",
    "dep": "Essonne"
  },
  {
    "code": "91630",
    "ville": "Guibeville",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Guigneville-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Guillerval",
    "dep": "Essonne"
  },
  {
    "code": "91430",
    "ville": "Igny",
    "dep": "Essonne"
  },
  {
    "code": "91760",
    "ville": "Itteville",
    "dep": "Essonne"
  },
  {
    "code": "91510",
    "ville": "Janville-sur-Juine",
    "dep": "Essonne"
  },
  {
    "code": "91640",
    "ville": "Janvry",
    "dep": "Essonne"
  },
  {
    "code": "91260",
    "ville": "Juvisy-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91510",
    "ville": "Lardy",
    "dep": "Essonne"
  },
  {
    "code": "91630",
    "ville": "Leudeville",
    "dep": "Essonne"
  },
  {
    "code": "91310",
    "ville": "Leuville-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Limours",
    "dep": "Essonne"
  },
  {
    "code": "91310",
    "ville": "Linas",
    "dep": "Essonne"
  },
  {
    "code": "91090",
    "ville": "Lisses",
    "dep": "Essonne"
  },
  {
    "code": "91160",
    "ville": "Longjumeau",
    "dep": "Essonne"
  },
  {
    "code": "91310",
    "ville": "Longpont-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Maisse",
    "dep": "Essonne"
  },
  {
    "code": "91460",
    "ville": "Marcoussis",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Marolles-en-Beauce",
    "dep": "Essonne"
  },
  {
    "code": "91630",
    "ville": "Marolles-en-Hurepoix",
    "dep": "Essonne"
  },
  {
    "code": "91300",
    "ville": "Massy",
    "dep": "Essonne"
  },
  {
    "code": "91730",
    "ville": "Mauchamps",
    "dep": "Essonne"
  },
  {
    "code": "91540",
    "ville": "Mennecy",
    "dep": "Essonne"
  },
  {
    "code": "91660",
    "ville": "Le Mérévillois",
    "dep": "Essonne"
  },
  {
    "code": "91780",
    "ville": "Mérobert",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Mespuits",
    "dep": "Essonne"
  },
  {
    "code": "91490",
    "ville": "Milly-la-Forêt",
    "dep": "Essonne"
  },
  {
    "code": "91490",
    "ville": "Moigny-sur-École",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Les Molières",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Mondeville",
    "dep": "Essonne"
  },
  {
    "code": "91930",
    "ville": "Monnerville",
    "dep": "Essonne"
  },
  {
    "code": "91230",
    "ville": "Montgeron",
    "dep": "Essonne"
  },
  {
    "code": "91310",
    "ville": "Montlhéry",
    "dep": "Essonne"
  },
  {
    "code": "91420",
    "ville": "Morangis",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Morigny-Champigny",
    "dep": "Essonne"
  },
  {
    "code": "91390",
    "ville": "Morsang-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91250",
    "ville": "Morsang-sur-Seine",
    "dep": "Essonne"
  },
  {
    "code": "91750",
    "ville": "Nainville-les-Roches",
    "dep": "Essonne"
  },
  {
    "code": "91290",
    "ville": "La Norville",
    "dep": "Essonne"
  },
  {
    "code": "91620",
    "ville": "Nozay",
    "dep": "Essonne"
  },
  {
    "code": "91340",
    "ville": "Ollainville",
    "dep": "Essonne"
  },
  {
    "code": "91490",
    "ville": "Oncy-sur-École",
    "dep": "Essonne"
  },
  {
    "code": "91540",
    "ville": "Ormoy",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Ormoy-la-Rivière",
    "dep": "Essonne"
  },
  {
    "code": "91400",
    "ville": "Orsay",
    "dep": "Essonne"
  },
  {
    "code": "91590",
    "ville": "Orveau",
    "dep": "Essonne"
  },
  {
    "code": "91120",
    "ville": "Palaiseau",
    "dep": "Essonne"
  },
  {
    "code": "91550",
    "ville": "Paray-Vieille-Poste",
    "dep": "Essonne"
  },
  {
    "code": "91470",
    "ville": "Pecqueuse",
    "dep": "Essonne"
  },
  {
    "code": "91220",
    "ville": "Le Plessis-Pâté",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Plessis-Saint-Benoist",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Prunay-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Puiselet-le-Marais",
    "dep": "Essonne"
  },
  {
    "code": "91740",
    "ville": "Pussay",
    "dep": "Essonne"
  },
  {
    "code": "91480",
    "ville": "Quincy-sous-Sénart",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Richarville",
    "dep": "Essonne"
  },
  {
    "code": "91130",
    "ville": "Ris-Orangis",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Roinville",
    "dep": "Essonne"
  },
  {
    "code": "91150",
    "ville": "Roinvilliers",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Saclas",
    "dep": "Essonne"
  },
  {
    "code": "91400",
    "ville": "Saclay",
    "dep": "Essonne"
  },
  {
    "code": "91190",
    "ville": "Saint-Aubin",
    "dep": "Essonne"
  },
  {
    "code": "91530",
    "ville": "Saint-Chéron",
    "dep": "Essonne"
  },
  {
    "code": "91690",
    "ville": "Saint-Cyr-la-Rivière",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Saint-Cyr-sous-Dourdan",
    "dep": "Essonne"
  },
  {
    "code": "91410",
    "ville": "Saint-Escobille",
    "dep": "Essonne"
  },
  {
    "code": "91700",
    "ville": "Sainte-Geneviève-des-Bois",
    "dep": "Essonne"
  },
  {
    "code": "91180",
    "ville": "Saint-Germain-lès-Arpajon",
    "dep": "Essonne"
  },
  {
    "code": "91250",
    "ville": "Saint-Germain-lès-Corbeil",
    "dep": "Essonne"
  },
  {
    "code": "91780",
    "ville": "Saint-Hilaire",
    "dep": "Essonne"
  },
  {
    "code": "91940",
    "ville": "Saint-Jean-de-Beauregard",
    "dep": "Essonne"
  },
  {
    "code": "91530",
    "ville": "Saint-Maurice-Montcouronne",
    "dep": "Essonne"
  },
  {
    "code": "91240",
    "ville": "Saint-Michel-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91280",
    "ville": "Saint-Pierre-du-Perray",
    "dep": "Essonne"
  },
  {
    "code": "91250",
    "ville": "Saintry-sur-Seine",
    "dep": "Essonne"
  },
  {
    "code": "91910",
    "ville": "Saint-Sulpice-de-Favières",
    "dep": "Essonne"
  },
  {
    "code": "91770",
    "ville": "Saint-Vrain",
    "dep": "Essonne"
  },
  {
    "code": "91650",
    "ville": "Saint-Yon",
    "dep": "Essonne"
  },
  {
    "code": "91160",
    "ville": "Saulx-les-Chartreux",
    "dep": "Essonne"
  },
  {
    "code": "91600",
    "ville": "Savigny-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91530",
    "ville": "Sermaise",
    "dep": "Essonne"
  },
  {
    "code": "91840",
    "ville": "Soisy-sur-École",
    "dep": "Essonne"
  },
  {
    "code": "91450",
    "ville": "Soisy-sur-Seine",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Souzy-la-Briche",
    "dep": "Essonne"
  },
  {
    "code": "91740",
    "ville": "Congerville-Thionville",
    "dep": "Essonne"
  },
  {
    "code": "91250",
    "ville": "Tigery",
    "dep": "Essonne"
  },
  {
    "code": "91730",
    "ville": "Torfou",
    "dep": "Essonne"
  },
  {
    "code": "91720",
    "ville": "Valpuiseaux",
    "dep": "Essonne"
  },
  {
    "code": "91530",
    "ville": "Le Val-Saint-Germain",
    "dep": "Essonne"
  },
  {
    "code": "91480",
    "ville": "Varennes-Jarcy",
    "dep": "Essonne"
  },
  {
    "code": "91640",
    "ville": "Vaugrigneuse",
    "dep": "Essonne"
  },
  {
    "code": "91430",
    "ville": "Vauhallan",
    "dep": "Essonne"
  },
  {
    "code": "91820",
    "ville": "Vayres-sur-Essonne",
    "dep": "Essonne"
  },
  {
    "code": "91370",
    "ville": "Verrières-le-Buisson",
    "dep": "Essonne"
  },
  {
    "code": "91810",
    "ville": "Vert-le-Grand",
    "dep": "Essonne"
  },
  {
    "code": "91710",
    "ville": "Vert-le-Petit",
    "dep": "Essonne"
  },
  {
    "code": "91890",
    "ville": "Videlles",
    "dep": "Essonne"
  },
  {
    "code": "91270",
    "ville": "Vigneux-sur-Seine",
    "dep": "Essonne"
  },
  {
    "code": "91100",
    "ville": "Villabé",
    "dep": "Essonne"
  },
  {
    "code": "91140",
    "ville": "Villebon-sur-Yvette",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Villeconin",
    "dep": "Essonne"
  },
  {
    "code": "91620",
    "ville": "La Ville-du-Bois",
    "dep": "Essonne"
  },
  {
    "code": "91140",
    "ville": "Villejust",
    "dep": "Essonne"
  },
  {
    "code": "91360",
    "ville": "Villemoisson-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91580",
    "ville": "Villeneuve-sur-Auvers",
    "dep": "Essonne"
  },
  {
    "code": "91190",
    "ville": "Villiers-le-Bâcle",
    "dep": "Essonne"
  },
  {
    "code": "91700",
    "ville": "Villiers-sur-Orge",
    "dep": "Essonne"
  },
  {
    "code": "91170",
    "ville": "Viry-Châtillon",
    "dep": "Essonne"
  },
  {
    "code": "91320",
    "ville": "Wissous",
    "dep": "Essonne"
  },
  {
    "code": "91330",
    "ville": "Yerres",
    "dep": "Essonne"
  },
  {
    "code": "91940",
    "ville": "Les Ulis",
    "dep": "Essonne"
  },
  {
    "code": "92160",
    "ville": "Antony",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92600",
    "ville": "Asnières-sur-Seine",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92220",
    "ville": "Bagneux",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92270",
    "ville": "Bois-Colombes",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92100",
    "ville": "Boulogne-Billancourt",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92340",
    "ville": "Bourg-la-Reine",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92290",
    "ville": "Châtenay-Malabry",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92320",
    "ville": "Châtillon",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92370",
    "ville": "Chaville",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92140",
    "ville": "Clamart",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92110",
    "ville": "Clichy",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92700",
    "ville": "Colombes",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92400",
    "ville": "Courbevoie",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92260",
    "ville": "Fontenay-aux-Roses",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92380",
    "ville": "Garches",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92250",
    "ville": "La Garenne-Colombes",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92230",
    "ville": "Gennevilliers",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92130",
    "ville": "Issy-les-Moulineaux",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92300",
    "ville": "Levallois-Perret",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92240",
    "ville": "Malakoff",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92430",
    "ville": "Marnes-la-Coquette",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92190",
    "ville": "Meudon",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92120",
    "ville": "Montrouge",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92000",
    "ville": "Nanterre",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92200",
    "ville": "Neuilly-sur-Seine",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92350",
    "ville": "Le Plessis-Robinson",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92800",
    "ville": "Puteaux",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92500",
    "ville": "Rueil-Malmaison",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92210",
    "ville": "Saint-Cloud",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92330",
    "ville": "Sceaux",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92310",
    "ville": "Sèvres",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92150",
    "ville": "Suresnes",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92170",
    "ville": "Vanves",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92420",
    "ville": "Vaucresson",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92410",
    "ville": "Ville-d'Avray",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "92390",
    "ville": "Villeneuve-la-Garenne",
    "dep": "Hauts-de-Seine"
  },
  {
    "code": "93300",
    "ville": "Aubervilliers",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93600",
    "ville": "Aulnay-sous-Bois",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93170",
    "ville": "Bagnolet",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93150",
    "ville": "Le Blanc-Mesnil",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93000",
    "ville": "Bobigny",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93140",
    "ville": "Bondy",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93350",
    "ville": "Le Bourget",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93390",
    "ville": "Clichy-sous-Bois",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93470",
    "ville": "Coubron",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93120",
    "ville": "La Courneuve",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93700",
    "ville": "Drancy",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93440",
    "ville": "Dugny",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93800",
    "ville": "Épinay-sur-Seine",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93220",
    "ville": "Gagny",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93460",
    "ville": "Gournay-sur-Marne",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93450",
    "ville": "L'Île-Saint-Denis",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93260",
    "ville": "Les Lilas",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93190",
    "ville": "Livry-Gargan",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93370",
    "ville": "Montfermeil",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93100",
    "ville": "Montreuil",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93360",
    "ville": "Neuilly-Plaisance",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93330",
    "ville": "Neuilly-sur-Marne",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93160",
    "ville": "Noisy-le-Grand",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93130",
    "ville": "Noisy-le-Sec",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93500",
    "ville": "Pantin",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93320",
    "ville": "Les Pavillons-sous-Bois",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93380",
    "ville": "Pierrefitte-sur-Seine",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93310",
    "ville": "Le Pré-Saint-Gervais",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93340",
    "ville": "Le Raincy",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93230",
    "ville": "Romainville",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93110",
    "ville": "Rosny-sous-Bois",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93210",
    "ville": "Saint-Denis",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93400",
    "ville": "Saint-Ouen-sur-Seine",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93270",
    "ville": "Sevran",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93240",
    "ville": "Stains",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93290",
    "ville": "Tremblay-en-France",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93410",
    "ville": "Vaujours",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93250",
    "ville": "Villemomble",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93420",
    "ville": "Villepinte",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "93430",
    "ville": "Villetaneuse",
    "dep": "Seine-Saint-Denis"
  },
  {
    "code": "94480",
    "ville": "Ablon-sur-Seine",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94140",
    "ville": "Alfortville",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94110",
    "ville": "Arcueil",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94470",
    "ville": "Boissy-Saint-Léger",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94380",
    "ville": "Bonneuil-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94360",
    "ville": "Bry-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94230",
    "ville": "Cachan",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94500",
    "ville": "Champigny-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94220",
    "ville": "Charenton-le-Pont",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94430",
    "ville": "Chennevières-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94550",
    "ville": "Chevilly-Larue",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94600",
    "ville": "Choisy-le-Roi",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94000",
    "ville": "Créteil",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94120",
    "ville": "Fontenay-sous-Bois",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94260",
    "ville": "Fresnes",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94250",
    "ville": "Gentilly",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94240",
    "ville": "L'Haÿ-les-Roses",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94200",
    "ville": "Ivry-sur-Seine",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94340",
    "ville": "Joinville-le-Pont",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94270",
    "ville": "Le Kremlin-Bicêtre",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94450",
    "ville": "Limeil-Brévannes",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94700",
    "ville": "Maisons-Alfort",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94520",
    "ville": "Mandres-les-Roses",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94440",
    "ville": "Marolles-en-Brie",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94130",
    "ville": "Nogent-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94880",
    "ville": "Noiseau",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94310",
    "ville": "Orly",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94490",
    "ville": "Ormesson-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94520",
    "ville": "Périgny",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94170",
    "ville": "Le Perreux-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94420",
    "ville": "Le Plessis-Trévise",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94510",
    "ville": "La Queue-en-Brie",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94150",
    "ville": "Rungis",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94160",
    "ville": "Saint-Mandé",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94210",
    "ville": "Saint-Maur-des-Fossés",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94410",
    "ville": "Saint-Maurice",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94440",
    "ville": "Santeny",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94370",
    "ville": "Sucy-en-Brie",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94320",
    "ville": "Thiais",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94460",
    "ville": "Valenton",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94440",
    "ville": "Villecresnes",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94800",
    "ville": "Villejuif",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94290",
    "ville": "Villeneuve-le-Roi",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94190",
    "ville": "Villeneuve-Saint-Georges",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94350",
    "ville": "Villiers-sur-Marne",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94300",
    "ville": "Vincennes",
    "dep": "Val-de-Marne"
  },
  {
    "code": "94400",
    "ville": "Vitry-sur-Seine",
    "dep": "Val-de-Marne"
  },
  {
    "code": "95450",
    "ville": "Ableiges",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Aincourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Ambleville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Amenucourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95580",
    "ville": "Andilly",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95100",
    "ville": "Argenteuil",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95400",
    "ville": "Arnouville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Arronville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Arthies",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Asnières-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95570",
    "ville": "Attainville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95430",
    "ville": "Auvers-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Avernes",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95560",
    "ville": "Baillet-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Banthelu",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95250",
    "ville": "Beauchamp",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95260",
    "ville": "Beaumont-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95750",
    "ville": "Le Bellay-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Bellefontaine",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Belloy-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95340",
    "ville": "Bernes-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Berville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95550",
    "ville": "Bessancourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95840",
    "ville": "Béthemont-la-Forêt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95870",
    "ville": "Bezons",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95000",
    "ville": "Boisemont",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95650",
    "ville": "Boissy-l'Aillerie",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95500",
    "ville": "Bonneuil-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95570",
    "ville": "Bouffémont",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95720",
    "ville": "Bouqueval",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95710",
    "ville": "Bray-et-Lû",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Bréançon",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Brignancourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95820",
    "ville": "Bruyères-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95770",
    "ville": "Buhy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95430",
    "ville": "Butry-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95000",
    "ville": "Cergy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95660",
    "ville": "Champagne-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "La Chapelle-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Charmont",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95750",
    "ville": "Chars",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95190",
    "ville": "Châtenay-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Chaumontel",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95710",
    "ville": "Chaussy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95560",
    "ville": "Chauvry",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95380",
    "ville": "Chennevières-lès-Louvres",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Chérence",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Cléry-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Commeny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Condécourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95240",
    "ville": "Cormeilles-en-Parisis",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95830",
    "ville": "Cormeilles-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95650",
    "ville": "Courcelles-sur-Viosne",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95800",
    "ville": "Courdimanche",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95170",
    "ville": "Deuil-la-Barre",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95330",
    "ville": "Domont",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95600",
    "ville": "Eaubonne",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95440",
    "ville": "Écouen",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95880",
    "ville": "Enghien-les-Bains",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95300",
    "ville": "Ennery",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95380",
    "ville": "Épiais-lès-Louvres",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Épiais-Rhus",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Épinay-Champlâtreux",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95610",
    "ville": "Éragny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95120",
    "ville": "Ermont",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95460",
    "ville": "Ézanville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95190",
    "ville": "Fontenay-en-Parisis",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95470",
    "ville": "Fosses",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95130",
    "ville": "Franconville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Frémainville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95830",
    "ville": "Frémécourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95740",
    "ville": "Frépillon",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95530",
    "ville": "La Frette-sur-Seine",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95690",
    "ville": "Frouville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95140",
    "ville": "Garges-lès-Gonesse",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Genainville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95650",
    "ville": "Génicourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95500",
    "ville": "Gonesse",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95190",
    "ville": "Goussainville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Grisy-les-Plâtres",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95410",
    "ville": "Groslay",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Guiry-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Haravilliers",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95780",
    "ville": "Haute-Isle",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Le Heaulme",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95690",
    "ville": "Hédouville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95220",
    "ville": "Herblay-sur-Seine",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95300",
    "ville": "Hérouville-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Hodent",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95290",
    "ville": "L'Isle-Adam",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95850",
    "ville": "Jagny-sous-Bois",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95280",
    "ville": "Jouy-le-Moutier",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95690",
    "ville": "Labbeville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Lassy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95300",
    "ville": "Livilliers",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Longuesse",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95380",
    "ville": "Louvres",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Luzarches",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95560",
    "ville": "Maffliers",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Magny-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95850",
    "ville": "Mareil-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95580",
    "ville": "Margency",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Marines",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95670",
    "ville": "Marly-la-Ville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Maudétour-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Menouville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95180",
    "ville": "Menucourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95630",
    "ville": "Mériel",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95540",
    "ville": "Méry-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95720",
    "ville": "Le Mesnil-Aubry",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95570",
    "ville": "Moisselles",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95650",
    "ville": "Montgeroult",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95370",
    "ville": "Montigny-lès-Cormeilles",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95680",
    "ville": "Montlignon",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95360",
    "ville": "Montmagny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95160",
    "ville": "Montmorency",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95770",
    "ville": "Montreuil-sur-Epte",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95560",
    "ville": "Montsoult",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95260",
    "ville": "Mours",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Moussy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95590",
    "ville": "Nerville-la-Forêt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95690",
    "ville": "Nesles-la-Vallée",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Neuilly-en-Vexin",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95000",
    "ville": "Neuville-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95590",
    "ville": "Nointel",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Noisy-sur-Oise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Nucourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Omerville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95520",
    "ville": "Osny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95620",
    "ville": "Parmain",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Le Perchay",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95340",
    "ville": "Persan",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95220",
    "ville": "Pierrelaye",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95350",
    "ville": "Piscop",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95130",
    "ville": "Le Plessis-Bouchard",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95720",
    "ville": "Le Plessis-Gassot",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Le Plessis-Luzarches",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95300",
    "ville": "Pontoise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95590",
    "ville": "Presles",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95380",
    "ville": "Puiseux-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95650",
    "ville": "Puiseux-Pontoise",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95780",
    "ville": "La Roche-Guyon",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95700",
    "ville": "Roissy-en-France",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95340",
    "ville": "Ronquerolles",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Sagy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95350",
    "ville": "Saint-Brice-sous-Forêt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95770",
    "ville": "Saint-Clair-sur-Epte",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Saint-Cyr-en-Arthies",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Saint-Gervais",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95210",
    "ville": "Saint-Gratien",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95320",
    "ville": "Saint-Leu-la-Forêt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Saint-Martin-du-Tertre",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95310",
    "ville": "Saint-Ouen-l'Aumône",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95390",
    "ville": "Saint-Prix",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95470",
    "ville": "Saint-Witz",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95110",
    "ville": "Sannois",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95640",
    "ville": "Santeuil",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95200",
    "ville": "Sarcelles",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Seraincourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Seugy",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95230",
    "ville": "Soisy-sous-Montmorency",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95470",
    "ville": "Survilliers",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95150",
    "ville": "Taverny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Théméricourt",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Theuville",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95500",
    "ville": "Le Thillay",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Us",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95810",
    "ville": "Vallangoujard",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95760",
    "ville": "Valmondois",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95500",
    "ville": "Vaudherland",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95490",
    "ville": "Vauréal",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95470",
    "ville": "Vémars",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Vétheuil",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95270",
    "ville": "Viarmes",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Vienne-en-Arthies",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95450",
    "ville": "Vigny",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95570",
    "ville": "Villaines-sous-Bois",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95380",
    "ville": "Villeron",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95510",
    "ville": "Villers-en-Arthies",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95840",
    "ville": "Villiers-Adam",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95400",
    "ville": "Villiers-le-Bel",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95720",
    "ville": "Villiers-le-Sec",
    "dep": "Val-d'Oise"
  },
  {
    "code": "95420",
    "ville": "Wy-dit-Joli-Village",
    "dep": "Val-d'Oise"
  },
  {
    "code": "97142",
    "ville": "Les Abymes",
    "dep": "Guadeloupe"
  },
  {
    "code": "97121",
    "ville": "Anse-Bertrand",
    "dep": "Guadeloupe"
  },
  {
    "code": "97122",
    "ville": "Baie-Mahault",
    "dep": "Guadeloupe"
  },
  {
    "code": "97123",
    "ville": "Baillif",
    "dep": "Guadeloupe"
  },
  {
    "code": "97100",
    "ville": "Basse-Terre",
    "dep": "Guadeloupe"
  },
  {
    "code": "97125",
    "ville": "Bouillante",
    "dep": "Guadeloupe"
  },
  {
    "code": "97130",
    "ville": "Capesterre-Belle-Eau",
    "dep": "Guadeloupe"
  },
  {
    "code": "97140",
    "ville": "Capesterre-de-Marie-Galante",
    "dep": "Guadeloupe"
  },
  {
    "code": "97113",
    "ville": "Gourbeyre",
    "dep": "Guadeloupe"
  },
  {
    "code": "97127",
    "ville": "La Désirade",
    "dep": "Guadeloupe"
  },
  {
    "code": "97126",
    "ville": "Deshaies",
    "dep": "Guadeloupe"
  },
  {
    "code": "97112",
    "ville": "Grand-Bourg",
    "dep": "Guadeloupe"
  },
  {
    "code": "97190",
    "ville": "Le Gosier",
    "dep": "Guadeloupe"
  },
  {
    "code": "97128",
    "ville": "Goyave",
    "dep": "Guadeloupe"
  },
  {
    "code": "97129",
    "ville": "Lamentin",
    "dep": "Guadeloupe"
  },
  {
    "code": "97111",
    "ville": "Morne-à-l'Eau",
    "dep": "Guadeloupe"
  },
  {
    "code": "97160",
    "ville": "Le Moule",
    "dep": "Guadeloupe"
  },
  {
    "code": "97170",
    "ville": "Petit-Bourg",
    "dep": "Guadeloupe"
  },
  {
    "code": "97131",
    "ville": "Petit-Canal",
    "dep": "Guadeloupe"
  },
  {
    "code": "97110",
    "ville": "Pointe-à-Pitre",
    "dep": "Guadeloupe"
  },
  {
    "code": "97116",
    "ville": "Pointe-Noire",
    "dep": "Guadeloupe"
  },
  {
    "code": "97117",
    "ville": "Port-Louis",
    "dep": "Guadeloupe"
  },
  {
    "code": "97120",
    "ville": "Saint-Claude",
    "dep": "Guadeloupe"
  },
  {
    "code": "97118",
    "ville": "Saint-François",
    "dep": "Guadeloupe"
  },
  {
    "code": "97134",
    "ville": "Saint-Louis",
    "dep": "Guadeloupe"
  },
  {
    "code": "97180",
    "ville": "Sainte-Anne",
    "dep": "Guadeloupe"
  },
  {
    "code": "97115",
    "ville": "Sainte-Rose",
    "dep": "Guadeloupe"
  },
  {
    "code": "97136",
    "ville": "Terre-de-Bas",
    "dep": "Guadeloupe"
  },
  {
    "code": "97137",
    "ville": "Terre-de-Haut",
    "dep": "Guadeloupe"
  },
  {
    "code": "97114",
    "ville": "Trois-Rivières",
    "dep": "Guadeloupe"
  },
  {
    "code": "97141",
    "ville": "Vieux-Fort",
    "dep": "Guadeloupe"
  },
  {
    "code": "97119",
    "ville": "Vieux-Habitants",
    "dep": "Guadeloupe"
  },
  {
    "code": "97216",
    "ville": "L'Ajoupa-Bouillon",
    "dep": "Martinique"
  },
  {
    "code": "97217",
    "ville": "Les Anses-d'Arlet",
    "dep": "Martinique"
  },
  {
    "code": "97218",
    "ville": "Basse-Pointe",
    "dep": "Martinique"
  },
  {
    "code": "97221",
    "ville": "Le Carbet",
    "dep": "Martinique"
  },
  {
    "code": "97222",
    "ville": "Case-Pilote",
    "dep": "Martinique"
  },
  {
    "code": "97223",
    "ville": "Le Diamant",
    "dep": "Martinique"
  },
  {
    "code": "97224",
    "ville": "Ducos",
    "dep": "Martinique"
  },
  {
    "code": "97250",
    "ville": "Fonds-Saint-Denis",
    "dep": "Martinique"
  },
  {
    "code": "97200",
    "ville": "Fort-de-France",
    "dep": "Martinique"
  },
  {
    "code": "97240",
    "ville": "Le François",
    "dep": "Martinique"
  },
  {
    "code": "97218",
    "ville": "Grand'Rivière",
    "dep": "Martinique"
  },
  {
    "code": "97213",
    "ville": "Gros-Morne",
    "dep": "Martinique"
  },
  {
    "code": "97232",
    "ville": "Le Lamentin",
    "dep": "Martinique"
  },
  {
    "code": "97214",
    "ville": "Le Lorrain",
    "dep": "Martinique"
  },
  {
    "code": "97218",
    "ville": "Macouba",
    "dep": "Martinique"
  },
  {
    "code": "97225",
    "ville": "Le Marigot",
    "dep": "Martinique"
  },
  {
    "code": "97290",
    "ville": "Le Marin",
    "dep": "Martinique"
  },
  {
    "code": "97260",
    "ville": "Le Morne-Rouge",
    "dep": "Martinique"
  },
  {
    "code": "97250",
    "ville": "Le Prêcheur",
    "dep": "Martinique"
  },
  {
    "code": "97211",
    "ville": "Rivière-Pilote",
    "dep": "Martinique"
  },
  {
    "code": "97215",
    "ville": "Rivière-Salée",
    "dep": "Martinique"
  },
  {
    "code": "97231",
    "ville": "Le Robert",
    "dep": "Martinique"
  },
  {
    "code": "97270",
    "ville": "Saint-Esprit",
    "dep": "Martinique"
  },
  {
    "code": "97212",
    "ville": "Saint-Joseph",
    "dep": "Martinique"
  },
  {
    "code": "97250",
    "ville": "Saint-Pierre",
    "dep": "Martinique"
  },
  {
    "code": "97227",
    "ville": "Sainte-Anne",
    "dep": "Martinique"
  },
  {
    "code": "97228",
    "ville": "Sainte-Luce",
    "dep": "Martinique"
  },
  {
    "code": "97230",
    "ville": "Sainte-Marie",
    "dep": "Martinique"
  },
  {
    "code": "97233",
    "ville": "Schœlcher",
    "dep": "Martinique"
  },
  {
    "code": "97220",
    "ville": "La Trinité",
    "dep": "Martinique"
  },
  {
    "code": "97229",
    "ville": "Les Trois-Îlets",
    "dep": "Martinique"
  },
  {
    "code": "97280",
    "ville": "Le Vauclin",
    "dep": "Martinique"
  },
  {
    "code": "97226",
    "ville": "Le Morne-Vert",
    "dep": "Martinique"
  },
  {
    "code": "97222",
    "ville": "Bellefontaine",
    "dep": "Martinique"
  },
  {
    "code": "97390",
    "ville": "Régina",
    "dep": "Guyane"
  },
  {
    "code": "97300",
    "ville": "Cayenne",
    "dep": "Guyane"
  },
  {
    "code": "97350",
    "ville": "Iracoubo",
    "dep": "Guyane"
  },
  {
    "code": "97310",
    "ville": "Kourou",
    "dep": "Guyane"
  },
  {
    "code": "97355",
    "ville": "Macouria",
    "dep": "Guyane"
  },
  {
    "code": "97318",
    "ville": "Mana",
    "dep": "Guyane"
  },
  {
    "code": "97351",
    "ville": "Matoury",
    "dep": "Guyane"
  },
  {
    "code": "97313",
    "ville": "Saint-Georges",
    "dep": "Guyane"
  },
  {
    "code": "97354",
    "ville": "Remire-Montjoly",
    "dep": "Guyane"
  },
  {
    "code": "97311",
    "ville": "Roura",
    "dep": "Guyane"
  },
  {
    "code": "97320",
    "ville": "Saint-Laurent-du-Maroni",
    "dep": "Guyane"
  },
  {
    "code": "97315",
    "ville": "Sinnamary",
    "dep": "Guyane"
  },
  {
    "code": "97356",
    "ville": "Montsinéry-Tonnegrande",
    "dep": "Guyane"
  },
  {
    "code": "97380",
    "ville": "Ouanary",
    "dep": "Guyane"
  },
  {
    "code": "97314",
    "ville": "Saül",
    "dep": "Guyane"
  },
  {
    "code": "97370",
    "ville": "Maripasoula",
    "dep": "Guyane"
  },
  {
    "code": "97330",
    "ville": "Camopi",
    "dep": "Guyane"
  },
  {
    "code": "97340",
    "ville": "Grand-Santi",
    "dep": "Guyane"
  },
  {
    "code": "97312",
    "ville": "Saint-Élie",
    "dep": "Guyane"
  },
  {
    "code": "97317",
    "ville": "Apatou",
    "dep": "Guyane"
  },
  {
    "code": "97319",
    "ville": "Awala-Yalimapo",
    "dep": "Guyane"
  },
  {
    "code": "97316",
    "ville": "Papaichton",
    "dep": "Guyane"
  },
  {
    "code": "97425",
    "ville": "Les Avirons",
    "dep": "La Réunion"
  },
  {
    "code": "97412",
    "ville": "Bras-Panon",
    "dep": "La Réunion"
  },
  {
    "code": "97414",
    "ville": "Entre-Deux",
    "dep": "La Réunion"
  },
  {
    "code": "97427",
    "ville": "L'Étang-Salé",
    "dep": "La Réunion"
  },
  {
    "code": "97429",
    "ville": "Petite-Île",
    "dep": "La Réunion"
  },
  {
    "code": "97431",
    "ville": "La Plaine-des-Palmistes",
    "dep": "La Réunion"
  },
  {
    "code": "97420",
    "ville": "Le Port",
    "dep": "La Réunion"
  },
  {
    "code": "97419",
    "ville": "La Possession",
    "dep": "La Réunion"
  },
  {
    "code": "97440",
    "ville": "Saint-André",
    "dep": "La Réunion"
  },
  {
    "code": "97437",
    "ville": "Saint-Benoît",
    "dep": "La Réunion"
  },
  {
    "code": "97400",
    "ville": "Saint-Denis",
    "dep": "La Réunion"
  },
  {
    "code": "97480",
    "ville": "Saint-Joseph",
    "dep": "La Réunion"
  },
  {
    "code": "97416",
    "ville": "Saint-Leu",
    "dep": "La Réunion"
  },
  {
    "code": "97421",
    "ville": "Saint-Louis",
    "dep": "La Réunion"
  },
  {
    "code": "97411",
    "ville": "Saint-Paul",
    "dep": "La Réunion"
  },
  {
    "code": "97410",
    "ville": "Saint-Pierre",
    "dep": "La Réunion"
  },
  {
    "code": "97442",
    "ville": "Saint-Philippe",
    "dep": "La Réunion"
  },
  {
    "code": "97438",
    "ville": "Sainte-Marie",
    "dep": "La Réunion"
  },
  {
    "code": "97439",
    "ville": "Sainte-Rose",
    "dep": "La Réunion"
  },
  {
    "code": "97441",
    "ville": "Sainte-Suzanne",
    "dep": "La Réunion"
  },
  {
    "code": "97433",
    "ville": "Salazie",
    "dep": "La Réunion"
  },
  {
    "code": "97418",
    "ville": "Le Tampon",
    "dep": "La Réunion"
  },
  {
    "code": "97426",
    "ville": "Les Trois-Bassins",
    "dep": "La Réunion"
  },
  {
    "code": "97413",
    "ville": "Cilaos",
    "dep": "La Réunion"
  },
  {
    "code": "97630",
    "ville": "Acoua",
    "dep": "Mayotte"
  },
  {
    "code": "97650",
    "ville": "Bandraboua",
    "dep": "Mayotte"
  },
  {
    "code": "97660",
    "ville": "Bandrele",
    "dep": "Mayotte"
  },
  {
    "code": "97620",
    "ville": "Bouéni",
    "dep": "Mayotte"
  },
  {
    "code": "97670",
    "ville": "Chiconi",
    "dep": "Mayotte"
  },
  {
    "code": "97620",
    "ville": "Chirongui",
    "dep": "Mayotte"
  },
  {
    "code": "97660",
    "ville": "Dembeni",
    "dep": "Mayotte"
  },
  {
    "code": "97615",
    "ville": "Dzaoudzi",
    "dep": "Mayotte"
  },
  {
    "code": "97625",
    "ville": "Kani-Kéli",
    "dep": "Mayotte"
  },
  {
    "code": "97600",
    "ville": "Koungou",
    "dep": "Mayotte"
  },
  {
    "code": "97600",
    "ville": "Mamoudzou",
    "dep": "Mayotte"
  },
  {
    "code": "97630",
    "ville": "Mtsamboro",
    "dep": "Mayotte"
  },
  {
    "code": "97650",
    "ville": "M'Tsangamouji",
    "dep": "Mayotte"
  },
  {
    "code": "97670",
    "ville": "Ouangani",
    "dep": "Mayotte"
  },
  {
    "code": "97615",
    "ville": "Pamandzi",
    "dep": "Mayotte"
  },
  {
    "code": "97640",
    "ville": "Sada",
    "dep": "Mayotte"
  },
  {
    "code": "97680",
    "ville": "Tsingoni",
    "dep": "Mayotte"
  }
];

export function searchVilles(query) {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  
  return villesFrance
    .filter(v => {
      const ville = v.ville.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      const code = v.code.toLowerCase();
      
      // Recherche dans le code postal OU dans le nom de la ville
      return code.includes(q) || ville.includes(q);
    })
    .slice(0, 10);
}
